(function (f) { if (typeof exports === "object" && typeof module !== "undefined") { module.exports = f() } else if (typeof define === "function" && define.amd) { define([], f) } else { var g; if (typeof window !== "undefined") { g = window } else if (typeof global !== "undefined") { g = global } else if (typeof self !== "undefined") { g = self } else { g = this } g.bitGoUTXO = f() } })(function () {
  var define, module, exports; return (function () { function r(e, n, t) { function o(i, f) { if (!n[i]) { if (!e[i]) { var c = "function" == typeof require && require; if (!f && c) return c(i, !0); if (u) return u(i, !0); var a = new Error("Cannot find module '" + i + "'"); throw a.code = "MODULE_NOT_FOUND", a } var p = n[i] = { exports: {} }; e[i][0].call(p.exports, function (r) { var n = e[i][1][r]; return o(n || r) }, p, p.exports, r, e, n, t) } return n[i].exports } for (var u = "function" == typeof require && require, i = 0; i < t.length; i++)o(t[i]); return o } return r })()({
    1: [function (require, module, exports) {
      'use strict'
      // base-x encoding / decoding
      // Copyright (c) 2018 base-x contributors
      // Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
      // Distributed under the MIT software license, see the accompanying
      // file LICENSE or http://www.opensource.org/licenses/mit-license.php.
      // @ts-ignore
      var _Buffer = require('safe-buffer').Buffer
      function base(ALPHABET) {
        if (ALPHABET.length >= 255) { throw new TypeError('Alphabet too long') }
        var BASE_MAP = new Uint8Array(256)
        for (var j = 0; j < BASE_MAP.length; j++) {
          BASE_MAP[j] = 255
        }
        for (var i = 0; i < ALPHABET.length; i++) {
          var x = ALPHABET.charAt(i)
          var xc = x.charCodeAt(0)
          if (BASE_MAP[xc] !== 255) { throw new TypeError(x + ' is ambiguous') }
          BASE_MAP[xc] = i
        }
        var BASE = ALPHABET.length
        var LEADER = ALPHABET.charAt(0)
        var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
        var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
        function encode(source) {
          if (Array.isArray(source) || source instanceof Uint8Array) { source = _Buffer.from(source) }
          if (!_Buffer.isBuffer(source)) { throw new TypeError('Expected Buffer') }
          if (source.length === 0) { return '' }
          // Skip & count leading zeroes.
          var zeroes = 0
          var length = 0
          var pbegin = 0
          var pend = source.length
          while (pbegin !== pend && source[pbegin] === 0) {
            pbegin++
            zeroes++
          }
          // Allocate enough space in big-endian base58 representation.
          var size = ((pend - pbegin) * iFACTOR + 1) >>> 0
          var b58 = new Uint8Array(size)
          // Process the bytes.
          while (pbegin !== pend) {
            var carry = source[pbegin]
            // Apply "b58 = b58 * 256 + ch".
            var i = 0
            for (var it1 = size - 1; (carry !== 0 || i < length) && (it1 !== -1); it1--, i++) {
              carry += (256 * b58[it1]) >>> 0
              b58[it1] = (carry % BASE) >>> 0
              carry = (carry / BASE) >>> 0
            }
            if (carry !== 0) { throw new Error('Non-zero carry') }
            length = i
            pbegin++
          }
          // Skip leading zeroes in base58 result.
          var it2 = size - length
          while (it2 !== size && b58[it2] === 0) {
            it2++
          }
          // Translate the result into a string.
          var str = LEADER.repeat(zeroes)
          for (; it2 < size; ++it2) { str += ALPHABET.charAt(b58[it2]) }
          return str
        }
        function decodeUnsafe(source) {
          if (typeof source !== 'string') { throw new TypeError('Expected String') }
          if (source.length === 0) { return _Buffer.alloc(0) }
          var psz = 0
          // Skip leading spaces.
          if (source[psz] === ' ') { return }
          // Skip and count leading '1's.
          var zeroes = 0
          var length = 0
          while (source[psz] === LEADER) {
            zeroes++
            psz++
          }
          // Allocate enough space in big-endian base256 representation.
          var size = (((source.length - psz) * FACTOR) + 1) >>> 0 // log(58) / log(256), rounded up.
          var b256 = new Uint8Array(size)
          // Process the characters.
          while (source[psz]) {
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)]
            // Invalid character
            if (carry === 255) { return }
            var i = 0
            for (var it3 = size - 1; (carry !== 0 || i < length) && (it3 !== -1); it3--, i++) {
              carry += (BASE * b256[it3]) >>> 0
              b256[it3] = (carry % 256) >>> 0
              carry = (carry / 256) >>> 0
            }
            if (carry !== 0) { throw new Error('Non-zero carry') }
            length = i
            psz++
          }
          // Skip trailing spaces.
          if (source[psz] === ' ') { return }
          // Skip leading zeroes in b256.
          var it4 = size - length
          while (it4 !== size && b256[it4] === 0) {
            it4++
          }
          var vch = _Buffer.allocUnsafe(zeroes + (size - it4))
          vch.fill(0x00, 0, zeroes)
          var j = zeroes
          while (it4 !== size) {
            vch[j++] = b256[it4++]
          }
          return vch
        }
        function decode(string) {
          var buffer = decodeUnsafe(string)
          if (buffer) { return buffer }
          throw new Error('Non-base' + BASE + ' character')
        }
        return {
          encode: encode,
          decodeUnsafe: decodeUnsafe,
          decode: decode
        }
      }
      module.exports = base

    }, { "safe-buffer": 133 }], 2: [function (require, module, exports) {
      'use strict'
      let ALPHABET = 'qpzry9x8gf2tvdw0s3jn54khce6mua7l'

      // pre-compute lookup table
      let ALPHABET_MAP = {}
      for (let z = 0; z < ALPHABET.length; z++) {
        let x = ALPHABET.charAt(z)

        if (ALPHABET_MAP[x] !== undefined) throw new TypeError(x + ' is ambiguous')
        ALPHABET_MAP[x] = z
      }

      function polymodStep(pre) {
        let b = pre >> 25
        return ((pre & 0x1FFFFFF) << 5) ^
          (-((b >> 0) & 1) & 0x3b6a57b2) ^
          (-((b >> 1) & 1) & 0x26508e6d) ^
          (-((b >> 2) & 1) & 0x1ea119fa) ^
          (-((b >> 3) & 1) & 0x3d4233dd) ^
          (-((b >> 4) & 1) & 0x2a1462b3)
      }

      function prefixChk(prefix) {
        let chk = 1
        for (let i = 0; i < prefix.length; ++i) {
          let c = prefix.charCodeAt(i)
          if (c < 33 || c > 126) throw new Error('Invalid prefix (' + prefix + ')')

          chk = polymodStep(chk) ^ (c >> 5)
        }
        chk = polymodStep(chk)

        for (let i = 0; i < prefix.length; ++i) {
          let v = prefix.charCodeAt(i)
          chk = polymodStep(chk) ^ (v & 0x1f)
        }
        return chk
      }

      function encode(prefix, words) {
        // too long?
        if ((prefix.length + 7 + words.length) > 90) throw new TypeError('Exceeds Bech32 maximum length')
        prefix = prefix.toLowerCase()

        // determine chk mod
        let chk = prefixChk(prefix)
        let result = prefix + '1'
        for (let i = 0; i < words.length; ++i) {
          let x = words[i]
          if ((x >> 5) !== 0) throw new Error('Non 5-bit word')

          chk = polymodStep(chk) ^ x
          result += ALPHABET.charAt(x)
        }

        for (let i = 0; i < 6; ++i) {
          chk = polymodStep(chk)
        }
        chk ^= 1

        for (let i = 0; i < 6; ++i) {
          let v = (chk >> ((5 - i) * 5)) & 0x1f
          result += ALPHABET.charAt(v)
        }

        return result
      }

      function decode(str) {
        if (str.length < 8) throw new TypeError(str + ' too short')
        if (str.length > 90) throw new TypeError(str + ' too long')

        // don't allow mixed case
        let lowered = str.toLowerCase()
        let uppered = str.toUpperCase()
        if (str !== lowered && str !== uppered) throw new Error('Mixed-case string ' + str)
        str = lowered

        let split = str.lastIndexOf('1')
        if (split === 0) throw new Error('Missing prefix for ' + str)

        let prefix = str.slice(0, split)
        let wordChars = str.slice(split + 1)
        if (wordChars.length < 6) throw new Error('Data too short')

        let chk = prefixChk(prefix)
        let words = []
        for (let i = 0; i < wordChars.length; ++i) {
          let c = wordChars.charAt(i)
          let v = ALPHABET_MAP[c]
          if (v === undefined) throw new Error('Unknown character ' + c)
          chk = polymodStep(chk) ^ v

          // not in the checksum?
          if (i + 6 >= wordChars.length) continue
          words.push(v)
        }

        if (chk !== 1) throw new Error('Invalid checksum for ' + str)
        return { prefix, words }
      }

      function convert(data, inBits, outBits, pad) {
        let value = 0
        let bits = 0
        let maxV = (1 << outBits) - 1

        let result = []
        for (let i = 0; i < data.length; ++i) {
          value = (value << inBits) | data[i]
          bits += inBits

          while (bits >= outBits) {
            bits -= outBits
            result.push((value >> bits) & maxV)
          }
        }

        if (pad) {
          if (bits > 0) {
            result.push((value << (outBits - bits)) & maxV)
          }
        } else {
          if (bits >= inBits) throw new Error('Excess padding')
          if ((value << (outBits - bits)) & maxV) throw new Error('Non-zero padding')
        }

        return result
      }

      function toWords(bytes) {
        return convert(bytes, 8, 5, true)
      }

      function fromWords(words) {
        return convert(words, 5, 8, false)
      }

      module.exports = { decode, encode, toWords, fromWords }

    }, {}], 3: [function (require, module, exports) {
      // (public) Constructor
      function BigInteger(a, b, c) {
        if (!(this instanceof BigInteger))
          return new BigInteger(a, b, c)

        if (a != null) {
          if ("number" == typeof a) this.fromNumber(a, b, c)
          else if (b == null && "string" != typeof a) this.fromString(a, 256)
          else this.fromString(a, b)
        }
      }

      var proto = BigInteger.prototype

      // duck-typed isBigInteger
      proto.__bigi = require('../package.json').version
      BigInteger.isBigInteger = function (obj, check_ver) {
        return obj && obj.__bigi && (!check_ver || obj.__bigi === proto.__bigi)
      }

      // Bits per digit
      var dbits

      // am: Compute w_j += (x*this_i), propagate carries,
      // c is initial carry, returns final carry.
      // c < 3*dvalue, x < 2*dvalue, this_i < dvalue
      // We need to select the fastest one that works in this environment.

      // am1: use a single mult and divide to get the high bits,
      // max digit bits should be 26 because
      // max internal value = 2*dvalue^2-2*dvalue (< 2^53)
      function am1(i, x, w, j, c, n) {
        while (--n >= 0) {
          var v = x * this[i++] + w[j] + c
          c = Math.floor(v / 0x4000000)
          w[j++] = v & 0x3ffffff
        }
        return c
      }
      // am2 avoids a big mult-and-extract completely.
      // Max digit bits should be <= 30 because we do bitwise ops
      // on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
      function am2(i, x, w, j, c, n) {
        var xl = x & 0x7fff,
          xh = x >> 15
        while (--n >= 0) {
          var l = this[i] & 0x7fff
          var h = this[i++] >> 15
          var m = xh * l + h * xl
          l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff)
          c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30)
          w[j++] = l & 0x3fffffff
        }
        return c
      }
      // Alternately, set max digit bits to 28 since some
      // browsers slow down when dealing with 32-bit numbers.
      function am3(i, x, w, j, c, n) {
        var xl = x & 0x3fff,
          xh = x >> 14
        while (--n >= 0) {
          var l = this[i] & 0x3fff
          var h = this[i++] >> 14
          var m = xh * l + h * xl
          l = xl * l + ((m & 0x3fff) << 14) + w[j] + c
          c = (l >> 28) + (m >> 14) + xh * h
          w[j++] = l & 0xfffffff
        }
        return c
      }

      // wtf?
      BigInteger.prototype.am = am1
      dbits = 26

      BigInteger.prototype.DB = dbits
      BigInteger.prototype.DM = ((1 << dbits) - 1)
      var DV = BigInteger.prototype.DV = (1 << dbits)

      var BI_FP = 52
      BigInteger.prototype.FV = Math.pow(2, BI_FP)
      BigInteger.prototype.F1 = BI_FP - dbits
      BigInteger.prototype.F2 = 2 * dbits - BI_FP

      // Digit conversions
      var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz"
      var BI_RC = new Array()
      var rr, vv
      rr = "0".charCodeAt(0)
      for (vv = 0; vv <= 9; ++vv) BI_RC[rr++] = vv
      rr = "a".charCodeAt(0)
      for (vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv
      rr = "A".charCodeAt(0)
      for (vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv

      function int2char(n) {
        return BI_RM.charAt(n)
      }

      function intAt(s, i) {
        var c = BI_RC[s.charCodeAt(i)]
        return (c == null) ? -1 : c
      }

      // (protected) copy this to r
      function bnpCopyTo(r) {
        for (var i = this.t - 1; i >= 0; --i) r[i] = this[i]
        r.t = this.t
        r.s = this.s
      }

      // (protected) set from integer value x, -DV <= x < DV
      function bnpFromInt(x) {
        this.t = 1
        this.s = (x < 0) ? -1 : 0
        if (x > 0) this[0] = x
        else if (x < -1) this[0] = x + DV
        else this.t = 0
      }

      // return bigint initialized to value
      function nbv(i) {
        var r = new BigInteger()
        r.fromInt(i)
        return r
      }

      // (protected) set from string and radix
      function bnpFromString(s, b) {
        var self = this

        var k
        if (b == 16) k = 4
        else if (b == 8) k = 3
        else if (b == 256) k = 8; // byte array
        else if (b == 2) k = 1
        else if (b == 32) k = 5
        else if (b == 4) k = 2
        else {
          self.fromRadix(s, b)
          return
        }
        self.t = 0
        self.s = 0
        var i = s.length,
          mi = false,
          sh = 0
        while (--i >= 0) {
          var x = (k == 8) ? s[i] & 0xff : intAt(s, i)
          if (x < 0) {
            if (s.charAt(i) == "-") mi = true
            continue
          }
          mi = false
          if (sh == 0)
            self[self.t++] = x
          else if (sh + k > self.DB) {
            self[self.t - 1] |= (x & ((1 << (self.DB - sh)) - 1)) << sh
            self[self.t++] = (x >> (self.DB - sh))
          } else
            self[self.t - 1] |= x << sh
          sh += k
          if (sh >= self.DB) sh -= self.DB
        }
        if (k == 8 && (s[0] & 0x80) != 0) {
          self.s = -1
          if (sh > 0) self[self.t - 1] |= ((1 << (self.DB - sh)) - 1) << sh
        }
        self.clamp()
        if (mi) BigInteger.ZERO.subTo(self, self)
      }

      // (protected) clamp off excess high words
      function bnpClamp() {
        var c = this.s & this.DM
        while (this.t > 0 && this[this.t - 1] == c) --this.t
      }

      // (public) return string representation in given radix
      function bnToString(b) {
        var self = this
        if (self.s < 0) return "-" + self.negate()
          .toString(b)
        var k
        if (b == 16) k = 4
        else if (b == 8) k = 3
        else if (b == 2) k = 1
        else if (b == 32) k = 5
        else if (b == 4) k = 2
        else return self.toRadix(b)
        var km = (1 << k) - 1,
          d, m = false,
          r = "",
          i = self.t
        var p = self.DB - (i * self.DB) % k
        if (i-- > 0) {
          if (p < self.DB && (d = self[i] >> p) > 0) {
            m = true
            r = int2char(d)
          }
          while (i >= 0) {
            if (p < k) {
              d = (self[i] & ((1 << p) - 1)) << (k - p)
              d |= self[--i] >> (p += self.DB - k)
            } else {
              d = (self[i] >> (p -= k)) & km
              if (p <= 0) {
                p += self.DB
                --i
              }
            }
            if (d > 0) m = true
            if (m) r += int2char(d)
          }
        }
        return m ? r : "0"
      }

      // (public) -this
      function bnNegate() {
        var r = new BigInteger()
        BigInteger.ZERO.subTo(this, r)
        return r
      }

      // (public) |this|
      function bnAbs() {
        return (this.s < 0) ? this.negate() : this
      }

      // (public) return + if this > a, - if this < a, 0 if equal
      function bnCompareTo(a) {
        var r = this.s - a.s
        if (r != 0) return r
        var i = this.t
        r = i - a.t
        if (r != 0) return (this.s < 0) ? -r : r
        while (--i >= 0)
          if ((r = this[i] - a[i]) != 0) return r
        return 0
      }

      // returns bit length of the integer x
      function nbits(x) {
        var r = 1,
          t
        if ((t = x >>> 16) != 0) {
          x = t
          r += 16
        }
        if ((t = x >> 8) != 0) {
          x = t
          r += 8
        }
        if ((t = x >> 4) != 0) {
          x = t
          r += 4
        }
        if ((t = x >> 2) != 0) {
          x = t
          r += 2
        }
        if ((t = x >> 1) != 0) {
          x = t
          r += 1
        }
        return r
      }

      // (public) return the number of bits in "this"
      function bnBitLength() {
        if (this.t <= 0) return 0
        return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ (this.s & this.DM))
      }

      // (public) return the number of bytes in "this"
      function bnByteLength() {
        return this.bitLength() >> 3
      }

      // (protected) r = this << n*DB
      function bnpDLShiftTo(n, r) {
        var i
        for (i = this.t - 1; i >= 0; --i) r[i + n] = this[i]
        for (i = n - 1; i >= 0; --i) r[i] = 0
        r.t = this.t + n
        r.s = this.s
      }

      // (protected) r = this >> n*DB
      function bnpDRShiftTo(n, r) {
        for (var i = n; i < this.t; ++i) r[i - n] = this[i]
        r.t = Math.max(this.t - n, 0)
        r.s = this.s
      }

      // (protected) r = this << n
      function bnpLShiftTo(n, r) {
        var self = this
        var bs = n % self.DB
        var cbs = self.DB - bs
        var bm = (1 << cbs) - 1
        var ds = Math.floor(n / self.DB),
          c = (self.s << bs) & self.DM,
          i
        for (i = self.t - 1; i >= 0; --i) {
          r[i + ds + 1] = (self[i] >> cbs) | c
          c = (self[i] & bm) << bs
        }
        for (i = ds - 1; i >= 0; --i) r[i] = 0
        r[ds] = c
        r.t = self.t + ds + 1
        r.s = self.s
        r.clamp()
      }

      // (protected) r = this >> n
      function bnpRShiftTo(n, r) {
        var self = this
        r.s = self.s
        var ds = Math.floor(n / self.DB)
        if (ds >= self.t) {
          r.t = 0
          return
        }
        var bs = n % self.DB
        var cbs = self.DB - bs
        var bm = (1 << bs) - 1
        r[0] = self[ds] >> bs
        for (var i = ds + 1; i < self.t; ++i) {
          r[i - ds - 1] |= (self[i] & bm) << cbs
          r[i - ds] = self[i] >> bs
        }
        if (bs > 0) r[self.t - ds - 1] |= (self.s & bm) << cbs
        r.t = self.t - ds
        r.clamp()
      }

      // (protected) r = this - a
      function bnpSubTo(a, r) {
        var self = this
        var i = 0,
          c = 0,
          m = Math.min(a.t, self.t)
        while (i < m) {
          c += self[i] - a[i]
          r[i++] = c & self.DM
          c >>= self.DB
        }
        if (a.t < self.t) {
          c -= a.s
          while (i < self.t) {
            c += self[i]
            r[i++] = c & self.DM
            c >>= self.DB
          }
          c += self.s
        } else {
          c += self.s
          while (i < a.t) {
            c -= a[i]
            r[i++] = c & self.DM
            c >>= self.DB
          }
          c -= a.s
        }
        r.s = (c < 0) ? -1 : 0
        if (c < -1) r[i++] = self.DV + c
        else if (c > 0) r[i++] = c
        r.t = i
        r.clamp()
      }

      // (protected) r = this * a, r != this,a (HAC 14.12)
      // "this" should be the larger one if appropriate.
      function bnpMultiplyTo(a, r) {
        var x = this.abs(),
          y = a.abs()
        var i = x.t
        r.t = i + y.t
        while (--i >= 0) r[i] = 0
        for (i = 0; i < y.t; ++i) r[i + x.t] = x.am(0, y[i], r, i, 0, x.t)
        r.s = 0
        r.clamp()
        if (this.s != a.s) BigInteger.ZERO.subTo(r, r)
      }

      // (protected) r = this^2, r != this (HAC 14.16)
      function bnpSquareTo(r) {
        var x = this.abs()
        var i = r.t = 2 * x.t
        while (--i >= 0) r[i] = 0
        for (i = 0; i < x.t - 1; ++i) {
          var c = x.am(i, x[i], r, 2 * i, 0, 1)
          if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV
            r[i + x.t + 1] = 1
          }
        }
        if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1)
        r.s = 0
        r.clamp()
      }

      // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
      // r != q, this != m.  q or r may be null.
      function bnpDivRemTo(m, q, r) {
        var self = this
        var pm = m.abs()
        if (pm.t <= 0) return
        var pt = self.abs()
        if (pt.t < pm.t) {
          if (q != null) q.fromInt(0)
          if (r != null) self.copyTo(r)
          return
        }
        if (r == null) r = new BigInteger()
        var y = new BigInteger(),
          ts = self.s,
          ms = m.s
        var nsh = self.DB - nbits(pm[pm.t - 1]); // normalize modulus
        if (nsh > 0) {
          pm.lShiftTo(nsh, y)
          pt.lShiftTo(nsh, r)
        } else {
          pm.copyTo(y)
          pt.copyTo(r)
        }
        var ys = y.t
        var y0 = y[ys - 1]
        if (y0 == 0) return
        var yt = y0 * (1 << self.F1) + ((ys > 1) ? y[ys - 2] >> self.F2 : 0)
        var d1 = self.FV / yt,
          d2 = (1 << self.F1) / yt,
          e = 1 << self.F2
        var i = r.t,
          j = i - ys,
          t = (q == null) ? new BigInteger() : q
        y.dlShiftTo(j, t)
        if (r.compareTo(t) >= 0) {
          r[r.t++] = 1
          r.subTo(t, r)
        }
        BigInteger.ONE.dlShiftTo(ys, t)
        t.subTo(y, y); // "negative" y so we can replace sub with am later
        while (y.t < ys) y[y.t++] = 0
        while (--j >= 0) {
          // Estimate quotient digit
          var qd = (r[--i] == y0) ? self.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2)
          if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) { // Try it out
            y.dlShiftTo(j, t)
            r.subTo(t, r)
            while (r[i] < --qd) r.subTo(t, r)
          }
        }
        if (q != null) {
          r.drShiftTo(ys, q)
          if (ts != ms) BigInteger.ZERO.subTo(q, q)
        }
        r.t = ys
        r.clamp()
        if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder
        if (ts < 0) BigInteger.ZERO.subTo(r, r)
      }

      // (public) this mod a
      function bnMod(a) {
        var r = new BigInteger()
        this.abs()
          .divRemTo(a, null, r)
        if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r)
        return r
      }

      // Modular reduction using "classic" algorithm
      function Classic(m) {
        this.m = m
      }

      function cConvert(x) {
        if (x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m)
        else return x
      }

      function cRevert(x) {
        return x
      }

      function cReduce(x) {
        x.divRemTo(this.m, null, x)
      }

      function cMulTo(x, y, r) {
        x.multiplyTo(y, r)
        this.reduce(r)
      }

      function cSqrTo(x, r) {
        x.squareTo(r)
        this.reduce(r)
      }

      Classic.prototype.convert = cConvert
      Classic.prototype.revert = cRevert
      Classic.prototype.reduce = cReduce
      Classic.prototype.mulTo = cMulTo
      Classic.prototype.sqrTo = cSqrTo

      // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
      // justification:
      //         xy == 1 (mod m)
      //         xy =  1+km
      //   xy(2-xy) = (1+km)(1-km)
      // x[y(2-xy)] = 1-k^2m^2
      // x[y(2-xy)] == 1 (mod m^2)
      // if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
      // should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
      // JS multiply "overflows" differently from C/C++, so care is needed here.
      function bnpInvDigit() {
        if (this.t < 1) return 0
        var x = this[0]
        if ((x & 1) == 0) return 0
        var y = x & 3; // y == 1/x mod 2^2
        y = (y * (2 - (x & 0xf) * y)) & 0xf; // y == 1/x mod 2^4
        y = (y * (2 - (x & 0xff) * y)) & 0xff; // y == 1/x mod 2^8
        y = (y * (2 - (((x & 0xffff) * y) & 0xffff))) & 0xffff; // y == 1/x mod 2^16
        // last step - calculate inverse mod DV directly
        // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
        y = (y * (2 - x * y % this.DV)) % this.DV; // y == 1/x mod 2^dbits
        // we really want the negative inverse, and -DV < y < DV
        return (y > 0) ? this.DV - y : -y
      }

      // Montgomery reduction
      function Montgomery(m) {
        this.m = m
        this.mp = m.invDigit()
        this.mpl = this.mp & 0x7fff
        this.mph = this.mp >> 15
        this.um = (1 << (m.DB - 15)) - 1
        this.mt2 = 2 * m.t
      }

      // xR mod m
      function montConvert(x) {
        var r = new BigInteger()
        x.abs()
          .dlShiftTo(this.m.t, r)
        r.divRemTo(this.m, null, r)
        if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r)
        return r
      }

      // x/R mod m
      function montRevert(x) {
        var r = new BigInteger()
        x.copyTo(r)
        this.reduce(r)
        return r
      }

      // x = x/R mod m (HAC 14.32)
      function montReduce(x) {
        while (x.t <= this.mt2) // pad x so am has enough room later
          x[x.t++] = 0
        for (var i = 0; i < this.m.t; ++i) {
          // faster way of calculating u0 = x[i]*mp mod DV
          var j = x[i] & 0x7fff
          var u0 = (j * this.mpl + (((j * this.mph + (x[i] >> 15) * this.mpl) & this.um) << 15)) & x.DM
          // use am to combine the multiply-shift-add into one call
          j = i + this.m.t
          x[j] += this.m.am(0, u0, x, i, 0, this.m.t)
          // propagate carry
          while (x[j] >= x.DV) {
            x[j] -= x.DV
            x[++j]++
          }
        }
        x.clamp()
        x.drShiftTo(this.m.t, x)
        if (x.compareTo(this.m) >= 0) x.subTo(this.m, x)
      }

      // r = "x^2/R mod m"; x != r
      function montSqrTo(x, r) {
        x.squareTo(r)
        this.reduce(r)
      }

      // r = "xy/R mod m"; x,y != r
      function montMulTo(x, y, r) {
        x.multiplyTo(y, r)
        this.reduce(r)
      }

      Montgomery.prototype.convert = montConvert
      Montgomery.prototype.revert = montRevert
      Montgomery.prototype.reduce = montReduce
      Montgomery.prototype.mulTo = montMulTo
      Montgomery.prototype.sqrTo = montSqrTo

      // (protected) true iff this is even
      function bnpIsEven() {
        return ((this.t > 0) ? (this[0] & 1) : this.s) == 0
      }

      // (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
      function bnpExp(e, z) {
        if (e > 0xffffffff || e < 1) return BigInteger.ONE
        var r = new BigInteger(),
          r2 = new BigInteger(),
          g = z.convert(this),
          i = nbits(e) - 1
        g.copyTo(r)
        while (--i >= 0) {
          z.sqrTo(r, r2)
          if ((e & (1 << i)) > 0) z.mulTo(r2, g, r)
          else {
            var t = r
            r = r2
            r2 = t
          }
        }
        return z.revert(r)
      }

      // (public) this^e % m, 0 <= e < 2^32
      function bnModPowInt(e, m) {
        var z
        if (e < 256 || m.isEven()) z = new Classic(m)
        else z = new Montgomery(m)
        return this.exp(e, z)
      }

      // protected
      proto.copyTo = bnpCopyTo
      proto.fromInt = bnpFromInt
      proto.fromString = bnpFromString
      proto.clamp = bnpClamp
      proto.dlShiftTo = bnpDLShiftTo
      proto.drShiftTo = bnpDRShiftTo
      proto.lShiftTo = bnpLShiftTo
      proto.rShiftTo = bnpRShiftTo
      proto.subTo = bnpSubTo
      proto.multiplyTo = bnpMultiplyTo
      proto.squareTo = bnpSquareTo
      proto.divRemTo = bnpDivRemTo
      proto.invDigit = bnpInvDigit
      proto.isEven = bnpIsEven
      proto.exp = bnpExp

      // public
      proto.toString = bnToString
      proto.negate = bnNegate
      proto.abs = bnAbs
      proto.compareTo = bnCompareTo
      proto.bitLength = bnBitLength
      proto.byteLength = bnByteLength
      proto.mod = bnMod
      proto.modPowInt = bnModPowInt

      // (public)
      function bnClone() {
        var r = new BigInteger()
        this.copyTo(r)
        return r
      }

      // (public) return value as integer
      function bnIntValue() {
        if (this.s < 0) {
          if (this.t == 1) return this[0] - this.DV
          else if (this.t == 0) return -1
        } else if (this.t == 1) return this[0]
        else if (this.t == 0) return 0
        // assumes 16 < DB < 32
        return ((this[1] & ((1 << (32 - this.DB)) - 1)) << this.DB) | this[0]
      }

      // (public) return value as byte
      function bnByteValue() {
        return (this.t == 0) ? this.s : (this[0] << 24) >> 24
      }

      // (public) return value as short (assumes DB>=16)
      function bnShortValue() {
        return (this.t == 0) ? this.s : (this[0] << 16) >> 16
      }

      // (protected) return x s.t. r^x < DV
      function bnpChunkSize(r) {
        return Math.floor(Math.LN2 * this.DB / Math.log(r))
      }

      // (public) 0 if this == 0, 1 if this > 0
      function bnSigNum() {
        if (this.s < 0) return -1
        else if (this.t <= 0 || (this.t == 1 && this[0] <= 0)) return 0
        else return 1
      }

      // (protected) convert to radix string
      function bnpToRadix(b) {
        if (b == null) b = 10
        if (this.signum() == 0 || b < 2 || b > 36) return "0"
        var cs = this.chunkSize(b)
        var a = Math.pow(b, cs)
        var d = nbv(a),
          y = new BigInteger(),
          z = new BigInteger(),
          r = ""
        this.divRemTo(d, y, z)
        while (y.signum() > 0) {
          r = (a + z.intValue())
            .toString(b)
            .substr(1) + r
          y.divRemTo(d, y, z)
        }
        return z.intValue()
          .toString(b) + r
      }

      // (protected) convert from radix string
      function bnpFromRadix(s, b) {
        var self = this
        self.fromInt(0)
        if (b == null) b = 10
        var cs = self.chunkSize(b)
        var d = Math.pow(b, cs),
          mi = false,
          j = 0,
          w = 0
        for (var i = 0; i < s.length; ++i) {
          var x = intAt(s, i)
          if (x < 0) {
            if (s.charAt(i) == "-" && self.signum() == 0) mi = true
            continue
          }
          w = b * w + x
          if (++j >= cs) {
            self.dMultiply(d)
            self.dAddOffset(w, 0)
            j = 0
            w = 0
          }
        }
        if (j > 0) {
          self.dMultiply(Math.pow(b, j))
          self.dAddOffset(w, 0)
        }
        if (mi) BigInteger.ZERO.subTo(self, self)
      }

      // (protected) alternate constructor
      function bnpFromNumber(a, b, c) {
        var self = this
        if ("number" == typeof b) {
          // new BigInteger(int,int,RNG)
          if (a < 2) self.fromInt(1)
          else {
            self.fromNumber(a, c)
            if (!self.testBit(a - 1)) // force MSB set
              self.bitwiseTo(BigInteger.ONE.shiftLeft(a - 1), op_or, self)
            if (self.isEven()) self.dAddOffset(1, 0); // force odd
            while (!self.isProbablePrime(b)) {
              self.dAddOffset(2, 0)
              if (self.bitLength() > a) self.subTo(BigInteger.ONE.shiftLeft(a - 1), self)
            }
          }
        } else {
          // new BigInteger(int,RNG)
          var x = new Array(),
            t = a & 7
          x.length = (a >> 3) + 1
          b.nextBytes(x)
          if (t > 0) x[0] &= ((1 << t) - 1)
          else x[0] = 0
          self.fromString(x, 256)
        }
      }

      // (public) convert to bigendian byte array
      function bnToByteArray() {
        var self = this
        var i = self.t,
          r = new Array()
        r[0] = self.s
        var p = self.DB - (i * self.DB) % 8,
          d, k = 0
        if (i-- > 0) {
          if (p < self.DB && (d = self[i] >> p) != (self.s & self.DM) >> p)
            r[k++] = d | (self.s << (self.DB - p))
          while (i >= 0) {
            if (p < 8) {
              d = (self[i] & ((1 << p) - 1)) << (8 - p)
              d |= self[--i] >> (p += self.DB - 8)
            } else {
              d = (self[i] >> (p -= 8)) & 0xff
              if (p <= 0) {
                p += self.DB
                --i
              }
            }
            if ((d & 0x80) != 0) d |= -256
            if (k === 0 && (self.s & 0x80) != (d & 0x80)) ++k
            if (k > 0 || d != self.s) r[k++] = d
          }
        }
        return r
      }

      function bnEquals(a) {
        return (this.compareTo(a) == 0)
      }

      function bnMin(a) {
        return (this.compareTo(a) < 0) ? this : a
      }

      function bnMax(a) {
        return (this.compareTo(a) > 0) ? this : a
      }

      // (protected) r = this op a (bitwise)
      function bnpBitwiseTo(a, op, r) {
        var self = this
        var i, f, m = Math.min(a.t, self.t)
        for (i = 0; i < m; ++i) r[i] = op(self[i], a[i])
        if (a.t < self.t) {
          f = a.s & self.DM
          for (i = m; i < self.t; ++i) r[i] = op(self[i], f)
          r.t = self.t
        } else {
          f = self.s & self.DM
          for (i = m; i < a.t; ++i) r[i] = op(f, a[i])
          r.t = a.t
        }
        r.s = op(self.s, a.s)
        r.clamp()
      }

      // (public) this & a
      function op_and(x, y) {
        return x & y
      }

      function bnAnd(a) {
        var r = new BigInteger()
        this.bitwiseTo(a, op_and, r)
        return r
      }

      // (public) this | a
      function op_or(x, y) {
        return x | y
      }

      function bnOr(a) {
        var r = new BigInteger()
        this.bitwiseTo(a, op_or, r)
        return r
      }

      // (public) this ^ a
      function op_xor(x, y) {
        return x ^ y
      }

      function bnXor(a) {
        var r = new BigInteger()
        this.bitwiseTo(a, op_xor, r)
        return r
      }

      // (public) this & ~a
      function op_andnot(x, y) {
        return x & ~y
      }

      function bnAndNot(a) {
        var r = new BigInteger()
        this.bitwiseTo(a, op_andnot, r)
        return r
      }

      // (public) ~this
      function bnNot() {
        var r = new BigInteger()
        for (var i = 0; i < this.t; ++i) r[i] = this.DM & ~this[i]
        r.t = this.t
        r.s = ~this.s
        return r
      }

      // (public) this << n
      function bnShiftLeft(n) {
        var r = new BigInteger()
        if (n < 0) this.rShiftTo(-n, r)
        else this.lShiftTo(n, r)
        return r
      }

      // (public) this >> n
      function bnShiftRight(n) {
        var r = new BigInteger()
        if (n < 0) this.lShiftTo(-n, r)
        else this.rShiftTo(n, r)
        return r
      }

      // return index of lowest 1-bit in x, x < 2^31
      function lbit(x) {
        if (x == 0) return -1
        var r = 0
        if ((x & 0xffff) == 0) {
          x >>= 16
          r += 16
        }
        if ((x & 0xff) == 0) {
          x >>= 8
          r += 8
        }
        if ((x & 0xf) == 0) {
          x >>= 4
          r += 4
        }
        if ((x & 3) == 0) {
          x >>= 2
          r += 2
        }
        if ((x & 1) == 0) ++r
        return r
      }

      // (public) returns index of lowest 1-bit (or -1 if none)
      function bnGetLowestSetBit() {
        for (var i = 0; i < this.t; ++i)
          if (this[i] != 0) return i * this.DB + lbit(this[i])
        if (this.s < 0) return this.t * this.DB
        return -1
      }

      // return number of 1 bits in x
      function cbit(x) {
        var r = 0
        while (x != 0) {
          x &= x - 1
          ++r
        }
        return r
      }

      // (public) return number of set bits
      function bnBitCount() {
        var r = 0,
          x = this.s & this.DM
        for (var i = 0; i < this.t; ++i) r += cbit(this[i] ^ x)
        return r
      }

      // (public) true iff nth bit is set
      function bnTestBit(n) {
        var j = Math.floor(n / this.DB)
        if (j >= this.t) return (this.s != 0)
        return ((this[j] & (1 << (n % this.DB))) != 0)
      }

      // (protected) this op (1<<n)
      function bnpChangeBit(n, op) {
        var r = BigInteger.ONE.shiftLeft(n)
        this.bitwiseTo(r, op, r)
        return r
      }

      // (public) this | (1<<n)
      function bnSetBit(n) {
        return this.changeBit(n, op_or)
      }

      // (public) this & ~(1<<n)
      function bnClearBit(n) {
        return this.changeBit(n, op_andnot)
      }

      // (public) this ^ (1<<n)
      function bnFlipBit(n) {
        return this.changeBit(n, op_xor)
      }

      // (protected) r = this + a
      function bnpAddTo(a, r) {
        var self = this

        var i = 0,
          c = 0,
          m = Math.min(a.t, self.t)
        while (i < m) {
          c += self[i] + a[i]
          r[i++] = c & self.DM
          c >>= self.DB
        }
        if (a.t < self.t) {
          c += a.s
          while (i < self.t) {
            c += self[i]
            r[i++] = c & self.DM
            c >>= self.DB
          }
          c += self.s
        } else {
          c += self.s
          while (i < a.t) {
            c += a[i]
            r[i++] = c & self.DM
            c >>= self.DB
          }
          c += a.s
        }
        r.s = (c < 0) ? -1 : 0
        if (c > 0) r[i++] = c
        else if (c < -1) r[i++] = self.DV + c
        r.t = i
        r.clamp()
      }

      // (public) this + a
      function bnAdd(a) {
        var r = new BigInteger()
        this.addTo(a, r)
        return r
      }

      // (public) this - a
      function bnSubtract(a) {
        var r = new BigInteger()
        this.subTo(a, r)
        return r
      }

      // (public) this * a
      function bnMultiply(a) {
        var r = new BigInteger()
        this.multiplyTo(a, r)
        return r
      }

      // (public) this^2
      function bnSquare() {
        var r = new BigInteger()
        this.squareTo(r)
        return r
      }

      // (public) this / a
      function bnDivide(a) {
        var r = new BigInteger()
        this.divRemTo(a, r, null)
        return r
      }

      // (public) this % a
      function bnRemainder(a) {
        var r = new BigInteger()
        this.divRemTo(a, null, r)
        return r
      }

      // (public) [this/a,this%a]
      function bnDivideAndRemainder(a) {
        var q = new BigInteger(),
          r = new BigInteger()
        this.divRemTo(a, q, r)
        return new Array(q, r)
      }

      // (protected) this *= n, this >= 0, 1 < n < DV
      function bnpDMultiply(n) {
        this[this.t] = this.am(0, n - 1, this, 0, 0, this.t)
        ++this.t
        this.clamp()
      }

      // (protected) this += n << w words, this >= 0
      function bnpDAddOffset(n, w) {
        if (n == 0) return
        while (this.t <= w) this[this.t++] = 0
        this[w] += n
        while (this[w] >= this.DV) {
          this[w] -= this.DV
          if (++w >= this.t) this[this.t++] = 0
          ++this[w]
        }
      }

      // A "null" reducer
      function NullExp() { }

      function nNop(x) {
        return x
      }

      function nMulTo(x, y, r) {
        x.multiplyTo(y, r)
      }

      function nSqrTo(x, r) {
        x.squareTo(r)
      }

      NullExp.prototype.convert = nNop
      NullExp.prototype.revert = nNop
      NullExp.prototype.mulTo = nMulTo
      NullExp.prototype.sqrTo = nSqrTo

      // (public) this^e
      function bnPow(e) {
        return this.exp(e, new NullExp())
      }

      // (protected) r = lower n words of "this * a", a.t <= n
      // "this" should be the larger one if appropriate.
      function bnpMultiplyLowerTo(a, n, r) {
        var i = Math.min(this.t + a.t, n)
        r.s = 0; // assumes a,this >= 0
        r.t = i
        while (i > 0) r[--i] = 0
        var j
        for (j = r.t - this.t; i < j; ++i) r[i + this.t] = this.am(0, a[i], r, i, 0, this.t)
        for (j = Math.min(a.t, n); i < j; ++i) this.am(0, a[i], r, i, 0, n - i)
        r.clamp()
      }

      // (protected) r = "this * a" without lower n words, n > 0
      // "this" should be the larger one if appropriate.
      function bnpMultiplyUpperTo(a, n, r) {
        --n
        var i = r.t = this.t + a.t - n
        r.s = 0; // assumes a,this >= 0
        while (--i >= 0) r[i] = 0
        for (i = Math.max(n - this.t, 0); i < a.t; ++i)
          r[this.t + i - n] = this.am(n - i, a[i], r, 0, 0, this.t + i - n)
        r.clamp()
        r.drShiftTo(1, r)
      }

      // Barrett modular reduction
      function Barrett(m) {
        // setup Barrett
        this.r2 = new BigInteger()
        this.q3 = new BigInteger()
        BigInteger.ONE.dlShiftTo(2 * m.t, this.r2)
        this.mu = this.r2.divide(m)
        this.m = m
      }

      function barrettConvert(x) {
        if (x.s < 0 || x.t > 2 * this.m.t) return x.mod(this.m)
        else if (x.compareTo(this.m) < 0) return x
        else {
          var r = new BigInteger()
          x.copyTo(r)
          this.reduce(r)
          return r
        }
      }

      function barrettRevert(x) {
        return x
      }

      // x = x mod m (HAC 14.42)
      function barrettReduce(x) {
        var self = this
        x.drShiftTo(self.m.t - 1, self.r2)
        if (x.t > self.m.t + 1) {
          x.t = self.m.t + 1
          x.clamp()
        }
        self.mu.multiplyUpperTo(self.r2, self.m.t + 1, self.q3)
        self.m.multiplyLowerTo(self.q3, self.m.t + 1, self.r2)
        while (x.compareTo(self.r2) < 0) x.dAddOffset(1, self.m.t + 1)
        x.subTo(self.r2, x)
        while (x.compareTo(self.m) >= 0) x.subTo(self.m, x)
      }

      // r = x^2 mod m; x != r
      function barrettSqrTo(x, r) {
        x.squareTo(r)
        this.reduce(r)
      }

      // r = x*y mod m; x,y != r
      function barrettMulTo(x, y, r) {
        x.multiplyTo(y, r)
        this.reduce(r)
      }

      Barrett.prototype.convert = barrettConvert
      Barrett.prototype.revert = barrettRevert
      Barrett.prototype.reduce = barrettReduce
      Barrett.prototype.mulTo = barrettMulTo
      Barrett.prototype.sqrTo = barrettSqrTo

      // (public) this^e % m (HAC 14.85)
      function bnModPow(e, m) {
        var i = e.bitLength(),
          k, r = nbv(1),
          z
        if (i <= 0) return r
        else if (i < 18) k = 1
        else if (i < 48) k = 3
        else if (i < 144) k = 4
        else if (i < 768) k = 5
        else k = 6
        if (i < 8)
          z = new Classic(m)
        else if (m.isEven())
          z = new Barrett(m)
        else
          z = new Montgomery(m)

        // precomputation
        var g = new Array(),
          n = 3,
          k1 = k - 1,
          km = (1 << k) - 1
        g[1] = z.convert(this)
        if (k > 1) {
          var g2 = new BigInteger()
          z.sqrTo(g[1], g2)
          while (n <= km) {
            g[n] = new BigInteger()
            z.mulTo(g2, g[n - 2], g[n])
            n += 2
          }
        }

        var j = e.t - 1,
          w, is1 = true,
          r2 = new BigInteger(),
          t
        i = nbits(e[j]) - 1
        while (j >= 0) {
          if (i >= k1) w = (e[j] >> (i - k1)) & km
          else {
            w = (e[j] & ((1 << (i + 1)) - 1)) << (k1 - i)
            if (j > 0) w |= e[j - 1] >> (this.DB + i - k1)
          }

          n = k
          while ((w & 1) == 0) {
            w >>= 1
            --n
          }
          if ((i -= n) < 0) {
            i += this.DB
            --j
          }
          if (is1) { // ret == 1, don't bother squaring or multiplying it
            g[w].copyTo(r)
            is1 = false
          } else {
            while (n > 1) {
              z.sqrTo(r, r2)
              z.sqrTo(r2, r)
              n -= 2
            }
            if (n > 0) z.sqrTo(r, r2)
            else {
              t = r
              r = r2
              r2 = t
            }
            z.mulTo(r2, g[w], r)
          }

          while (j >= 0 && (e[j] & (1 << i)) == 0) {
            z.sqrTo(r, r2)
            t = r
            r = r2
            r2 = t
            if (--i < 0) {
              i = this.DB - 1
              --j
            }
          }
        }
        return z.revert(r)
      }

      // (public) gcd(this,a) (HAC 14.54)
      function bnGCD(a) {
        var x = (this.s < 0) ? this.negate() : this.clone()
        var y = (a.s < 0) ? a.negate() : a.clone()
        if (x.compareTo(y) < 0) {
          var t = x
          x = y
          y = t
        }
        var i = x.getLowestSetBit(),
          g = y.getLowestSetBit()
        if (g < 0) return x
        if (i < g) g = i
        if (g > 0) {
          x.rShiftTo(g, x)
          y.rShiftTo(g, y)
        }
        while (x.signum() > 0) {
          if ((i = x.getLowestSetBit()) > 0) x.rShiftTo(i, x)
          if ((i = y.getLowestSetBit()) > 0) y.rShiftTo(i, y)
          if (x.compareTo(y) >= 0) {
            x.subTo(y, x)
            x.rShiftTo(1, x)
          } else {
            y.subTo(x, y)
            y.rShiftTo(1, y)
          }
        }
        if (g > 0) y.lShiftTo(g, y)
        return y
      }

      // (protected) this % n, n < 2^26
      function bnpModInt(n) {
        if (n <= 0) return 0
        var d = this.DV % n,
          r = (this.s < 0) ? n - 1 : 0
        if (this.t > 0)
          if (d == 0) r = this[0] % n
          else
            for (var i = this.t - 1; i >= 0; --i) r = (d * r + this[i]) % n
        return r
      }

      // (public) 1/this % m (HAC 14.61)
      function bnModInverse(m) {
        var ac = m.isEven()
        if (this.signum() === 0) throw new Error('division by zero')
        if ((this.isEven() && ac) || m.signum() == 0) return BigInteger.ZERO
        var u = m.clone(),
          v = this.clone()
        var a = nbv(1),
          b = nbv(0),
          c = nbv(0),
          d = nbv(1)
        while (u.signum() != 0) {
          while (u.isEven()) {
            u.rShiftTo(1, u)
            if (ac) {
              if (!a.isEven() || !b.isEven()) {
                a.addTo(this, a)
                b.subTo(m, b)
              }
              a.rShiftTo(1, a)
            } else if (!b.isEven()) b.subTo(m, b)
            b.rShiftTo(1, b)
          }
          while (v.isEven()) {
            v.rShiftTo(1, v)
            if (ac) {
              if (!c.isEven() || !d.isEven()) {
                c.addTo(this, c)
                d.subTo(m, d)
              }
              c.rShiftTo(1, c)
            } else if (!d.isEven()) d.subTo(m, d)
            d.rShiftTo(1, d)
          }
          if (u.compareTo(v) >= 0) {
            u.subTo(v, u)
            if (ac) a.subTo(c, a)
            b.subTo(d, b)
          } else {
            v.subTo(u, v)
            if (ac) c.subTo(a, c)
            d.subTo(b, d)
          }
        }
        if (v.compareTo(BigInteger.ONE) != 0) return BigInteger.ZERO
        while (d.compareTo(m) >= 0) d.subTo(m, d)
        while (d.signum() < 0) d.addTo(m, d)
        return d
      }

      var lowprimes = [
        2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71,
        73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151,
        157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233,
        239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317,
        331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419,
        421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503,
        509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607,
        613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701,
        709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811,
        821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911,
        919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997
      ]

      var lplim = (1 << 26) / lowprimes[lowprimes.length - 1]

      // (public) test primality with certainty >= 1-.5^t
      function bnIsProbablePrime(t) {
        var i, x = this.abs()
        if (x.t == 1 && x[0] <= lowprimes[lowprimes.length - 1]) {
          for (i = 0; i < lowprimes.length; ++i)
            if (x[0] == lowprimes[i]) return true
          return false
        }
        if (x.isEven()) return false
        i = 1
        while (i < lowprimes.length) {
          var m = lowprimes[i],
            j = i + 1
          while (j < lowprimes.length && m < lplim) m *= lowprimes[j++]
          m = x.modInt(m)
          while (i < j) if (m % lowprimes[i++] == 0) return false
        }
        return x.millerRabin(t)
      }

      // (protected) true if probably prime (HAC 4.24, Miller-Rabin)
      function bnpMillerRabin(t) {
        var n1 = this.subtract(BigInteger.ONE)
        var k = n1.getLowestSetBit()
        if (k <= 0) return false
        var r = n1.shiftRight(k)
        t = (t + 1) >> 1
        if (t > lowprimes.length) t = lowprimes.length
        var a = new BigInteger(null)
        var j, bases = []
        for (var i = 0; i < t; ++i) {
          for (; ;) {
            j = lowprimes[Math.floor(Math.random() * lowprimes.length)]
            if (bases.indexOf(j) == -1) break
          }
          bases.push(j)
          a.fromInt(j)
          var y = a.modPow(r, this)
          if (y.compareTo(BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
            var j = 1
            while (j++ < k && y.compareTo(n1) != 0) {
              y = y.modPowInt(2, this)
              if (y.compareTo(BigInteger.ONE) == 0) return false
            }
            if (y.compareTo(n1) != 0) return false
          }
        }
        return true
      }

      // protected
      proto.chunkSize = bnpChunkSize
      proto.toRadix = bnpToRadix
      proto.fromRadix = bnpFromRadix
      proto.fromNumber = bnpFromNumber
      proto.bitwiseTo = bnpBitwiseTo
      proto.changeBit = bnpChangeBit
      proto.addTo = bnpAddTo
      proto.dMultiply = bnpDMultiply
      proto.dAddOffset = bnpDAddOffset
      proto.multiplyLowerTo = bnpMultiplyLowerTo
      proto.multiplyUpperTo = bnpMultiplyUpperTo
      proto.modInt = bnpModInt
      proto.millerRabin = bnpMillerRabin

      // public
      proto.clone = bnClone
      proto.intValue = bnIntValue
      proto.byteValue = bnByteValue
      proto.shortValue = bnShortValue
      proto.signum = bnSigNum
      proto.toByteArray = bnToByteArray
      proto.equals = bnEquals
      proto.min = bnMin
      proto.max = bnMax
      proto.and = bnAnd
      proto.or = bnOr
      proto.xor = bnXor
      proto.andNot = bnAndNot
      proto.not = bnNot
      proto.shiftLeft = bnShiftLeft
      proto.shiftRight = bnShiftRight
      proto.getLowestSetBit = bnGetLowestSetBit
      proto.bitCount = bnBitCount
      proto.testBit = bnTestBit
      proto.setBit = bnSetBit
      proto.clearBit = bnClearBit
      proto.flipBit = bnFlipBit
      proto.add = bnAdd
      proto.subtract = bnSubtract
      proto.multiply = bnMultiply
      proto.divide = bnDivide
      proto.remainder = bnRemainder
      proto.divideAndRemainder = bnDivideAndRemainder
      proto.modPow = bnModPow
      proto.modInverse = bnModInverse
      proto.pow = bnPow
      proto.gcd = bnGCD
      proto.isProbablePrime = bnIsProbablePrime

      // JSBN-specific extension
      proto.square = bnSquare

      // constants
      BigInteger.ZERO = nbv(0)
      BigInteger.ONE = nbv(1)
      BigInteger.valueOf = nbv

      module.exports = BigInteger

    }, { "../package.json": 6 }], 4: [function (require, module, exports) {
      (function (Buffer) {
        (function () {
          // FIXME: Kind of a weird way to throw exceptions, consider removing
          var assert = require('assert')
          var BigInteger = require('./bigi')

          /**
           * Turns a byte array into a big integer.
           *
           * This function will interpret a byte array as a big integer in big
           * endian notation.
           */
          BigInteger.fromByteArrayUnsigned = function (byteArray) {
            // BigInteger expects a DER integer conformant byte array
            if (byteArray[0] & 0x80) {
              return new BigInteger([0].concat(byteArray))
            }

            return new BigInteger(byteArray)
          }

          /**
           * Returns a byte array representation of the big integer.
           *
           * This returns the absolute of the contained value in big endian
           * form. A value of zero results in an empty array.
           */
          BigInteger.prototype.toByteArrayUnsigned = function () {
            var byteArray = this.toByteArray()
            return byteArray[0] === 0 ? byteArray.slice(1) : byteArray
          }

          BigInteger.fromDERInteger = function (byteArray) {
            return new BigInteger(byteArray)
          }

          /*
           * Converts BigInteger to a DER integer representation.
           *
           * The format for this value uses the most significant bit as a sign
           * bit.  If the most significant bit is already set and the integer is
           * positive, a 0x00 is prepended.
           *
           * Examples:
           *
           *      0 =>     0x00
           *      1 =>     0x01
           *     -1 =>     0xff
           *    127 =>     0x7f
           *   -127 =>     0x81
           *    128 =>   0x0080
           *   -128 =>     0x80
           *    255 =>   0x00ff
           *   -255 =>   0xff01
           *  16300 =>   0x3fac
           * -16300 =>   0xc054
           *  62300 => 0x00f35c
           * -62300 => 0xff0ca4
          */
          BigInteger.prototype.toDERInteger = BigInteger.prototype.toByteArray

          BigInteger.fromBuffer = function (buffer) {
            // BigInteger expects a DER integer conformant byte array
            if (buffer[0] & 0x80) {
              var byteArray = Array.prototype.slice.call(buffer)

              return new BigInteger([0].concat(byteArray))
            }

            return new BigInteger(buffer)
          }

          BigInteger.fromHex = function (hex) {
            if (hex === '') return BigInteger.ZERO

            assert.equal(hex, hex.match(/^[A-Fa-f0-9]+/), 'Invalid hex string')
            assert.equal(hex.length % 2, 0, 'Incomplete hex')
            return new BigInteger(hex, 16)
          }

          BigInteger.prototype.toBuffer = function (size) {
            var byteArray = this.toByteArrayUnsigned()
            var zeros = []

            var padding = size - byteArray.length
            while (zeros.length < padding) zeros.push(0)

            return new Buffer(zeros.concat(byteArray))
          }

          BigInteger.prototype.toHex = function (size) {
            return this.toBuffer(size).toString('hex')
          }

        }).call(this)
      }).call(this, require("buffer").Buffer)
    }, { "./bigi": 3, "assert": 165, "buffer": 216 }], 5: [function (require, module, exports) {
      var BigInteger = require('./bigi')

      //addons
      require('./convert')

      module.exports = BigInteger
    }, { "./bigi": 3, "./convert": 4 }], 6: [function (require, module, exports) {
      module.exports = {
        "name": "bigi",
        "version": "1.4.2",
        "description": "Big integers.",
        "keywords": [
          "cryptography",
          "math",
          "bitcoin",
          "arbitrary",
          "precision",
          "arithmetic",
          "big",
          "integer",
          "int",
          "number",
          "biginteger",
          "bigint",
          "bignumber",
          "decimal",
          "float"
        ],
        "devDependencies": {
          "coveralls": "^2.11.2",
          "istanbul": "^0.3.5",
          "jshint": "^2.5.1",
          "mocha": "^2.1.0",
          "mochify": "^2.1.0"
        },
        "repository": {
          "url": "https://github.com/cryptocoinjs/bigi",
          "type": "git"
        },
        "main": "./lib/index.js",
        "scripts": {
          "browser-test": "./node_modules/.bin/mochify --wd -R spec",
          "test": "./node_modules/.bin/_mocha -- test/*.js",
          "jshint": "./node_modules/.bin/jshint --config jshint.json lib/*.js ; true",
          "unit": "./node_modules/.bin/mocha",
          "coverage": "./node_modules/.bin/istanbul cover ./node_modules/.bin/_mocha -- --reporter list test/*.js",
          "coveralls": "npm run-script coverage && node ./node_modules/.bin/coveralls < coverage/lcov.info"
        },
        "dependencies": {},
        "testling": {
          "files": "test/*.js",
          "harness": "mocha",
          "browsers": [
            "ie/9..latest",
            "firefox/latest",
            "chrome/latest",
            "safari/6.0..latest",
            "iphone/6.0..latest",
            "android-browser/4.2..latest"
          ]
        }
      }

    }, {}], 7: [function (require, module, exports) {
      // Reference https://github.com/bitcoin/bips/blob/master/bip-0066.mediawiki
      // Format: 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
      // NOTE: SIGHASH byte ignored AND restricted, truncate before use

      var Buffer = require('safe-buffer').Buffer

      function check(buffer) {
        if (buffer.length < 8) return false
        if (buffer.length > 72) return false
        if (buffer[0] !== 0x30) return false
        if (buffer[1] !== buffer.length - 2) return false
        if (buffer[2] !== 0x02) return false

        var lenR = buffer[3]
        if (lenR === 0) return false
        if (5 + lenR >= buffer.length) return false
        if (buffer[4 + lenR] !== 0x02) return false

        var lenS = buffer[5 + lenR]
        if (lenS === 0) return false
        if ((6 + lenR + lenS) !== buffer.length) return false

        if (buffer[4] & 0x80) return false
        if (lenR > 1 && (buffer[4] === 0x00) && !(buffer[5] & 0x80)) return false

        if (buffer[lenR + 6] & 0x80) return false
        if (lenS > 1 && (buffer[lenR + 6] === 0x00) && !(buffer[lenR + 7] & 0x80)) return false
        return true
      }

      function decode(buffer) {
        if (buffer.length < 8) throw new Error('DER sequence length is too short')
        if (buffer.length > 72) throw new Error('DER sequence length is too long')
        if (buffer[0] !== 0x30) throw new Error('Expected DER sequence')
        if (buffer[1] !== buffer.length - 2) throw new Error('DER sequence length is invalid')
        if (buffer[2] !== 0x02) throw new Error('Expected DER integer')

        var lenR = buffer[3]
        if (lenR === 0) throw new Error('R length is zero')
        if (5 + lenR >= buffer.length) throw new Error('R length is too long')
        if (buffer[4 + lenR] !== 0x02) throw new Error('Expected DER integer (2)')

        var lenS = buffer[5 + lenR]
        if (lenS === 0) throw new Error('S length is zero')
        if ((6 + lenR + lenS) !== buffer.length) throw new Error('S length is invalid')

        if (buffer[4] & 0x80) throw new Error('R value is negative')
        if (lenR > 1 && (buffer[4] === 0x00) && !(buffer[5] & 0x80)) throw new Error('R value excessively padded')

        if (buffer[lenR + 6] & 0x80) throw new Error('S value is negative')
        if (lenS > 1 && (buffer[lenR + 6] === 0x00) && !(buffer[lenR + 7] & 0x80)) throw new Error('S value excessively padded')

        // non-BIP66 - extract R, S values
        return {
          r: buffer.slice(4, 4 + lenR),
          s: buffer.slice(6 + lenR)
        }
      }

      /*
       * Expects r and s to be positive DER integers.
       *
       * The DER format uses the most significant bit as a sign bit (& 0x80).
       * If the significant bit is set AND the integer is positive, a 0x00 is prepended.
       *
       * Examples:
       *
       *      0 =>     0x00
       *      1 =>     0x01
       *     -1 =>     0xff
       *    127 =>     0x7f
       *   -127 =>     0x81
       *    128 =>   0x0080
       *   -128 =>     0x80
       *    255 =>   0x00ff
       *   -255 =>   0xff01
       *  16300 =>   0x3fac
       * -16300 =>   0xc054
       *  62300 => 0x00f35c
       * -62300 => 0xff0ca4
      */
      function encode(r, s) {
        var lenR = r.length
        var lenS = s.length
        if (lenR === 0) throw new Error('R length is zero')
        if (lenS === 0) throw new Error('S length is zero')
        if (lenR > 33) throw new Error('R length is too long')
        if (lenS > 33) throw new Error('S length is too long')
        if (r[0] & 0x80) throw new Error('R value is negative')
        if (s[0] & 0x80) throw new Error('S value is negative')
        if (lenR > 1 && (r[0] === 0x00) && !(r[1] & 0x80)) throw new Error('R value excessively padded')
        if (lenS > 1 && (s[0] === 0x00) && !(s[1] & 0x80)) throw new Error('S value excessively padded')

        var signature = Buffer.allocUnsafe(6 + lenR + lenS)

        // 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
        signature[0] = 0x30
        signature[1] = signature.length - 2
        signature[2] = 0x02
        signature[3] = r.length
        r.copy(signature, 4)
        signature[4 + lenR] = 0x02
        signature[5 + lenR] = s.length
        s.copy(signature, 6 + lenR)

        return signature
      }

      module.exports = {
        check: check,
        decode: decode,
        encode: encode
      }

    }, { "safe-buffer": 133 }], 8: [function (require, module, exports) {
      module.exports = {
        "OP_FALSE": 0,
        "OP_0": 0,
        "OP_PUSHDATA1": 76,
        "OP_PUSHDATA2": 77,
        "OP_PUSHDATA4": 78,
        "OP_1NEGATE": 79,
        "OP_RESERVED": 80,
        "OP_TRUE": 81,
        "OP_1": 81,
        "OP_2": 82,
        "OP_3": 83,
        "OP_4": 84,
        "OP_5": 85,
        "OP_6": 86,
        "OP_7": 87,
        "OP_8": 88,
        "OP_9": 89,
        "OP_10": 90,
        "OP_11": 91,
        "OP_12": 92,
        "OP_13": 93,
        "OP_14": 94,
        "OP_15": 95,
        "OP_16": 96,

        "OP_NOP": 97,
        "OP_VER": 98,
        "OP_IF": 99,
        "OP_NOTIF": 100,
        "OP_VERIF": 101,
        "OP_VERNOTIF": 102,
        "OP_ELSE": 103,
        "OP_ENDIF": 104,
        "OP_VERIFY": 105,
        "OP_RETURN": 106,

        "OP_TOALTSTACK": 107,
        "OP_FROMALTSTACK": 108,
        "OP_2DROP": 109,
        "OP_2DUP": 110,
        "OP_3DUP": 111,
        "OP_2OVER": 112,
        "OP_2ROT": 113,
        "OP_2SWAP": 114,
        "OP_IFDUP": 115,
        "OP_DEPTH": 116,
        "OP_DROP": 117,
        "OP_DUP": 118,
        "OP_NIP": 119,
        "OP_OVER": 120,
        "OP_PICK": 121,
        "OP_ROLL": 122,
        "OP_ROT": 123,
        "OP_SWAP": 124,
        "OP_TUCK": 125,

        "OP_CAT": 126,
        "OP_SUBSTR": 127,
        "OP_LEFT": 128,
        "OP_RIGHT": 129,
        "OP_SIZE": 130,

        "OP_INVERT": 131,
        "OP_AND": 132,
        "OP_OR": 133,
        "OP_XOR": 134,
        "OP_EQUAL": 135,
        "OP_EQUALVERIFY": 136,
        "OP_RESERVED1": 137,
        "OP_RESERVED2": 138,

        "OP_1ADD": 139,
        "OP_1SUB": 140,
        "OP_2MUL": 141,
        "OP_2DIV": 142,
        "OP_NEGATE": 143,
        "OP_ABS": 144,
        "OP_NOT": 145,
        "OP_0NOTEQUAL": 146,
        "OP_ADD": 147,
        "OP_SUB": 148,
        "OP_MUL": 149,
        "OP_DIV": 150,
        "OP_MOD": 151,
        "OP_LSHIFT": 152,
        "OP_RSHIFT": 153,

        "OP_BOOLAND": 154,
        "OP_BOOLOR": 155,
        "OP_NUMEQUAL": 156,
        "OP_NUMEQUALVERIFY": 157,
        "OP_NUMNOTEQUAL": 158,
        "OP_LESSTHAN": 159,
        "OP_GREATERTHAN": 160,
        "OP_LESSTHANOREQUAL": 161,
        "OP_GREATERTHANOREQUAL": 162,
        "OP_MIN": 163,
        "OP_MAX": 164,

        "OP_WITHIN": 165,

        "OP_RIPEMD160": 166,
        "OP_SHA1": 167,
        "OP_SHA256": 168,
        "OP_HASH160": 169,
        "OP_HASH256": 170,
        "OP_CODESEPARATOR": 171,
        "OP_CHECKSIG": 172,
        "OP_CHECKSIGVERIFY": 173,
        "OP_CHECKMULTISIG": 174,
        "OP_CHECKMULTISIGVERIFY": 175,

        "OP_NOP1": 176,

        "OP_NOP2": 177,
        "OP_CHECKLOCKTIMEVERIFY": 177,

        "OP_NOP3": 178,
        "OP_CHECKSEQUENCEVERIFY": 178,

        "OP_NOP4": 179,
        "OP_NOP5": 180,
        "OP_NOP6": 181,
        "OP_NOP7": 182,
        "OP_NOP8": 183,
        "OP_NOP9": 184,
        "OP_NOP10": 185,

        "OP_PUBKEYHASH": 253,
        "OP_PUBKEY": 254,
        "OP_INVALIDOPCODE": 255
      }

    }, {}], 9: [function (require, module, exports) {
      var OPS = require('./index.json')

      var map = {}
      for (var op in OPS) {
        var code = OPS[op]
        map[code] = op
      }

      module.exports = map

    }, { "./index.json": 8 }], 10: [function (require, module, exports) {
      (function (process) {
        (function () {
          /**
           * This is the web browser implementation of `debug()`.
           *
           * Expose `debug()` as the module.
           */

          exports = module.exports = require('./debug');
          exports.log = log;
          exports.formatArgs = formatArgs;
          exports.save = save;
          exports.load = load;
          exports.useColors = useColors;
          exports.storage = 'undefined' != typeof chrome
            && 'undefined' != typeof chrome.storage
            ? chrome.storage.local
            : localstorage();

          /**
           * Colors.
           */

          exports.colors = [
            '#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC',
            '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF',
            '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC',
            '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF',
            '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC',
            '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033',
            '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366',
            '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933',
            '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC',
            '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF',
            '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'
          ];

          /**
           * Currently only WebKit-based Web Inspectors, Firefox >= v31,
           * and the Firebug extension (any Firefox version) are known
           * to support "%c" CSS customizations.
           *
           * TODO: add a `localStorage` variable to explicitly enable/disable colors
           */

          function useColors() {
            // NB: In an Electron preload script, document will be defined but not fully
            // initialized. Since we know we're in Chrome, we'll just detect this case
            // explicitly
            if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
              return true;
            }

            // Internet Explorer and Edge do not support colors.
            if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
              return false;
            }

            // is webkit? http://stackoverflow.com/a/16459606/376773
            // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
            return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
              // is firebug? http://stackoverflow.com/a/398120/376773
              (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
              // is firefox >= v31?
              // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
              (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
              // double check webkit in userAgent just in case we are in a worker
              (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
          }

          /**
           * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
           */

          exports.formatters.j = function (v) {
            try {
              return JSON.stringify(v);
            } catch (err) {
              return '[UnexpectedJSONParseError]: ' + err.message;
            }
          };


          /**
           * Colorize log arguments if enabled.
           *
           * @api public
           */

          function formatArgs(args) {
            var useColors = this.useColors;

            args[0] = (useColors ? '%c' : '')
              + this.namespace
              + (useColors ? ' %c' : ' ')
              + args[0]
              + (useColors ? '%c ' : ' ')
              + '+' + exports.humanize(this.diff);

            if (!useColors) return;

            var c = 'color: ' + this.color;
            args.splice(1, 0, c, 'color: inherit')

            // the final "%c" is somewhat tricky, because there could be other
            // arguments passed either before or after the %c, so we need to
            // figure out the correct index to insert the CSS into
            var index = 0;
            var lastC = 0;
            args[0].replace(/%[a-zA-Z%]/g, function (match) {
              if ('%%' === match) return;
              index++;
              if ('%c' === match) {
                // we only are interested in the *last* %c
                // (the user may have provided their own)
                lastC = index;
              }
            });

            args.splice(lastC, 0, c);
          }

          /**
           * Invokes `console.log()` when available.
           * No-op when `console.log` is not a "function".
           *
           * @api public
           */

          function log() {
            // this hackery is required for IE8/9, where
            // the `console.log` function doesn't have 'apply'
            return 'object' === typeof console
              && console.log
              && Function.prototype.apply.call(console.log, console, arguments);
          }

          /**
           * Save `namespaces`.
           *
           * @param {String} namespaces
           * @api private
           */

          function save(namespaces) {
            try {
              if (null == namespaces) {
                exports.storage.removeItem('debug');
              } else {
                exports.storage.debug = namespaces;
              }
            } catch (e) { }
          }

          /**
           * Load `namespaces`.
           *
           * @return {String} returns the previously persisted debug modes
           * @api private
           */

          function load() {
            var r;
            try {
              r = exports.storage.debug;
            } catch (e) { }

            // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
            if (!r && typeof process !== 'undefined' && 'env' in process) {
              r = process.env.DEBUG;
            }

            return r;
          }

          /**
           * Enable namespaces listed in `localStorage.debug` initially.
           */

          exports.enable(load());

          /**
           * Localstorage attempts to return the localstorage.
           *
           * This is necessary because safari throws
           * when a user disables cookies/localstorage
           * and you attempt to access it.
           *
           * @return {LocalStorage}
           * @api private
           */

          function localstorage() {
            try {
              return window.localStorage;
            } catch (e) { }
          }

        }).call(this)
      }).call(this, require('_process'))
    }, { "./debug": 11, "_process": 304 }], 11: [function (require, module, exports) {

      /**
       * This is the common logic for both the Node.js and web browser
       * implementations of `debug()`.
       *
       * Expose `debug()` as the module.
       */

      exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
      exports.coerce = coerce;
      exports.disable = disable;
      exports.enable = enable;
      exports.enabled = enabled;
      exports.humanize = require('ms');

      /**
       * Active `debug` instances.
       */
      exports.instances = [];

      /**
       * The currently active debug mode names, and names to skip.
       */

      exports.names = [];
      exports.skips = [];

      /**
       * Map of special "%n" handling functions, for the debug "format" argument.
       *
       * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
       */

      exports.formatters = {};

      /**
       * Select a color.
       * @param {String} namespace
       * @return {Number}
       * @api private
       */

      function selectColor(namespace) {
        var hash = 0, i;

        for (i in namespace) {
          hash = ((hash << 5) - hash) + namespace.charCodeAt(i);
          hash |= 0; // Convert to 32bit integer
        }

        return exports.colors[Math.abs(hash) % exports.colors.length];
      }

      /**
       * Create a debugger with the given `namespace`.
       *
       * @param {String} namespace
       * @return {Function}
       * @api public
       */

      function createDebug(namespace) {

        var prevTime;

        function debug() {
          // disabled?
          if (!debug.enabled) return;

          var self = debug;

          // set `diff` timestamp
          var curr = +new Date();
          var ms = curr - (prevTime || curr);
          self.diff = ms;
          self.prev = prevTime;
          self.curr = curr;
          prevTime = curr;

          // turn the `arguments` into a proper Array
          var args = new Array(arguments.length);
          for (var i = 0; i < args.length; i++) {
            args[i] = arguments[i];
          }

          args[0] = exports.coerce(args[0]);

          if ('string' !== typeof args[0]) {
            // anything else let's inspect with %O
            args.unshift('%O');
          }

          // apply any `formatters` transformations
          var index = 0;
          args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
            // if we encounter an escaped % then don't increase the array index
            if (match === '%%') return match;
            index++;
            var formatter = exports.formatters[format];
            if ('function' === typeof formatter) {
              var val = args[index];
              match = formatter.call(self, val);

              // now we need to remove `args[index]` since it's inlined in the `format`
              args.splice(index, 1);
              index--;
            }
            return match;
          });

          // apply env-specific formatting (colors, etc.)
          exports.formatArgs.call(self, args);

          var logFn = debug.log || exports.log || console.log.bind(console);
          logFn.apply(self, args);
        }

        debug.namespace = namespace;
        debug.enabled = exports.enabled(namespace);
        debug.useColors = exports.useColors();
        debug.color = selectColor(namespace);
        debug.destroy = destroy;

        // env-specific initialization logic for debug instances
        if ('function' === typeof exports.init) {
          exports.init(debug);
        }

        exports.instances.push(debug);

        return debug;
      }

      function destroy() {
        var index = exports.instances.indexOf(this);
        if (index !== -1) {
          exports.instances.splice(index, 1);
          return true;
        } else {
          return false;
        }
      }

      /**
       * Enables a debug mode by namespaces. This can include modes
       * separated by a colon and wildcards.
       *
       * @param {String} namespaces
       * @api public
       */

      function enable(namespaces) {
        exports.save(namespaces);

        exports.names = [];
        exports.skips = [];

        var i;
        var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
        var len = split.length;

        for (i = 0; i < len; i++) {
          if (!split[i]) continue; // ignore empty strings
          namespaces = split[i].replace(/\*/g, '.*?');
          if (namespaces[0] === '-') {
            exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
          } else {
            exports.names.push(new RegExp('^' + namespaces + '$'));
          }
        }

        for (i = 0; i < exports.instances.length; i++) {
          var instance = exports.instances[i];
          instance.enabled = exports.enabled(instance.namespace);
        }
      }

      /**
       * Disable debug output.
       *
       * @api public
       */

      function disable() {
        exports.enable('');
      }

      /**
       * Returns true if the given mode name is enabled, false otherwise.
       *
       * @param {String} name
       * @return {Boolean}
       * @api public
       */

      function enabled(name) {
        if (name[name.length - 1] === '*') {
          return true;
        }
        var i, len;
        for (i = 0, len = exports.skips.length; i < len; i++) {
          if (exports.skips[i].test(name)) {
            return false;
          }
        }
        for (i = 0, len = exports.names.length; i < len; i++) {
          if (exports.names[i].test(name)) {
            return true;
          }
        }
        return false;
      }

      /**
       * Coerce `val`.
       *
       * @param {Mixed} val
       * @return {Mixed}
       * @api private
       */

      function coerce(val) {
        if (val instanceof Error) return val.stack || val.message;
        return val;
      }

    }, { "ms": 12 }], 12: [function (require, module, exports) {
      /**
       * Helpers.
       */

      var s = 1000;
      var m = s * 60;
      var h = m * 60;
      var d = h * 24;
      var y = d * 365.25;

      /**
       * Parse or format the given `val`.
       *
       * Options:
       *
       *  - `long` verbose formatting [false]
       *
       * @param {String|Number} val
       * @param {Object} [options]
       * @throws {Error} throw an error if val is not a non-empty string or a number
       * @return {String|Number}
       * @api public
       */

      module.exports = function (val, options) {
        options = options || {};
        var type = typeof val;
        if (type === 'string' && val.length > 0) {
          return parse(val);
        } else if (type === 'number' && isNaN(val) === false) {
          return options.long ? fmtLong(val) : fmtShort(val);
        }
        throw new Error(
          'val is not a non-empty string or a valid number. val=' +
          JSON.stringify(val)
        );
      };

      /**
       * Parse the given `str` and return milliseconds.
       *
       * @param {String} str
       * @return {Number}
       * @api private
       */

      function parse(str) {
        str = String(str);
        if (str.length > 100) {
          return;
        }
        var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
          str
        );
        if (!match) {
          return;
        }
        var n = parseFloat(match[1]);
        var type = (match[2] || 'ms').toLowerCase();
        switch (type) {
          case 'years':
          case 'year':
          case 'yrs':
          case 'yr':
          case 'y':
            return n * y;
          case 'days':
          case 'day':
          case 'd':
            return n * d;
          case 'hours':
          case 'hour':
          case 'hrs':
          case 'hr':
          case 'h':
            return n * h;
          case 'minutes':
          case 'minute':
          case 'mins':
          case 'min':
          case 'm':
            return n * m;
          case 'seconds':
          case 'second':
          case 'secs':
          case 'sec':
          case 's':
            return n * s;
          case 'milliseconds':
          case 'millisecond':
          case 'msecs':
          case 'msec':
          case 'ms':
            return n;
          default:
            return undefined;
        }
      }

      /**
       * Short format for `ms`.
       *
       * @param {Number} ms
       * @return {String}
       * @api private
       */

      function fmtShort(ms) {
        if (ms >= d) {
          return Math.round(ms / d) + 'd';
        }
        if (ms >= h) {
          return Math.round(ms / h) + 'h';
        }
        if (ms >= m) {
          return Math.round(ms / m) + 'm';
        }
        if (ms >= s) {
          return Math.round(ms / s) + 's';
        }
        return ms + 'ms';
      }

      /**
       * Long format for `ms`.
       *
       * @param {Number} ms
       * @return {String}
       * @api private
       */

      function fmtLong(ms) {
        return plural(ms, d, 'day') ||
          plural(ms, h, 'hour') ||
          plural(ms, m, 'minute') ||
          plural(ms, s, 'second') ||
          ms + ' ms';
      }

      /**
       * Pluralization helper.
       */

      function plural(ms, n, name) {
        if (ms < n) {
          return;
        }
        if (ms < n * 1.5) {
          return Math.floor(ms / n) + ' ' + name;
        }
        return Math.ceil(ms / n) + ' ' + name + 's';
      }

    }, {}], 13: [function (require, module, exports) {
      'use strict'
      module.exports = require('./lib')(require('./lib/elliptic'))

    }, { "./lib": 17, "./lib/elliptic": 16 }], 14: [function (require, module, exports) {
      (function (Buffer) {
        (function () {
          'use strict'
          var toString = Object.prototype.toString

          // TypeError
          exports.isArray = function (value, message) {
            if (!Array.isArray(value)) throw TypeError(message)
          }

          exports.isBoolean = function (value, message) {
            if (toString.call(value) !== '[object Boolean]') throw TypeError(message)
          }

          exports.isBuffer = function (value, message) {
            if (!Buffer.isBuffer(value)) throw TypeError(message)
          }

          exports.isFunction = function (value, message) {
            if (toString.call(value) !== '[object Function]') throw TypeError(message)
          }

          exports.isNumber = function (value, message) {
            if (toString.call(value) !== '[object Number]') throw TypeError(message)
          }

          exports.isObject = function (value, message) {
            if (toString.call(value) !== '[object Object]') throw TypeError(message)
          }

          // RangeError
          exports.isBufferLength = function (buffer, length, message) {
            if (buffer.length !== length) throw RangeError(message)
          }

          exports.isBufferLength2 = function (buffer, length1, length2, message) {
            if (buffer.length !== length1 && buffer.length !== length2) throw RangeError(message)
          }

          exports.isLengthGTZero = function (value, message) {
            if (value.length === 0) throw RangeError(message)
          }

          exports.isNumberInInterval = function (number, x, y, message) {
            if (number <= x || number >= y) throw RangeError(message)
          }

        }).call(this)
      }).call(this, { "isBuffer": require("../../../../../../../../../usr/lib/node_modules/browserify/node_modules/is-buffer/index.js") })
    }, { "../../../../../../../../../usr/lib/node_modules/browserify/node_modules/is-buffer/index.js": 286 }], 15: [function (require, module, exports) {
      'use strict'
      var Buffer = require('safe-buffer').Buffer
      var bip66 = require('bip66')

      var EC_PRIVKEY_EXPORT_DER_COMPRESSED = Buffer.from([
        // begin
        0x30, 0x81, 0xd3, 0x02, 0x01, 0x01, 0x04, 0x20,
        // private key
        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
        // middle
        0xa0, 0x81, 0x85, 0x30, 0x81, 0x82, 0x02, 0x01, 0x01, 0x30, 0x2c, 0x06, 0x07, 0x2a, 0x86, 0x48,
        0xcE, 0x3d, 0x01, 0x01, 0x02, 0x21, 0x00, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,
        0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,
        0xff, 0xff, 0xfE, 0xff, 0xff, 0xfc, 0x2f, 0x30, 0x06, 0x04, 0x01, 0x00, 0x04, 0x01, 0x07, 0x04,
        0x21, 0x02, 0x79, 0xbE, 0x66, 0x7E, 0xf9, 0xdc, 0xbb, 0xac, 0x55, 0xa0, 0x62, 0x95, 0xcE, 0x87,
        0x0b, 0x07, 0x02, 0x9b, 0xfc, 0xdb, 0x2d, 0xcE, 0x28, 0xd9, 0x59, 0xf2, 0x81, 0x5b, 0x16, 0xf8,
        0x17, 0x98, 0x02, 0x21, 0x00, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,
        0xff, 0xff, 0xff, 0xff, 0xfE, 0xba, 0xaE, 0xdc, 0xE6, 0xaf, 0x48, 0xa0, 0x3b, 0xbf, 0xd2, 0x5E,
        0x8c, 0xd0, 0x36, 0x41, 0x41, 0x02, 0x01, 0x01, 0xa1, 0x24, 0x03, 0x22, 0x00,
        // public key
        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
        0x00
      ])

      var EC_PRIVKEY_EXPORT_DER_UNCOMPRESSED = Buffer.from([
        // begin
        0x30, 0x82, 0x01, 0x13, 0x02, 0x01, 0x01, 0x04, 0x20,
        // private key
        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
        // middle
        0xa0, 0x81, 0xa5, 0x30, 0x81, 0xa2, 0x02, 0x01, 0x01, 0x30, 0x2c, 0x06, 0x07, 0x2a, 0x86, 0x48,
        0xcE, 0x3d, 0x01, 0x01, 0x02, 0x21, 0x00, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,
        0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,
        0xff, 0xff, 0xfE, 0xff, 0xff, 0xfc, 0x2f, 0x30, 0x06, 0x04, 0x01, 0x00, 0x04, 0x01, 0x07, 0x04,
        0x41, 0x04, 0x79, 0xbE, 0x66, 0x7E, 0xf9, 0xdc, 0xbb, 0xac, 0x55, 0xa0, 0x62, 0x95, 0xcE, 0x87,
        0x0b, 0x07, 0x02, 0x9b, 0xfc, 0xdb, 0x2d, 0xcE, 0x28, 0xd9, 0x59, 0xf2, 0x81, 0x5b, 0x16, 0xf8,
        0x17, 0x98, 0x48, 0x3a, 0xda, 0x77, 0x26, 0xa3, 0xc4, 0x65, 0x5d, 0xa4, 0xfb, 0xfc, 0x0E, 0x11,
        0x08, 0xa8, 0xfd, 0x17, 0xb4, 0x48, 0xa6, 0x85, 0x54, 0x19, 0x9c, 0x47, 0xd0, 0x8f, 0xfb, 0x10,
        0xd4, 0xb8, 0x02, 0x21, 0x00, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff,
        0xff, 0xff, 0xff, 0xff, 0xfE, 0xba, 0xaE, 0xdc, 0xE6, 0xaf, 0x48, 0xa0, 0x3b, 0xbf, 0xd2, 0x5E,
        0x8c, 0xd0, 0x36, 0x41, 0x41, 0x02, 0x01, 0x01, 0xa1, 0x44, 0x03, 0x42, 0x00,
        // public key
        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
        0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00,
        0x00
      ])

      exports.privateKeyExport = function (privateKey, publicKey, compressed) {
        var result = Buffer.from(compressed ? EC_PRIVKEY_EXPORT_DER_COMPRESSED : EC_PRIVKEY_EXPORT_DER_UNCOMPRESSED)
        privateKey.copy(result, compressed ? 8 : 9)
        publicKey.copy(result, compressed ? 181 : 214)
        return result
      }

      exports.privateKeyImport = function (privateKey) {
        var length = privateKey.length

        // sequence header
        var index = 0
        if (length < index + 1 || privateKey[index] !== 0x30) return
        index += 1

        // sequence length constructor
        if (length < index + 1 || !(privateKey[index] & 0x80)) return

        var lenb = privateKey[index] & 0x7f
        index += 1
        if (lenb < 1 || lenb > 2) return
        if (length < index + lenb) return

        // sequence length
        var len = privateKey[index + lenb - 1] | (lenb > 1 ? privateKey[index + lenb - 2] << 8 : 0)
        index += lenb
        if (length < index + len) return

        // sequence element 0: version number (=1)
        if (length < index + 3 ||
          privateKey[index] !== 0x02 ||
          privateKey[index + 1] !== 0x01 ||
          privateKey[index + 2] !== 0x01) {
          return
        }
        index += 3

        // sequence element 1: octet string, up to 32 bytes
        if (length < index + 2 ||
          privateKey[index] !== 0x04 ||
          privateKey[index + 1] > 0x20 ||
          length < index + 2 + privateKey[index + 1]) {
          return
        }

        return privateKey.slice(index + 2, index + 2 + privateKey[index + 1])
      }

      exports.signatureExport = function (sigObj) {
        var r = Buffer.concat([Buffer.from([0]), sigObj.r])
        for (var lenR = 33, posR = 0; lenR > 1 && r[posR] === 0x00 && !(r[posR + 1] & 0x80); --lenR, ++posR);

        var s = Buffer.concat([Buffer.from([0]), sigObj.s])
        for (var lenS = 33, posS = 0; lenS > 1 && s[posS] === 0x00 && !(s[posS + 1] & 0x80); --lenS, ++posS);

        return bip66.encode(r.slice(posR), s.slice(posS))
      }

      exports.signatureImport = function (sig) {
        var r = Buffer.alloc(32, 0)
        var s = Buffer.alloc(32, 0)

        try {
          var sigObj = bip66.decode(sig)
          if (sigObj.r.length === 33 && sigObj.r[0] === 0x00) sigObj.r = sigObj.r.slice(1)
          if (sigObj.r.length > 32) throw new Error('R length is too long')
          if (sigObj.s.length === 33 && sigObj.s[0] === 0x00) sigObj.s = sigObj.s.slice(1)
          if (sigObj.s.length > 32) throw new Error('S length is too long')
        } catch (err) {
          return
        }

        sigObj.r.copy(r, 32 - sigObj.r.length)
        sigObj.s.copy(s, 32 - sigObj.s.length)

        return { r: r, s: s }
      }

      exports.signatureImportLax = function (sig) {
        var r = Buffer.alloc(32, 0)
        var s = Buffer.alloc(32, 0)

        var length = sig.length
        var index = 0

        // sequence tag byte
        if (sig[index++] !== 0x30) return

        // sequence length byte
        var lenbyte = sig[index++]
        if (lenbyte & 0x80) {
          index += lenbyte - 0x80
          if (index > length) return
        }

        // sequence tag byte for r
        if (sig[index++] !== 0x02) return

        // length for r
        var rlen = sig[index++]
        if (rlen & 0x80) {
          lenbyte = rlen - 0x80
          if (index + lenbyte > length) return
          for (; lenbyte > 0 && sig[index] === 0x00; index += 1, lenbyte -= 1);
          for (rlen = 0; lenbyte > 0; index += 1, lenbyte -= 1) rlen = (rlen << 8) + sig[index]
        }
        if (rlen > length - index) return
        var rindex = index
        index += rlen

        // sequence tag byte for s
        if (sig[index++] !== 0x02) return

        // length for s
        var slen = sig[index++]
        if (slen & 0x80) {
          lenbyte = slen - 0x80
          if (index + lenbyte > length) return
          for (; lenbyte > 0 && sig[index] === 0x00; index += 1, lenbyte -= 1);
          for (slen = 0; lenbyte > 0; index += 1, lenbyte -= 1) slen = (slen << 8) + sig[index]
        }
        if (slen > length - index) return
        var sindex = index
        index += slen

        // ignore leading zeros in r
        for (; rlen > 0 && sig[rindex] === 0x00; rlen -= 1, rindex += 1);
        // copy r value
        if (rlen > 32) return
        var rvalue = sig.slice(rindex, rindex + rlen)
        rvalue.copy(r, 32 - rvalue.length)

        // ignore leading zeros in s
        for (; slen > 0 && sig[sindex] === 0x00; slen -= 1, sindex += 1);
        // copy s value
        if (slen > 32) return
        var svalue = sig.slice(sindex, sindex + slen)
        svalue.copy(s, 32 - svalue.length)

        return { r: r, s: s }
      }

    }, { "bip66": 7, "safe-buffer": 133 }], 16: [function (require, module, exports) {
      'use strict'
      var Buffer = require('safe-buffer').Buffer
      var createHash = require('create-hash')
      var BN = require('bn.js')
      var EC = require('elliptic').ec

      var messages = require('../messages.json')

      var ec = new EC('secp256k1')
      var ecparams = ec.curve

      function loadCompressedPublicKey(first, xBuffer) {
        var x = new BN(xBuffer)

        // overflow
        if (x.cmp(ecparams.p) >= 0) return null
        x = x.toRed(ecparams.red)

        // compute corresponding Y
        var y = x.redSqr().redIMul(x).redIAdd(ecparams.b).redSqrt()
        if ((first === 0x03) !== y.isOdd()) y = y.redNeg()

        return ec.keyPair({ pub: { x: x, y: y } })
      }

      function loadUncompressedPublicKey(first, xBuffer, yBuffer) {
        var x = new BN(xBuffer)
        var y = new BN(yBuffer)

        // overflow
        if (x.cmp(ecparams.p) >= 0 || y.cmp(ecparams.p) >= 0) return null

        x = x.toRed(ecparams.red)
        y = y.toRed(ecparams.red)

        // is odd flag
        if ((first === 0x06 || first === 0x07) && y.isOdd() !== (first === 0x07)) return null

        // x*x*x + b = y*y
        var x3 = x.redSqr().redIMul(x)
        if (!y.redSqr().redISub(x3.redIAdd(ecparams.b)).isZero()) return null

        return ec.keyPair({ pub: { x: x, y: y } })
      }

      function loadPublicKey(publicKey) {
        var first = publicKey[0]
        switch (first) {
          case 0x02:
          case 0x03:
            if (publicKey.length !== 33) return null
            return loadCompressedPublicKey(first, publicKey.slice(1, 33))
          case 0x04:
          case 0x06:
          case 0x07:
            if (publicKey.length !== 65) return null
            return loadUncompressedPublicKey(first, publicKey.slice(1, 33), publicKey.slice(33, 65))
          default:
            return null
        }
      }

      exports.privateKeyVerify = function (privateKey) {
        var bn = new BN(privateKey)
        return bn.cmp(ecparams.n) < 0 && !bn.isZero()
      }

      exports.privateKeyExport = function (privateKey, compressed) {
        var d = new BN(privateKey)
        if (d.cmp(ecparams.n) >= 0 || d.isZero()) throw new Error(messages.EC_PRIVATE_KEY_EXPORT_DER_FAIL)

        return Buffer.from(ec.keyFromPrivate(privateKey).getPublic(compressed, true))
      }

      exports.privateKeyNegate = function (privateKey) {
        var bn = new BN(privateKey)
        return bn.isZero() ? Buffer.alloc(32) : ecparams.n.sub(bn).umod(ecparams.n).toArrayLike(Buffer, 'be', 32)
      }

      exports.privateKeyModInverse = function (privateKey) {
        var bn = new BN(privateKey)
        if (bn.cmp(ecparams.n) >= 0 || bn.isZero()) throw new Error(messages.EC_PRIVATE_KEY_RANGE_INVALID)

        return bn.invm(ecparams.n).toArrayLike(Buffer, 'be', 32)
      }

      exports.privateKeyTweakAdd = function (privateKey, tweak) {
        var bn = new BN(tweak)
        if (bn.cmp(ecparams.n) >= 0) throw new Error(messages.EC_PRIVATE_KEY_TWEAK_ADD_FAIL)

        bn.iadd(new BN(privateKey))
        if (bn.cmp(ecparams.n) >= 0) bn.isub(ecparams.n)
        if (bn.isZero()) throw new Error(messages.EC_PRIVATE_KEY_TWEAK_ADD_FAIL)

        return bn.toArrayLike(Buffer, 'be', 32)
      }

      exports.privateKeyTweakMul = function (privateKey, tweak) {
        var bn = new BN(tweak)
        if (bn.cmp(ecparams.n) >= 0 || bn.isZero()) throw new Error(messages.EC_PRIVATE_KEY_TWEAK_MUL_FAIL)

        bn.imul(new BN(privateKey))
        if (bn.cmp(ecparams.n)) bn = bn.umod(ecparams.n)

        return bn.toArrayLike(Buffer, 'be', 32)
      }

      exports.publicKeyCreate = function (privateKey, compressed) {
        var d = new BN(privateKey)
        if (d.cmp(ecparams.n) >= 0 || d.isZero()) throw new Error(messages.EC_PUBLIC_KEY_CREATE_FAIL)

        return Buffer.from(ec.keyFromPrivate(privateKey).getPublic(compressed, true))
      }

      exports.publicKeyConvert = function (publicKey, compressed) {
        var pair = loadPublicKey(publicKey)
        if (pair === null) throw new Error(messages.EC_PUBLIC_KEY_PARSE_FAIL)

        return Buffer.from(pair.getPublic(compressed, true))
      }

      exports.publicKeyVerify = function (publicKey) {
        return loadPublicKey(publicKey) !== null
      }

      exports.publicKeyTweakAdd = function (publicKey, tweak, compressed) {
        var pair = loadPublicKey(publicKey)
        if (pair === null) throw new Error(messages.EC_PUBLIC_KEY_PARSE_FAIL)

        tweak = new BN(tweak)
        if (tweak.cmp(ecparams.n) >= 0) throw new Error(messages.EC_PUBLIC_KEY_TWEAK_ADD_FAIL)

        var point = ecparams.g.mul(tweak).add(pair.pub)
        if (point.isInfinity()) throw new Error(messages.EC_PUBLIC_KEY_TWEAK_ADD_FAIL)

        return Buffer.from(point.encode(true, compressed))
      }

      exports.publicKeyTweakMul = function (publicKey, tweak, compressed) {
        var pair = loadPublicKey(publicKey)
        if (pair === null) throw new Error(messages.EC_PUBLIC_KEY_PARSE_FAIL)

        tweak = new BN(tweak)
        if (tweak.cmp(ecparams.n) >= 0 || tweak.isZero()) throw new Error(messages.EC_PUBLIC_KEY_TWEAK_MUL_FAIL)

        return Buffer.from(pair.pub.mul(tweak).encode(true, compressed))
      }

      exports.publicKeyCombine = function (publicKeys, compressed) {
        var pairs = new Array(publicKeys.length)
        for (var i = 0; i < publicKeys.length; ++i) {
          pairs[i] = loadPublicKey(publicKeys[i])
          if (pairs[i] === null) throw new Error(messages.EC_PUBLIC_KEY_PARSE_FAIL)
        }

        var point = pairs[0].pub
        for (var j = 1; j < pairs.length; ++j) point = point.add(pairs[j].pub)
        if (point.isInfinity()) throw new Error(messages.EC_PUBLIC_KEY_COMBINE_FAIL)

        return Buffer.from(point.encode(true, compressed))
      }

      exports.signatureNormalize = function (signature) {
        var r = new BN(signature.slice(0, 32))
        var s = new BN(signature.slice(32, 64))
        if (r.cmp(ecparams.n) >= 0 || s.cmp(ecparams.n) >= 0) throw new Error(messages.ECDSA_SIGNATURE_PARSE_FAIL)

        var result = Buffer.from(signature)
        if (s.cmp(ec.nh) === 1) ecparams.n.sub(s).toArrayLike(Buffer, 'be', 32).copy(result, 32)

        return result
      }

      exports.signatureExport = function (signature) {
        var r = signature.slice(0, 32)
        var s = signature.slice(32, 64)
        if (new BN(r).cmp(ecparams.n) >= 0 || new BN(s).cmp(ecparams.n) >= 0) throw new Error(messages.ECDSA_SIGNATURE_PARSE_FAIL)

        return { r: r, s: s }
      }

      exports.signatureImport = function (sigObj) {
        var r = new BN(sigObj.r)
        if (r.cmp(ecparams.n) >= 0) r = new BN(0)

        var s = new BN(sigObj.s)
        if (s.cmp(ecparams.n) >= 0) s = new BN(0)

        return Buffer.concat([
          r.toArrayLike(Buffer, 'be', 32),
          s.toArrayLike(Buffer, 'be', 32)
        ])
      }

      exports.sign = function (message, privateKey, noncefn, data) {
        if (typeof noncefn === 'function') {
          var getNonce = noncefn
          noncefn = function (counter) {
            var nonce = getNonce(message, privateKey, null, data, counter)
            if (!Buffer.isBuffer(nonce) || nonce.length !== 32) throw new Error(messages.ECDSA_SIGN_FAIL)

            return new BN(nonce)
          }
        }

        var d = new BN(privateKey)
        if (d.cmp(ecparams.n) >= 0 || d.isZero()) throw new Error(messages.ECDSA_SIGN_FAIL)

        var result = ec.sign(message, privateKey, { canonical: true, k: noncefn, pers: data })
        return {
          signature: Buffer.concat([
            result.r.toArrayLike(Buffer, 'be', 32),
            result.s.toArrayLike(Buffer, 'be', 32)
          ]),
          recovery: result.recoveryParam
        }
      }

      exports.verify = function (message, signature, publicKey) {
        var sigObj = { r: signature.slice(0, 32), s: signature.slice(32, 64) }

        var sigr = new BN(sigObj.r)
        var sigs = new BN(sigObj.s)
        if (sigr.cmp(ecparams.n) >= 0 || sigs.cmp(ecparams.n) >= 0) throw new Error(messages.ECDSA_SIGNATURE_PARSE_FAIL)
        if (sigs.cmp(ec.nh) === 1 || sigr.isZero() || sigs.isZero()) return false

        var pair = loadPublicKey(publicKey)
        if (pair === null) throw new Error(messages.EC_PUBLIC_KEY_PARSE_FAIL)

        return ec.verify(message, sigObj, { x: pair.pub.x, y: pair.pub.y })
      }

      exports.recover = function (message, signature, recovery, compressed) {
        var sigObj = { r: signature.slice(0, 32), s: signature.slice(32, 64) }

        var sigr = new BN(sigObj.r)
        var sigs = new BN(sigObj.s)
        if (sigr.cmp(ecparams.n) >= 0 || sigs.cmp(ecparams.n) >= 0) throw new Error(messages.ECDSA_SIGNATURE_PARSE_FAIL)

        try {
          if (sigr.isZero() || sigs.isZero()) throw new Error()

          var point = ec.recoverPubKey(message, sigObj, recovery)
          return Buffer.from(point.encode(true, compressed))
        } catch (err) {
          throw new Error(messages.ECDSA_RECOVER_FAIL)
        }
      }

      exports.ecdh = function (publicKey, privateKey) {
        var shared = exports.ecdhUnsafe(publicKey, privateKey, true)
        return createHash('sha256').update(shared).digest()
      }

      exports.ecdhUnsafe = function (publicKey, privateKey, compressed) {
        var pair = loadPublicKey(publicKey)
        if (pair === null) throw new Error(messages.EC_PUBLIC_KEY_PARSE_FAIL)

        var scalar = new BN(privateKey)
        if (scalar.cmp(ecparams.n) >= 0 || scalar.isZero()) throw new Error(messages.ECDH_FAIL)

        return Buffer.from(pair.pub.mul(scalar).encode(true, compressed))
      }

    }, { "../messages.json": 18, "bn.js": 64, "create-hash": 70, "elliptic": 79, "safe-buffer": 133 }], 17: [function (require, module, exports) {
      'use strict'
      var assert = require('./assert')
      var der = require('./der')
      var messages = require('./messages.json')

      function initCompressedValue(value, defaultValue) {
        if (value === undefined) return defaultValue

        assert.isBoolean(value, messages.COMPRESSED_TYPE_INVALID)
        return value
      }

      module.exports = function (secp256k1) {
        return {
          privateKeyVerify: function (privateKey) {
            assert.isBuffer(privateKey, messages.EC_PRIVATE_KEY_TYPE_INVALID)
            return privateKey.length === 32 && secp256k1.privateKeyVerify(privateKey)
          },

          privateKeyExport: function (privateKey, compressed) {
            assert.isBuffer(privateKey, messages.EC_PRIVATE_KEY_TYPE_INVALID)
            assert.isBufferLength(privateKey, 32, messages.EC_PRIVATE_KEY_LENGTH_INVALID)

            compressed = initCompressedValue(compressed, true)
            var publicKey = secp256k1.privateKeyExport(privateKey, compressed)

            return der.privateKeyExport(privateKey, publicKey, compressed)
          },

          privateKeyImport: function (privateKey) {
            assert.isBuffer(privateKey, messages.EC_PRIVATE_KEY_TYPE_INVALID)

            privateKey = der.privateKeyImport(privateKey)
            if (privateKey && privateKey.length === 32 && secp256k1.privateKeyVerify(privateKey)) return privateKey

            throw new Error(messages.EC_PRIVATE_KEY_IMPORT_DER_FAIL)
          },

          privateKeyNegate: function (privateKey) {
            assert.isBuffer(privateKey, messages.EC_PRIVATE_KEY_TYPE_INVALID)
            assert.isBufferLength(privateKey, 32, messages.EC_PRIVATE_KEY_LENGTH_INVALID)

            return secp256k1.privateKeyNegate(privateKey)
          },

          privateKeyModInverse: function (privateKey) {
            assert.isBuffer(privateKey, messages.EC_PRIVATE_KEY_TYPE_INVALID)
            assert.isBufferLength(privateKey, 32, messages.EC_PRIVATE_KEY_LENGTH_INVALID)

            return secp256k1.privateKeyModInverse(privateKey)
          },

          privateKeyTweakAdd: function (privateKey, tweak) {
            assert.isBuffer(privateKey, messages.EC_PRIVATE_KEY_TYPE_INVALID)
            assert.isBufferLength(privateKey, 32, messages.EC_PRIVATE_KEY_LENGTH_INVALID)

            assert.isBuffer(tweak, messages.TWEAK_TYPE_INVALID)
            assert.isBufferLength(tweak, 32, messages.TWEAK_LENGTH_INVALID)

            return secp256k1.privateKeyTweakAdd(privateKey, tweak)
          },

          privateKeyTweakMul: function (privateKey, tweak) {
            assert.isBuffer(privateKey, messages.EC_PRIVATE_KEY_TYPE_INVALID)
            assert.isBufferLength(privateKey, 32, messages.EC_PRIVATE_KEY_LENGTH_INVALID)

            assert.isBuffer(tweak, messages.TWEAK_TYPE_INVALID)
            assert.isBufferLength(tweak, 32, messages.TWEAK_LENGTH_INVALID)

            return secp256k1.privateKeyTweakMul(privateKey, tweak)
          },

          publicKeyCreate: function (privateKey, compressed) {
            assert.isBuffer(privateKey, messages.EC_PRIVATE_KEY_TYPE_INVALID)
            assert.isBufferLength(privateKey, 32, messages.EC_PRIVATE_KEY_LENGTH_INVALID)

            compressed = initCompressedValue(compressed, true)

            return secp256k1.publicKeyCreate(privateKey, compressed)
          },

          publicKeyConvert: function (publicKey, compressed) {
            assert.isBuffer(publicKey, messages.EC_PUBLIC_KEY_TYPE_INVALID)
            assert.isBufferLength2(publicKey, 33, 65, messages.EC_PUBLIC_KEY_LENGTH_INVALID)

            compressed = initCompressedValue(compressed, true)

            return secp256k1.publicKeyConvert(publicKey, compressed)
          },

          publicKeyVerify: function (publicKey) {
            assert.isBuffer(publicKey, messages.EC_PUBLIC_KEY_TYPE_INVALID)
            return secp256k1.publicKeyVerify(publicKey)
          },

          publicKeyTweakAdd: function (publicKey, tweak, compressed) {
            assert.isBuffer(publicKey, messages.EC_PUBLIC_KEY_TYPE_INVALID)
            assert.isBufferLength2(publicKey, 33, 65, messages.EC_PUBLIC_KEY_LENGTH_INVALID)

            assert.isBuffer(tweak, messages.TWEAK_TYPE_INVALID)
            assert.isBufferLength(tweak, 32, messages.TWEAK_LENGTH_INVALID)

            compressed = initCompressedValue(compressed, true)

            return secp256k1.publicKeyTweakAdd(publicKey, tweak, compressed)
          },

          publicKeyTweakMul: function (publicKey, tweak, compressed) {
            assert.isBuffer(publicKey, messages.EC_PUBLIC_KEY_TYPE_INVALID)
            assert.isBufferLength2(publicKey, 33, 65, messages.EC_PUBLIC_KEY_LENGTH_INVALID)

            assert.isBuffer(tweak, messages.TWEAK_TYPE_INVALID)
            assert.isBufferLength(tweak, 32, messages.TWEAK_LENGTH_INVALID)

            compressed = initCompressedValue(compressed, true)

            return secp256k1.publicKeyTweakMul(publicKey, tweak, compressed)
          },

          publicKeyCombine: function (publicKeys, compressed) {
            assert.isArray(publicKeys, messages.EC_PUBLIC_KEYS_TYPE_INVALID)
            assert.isLengthGTZero(publicKeys, messages.EC_PUBLIC_KEYS_LENGTH_INVALID)
            for (var i = 0; i < publicKeys.length; ++i) {
              assert.isBuffer(publicKeys[i], messages.EC_PUBLIC_KEY_TYPE_INVALID)
              assert.isBufferLength2(publicKeys[i], 33, 65, messages.EC_PUBLIC_KEY_LENGTH_INVALID)
            }

            compressed = initCompressedValue(compressed, true)

            return secp256k1.publicKeyCombine(publicKeys, compressed)
          },

          signatureNormalize: function (signature) {
            assert.isBuffer(signature, messages.ECDSA_SIGNATURE_TYPE_INVALID)
            assert.isBufferLength(signature, 64, messages.ECDSA_SIGNATURE_LENGTH_INVALID)

            return secp256k1.signatureNormalize(signature)
          },

          signatureExport: function (signature) {
            assert.isBuffer(signature, messages.ECDSA_SIGNATURE_TYPE_INVALID)
            assert.isBufferLength(signature, 64, messages.ECDSA_SIGNATURE_LENGTH_INVALID)

            var sigObj = secp256k1.signatureExport(signature)
            return der.signatureExport(sigObj)
          },

          signatureImport: function (sig) {
            assert.isBuffer(sig, messages.ECDSA_SIGNATURE_TYPE_INVALID)
            assert.isLengthGTZero(sig, messages.ECDSA_SIGNATURE_LENGTH_INVALID)

            var sigObj = der.signatureImport(sig)
            if (sigObj) return secp256k1.signatureImport(sigObj)

            throw new Error(messages.ECDSA_SIGNATURE_PARSE_DER_FAIL)
          },

          signatureImportLax: function (sig) {
            assert.isBuffer(sig, messages.ECDSA_SIGNATURE_TYPE_INVALID)
            assert.isLengthGTZero(sig, messages.ECDSA_SIGNATURE_LENGTH_INVALID)

            var sigObj = der.signatureImportLax(sig)
            if (sigObj) return secp256k1.signatureImport(sigObj)

            throw new Error(messages.ECDSA_SIGNATURE_PARSE_DER_FAIL)
          },

          sign: function (message, privateKey, options) {
            assert.isBuffer(message, messages.MSG32_TYPE_INVALID)
            assert.isBufferLength(message, 32, messages.MSG32_LENGTH_INVALID)

            assert.isBuffer(privateKey, messages.EC_PRIVATE_KEY_TYPE_INVALID)
            assert.isBufferLength(privateKey, 32, messages.EC_PRIVATE_KEY_LENGTH_INVALID)

            var data = null
            var noncefn = null
            if (options !== undefined) {
              assert.isObject(options, messages.OPTIONS_TYPE_INVALID)

              if (options.data !== undefined) {
                assert.isBuffer(options.data, messages.OPTIONS_DATA_TYPE_INVALID)
                assert.isBufferLength(options.data, 32, messages.OPTIONS_DATA_LENGTH_INVALID)
                data = options.data
              }

              if (options.noncefn !== undefined) {
                assert.isFunction(options.noncefn, messages.OPTIONS_NONCEFN_TYPE_INVALID)
                noncefn = options.noncefn
              }
            }

            return secp256k1.sign(message, privateKey, noncefn, data)
          },

          verify: function (message, signature, publicKey) {
            assert.isBuffer(message, messages.MSG32_TYPE_INVALID)
            assert.isBufferLength(message, 32, messages.MSG32_LENGTH_INVALID)

            assert.isBuffer(signature, messages.ECDSA_SIGNATURE_TYPE_INVALID)
            assert.isBufferLength(signature, 64, messages.ECDSA_SIGNATURE_LENGTH_INVALID)

            assert.isBuffer(publicKey, messages.EC_PUBLIC_KEY_TYPE_INVALID)
            assert.isBufferLength2(publicKey, 33, 65, messages.EC_PUBLIC_KEY_LENGTH_INVALID)

            return secp256k1.verify(message, signature, publicKey)
          },

          recover: function (message, signature, recovery, compressed) {
            assert.isBuffer(message, messages.MSG32_TYPE_INVALID)
            assert.isBufferLength(message, 32, messages.MSG32_LENGTH_INVALID)

            assert.isBuffer(signature, messages.ECDSA_SIGNATURE_TYPE_INVALID)
            assert.isBufferLength(signature, 64, messages.ECDSA_SIGNATURE_LENGTH_INVALID)

            assert.isNumber(recovery, messages.RECOVERY_ID_TYPE_INVALID)
            assert.isNumberInInterval(recovery, -1, 4, messages.RECOVERY_ID_VALUE_INVALID)

            compressed = initCompressedValue(compressed, true)

            return secp256k1.recover(message, signature, recovery, compressed)
          },

          ecdh: function (publicKey, privateKey) {
            assert.isBuffer(publicKey, messages.EC_PUBLIC_KEY_TYPE_INVALID)
            assert.isBufferLength2(publicKey, 33, 65, messages.EC_PUBLIC_KEY_LENGTH_INVALID)

            assert.isBuffer(privateKey, messages.EC_PRIVATE_KEY_TYPE_INVALID)
            assert.isBufferLength(privateKey, 32, messages.EC_PRIVATE_KEY_LENGTH_INVALID)

            return secp256k1.ecdh(publicKey, privateKey)
          },

          ecdhUnsafe: function (publicKey, privateKey, compressed) {
            assert.isBuffer(publicKey, messages.EC_PUBLIC_KEY_TYPE_INVALID)
            assert.isBufferLength2(publicKey, 33, 65, messages.EC_PUBLIC_KEY_LENGTH_INVALID)

            assert.isBuffer(privateKey, messages.EC_PRIVATE_KEY_TYPE_INVALID)
            assert.isBufferLength(privateKey, 32, messages.EC_PRIVATE_KEY_LENGTH_INVALID)

            compressed = initCompressedValue(compressed, true)

            return secp256k1.ecdhUnsafe(publicKey, privateKey, compressed)
          }
        }
      }

    }, { "./assert": 14, "./der": 15, "./messages.json": 18 }], 18: [function (require, module, exports) {
      module.exports = {
        "COMPRESSED_TYPE_INVALID": "compressed should be a boolean",
        "EC_PRIVATE_KEY_TYPE_INVALID": "private key should be a Buffer",
        "EC_PRIVATE_KEY_LENGTH_INVALID": "private key length is invalid",
        "EC_PRIVATE_KEY_RANGE_INVALID": "private key range is invalid",
        "EC_PRIVATE_KEY_TWEAK_ADD_FAIL": "tweak out of range or resulting private key is invalid",
        "EC_PRIVATE_KEY_TWEAK_MUL_FAIL": "tweak out of range",
        "EC_PRIVATE_KEY_EXPORT_DER_FAIL": "couldn't export to DER format",
        "EC_PRIVATE_KEY_IMPORT_DER_FAIL": "couldn't import from DER format",
        "EC_PUBLIC_KEYS_TYPE_INVALID": "public keys should be an Array",
        "EC_PUBLIC_KEYS_LENGTH_INVALID": "public keys Array should have at least 1 element",
        "EC_PUBLIC_KEY_TYPE_INVALID": "public key should be a Buffer",
        "EC_PUBLIC_KEY_LENGTH_INVALID": "public key length is invalid",
        "EC_PUBLIC_KEY_PARSE_FAIL": "the public key could not be parsed or is invalid",
        "EC_PUBLIC_KEY_CREATE_FAIL": "private was invalid, try again",
        "EC_PUBLIC_KEY_TWEAK_ADD_FAIL": "tweak out of range or resulting public key is invalid",
        "EC_PUBLIC_KEY_TWEAK_MUL_FAIL": "tweak out of range",
        "EC_PUBLIC_KEY_COMBINE_FAIL": "the sum of the public keys is not valid",
        "ECDH_FAIL": "scalar was invalid (zero or overflow)",
        "ECDSA_SIGNATURE_TYPE_INVALID": "signature should be a Buffer",
        "ECDSA_SIGNATURE_LENGTH_INVALID": "signature length is invalid",
        "ECDSA_SIGNATURE_PARSE_FAIL": "couldn't parse signature",
        "ECDSA_SIGNATURE_PARSE_DER_FAIL": "couldn't parse DER signature",
        "ECDSA_SIGNATURE_SERIALIZE_DER_FAIL": "couldn't serialize signature to DER format",
        "ECDSA_SIGN_FAIL": "nonce generation function failed or private key is invalid",
        "ECDSA_RECOVER_FAIL": "couldn't recover public key from signature",
        "MSG32_TYPE_INVALID": "message should be a Buffer",
        "MSG32_LENGTH_INVALID": "message length is invalid",
        "OPTIONS_TYPE_INVALID": "options should be an Object",
        "OPTIONS_DATA_TYPE_INVALID": "options.data should be a Buffer",
        "OPTIONS_DATA_LENGTH_INVALID": "options.data length is invalid",
        "OPTIONS_NONCEFN_TYPE_INVALID": "options.noncefn should be a Function",
        "RECOVERY_ID_TYPE_INVALID": "recovery should be a Number",
        "RECOVERY_ID_VALUE_INVALID": "recovery should have value between -1 and 4",
        "TWEAK_TYPE_INVALID": "tweak should be a Buffer",
        "TWEAK_LENGTH_INVALID": "tweak length is invalid"
      }

    }, {}], 19: [function (require, module, exports) {
      var Buffer = require('safe-buffer').Buffer
      var bech32 = require('bech32')
      var bs58check = require('bs58check')
      var bscript = require('./script')
      var btemplates = require('./templates')
      var networks = require('./networks')
      var typeforce = require('typeforce')
      var types = require('./types')

      function fromBase58Check(address) {
        var payload = bs58check.decode(address)

        // TODO: 4.0.0, move to "toOutputScript"
        if (payload.length < 21) throw new TypeError(address + ' is too short')
        if (payload.length > 22) throw new TypeError(address + ' is too long')

        var multibyte = payload.length === 22
        var offset = multibyte ? 2 : 1

        var version = multibyte ? payload.readUInt16BE(0) : payload[0]
        var hash = payload.slice(offset)

        return { version: version, hash: hash }
      }

      function fromBech32(address) {
        var result = bech32.decode(address)
        var data = bech32.fromWords(result.words.slice(1))

        return {
          version: result.words[0],
          prefix: result.prefix,
          data: Buffer.from(data)
        }
      }

      function toBase58Check(hash, version) {
        typeforce(types.tuple(types.Hash160bit, types.UInt16), arguments)

        // Zcash adds an extra prefix resulting in a bigger (22 bytes) payload. We identify them Zcash by checking if the
        // version is multibyte (2 bytes instead of 1)
        var multibyte = version > 0xff
        var size = multibyte ? 22 : 21
        var offset = multibyte ? 2 : 1

        var payload = Buffer.allocUnsafe(size)
        multibyte ? payload.writeUInt16BE(version, 0) : payload.writeUInt8(version, 0)
        hash.copy(payload, offset)

        return bs58check.encode(payload)
      }

      function toBech32(data, version, prefix) {
        var words = bech32.toWords(data)
        words.unshift(version)

        return bech32.encode(prefix, words)
      }

      function fromOutputScript(outputScript, network) {
        network = network || networks.bitcoin

        if (btemplates.pubKeyHash.output.check(outputScript)) return toBase58Check(bscript.compile(outputScript).slice(3, 23), network.pubKeyHash)
        if (btemplates.scriptHash.output.check(outputScript)) return toBase58Check(bscript.compile(outputScript).slice(2, 22), network.scriptHash)
        if (btemplates.witnessPubKeyHash.output.check(outputScript)) return toBech32(bscript.compile(outputScript).slice(2, 22), 0, network.bech32)
        if (btemplates.witnessScriptHash.output.check(outputScript)) return toBech32(bscript.compile(outputScript).slice(2, 34), 0, network.bech32)

        throw new Error(bscript.toASM(outputScript) + ' has no matching Address')
      }

      function toOutputScript(address, network) {
        network = network || networks.bitcoin

        var decode
        try {
          decode = fromBase58Check(address)
        } catch (e) { }

        if (decode) {
          if (decode.version === network.pubKeyHash) return btemplates.pubKeyHash.output.encode(decode.hash)
          if (decode.version === network.scriptHash) return btemplates.scriptHash.output.encode(decode.hash)
        } else {
          try {
            decode = fromBech32(address)
          } catch (e) { }

          if (decode) {
            if (decode.prefix !== network.bech32) throw new Error(address + ' has an invalid prefix')
            if (decode.version === 0) {
              if (decode.data.length === 20) return btemplates.witnessPubKeyHash.output.encode(decode.data)
              if (decode.data.length === 32) return btemplates.witnessScriptHash.output.encode(decode.data)
            }
          }
        }

        throw new Error(address + ' has no matching Script')
      }

      module.exports = {
        fromBase58Check: fromBase58Check,
        fromBech32: fromBech32,
        fromOutputScript: fromOutputScript,
        toBase58Check: toBase58Check,
        toBech32: toBech32,
        toOutputScript: toOutputScript
      }

    }, { "./networks": 33, "./script": 34, "./templates": 36, "./types": 60, "bech32": 2, "bs58check": 68, "safe-buffer": 133, "typeforce": 145 }], 20: [function (require, module, exports) {
      module.exports = {
        keyutil: require('./keyutil')
      }

    }, { "./keyutil": 21 }], 21: [function (require, module, exports) {
      (function (Buffer) {
        (function () {
          const BigInteger = require('bigi')
          const ECPair = require('../ecpair')

          /**
           * Create an ECPair from the raw private key bytes
           * @param {Buffer} buffer - Private key for the ECPair. Must be exactly 32 bytes.
           * @param {Object} [network] - Network for the ECPair. Defaults to bitcoin.
           * @return {ECPair}
           */
          function privateKeyBufferToECPair(buffer, network) {
            if (!Buffer.isBuffer(buffer) || buffer.length !== 32) {
              throw new Error('invalid private key buffer')
            }

            const d = BigInteger.fromBuffer(buffer)
            return new ECPair(d, null, { network })
          }

          /**
           * Get the private key as a 32 bytes buffer. If it is smaller than 32 bytes, pad it with zeros
           * @param {ECPair} ecPair
           * @return {Buffer} 32 bytes
           */
          function privateKeyBufferFromECPair(ecPair) {
            if (!(ecPair instanceof ECPair)) {
              throw new TypeError(`invalid argument ecpair`)
            }

            if (!ecPair.d) throw new Error('Missing private key')

            return ecPair.d.toBuffer(32)
          }

          module.exports = {
            privateKeyBufferToECPair,
            privateKeyBufferFromECPair
          }

        }).call(this)
      }).call(this, { "isBuffer": require("../../../../../../../../usr/lib/node_modules/browserify/node_modules/is-buffer/index.js") })
    }, { "../../../../../../../../usr/lib/node_modules/browserify/node_modules/is-buffer/index.js": 286, "../ecpair": 28, "bigi": 5 }], 22: [function (require, module, exports) {
      var Buffer = require('safe-buffer').Buffer
      var bcrypto = require('./crypto')
      var fastMerkleRoot = require('merkle-lib/fastRoot')
      var typeforce = require('typeforce')
      var types = require('./types')
      var varuint = require('varuint-bitcoin')
      var networks = require('./networks')
      var coins = require('./coins')

      var Transaction = require('./transaction')

      function Block(network) {
        typeforce(types.maybe(types.Network), network)
        network = network || networks.bitcoin
        this.version = 1
        this.prevHash = null
        this.merkleRoot = null
        this.timestamp = 0
        this.bits = 0
        this.nonce = 0
        this.network = network
        if (coins.isZcash(network)) {
          this.finalSaplingRoot = null
          this.solutionSize = 0
          this.solution = null
        }
      }

      Block.HEADER_BYTE_SIZE = 80
      Block.ZCASH_HEADER_BYTE_SIZE = 1487

      Block.fromBuffer = function (buffer, network) {
        if (buffer.length < 80) throw new Error('Buffer too small (< 80 bytes)')
        network = network || networks.bitcoin

        var offset = 0
        function readSlice(n) {
          offset += n
          return buffer.slice(offset - n, offset)
        }

        function readUInt32() {
          var i = buffer.readUInt32LE(offset)
          offset += 4
          return i
        }

        function readInt32() {
          var i = buffer.readInt32LE(offset)
          offset += 4
          return i
        }

        function readVarInt() {
          var vi = varuint.decode(buffer, offset)
          offset += varuint.decode.bytes
          return vi
        }

        var block = new Block(network)
        block.version = readInt32()
        block.prevHash = readSlice(32)
        block.merkleRoot = readSlice(32)
        if (coins.isZcash(network)) {
          block.finalSaplingRoot = readSlice(32)
        }
        block.timestamp = readUInt32()
        block.bits = readUInt32()
        if (coins.isZcash(network)) {
          block.nonce = readSlice(32)
          block.solutionSize = readVarInt()
          block.solution = readSlice(1344)
        } else {
          // Not sure sure why the nonce is read as UInt 32 and not as a slice
          block.nonce = readUInt32()
        }

        if (buffer.length === 80) return block

        function readTransaction() {
          var tx = Transaction.fromBuffer(buffer.slice(offset), network, true)
          offset += tx.byteLength()
          return tx
        }

        var nTransactions = readVarInt()
        block.transactions = []

        for (var i = 0; i < nTransactions; ++i) {
          var tx = readTransaction()
          block.transactions.push(tx)
        }

        return block
      }

      Block.prototype.byteLength = function (headersOnly) {
        if (coins.isZcash(this.network)) {
          if (headersOnly) {
            return Block.ZCASH_HEADER_BYTE_SIZE
          }
          return Block.ZCASH_HEADER_BYTE_SIZE +
            varuint.encodingLength(this.transactions.length) + this.transactions.reduce(function (a, x) {
              return a + x.byteLength()
            }, 0)
        }

        if (headersOnly || !this.transactions) return Block.HEADER_BYTE_SIZE

        return Block.HEADER_BYTE_SIZE +
          varuint.encodingLength(this.transactions.length) + this.transactions.reduce(function (a, x) {
            return a + x.byteLength()
          }, 0)
      }

      Block.fromHex = function (hex, network) {
        return Block.fromBuffer(Buffer.from(hex, 'hex'), network)
      }

      Block.prototype.getHash = function () {
        return bcrypto.hash256(this.toBuffer(true))
      }

      Block.prototype.getId = function () {
        return this.getHash().reverse().toString('hex')
      }

      Block.prototype.getUTCDate = function () {
        var date = new Date(0) // epoch
        date.setUTCSeconds(this.timestamp)

        return date
      }

      // TODO: buffer, offset compatibility
      Block.prototype.toBuffer = function (headersOnly) {
        var buffer = Buffer.allocUnsafe(this.byteLength(headersOnly))

        var offset = 0
        function writeSlice(slice) {
          slice.copy(buffer, offset)
          offset += slice.length
        }

        function writeInt32(i) {
          buffer.writeInt32LE(i, offset)
          offset += 4
        }
        function writeUInt32(i) {
          buffer.writeUInt32LE(i, offset)
          offset += 4
        }

        writeInt32(this.version)
        writeSlice(this.prevHash)
        writeSlice(this.merkleRoot)
        if (coins.isZcash(this.network)) {
          writeSlice(this.finalSaplingRoot)
        }
        writeUInt32(this.timestamp)
        writeUInt32(this.bits)
        if (coins.isZcash(this.network)) {
          writeSlice(this.nonce)
          varuint.encode(this.solutionSize, buffer, offset)
          offset += varuint.encode.bytes
          writeSlice(this.solution)
        } else {
          // Not sure sure why the nonce is interpreted as UInt 32 and not a slice in bitcoin
          writeUInt32(this.nonce)
        }

        if (headersOnly || !this.transactions) return buffer

        varuint.encode(this.transactions.length, buffer, offset)
        offset += varuint.encode.bytes

        this.transactions.forEach(function (tx) {
          var txSize = tx.byteLength() // TODO: extract from toBuffer?
          tx.toBuffer(buffer, offset)
          offset += txSize
        })

        return buffer
      }

      Block.prototype.toHex = function (headersOnly) {
        return this.toBuffer(headersOnly).toString('hex')
      }

      Block.calculateTarget = function (bits) {
        var exponent = ((bits & 0xff000000) >> 24) - 3
        var mantissa = bits & 0x007fffff
        var target = Buffer.alloc(32, 0)
        if (exponent < 0) {
          // If it is negative, we will overflow the target buffer so we have to slice the mantissa to fit
          mantissa = mantissa >> (8 * Math.abs(exponent))
          target.writeUInt32BE(mantissa, 28)
        } else if (exponent > 28) {
          // If it is greater than 28, we need to shift the mantissa since the offset cannot be greater than 32 - 4
          // (safe-buffer restriction)
          mantissa <<= 8 * (exponent - 28)
          target.writeUInt32BE(mantissa, 0)
        } else {
          target.writeUInt32BE(mantissa, 28 - exponent)
        }
        return target
      }

      Block.calculateMerkleRoot = function (transactions) {
        typeforce([{ getHash: types.Function }], transactions)
        if (transactions.length === 0) throw TypeError('Cannot compute merkle root for zero transactions')

        var hashes = transactions.map(function (transaction) {
          return transaction.getHash()
        })

        return fastMerkleRoot(hashes, bcrypto.hash256)
      }

      Block.prototype.checkMerkleRoot = function () {
        if (!this.transactions) return false

        var actualMerkleRoot = Block.calculateMerkleRoot(this.transactions)
        return this.merkleRoot.compare(actualMerkleRoot) === 0
      }

      Block.prototype.checkProofOfWork = function () {
        var hash = this.getHash().reverse()
        var target = Block.calculateTarget(this.bits)

        return hash.compare(target) <= 0
      }

      module.exports = Block

    }, { "./coins": 25, "./crypto": 26, "./networks": 33, "./transaction": 58, "./types": 60, "merkle-lib/fastRoot": 111, "safe-buffer": 133, "typeforce": 145, "varuint-bitcoin": 148 }], 23: [function (require, module, exports) {
      var Buffer = require('safe-buffer').Buffer
      var bufferutils = require('./bufferutils')
      var varuint = require('varuint-bitcoin')

      function BufferWriter(bufferSize) {
        this.buffer = Buffer.allocUnsafe(bufferSize)
        this.offset = 0
      }

      BufferWriter.prototype.getBuffer = function () {
        return this.buffer
      }

      BufferWriter.prototype.writeSlice = function (slice) {
        this.offset += slice.copy(this.buffer, this.offset)
      }

      BufferWriter.prototype.writeInt32 = function (input) {
        this.offset = this.buffer.writeInt32LE(input, this.offset)
      }

      BufferWriter.prototype.writeUInt32 = function (input) {
        this.offset = this.buffer.writeUInt32LE(input, this.offset)
      }

      BufferWriter.prototype.writeUInt64 = function (input) {
        this.offset = bufferutils.writeUInt64LE(this.buffer, input, this.offset)
      }

      BufferWriter.prototype.writeVarInt = function (input) {
        varuint.encode(input, this.buffer, this.offset)
        this.offset += varuint.encode.bytes
      }

      BufferWriter.prototype.writeVarSlice = function (slice) {
        this.writeVarInt(slice.length)
        this.writeSlice(slice)
      }

      module.exports = BufferWriter

    }, { "./bufferutils": 24, "safe-buffer": 133, "varuint-bitcoin": 148 }], 24: [function (require, module, exports) {
      var pushdata = require('pushdata-bitcoin')
      var varuint = require('varuint-bitcoin')

      // https://github.com/feross/buffer/blob/master/index.js#L1127
      function verifuint(value, max) {
        if (typeof value !== 'number') throw new Error('cannot write a non-number as a number')
        if (value < 0) throw new Error('specified a negative value for writing an unsigned value')
        if (value > max) throw new Error('RangeError: value out of range')
        if (Math.floor(value) !== value) throw new Error('value has a fractional component')
      }

      function readUInt64LE(buffer, offset) {
        var a = buffer.readUInt32LE(offset)
        var b = buffer.readUInt32LE(offset + 4)
        b *= 0x100000000

        verifuint(b + a, 0x001fffffffffffff)

        return b + a
      }

      function readInt64LE(buffer, offset) {
        var a = buffer.readUInt32LE(offset)
        var b = buffer.readInt32LE(offset + 4)
        b *= 0x100000000

        return b + a
      }

      function writeUInt64LE(buffer, value, offset) {
        verifuint(value, 0x001fffffffffffff)

        buffer.writeInt32LE(value & -1, offset)
        buffer.writeUInt32LE(Math.floor(value / 0x100000000), offset + 4)
        return offset + 8
      }

      // TODO: remove in 4.0.0?
      function readVarInt(buffer, offset) {
        var result = varuint.decode(buffer, offset)

        return {
          number: result,
          size: varuint.decode.bytes
        }
      }

      // TODO: remove in 4.0.0?
      function writeVarInt(buffer, number, offset) {
        varuint.encode(number, buffer, offset)
        return varuint.encode.bytes
      }

      module.exports = {
        pushDataSize: pushdata.encodingLength,
        readPushDataInt: pushdata.decode,
        readUInt64LE: readUInt64LE,
        readInt64LE: readInt64LE,
        readVarInt: readVarInt,
        varIntBuffer: varuint.encode,
        varIntSize: varuint.encodingLength,
        writePushDataInt: pushdata.encode,
        writeUInt64LE: writeUInt64LE,
        writeVarInt: writeVarInt
      }

    }, { "pushdata-bitcoin": 115, "varuint-bitcoin": 148 }], 25: [function (require, module, exports) {
      // Coins supported by bitgo-bitcoinjs-lib
      const typeforce = require('typeforce')

      const coins = {
        BCH: 'bch',
        BSV: 'bsv',
        BTC: 'btc',
        BTG: 'btg',
        LTC: 'ltc',
        ZEC: 'zec',
        DASH: 'dash'
      }

      coins.isBitcoin = function (network) {
        return typeforce.value(coins.BTC)(network.coin)
      }

      coins.isBitcoinCash = function (network) {
        return typeforce.value(coins.BCH)(network.coin)
      }

      coins.isBitcoinSV = function (network) {
        return typeforce.value(coins.BSV)(network.coin)
      }

      coins.isBitcoinGold = function (network) {
        return typeforce.value(coins.BTG)(network.coin)
      }

      coins.isDash = function (network) {
        return typeforce.value(coins.DASH)(network.coin)
      }

      coins.isLitecoin = function (network) {
        return typeforce.value(coins.LTC)(network.coin)
      }

      coins.isZcash = function (network) {
        return typeforce.value(coins.ZEC)(network.coin)
      }

      coins.isValidCoin = typeforce.oneOf(
        coins.isBitcoin,
        coins.isBitcoinCash,
        coins.isBitcoinSV,
        coins.isBitcoinGold,
        coins.isLitecoin,
        coins.isZcash
      )

      module.exports = coins

    }, { "typeforce": 145 }], 26: [function (require, module, exports) {
      var createHash = require('create-hash')
      var crypto = require('crypto')

      function ripemd160(buffer) {
        var hash = 'rmd160'
        var supportedHashes = crypto.getHashes()
        // some environments (electron) only support the long alias
        if (supportedHashes.indexOf(hash) === -1 && supportedHashes.indexOf('ripemd160') !== -1) {
          hash = 'ripemd160'
        }

        return createHash(hash).update(buffer).digest()
      }

      function sha1(buffer) {
        return createHash('sha1').update(buffer).digest()
      }

      function sha256(buffer) {
        return createHash('sha256').update(buffer).digest()
      }

      function hash160(buffer) {
        return ripemd160(sha256(buffer))
      }

      function hash256(buffer) {
        return sha256(sha256(buffer))
      }

      module.exports = {
        hash160: hash160,
        hash256: hash256,
        ripemd160: ripemd160,
        sha1: sha1,
        sha256: sha256
      }

    }, { "create-hash": 70, "crypto": 224 }], 27: [function (require, module, exports) {
      var Buffer = require('safe-buffer').Buffer
      var createHmac = require('create-hmac')
      var typeforce = require('typeforce')
      var types = require('./types')

      var BigInteger = require('bigi')
      var ECSignature = require('./ecsignature')

      var ZERO = Buffer.alloc(1, 0)
      var ONE = Buffer.alloc(1, 1)

      var ecurve = require('ecurve')
      var secp256k1 = ecurve.getCurveByName('secp256k1')

      // https://tools.ietf.org/html/rfc6979#section-3.2
      function deterministicGenerateK(hash, x, checkSig) {
        typeforce(types.tuple(
          types.Hash256bit,
          types.Buffer256bit,
          types.Function
        ), arguments)

        // Step A, ignored as hash already provided
        // Step B
        // Step C
        var k = Buffer.alloc(32, 0)
        var v = Buffer.alloc(32, 1)

        // Step D
        k = createHmac('sha256', k)
          .update(v)
          .update(ZERO)
          .update(x)
          .update(hash)
          .digest()

        // Step E
        v = createHmac('sha256', k).update(v).digest()

        // Step F
        k = createHmac('sha256', k)
          .update(v)
          .update(ONE)
          .update(x)
          .update(hash)
          .digest()

        // Step G
        v = createHmac('sha256', k).update(v).digest()

        // Step H1/H2a, ignored as tlen === qlen (256 bit)
        // Step H2b
        v = createHmac('sha256', k).update(v).digest()

        var T = BigInteger.fromBuffer(v)

        // Step H3, repeat until T is within the interval [1, n - 1] and is suitable for ECDSA
        while (T.signum() <= 0 || T.compareTo(secp256k1.n) >= 0 || !checkSig(T)) {
          k = createHmac('sha256', k)
            .update(v)
            .update(ZERO)
            .digest()

          v = createHmac('sha256', k).update(v).digest()

          // Step H1/H2a, again, ignored as tlen === qlen (256 bit)
          // Step H2b again
          v = createHmac('sha256', k).update(v).digest()
          T = BigInteger.fromBuffer(v)
        }

        return T
      }

      var N_OVER_TWO = secp256k1.n.shiftRight(1)

      function sign(hash, d) {
        typeforce(types.tuple(types.Hash256bit, types.BigInt), arguments)

        var x = d.toBuffer(32)
        var e = BigInteger.fromBuffer(hash)
        var n = secp256k1.n
        var G = secp256k1.G

        var r, s
        deterministicGenerateK(hash, x, function (k) {
          var Q = G.multiply(k)

          if (secp256k1.isInfinity(Q)) return false

          r = Q.affineX.mod(n)
          if (r.signum() === 0) return false

          s = k.modInverse(n).multiply(e.add(d.multiply(r))).mod(n)
          if (s.signum() === 0) return false

          return true
        })

        // enforce low S values, see bip62: 'low s values in signatures'
        if (s.compareTo(N_OVER_TWO) > 0) {
          s = n.subtract(s)
        }

        return new ECSignature(r, s)
      }

      function verify(hash, signature, Q) {
        typeforce(types.tuple(
          types.Hash256bit,
          types.ECSignature,
          types.ECPoint
        ), arguments)

        var n = secp256k1.n
        var G = secp256k1.G

        var r = signature.r
        var s = signature.s

        // 1.4.1 Enforce r and s are both integers in the interval [1, n − 1]
        if (r.signum() <= 0 || r.compareTo(n) >= 0) return false
        if (s.signum() <= 0 || s.compareTo(n) >= 0) return false

        // 1.4.2 H = Hash(M), already done by the user
        // 1.4.3 e = H
        var e = BigInteger.fromBuffer(hash)

        // Compute s^-1
        var sInv = s.modInverse(n)

        // 1.4.4 Compute u1 = es^−1 mod n
        //               u2 = rs^−1 mod n
        var u1 = e.multiply(sInv).mod(n)
        var u2 = r.multiply(sInv).mod(n)

        // 1.4.5 Compute R = (xR, yR)
        //               R = u1G + u2Q
        var R = G.multiplyTwo(u1, Q, u2)

        // 1.4.5 (cont.) Enforce R is not at infinity
        if (secp256k1.isInfinity(R)) return false

        // 1.4.6 Convert the field element R.x to an integer
        var xR = R.affineX

        // 1.4.7 Set v = xR mod n
        var v = xR.mod(n)

        // 1.4.8 If v = r, output "valid", and if v != r, output "invalid"
        return v.equals(r)
      }

      module.exports = {
        deterministicGenerateK: deterministicGenerateK,
        sign: sign,
        verify: verify,

        // TODO: remove
        __curve: secp256k1
      }

    }, { "./ecsignature": 29, "./types": 60, "bigi": 5, "create-hmac": 72, "ecurve": 76, "safe-buffer": 133, "typeforce": 145 }], 28: [function (require, module, exports) {
      var baddress = require('./address')
      var bcrypto = require('./crypto')
      var ecdsa = require('./ecdsa')
      var randomBytes = require('randombytes')
      var typeforce = require('typeforce')
      var types = require('./types')
      var wif = require('wif')

      var NETWORKS = require('./networks')
      var BigInteger = require('bigi')

      var ecurve = require('ecurve')
      var curve = ecurve.getCurveByName('secp256k1')
      var secp256k1 = ecdsa.__curve

      var fastcurve = require('./fastcurve')

      function ECPair(d, Q, options) {
        if (options) {
          typeforce({
            compressed: types.maybe(types.Boolean),
            network: types.maybe(types.Network)
          }, options)
        }

        options = options || {}

        if (d) {
          if (d.signum() <= 0) throw new Error('Private key must be greater than 0')
          if (d.compareTo(secp256k1.n) >= 0) throw new Error('Private key must be less than the curve order')
          if (Q) throw new TypeError('Unexpected publicKey parameter')

          this.d = d
        } else {
          typeforce(types.ECPoint, Q)

          this.__Q = Q
        }

        this.compressed = options.compressed === undefined ? true : options.compressed
        this.network = options.network || NETWORKS.bitcoin
      }

      Object.defineProperty(ECPair.prototype, 'Q', {
        get: function () {
          if (!this.__Q && this.d) {
            const qBuf = fastcurve.publicKeyCreate(this.d.toBuffer(32), false)
            this.__Q = qBuf ? ecurve.Point.decodeFrom(curve, qBuf) : secp256k1.G.multiply(this.d)
          }

          return this.__Q
        }
      })

      ECPair.fromPublicKeyBuffer = function (buffer, network) {
        var Q = ecurve.Point.decodeFrom(secp256k1, buffer)

        return new ECPair(null, Q, {
          compressed: Q.compressed,
          network: network
        })
      }
      ECPair.fromWIF = function (string, network) {
        var decoded = wif.decode(string)
        var version = decoded.version

        // list of networks?
        if (types.Array(network)) {
          network = network.filter(function (x) {
            return version === x.wif
          }).pop()  // We should not use pop since it depends on the order of the networks for the same wif

          if (!network) throw new Error('Unknown network version')

          // otherwise, assume a network object (or default to bitcoin)
        } else {
          network = network || NETWORKS.bitcoin

          if (version !== network.wif) throw new Error('Invalid network version')
        }

        var d = BigInteger.fromBuffer(decoded.privateKey)

        return new ECPair(d, null, {
          compressed: decoded.compressed,
          network: network
        })
      }

      ECPair.makeRandom = function (options) {
        options = options || {}

        var rng = options.rng || randomBytes

        var d
        do {
          var buffer = rng(32)
          typeforce(types.Buffer256bit, buffer)

          d = BigInteger.fromBuffer(buffer)
        } while (d.signum() <= 0 || d.compareTo(secp256k1.n) >= 0)

        return new ECPair(d, null, options)
      }

      ECPair.prototype.getAddress = function () {
        return baddress.toBase58Check(bcrypto.hash160(this.getPublicKeyBuffer()), this.getNetwork().pubKeyHash)
      }

      ECPair.prototype.getNetwork = function () {
        return this.network
      }

      ECPair.prototype.getPublicKeyBuffer = function () {
        return this.Q.getEncoded(this.compressed)
      }

      ECPair.prototype.sign = function (hash) {
        if (!this.d) throw new Error('Missing private key')

        var sig = fastcurve.sign(hash, this.d)
        if (sig !== undefined) return sig
        return ecdsa.sign(hash, this.d)
      }

      ECPair.prototype.toWIF = function () {
        if (!this.d) throw new Error('Missing private key')

        return wif.encode(this.network.wif, this.d.toBuffer(32), this.compressed)
      }

      ECPair.prototype.verify = function (hash, signature) {
        var fastsig = fastcurve.verify(hash, signature, this.getPublicKeyBuffer())
        if (fastsig !== undefined) return fastsig
        return ecdsa.verify(hash, signature, this.Q)
      }

      /**
       * @deprecated
       * Use {@see keyutil.privateKeyBufferToECPair} instead
       * Will be removed in next major version (BLOCK-267)
       */
      ECPair.fromPrivateKeyBuffer = function (buffer, network) {
        // toplevel import unavailable due to circular dependency
        var keyutil = require('./bitgo/keyutil')
        return keyutil.privateKeyBufferToECPair(buffer, network)
      }

      /**
       * @deprecated
       * Use {@see keyutil.privateKeyBufferFromECPair} instead
       * Will be removed in next major version (BLOCK-267)
       */
      ECPair.prototype.getPrivateKeyBuffer = function () {
        // toplevel import unavailable due to circular dependency
        var keyutil = require('./bitgo/keyutil')
        return keyutil.privateKeyBufferFromECPair(this)
      }

      module.exports = ECPair

    }, { "./address": 19, "./bitgo/keyutil": 21, "./crypto": 26, "./ecdsa": 27, "./fastcurve": 30, "./networks": 33, "./types": 60, "bigi": 5, "ecurve": 76, "randombytes": 116, "typeforce": 145, "wif": 149 }], 29: [function (require, module, exports) {
      (function (Buffer) {
        (function () {
          var bip66 = require('bip66')
          var typeforce = require('typeforce')
          var types = require('./types')

          var BigInteger = require('bigi')

          function ECSignature(r, s) {
            typeforce(types.tuple(types.BigInt, types.BigInt), arguments)

            this.r = r
            this.s = s
          }

          ECSignature.parseCompact = function (buffer) {
            typeforce(types.BufferN(65), buffer)

            var flagByte = buffer.readUInt8(0) - 27
            if (flagByte !== (flagByte & 7)) throw new Error('Invalid signature parameter')

            var compressed = !!(flagByte & 4)
            var recoveryParam = flagByte & 3
            var signature = ECSignature.fromRSBuffer(buffer.slice(1))

            return {
              compressed: compressed,
              i: recoveryParam,
              signature: signature
            }
          }

          ECSignature.fromRSBuffer = function (buffer) {
            typeforce(types.BufferN(64), buffer)

            var r = BigInteger.fromBuffer(buffer.slice(0, 32))
            var s = BigInteger.fromBuffer(buffer.slice(32, 64))
            return new ECSignature(r, s)
          }

          ECSignature.fromDER = function (buffer) {
            var decode = bip66.decode(buffer)
            var r = BigInteger.fromDERInteger(decode.r)
            var s = BigInteger.fromDERInteger(decode.s)

            return new ECSignature(r, s)
          }

          // BIP62: 1 byte hashType flag (only 0x01, 0x02, 0x03, 0x81, 0x82 and 0x83 are allowed)
          ECSignature.parseScriptSignature = function (buffer) {
            var hashType = buffer.readUInt8(buffer.length - 1)
            var hashTypeMod = hashType & ~0xc0

            if (hashTypeMod <= 0x00 || hashTypeMod >= 0x04) throw new Error('Invalid hashType ' + hashType)

            return {
              signature: ECSignature.fromDER(buffer.slice(0, -1)),
              hashType: hashType
            }
          }

          ECSignature.prototype.toCompact = function (i, compressed) {
            if (compressed) {
              i += 4
            }

            i += 27

            var buffer = Buffer.alloc(65)
            buffer.writeUInt8(i, 0)
            this.toRSBuffer(buffer, 1)
            return buffer
          }

          ECSignature.prototype.toDER = function () {
            var r = Buffer.from(this.r.toDERInteger())
            var s = Buffer.from(this.s.toDERInteger())

            return bip66.encode(r, s)
          }

          ECSignature.prototype.toRSBuffer = function (buffer, offset) {
            buffer = buffer || Buffer.alloc(64)
            this.r.toBuffer(32).copy(buffer, offset)
            this.s.toBuffer(32).copy(buffer, offset + 32)
            return buffer
          }

          ECSignature.prototype.toScriptSignature = function (hashType) {
            var hashTypeMod = hashType & ~0xc0
            if (hashTypeMod <= 0 || hashTypeMod >= 4) throw new Error('Invalid hashType ' + hashType)

            var hashTypeBuffer = Buffer.alloc(1)
            hashTypeBuffer.writeUInt8(hashType, 0)

            return Buffer.concat([this.toDER(), hashTypeBuffer])
          }

          module.exports = ECSignature

        }).call(this)
      }).call(this, require("buffer").Buffer)
    }, { "./types": 60, "bigi": 5, "bip66": 7, "buffer": 216, "typeforce": 145 }], 30: [function (require, module, exports) {
      var typeforce = require('typeforce')

      var ECSignature = require('./ecsignature')
      var types = require('./types')

      var secp256k1
      var available = false
      try {
        // secp256k1 is an optional native module used for accelerating
        // low-level elliptic curve operations. It's nice to have, but
        // we can live without it too
        secp256k1 = require('secp256k1')
        available = true
      } catch (e) {
        // secp256k1 is not available, this is alright
      }

      /**
       * Derive a public key from a 32 byte private key buffer.
       *
       * Uses secp256k1 for acceleration. If secp256k1 is not available,
       * this function returns undefined.
       *
       * @param buffer {Buffer} Private key buffer
       * @param compressed {Boolean} Whether the public key should be compressed
       * @return {undefined}
       */
      var publicKeyCreate = function (buffer, compressed) {
        typeforce(types.tuple(types.Buffer256bit, types.Boolean), arguments)

        if (!available) {
          return undefined
        }

        return secp256k1.publicKeyCreate(buffer, compressed)
      }

      /**
       * Create an ECDSA signature over the given message hash `hash` with
       * the private key `d`.
       *
       * Uses secp256k1 for acceleration. If secp256k1 is not available,
       * this function returns undefined.
       * @param hash {Buffer} hash of the message which is to be signed
       * @param d {BigInteger} private key which is to be used for signing
       * @return {ECSignature}
       */
      var sign = function (hash, d) {
        typeforce(types.tuple(types.Buffer256bit, types.BigInt), arguments)

        if (!available) {
          return undefined
        }

        var sig = secp256k1.sign(hash, d.toBuffer(32)).signature
        return ECSignature.fromDER(secp256k1.signatureExport(sig))
      }

      /**
       * Verify an ECDSA signature over the given message hash `hash` with signature `sig`
       * and public key `pubkey`.
       *
       * Uses secp256k1 for acceleration. If secp256k1 is not available,
       * this function returns undefined.
       * @param hash {Buffer} hash of the message which is to be verified
       * @param sig {ECSignature} signature which is to be verified
       * @param pubkey {Buffer} public key which will be used to verify the message signature
       * @return {Boolean}
       */
      var verify = function (hash, sig, pubkey) {
        typeforce(types.tuple(
          types.Hash256bit,
          types.ECSignature,
          // both compressed and uncompressed public keys are fine
          types.oneOf(types.BufferN(33), types.BufferN(65))),
          arguments)

        if (!available) {
          return undefined
        }

        sig = new ECSignature(sig.r, sig.s)
        sig = secp256k1.signatureNormalize(secp256k1.signatureImport(sig.toDER()))
        return secp256k1.verify(hash, sig, pubkey)
      }

      module.exports = {
        available: available,
        publicKeyCreate: publicKeyCreate,
        sign: sign,
        verify: verify
      }

    }, { "./ecsignature": 29, "./types": 60, "secp256k1": 13, "typeforce": 145 }], 31: [function (require, module, exports) {
      var Buffer = require('safe-buffer').Buffer
      var base58check = require('bs58check')
      var bcrypto = require('./crypto')
      var createHmac = require('create-hmac')
      var typeforce = require('typeforce')
      var types = require('./types')
      var NETWORKS = require('./networks')

      var BigInteger = require('bigi')
      var ECPair = require('./ecpair')

      var ecurve = require('ecurve')
      var curve = ecurve.getCurveByName('secp256k1')

      var fastcurve = require('./fastcurve')

      function HDNode(keyPair, chainCode) {
        typeforce(types.tuple('ECPair', types.Buffer256bit), arguments)

        if (!keyPair.compressed) throw new TypeError('BIP32 only allows compressed keyPairs')

        this.keyPair = keyPair
        this.chainCode = chainCode
        this.depth = 0
        this.index = 0
        this.parentFingerprint = 0x00000000
        this.derivationCache = {}
      }

      HDNode.HIGHEST_BIT = 0x80000000
      HDNode.LENGTH = 78
      HDNode.MASTER_SECRET = Buffer.from('Bitcoin seed', 'utf8')

      HDNode.fromSeedBuffer = function (seed, network) {
        typeforce(types.tuple(types.Buffer, types.maybe(types.Network)), arguments)

        if (seed.length < 16) throw new TypeError('Seed should be at least 128 bits')
        if (seed.length > 64) throw new TypeError('Seed should be at most 512 bits')

        var I = createHmac('sha512', HDNode.MASTER_SECRET).update(seed).digest()
        var IL = I.slice(0, 32)
        var IR = I.slice(32)

        // In case IL is 0 or >= n, the master key is invalid
        // This is handled by the ECPair constructor
        var pIL = BigInteger.fromBuffer(IL)
        var keyPair = new ECPair(pIL, null, {
          network: network
        })

        return new HDNode(keyPair, IR)
      }

      HDNode.fromSeedHex = function (hex, network) {
        return HDNode.fromSeedBuffer(Buffer.from(hex, 'hex'), network)
      }

      HDNode.fromBase58 = function (string, networks) {
        // FixMe: Issue #38, this method just pops the latest network object from the list instead of being more discerning.
        var buffer = base58check.decode(string)
        if (buffer.length !== 78) throw new Error('Invalid buffer length')

        // 4 bytes: version bytes
        var version = buffer.readUInt32BE(0)
        var network

        // list of networks?
        if (Array.isArray(networks)) {
          network = networks.filter(function (x) {
            return version === x.bip32.private ||
              version === x.bip32.public
          }).pop()

          if (!network) throw new Error('Unknown network version')

          // otherwise, assume a network object (or default to bitcoin)
        } else {
          network = networks || NETWORKS.bitcoin
        }

        if (version !== network.bip32.private &&
          version !== network.bip32.public) throw new Error('Invalid network version')

        // 1 byte: depth: 0x00 for master nodes, 0x01 for level-1 descendants, ...
        var depth = buffer[4]

        // 4 bytes: the fingerprint of the parent's key (0x00000000 if master key)
        var parentFingerprint = buffer.readUInt32BE(5)
        if (depth === 0) {
          if (parentFingerprint !== 0x00000000) throw new Error('Invalid parent fingerprint')
        }

        // 4 bytes: child number. This is the number i in xi = xpar/i, with xi the key being serialized.
        // This is encoded in MSB order. (0x00000000 if master key)
        var index = buffer.readUInt32BE(9)
        if (depth === 0 && index !== 0) throw new Error('Invalid index')

        // 32 bytes: the chain code
        var chainCode = buffer.slice(13, 45)
        var keyPair

        // 33 bytes: private key data (0x00 + k)
        if (version === network.bip32.private) {
          if (buffer.readUInt8(45) !== 0x00) throw new Error('Invalid private key')

          var d = BigInteger.fromBuffer(buffer.slice(46, 78))
          keyPair = new ECPair(d, null, { network: network })

          // 33 bytes: public key data (0x02 + X or 0x03 + X)
        } else {
          var Q = ecurve.Point.decodeFrom(curve, buffer.slice(45, 78))
          // Q.compressed is assumed, if somehow this assumption is broken, `new HDNode` will throw

          // Verify that the X coordinate in the public point corresponds to a point on the curve.
          // If not, the extended public key is invalid.
          curve.validate(Q)

          keyPair = new ECPair(null, Q, { network: network })
        }

        var hd = new HDNode(keyPair, chainCode)
        hd.depth = depth
        hd.index = index
        hd.parentFingerprint = parentFingerprint

        return hd
      }

      HDNode.prototype.getAddress = function () {
        return this.keyPair.getAddress()
      }

      HDNode.prototype.getIdentifier = function () {
        return bcrypto.hash160(this.keyPair.getPublicKeyBuffer())
      }

      HDNode.prototype.getFingerprint = function () {
        return this.getIdentifier().slice(0, 4)
      }

      HDNode.prototype.getNetwork = function () {
        return this.keyPair.getNetwork()
      }

      HDNode.prototype.getPublicKeyBuffer = function () {
        return this.keyPair.getPublicKeyBuffer()
      }

      HDNode.prototype.neutered = function () {
        var neuteredKeyPair = new ECPair(null, this.keyPair.Q, {
          network: this.keyPair.network
        })

        var neutered = new HDNode(neuteredKeyPair, this.chainCode)
        neutered.depth = this.depth
        neutered.index = this.index
        neutered.parentFingerprint = this.parentFingerprint

        return neutered
      }

      HDNode.prototype.sign = function (hash) {
        return this.keyPair.sign(hash)
      }

      HDNode.prototype.verify = function (hash, signature) {
        return this.keyPair.verify(hash, signature)
      }

      HDNode.prototype.toBase58 = function (__isPrivate) {
        if (__isPrivate !== undefined) throw new TypeError('Unsupported argument in 2.0.0')

        // Version
        var network = this.keyPair.network
        var version = (!this.isNeutered()) ? network.bip32.private : network.bip32.public
        var buffer = Buffer.allocUnsafe(78)

        // 4 bytes: version bytes
        buffer.writeUInt32BE(version, 0)

        // 1 byte: depth: 0x00 for master nodes, 0x01 for level-1 descendants, ....
        buffer.writeUInt8(this.depth, 4)

        // 4 bytes: the fingerprint of the parent's key (0x00000000 if master key)
        buffer.writeUInt32BE(this.parentFingerprint, 5)

        // 4 bytes: child number. This is the number i in xi = xpar/i, with xi the key being serialized.
        // This is encoded in big endian. (0x00000000 if master key)
        buffer.writeUInt32BE(this.index, 9)

        // 32 bytes: the chain code
        this.chainCode.copy(buffer, 13)

        // 33 bytes: the public key or private key data
        if (!this.isNeutered()) {
          // 0x00 + k for private keys
          buffer.writeUInt8(0, 45)
          this.keyPair.d.toBuffer(32).copy(buffer, 46)

          // 33 bytes: the public key
        } else {
          // X9.62 encoding for public keys
          this.keyPair.getPublicKeyBuffer().copy(buffer, 45)
        }

        return base58check.encode(buffer)
      }

      // https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki#child-key-derivation-ckd-functions
      HDNode.prototype.derive = function (index) {
        typeforce(types.UInt32, index)

        var isHardened = index >= HDNode.HIGHEST_BIT
        var data = Buffer.allocUnsafe(37)

        // Hardened child
        if (isHardened) {
          if (this.isNeutered()) throw new TypeError('Could not derive hardened child key')

          // data = 0x00 || ser256(kpar) || ser32(index)
          data[0] = 0x00
          this.keyPair.d.toBuffer(32).copy(data, 1)
          data.writeUInt32BE(index, 33)

          // Normal child
        } else {
          // data = serP(point(kpar)) || ser32(index)
          //      = serP(Kpar) || ser32(index)
          this.keyPair.getPublicKeyBuffer().copy(data, 0)
          data.writeUInt32BE(index, 33)
        }

        var I = createHmac('sha512', this.chainCode).update(data).digest()
        var IL = I.slice(0, 32)
        var IR = I.slice(32)

        var pIL = BigInteger.fromBuffer(IL)

        // In case parse256(IL) >= n, proceed with the next value for i
        if (pIL.compareTo(curve.n) >= 0) {
          return this.derive(index + 1)
        }

        // Private parent key -> private child key
        var derivedKeyPair
        if (!this.isNeutered()) {
          // ki = parse256(IL) + kpar (mod n)
          var ki = pIL.add(this.keyPair.d).mod(curve.n)

          // In case ki == 0, proceed with the next value for i
          if (ki.signum() === 0) {
            return this.derive(index + 1)
          }

          derivedKeyPair = new ECPair(ki, null, {
            network: this.keyPair.network
          })

          // Public parent key -> public child key
        } else {
          // Ki = point(parse256(IL)) + Kpar
          //    = G*IL + Kpar
          var point = fastcurve.publicKeyCreate(IL, false)
          var Ki = point !== undefined
            ? ecurve.Point.decodeFrom(curve, point).add(this.keyPair.Q)
            : curve.G.multiply(pIL).add(this.keyPair.Q)

          // In case Ki is the point at infinity, proceed with the next value for i
          if (curve.isInfinity(Ki)) {
            return this.derive(index + 1)
          }

          derivedKeyPair = new ECPair(null, Ki, {
            network: this.keyPair.network
          })
        }

        var hd = new HDNode(derivedKeyPair, IR)
        hd.depth = this.depth + 1
        hd.index = index
        hd.parentFingerprint = this.getFingerprint().readUInt32BE(0)

        return hd
      }

      HDNode.prototype.deriveHardened = function (index) {
        typeforce(types.UInt31, index)

        // Only derives hardened private keys by default
        return this.derive(index + HDNode.HIGHEST_BIT)
      }

      // Private === not neutered
      // Public === neutered
      HDNode.prototype.isNeutered = function () {
        return !(this.keyPair.d)
      }

      HDNode.prototype.derivePath = function (path, cache) {
        typeforce(types.BIP32Path, path)
        typeforce(types.maybe(types.Object), cache)

        cache = cache || this.derivationCache

        var splitPath = path.split('/')
        if (splitPath[0] === 'm') {
          if (this.parentFingerprint) {
            throw new Error('Not a master node')
          }

          splitPath = splitPath.slice(1)
        }

        return splitPath.reduce(function (prevHd, indexStr) {
          var index
          var cacheObject = cache[indexStr] || {}
          if (cacheObject.node) {
            cache = cacheObject.next
            return cacheObject.node
          }
          if (indexStr.slice(-1) === "'") {
            index = parseInt(indexStr.slice(0, -1), 10)
            cacheObject.node = prevHd.deriveHardened(index)
          } else {
            index = parseInt(indexStr, 10)
            cacheObject.node = prevHd.derive(index)
          }

          cache[indexStr] = cacheObject
          cacheObject.next = {}
          cache = cacheObject.next
          return cacheObject.node
        }, this)
      }

      /**
       * Create a new ECPair object from this HDNode's ECPair.
       *
       * Uses secp256k1 if available for accelerated computation of the cloned public key.
       * @return {ECPair}
       */
      HDNode.prototype.cloneKeypair = function () {
        var k = this.keyPair
        var result = new ECPair(k.d, k.d ? null : k.Q, {
          network: k.network,
          compressed: k.compressed
        })
        // Creating Q from d takes ~25ms, so if it's not created, use native bindings to pre-compute
        // if Q is not set here, it will be lazily computed via the slow path
        if (!result.__Q) {
          var point = fastcurve.publicKeyCreate(k.d.toBuffer(32), false)
          if (point !== undefined) {
            result.__Q = ecurve.Point.decodeFrom(curve, point)
          }
        }
        return result
      }

      module.exports = HDNode

    }, { "./crypto": 26, "./ecpair": 28, "./fastcurve": 30, "./networks": 33, "./types": 60, "bigi": 5, "bs58check": 68, "create-hmac": 72, "ecurve": 76, "safe-buffer": 133, "typeforce": 145 }], 32: [function (require, module, exports) {
      var script = require('./script')

      var templates = require('./templates')
      for (var key in templates) {
        script[key] = templates[key]
      }

      module.exports = {
        bitgo: require('./bitgo'),
        bufferutils: require('./bufferutils'), // TODO: remove in 4.0.0

        Block: require('./block'),
        ECPair: require('./ecpair'),
        ECSignature: require('./ecsignature'),
        HDNode: require('./hdnode'),
        Transaction: require('./transaction'),
        TransactionBuilder: require('./transaction_builder'),

        address: require('./address'),
        coins: require('./coins'),
        crypto: require('./crypto'),
        networks: require('./networks'),
        opcodes: require('bitcoin-ops'),
        script: script
      }

    }, { "./address": 19, "./bitgo": 20, "./block": 22, "./bufferutils": 24, "./coins": 25, "./crypto": 26, "./ecpair": 28, "./ecsignature": 29, "./hdnode": 31, "./networks": 33, "./script": 34, "./templates": 36, "./transaction": 58, "./transaction_builder": 59, "bitcoin-ops": 8 }], 33: [function (require, module, exports) {
      // https://en.bitcoin.it/wiki/List_of_address_prefixes
      // Dogecoin BIP32 is a proposed standard: https://bitcointalk.org/index.php?topic=409731
      var coins = require('./coins')

      module.exports = {
        dash: {
          messagePrefix: '\x19DarkCoin Signed Message:\n',
          bip32: {
            public: 0x0488b21e,
            private: 0x0488ade4
          },
          pubKeyHash: 0x4c, // https://dash-docs.github.io/en/developer-reference#opcodes
          scriptHash: 0x10,
          wif: 0xcc,
          coin: coins.DASH
        },
        dashTest: {
          messagePrefix: '\x19DarkCoin Signed Message:\n',
          bip32: {
            public: 0x043587cf,
            private: 0x04358394
          },
          pubKeyHash: 0x8c, // https://dash-docs.github.io/en/developer-reference#opcodes
          scriptHash: 0x13,
          wif: 0xef, // https://github.com/dashpay/godashutil/blob/master/wif.go#L72
          coin: coins.DASH
        },
        bitcoincash: {
          messagePrefix: '\x18Bitcoin Signed Message:\n',
          bip32: {
            public: 0x0488b21e,
            private: 0x0488ade4
          },
          pubKeyHash: 0x00,
          scriptHash: 0x05,
          wif: 0x80,
          coin: coins.BCH,
          forkId: 0x00
        },
        bitcoincashTestnet: {
          messagePrefix: '\x18Bitcoin Signed Message:\n',
          bip32: {
            public: 0x043587cf,
            private: 0x04358394
          },
          pubKeyHash: 0x6f,
          scriptHash: 0xc4,
          wif: 0xef,
          coin: coins.BCH
        },
        bitcoinsv: {
          messagePrefix: '\x18Bitcoin Signed Message:\n',
          bip32: {
            public: 0x0488b21e,
            private: 0x0488ade4
          },
          pubKeyHash: 0x00,
          scriptHash: 0x05,
          wif: 0x80,
          coin: coins.BSV,
          forkId: 0x00
        },
        bitcoinsvTestnet: {
          messagePrefix: '\x18Bitcoin Signed Message:\n',
          bip32: {
            public: 0x043587cf,
            private: 0x04358394
          },
          pubKeyHash: 0x6f,
          scriptHash: 0xc4,
          wif: 0xef,
          coin: coins.BSV
        },
        zcash: {
          messagePrefix: '\x18ZCash Signed Message:\n',
          bip32: {
            public: 0x0488b21e,
            private: 0x0488ade4
          },
          pubKeyHash: 0x1cb8,
          scriptHash: 0x1cbd,
          wif: 0x80,
          // This parameter was introduced in version 3 to allow soft forks, for version 1 and 2 transactions we add a
          // dummy value.
          consensusBranchId: {
            1: 0x00,
            2: 0x00,
            3: 0x5ba81b19,
            // 4: 0x76b809bb (old Sapling branch id). Blossom branch id becomes effective after block 653600
            4: 0x2bb40e60
          },
          coin: coins.ZEC
        },
        zcashTest: {
          messagePrefix: '\x18ZCash Signed Message:\n',
          bip32: {
            public: 0x043587cf,
            private: 0x04358394
          },
          pubKeyHash: 0x1d25,
          scriptHash: 0x1cba,
          wif: 0xef,
          consensusBranchId: {
            1: 0x00,
            2: 0x00,
            3: 0x5ba81b19,
            // 4: 0x76b809bb (old Sapling branch id)
            4: 0x2bb40e60
          },
          coin: coins.ZEC
        },
        bitcoingold: {
          messagePrefix: '\x18Bitcoin Gold Signed Message:\n',
          bech32: 'btg',
          bip32: {
            public: 0x0488b21e,
            private: 0x0488ade4
          },
          pubKeyHash: 0x26,
          scriptHash: 0x17,
          wif: 0x80,
          coin: coins.BTG,
          forkId: 0x4F /* 79 */
        },
        litecoin: {
          messagePrefix: '\x19Litecoin Signed Message:\n',
          bech32: 'ltc',
          bip32: {
            public: 0x019da462,
            private: 0x019d9cfe
          },
          pubKeyHash: 0x30,
          scriptHash: 0x32,
          wif: 0xb0,
          coin: coins.LTC
        },
        litecoinTest: {
          messagePrefix: '\x19Litecoin Signed Message:\n',
          bech32: 'tltc',
          bip32: {
            public: 0x0488b21e,
            private: 0x0488ade4
          },
          pubKeyHash: 0x6f,
          scriptHash: 0x3a,
          wif: 0xb0,
          coin: coins.LTC
        },
        bitcoin: {
          messagePrefix: '\x18Bitcoin Signed Message:\n',
          bech32: 'bc',
          bip32: {
            public: 0x0488b21e,
            private: 0x0488ade4
          },
          pubKeyHash: 0x00,
          scriptHash: 0x05,
          wif: 0x80,
          coin: coins.BTC
        },
        testnet: {
          messagePrefix: '\x18Bitcoin Signed Message:\n',
          bech32: 'tb',
          bip32: {
            public: 0x043587cf,
            private: 0x04358394
          },
          pubKeyHash: 0x6f,
          scriptHash: 0xc4,
          wif: 0xef,
          coin: coins.BTC
        }
      }

    }, { "./coins": 25 }], 34: [function (require, module, exports) {
      var Buffer = require('safe-buffer').Buffer
      var bip66 = require('bip66')
      var pushdata = require('pushdata-bitcoin')
      var typeforce = require('typeforce')
      var types = require('./types')
      var scriptNumber = require('./script_number')

      var OPS = require('bitcoin-ops')
      var REVERSE_OPS = require('bitcoin-ops/map')
      var OP_INT_BASE = OPS.OP_RESERVED // OP_1 - 1

      function isOPInt(value) {
        return types.Number(value) &&
          ((value === OPS.OP_0) ||
            (value >= OPS.OP_1 && value <= OPS.OP_16) ||
            (value === OPS.OP_1NEGATE))
      }

      function isPushOnlyChunk(value) {
        return types.Buffer(value) || isOPInt(value)
      }

      function isPushOnly(value) {
        return types.Array(value) && value.every(isPushOnlyChunk)
      }

      function asMinimalOP(buffer) {
        if (buffer.length === 0) return OPS.OP_0
        if (buffer.length !== 1) return
        if (buffer[0] >= 1 && buffer[0] <= 16) return OP_INT_BASE + buffer[0]
        if (buffer[0] === 0x81) return OPS.OP_1NEGATE
      }

      function compile(chunks) {
        // TODO: remove me
        if (Buffer.isBuffer(chunks)) return chunks

        typeforce(types.Array, chunks)

        var bufferSize = chunks.reduce(function (accum, chunk) {
          // data chunk
          if (Buffer.isBuffer(chunk)) {
            // adhere to BIP62.3, minimal push policy
            if (chunk.length === 1 && asMinimalOP(chunk) !== undefined) {
              return accum + 1
            }

            return accum + pushdata.encodingLength(chunk.length) + chunk.length
          }

          // opcode
          return accum + 1
        }, 0.0)

        var buffer = Buffer.allocUnsafe(bufferSize)
        var offset = 0

        chunks.forEach(function (chunk) {
          // data chunk
          if (Buffer.isBuffer(chunk)) {
            // adhere to BIP62.3, minimal push policy
            var opcode = asMinimalOP(chunk)
            if (opcode !== undefined) {
              buffer.writeUInt8(opcode, offset)
              offset += 1
              return
            }

            offset += pushdata.encode(buffer, chunk.length, offset)
            chunk.copy(buffer, offset)
            offset += chunk.length

            // opcode
          } else {
            buffer.writeUInt8(chunk, offset)
            offset += 1
          }
        })

        if (offset !== buffer.length) throw new Error('Could not decode chunks')
        return buffer
      }

      function decompile(buffer) {
        // TODO: remove me
        if (types.Array(buffer)) return buffer

        typeforce(types.Buffer, buffer)

        var chunks = []
        var i = 0

        while (i < buffer.length) {
          var opcode = buffer[i]

          // data chunk
          if ((opcode > OPS.OP_0) && (opcode <= OPS.OP_PUSHDATA4)) {
            var d = pushdata.decode(buffer, i)

            // did reading a pushDataInt fail? empty script
            if (d === null) return []
            i += d.size

            // attempt to read too much data? empty script
            if (i + d.number > buffer.length) return []

            var data = buffer.slice(i, i + d.number)
            i += d.number

            // decompile minimally
            var op = asMinimalOP(data)
            if (op !== undefined) {
              chunks.push(op)
            } else {
              chunks.push(data)
            }

            // opcode
          } else {
            chunks.push(opcode)

            i += 1
          }
        }

        return chunks
      }

      function toASM(chunks) {
        if (Buffer.isBuffer(chunks)) {
          chunks = decompile(chunks)
        }

        return chunks.map(function (chunk) {
          // data?
          if (Buffer.isBuffer(chunk)) {
            var op = asMinimalOP(chunk)
            if (op === undefined) return chunk.toString('hex')
            chunk = op
          }

          // opcode!
          return REVERSE_OPS[chunk]
        }).join(' ')
      }

      function fromASM(asm) {
        typeforce(types.String, asm)

        return compile(asm.split(' ').map(function (chunkStr) {
          // opcode?
          if (OPS[chunkStr] !== undefined) return OPS[chunkStr]
          typeforce(types.Hex, chunkStr)

          // data!
          return Buffer.from(chunkStr, 'hex')
        }))
      }

      function toStack(chunks) {
        chunks = decompile(chunks)
        typeforce(isPushOnly, chunks)

        return chunks.map(function (op) {
          if (Buffer.isBuffer(op)) return op
          if (op === OPS.OP_0) return Buffer.allocUnsafe(0)

          return scriptNumber.encode(op - OP_INT_BASE)
        })
      }

      function isCanonicalPubKey(buffer) {
        if (!Buffer.isBuffer(buffer)) return false
        if (buffer.length < 33) return false

        switch (buffer[0]) {
          case 0x02:
          case 0x03:
            return buffer.length === 33
          case 0x04:
            return buffer.length === 65
        }

        return false
      }

      function isDefinedHashType(hashType) {
        var hashTypeMod = hashType & ~0xc0

        // return hashTypeMod > SIGHASH_ALL && hashTypeMod < SIGHASH_SINGLE
        return hashTypeMod > 0x00 && hashTypeMod < 0x04
      }

      function isCanonicalSignature(buffer) {
        if (!Buffer.isBuffer(buffer)) return false
        if (!isDefinedHashType(buffer[buffer.length - 1])) return false

        return bip66.check(buffer.slice(0, -1))
      }

      module.exports = {
        compile: compile,
        decompile: decompile,
        fromASM: fromASM,
        toASM: toASM,
        toStack: toStack,

        number: require('./script_number'),

        isCanonicalPubKey: isCanonicalPubKey,
        isCanonicalSignature: isCanonicalSignature,
        isPushOnly: isPushOnly,
        isDefinedHashType: isDefinedHashType
      }

    }, { "./script_number": 35, "./types": 60, "bip66": 7, "bitcoin-ops": 8, "bitcoin-ops/map": 9, "pushdata-bitcoin": 115, "safe-buffer": 133, "typeforce": 145 }], 35: [function (require, module, exports) {
      var Buffer = require('safe-buffer').Buffer

      function decode(buffer, maxLength, minimal) {
        maxLength = maxLength || 4
        minimal = minimal === undefined ? true : minimal

        var length = buffer.length
        if (length === 0) return 0
        if (length > maxLength) throw new TypeError('Script number overflow')
        if (minimal) {
          if ((buffer[length - 1] & 0x7f) === 0) {
            if (length <= 1 || (buffer[length - 2] & 0x80) === 0) throw new Error('Non-minimally encoded script number')
          }
        }

        // 40-bit
        if (length === 5) {
          var a = buffer.readUInt32LE(0)
          var b = buffer.readUInt8(4)

          if (b & 0x80) return -(((b & ~0x80) * 0x100000000) + a)
          return (b * 0x100000000) + a
        }

        var result = 0

        // 32-bit / 24-bit / 16-bit / 8-bit
        for (var i = 0; i < length; ++i) {
          result |= buffer[i] << (8 * i)
        }

        if (buffer[length - 1] & 0x80) return -(result & ~(0x80 << (8 * (length - 1))))
        return result
      }

      function scriptNumSize(i) {
        return i > 0x7fffffff ? 5
          : i > 0x7fffff ? 4
            : i > 0x7fff ? 3
              : i > 0x7f ? 2
                : i > 0x00 ? 1
                  : 0
      }

      function encode(number) {
        var value = Math.abs(number)
        var size = scriptNumSize(value)
        var buffer = Buffer.allocUnsafe(size)
        var negative = number < 0

        for (var i = 0; i < size; ++i) {
          buffer.writeUInt8(value & 0xff, i)
          value >>= 8
        }

        if (buffer[size - 1] & 0x80) {
          buffer.writeUInt8(negative ? 0x80 : 0x00, size - 1)
        } else if (negative) {
          buffer[size - 1] |= 0x80
        }

        return buffer
      }

      module.exports = {
        decode: decode,
        encode: encode
      }

    }, { "safe-buffer": 133 }], 36: [function (require, module, exports) {
      var decompile = require('../script').decompile
      var multisig = require('./multisig')
      var nullData = require('./nulldata')
      var pubKey = require('./pubkey')
      var pubKeyHash = require('./pubkeyhash')
      var scriptHash = require('./scripthash')
      var witnessPubKeyHash = require('./witnesspubkeyhash')
      var witnessScriptHash = require('./witnessscripthash')
      var witnessCommitment = require('./witnesscommitment')

      var types = {
        MULTISIG: 'multisig',
        NONSTANDARD: 'nonstandard',
        NULLDATA: 'nulldata',
        P2PK: 'pubkey',
        P2PKH: 'pubkeyhash',
        P2SH: 'scripthash',
        P2WPKH: 'witnesspubkeyhash',
        P2WSH: 'witnessscripthash',
        WITNESS_COMMITMENT: 'witnesscommitment'
      }

      function classifyOutput(script) {
        if (witnessPubKeyHash.output.check(script)) return types.P2WPKH
        if (witnessScriptHash.output.check(script)) return types.P2WSH
        if (pubKeyHash.output.check(script)) return types.P2PKH
        if (scriptHash.output.check(script)) return types.P2SH

        // XXX: optimization, below functions .decompile before use
        var chunks = decompile(script)
        if (multisig.output.check(chunks)) return types.MULTISIG
        if (pubKey.output.check(chunks)) return types.P2PK
        if (witnessCommitment.output.check(chunks)) return types.WITNESS_COMMITMENT
        if (nullData.output.check(chunks)) return types.NULLDATA

        return types.NONSTANDARD
      }

      function classifyInput(script, allowIncomplete) {
        // XXX: optimization, below functions .decompile before use
        var chunks = decompile(script)

        if (pubKeyHash.input.check(chunks)) return types.P2PKH
        if (scriptHash.input.check(chunks, allowIncomplete)) return types.P2SH
        if (multisig.input.check(chunks, allowIncomplete)) return types.MULTISIG
        if (pubKey.input.check(chunks)) return types.P2PK

        return types.NONSTANDARD
      }

      function classifyWitness(script, allowIncomplete) {
        // XXX: optimization, below functions .decompile before use
        var chunks = decompile(script)

        if (witnessPubKeyHash.input.check(chunks)) return types.P2WPKH
        if (witnessScriptHash.input.check(chunks, allowIncomplete)) return types.P2WSH

        return types.NONSTANDARD
      }

      module.exports = {
        classifyInput: classifyInput,
        classifyOutput: classifyOutput,
        classifyWitness: classifyWitness,
        multisig: multisig,
        nullData: nullData,
        pubKey: pubKey,
        pubKeyHash: pubKeyHash,
        scriptHash: scriptHash,
        witnessPubKeyHash: witnessPubKeyHash,
        witnessScriptHash: witnessScriptHash,
        witnessCommitment: witnessCommitment,
        types: types
      }

    }, { "../script": 34, "./multisig": 37, "./nulldata": 40, "./pubkey": 41, "./pubkeyhash": 44, "./scripthash": 47, "./witnesscommitment": 50, "./witnesspubkeyhash": 52, "./witnessscripthash": 55 }], 37: [function (require, module, exports) {
      module.exports = {
        input: require('./input'),
        output: require('./output')
      }

    }, { "./input": 38, "./output": 39 }], 38: [function (require, module, exports) {
      // OP_0 [signatures ...]

      var Buffer = require('safe-buffer').Buffer
      var bscript = require('../../script')
      var p2mso = require('./output')
      var typeforce = require('typeforce')
      var OPS = require('bitcoin-ops')

      function partialSignature(value) {
        return value === OPS.OP_0 || bscript.isCanonicalSignature(value)
      }

      function check(script, allowIncomplete) {
        var chunks = bscript.decompile(script)
        if (chunks.length < 2) return false
        if (chunks[0] !== OPS.OP_0) return false

        if (allowIncomplete) {
          return chunks.slice(1).every(partialSignature)
        }

        return chunks.slice(1).every(bscript.isCanonicalSignature)
      }
      check.toJSON = function () { return 'multisig input' }

      var EMPTY_BUFFER = Buffer.allocUnsafe(0)

      function encodeStack(signatures, scriptPubKey) {
        typeforce([partialSignature], signatures)

        if (scriptPubKey) {
          var scriptData = p2mso.decode(scriptPubKey)

          if (signatures.length < scriptData.m) {
            throw new TypeError('Not enough signatures provided')
          }

          if (signatures.length > scriptData.pubKeys.length) {
            throw new TypeError('Too many signatures provided')
          }
        }

        return [].concat(EMPTY_BUFFER, signatures.map(function (sig) {
          if (sig === OPS.OP_0) {
            return EMPTY_BUFFER
          }
          return sig
        }))
      }

      function encode(signatures, scriptPubKey) {
        return bscript.compile(encodeStack(signatures, scriptPubKey))
      }

      function decodeStack(stack, allowIncomplete) {
        typeforce(check, stack, allowIncomplete)
        return stack.slice(1)
      }

      function decode(buffer, allowIncomplete) {
        var stack = bscript.decompile(buffer)
        return decodeStack(stack, allowIncomplete)
      }

      module.exports = {
        check: check,
        decode: decode,
        decodeStack: decodeStack,
        encode: encode,
        encodeStack: encodeStack
      }

    }, { "../../script": 34, "./output": 39, "bitcoin-ops": 8, "safe-buffer": 133, "typeforce": 145 }], 39: [function (require, module, exports) {
      // m [pubKeys ...] n OP_CHECKMULTISIG

      var bscript = require('../../script')
      var types = require('../../types')
      var typeforce = require('typeforce')
      var OPS = require('bitcoin-ops')
      var OP_INT_BASE = OPS.OP_RESERVED // OP_1 - 1

      function check(script, allowIncomplete) {
        var chunks = bscript.decompile(script)

        if (chunks.length < 4) return false
        if (chunks[chunks.length - 1] !== OPS.OP_CHECKMULTISIG) return false
        if (!types.Number(chunks[0])) return false
        if (!types.Number(chunks[chunks.length - 2])) return false
        var m = chunks[0] - OP_INT_BASE
        var n = chunks[chunks.length - 2] - OP_INT_BASE

        if (m <= 0) return false
        if (n > 16) return false
        if (m > n) return false
        if (n !== chunks.length - 3) return false
        if (allowIncomplete) return true

        var keys = chunks.slice(1, -2)
        return keys.every(bscript.isCanonicalPubKey)
      }
      check.toJSON = function () { return 'multi-sig output' }

      function encode(m, pubKeys) {
        typeforce({
          m: types.Number,
          pubKeys: [bscript.isCanonicalPubKey]
        }, {
          m: m,
          pubKeys: pubKeys
        })

        var n = pubKeys.length
        if (n < m) throw new TypeError('Not enough pubKeys provided')

        return bscript.compile([].concat(
          OP_INT_BASE + m,
          pubKeys,
          OP_INT_BASE + n,
          OPS.OP_CHECKMULTISIG
        ))
      }

      function decode(buffer, allowIncomplete) {
        var chunks = bscript.decompile(buffer)
        typeforce(check, chunks, allowIncomplete)

        return {
          m: chunks[0] - OP_INT_BASE,
          pubKeys: chunks.slice(1, -2)
        }
      }

      module.exports = {
        check: check,
        decode: decode,
        encode: encode
      }

    }, { "../../script": 34, "../../types": 60, "bitcoin-ops": 8, "typeforce": 145 }], 40: [function (require, module, exports) {
      // OP_RETURN {data}

      var bscript = require('../script')
      var types = require('../types')
      var typeforce = require('typeforce')
      var OPS = require('bitcoin-ops')

      function check(script) {
        var buffer = bscript.compile(script)

        return buffer.length > 1 &&
          buffer[0] === OPS.OP_RETURN
      }
      check.toJSON = function () { return 'null data output' }

      function encode(data) {
        // Allow arrays types since decompile returns an array too
        typeforce(typeforce.oneOf(types.Buffer, types.Array), data)

        return bscript.compile([OPS.OP_RETURN].concat(data))
      }

      function decode(buffer) {
        typeforce(check, buffer)

        var chunks = bscript.decompile(buffer)

        chunks.shift()

        return chunks.length === 1 ? chunks[0] : chunks
      }

      module.exports = {
        output: {
          check: check,
          decode: decode,
          encode: encode
        }
      }

    }, { "../script": 34, "../types": 60, "bitcoin-ops": 8, "typeforce": 145 }], 41: [function (require, module, exports) {
      arguments[4][37][0].apply(exports, arguments)
    }, { "./input": 42, "./output": 43, "dup": 37 }], 42: [function (require, module, exports) {
      // {signature}

      var bscript = require('../../script')
      var typeforce = require('typeforce')

      function check(script) {
        var chunks = bscript.decompile(script)

        return chunks.length === 1 &&
          bscript.isCanonicalSignature(chunks[0])
      }
      check.toJSON = function () { return 'pubKey input' }

      function encodeStack(signature) {
        typeforce(bscript.isCanonicalSignature, signature)
        return [signature]
      }

      function encode(signature) {
        return bscript.compile(encodeStack(signature))
      }

      function decodeStack(stack) {
        typeforce(check, stack)
        return stack[0]
      }

      function decode(buffer) {
        var stack = bscript.decompile(buffer)
        return decodeStack(stack)
      }

      module.exports = {
        check: check,
        decode: decode,
        decodeStack: decodeStack,
        encode: encode,
        encodeStack: encodeStack
      }

    }, { "../../script": 34, "typeforce": 145 }], 43: [function (require, module, exports) {
      // {pubKey} OP_CHECKSIG

      var bscript = require('../../script')
      var typeforce = require('typeforce')
      var OPS = require('bitcoin-ops')

      function check(script) {
        var chunks = bscript.decompile(script)

        return chunks.length === 2 &&
          bscript.isCanonicalPubKey(chunks[0]) &&
          chunks[1] === OPS.OP_CHECKSIG
      }
      check.toJSON = function () { return 'pubKey output' }

      function encode(pubKey) {
        typeforce(bscript.isCanonicalPubKey, pubKey)

        return bscript.compile([pubKey, OPS.OP_CHECKSIG])
      }

      function decode(buffer) {
        var chunks = bscript.decompile(buffer)
        typeforce(check, chunks)

        return chunks[0]
      }

      module.exports = {
        check: check,
        decode: decode,
        encode: encode
      }

    }, { "../../script": 34, "bitcoin-ops": 8, "typeforce": 145 }], 44: [function (require, module, exports) {
      arguments[4][37][0].apply(exports, arguments)
    }, { "./input": 45, "./output": 46, "dup": 37 }], 45: [function (require, module, exports) {
      // {signature} {pubKey}

      var bscript = require('../../script')
      var typeforce = require('typeforce')

      function check(script) {
        var chunks = bscript.decompile(script)

        return chunks.length === 2 &&
          bscript.isCanonicalSignature(chunks[0]) &&
          bscript.isCanonicalPubKey(chunks[1])
      }
      check.toJSON = function () { return 'pubKeyHash input' }

      function encodeStack(signature, pubKey) {
        typeforce({
          signature: bscript.isCanonicalSignature,
          pubKey: bscript.isCanonicalPubKey
        }, {
          signature: signature,
          pubKey: pubKey
        })

        return [signature, pubKey]
      }

      function encode(signature, pubKey) {
        return bscript.compile(encodeStack(signature, pubKey))
      }

      function decodeStack(stack) {
        typeforce(check, stack)

        return {
          signature: stack[0],
          pubKey: stack[1]
        }
      }

      function decode(buffer) {
        var stack = bscript.decompile(buffer)
        return decodeStack(stack)
      }

      module.exports = {
        check: check,
        decode: decode,
        decodeStack: decodeStack,
        encode: encode,
        encodeStack: encodeStack
      }

    }, { "../../script": 34, "typeforce": 145 }], 46: [function (require, module, exports) {
      // OP_DUP OP_HASH160 {pubKeyHash} OP_EQUALVERIFY OP_CHECKSIG

      var bscript = require('../../script')
      var types = require('../../types')
      var typeforce = require('typeforce')
      var OPS = require('bitcoin-ops')

      function check(script) {
        var buffer = bscript.compile(script)

        return buffer.length === 25 &&
          buffer[0] === OPS.OP_DUP &&
          buffer[1] === OPS.OP_HASH160 &&
          buffer[2] === 0x14 &&
          buffer[23] === OPS.OP_EQUALVERIFY &&
          buffer[24] === OPS.OP_CHECKSIG
      }
      check.toJSON = function () { return 'pubKeyHash output' }

      function encode(pubKeyHash) {
        typeforce(types.Hash160bit, pubKeyHash)

        return bscript.compile([
          OPS.OP_DUP,
          OPS.OP_HASH160,
          pubKeyHash,
          OPS.OP_EQUALVERIFY,
          OPS.OP_CHECKSIG
        ])
      }

      function decode(buffer) {
        typeforce(check, buffer)

        return buffer.slice(3, 23)
      }

      module.exports = {
        check: check,
        decode: decode,
        encode: encode
      }

    }, { "../../script": 34, "../../types": 60, "bitcoin-ops": 8, "typeforce": 145 }], 47: [function (require, module, exports) {
      arguments[4][37][0].apply(exports, arguments)
    }, { "./input": 48, "./output": 49, "dup": 37 }], 48: [function (require, module, exports) {
      // <scriptSig> {serialized scriptPubKey script}

      var Buffer = require('safe-buffer').Buffer
      var bscript = require('../../script')
      var typeforce = require('typeforce')

      var p2ms = require('../multisig/')
      var p2pk = require('../pubkey/')
      var p2pkh = require('../pubkeyhash/')
      var p2wpkho = require('../witnesspubkeyhash/output')
      var p2wsho = require('../witnessscripthash/output')

      function check(script, allowIncomplete) {
        var chunks = bscript.decompile(script)
        if (chunks.length < 1) return false

        var lastChunk = chunks[chunks.length - 1]
        if (!Buffer.isBuffer(lastChunk)) return false

        var scriptSigChunks = bscript.decompile(bscript.compile(chunks.slice(0, -1)))
        var redeemScriptChunks = bscript.decompile(lastChunk)

        // is redeemScript a valid script?
        if (redeemScriptChunks.length === 0) return false

        // is redeemScriptSig push only?
        if (!bscript.isPushOnly(scriptSigChunks)) return false

        // is witness?
        if (chunks.length === 1) {
          return p2wsho.check(redeemScriptChunks) ||
            p2wpkho.check(redeemScriptChunks)
        }

        // match types
        if (p2pkh.input.check(scriptSigChunks) &&
          p2pkh.output.check(redeemScriptChunks)) return true

        if (p2ms.input.check(scriptSigChunks, allowIncomplete) &&
          p2ms.output.check(redeemScriptChunks)) return true

        if (p2pk.input.check(scriptSigChunks) &&
          p2pk.output.check(redeemScriptChunks)) return true

        return false
      }
      check.toJSON = function () { return 'scriptHash input' }

      function encodeStack(redeemScriptStack, redeemScript) {
        var serializedScriptPubKey = bscript.compile(redeemScript)

        return [].concat(redeemScriptStack, serializedScriptPubKey)
      }

      function encode(redeemScriptSig, redeemScript) {
        var redeemScriptStack = bscript.decompile(redeemScriptSig)

        return bscript.compile(encodeStack(redeemScriptStack, redeemScript))
      }

      function decodeStack(stack) {
        typeforce(check, stack)

        return {
          redeemScriptStack: stack.slice(0, -1),
          redeemScript: stack[stack.length - 1]
        }
      }

      function decode(buffer) {
        var stack = bscript.decompile(buffer)
        var result = decodeStack(stack)
        result.redeemScriptSig = bscript.compile(result.redeemScriptStack)
        delete result.redeemScriptStack
        return result
      }

      module.exports = {
        check: check,
        decode: decode,
        decodeStack: decodeStack,
        encode: encode,
        encodeStack: encodeStack
      }

    }, { "../../script": 34, "../multisig/": 37, "../pubkey/": 41, "../pubkeyhash/": 44, "../witnesspubkeyhash/output": 54, "../witnessscripthash/output": 57, "safe-buffer": 133, "typeforce": 145 }], 49: [function (require, module, exports) {
      // OP_HASH160 {scriptHash} OP_EQUAL

      var bscript = require('../../script')
      var types = require('../../types')
      var typeforce = require('typeforce')
      var OPS = require('bitcoin-ops')

      function check(script) {
        var buffer = bscript.compile(script)

        return buffer.length === 23 &&
          buffer[0] === OPS.OP_HASH160 &&
          buffer[1] === 0x14 &&
          buffer[22] === OPS.OP_EQUAL
      }
      check.toJSON = function () { return 'scriptHash output' }

      function encode(scriptHash) {
        typeforce(types.Hash160bit, scriptHash)

        return bscript.compile([OPS.OP_HASH160, scriptHash, OPS.OP_EQUAL])
      }

      function decode(buffer) {
        typeforce(check, buffer)

        return buffer.slice(2, 22)
      }

      module.exports = {
        check: check,
        decode: decode,
        encode: encode
      }

    }, { "../../script": 34, "../../types": 60, "bitcoin-ops": 8, "typeforce": 145 }], 50: [function (require, module, exports) {
      module.exports = {
        output: require('./output')
      }

    }, { "./output": 51 }], 51: [function (require, module, exports) {
      // OP_RETURN {aa21a9ed} {commitment}

      var Buffer = require('safe-buffer').Buffer
      var bscript = require('../../script')
      var types = require('../../types')
      var typeforce = require('typeforce')
      var OPS = require('bitcoin-ops')

      var HEADER = Buffer.from('aa21a9ed', 'hex')

      function check(script) {
        var buffer = bscript.compile(script)

        return buffer.length > 37 &&
          buffer[0] === OPS.OP_RETURN &&
          buffer[1] === 0x24 &&
          buffer.slice(2, 6).equals(HEADER)
      }

      check.toJSON = function () { return 'Witness commitment output' }

      function encode(commitment) {
        typeforce(types.Hash256bit, commitment)

        var buffer = Buffer.allocUnsafe(36)
        HEADER.copy(buffer, 0)
        commitment.copy(buffer, 4)

        return bscript.compile([OPS.OP_RETURN, buffer])
      }

      function decode(buffer) {
        typeforce(check, buffer)

        return bscript.decompile(buffer)[1].slice(4, 36)
      }

      module.exports = {
        check: check,
        decode: decode,
        encode: encode
      }

    }, { "../../script": 34, "../../types": 60, "bitcoin-ops": 8, "safe-buffer": 133, "typeforce": 145 }], 52: [function (require, module, exports) {
      arguments[4][37][0].apply(exports, arguments)
    }, { "./input": 53, "./output": 54, "dup": 37 }], 53: [function (require, module, exports) {
      // {signature} {pubKey}

      var bscript = require('../../script')
      var typeforce = require('typeforce')

      function isCompressedCanonicalPubKey(pubKey) {
        return bscript.isCanonicalPubKey(pubKey) && pubKey.length === 33
      }

      function check(script) {
        var chunks = bscript.decompile(script)

        return chunks.length === 2 &&
          bscript.isCanonicalSignature(chunks[0]) &&
          isCompressedCanonicalPubKey(chunks[1])
      }
      check.toJSON = function () { return 'witnessPubKeyHash input' }

      function encodeStack(signature, pubKey) {
        typeforce({
          signature: bscript.isCanonicalSignature,
          pubKey: isCompressedCanonicalPubKey
        }, {
          signature: signature,
          pubKey: pubKey
        })

        return [signature, pubKey]
      }

      function decodeStack(stack) {
        typeforce(check, stack)

        return {
          signature: stack[0],
          pubKey: stack[1]
        }
      }

      module.exports = {
        check: check,
        decodeStack: decodeStack,
        encodeStack: encodeStack
      }

    }, { "../../script": 34, "typeforce": 145 }], 54: [function (require, module, exports) {
      // OP_0 {pubKeyHash}

      var bscript = require('../../script')
      var types = require('../../types')
      var typeforce = require('typeforce')
      var OPS = require('bitcoin-ops')

      function check(script) {
        var buffer = bscript.compile(script)

        return buffer.length === 22 &&
          buffer[0] === OPS.OP_0 &&
          buffer[1] === 0x14
      }
      check.toJSON = function () { return 'Witness pubKeyHash output' }

      function encode(pubKeyHash) {
        typeforce(types.Hash160bit, pubKeyHash)

        return bscript.compile([OPS.OP_0, pubKeyHash])
      }

      function decode(buffer) {
        typeforce(check, buffer)

        return buffer.slice(2)
      }

      module.exports = {
        check: check,
        decode: decode,
        encode: encode
      }

    }, { "../../script": 34, "../../types": 60, "bitcoin-ops": 8, "typeforce": 145 }], 55: [function (require, module, exports) {
      arguments[4][37][0].apply(exports, arguments)
    }, { "./input": 56, "./output": 57, "dup": 37 }], 56: [function (require, module, exports) {
      (function (Buffer) {
        (function () {
          // <scriptSig> {serialized scriptPubKey script}

          var bscript = require('../../script')
          var types = require('../../types')
          var typeforce = require('typeforce')

          var p2ms = require('../multisig/')
          var p2pk = require('../pubkey/')
          var p2pkh = require('../pubkeyhash/')

          function check(chunks, allowIncomplete) {
            typeforce(types.Array, chunks)
            if (chunks.length < 1) return false

            var witnessScript = chunks[chunks.length - 1]
            if (!Buffer.isBuffer(witnessScript)) return false

            var witnessScriptChunks = bscript.decompile(witnessScript)

            // is witnessScript a valid script?
            if (witnessScriptChunks.length === 0) return false

            var witnessRawScriptSig = bscript.compile(chunks.slice(0, -1))

            // match types
            if (p2pkh.input.check(witnessRawScriptSig) &&
              p2pkh.output.check(witnessScriptChunks)) return true

            if (p2ms.input.check(witnessRawScriptSig, allowIncomplete) &&
              p2ms.output.check(witnessScriptChunks)) return true

            if (p2pk.input.check(witnessRawScriptSig) &&
              p2pk.output.check(witnessScriptChunks)) return true

            return false
          }
          check.toJSON = function () { return 'witnessScriptHash input' }

          function encodeStack(witnessData, witnessScript) {
            typeforce({
              witnessData: [types.Buffer],
              witnessScript: types.Buffer
            }, {
              witnessData: witnessData,
              witnessScript: witnessScript
            })

            return [].concat(witnessData, witnessScript)
          }

          function decodeStack(chunks) {
            typeforce(check, chunks)
            return {
              witnessData: chunks.slice(0, -1),
              witnessScript: chunks[chunks.length - 1]
            }
          }

          module.exports = {
            check: check,
            decodeStack: decodeStack,
            encodeStack: encodeStack
          }

        }).call(this)
      }).call(this, { "isBuffer": require("../../../../../../../../../usr/lib/node_modules/browserify/node_modules/is-buffer/index.js") })
    }, { "../../../../../../../../../usr/lib/node_modules/browserify/node_modules/is-buffer/index.js": 286, "../../script": 34, "../../types": 60, "../multisig/": 37, "../pubkey/": 41, "../pubkeyhash/": 44, "typeforce": 145 }], 57: [function (require, module, exports) {
      // OP_0 {scriptHash}

      var bscript = require('../../script')
      var types = require('../../types')
      var typeforce = require('typeforce')
      var OPS = require('bitcoin-ops')

      function check(script) {
        var buffer = bscript.compile(script)

        return buffer.length === 34 &&
          buffer[0] === OPS.OP_0 &&
          buffer[1] === 0x20
      }
      check.toJSON = function () { return 'Witness scriptHash output' }

      function encode(scriptHash) {
        typeforce(types.Hash256bit, scriptHash)

        return bscript.compile([OPS.OP_0, scriptHash])
      }

      function decode(buffer) {
        typeforce(check, buffer)

        return buffer.slice(2)
      }

      module.exports = {
        check: check,
        decode: decode,
        encode: encode
      }

    }, { "../../script": 34, "../../types": 60, "bitcoin-ops": 8, "typeforce": 145 }], 58: [function (require, module, exports) {
      var Buffer = require('safe-buffer').Buffer
      var BufferWriter = require('./bufferWriter')
      var bcrypto = require('./crypto')
      var bscript = require('./script')
      var bufferutils = require('./bufferutils')
      var coins = require('./coins')
      var opcodes = require('bitcoin-ops')
      var networks = require('./networks')
      var typeforce = require('typeforce')
      var types = require('./types')
      var varuint = require('varuint-bitcoin')
      var blake2b = require('blake2b')

      function varSliceSize(someScript) {
        var length = someScript.length

        return varuint.encodingLength(length) + length
      }

      function vectorSize(someVector) {
        var length = someVector.length

        return varuint.encodingLength(length) + someVector.reduce(function (sum, witness) {
          return sum + varSliceSize(witness)
        }, 0)
      }

      // By default, assume is a bitcoin transaction
      function Transaction(network = networks.bitcoin) {
        this.version = 1
        this.locktime = 0
        this.ins = []
        this.outs = []
        this.network = network
        if (coins.isZcash(network)) {
          // ZCash version >= 2
          this.joinsplits = []
          this.joinsplitPubkey = []
          this.joinsplitSig = []
          // ZCash version >= 3
          this.overwintered = 0  // 1 if the transaction is post overwinter upgrade, 0 otherwise
          this.versionGroupId = 0  // 0x03C48270 (63210096) for overwinter and 0x892F2085 (2301567109) for sapling
          this.expiryHeight = 0  // Block height after which this transactions will expire, or 0 to disable expiry
          // ZCash version >= 4
          this.valueBalance = 0
          this.vShieldedSpend = []
          this.vShieldedOutput = []
          this.bindingSig = 0
        }
        if (coins.isDash(network)) {
          // Dash version = 3
          this.type = 0
          this.extraPayload = Buffer.alloc(0)
        }
      }

      Transaction.DEFAULT_SEQUENCE = 0xffffffff
      Transaction.SIGHASH_ALL = 0x01
      Transaction.SIGHASH_NONE = 0x02
      Transaction.SIGHASH_SINGLE = 0x03
      Transaction.SIGHASH_ANYONECANPAY = 0x80
      Transaction.SIGHASH_BITCOINCASHBIP143 = 0x40
      Transaction.ADVANCED_TRANSACTION_MARKER = 0x00
      Transaction.ADVANCED_TRANSACTION_FLAG = 0x01

      var EMPTY_SCRIPT = Buffer.allocUnsafe(0)
      var EMPTY_WITNESS = []
      var ZERO = Buffer.from('0000000000000000000000000000000000000000000000000000000000000000', 'hex')
      var ONE = Buffer.from('0000000000000000000000000000000000000000000000000000000000000001', 'hex')
      // Used to represent the absence of a value
      var VALUE_UINT64_MAX = Buffer.from('ffffffffffffffff', 'hex')
      var BLANK_OUTPUT = {
        script: EMPTY_SCRIPT,
        valueBuffer: VALUE_UINT64_MAX
      }

      Transaction.ZCASH_OVERWINTER_VERSION = 3
      Transaction.ZCASH_SAPLING_VERSION = 4
      Transaction.ZCASH_JOINSPLITS_SUPPORT_VERSION = 2
      Transaction.ZCASH_NUM_JOINSPLITS_INPUTS = 2
      Transaction.ZCASH_NUM_JOINSPLITS_OUTPUTS = 2
      Transaction.ZCASH_NOTECIPHERTEXT_SIZE = 1 + 8 + 32 + 32 + 512 + 16

      Transaction.ZCASH_G1_PREFIX_MASK = 0x02
      Transaction.ZCASH_G2_PREFIX_MASK = 0x0a

      Transaction.DASH_NORMAL = 0
      Transaction.DASH_PROVIDER_REGISTER = 1
      Transaction.DASH_PROVIDER_UPDATE_SERVICE = 2
      Transaction.DASH_PROVIDER_UPDATE_REGISTRAR = 3
      Transaction.DASH_PROVIDER_UPDATE_REVOKE = 4
      Transaction.DASH_COINBASE = 5
      Transaction.DASH_QUORUM_COMMITMENT = 6

      Transaction.fromBuffer = function (buffer, network = networks.bitcoin, __noStrict) {
        var offset = 0
        function readSlice(n) {
          offset += n
          return buffer.slice(offset - n, offset)
        }

        function readUInt8() {
          var i = buffer.readUInt8(offset)
          offset += 1
          return i
        }

        function readUInt32() {
          var i = buffer.readUInt32LE(offset)
          offset += 4
          return i
        }

        function readInt32() {
          var i = buffer.readInt32LE(offset)
          offset += 4
          return i
        }

        function readInt64() {
          var i = bufferutils.readInt64LE(buffer, offset)
          offset += 8
          return i
        }

        function readUInt64() {
          var i = bufferutils.readUInt64LE(buffer, offset)
          offset += 8
          return i
        }

        function readVarInt() {
          var vi = varuint.decode(buffer, offset)
          offset += varuint.decode.bytes
          return vi
        }

        function readVarSlice() {
          return readSlice(readVarInt())
        }

        function readVector() {
          var count = readVarInt()
          var vector = []
          for (var i = 0; i < count; i++) vector.push(readVarSlice())
          return vector
        }

        function readCompressedG1() {
          var yLsb = readUInt8() & 1
          var x = readSlice(32)
          return {
            x: x,
            yLsb: yLsb
          }
        }

        function readCompressedG2() {
          var yLsb = readUInt8() & 1
          var x = readSlice(64)
          return {
            x: x,
            yLsb: yLsb
          }
        }

        function readZKProof() {
          var zkproof
          if (tx.isSaplingCompatible()) {
            zkproof = {
              sA: readSlice(48),
              sB: readSlice(96),
              sC: readSlice(48)
            }
          } else {
            zkproof = {
              gA: readCompressedG1(),
              gAPrime: readCompressedG1(),
              gB: readCompressedG2(),
              gBPrime: readCompressedG1(),
              gC: readCompressedG1(),
              gCPrime: readCompressedG1(),
              gK: readCompressedG1(),
              gH: readCompressedG1()
            }
          }
          return zkproof
        }

        function readJoinSplit() {
          var vpubOld = readUInt64()
          var vpubNew = readUInt64()
          var anchor = readSlice(32)
          var nullifiers = []
          for (var j = 0; j < Transaction.ZCASH_NUM_JOINSPLITS_INPUTS; j++) {
            nullifiers.push(readSlice(32))
          }
          var commitments = []
          for (j = 0; j < Transaction.ZCASH_NUM_JOINSPLITS_OUTPUTS; j++) {
            commitments.push(readSlice(32))
          }
          var ephemeralKey = readSlice(32)
          var randomSeed = readSlice(32)
          var macs = []
          for (j = 0; j < Transaction.ZCASH_NUM_JOINSPLITS_INPUTS; j++) {
            macs.push(readSlice(32))
          }

          var zkproof = readZKProof()
          var ciphertexts = []
          for (j = 0; j < Transaction.ZCASH_NUM_JOINSPLITS_OUTPUTS; j++) {
            ciphertexts.push(readSlice(Transaction.ZCASH_NOTECIPHERTEXT_SIZE))
          }
          return {
            vpubOld: vpubOld,
            vpubNew: vpubNew,
            anchor: anchor,
            nullifiers: nullifiers,
            commitments: commitments,
            ephemeralKey: ephemeralKey,
            randomSeed: randomSeed,
            macs: macs,
            zkproof: zkproof,
            ciphertexts: ciphertexts
          }
        }

        function readShieldedSpend() {
          var cv = readSlice(32)
          var anchor = readSlice(32)
          var nullifier = readSlice(32)
          var rk = readSlice(32)
          var zkproof = readZKProof()
          var spendAuthSig = readSlice(64)
          return {
            cv: cv,
            anchor: anchor,
            nullifier: nullifier,
            rk: rk,
            zkproof: zkproof,
            spendAuthSig: spendAuthSig
          }
        }

        function readShieldedOutput() {
          var cv = readSlice(32)
          var cmu = readSlice(32)
          var ephemeralKey = readSlice(32)
          var encCiphertext = readSlice(580)
          var outCiphertext = readSlice(80)
          var zkproof = readZKProof()

          return {
            cv: cv,
            cmu: cmu,
            ephemeralKey: ephemeralKey,
            encCiphertext: encCiphertext,
            outCiphertext: outCiphertext,
            zkproof: zkproof
          }
        }
        var tx = new Transaction(network)
        tx.version = readInt32()

        if (coins.isZcash(network)) {
          // Split the header into fOverwintered and nVersion
          tx.overwintered = tx.version >>> 31  // Must be 1 for version 3 and up
          tx.version = tx.version & 0x07FFFFFFF  // 3 for overwinter
          if (!network.consensusBranchId.hasOwnProperty(tx.version)) {
            throw new Error('Unsupported Zcash transaction')
          }
        }

        if (coins.isDash(network)) {
          tx.type = tx.version >> 16
          tx.version = tx.version & 0xffff
          if (tx.version === 3 && (tx.type < Transaction.DASH_NORMAL || tx.type > Transaction.DASH_QUORUM_COMMITMENT)) {
            throw new Error('Unsupported Dash transaction type')
          }
        }

        var marker = buffer.readUInt8(offset)
        var flag = buffer.readUInt8(offset + 1)

        var hasWitnesses = false
        if (marker === Transaction.ADVANCED_TRANSACTION_MARKER &&
          flag === Transaction.ADVANCED_TRANSACTION_FLAG &&
          !coins.isZcash(network)) {
          offset += 2
          hasWitnesses = true
        }

        if (tx.isOverwinterCompatible()) {
          tx.versionGroupId = readUInt32()
        }

        var vinLen = readVarInt()
        for (var i = 0; i < vinLen; ++i) {
          tx.ins.push({
            hash: readSlice(32),
            index: readUInt32(),
            script: readVarSlice(),
            sequence: readUInt32(),
            witness: EMPTY_WITNESS
          })
        }

        var voutLen = readVarInt()
        for (i = 0; i < voutLen; ++i) {
          tx.outs.push({
            value: readUInt64(),
            script: readVarSlice()
          })
        }

        if (hasWitnesses) {
          for (i = 0; i < vinLen; ++i) {
            tx.ins[i].witness = readVector()
          }

          // was this pointless?
          if (!tx.hasWitnesses()) throw new Error('Transaction has superfluous witness data')
        }

        tx.locktime = readUInt32()

        if (coins.isZcash(network)) {
          if (tx.isOverwinterCompatible()) {
            tx.expiryHeight = readUInt32()
          }

          if (tx.isSaplingCompatible()) {
            tx.valueBalance = readInt64()
            var nShieldedSpend = readVarInt()
            for (i = 0; i < nShieldedSpend; ++i) {
              tx.vShieldedSpend.push(readShieldedSpend())
            }

            var nShieldedOutput = readVarInt()
            for (i = 0; i < nShieldedOutput; ++i) {
              tx.vShieldedOutput.push(readShieldedOutput())
            }
          }

          if (tx.supportsJoinSplits()) {
            var joinSplitsLen = readVarInt()
            for (i = 0; i < joinSplitsLen; ++i) {
              tx.joinsplits.push(readJoinSplit())
            }
            if (joinSplitsLen > 0) {
              tx.joinsplitPubkey = readSlice(32)
              tx.joinsplitSig = readSlice(64)
            }
          }

          if (tx.isSaplingCompatible() &&
            tx.vShieldedSpend.length + tx.vShieldedOutput.length > 0) {
            tx.bindingSig = readSlice(64)
          }
        }

        if (tx.isDashSpecialTransaction()) {
          tx.extraPayload = readVarSlice()
        }

        tx.network = network

        if (__noStrict) return tx
        if (offset !== buffer.length) throw new Error('Transaction has unexpected data')

        return tx
      }

      Transaction.fromHex = function (hex, network) {
        return Transaction.fromBuffer(Buffer.from(hex, 'hex'), network)
      }

      Transaction.isCoinbaseHash = function (buffer) {
        typeforce(types.Hash256bit, buffer)
        for (var i = 0; i < 32; ++i) {
          if (buffer[i] !== 0) return false
        }
        return true
      }

      Transaction.prototype.isSaplingCompatible = function () {
        return coins.isZcash(this.network) && this.version >= Transaction.ZCASH_SAPLING_VERSION
      }

      Transaction.prototype.isOverwinterCompatible = function () {
        return coins.isZcash(this.network) && this.version >= Transaction.ZCASH_OVERWINTER_VERSION
      }

      Transaction.prototype.supportsJoinSplits = function () {
        return coins.isZcash(this.network) && this.version >= Transaction.ZCASH_JOINSPLITS_SUPPORT_VERSION
      }

      Transaction.prototype.versionSupportsDashSpecialTransactions = function () {
        return coins.isDash(this.network) && this.version >= 3
      }

      Transaction.prototype.isDashSpecialTransaction = function () {
        return this.versionSupportsDashSpecialTransactions() && this.type !== Transaction.DASH_NORMAL
      }

      Transaction.prototype.isCoinbase = function () {
        return this.ins.length === 1 && Transaction.isCoinbaseHash(this.ins[0].hash)
      }

      Transaction.prototype.addInput = function (hash, index, sequence, scriptSig) {
        typeforce(types.tuple(
          types.Hash256bit,
          types.UInt32,
          types.maybe(types.UInt32),
          types.maybe(types.Buffer)
        ), arguments)

        if (types.Null(sequence)) {
          sequence = Transaction.DEFAULT_SEQUENCE
        }

        // Add the input and return the input's index
        return (this.ins.push({
          hash: hash,
          index: index,
          script: scriptSig || EMPTY_SCRIPT,
          sequence: sequence,
          witness: EMPTY_WITNESS
        }) - 1)
      }

      Transaction.prototype.addOutput = function (scriptPubKey, value) {
        typeforce(types.tuple(types.Buffer, types.Satoshi), arguments)

        // Add the output and return the output's index
        return (this.outs.push({
          script: scriptPubKey,
          value: value
        }) - 1)
      }

      Transaction.prototype.hasWitnesses = function () {
        return this.ins.some(function (x) {
          return x.witness.length !== 0
        })
      }

      Transaction.prototype.weight = function () {
        var base = this.__byteLength(false)
        var total = this.__byteLength(true)
        return base * 3 + total
      }

      Transaction.prototype.virtualSize = function () {
        return Math.ceil(this.weight() / 4)
      }

      Transaction.prototype.byteLength = function () {
        return this.__byteLength(true)
      }

      Transaction.prototype.getShieldedSpendByteLength = function () {
        if (!this.isSaplingCompatible()) {
          return 0
        }

        var byteLength = 0
        byteLength += varuint.encodingLength(this.vShieldedSpend.length)  // nShieldedSpend
        byteLength += (384 * this.vShieldedSpend.length)  // vShieldedSpend
        return byteLength
      }

      Transaction.prototype.getShieldedOutputByteLength = function () {
        if (!this.isSaplingCompatible()) {
          return 0
        }
        var byteLength = 0
        byteLength += varuint.encodingLength(this.vShieldedOutput.length)  // nShieldedOutput
        byteLength += (948 * this.vShieldedOutput.length)  // vShieldedOutput
        return byteLength
      }

      Transaction.prototype.getJoinSplitByteLength = function () {
        if (!this.supportsJoinSplits()) {
          return 0
        }
        var joinSplitsLen = this.joinsplits.length
        var byteLength = 0
        byteLength += bufferutils.varIntSize(joinSplitsLen)  // vJoinSplit

        if (joinSplitsLen > 0) {
          // Both pre and post Sapling JoinSplits are encoded with the following data:
          // 8 vpub_old, 8 vpub_new, 32 anchor, joinSplitsLen * 32 nullifiers, joinSplitsLen * 32 commitments, 32 ephemeralKey
          // 32 ephemeralKey, 32 randomSeed, joinsplit.macs.length * 32 vmacs
          if (this.isSaplingCompatible()) {
            byteLength += 1698 * joinSplitsLen  // vJoinSplit using JSDescriptionGroth16
          } else {
            byteLength += 1802 * joinSplitsLen  // vJoinSplit using JSDescriptionPHGR13
          }
          byteLength += 32  // joinSplitPubKey
          byteLength += 64  // joinSplitSig
        }

        return byteLength
      }

      Transaction.prototype.zcashTransactionByteLength = function () {
        if (!coins.isZcash(this.network)) {
          throw new Error('zcashTransactionByteLength can only be called when using Zcash network')
        }
        var byteLength = 0
        byteLength += 4  // Header
        if (this.isOverwinterCompatible()) {
          byteLength += 4  // nVersionGroupId
        }
        byteLength += varuint.encodingLength(this.ins.length)  // tx_in_count
        byteLength += this.ins.reduce(function (sum, input) { return sum + 40 + varSliceSize(input.script) }, 0)  // tx_in
        byteLength += varuint.encodingLength(this.outs.length)  // tx_out_count
        byteLength += this.outs.reduce(function (sum, output) { return sum + 8 + varSliceSize(output.script) }, 0)  // tx_out
        byteLength += 4  // lock_time
        if (this.isOverwinterCompatible()) {
          byteLength += 4  // nExpiryHeight
        }
        if (this.isSaplingCompatible()) {
          byteLength += 8  // valueBalance
          byteLength += this.getShieldedSpendByteLength()
          byteLength += this.getShieldedOutputByteLength()
        }
        if (this.supportsJoinSplits()) {
          byteLength += this.getJoinSplitByteLength()
        }
        if (this.isSaplingCompatible() &&
          this.vShieldedSpend.length + this.vShieldedOutput.length > 0) {
          byteLength += 64  // bindingSig
        }
        return byteLength
      }

      Transaction.prototype.__byteLength = function (__allowWitness) {
        var hasWitnesses = __allowWitness && this.hasWitnesses()

        if (coins.isZcash(this.network)) {
          return this.zcashTransactionByteLength()
        }

        return (
          (hasWitnesses ? 10 : 8) +
          varuint.encodingLength(this.ins.length) +
          varuint.encodingLength(this.outs.length) +
          this.ins.reduce(function (sum, input) { return sum + 40 + varSliceSize(input.script) }, 0) +
          this.outs.reduce(function (sum, output) { return sum + 8 + varSliceSize(output.script) }, 0) +
          (this.isDashSpecialTransaction() ? varSliceSize(this.extraPayload) : 0) +
          (hasWitnesses ? this.ins.reduce(function (sum, input) { return sum + vectorSize(input.witness) }, 0) : 0)
        )
      }

      Transaction.prototype.clone = function () {
        var newTx = new Transaction(this.network)
        newTx.version = this.version
        newTx.locktime = this.locktime
        newTx.network = this.network

        if (coins.isDash(this.network)) {
          newTx.type = this.type
          newTx.extraPayload = this.extraPayload
        }

        if (this.isOverwinterCompatible()) {
          newTx.overwintered = this.overwintered
          newTx.versionGroupId = this.versionGroupId
          newTx.expiryHeight = this.expiryHeight
        }
        if (this.isSaplingCompatible()) {
          newTx.valueBalance = this.valueBalance
        }

        newTx.ins = this.ins.map(function (txIn) {
          return {
            hash: txIn.hash,
            index: txIn.index,
            script: txIn.script,
            sequence: txIn.sequence,
            witness: txIn.witness
          }
        })

        newTx.outs = this.outs.map(function (txOut) {
          return {
            script: txOut.script,
            value: txOut.value
          }
        })
        if (this.isSaplingCompatible()) {
          newTx.vShieldedSpend = this.vShieldedSpend.map(function (shieldedSpend) {
            return {
              cv: shieldedSpend.cv,
              anchor: shieldedSpend.anchor,
              nullifier: shieldedSpend.nullifier,
              rk: shieldedSpend.rk,
              zkproof: shieldedSpend.zkproof,
              spendAuthSig: shieldedSpend.spendAuthSig
            }
          })

          newTx.vShieldedOutput = this.vShieldedOutput.map(function (shieldedOutput) {
            return {
              cv: shieldedOutput.cv,
              cmu: shieldedOutput.cmu,
              ephemeralKey: shieldedOutput.ephemeralKey,
              encCiphertext: shieldedOutput.encCiphertext,
              outCiphertext: shieldedOutput.outCiphertext,
              zkproof: shieldedOutput.zkproof
            }
          })
        }

        if (this.supportsJoinSplits()) {
          newTx.joinsplits = this.joinsplits.map(function (txJoinsplit) {
            return {
              vpubOld: txJoinsplit.vpubOld,
              vpubNew: txJoinsplit.vpubNew,
              anchor: txJoinsplit.anchor,
              nullifiers: txJoinsplit.nullifiers,
              commitments: txJoinsplit.commitments,
              ephemeralKey: txJoinsplit.ephemeralKey,
              randomSeed: txJoinsplit.randomSeed,
              macs: txJoinsplit.macs,
              zkproof: txJoinsplit.zkproof,
              ciphertexts: txJoinsplit.ciphertexts
            }
          })

          newTx.joinsplitPubkey = this.joinsplitPubkey
          newTx.joinsplitSig = this.joinsplitSig
        }

        if (this.isSaplingCompatible() && this.vShieldedSpend.length + this.vShieldedOutput.length > 0) {
          newTx.bindingSig = this.bindingSig
        }

        return newTx
      }

      /**
       * Get Zcash header or version
       * @returns {number}
       */
      Transaction.prototype.getHeader = function () {
        var mask = (this.overwintered ? 1 : 0)
        var header = this.version | (mask << 31)
        return header
      }

      /**
       * Hash transaction for signing a specific input.
       *
       * Bitcoin uses a different hash for each signed transaction input.
       * This method copies the transaction, makes the necessary changes based on the
       * hashType, and then hashes the result.
       * This hash can then be used to sign the provided transaction input.
       */
      Transaction.prototype.hashForSignature = function (inIndex, prevOutScript, hashType) {
        typeforce(types.tuple(types.UInt32, types.Buffer, /* types.UInt8 */ types.Number), arguments)

        // https://github.com/bitcoin/bitcoin/blob/master/src/test/sighash_tests.cpp#L29
        if (inIndex >= this.ins.length) return ONE

        // ignore OP_CODESEPARATOR
        var ourScript = bscript.compile(bscript.decompile(prevOutScript).filter(function (x) {
          return x !== opcodes.OP_CODESEPARATOR
        }))

        var txTmp = this.clone()

        // SIGHASH_NONE: ignore all outputs? (wildcard payee)
        if ((hashType & 0x1f) === Transaction.SIGHASH_NONE) {
          txTmp.outs = []

          // ignore sequence numbers (except at inIndex)
          txTmp.ins.forEach(function (input, i) {
            if (i === inIndex) return

            input.sequence = 0
          })

          // SIGHASH_SINGLE: ignore all outputs, except at the same index?
        } else if ((hashType & 0x1f) === Transaction.SIGHASH_SINGLE) {
          // https://github.com/bitcoin/bitcoin/blob/master/src/test/sighash_tests.cpp#L60
          if (inIndex >= this.outs.length) return ONE

          // truncate outputs after
          txTmp.outs.length = inIndex + 1

          // "blank" outputs before
          for (var i = 0; i < inIndex; i++) {
            txTmp.outs[i] = BLANK_OUTPUT
          }

          // ignore sequence numbers (except at inIndex)
          txTmp.ins.forEach(function (input, y) {
            if (y === inIndex) return

            input.sequence = 0
          })
        }

        // SIGHASH_ANYONECANPAY: ignore inputs entirely?
        if (hashType & Transaction.SIGHASH_ANYONECANPAY) {
          txTmp.ins = [txTmp.ins[inIndex]]
          txTmp.ins[0].script = ourScript

          // SIGHASH_ALL: only ignore input scripts
        } else {
          // "blank" others input scripts
          txTmp.ins.forEach(function (input) { input.script = EMPTY_SCRIPT })
          txTmp.ins[inIndex].script = ourScript
        }

        // serialize and hash
        var buffer = Buffer.allocUnsafe(txTmp.__byteLength(false) + 4)
        buffer.writeInt32LE(hashType, buffer.length - 4)
        txTmp.__toBuffer(buffer, 0, false)

        return bcrypto.hash256(buffer)
      }

      /**
       * Blake2b hashing algorithm for Zcash
       * @param bufferToHash
       * @param personalization
       * @returns 256-bit BLAKE2b hash
       */
      Transaction.prototype.getBlake2bHash = function (bufferToHash, personalization) {
        var out = Buffer.allocUnsafe(32)
        return blake2b(out.length, null, null, Buffer.from(personalization)).update(bufferToHash).digest(out)
      }

      /**
       * Build a hash for all or none of the transaction inputs depending on the hashtype
       * @param hashType
       * @returns double SHA-256, 256-bit BLAKE2b hash or 256-bit zero if doesn't apply
       */
      Transaction.prototype.getPrevoutHash = function (hashType) {
        if (!(hashType & Transaction.SIGHASH_ANYONECANPAY)) {
          var bufferWriter = new BufferWriter(36 * this.ins.length)

          this.ins.forEach(function (txIn) {
            bufferWriter.writeSlice(txIn.hash)
            bufferWriter.writeUInt32(txIn.index)
          })

          if (coins.isZcash(this.network)) {
            return this.getBlake2bHash(bufferWriter.getBuffer(), 'ZcashPrevoutHash')
          }
          return bcrypto.hash256(bufferWriter.getBuffer())
        }
        return ZERO
      }

      /**
       * Build a hash for all or none of the transactions inputs sequence numbers depending on the hashtype
       * @param hashType
       * @returns double SHA-256, 256-bit BLAKE2b hash or 256-bit zero if doesn't apply
       */
      Transaction.prototype.getSequenceHash = function (hashType) {
        if (!(hashType & Transaction.SIGHASH_ANYONECANPAY) &&
          (hashType & 0x1f) !== Transaction.SIGHASH_SINGLE &&
          (hashType & 0x1f) !== Transaction.SIGHASH_NONE) {
          var bufferWriter = new BufferWriter(4 * this.ins.length)

          this.ins.forEach(function (txIn) {
            bufferWriter.writeUInt32(txIn.sequence)
          })

          if (coins.isZcash(this.network)) {
            return this.getBlake2bHash(bufferWriter.getBuffer(), 'ZcashSequencHash')
          }
          return bcrypto.hash256(bufferWriter.getBuffer())
        }
        return ZERO
      }

      /**
       * Build a hash for one, all or none of the transaction outputs depending on the hashtype
       * @param hashType
       * @param inIndex
       * @returns double SHA-256, 256-bit BLAKE2b hash or 256-bit zero if doesn't apply
       */
      Transaction.prototype.getOutputsHash = function (hashType, inIndex) {
        var bufferWriter
        if ((hashType & 0x1f) !== Transaction.SIGHASH_SINGLE && (hashType & 0x1f) !== Transaction.SIGHASH_NONE) {
          // Find out the size of the outputs and write them
          var txOutsSize = this.outs.reduce(function (sum, output) {
            return sum + 8 + varSliceSize(output.script)
          }, 0)

          bufferWriter = new BufferWriter(txOutsSize)

          this.outs.forEach(function (out) {
            bufferWriter.writeUInt64(out.value)
            bufferWriter.writeVarSlice(out.script)
          })

          if (coins.isZcash(this.network)) {
            return this.getBlake2bHash(bufferWriter.getBuffer(), 'ZcashOutputsHash')
          }
          return bcrypto.hash256(bufferWriter.getBuffer())
        } else if ((hashType & 0x1f) === Transaction.SIGHASH_SINGLE && inIndex < this.outs.length) {
          // Write only the output specified in inIndex
          var output = this.outs[inIndex]

          bufferWriter = new BufferWriter(8 + varSliceSize(output.script))
          bufferWriter.writeUInt64(output.value)
          bufferWriter.writeVarSlice(output.script)

          if (coins.isZcash(this.network)) {
            return this.getBlake2bHash(bufferWriter.getBuffer(), 'ZcashOutputsHash')
          }
          return bcrypto.hash256(bufferWriter.getBuffer())
        }
        return ZERO
      }

      /**
       * Hash transaction for signing a transparent transaction in Zcash. Protected transactions are not supported.
       * @param inIndex
       * @param prevOutScript
       * @param value
       * @param hashType
       * @returns double SHA-256 or 256-bit BLAKE2b hash
       */
      Transaction.prototype.hashForZcashSignature = function (inIndex, prevOutScript, value, hashType) {
        typeforce(types.tuple(types.UInt32, types.Buffer, types.Satoshi, types.UInt32), arguments)
        if (!coins.isZcash(this.network)) {
          throw new Error('hashForZcashSignature can only be called when using Zcash network')
        }
        if (this.joinsplits.length > 0) {
          throw new Error('Hash signature for Zcash protected transactions is not supported')
        }

        if (inIndex >= this.ins.length && inIndex !== VALUE_UINT64_MAX) {
          throw new Error('Input index is out of range')
        }

        if (this.isOverwinterCompatible()) {
          var hashPrevouts = this.getPrevoutHash(hashType)
          var hashSequence = this.getSequenceHash(hashType)
          var hashOutputs = this.getOutputsHash(hashType, inIndex)
          var hashJoinSplits = ZERO
          var hashShieldedSpends = ZERO
          var hashShieldedOutputs = ZERO

          var bufferWriter
          var baseBufferSize = 0
          baseBufferSize += 4 * 5  // header, nVersionGroupId, lock_time, nExpiryHeight, hashType
          baseBufferSize += 32 * 4  // 256 hashes: hashPrevouts, hashSequence, hashOutputs, hashJoinSplits
          if (inIndex !== VALUE_UINT64_MAX) {
            // If this hash is for a transparent input signature (i.e. not for txTo.joinSplitSig), we need extra space
            baseBufferSize += 4 * 2  // input.index, input.sequence
            baseBufferSize += 8  // value
            baseBufferSize += 32  // input.hash
            baseBufferSize += varSliceSize(prevOutScript)  // prevOutScript
          }
          if (this.isSaplingCompatible()) {
            baseBufferSize += 32 * 2  // hashShieldedSpends and hashShieldedOutputs
            baseBufferSize += 8  // valueBalance
          }
          bufferWriter = new BufferWriter(baseBufferSize)

          bufferWriter.writeInt32(this.getHeader())
          bufferWriter.writeUInt32(this.versionGroupId)
          bufferWriter.writeSlice(hashPrevouts)
          bufferWriter.writeSlice(hashSequence)
          bufferWriter.writeSlice(hashOutputs)
          bufferWriter.writeSlice(hashJoinSplits)
          if (this.isSaplingCompatible()) {
            bufferWriter.writeSlice(hashShieldedSpends)
            bufferWriter.writeSlice(hashShieldedOutputs)
          }
          bufferWriter.writeUInt32(this.locktime)
          bufferWriter.writeUInt32(this.expiryHeight)
          if (this.isSaplingCompatible()) {
            bufferWriter.writeUInt64(this.valueBalance)
          }
          bufferWriter.writeUInt32(hashType)

          // If this hash is for a transparent input signature (i.e. not for txTo.joinSplitSig):
          if (inIndex !== VALUE_UINT64_MAX) {
            // The input being signed (replacing the scriptSig with scriptCode + amount)
            // The prevout may already be contained in hashPrevout, and the nSequence
            // may already be contained in hashSequence.
            var input = this.ins[inIndex]
            bufferWriter.writeSlice(input.hash)
            bufferWriter.writeUInt32(input.index)
            bufferWriter.writeVarSlice(prevOutScript)
            bufferWriter.writeUInt64(value)
            bufferWriter.writeUInt32(input.sequence)
          }

          var personalization = Buffer.alloc(16)
          var prefix = 'ZcashSigHash'
          personalization.write(prefix)
          personalization.writeUInt32LE(this.network.consensusBranchId[this.version], prefix.length)

          return this.getBlake2bHash(bufferWriter.getBuffer(), personalization)
        }
        // TODO: support non overwinter transactions
      }

      Transaction.prototype.hashForWitnessV0 = function (inIndex, prevOutScript, value, hashType) {
        typeforce(types.tuple(types.UInt32, types.Buffer, types.Satoshi, types.UInt32), arguments)

        var hashPrevouts = this.getPrevoutHash(hashType)
        var hashSequence = this.getSequenceHash(hashType)
        var hashOutputs = this.getOutputsHash(hashType, inIndex)

        var bufferWriter = new BufferWriter(156 + varSliceSize(prevOutScript))
        var input = this.ins[inIndex]
        bufferWriter.writeUInt32(this.version)
        bufferWriter.writeSlice(hashPrevouts)
        bufferWriter.writeSlice(hashSequence)
        bufferWriter.writeSlice(input.hash)
        bufferWriter.writeUInt32(input.index)
        bufferWriter.writeVarSlice(prevOutScript)
        bufferWriter.writeUInt64(value)
        bufferWriter.writeUInt32(input.sequence)
        bufferWriter.writeSlice(hashOutputs)
        bufferWriter.writeUInt32(this.locktime)
        bufferWriter.writeUInt32(hashType)
        return bcrypto.hash256(bufferWriter.getBuffer())
      }

      /**
       * Hash transaction for signing a specific input for Bitcoin Cash.
       */
      Transaction.prototype.hashForCashSignature = function (inIndex, prevOutScript, inAmount, hashType) {
        typeforce(types.tuple(types.UInt32, types.Buffer, /* types.UInt8 */ types.Number, types.maybe(types.UInt53)), arguments)

        // This function works the way it does because Bitcoin Cash
        // uses BIP143 as their replay protection, AND their algo
        // includes `forkId | hashType`, AND since their forkId=0,
        // this is a NOP, and has no difference to segwit. To support
        // other forks, another parameter is required, and a new parameter
        // would be required in the hashForWitnessV0 function, or
        // it could be broken into two..

        // BIP143 sighash activated in BitcoinCash via 0x40 bit
        if (hashType & Transaction.SIGHASH_BITCOINCASHBIP143) {
          if (types.Null(inAmount)) {
            throw new Error('Bitcoin Cash sighash requires value of input to be signed.')
          }
          return this.hashForWitnessV0(inIndex, prevOutScript, inAmount, hashType)
        } else {
          return this.hashForSignature(inIndex, prevOutScript, hashType)
        }
      }

      /**
       * Hash transaction for signing a specific input for Bitcoin Gold.
       */
      Transaction.prototype.hashForGoldSignature = function (inIndex, prevOutScript, inAmount, hashType, sigVersion) {
        typeforce(types.tuple(types.UInt32, types.Buffer, /* types.UInt8 */ types.Number, types.maybe(types.UInt53)), arguments)

        // Bitcoin Gold also implements segregated witness
        // therefore we can pull out the setting of nForkHashType
        // and pass it into the functions.

        var nForkHashType = hashType
        var fUseForkId = (hashType & Transaction.SIGHASH_BITCOINCASHBIP143) > 0
        if (fUseForkId) {
          nForkHashType |= this.network.forkId << 8
        }

        // BIP143 sighash activated in BitcoinCash via 0x40 bit
        if (sigVersion || fUseForkId) {
          if (types.Null(inAmount)) {
            throw new Error('Bitcoin Cash sighash requires value of input to be signed.')
          }
          return this.hashForWitnessV0(inIndex, prevOutScript, inAmount, nForkHashType)
        } else {
          return this.hashForSignature(inIndex, prevOutScript, nForkHashType)
        }
      }

      Transaction.prototype.getHash = function () {
        return bcrypto.hash256(this.__toBuffer(undefined, undefined, false))
      }

      Transaction.prototype.getId = function () {
        // transaction hash's are displayed in reverse order
        return this.getHash().reverse().toString('hex')
      }

      Transaction.prototype.toBuffer = function (buffer, initialOffset) {
        return this.__toBuffer(buffer, initialOffset, true)
      }

      Transaction.prototype.__toBuffer = function (buffer, initialOffset, __allowWitness) {
        if (!buffer) buffer = Buffer.allocUnsafe(this.__byteLength(__allowWitness))

        var offset = initialOffset || 0
        function writeSlice(slice) { offset += slice.copy(buffer, offset) }
        function writeUInt8(i) { offset = buffer.writeUInt8(i, offset) }
        function writeUInt16(i) { offset = buffer.writeUInt16LE(i, offset) }
        function writeUInt32(i) { offset = buffer.writeUInt32LE(i, offset) }
        function writeInt32(i) { offset = buffer.writeInt32LE(i, offset) }
        function writeUInt64(i) { offset = bufferutils.writeUInt64LE(buffer, i, offset) }
        function writeVarInt(i) {
          varuint.encode(i, buffer, offset)
          offset += varuint.encode.bytes
        }
        function writeVarSlice(slice) { writeVarInt(slice.length); writeSlice(slice) }
        function writeVector(vector) { writeVarInt(vector.length); vector.forEach(writeVarSlice) }

        function writeCompressedG1(i) {
          writeUInt8(Transaction.ZCASH_G1_PREFIX_MASK | i.yLsb)
          writeSlice(i.x)
        }

        function writeCompressedG2(i) {
          writeUInt8(Transaction.ZCASH_G2_PREFIX_MASK | i.yLsb)
          writeSlice(i.x)
        }

        if (this.isOverwinterCompatible()) {
          var mask = (this.overwintered ? 1 : 0)
          writeInt32(this.version | (mask << 31))  // Set overwinter bit
          writeUInt32(this.versionGroupId)
        } else if (this.isDashSpecialTransaction()) {
          writeUInt16(this.version)
          writeUInt16(this.type)
        } else {
          writeInt32(this.version)
        }

        var hasWitnesses = __allowWitness && this.hasWitnesses()

        if (hasWitnesses) {
          writeUInt8(Transaction.ADVANCED_TRANSACTION_MARKER)
          writeUInt8(Transaction.ADVANCED_TRANSACTION_FLAG)
        }

        writeVarInt(this.ins.length)

        this.ins.forEach(function (txIn) {
          writeSlice(txIn.hash)
          writeUInt32(txIn.index)
          writeVarSlice(txIn.script)
          writeUInt32(txIn.sequence)
        })

        writeVarInt(this.outs.length)
        this.outs.forEach(function (txOut) {
          if (!txOut.valueBuffer) {
            writeUInt64(txOut.value)
          } else {
            writeSlice(txOut.valueBuffer)
          }

          writeVarSlice(txOut.script)
        })

        if (hasWitnesses) {
          this.ins.forEach(function (input) {
            writeVector(input.witness)
          })
        }

        writeUInt32(this.locktime)

        if (this.isOverwinterCompatible()) {
          writeUInt32(this.expiryHeight)
        }

        if (this.isSaplingCompatible()) {
          writeUInt64(this.valueBalance)

          writeVarInt(this.vShieldedSpend.length)
          this.vShieldedSpend.forEach(function (shieldedSpend) {
            writeSlice(shieldedSpend.cv)
            writeSlice(shieldedSpend.anchor)
            writeSlice(shieldedSpend.nullifier)
            writeSlice(shieldedSpend.rk)
            writeSlice(shieldedSpend.zkproof.sA)
            writeSlice(shieldedSpend.zkproof.sB)
            writeSlice(shieldedSpend.zkproof.sC)
            writeSlice(shieldedSpend.spendAuthSig)
          })
          writeVarInt(this.vShieldedOutput.length)
          this.vShieldedOutput.forEach(function (shieldedOutput) {
            writeSlice(shieldedOutput.cv)
            writeSlice(shieldedOutput.cmu)
            writeSlice(shieldedOutput.ephemeralKey)
            writeSlice(shieldedOutput.encCiphertext)
            writeSlice(shieldedOutput.outCiphertext)
            writeSlice(shieldedOutput.zkproof.sA)
            writeSlice(shieldedOutput.zkproof.sB)
            writeSlice(shieldedOutput.zkproof.sC)
          })
        }

        if (this.supportsJoinSplits()) {
          writeVarInt(this.joinsplits.length)
          this.joinsplits.forEach(function (joinsplit) {
            writeUInt64(joinsplit.vpubOld)
            writeUInt64(joinsplit.vpubNew)
            writeSlice(joinsplit.anchor)
            joinsplit.nullifiers.forEach(function (nullifier) {
              writeSlice(nullifier)
            })
            joinsplit.commitments.forEach(function (nullifier) {
              writeSlice(nullifier)
            })
            writeSlice(joinsplit.ephemeralKey)
            writeSlice(joinsplit.randomSeed)
            joinsplit.macs.forEach(function (nullifier) {
              writeSlice(nullifier)
            })
            if (this.isSaplingCompatible()) {
              writeSlice(joinsplit.zkproof.sA)
              writeSlice(joinsplit.zkproof.sB)
              writeSlice(joinsplit.zkproof.sC)
            } else {
              writeCompressedG1(joinsplit.zkproof.gA)
              writeCompressedG1(joinsplit.zkproof.gAPrime)
              writeCompressedG2(joinsplit.zkproof.gB)
              writeCompressedG1(joinsplit.zkproof.gBPrime)
              writeCompressedG1(joinsplit.zkproof.gC)
              writeCompressedG1(joinsplit.zkproof.gCPrime)
              writeCompressedG1(joinsplit.zkproof.gK)
              writeCompressedG1(joinsplit.zkproof.gH)
            }
            joinsplit.ciphertexts.forEach(function (ciphertext) {
              writeSlice(ciphertext)
            })
          }, this)
          if (this.joinsplits.length > 0) {
            writeSlice(this.joinsplitPubkey)
            writeSlice(this.joinsplitSig)
          }
        }

        if (this.isSaplingCompatible() && this.vShieldedSpend.length + this.vShieldedOutput.length > 0) {
          writeSlice(this.bindingSig)
        }

        if (this.isDashSpecialTransaction()) {
          writeVarSlice(this.extraPayload)
        }

        // avoid slicing unless necessary
        if (initialOffset !== undefined) return buffer.slice(initialOffset, offset)
        // TODO (https://github.com/BitGo/bitgo-utxo-lib/issues/11): we shouldn't have to slice the final buffer
        return buffer.slice(0, offset)
      }

      Transaction.prototype.toHex = function () {
        return this.toBuffer().toString('hex')
      }

      Transaction.prototype.setInputScript = function (index, scriptSig) {
        typeforce(types.tuple(types.Number, types.Buffer), arguments)

        this.ins[index].script = scriptSig
      }

      Transaction.prototype.setWitness = function (index, witness) {
        typeforce(types.tuple(types.Number, [types.Buffer]), arguments)

        this.ins[index].witness = witness
      }

      module.exports = Transaction

    }, { "./bufferWriter": 23, "./bufferutils": 24, "./coins": 25, "./crypto": 26, "./networks": 33, "./script": 34, "./types": 60, "bitcoin-ops": 8, "blake2b": 63, "safe-buffer": 133, "typeforce": 145, "varuint-bitcoin": 148 }], 59: [function (require, module, exports) {
      var Buffer = require('safe-buffer').Buffer
      var baddress = require('./address')
      var bcrypto = require('./crypto')
      var bscript = require('./script')
      var btemplates = require('./templates')
      var coins = require('./coins')
      var networks = require('./networks')
      var ops = require('bitcoin-ops')
      var typeforce = require('typeforce')
      var types = require('./types')
      var scriptTypes = btemplates.types
      var SIGNABLE = [btemplates.types.P2PKH, btemplates.types.P2PK, btemplates.types.MULTISIG]
      var P2SH = SIGNABLE.concat([btemplates.types.P2WPKH, btemplates.types.P2WSH])

      var ECPair = require('./ecpair')
      var ECSignature = require('./ecsignature')
      var Transaction = require('./transaction')

      var debug = require('debug')('bitgo:utxolib:txbuilder')

      function supportedType(type) {
        return SIGNABLE.indexOf(type) !== -1
      }

      function supportedP2SHType(type) {
        return P2SH.indexOf(type) !== -1
      }

      function extractChunks(type, chunks, script) {
        var pubKeys = []
        var signatures = []
        switch (type) {
          case scriptTypes.P2PKH:
            // if (redeemScript) throw new Error('Nonstandard... P2SH(P2PKH)')
            pubKeys = chunks.slice(1)
            signatures = chunks.slice(0, 1)
            break

          case scriptTypes.P2PK:
            pubKeys[0] = script ? btemplates.pubKey.output.decode(script) : undefined
            signatures = chunks.slice(0, 1)
            break

          case scriptTypes.MULTISIG:
            if (script) {
              var multisig = btemplates.multisig.output.decode(script)
              pubKeys = multisig.pubKeys
            }

            signatures = chunks.slice(1).map(function (chunk) {
              return chunk.length === 0 ? undefined : chunk
            })
            break
        }

        return {
          pubKeys: pubKeys,
          signatures: signatures
        }
      }
      function expandInput(scriptSig, witnessStack) {
        if (scriptSig.length === 0 && witnessStack.length === 0) return {}

        var prevOutScript
        var prevOutType
        var scriptType
        var script
        var redeemScript
        var witnessScript
        var witnessScriptType
        var redeemScriptType
        var witness = false
        var p2wsh = false
        var p2sh = false
        var witnessProgram
        var chunks

        var scriptSigChunks = bscript.decompile(scriptSig)
        var sigType = btemplates.classifyInput(scriptSigChunks, true)
        if (sigType === scriptTypes.P2SH) {
          p2sh = true
          redeemScript = scriptSigChunks[scriptSigChunks.length - 1]
          redeemScriptType = btemplates.classifyOutput(redeemScript)
          prevOutScript = btemplates.scriptHash.output.encode(bcrypto.hash160(redeemScript))
          prevOutType = scriptTypes.P2SH
          script = redeemScript
        }

        var classifyWitness = btemplates.classifyWitness(witnessStack, true)
        if (classifyWitness === scriptTypes.P2WSH) {
          witnessScript = witnessStack[witnessStack.length - 1]
          witnessScriptType = btemplates.classifyOutput(witnessScript)
          p2wsh = true
          witness = true
          if (scriptSig.length === 0) {
            prevOutScript = btemplates.witnessScriptHash.output.encode(bcrypto.sha256(witnessScript))
            prevOutType = scriptTypes.P2WSH
            if (redeemScript !== undefined) {
              throw new Error('Redeem script given when unnecessary')
            }
            // bare witness
          } else {
            if (!redeemScript) {
              throw new Error('No redeemScript provided for P2WSH, but scriptSig non-empty')
            }
            witnessProgram = btemplates.witnessScriptHash.output.encode(bcrypto.sha256(witnessScript))
            if (!redeemScript.equals(witnessProgram)) {
              throw new Error('Redeem script didn\'t match witnessScript')
            }
          }

          if (!supportedType(btemplates.classifyOutput(witnessScript))) {
            throw new Error('unsupported witness script')
          }

          script = witnessScript
          scriptType = witnessScriptType
          chunks = witnessStack.slice(0, -1)
        } else if (classifyWitness === scriptTypes.P2WPKH) {
          witness = true
          var key = witnessStack[witnessStack.length - 1]
          var keyHash = bcrypto.hash160(key)
          if (scriptSig.length === 0) {
            prevOutScript = btemplates.witnessPubKeyHash.output.encode(keyHash)
            prevOutType = scriptTypes.P2WPKH
            if (typeof redeemScript !== 'undefined') {
              throw new Error('Redeem script given when unnecessary')
            }
          } else {
            if (!redeemScript) {
              throw new Error('No redeemScript provided for P2WPKH, but scriptSig wasn\'t empty')
            }
            witnessProgram = btemplates.witnessPubKeyHash.output.encode(keyHash)
            if (!redeemScript.equals(witnessProgram)) {
              throw new Error('Redeem script did not have the right witness program')
            }
          }

          scriptType = scriptTypes.P2PKH
          chunks = witnessStack
        } else if (redeemScript) {
          if (!supportedP2SHType(redeemScriptType)) {
            throw new Error('Bad redeemscript!')
          }

          script = redeemScript
          scriptType = redeemScriptType
          chunks = scriptSigChunks.slice(0, -1)
        } else {
          prevOutType = scriptType = btemplates.classifyInput(scriptSig)
          chunks = scriptSigChunks
        }

        var expanded = extractChunks(scriptType, chunks, script)

        var result = {
          pubKeys: expanded.pubKeys,
          signatures: expanded.signatures,
          prevOutScript: prevOutScript,
          prevOutType: prevOutType,
          signType: scriptType,
          signScript: script,
          witness: Boolean(witness)
        }

        if (p2sh) {
          result.redeemScript = redeemScript
          result.redeemScriptType = redeemScriptType
        }

        if (p2wsh) {
          result.witnessScript = witnessScript
          result.witnessScriptType = witnessScriptType
        }

        return result
      }

      // could be done in expandInput, but requires the original Transaction for hashForSignature
      function fixMultisigOrder(input, transaction, vin, value, network) {
        if (input.redeemScriptType !== scriptTypes.MULTISIG || !input.redeemScript) return
        if (input.pubKeys.length === input.signatures.length) return

        network = network || networks.bitcoin
        var unmatched = input.signatures.concat()

        input.signatures = input.pubKeys.map(function (pubKey) {
          var keyPair = ECPair.fromPublicKeyBuffer(pubKey)
          var match

          // check for a signature
          unmatched.some(function (signature, i) {
            // skip if undefined || OP_0
            if (!signature) return false

            // TODO: avoid O(n) hashForSignature
            var parsed = ECSignature.parseScriptSignature(signature)
            var hash
            switch (network.coin) {
              case coins.BSV:
              case coins.BCH:
                hash = transaction.hashForCashSignature(vin, input.signScript, value, parsed.hashType)
                break
              case coins.BTG:
                hash = transaction.hashForGoldSignature(vin, input.signScript, value, parsed.hashType)
                break
              case coins.ZEC:
                if (value === undefined) {
                  return false
                }
                hash = transaction.hashForZcashSignature(vin, input.signScript, value, parsed.hashType)
                break
              default:
                if (input.witness) {
                  hash = transaction.hashForWitnessV0(vin, input.signScript, value, parsed.hashType)
                } else {
                  hash = transaction.hashForSignature(vin, input.signScript, parsed.hashType)
                }
                break
            }

            // skip if signature does not match pubKey
            if (!keyPair.verify(hash, parsed.signature)) return false

            // remove matched signature from unmatched
            unmatched[i] = undefined
            match = signature

            return true
          })

          return match
        })
      }

      function expandOutput(script, scriptType, ourPubKey) {
        typeforce(types.Buffer, script)

        var scriptChunks = bscript.decompile(script)
        if (!scriptType) {
          scriptType = btemplates.classifyOutput(script)
        }

        var pubKeys = []

        switch (scriptType) {
          // does our hash160(pubKey) match the output scripts?
          case scriptTypes.P2PKH:
            if (!ourPubKey) break

            var pkh1 = scriptChunks[2]
            var pkh2 = bcrypto.hash160(ourPubKey)
            if (pkh1.equals(pkh2)) pubKeys = [ourPubKey]
            break

          // does our hash160(pubKey) match the output scripts?
          case scriptTypes.P2WPKH:
            if (!ourPubKey) break

            var wpkh1 = scriptChunks[1]
            var wpkh2 = bcrypto.hash160(ourPubKey)
            if (wpkh1.equals(wpkh2)) pubKeys = [ourPubKey]
            break

          case scriptTypes.P2PK:
            pubKeys = scriptChunks.slice(0, 1)
            break

          case scriptTypes.MULTISIG:
            pubKeys = scriptChunks.slice(1, -2)
            break

          default: return { scriptType: scriptType }
        }

        return {
          pubKeys: pubKeys,
          scriptType: scriptType,
          signatures: pubKeys.map(function () { return undefined })
        }
      }

      function checkP2SHInput(input, redeemScriptHash) {
        if (input.prevOutType) {
          if (input.prevOutType !== scriptTypes.P2SH) throw new Error('PrevOutScript must be P2SH')

          var prevOutScriptScriptHash = bscript.decompile(input.prevOutScript)[1]
          if (!prevOutScriptScriptHash.equals(redeemScriptHash)) throw new Error('Inconsistent hash160(RedeemScript)')
        }
      }

      function checkP2WSHInput(input, witnessScriptHash) {
        if (input.prevOutType) {
          if (input.prevOutType !== scriptTypes.P2WSH) throw new Error('PrevOutScript must be P2WSH')

          var scriptHash = bscript.decompile(input.prevOutScript)[1]
          if (!scriptHash.equals(witnessScriptHash)) throw new Error('Inconsistent sha25(WitnessScript)')
        }
      }

      function prepareInput(input, kpPubKey, redeemScript, witnessValue, witnessScript) {
        var expanded
        var prevOutType
        var prevOutScript

        var p2sh = false
        var p2shType
        var redeemScriptHash

        var witness = false
        var p2wsh = false
        var witnessType
        var witnessScriptHash

        var signType
        var signScript

        if (redeemScript && witnessScript) {
          redeemScriptHash = bcrypto.hash160(redeemScript)
          witnessScriptHash = bcrypto.sha256(witnessScript)
          checkP2SHInput(input, redeemScriptHash)

          if (!redeemScript.equals(btemplates.witnessScriptHash.output.encode(witnessScriptHash))) throw new Error('Witness script inconsistent with redeem script')

          expanded = expandOutput(witnessScript, undefined, kpPubKey)
          if (!expanded.pubKeys) throw new Error('WitnessScript not supported "' + bscript.toASM(redeemScript) + '"')

          prevOutType = btemplates.types.P2SH
          prevOutScript = btemplates.scriptHash.output.encode(redeemScriptHash)
          p2sh = witness = p2wsh = true
          p2shType = btemplates.types.P2WSH
          signType = witnessType = expanded.scriptType
          signScript = witnessScript
        } else if (redeemScript) {
          redeemScriptHash = bcrypto.hash160(redeemScript)
          checkP2SHInput(input, redeemScriptHash)

          expanded = expandOutput(redeemScript, undefined, kpPubKey)
          if (!expanded.pubKeys) throw new Error('RedeemScript not supported "' + bscript.toASM(redeemScript) + '"')

          prevOutType = btemplates.types.P2SH
          prevOutScript = btemplates.scriptHash.output.encode(redeemScriptHash)
          p2sh = true
          signType = p2shType = expanded.scriptType
          signScript = redeemScript
          witness = signType === btemplates.types.P2WPKH
        } else if (witnessScript) {
          witnessScriptHash = bcrypto.sha256(witnessScript)
          checkP2WSHInput(input, witnessScriptHash)

          expanded = expandOutput(witnessScript, undefined, kpPubKey)
          if (!expanded.pubKeys) throw new Error('WitnessScript not supported "' + bscript.toASM(redeemScript) + '"')

          prevOutType = btemplates.types.P2WSH
          prevOutScript = btemplates.witnessScriptHash.output.encode(witnessScriptHash)
          witness = p2wsh = true
          signType = witnessType = expanded.scriptType
          signScript = witnessScript
        } else if (input.prevOutType) {
          // embedded scripts are not possible without a redeemScript
          if (input.prevOutType === scriptTypes.P2SH ||
            input.prevOutType === scriptTypes.P2WSH) {
            throw new Error('PrevOutScript is ' + input.prevOutType + ', requires redeemScript')
          }

          prevOutType = input.prevOutType
          prevOutScript = input.prevOutScript
          expanded = expandOutput(input.prevOutScript, input.prevOutType, kpPubKey)
          if (!expanded.pubKeys) return

          witness = (input.prevOutType === scriptTypes.P2WPKH)
          signType = prevOutType
          signScript = prevOutScript
        } else {
          prevOutScript = btemplates.pubKeyHash.output.encode(bcrypto.hash160(kpPubKey))
          expanded = expandOutput(prevOutScript, scriptTypes.P2PKH, kpPubKey)

          prevOutType = scriptTypes.P2PKH
          witness = false
          signType = prevOutType
          signScript = prevOutScript
        }

        if (signType === scriptTypes.P2WPKH) {
          signScript = btemplates.pubKeyHash.output.encode(btemplates.witnessPubKeyHash.output.decode(signScript))
        }

        if (p2sh) {
          input.redeemScript = redeemScript
          input.redeemScriptType = p2shType
        }

        if (p2wsh) {
          input.witnessScript = witnessScript
          input.witnessScriptType = witnessType
        }

        input.pubKeys = expanded.pubKeys
        input.signatures = expanded.signatures
        input.signScript = signScript
        input.signType = signType
        input.prevOutScript = prevOutScript
        input.prevOutType = prevOutType
        input.witness = witness
      }

      function buildStack(type, signatures, pubKeys, allowIncomplete) {
        if (type === scriptTypes.P2PKH) {
          if (signatures.length === 1 && Buffer.isBuffer(signatures[0]) && pubKeys.length === 1) return btemplates.pubKeyHash.input.encodeStack(signatures[0], pubKeys[0])
        } else if (type === scriptTypes.P2PK) {
          if (signatures.length === 1 && Buffer.isBuffer(signatures[0])) return btemplates.pubKey.input.encodeStack(signatures[0])
        } else if (type === scriptTypes.MULTISIG) {
          if (signatures.length > 0) {
            signatures = signatures.map(function (signature) {
              return signature || ops.OP_0
            })
            if (!allowIncomplete) {
              // remove blank signatures
              signatures = signatures.filter(function (x) { return x !== ops.OP_0 })
            }

            return btemplates.multisig.input.encodeStack(signatures)
          }
        } else {
          throw new Error('Not yet supported')
        }

        if (!allowIncomplete) throw new Error('Not enough signatures provided')
        return []
      }

      function buildInput(input, allowIncomplete) {
        var scriptType = input.prevOutType
        var sig = []
        var witness = []

        if (supportedType(scriptType)) {
          sig = buildStack(scriptType, input.signatures, input.pubKeys, allowIncomplete)
        }

        var p2sh = false
        if (scriptType === btemplates.types.P2SH) {
          // We can remove this error later when we have a guarantee prepareInput
          // rejects unsignable scripts - it MUST be signable at this point.
          if (!allowIncomplete && !supportedP2SHType(input.redeemScriptType)) {
            throw new Error('Impossible to sign this type')
          }

          if (supportedType(input.redeemScriptType)) {
            sig = buildStack(input.redeemScriptType, input.signatures, input.pubKeys, allowIncomplete)
          }

          // If it wasn't SIGNABLE, it's witness, defer to that
          if (input.redeemScriptType) {
            p2sh = true
            scriptType = input.redeemScriptType
          }
        }

        switch (scriptType) {
          // P2WPKH is a special case of P2PKH
          case btemplates.types.P2WPKH:
            witness = buildStack(btemplates.types.P2PKH, input.signatures, input.pubKeys, allowIncomplete)
            break

          case btemplates.types.P2WSH:
            // We can remove this check later
            if (!allowIncomplete && !supportedType(input.witnessScriptType)) {
              throw new Error('Impossible to sign this type')
            }

            if (supportedType(input.witnessScriptType)) {
              witness = buildStack(input.witnessScriptType, input.signatures, input.pubKeys, allowIncomplete)
              witness.push(input.witnessScript)
              scriptType = input.witnessScriptType
            }
            break
        }

        // append redeemScript if necessary
        if (p2sh) {
          sig.push(input.redeemScript)
        }

        return {
          type: scriptType,
          script: bscript.compile(sig),
          witness: witness
        }
      }

      // By default, assume is a bitcoin transaction
      function TransactionBuilder(network, maximumFeeRate) {
        this.prevTxMap = {}
        this.network = network || networks.bitcoin

        // WARNING: This is __NOT__ to be relied on, its just another potential safety mechanism (safety in-depth)
        this.maximumFeeRate = maximumFeeRate || 2500

        this.inputs = []
        this.tx = new Transaction(this.network)
      }

      TransactionBuilder.prototype.setLockTime = function (locktime) {
        typeforce(types.UInt32, locktime)

        // if any signatures exist, throw
        if (this.inputs.some(function (input) {
          if (!input.signatures) return false

          return input.signatures.some(function (s) { return s })
        })) {
          throw new Error('No, this would invalidate signatures')
        }

        this.tx.locktime = locktime
      }

      TransactionBuilder.prototype.setVersion = function (version, overwinter = true) {
        typeforce(types.UInt32, version)

        if (coins.isZcash(this.network)) {
          if (!this.network.consensusBranchId.hasOwnProperty(this.tx.version)) {
            throw new Error('Unsupported Zcash transaction')
          }
          this.tx.overwintered = (overwinter ? 1 : 0)
        }
        this.tx.version = version
      }

      TransactionBuilder.prototype.setVersionGroupId = function (versionGroupId) {
        if (!(coins.isZcash(this.network) && this.tx.isOverwinterCompatible())) {
          throw new Error('expiryHeight can only be set for Zcash starting at overwinter version. Current network coin: ' +
            this.network.coin + ', version: ' + this.tx.version)
        }
        typeforce(types.UInt32, versionGroupId)
        this.tx.versionGroupId = versionGroupId
      }

      TransactionBuilder.prototype.setExpiryHeight = function (expiryHeight) {
        if (!(coins.isZcash(this.network) && this.tx.isOverwinterCompatible())) {
          throw new Error('expiryHeight can only be set for Zcash starting at overwinter version. Current network coin: ' +
            this.network.coin + ', version: ' + this.tx.version)
        }
        typeforce(types.UInt32, expiryHeight)
        this.tx.expiryHeight = expiryHeight
      }

      TransactionBuilder.prototype.setJoinSplits = function (transaction) {
        if (!(coins.isZcash(this.network) && this.tx.supportsJoinSplits())) {
          throw new Error('joinsplits can only be set for Zcash starting at version 2. Current network coin: ' +
            this.network.coin + ', version: ' + this.tx.version)
        }
        if (transaction && transaction.joinsplits) {
          this.tx.joinsplits = transaction.joinsplits.map(function (txJoinsplit) {
            return {
              vpubOld: txJoinsplit.vpubOld,
              vpubNew: txJoinsplit.vpubNew,
              anchor: txJoinsplit.anchor,
              nullifiers: txJoinsplit.nullifiers,
              commitments: txJoinsplit.commitments,
              ephemeralKey: txJoinsplit.ephemeralKey,
              randomSeed: txJoinsplit.randomSeed,
              macs: txJoinsplit.macs,
              zproof: txJoinsplit.zproof,
              ciphertexts: txJoinsplit.ciphertexts
            }
          })

          this.tx.joinsplitPubkey = transaction.joinsplitPubkey
          this.tx.joinsplitSig = transaction.joinsplitSig
          return
        }
        throw new Error('Invalid transaction with joinsplits')
      }

      TransactionBuilder.fromTransaction = function (transaction, network) {
        var txbNetwork = network || networks.bitcoin
        var txb = new TransactionBuilder(txbNetwork)

        if (txb.network.coin !== transaction.network.coin) {
          throw new Error('This transaction is incompatible with the transaction builder')
        }

        // Copy transaction fields
        txb.setVersion(transaction.version, transaction.overwintered)
        txb.setLockTime(transaction.locktime)

        if (coins.isZcash(txbNetwork)) {
          // Copy Zcash overwinter fields. Omitted if the transaction builder is not for Zcash.
          if (txb.tx.isOverwinterCompatible()) {
            txb.setVersionGroupId(transaction.versionGroupId)
            txb.setExpiryHeight(transaction.expiryHeight)
          }

          // We don't support protected transactions but we copy the joinsplits for consistency. However, the transaction
          // builder will fail when we try to sign one of these transactions
          if (txb.tx.supportsJoinSplits()) {
            txb.setJoinSplits(transaction)
          }
        }

        // Copy Dash special transaction fields. Omitted if the transaction builder is not for Dash.
        if (coins.isDash(txbNetwork)) {
          typeforce(types.UInt16, transaction.type)
          txb.tx.type = transaction.type

          if (txb.tx.versionSupportsDashSpecialTransactions()) {
            typeforce(types.Buffer, transaction.extraPayload)
            txb.tx.extraPayload = transaction.extraPayload
          }
        }

        // Copy outputs (done first to avoid signature invalidation)
        transaction.outs.forEach(function (txOut) {
          txb.addOutput(txOut.script, txOut.value)
        })

        // Copy inputs
        transaction.ins.forEach(function (txIn) {
          txb.__addInputUnsafe(txIn.hash, txIn.index, {
            sequence: txIn.sequence,
            script: txIn.script,
            witness: txIn.witness,
            value: txIn.value
          })
        })

        // fix some things not possible through the public API
        txb.inputs.forEach(function (input, i) {
          fixMultisigOrder(input, transaction, i, input.value, txbNetwork)
        })

        return txb
      }

      TransactionBuilder.prototype.addInput = function (txHash, vout, sequence, prevOutScript) {
        if (!this.__canModifyInputs()) {
          throw new Error('No, this would invalidate signatures')
        }

        var value

        // is it a hex string?
        if (typeof txHash === 'string') {
          // transaction hashs's are displayed in reverse order, un-reverse it
          txHash = Buffer.from(txHash, 'hex').reverse()

          // is it a Transaction object?
        } else if (txHash instanceof Transaction) {
          var txOut = txHash.outs[vout]
          prevOutScript = txOut.script
          value = txOut.value

          txHash = txHash.getHash()
        }

        return this.__addInputUnsafe(txHash, vout, {
          sequence: sequence,
          prevOutScript: prevOutScript,
          value: value
        })
      }

      TransactionBuilder.prototype.__addInputUnsafe = function (txHash, vout, options) {
        if (Transaction.isCoinbaseHash(txHash)) {
          throw new Error('coinbase inputs not supported')
        }

        var prevTxOut = txHash.toString('hex') + ':' + vout
        if (this.prevTxMap[prevTxOut] !== undefined) throw new Error('Duplicate TxOut: ' + prevTxOut)

        var input = {}

        // derive what we can from the scriptSig
        if (options.script !== undefined) {
          input = expandInput(options.script, options.witness || [])
        }

        // if an input value was given, retain it
        if (options.value !== undefined) {
          input.value = options.value
        }

        // derive what we can from the previous transactions output script
        if (!input.prevOutScript && options.prevOutScript) {
          var prevOutType

          if (!input.pubKeys && !input.signatures) {
            var expanded = expandOutput(options.prevOutScript)

            if (expanded.pubKeys) {
              input.pubKeys = expanded.pubKeys
              input.signatures = expanded.signatures
            }

            prevOutType = expanded.scriptType
          }

          input.prevOutScript = options.prevOutScript
          input.prevOutType = prevOutType || btemplates.classifyOutput(options.prevOutScript)
        }

        var vin = this.tx.addInput(txHash, vout, options.sequence, options.scriptSig)
        this.inputs[vin] = input
        this.prevTxMap[prevTxOut] = vin
        return vin
      }

      TransactionBuilder.prototype.addOutput = function (scriptPubKey, value) {
        if (!this.__canModifyOutputs()) {
          throw new Error('No, this would invalidate signatures')
        }

        // Attempt to get a script if it's a base58 address string
        if (typeof scriptPubKey === 'string') {
          scriptPubKey = baddress.toOutputScript(scriptPubKey, this.network)
        }

        return this.tx.addOutput(scriptPubKey, value)
      }

      TransactionBuilder.prototype.build = function () {
        return this.__build(false)
      }
      TransactionBuilder.prototype.buildIncomplete = function () {
        return this.__build(true)
      }

      TransactionBuilder.prototype.__build = function (allowIncomplete) {
        if (!allowIncomplete) {
          if (!this.tx.ins.length) throw new Error('Transaction has no inputs')
          if (!this.tx.outs.length) throw new Error('Transaction has no outputs')
        }

        var tx = this.tx.clone()
        // Create script signatures from inputs
        this.inputs.forEach(function (input, i) {
          var scriptType = input.witnessScriptType || input.redeemScriptType || input.prevOutType
          if (!scriptType && !allowIncomplete) throw new Error('Transaction is not complete')
          var result = buildInput(input, allowIncomplete)

          // skip if no result
          if (!allowIncomplete) {
            if (!supportedType(result.type) && result.type !== btemplates.types.P2WPKH) {
              throw new Error(result.type + ' not supported')
            }
          }

          tx.setInputScript(i, result.script)
          tx.setWitness(i, result.witness)
        })

        if (!allowIncomplete) {
          // do not rely on this, its merely a last resort
          if (this.__overMaximumFees(tx.virtualSize())) {
            throw new Error('Transaction has absurd fees')
          }
        }

        return tx
      }

      function canSign(input) {
        return input.prevOutScript !== undefined &&
          input.signScript !== undefined &&
          input.pubKeys !== undefined &&
          input.signatures !== undefined &&
          input.signatures.length === input.pubKeys.length &&
          input.pubKeys.length > 0 &&
          (
            input.witness === false ||
            (input.witness === true && input.value !== undefined)
          )
      }

      TransactionBuilder.prototype.sign = function (vin, keyPair, redeemScript, hashType, witnessValue, witnessScript) {
        debug('Signing transaction: (input: %d, hashType: %d, witnessVal: %s, witnessScript: %j)', vin, hashType, witnessValue, witnessScript)
        debug('Transaction Builder network: %j', this.network)

        // TODO: remove keyPair.network matching in 4.0.0
        if (keyPair.network && keyPair.network !== this.network) throw new TypeError('Inconsistent network')
        if (!this.inputs[vin]) throw new Error('No input at index: ' + vin)
        hashType = hashType || Transaction.SIGHASH_ALL

        var input = this.inputs[vin]

        // if redeemScript was previously provided, enforce consistency
        if (input.redeemScript !== undefined &&
          redeemScript &&
          !input.redeemScript.equals(redeemScript)) {
          throw new Error('Inconsistent redeemScript')
        }

        var kpPubKey = keyPair.publicKey || keyPair.getPublicKeyBuffer()
        if (!canSign(input)) {
          if (witnessValue !== undefined) {
            if (input.value !== undefined && input.value !== witnessValue) throw new Error('Input didn\'t match witnessValue')
            typeforce(types.Satoshi, witnessValue)
            input.value = witnessValue
          }

          debug('Preparing input %d for signing', vin)

          if (!canSign(input)) prepareInput(input, kpPubKey, redeemScript, witnessValue, witnessScript)
          if (!canSign(input)) throw Error(input.prevOutType + ' not supported')
        }

        // ready to sign
        var signatureHash
        if (coins.isBitcoinGold(this.network)) {
          signatureHash = this.tx.hashForGoldSignature(vin, input.signScript, witnessValue, hashType, input.witness)
          debug('Calculated BTG sighash (%s)', signatureHash.toString('hex'))
        } else if (coins.isBitcoinCash(this.network) || coins.isBitcoinSV(this.network)) {
          signatureHash = this.tx.hashForCashSignature(vin, input.signScript, witnessValue, hashType)
          debug('Calculated BCH sighash (%s)', signatureHash.toString('hex'))
        } else if (coins.isZcash(this.network)) {
          signatureHash = this.tx.hashForZcashSignature(vin, input.signScript, witnessValue, hashType)
          debug('Calculated ZEC sighash (%s)', signatureHash.toString('hex'))
        } else {
          if (input.witness) {
            signatureHash = this.tx.hashForWitnessV0(vin, input.signScript, witnessValue, hashType)
            debug('Calculated witnessv0 sighash (%s)', signatureHash.toString('hex'))
          } else {
            signatureHash = this.tx.hashForSignature(vin, input.signScript, hashType)
            debug('Calculated sighash (%s)', signatureHash.toString('hex'))
          }
        }

        // enforce in order signing of public keys
        var signed = input.pubKeys.some(function (pubKey, i) {
          if (!kpPubKey.equals(pubKey)) return false
          if (input.signatures[i]) throw new Error('Signature already exists')
          if (kpPubKey.length !== 33 &&
            input.signType === scriptTypes.P2WPKH) throw new Error('BIP143 rejects uncompressed public keys in P2WPKH or P2WSH')

          var signature = keyPair.sign(signatureHash)
          if (Buffer.isBuffer(signature)) signature = ECSignature.fromRSBuffer(signature)

          debug('Produced signature (r: %s, s: %s)', signature.r, signature.s)

          input.signatures[i] = signature.toScriptSignature(hashType)
          return true
        })

        if (!signed) throw new Error('Key pair cannot sign for this input')
      }

      function signatureHashType(buffer) {
        return buffer.readUInt8(buffer.length - 1)
      }

      TransactionBuilder.prototype.__canModifyInputs = function () {
        return this.inputs.every(function (input) {
          // any signatures?
          if (input.signatures === undefined) return true

          return input.signatures.every(function (signature) {
            if (!signature) return true
            var hashType = signatureHashType(signature)

            // if SIGHASH_ANYONECANPAY is set, signatures would not
            // be invalidated by more inputs
            return hashType & Transaction.SIGHASH_ANYONECANPAY
          })
        })
      }

      TransactionBuilder.prototype.__canModifyOutputs = function () {
        var nInputs = this.tx.ins.length
        var nOutputs = this.tx.outs.length

        return this.inputs.every(function (input) {
          if (input.signatures === undefined) return true

          return input.signatures.every(function (signature) {
            if (!signature) return true
            var hashType = signatureHashType(signature)

            var hashTypeMod = hashType & 0x1f
            if (hashTypeMod === Transaction.SIGHASH_NONE) return true
            if (hashTypeMod === Transaction.SIGHASH_SINGLE) {
              // if SIGHASH_SINGLE is set, and nInputs > nOutputs
              // some signatures would be invalidated by the addition
              // of more outputs
              return nInputs <= nOutputs
            }
          })
        })
      }

      TransactionBuilder.prototype.__overMaximumFees = function (bytes) {
        // not all inputs will have .value defined
        var incoming = this.inputs.reduce(function (a, x) { return a + (x.value >>> 0) }, 0)

        // but all outputs do, and if we have any input value
        // we can immediately determine if the outputs are too small
        var outgoing = this.tx.outs.reduce(function (a, x) { return a + x.value }, 0)
        var fee = incoming - outgoing
        var feeRate = fee / bytes

        return feeRate > this.maximumFeeRate
      }

      module.exports = TransactionBuilder

    }, { "./address": 19, "./coins": 25, "./crypto": 26, "./ecpair": 28, "./ecsignature": 29, "./networks": 33, "./script": 34, "./templates": 36, "./transaction": 58, "./types": 60, "bitcoin-ops": 8, "debug": 10, "safe-buffer": 133, "typeforce": 145 }], 60: [function (require, module, exports) {
      var typeforce = require('typeforce')

      var UINT31_MAX = Math.pow(2, 31) - 1
      function UInt31(value) {
        return typeforce.UInt32(value) && value <= UINT31_MAX
      }

      function BIP32Path(value) {
        return typeforce.String(value) && value.match(/^(m\/)?(\d+'?\/)*\d+'?$/)
      }
      BIP32Path.toJSON = function () { return 'BIP32 derivation path' }

      var SATOSHI_MAX = 21 * 1e14
      function Satoshi(value) {
        return typeforce.UInt53(value) && value <= SATOSHI_MAX
      }

      // external dependent types
      var BigInt = typeforce.quacksLike('BigInteger')
      var ECPoint = typeforce.quacksLike('Point')

      // exposed, external API
      var ECSignature = typeforce.compile({ r: BigInt, s: BigInt })
      var networkVersion = typeforce.oneOf(typeforce.UInt8, typeforce.UInt16)
      var Network = typeforce.compile({
        messagePrefix: typeforce.oneOf(typeforce.Buffer, typeforce.String),
        bip32: {
          public: typeforce.UInt32,
          private: typeforce.UInt32
        },
        pubKeyHash: networkVersion,
        scriptHash: networkVersion,
        wif: typeforce.UInt8
      })

      // extend typeforce types with ours
      var types = {
        BigInt: BigInt,
        BIP32Path: BIP32Path,
        Buffer256bit: typeforce.BufferN(32),
        ECPoint: ECPoint,
        ECSignature: ECSignature,
        Hash160bit: typeforce.BufferN(20),
        Hash256bit: typeforce.BufferN(32),
        Network: Network,
        Satoshi: Satoshi,
        UInt31: UInt31,
        NetworkVersion: networkVersion
      }

      for (var typeName in typeforce) {
        types[typeName] = typeforce[typeName]
      }

      module.exports = types

    }, { "typeforce": 145 }], 61: [function (require, module, exports) {

      module.exports = loadWebAssembly

      // turning off support for WebAssembly, 
      //   chrome 69 has issues with loading webassembly in the main thread if the module size >4k
      loadWebAssembly.supported = false

      function loadWebAssembly(opts) {
        if (!loadWebAssembly.supported) return null

        var imp = opts && opts.imports
        var wasm = toUint8Array('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')
        var ready = null

        var mod = {
          buffer: wasm,
          memory: null,
          exports: null,
          realloc: realloc,
          onload: onload
        }

        onload(function () { })

        return mod

        function realloc(size) {
          mod.exports.memory.grow(Math.ceil(Math.abs(size - mod.memory.length) / 65536))
          mod.memory = new Uint8Array(mod.exports.memory.buffer)
        }

        function onload(cb) {
          if (mod.exports) return cb()

          if (ready) {
            ready.then(cb.bind(null, null)).catch(cb)
            return
          }

          try {
            if (opts && opts.async) throw new Error('async')
            setup({ instance: new WebAssembly.Instance(new WebAssembly.Module(wasm), imp) })
          } catch (err) {
            ready = WebAssembly.instantiate(wasm, imp).then(setup)
          }

          onload(cb)
        }

        function setup(w) {
          mod.exports = w.instance.exports
          mod.memory = mod.exports.memory && mod.exports.memory.buffer && new Uint8Array(mod.exports.memory.buffer)
        }
      }

      function toUint8Array(s) {
        if (typeof atob === 'function') return new Uint8Array(atob(s).split('').map(charCodeAt))
        return new (require('buf' + 'fer').Buffer)(s, 'base64')
      }

      function charCodeAt(c) {
        return c.charCodeAt(0)
      }

    }, {}], 62: [function (require, module, exports) {
      var assert = require('nanoassert')
      var wasm = require('./blake2b')()

      var head = 64
      var freeList = []

      module.exports = Blake2b
      var BYTES_MIN = module.exports.BYTES_MIN = 16
      var BYTES_MAX = module.exports.BYTES_MAX = 64
      var BYTES = module.exports.BYTES = 32
      var KEYBYTES_MIN = module.exports.KEYBYTES_MIN = 16
      var KEYBYTES_MAX = module.exports.KEYBYTES_MAX = 64
      var KEYBYTES = module.exports.KEYBYTES = 32
      var SALTBYTES = module.exports.SALTBYTES = 16
      var PERSONALBYTES = module.exports.PERSONALBYTES = 16

      function Blake2b(digestLength, key, salt, personal, noAssert) {
        if (!(this instanceof Blake2b)) return new Blake2b(digestLength, key, salt, personal, noAssert)
        if (!(wasm && wasm.exports)) throw new Error('WASM not loaded. Wait for Blake2b.ready(cb)')
        if (!digestLength) digestLength = 32

        if (noAssert !== true) {
          assert(digestLength >= BYTES_MIN, 'digestLength must be at least ' + BYTES_MIN + ', was given ' + digestLength)
          assert(digestLength <= BYTES_MAX, 'digestLength must be at most ' + BYTES_MAX + ', was given ' + digestLength)
          if (key != null) assert(key.length >= KEYBYTES_MIN, 'key must be at least ' + KEYBYTES_MIN + ', was given ' + key.length)
          if (key != null) assert(key.length <= KEYBYTES_MAX, 'key must be at least ' + KEYBYTES_MAX + ', was given ' + key.length)
          if (salt != null) assert(salt.length === SALTBYTES, 'salt must be exactly ' + SALTBYTES + ', was given ' + salt.length)
          if (personal != null) assert(personal.length === PERSONALBYTES, 'personal must be exactly ' + PERSONALBYTES + ', was given ' + personal.length)
        }

        if (!freeList.length) {
          freeList.push(head)
          head += 216
        }

        this.digestLength = digestLength
        this.finalized = false
        this.pointer = freeList.pop()

        wasm.memory.fill(0, 0, 64)
        wasm.memory[0] = this.digestLength
        wasm.memory[1] = key ? key.length : 0
        wasm.memory[2] = 1 // fanout
        wasm.memory[3] = 1 // depth

        if (salt) wasm.memory.set(salt, 32)
        if (personal) wasm.memory.set(personal, 48)

        if (this.pointer + 216 > wasm.memory.length) wasm.realloc(this.pointer + 216) // we need 216 bytes for the state
        wasm.exports.blake2b_init(this.pointer, this.digestLength)

        if (key) {
          this.update(key)
          wasm.memory.fill(0, head, head + key.length) // whiteout key
          wasm.memory[this.pointer + 200] = 128
        }
      }


      Blake2b.prototype.update = function (input) {
        assert(this.finalized === false, 'Hash instance finalized')
        assert(input, 'input must be TypedArray or Buffer')

        if (head + input.length > wasm.memory.length) wasm.realloc(head + input.length)
        wasm.memory.set(input, head)
        wasm.exports.blake2b_update(this.pointer, head, head + input.length)
        return this
      }

      Blake2b.prototype.digest = function (enc) {
        assert(this.finalized === false, 'Hash instance finalized')
        this.finalized = true

        freeList.push(this.pointer)
        wasm.exports.blake2b_final(this.pointer)

        if (!enc || enc === 'binary') {
          return wasm.memory.slice(this.pointer + 128, this.pointer + 128 + this.digestLength)
        }

        if (enc === 'hex') {
          return hexSlice(wasm.memory, this.pointer + 128, this.digestLength)
        }

        assert(enc.length >= this.digestLength, 'input must be TypedArray or Buffer')
        for (var i = 0; i < this.digestLength; i++) {
          enc[i] = wasm.memory[this.pointer + 128 + i]
        }

        return enc
      }

      // libsodium compat
      Blake2b.prototype.final = Blake2b.prototype.digest

      Blake2b.WASM = wasm && wasm.buffer
      Blake2b.SUPPORTED = typeof WebAssembly !== 'undefined'

      Blake2b.ready = function (cb) {
        if (!cb) cb = noop
        if (!wasm) return cb(new Error('WebAssembly not supported'))

        // backwards compat, can be removed in a new major
        var p = new Promise(function (reject, resolve) {
          wasm.onload(function (err) {
            if (err) resolve()
            else reject()
            cb(err)
          })
        })

        return p
      }

      Blake2b.prototype.ready = Blake2b.ready

      function noop() { }

      function hexSlice(buf, start, len) {
        var str = ''
        for (var i = 0; i < len; i++) str += toHex(buf[start + i])
        return str
      }

      function toHex(n) {
        if (n < 16) return '0' + n.toString(16)
        return n.toString(16)
      }

    }, { "./blake2b": 61, "nanoassert": 114 }], 63: [function (require, module, exports) {
      var assert = require('nanoassert')
      var b2wasm = require('blake2b-wasm')

      // 64-bit unsigned addition
      // Sets v[a,a+1] += v[b,b+1]
      // v should be a Uint32Array
      function ADD64AA(v, a, b) {
        var o0 = v[a] + v[b]
        var o1 = v[a + 1] + v[b + 1]
        if (o0 >= 0x100000000) {
          o1++
        }
        v[a] = o0
        v[a + 1] = o1
      }

      // 64-bit unsigned addition
      // Sets v[a,a+1] += b
      // b0 is the low 32 bits of b, b1 represents the high 32 bits
      function ADD64AC(v, a, b0, b1) {
        var o0 = v[a] + b0
        if (b0 < 0) {
          o0 += 0x100000000
        }
        var o1 = v[a + 1] + b1
        if (o0 >= 0x100000000) {
          o1++
        }
        v[a] = o0
        v[a + 1] = o1
      }

      // Little-endian byte access
      function B2B_GET32(arr, i) {
        return (arr[i] ^
          (arr[i + 1] << 8) ^
          (arr[i + 2] << 16) ^
          (arr[i + 3] << 24))
      }

      // G Mixing function
      // The ROTRs are inlined for speed
      function B2B_G(a, b, c, d, ix, iy) {
        var x0 = m[ix]
        var x1 = m[ix + 1]
        var y0 = m[iy]
        var y1 = m[iy + 1]

        ADD64AA(v, a, b) // v[a,a+1] += v[b,b+1] ... in JS we must store a uint64 as two uint32s
        ADD64AC(v, a, x0, x1) // v[a, a+1] += x ... x0 is the low 32 bits of x, x1 is the high 32 bits

        // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated to the right by 32 bits
        var xor0 = v[d] ^ v[a]
        var xor1 = v[d + 1] ^ v[a + 1]
        v[d] = xor1
        v[d + 1] = xor0

        ADD64AA(v, c, d)

        // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 24 bits
        xor0 = v[b] ^ v[c]
        xor1 = v[b + 1] ^ v[c + 1]
        v[b] = (xor0 >>> 24) ^ (xor1 << 8)
        v[b + 1] = (xor1 >>> 24) ^ (xor0 << 8)

        ADD64AA(v, a, b)
        ADD64AC(v, a, y0, y1)

        // v[d,d+1] = (v[d,d+1] xor v[a,a+1]) rotated right by 16 bits
        xor0 = v[d] ^ v[a]
        xor1 = v[d + 1] ^ v[a + 1]
        v[d] = (xor0 >>> 16) ^ (xor1 << 16)
        v[d + 1] = (xor1 >>> 16) ^ (xor0 << 16)

        ADD64AA(v, c, d)

        // v[b,b+1] = (v[b,b+1] xor v[c,c+1]) rotated right by 63 bits
        xor0 = v[b] ^ v[c]
        xor1 = v[b + 1] ^ v[c + 1]
        v[b] = (xor1 >>> 31) ^ (xor0 << 1)
        v[b + 1] = (xor0 >>> 31) ^ (xor1 << 1)
      }

      // Initialization Vector
      var BLAKE2B_IV32 = new Uint32Array([
        0xF3BCC908, 0x6A09E667, 0x84CAA73B, 0xBB67AE85,
        0xFE94F82B, 0x3C6EF372, 0x5F1D36F1, 0xA54FF53A,
        0xADE682D1, 0x510E527F, 0x2B3E6C1F, 0x9B05688C,
        0xFB41BD6B, 0x1F83D9AB, 0x137E2179, 0x5BE0CD19
      ])

      var SIGMA8 = [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
        14, 10, 4, 8, 9, 15, 13, 6, 1, 12, 0, 2, 11, 7, 5, 3,
        11, 8, 12, 0, 5, 2, 15, 13, 10, 14, 3, 6, 7, 1, 9, 4,
        7, 9, 3, 1, 13, 12, 11, 14, 2, 6, 5, 10, 4, 0, 15, 8,
        9, 0, 5, 7, 2, 4, 10, 15, 14, 1, 11, 12, 6, 8, 3, 13,
        2, 12, 6, 10, 0, 11, 8, 3, 4, 13, 7, 5, 15, 14, 1, 9,
        12, 5, 1, 15, 14, 13, 4, 10, 0, 7, 6, 3, 9, 2, 8, 11,
        13, 11, 7, 14, 12, 1, 3, 9, 5, 0, 15, 4, 8, 6, 2, 10,
        6, 15, 14, 9, 11, 3, 0, 8, 12, 2, 13, 7, 1, 4, 10, 5,
        10, 2, 8, 4, 7, 6, 1, 5, 15, 11, 9, 14, 3, 12, 13, 0,
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
        14, 10, 4, 8, 9, 15, 13, 6, 1, 12, 0, 2, 11, 7, 5, 3
      ]

      // These are offsets into a uint64 buffer.
      // Multiply them all by 2 to make them offsets into a uint32 buffer,
      // because this is Javascript and we don't have uint64s
      var SIGMA82 = new Uint8Array(SIGMA8.map(function (x) { return x * 2 }))

      // Compression function. 'last' flag indicates last block.
      // Note we're representing 16 uint64s as 32 uint32s
      var v = new Uint32Array(32)
      var m = new Uint32Array(32)
      function blake2bCompress(ctx, last) {
        var i = 0

        // init work variables
        for (i = 0; i < 16; i++) {
          v[i] = ctx.h[i]
          v[i + 16] = BLAKE2B_IV32[i]
        }

        // low 64 bits of offset
        v[24] = v[24] ^ ctx.t
        v[25] = v[25] ^ (ctx.t / 0x100000000)
        // high 64 bits not supported, offset may not be higher than 2**53-1

        // last block flag set ?
        if (last) {
          v[28] = ~v[28]
          v[29] = ~v[29]
        }

        // get little-endian words
        for (i = 0; i < 32; i++) {
          m[i] = B2B_GET32(ctx.b, 4 * i)
        }

        // twelve rounds of mixing
        for (i = 0; i < 12; i++) {
          B2B_G(0, 8, 16, 24, SIGMA82[i * 16 + 0], SIGMA82[i * 16 + 1])
          B2B_G(2, 10, 18, 26, SIGMA82[i * 16 + 2], SIGMA82[i * 16 + 3])
          B2B_G(4, 12, 20, 28, SIGMA82[i * 16 + 4], SIGMA82[i * 16 + 5])
          B2B_G(6, 14, 22, 30, SIGMA82[i * 16 + 6], SIGMA82[i * 16 + 7])
          B2B_G(0, 10, 20, 30, SIGMA82[i * 16 + 8], SIGMA82[i * 16 + 9])
          B2B_G(2, 12, 22, 24, SIGMA82[i * 16 + 10], SIGMA82[i * 16 + 11])
          B2B_G(4, 14, 16, 26, SIGMA82[i * 16 + 12], SIGMA82[i * 16 + 13])
          B2B_G(6, 8, 18, 28, SIGMA82[i * 16 + 14], SIGMA82[i * 16 + 15])
        }

        for (i = 0; i < 16; i++) {
          ctx.h[i] = ctx.h[i] ^ v[i] ^ v[i + 16]
        }
      }

      // reusable parameter_block
      var parameter_block = new Uint8Array([
        0, 0, 0, 0,      //  0: outlen, keylen, fanout, depth
        0, 0, 0, 0,      //  4: leaf length, sequential mode
        0, 0, 0, 0,      //  8: node offset
        0, 0, 0, 0,      // 12: node offset
        0, 0, 0, 0,      // 16: node depth, inner length, rfu
        0, 0, 0, 0,      // 20: rfu
        0, 0, 0, 0,      // 24: rfu
        0, 0, 0, 0,      // 28: rfu
        0, 0, 0, 0,      // 32: salt
        0, 0, 0, 0,      // 36: salt
        0, 0, 0, 0,      // 40: salt
        0, 0, 0, 0,      // 44: salt
        0, 0, 0, 0,      // 48: personal
        0, 0, 0, 0,      // 52: personal
        0, 0, 0, 0,      // 56: personal
        0, 0, 0, 0       // 60: personal
      ])

      // Creates a BLAKE2b hashing context
      // Requires an output length between 1 and 64 bytes
      // Takes an optional Uint8Array key
      function Blake2b(outlen, key, salt, personal) {
        // zero out parameter_block before usage
        parameter_block.fill(0)
        // state, 'param block'

        this.b = new Uint8Array(128)
        this.h = new Uint32Array(16)
        this.t = 0 // input count
        this.c = 0 // pointer within buffer
        this.outlen = outlen // output length in bytes

        parameter_block[0] = outlen
        if (key) parameter_block[1] = key.length
        parameter_block[2] = 1 // fanout
        parameter_block[3] = 1 // depth

        if (salt) parameter_block.set(salt, 32)
        if (personal) parameter_block.set(personal, 48)

        // initialize hash state
        for (var i = 0; i < 16; i++) {
          this.h[i] = BLAKE2B_IV32[i] ^ B2B_GET32(parameter_block, i * 4)
        }

        // key the hash, if applicable
        if (key) {
          blake2bUpdate(this, key)
          // at the end
          this.c = 128
        }
      }

      Blake2b.prototype.update = function (input) {
        assert(input != null, 'input must be Uint8Array or Buffer')
        blake2bUpdate(this, input)
        return this
      }

      Blake2b.prototype.digest = function (out) {
        var buf = (!out || out === 'binary' || out === 'hex') ? new Uint8Array(this.outlen) : out
        assert(buf.length >= this.outlen, 'out must have at least outlen bytes of space')
        blake2bFinal(this, buf)
        if (out === 'hex') return hexSlice(buf)
        return buf
      }

      Blake2b.prototype.final = Blake2b.prototype.digest

      Blake2b.ready = function (cb) {
        b2wasm.ready(function () {
          cb() // ignore the error
        })
      }

      // Updates a BLAKE2b streaming hash
      // Requires hash context and Uint8Array (byte array)
      function blake2bUpdate(ctx, input) {
        for (var i = 0; i < input.length; i++) {
          if (ctx.c === 128) { // buffer full ?
            ctx.t += ctx.c // add counters
            blake2bCompress(ctx, false) // compress (not last)
            ctx.c = 0 // counter to zero
          }
          ctx.b[ctx.c++] = input[i]
        }
      }

      // Completes a BLAKE2b streaming hash
      // Returns a Uint8Array containing the message digest
      function blake2bFinal(ctx, out) {
        ctx.t += ctx.c // mark last block offset

        while (ctx.c < 128) { // fill up with zeros
          ctx.b[ctx.c++] = 0
        }
        blake2bCompress(ctx, true) // final block flag = 1

        for (var i = 0; i < ctx.outlen; i++) {
          out[i] = ctx.h[i >> 2] >> (8 * (i & 3))
        }
        return out
      }

      function hexSlice(buf) {
        var str = ''
        for (var i = 0; i < buf.length; i++) str += toHex(buf[i])
        return str
      }

      function toHex(n) {
        if (n < 16) return '0' + n.toString(16)
        return n.toString(16)
      }

      var Proto = Blake2b

      module.exports = function createHash(outlen, key, salt, personal, noAssert) {
        if (noAssert !== true) {
          assert(outlen >= BYTES_MIN, 'outlen must be at least ' + BYTES_MIN + ', was given ' + outlen)
          assert(outlen <= BYTES_MAX, 'outlen must be at most ' + BYTES_MAX + ', was given ' + outlen)
          if (key != null) assert(key.length >= KEYBYTES_MIN, 'key must be at least ' + KEYBYTES_MIN + ', was given ' + key.length)
          if (key != null) assert(key.length <= KEYBYTES_MAX, 'key must be at most ' + KEYBYTES_MAX + ', was given ' + key.length)
          if (salt != null) assert(salt.length === SALTBYTES, 'salt must be exactly ' + SALTBYTES + ', was given ' + salt.length)
          if (personal != null) assert(personal.length === PERSONALBYTES, 'personal must be exactly ' + PERSONALBYTES + ', was given ' + personal.length)
        }

        return new Proto(outlen, key, salt, personal)
      }

      module.exports.ready = function (cb) {
        b2wasm.ready(function () { // ignore errors
          cb()
        })
      }

      module.exports.WASM_SUPPORTED = b2wasm.SUPPORTED
      module.exports.WASM_LOADED = false

      var BYTES_MIN = module.exports.BYTES_MIN = 16
      var BYTES_MAX = module.exports.BYTES_MAX = 64
      var BYTES = module.exports.BYTES = 32
      var KEYBYTES_MIN = module.exports.KEYBYTES_MIN = 16
      var KEYBYTES_MAX = module.exports.KEYBYTES_MAX = 64
      var KEYBYTES = module.exports.KEYBYTES = 32
      var SALTBYTES = module.exports.SALTBYTES = 16
      var PERSONALBYTES = module.exports.PERSONALBYTES = 16

      b2wasm.ready(function (err) {
        if (!err) {
          module.exports.WASM_LOADED = true
          Proto = b2wasm
        }
      })

    }, { "blake2b-wasm": 62, "nanoassert": 114 }], 64: [function (require, module, exports) {
      (function (module, exports) {
        'use strict';

        // Utils
        function assert(val, msg) {
          if (!val) throw new Error(msg || 'Assertion failed');
        }

        // Could use `inherits` module, but don't want to move from single file
        // architecture yet.
        function inherits(ctor, superCtor) {
          ctor.super_ = superCtor;
          var TempCtor = function () { };
          TempCtor.prototype = superCtor.prototype;
          ctor.prototype = new TempCtor();
          ctor.prototype.constructor = ctor;
        }

        // BN

        function BN(number, base, endian) {
          if (BN.isBN(number)) {
            return number;
          }

          this.negative = 0;
          this.words = null;
          this.length = 0;

          // Reduction context
          this.red = null;

          if (number !== null) {
            if (base === 'le' || base === 'be') {
              endian = base;
              base = 10;
            }

            this._init(number || 0, base || 10, endian || 'be');
          }
        }
        if (typeof module === 'object') {
          module.exports = BN;
        } else {
          exports.BN = BN;
        }

        BN.BN = BN;
        BN.wordSize = 26;

        var Buffer;
        try {
          if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
            Buffer = window.Buffer;
          } else {
            Buffer = require('buffer').Buffer;
          }
        } catch (e) {
        }

        BN.isBN = function isBN(num) {
          if (num instanceof BN) {
            return true;
          }

          return num !== null && typeof num === 'object' &&
            num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
        };

        BN.max = function max(left, right) {
          if (left.cmp(right) > 0) return left;
          return right;
        };

        BN.min = function min(left, right) {
          if (left.cmp(right) < 0) return left;
          return right;
        };

        BN.prototype._init = function init(number, base, endian) {
          if (typeof number === 'number') {
            return this._initNumber(number, base, endian);
          }

          if (typeof number === 'object') {
            return this._initArray(number, base, endian);
          }

          if (base === 'hex') {
            base = 16;
          }
          assert(base === (base | 0) && base >= 2 && base <= 36);

          number = number.toString().replace(/\s+/g, '');
          var start = 0;
          if (number[0] === '-') {
            start++;
            this.negative = 1;
          }

          if (start < number.length) {
            if (base === 16) {
              this._parseHex(number, start, endian);
            } else {
              this._parseBase(number, base, start);
              if (endian === 'le') {
                this._initArray(this.toArray(), base, endian);
              }
            }
          }
        };

        BN.prototype._initNumber = function _initNumber(number, base, endian) {
          if (number < 0) {
            this.negative = 1;
            number = -number;
          }
          if (number < 0x4000000) {
            this.words = [number & 0x3ffffff];
            this.length = 1;
          } else if (number < 0x10000000000000) {
            this.words = [
              number & 0x3ffffff,
              (number / 0x4000000) & 0x3ffffff
            ];
            this.length = 2;
          } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
              number & 0x3ffffff,
              (number / 0x4000000) & 0x3ffffff,
              1
            ];
            this.length = 3;
          }

          if (endian !== 'le') return;

          // Reverse the bytes
          this._initArray(this.toArray(), base, endian);
        };

        BN.prototype._initArray = function _initArray(number, base, endian) {
          // Perhaps a Uint8Array
          assert(typeof number.length === 'number');
          if (number.length <= 0) {
            this.words = [0];
            this.length = 1;
            return this;
          }

          this.length = Math.ceil(number.length / 3);
          this.words = new Array(this.length);
          for (var i = 0; i < this.length; i++) {
            this.words[i] = 0;
          }

          var j, w;
          var off = 0;
          if (endian === 'be') {
            for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
              w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
              this.words[j] |= (w << off) & 0x3ffffff;
              this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
              off += 24;
              if (off >= 26) {
                off -= 26;
                j++;
              }
            }
          } else if (endian === 'le') {
            for (i = 0, j = 0; i < number.length; i += 3) {
              w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
              this.words[j] |= (w << off) & 0x3ffffff;
              this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
              off += 24;
              if (off >= 26) {
                off -= 26;
                j++;
              }
            }
          }
          return this.strip();
        };

        function parseHex4Bits(string, index) {
          var c = string.charCodeAt(index);
          // 'A' - 'F'
          if (c >= 65 && c <= 70) {
            return c - 55;
            // 'a' - 'f'
          } else if (c >= 97 && c <= 102) {
            return c - 87;
            // '0' - '9'
          } else {
            return (c - 48) & 0xf;
          }
        }

        function parseHexByte(string, lowerBound, index) {
          var r = parseHex4Bits(string, index);
          if (index - 1 >= lowerBound) {
            r |= parseHex4Bits(string, index - 1) << 4;
          }
          return r;
        }

        BN.prototype._parseHex = function _parseHex(number, start, endian) {
          // Create possibly bigger array to ensure that it fits the number
          this.length = Math.ceil((number.length - start) / 6);
          this.words = new Array(this.length);
          for (var i = 0; i < this.length; i++) {
            this.words[i] = 0;
          }

          // 24-bits chunks
          var off = 0;
          var j = 0;

          var w;
          if (endian === 'be') {
            for (i = number.length - 1; i >= start; i -= 2) {
              w = parseHexByte(number, start, i) << off;
              this.words[j] |= w & 0x3ffffff;
              if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
              } else {
                off += 8;
              }
            }
          } else {
            var parseLength = number.length - start;
            for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
              w = parseHexByte(number, start, i) << off;
              this.words[j] |= w & 0x3ffffff;
              if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
              } else {
                off += 8;
              }
            }
          }

          this.strip();
        };

        function parseBase(str, start, end, mul) {
          var r = 0;
          var len = Math.min(str.length, end);
          for (var i = start; i < len; i++) {
            var c = str.charCodeAt(i) - 48;

            r *= mul;

            // 'a'
            if (c >= 49) {
              r += c - 49 + 0xa;

              // 'A'
            } else if (c >= 17) {
              r += c - 17 + 0xa;

              // '0' - '9'
            } else {
              r += c;
            }
          }
          return r;
        }

        BN.prototype._parseBase = function _parseBase(number, base, start) {
          // Initialize as zero
          this.words = [0];
          this.length = 1;

          // Find length of limb in base
          for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
            limbLen++;
          }
          limbLen--;
          limbPow = (limbPow / base) | 0;

          var total = number.length - start;
          var mod = total % limbLen;
          var end = Math.min(total, total - mod) + start;

          var word = 0;
          for (var i = start; i < end; i += limbLen) {
            word = parseBase(number, i, i + limbLen, base);

            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) {
              this.words[0] += word;
            } else {
              this._iaddn(word);
            }
          }

          if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);

            for (i = 0; i < mod; i++) {
              pow *= base;
            }

            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) {
              this.words[0] += word;
            } else {
              this._iaddn(word);
            }
          }

          this.strip();
        };

        BN.prototype.copy = function copy(dest) {
          dest.words = new Array(this.length);
          for (var i = 0; i < this.length; i++) {
            dest.words[i] = this.words[i];
          }
          dest.length = this.length;
          dest.negative = this.negative;
          dest.red = this.red;
        };

        BN.prototype.clone = function clone() {
          var r = new BN(null);
          this.copy(r);
          return r;
        };

        BN.prototype._expand = function _expand(size) {
          while (this.length < size) {
            this.words[this.length++] = 0;
          }
          return this;
        };

        // Remove leading `0` from `this`
        BN.prototype.strip = function strip() {
          while (this.length > 1 && this.words[this.length - 1] === 0) {
            this.length--;
          }
          return this._normSign();
        };

        BN.prototype._normSign = function _normSign() {
          // -0 = 0
          if (this.length === 1 && this.words[0] === 0) {
            this.negative = 0;
          }
          return this;
        };

        BN.prototype.inspect = function inspect() {
          return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
        };

        /*
      
        var zeros = [];
        var groupSizes = [];
        var groupBases = [];
      
        var s = '';
        var i = -1;
        while (++i < BN.wordSize) {
          zeros[i] = s;
          s += '0';
        }
        groupSizes[0] = 0;
        groupSizes[1] = 0;
        groupBases[0] = 0;
        groupBases[1] = 0;
        var base = 2 - 1;
        while (++base < 36 + 1) {
          var groupSize = 0;
          var groupBase = 1;
          while (groupBase < (1 << BN.wordSize) / base) {
            groupBase *= base;
            groupSize += 1;
          }
          groupSizes[base] = groupSize;
          groupBases[base] = groupBase;
        }
      
        */

        var zeros = [
          '',
          '0',
          '00',
          '000',
          '0000',
          '00000',
          '000000',
          '0000000',
          '00000000',
          '000000000',
          '0000000000',
          '00000000000',
          '000000000000',
          '0000000000000',
          '00000000000000',
          '000000000000000',
          '0000000000000000',
          '00000000000000000',
          '000000000000000000',
          '0000000000000000000',
          '00000000000000000000',
          '000000000000000000000',
          '0000000000000000000000',
          '00000000000000000000000',
          '000000000000000000000000',
          '0000000000000000000000000'
        ];

        var groupSizes = [
          0, 0,
          25, 16, 12, 11, 10, 9, 8,
          8, 7, 7, 7, 7, 6, 6,
          6, 6, 6, 6, 6, 5, 5,
          5, 5, 5, 5, 5, 5, 5,
          5, 5, 5, 5, 5, 5, 5
        ];

        var groupBases = [
          0, 0,
          33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
          43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
          16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
          6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
          24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
        ];

        BN.prototype.toString = function toString(base, padding) {
          base = base || 10;
          padding = padding | 0 || 1;

          var out;
          if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for (var i = 0; i < this.length; i++) {
              var w = this.words[i];
              var word = (((w << off) | carry) & 0xffffff).toString(16);
              carry = (w >>> (24 - off)) & 0xffffff;
              if (carry !== 0 || i !== this.length - 1) {
                out = zeros[6 - word.length] + word + out;
              } else {
                out = word + out;
              }
              off += 2;
              if (off >= 26) {
                off -= 26;
                i--;
              }
            }
            if (carry !== 0) {
              out = carry.toString(16) + out;
            }
            while (out.length % padding !== 0) {
              out = '0' + out;
            }
            if (this.negative !== 0) {
              out = '-' + out;
            }
            return out;
          }

          if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while (!c.isZero()) {
              var r = c.modn(groupBase).toString(base);
              c = c.idivn(groupBase);

              if (!c.isZero()) {
                out = zeros[groupSize - r.length] + r + out;
              } else {
                out = r + out;
              }
            }
            if (this.isZero()) {
              out = '0' + out;
            }
            while (out.length % padding !== 0) {
              out = '0' + out;
            }
            if (this.negative !== 0) {
              out = '-' + out;
            }
            return out;
          }

          assert(false, 'Base should be between 2 and 36');
        };

        BN.prototype.toNumber = function toNumber() {
          var ret = this.words[0];
          if (this.length === 2) {
            ret += this.words[1] * 0x4000000;
          } else if (this.length === 3 && this.words[2] === 0x01) {
            // NOTE: at this stage it is known that the top bit is set
            ret += 0x10000000000000 + (this.words[1] * 0x4000000);
          } else if (this.length > 2) {
            assert(false, 'Number can only safely store up to 53 bits');
          }
          return (this.negative !== 0) ? -ret : ret;
        };

        BN.prototype.toJSON = function toJSON() {
          return this.toString(16);
        };

        BN.prototype.toBuffer = function toBuffer(endian, length) {
          assert(typeof Buffer !== 'undefined');
          return this.toArrayLike(Buffer, endian, length);
        };

        BN.prototype.toArray = function toArray(endian, length) {
          return this.toArrayLike(Array, endian, length);
        };

        BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
          var byteLength = this.byteLength();
          var reqLength = length || Math.max(1, byteLength);
          assert(byteLength <= reqLength, 'byte array longer than desired length');
          assert(reqLength > 0, 'Requested array length <= 0');

          this.strip();
          var littleEndian = endian === 'le';
          var res = new ArrayType(reqLength);

          var b, i;
          var q = this.clone();
          if (!littleEndian) {
            // Assume big-endian
            for (i = 0; i < reqLength - byteLength; i++) {
              res[i] = 0;
            }

            for (i = 0; !q.isZero(); i++) {
              b = q.andln(0xff);
              q.iushrn(8);

              res[reqLength - i - 1] = b;
            }
          } else {
            for (i = 0; !q.isZero(); i++) {
              b = q.andln(0xff);
              q.iushrn(8);

              res[i] = b;
            }

            for (; i < reqLength; i++) {
              res[i] = 0;
            }
          }

          return res;
        };

        if (Math.clz32) {
          BN.prototype._countBits = function _countBits(w) {
            return 32 - Math.clz32(w);
          };
        } else {
          BN.prototype._countBits = function _countBits(w) {
            var t = w;
            var r = 0;
            if (t >= 0x1000) {
              r += 13;
              t >>>= 13;
            }
            if (t >= 0x40) {
              r += 7;
              t >>>= 7;
            }
            if (t >= 0x8) {
              r += 4;
              t >>>= 4;
            }
            if (t >= 0x02) {
              r += 2;
              t >>>= 2;
            }
            return r + t;
          };
        }

        BN.prototype._zeroBits = function _zeroBits(w) {
          // Short-cut
          if (w === 0) return 26;

          var t = w;
          var r = 0;
          if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
          }
          if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
          }
          if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
          }
          if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
          }
          if ((t & 0x1) === 0) {
            r++;
          }
          return r;
        };

        // Return number of used bits in a BN
        BN.prototype.bitLength = function bitLength() {
          var w = this.words[this.length - 1];
          var hi = this._countBits(w);
          return (this.length - 1) * 26 + hi;
        };

        function toBitArray(num) {
          var w = new Array(num.bitLength());

          for (var bit = 0; bit < w.length; bit++) {
            var off = (bit / 26) | 0;
            var wbit = bit % 26;

            w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
          }

          return w;
        }

        // Number of trailing zero bits
        BN.prototype.zeroBits = function zeroBits() {
          if (this.isZero()) return 0;

          var r = 0;
          for (var i = 0; i < this.length; i++) {
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
          }
          return r;
        };

        BN.prototype.byteLength = function byteLength() {
          return Math.ceil(this.bitLength() / 8);
        };

        BN.prototype.toTwos = function toTwos(width) {
          if (this.negative !== 0) {
            return this.abs().inotn(width).iaddn(1);
          }
          return this.clone();
        };

        BN.prototype.fromTwos = function fromTwos(width) {
          if (this.testn(width - 1)) {
            return this.notn(width).iaddn(1).ineg();
          }
          return this.clone();
        };

        BN.prototype.isNeg = function isNeg() {
          return this.negative !== 0;
        };

        // Return negative clone of `this`
        BN.prototype.neg = function neg() {
          return this.clone().ineg();
        };

        BN.prototype.ineg = function ineg() {
          if (!this.isZero()) {
            this.negative ^= 1;
          }

          return this;
        };

        // Or `num` with `this` in-place
        BN.prototype.iuor = function iuor(num) {
          while (this.length < num.length) {
            this.words[this.length++] = 0;
          }

          for (var i = 0; i < num.length; i++) {
            this.words[i] = this.words[i] | num.words[i];
          }

          return this.strip();
        };

        BN.prototype.ior = function ior(num) {
          assert((this.negative | num.negative) === 0);
          return this.iuor(num);
        };

        // Or `num` with `this`
        BN.prototype.or = function or(num) {
          if (this.length > num.length) return this.clone().ior(num);
          return num.clone().ior(this);
        };

        BN.prototype.uor = function uor(num) {
          if (this.length > num.length) return this.clone().iuor(num);
          return num.clone().iuor(this);
        };

        // And `num` with `this` in-place
        BN.prototype.iuand = function iuand(num) {
          // b = min-length(num, this)
          var b;
          if (this.length > num.length) {
            b = num;
          } else {
            b = this;
          }

          for (var i = 0; i < b.length; i++) {
            this.words[i] = this.words[i] & num.words[i];
          }

          this.length = b.length;

          return this.strip();
        };

        BN.prototype.iand = function iand(num) {
          assert((this.negative | num.negative) === 0);
          return this.iuand(num);
        };

        // And `num` with `this`
        BN.prototype.and = function and(num) {
          if (this.length > num.length) return this.clone().iand(num);
          return num.clone().iand(this);
        };

        BN.prototype.uand = function uand(num) {
          if (this.length > num.length) return this.clone().iuand(num);
          return num.clone().iuand(this);
        };

        // Xor `num` with `this` in-place
        BN.prototype.iuxor = function iuxor(num) {
          // a.length > b.length
          var a;
          var b;
          if (this.length > num.length) {
            a = this;
            b = num;
          } else {
            a = num;
            b = this;
          }

          for (var i = 0; i < b.length; i++) {
            this.words[i] = a.words[i] ^ b.words[i];
          }

          if (this !== a) {
            for (; i < a.length; i++) {
              this.words[i] = a.words[i];
            }
          }

          this.length = a.length;

          return this.strip();
        };

        BN.prototype.ixor = function ixor(num) {
          assert((this.negative | num.negative) === 0);
          return this.iuxor(num);
        };

        // Xor `num` with `this`
        BN.prototype.xor = function xor(num) {
          if (this.length > num.length) return this.clone().ixor(num);
          return num.clone().ixor(this);
        };

        BN.prototype.uxor = function uxor(num) {
          if (this.length > num.length) return this.clone().iuxor(num);
          return num.clone().iuxor(this);
        };

        // Not ``this`` with ``width`` bitwidth
        BN.prototype.inotn = function inotn(width) {
          assert(typeof width === 'number' && width >= 0);

          var bytesNeeded = Math.ceil(width / 26) | 0;
          var bitsLeft = width % 26;

          // Extend the buffer with leading zeroes
          this._expand(bytesNeeded);

          if (bitsLeft > 0) {
            bytesNeeded--;
          }

          // Handle complete words
          for (var i = 0; i < bytesNeeded; i++) {
            this.words[i] = ~this.words[i] & 0x3ffffff;
          }

          // Handle the residue
          if (bitsLeft > 0) {
            this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
          }

          // And remove leading zeroes
          return this.strip();
        };

        BN.prototype.notn = function notn(width) {
          return this.clone().inotn(width);
        };

        // Set `bit` of `this`
        BN.prototype.setn = function setn(bit, val) {
          assert(typeof bit === 'number' && bit >= 0);

          var off = (bit / 26) | 0;
          var wbit = bit % 26;

          this._expand(off + 1);

          if (val) {
            this.words[off] = this.words[off] | (1 << wbit);
          } else {
            this.words[off] = this.words[off] & ~(1 << wbit);
          }

          return this.strip();
        };

        // Add `num` to `this` in-place
        BN.prototype.iadd = function iadd(num) {
          var r;

          // negative + positive
          if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();

            // positive + negative
          } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
          }

          // a.length > b.length
          var a, b;
          if (this.length > num.length) {
            a = this;
            b = num;
          } else {
            a = num;
            b = this;
          }

          var carry = 0;
          for (var i = 0; i < b.length; i++) {
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
          }
          for (; carry !== 0 && i < a.length; i++) {
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
          }

          this.length = a.length;
          if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
            // Copy the rest of the words
          } else if (a !== this) {
            for (; i < a.length; i++) {
              this.words[i] = a.words[i];
            }
          }

          return this;
        };

        // Add `num` to `this`
        BN.prototype.add = function add(num) {
          var res;
          if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
          } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
          }

          if (this.length > num.length) return this.clone().iadd(num);

          return num.clone().iadd(this);
        };

        // Subtract `num` from `this` in-place
        BN.prototype.isub = function isub(num) {
          // this - (-num) = this + num
          if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();

            // -this - num = -(this + num)
          } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
          }

          // At this point both numbers are positive
          var cmp = this.cmp(num);

          // Optimization - zeroify
          if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
          }

          // a > b
          var a, b;
          if (cmp > 0) {
            a = this;
            b = num;
          } else {
            a = num;
            b = this;
          }

          var carry = 0;
          for (var i = 0; i < b.length; i++) {
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
          }
          for (; carry !== 0 && i < a.length; i++) {
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
          }

          // Copy rest of the words
          if (carry === 0 && i < a.length && a !== this) {
            for (; i < a.length; i++) {
              this.words[i] = a.words[i];
            }
          }

          this.length = Math.max(this.length, i);

          if (a !== this) {
            this.negative = 1;
          }

          return this.strip();
        };

        // Subtract `num` from `this`
        BN.prototype.sub = function sub(num) {
          return this.clone().isub(num);
        };

        function smallMulTo(self, num, out) {
          out.negative = num.negative ^ self.negative;
          var len = (self.length + num.length) | 0;
          out.length = len;
          len = (len - 1) | 0;

          // Peel one iteration (compiler can't do it, because of code complexity)
          var a = self.words[0] | 0;
          var b = num.words[0] | 0;
          var r = a * b;

          var lo = r & 0x3ffffff;
          var carry = (r / 0x4000000) | 0;
          out.words[0] = lo;

          for (var k = 1; k < len; k++) {
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
              var i = (k - j) | 0;
              a = self.words[i] | 0;
              b = num.words[j] | 0;
              r = a * b + rword;
              ncarry += (r / 0x4000000) | 0;
              rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
          }
          if (carry !== 0) {
            out.words[k] = carry | 0;
          } else {
            out.length--;
          }

          return out.strip();
        }

        // TODO(indutny): it may be reasonable to omit it for users who don't need
        // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
        // multiplication (like elliptic secp256k1).
        var comb10MulTo = function comb10MulTo(self, num, out) {
          var a = self.words;
          var b = num.words;
          var o = out.words;
          var c = 0;
          var lo;
          var mid;
          var hi;
          var a0 = a[0] | 0;
          var al0 = a0 & 0x1fff;
          var ah0 = a0 >>> 13;
          var a1 = a[1] | 0;
          var al1 = a1 & 0x1fff;
          var ah1 = a1 >>> 13;
          var a2 = a[2] | 0;
          var al2 = a2 & 0x1fff;
          var ah2 = a2 >>> 13;
          var a3 = a[3] | 0;
          var al3 = a3 & 0x1fff;
          var ah3 = a3 >>> 13;
          var a4 = a[4] | 0;
          var al4 = a4 & 0x1fff;
          var ah4 = a4 >>> 13;
          var a5 = a[5] | 0;
          var al5 = a5 & 0x1fff;
          var ah5 = a5 >>> 13;
          var a6 = a[6] | 0;
          var al6 = a6 & 0x1fff;
          var ah6 = a6 >>> 13;
          var a7 = a[7] | 0;
          var al7 = a7 & 0x1fff;
          var ah7 = a7 >>> 13;
          var a8 = a[8] | 0;
          var al8 = a8 & 0x1fff;
          var ah8 = a8 >>> 13;
          var a9 = a[9] | 0;
          var al9 = a9 & 0x1fff;
          var ah9 = a9 >>> 13;
          var b0 = b[0] | 0;
          var bl0 = b0 & 0x1fff;
          var bh0 = b0 >>> 13;
          var b1 = b[1] | 0;
          var bl1 = b1 & 0x1fff;
          var bh1 = b1 >>> 13;
          var b2 = b[2] | 0;
          var bl2 = b2 & 0x1fff;
          var bh2 = b2 >>> 13;
          var b3 = b[3] | 0;
          var bl3 = b3 & 0x1fff;
          var bh3 = b3 >>> 13;
          var b4 = b[4] | 0;
          var bl4 = b4 & 0x1fff;
          var bh4 = b4 >>> 13;
          var b5 = b[5] | 0;
          var bl5 = b5 & 0x1fff;
          var bh5 = b5 >>> 13;
          var b6 = b[6] | 0;
          var bl6 = b6 & 0x1fff;
          var bh6 = b6 >>> 13;
          var b7 = b[7] | 0;
          var bl7 = b7 & 0x1fff;
          var bh7 = b7 >>> 13;
          var b8 = b[8] | 0;
          var bl8 = b8 & 0x1fff;
          var bh8 = b8 >>> 13;
          var b9 = b[9] | 0;
          var bl9 = b9 & 0x1fff;
          var bh9 = b9 >>> 13;

          out.negative = self.negative ^ num.negative;
          out.length = 19;
          /* k = 0 */
          lo = Math.imul(al0, bl0);
          mid = Math.imul(al0, bh0);
          mid = (mid + Math.imul(ah0, bl0)) | 0;
          hi = Math.imul(ah0, bh0);
          var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
          w0 &= 0x3ffffff;
          /* k = 1 */
          lo = Math.imul(al1, bl0);
          mid = Math.imul(al1, bh0);
          mid = (mid + Math.imul(ah1, bl0)) | 0;
          hi = Math.imul(ah1, bh0);
          lo = (lo + Math.imul(al0, bl1)) | 0;
          mid = (mid + Math.imul(al0, bh1)) | 0;
          mid = (mid + Math.imul(ah0, bl1)) | 0;
          hi = (hi + Math.imul(ah0, bh1)) | 0;
          var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
          w1 &= 0x3ffffff;
          /* k = 2 */
          lo = Math.imul(al2, bl0);
          mid = Math.imul(al2, bh0);
          mid = (mid + Math.imul(ah2, bl0)) | 0;
          hi = Math.imul(ah2, bh0);
          lo = (lo + Math.imul(al1, bl1)) | 0;
          mid = (mid + Math.imul(al1, bh1)) | 0;
          mid = (mid + Math.imul(ah1, bl1)) | 0;
          hi = (hi + Math.imul(ah1, bh1)) | 0;
          lo = (lo + Math.imul(al0, bl2)) | 0;
          mid = (mid + Math.imul(al0, bh2)) | 0;
          mid = (mid + Math.imul(ah0, bl2)) | 0;
          hi = (hi + Math.imul(ah0, bh2)) | 0;
          var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
          w2 &= 0x3ffffff;
          /* k = 3 */
          lo = Math.imul(al3, bl0);
          mid = Math.imul(al3, bh0);
          mid = (mid + Math.imul(ah3, bl0)) | 0;
          hi = Math.imul(ah3, bh0);
          lo = (lo + Math.imul(al2, bl1)) | 0;
          mid = (mid + Math.imul(al2, bh1)) | 0;
          mid = (mid + Math.imul(ah2, bl1)) | 0;
          hi = (hi + Math.imul(ah2, bh1)) | 0;
          lo = (lo + Math.imul(al1, bl2)) | 0;
          mid = (mid + Math.imul(al1, bh2)) | 0;
          mid = (mid + Math.imul(ah1, bl2)) | 0;
          hi = (hi + Math.imul(ah1, bh2)) | 0;
          lo = (lo + Math.imul(al0, bl3)) | 0;
          mid = (mid + Math.imul(al0, bh3)) | 0;
          mid = (mid + Math.imul(ah0, bl3)) | 0;
          hi = (hi + Math.imul(ah0, bh3)) | 0;
          var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
          w3 &= 0x3ffffff;
          /* k = 4 */
          lo = Math.imul(al4, bl0);
          mid = Math.imul(al4, bh0);
          mid = (mid + Math.imul(ah4, bl0)) | 0;
          hi = Math.imul(ah4, bh0);
          lo = (lo + Math.imul(al3, bl1)) | 0;
          mid = (mid + Math.imul(al3, bh1)) | 0;
          mid = (mid + Math.imul(ah3, bl1)) | 0;
          hi = (hi + Math.imul(ah3, bh1)) | 0;
          lo = (lo + Math.imul(al2, bl2)) | 0;
          mid = (mid + Math.imul(al2, bh2)) | 0;
          mid = (mid + Math.imul(ah2, bl2)) | 0;
          hi = (hi + Math.imul(ah2, bh2)) | 0;
          lo = (lo + Math.imul(al1, bl3)) | 0;
          mid = (mid + Math.imul(al1, bh3)) | 0;
          mid = (mid + Math.imul(ah1, bl3)) | 0;
          hi = (hi + Math.imul(ah1, bh3)) | 0;
          lo = (lo + Math.imul(al0, bl4)) | 0;
          mid = (mid + Math.imul(al0, bh4)) | 0;
          mid = (mid + Math.imul(ah0, bl4)) | 0;
          hi = (hi + Math.imul(ah0, bh4)) | 0;
          var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
          w4 &= 0x3ffffff;
          /* k = 5 */
          lo = Math.imul(al5, bl0);
          mid = Math.imul(al5, bh0);
          mid = (mid + Math.imul(ah5, bl0)) | 0;
          hi = Math.imul(ah5, bh0);
          lo = (lo + Math.imul(al4, bl1)) | 0;
          mid = (mid + Math.imul(al4, bh1)) | 0;
          mid = (mid + Math.imul(ah4, bl1)) | 0;
          hi = (hi + Math.imul(ah4, bh1)) | 0;
          lo = (lo + Math.imul(al3, bl2)) | 0;
          mid = (mid + Math.imul(al3, bh2)) | 0;
          mid = (mid + Math.imul(ah3, bl2)) | 0;
          hi = (hi + Math.imul(ah3, bh2)) | 0;
          lo = (lo + Math.imul(al2, bl3)) | 0;
          mid = (mid + Math.imul(al2, bh3)) | 0;
          mid = (mid + Math.imul(ah2, bl3)) | 0;
          hi = (hi + Math.imul(ah2, bh3)) | 0;
          lo = (lo + Math.imul(al1, bl4)) | 0;
          mid = (mid + Math.imul(al1, bh4)) | 0;
          mid = (mid + Math.imul(ah1, bl4)) | 0;
          hi = (hi + Math.imul(ah1, bh4)) | 0;
          lo = (lo + Math.imul(al0, bl5)) | 0;
          mid = (mid + Math.imul(al0, bh5)) | 0;
          mid = (mid + Math.imul(ah0, bl5)) | 0;
          hi = (hi + Math.imul(ah0, bh5)) | 0;
          var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
          w5 &= 0x3ffffff;
          /* k = 6 */
          lo = Math.imul(al6, bl0);
          mid = Math.imul(al6, bh0);
          mid = (mid + Math.imul(ah6, bl0)) | 0;
          hi = Math.imul(ah6, bh0);
          lo = (lo + Math.imul(al5, bl1)) | 0;
          mid = (mid + Math.imul(al5, bh1)) | 0;
          mid = (mid + Math.imul(ah5, bl1)) | 0;
          hi = (hi + Math.imul(ah5, bh1)) | 0;
          lo = (lo + Math.imul(al4, bl2)) | 0;
          mid = (mid + Math.imul(al4, bh2)) | 0;
          mid = (mid + Math.imul(ah4, bl2)) | 0;
          hi = (hi + Math.imul(ah4, bh2)) | 0;
          lo = (lo + Math.imul(al3, bl3)) | 0;
          mid = (mid + Math.imul(al3, bh3)) | 0;
          mid = (mid + Math.imul(ah3, bl3)) | 0;
          hi = (hi + Math.imul(ah3, bh3)) | 0;
          lo = (lo + Math.imul(al2, bl4)) | 0;
          mid = (mid + Math.imul(al2, bh4)) | 0;
          mid = (mid + Math.imul(ah2, bl4)) | 0;
          hi = (hi + Math.imul(ah2, bh4)) | 0;
          lo = (lo + Math.imul(al1, bl5)) | 0;
          mid = (mid + Math.imul(al1, bh5)) | 0;
          mid = (mid + Math.imul(ah1, bl5)) | 0;
          hi = (hi + Math.imul(ah1, bh5)) | 0;
          lo = (lo + Math.imul(al0, bl6)) | 0;
          mid = (mid + Math.imul(al0, bh6)) | 0;
          mid = (mid + Math.imul(ah0, bl6)) | 0;
          hi = (hi + Math.imul(ah0, bh6)) | 0;
          var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
          w6 &= 0x3ffffff;
          /* k = 7 */
          lo = Math.imul(al7, bl0);
          mid = Math.imul(al7, bh0);
          mid = (mid + Math.imul(ah7, bl0)) | 0;
          hi = Math.imul(ah7, bh0);
          lo = (lo + Math.imul(al6, bl1)) | 0;
          mid = (mid + Math.imul(al6, bh1)) | 0;
          mid = (mid + Math.imul(ah6, bl1)) | 0;
          hi = (hi + Math.imul(ah6, bh1)) | 0;
          lo = (lo + Math.imul(al5, bl2)) | 0;
          mid = (mid + Math.imul(al5, bh2)) | 0;
          mid = (mid + Math.imul(ah5, bl2)) | 0;
          hi = (hi + Math.imul(ah5, bh2)) | 0;
          lo = (lo + Math.imul(al4, bl3)) | 0;
          mid = (mid + Math.imul(al4, bh3)) | 0;
          mid = (mid + Math.imul(ah4, bl3)) | 0;
          hi = (hi + Math.imul(ah4, bh3)) | 0;
          lo = (lo + Math.imul(al3, bl4)) | 0;
          mid = (mid + Math.imul(al3, bh4)) | 0;
          mid = (mid + Math.imul(ah3, bl4)) | 0;
          hi = (hi + Math.imul(ah3, bh4)) | 0;
          lo = (lo + Math.imul(al2, bl5)) | 0;
          mid = (mid + Math.imul(al2, bh5)) | 0;
          mid = (mid + Math.imul(ah2, bl5)) | 0;
          hi = (hi + Math.imul(ah2, bh5)) | 0;
          lo = (lo + Math.imul(al1, bl6)) | 0;
          mid = (mid + Math.imul(al1, bh6)) | 0;
          mid = (mid + Math.imul(ah1, bl6)) | 0;
          hi = (hi + Math.imul(ah1, bh6)) | 0;
          lo = (lo + Math.imul(al0, bl7)) | 0;
          mid = (mid + Math.imul(al0, bh7)) | 0;
          mid = (mid + Math.imul(ah0, bl7)) | 0;
          hi = (hi + Math.imul(ah0, bh7)) | 0;
          var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
          w7 &= 0x3ffffff;
          /* k = 8 */
          lo = Math.imul(al8, bl0);
          mid = Math.imul(al8, bh0);
          mid = (mid + Math.imul(ah8, bl0)) | 0;
          hi = Math.imul(ah8, bh0);
          lo = (lo + Math.imul(al7, bl1)) | 0;
          mid = (mid + Math.imul(al7, bh1)) | 0;
          mid = (mid + Math.imul(ah7, bl1)) | 0;
          hi = (hi + Math.imul(ah7, bh1)) | 0;
          lo = (lo + Math.imul(al6, bl2)) | 0;
          mid = (mid + Math.imul(al6, bh2)) | 0;
          mid = (mid + Math.imul(ah6, bl2)) | 0;
          hi = (hi + Math.imul(ah6, bh2)) | 0;
          lo = (lo + Math.imul(al5, bl3)) | 0;
          mid = (mid + Math.imul(al5, bh3)) | 0;
          mid = (mid + Math.imul(ah5, bl3)) | 0;
          hi = (hi + Math.imul(ah5, bh3)) | 0;
          lo = (lo + Math.imul(al4, bl4)) | 0;
          mid = (mid + Math.imul(al4, bh4)) | 0;
          mid = (mid + Math.imul(ah4, bl4)) | 0;
          hi = (hi + Math.imul(ah4, bh4)) | 0;
          lo = (lo + Math.imul(al3, bl5)) | 0;
          mid = (mid + Math.imul(al3, bh5)) | 0;
          mid = (mid + Math.imul(ah3, bl5)) | 0;
          hi = (hi + Math.imul(ah3, bh5)) | 0;
          lo = (lo + Math.imul(al2, bl6)) | 0;
          mid = (mid + Math.imul(al2, bh6)) | 0;
          mid = (mid + Math.imul(ah2, bl6)) | 0;
          hi = (hi + Math.imul(ah2, bh6)) | 0;
          lo = (lo + Math.imul(al1, bl7)) | 0;
          mid = (mid + Math.imul(al1, bh7)) | 0;
          mid = (mid + Math.imul(ah1, bl7)) | 0;
          hi = (hi + Math.imul(ah1, bh7)) | 0;
          lo = (lo + Math.imul(al0, bl8)) | 0;
          mid = (mid + Math.imul(al0, bh8)) | 0;
          mid = (mid + Math.imul(ah0, bl8)) | 0;
          hi = (hi + Math.imul(ah0, bh8)) | 0;
          var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
          w8 &= 0x3ffffff;
          /* k = 9 */
          lo = Math.imul(al9, bl0);
          mid = Math.imul(al9, bh0);
          mid = (mid + Math.imul(ah9, bl0)) | 0;
          hi = Math.imul(ah9, bh0);
          lo = (lo + Math.imul(al8, bl1)) | 0;
          mid = (mid + Math.imul(al8, bh1)) | 0;
          mid = (mid + Math.imul(ah8, bl1)) | 0;
          hi = (hi + Math.imul(ah8, bh1)) | 0;
          lo = (lo + Math.imul(al7, bl2)) | 0;
          mid = (mid + Math.imul(al7, bh2)) | 0;
          mid = (mid + Math.imul(ah7, bl2)) | 0;
          hi = (hi + Math.imul(ah7, bh2)) | 0;
          lo = (lo + Math.imul(al6, bl3)) | 0;
          mid = (mid + Math.imul(al6, bh3)) | 0;
          mid = (mid + Math.imul(ah6, bl3)) | 0;
          hi = (hi + Math.imul(ah6, bh3)) | 0;
          lo = (lo + Math.imul(al5, bl4)) | 0;
          mid = (mid + Math.imul(al5, bh4)) | 0;
          mid = (mid + Math.imul(ah5, bl4)) | 0;
          hi = (hi + Math.imul(ah5, bh4)) | 0;
          lo = (lo + Math.imul(al4, bl5)) | 0;
          mid = (mid + Math.imul(al4, bh5)) | 0;
          mid = (mid + Math.imul(ah4, bl5)) | 0;
          hi = (hi + Math.imul(ah4, bh5)) | 0;
          lo = (lo + Math.imul(al3, bl6)) | 0;
          mid = (mid + Math.imul(al3, bh6)) | 0;
          mid = (mid + Math.imul(ah3, bl6)) | 0;
          hi = (hi + Math.imul(ah3, bh6)) | 0;
          lo = (lo + Math.imul(al2, bl7)) | 0;
          mid = (mid + Math.imul(al2, bh7)) | 0;
          mid = (mid + Math.imul(ah2, bl7)) | 0;
          hi = (hi + Math.imul(ah2, bh7)) | 0;
          lo = (lo + Math.imul(al1, bl8)) | 0;
          mid = (mid + Math.imul(al1, bh8)) | 0;
          mid = (mid + Math.imul(ah1, bl8)) | 0;
          hi = (hi + Math.imul(ah1, bh8)) | 0;
          lo = (lo + Math.imul(al0, bl9)) | 0;
          mid = (mid + Math.imul(al0, bh9)) | 0;
          mid = (mid + Math.imul(ah0, bl9)) | 0;
          hi = (hi + Math.imul(ah0, bh9)) | 0;
          var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
          w9 &= 0x3ffffff;
          /* k = 10 */
          lo = Math.imul(al9, bl1);
          mid = Math.imul(al9, bh1);
          mid = (mid + Math.imul(ah9, bl1)) | 0;
          hi = Math.imul(ah9, bh1);
          lo = (lo + Math.imul(al8, bl2)) | 0;
          mid = (mid + Math.imul(al8, bh2)) | 0;
          mid = (mid + Math.imul(ah8, bl2)) | 0;
          hi = (hi + Math.imul(ah8, bh2)) | 0;
          lo = (lo + Math.imul(al7, bl3)) | 0;
          mid = (mid + Math.imul(al7, bh3)) | 0;
          mid = (mid + Math.imul(ah7, bl3)) | 0;
          hi = (hi + Math.imul(ah7, bh3)) | 0;
          lo = (lo + Math.imul(al6, bl4)) | 0;
          mid = (mid + Math.imul(al6, bh4)) | 0;
          mid = (mid + Math.imul(ah6, bl4)) | 0;
          hi = (hi + Math.imul(ah6, bh4)) | 0;
          lo = (lo + Math.imul(al5, bl5)) | 0;
          mid = (mid + Math.imul(al5, bh5)) | 0;
          mid = (mid + Math.imul(ah5, bl5)) | 0;
          hi = (hi + Math.imul(ah5, bh5)) | 0;
          lo = (lo + Math.imul(al4, bl6)) | 0;
          mid = (mid + Math.imul(al4, bh6)) | 0;
          mid = (mid + Math.imul(ah4, bl6)) | 0;
          hi = (hi + Math.imul(ah4, bh6)) | 0;
          lo = (lo + Math.imul(al3, bl7)) | 0;
          mid = (mid + Math.imul(al3, bh7)) | 0;
          mid = (mid + Math.imul(ah3, bl7)) | 0;
          hi = (hi + Math.imul(ah3, bh7)) | 0;
          lo = (lo + Math.imul(al2, bl8)) | 0;
          mid = (mid + Math.imul(al2, bh8)) | 0;
          mid = (mid + Math.imul(ah2, bl8)) | 0;
          hi = (hi + Math.imul(ah2, bh8)) | 0;
          lo = (lo + Math.imul(al1, bl9)) | 0;
          mid = (mid + Math.imul(al1, bh9)) | 0;
          mid = (mid + Math.imul(ah1, bl9)) | 0;
          hi = (hi + Math.imul(ah1, bh9)) | 0;
          var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
          w10 &= 0x3ffffff;
          /* k = 11 */
          lo = Math.imul(al9, bl2);
          mid = Math.imul(al9, bh2);
          mid = (mid + Math.imul(ah9, bl2)) | 0;
          hi = Math.imul(ah9, bh2);
          lo = (lo + Math.imul(al8, bl3)) | 0;
          mid = (mid + Math.imul(al8, bh3)) | 0;
          mid = (mid + Math.imul(ah8, bl3)) | 0;
          hi = (hi + Math.imul(ah8, bh3)) | 0;
          lo = (lo + Math.imul(al7, bl4)) | 0;
          mid = (mid + Math.imul(al7, bh4)) | 0;
          mid = (mid + Math.imul(ah7, bl4)) | 0;
          hi = (hi + Math.imul(ah7, bh4)) | 0;
          lo = (lo + Math.imul(al6, bl5)) | 0;
          mid = (mid + Math.imul(al6, bh5)) | 0;
          mid = (mid + Math.imul(ah6, bl5)) | 0;
          hi = (hi + Math.imul(ah6, bh5)) | 0;
          lo = (lo + Math.imul(al5, bl6)) | 0;
          mid = (mid + Math.imul(al5, bh6)) | 0;
          mid = (mid + Math.imul(ah5, bl6)) | 0;
          hi = (hi + Math.imul(ah5, bh6)) | 0;
          lo = (lo + Math.imul(al4, bl7)) | 0;
          mid = (mid + Math.imul(al4, bh7)) | 0;
          mid = (mid + Math.imul(ah4, bl7)) | 0;
          hi = (hi + Math.imul(ah4, bh7)) | 0;
          lo = (lo + Math.imul(al3, bl8)) | 0;
          mid = (mid + Math.imul(al3, bh8)) | 0;
          mid = (mid + Math.imul(ah3, bl8)) | 0;
          hi = (hi + Math.imul(ah3, bh8)) | 0;
          lo = (lo + Math.imul(al2, bl9)) | 0;
          mid = (mid + Math.imul(al2, bh9)) | 0;
          mid = (mid + Math.imul(ah2, bl9)) | 0;
          hi = (hi + Math.imul(ah2, bh9)) | 0;
          var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
          w11 &= 0x3ffffff;
          /* k = 12 */
          lo = Math.imul(al9, bl3);
          mid = Math.imul(al9, bh3);
          mid = (mid + Math.imul(ah9, bl3)) | 0;
          hi = Math.imul(ah9, bh3);
          lo = (lo + Math.imul(al8, bl4)) | 0;
          mid = (mid + Math.imul(al8, bh4)) | 0;
          mid = (mid + Math.imul(ah8, bl4)) | 0;
          hi = (hi + Math.imul(ah8, bh4)) | 0;
          lo = (lo + Math.imul(al7, bl5)) | 0;
          mid = (mid + Math.imul(al7, bh5)) | 0;
          mid = (mid + Math.imul(ah7, bl5)) | 0;
          hi = (hi + Math.imul(ah7, bh5)) | 0;
          lo = (lo + Math.imul(al6, bl6)) | 0;
          mid = (mid + Math.imul(al6, bh6)) | 0;
          mid = (mid + Math.imul(ah6, bl6)) | 0;
          hi = (hi + Math.imul(ah6, bh6)) | 0;
          lo = (lo + Math.imul(al5, bl7)) | 0;
          mid = (mid + Math.imul(al5, bh7)) | 0;
          mid = (mid + Math.imul(ah5, bl7)) | 0;
          hi = (hi + Math.imul(ah5, bh7)) | 0;
          lo = (lo + Math.imul(al4, bl8)) | 0;
          mid = (mid + Math.imul(al4, bh8)) | 0;
          mid = (mid + Math.imul(ah4, bl8)) | 0;
          hi = (hi + Math.imul(ah4, bh8)) | 0;
          lo = (lo + Math.imul(al3, bl9)) | 0;
          mid = (mid + Math.imul(al3, bh9)) | 0;
          mid = (mid + Math.imul(ah3, bl9)) | 0;
          hi = (hi + Math.imul(ah3, bh9)) | 0;
          var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
          w12 &= 0x3ffffff;
          /* k = 13 */
          lo = Math.imul(al9, bl4);
          mid = Math.imul(al9, bh4);
          mid = (mid + Math.imul(ah9, bl4)) | 0;
          hi = Math.imul(ah9, bh4);
          lo = (lo + Math.imul(al8, bl5)) | 0;
          mid = (mid + Math.imul(al8, bh5)) | 0;
          mid = (mid + Math.imul(ah8, bl5)) | 0;
          hi = (hi + Math.imul(ah8, bh5)) | 0;
          lo = (lo + Math.imul(al7, bl6)) | 0;
          mid = (mid + Math.imul(al7, bh6)) | 0;
          mid = (mid + Math.imul(ah7, bl6)) | 0;
          hi = (hi + Math.imul(ah7, bh6)) | 0;
          lo = (lo + Math.imul(al6, bl7)) | 0;
          mid = (mid + Math.imul(al6, bh7)) | 0;
          mid = (mid + Math.imul(ah6, bl7)) | 0;
          hi = (hi + Math.imul(ah6, bh7)) | 0;
          lo = (lo + Math.imul(al5, bl8)) | 0;
          mid = (mid + Math.imul(al5, bh8)) | 0;
          mid = (mid + Math.imul(ah5, bl8)) | 0;
          hi = (hi + Math.imul(ah5, bh8)) | 0;
          lo = (lo + Math.imul(al4, bl9)) | 0;
          mid = (mid + Math.imul(al4, bh9)) | 0;
          mid = (mid + Math.imul(ah4, bl9)) | 0;
          hi = (hi + Math.imul(ah4, bh9)) | 0;
          var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
          w13 &= 0x3ffffff;
          /* k = 14 */
          lo = Math.imul(al9, bl5);
          mid = Math.imul(al9, bh5);
          mid = (mid + Math.imul(ah9, bl5)) | 0;
          hi = Math.imul(ah9, bh5);
          lo = (lo + Math.imul(al8, bl6)) | 0;
          mid = (mid + Math.imul(al8, bh6)) | 0;
          mid = (mid + Math.imul(ah8, bl6)) | 0;
          hi = (hi + Math.imul(ah8, bh6)) | 0;
          lo = (lo + Math.imul(al7, bl7)) | 0;
          mid = (mid + Math.imul(al7, bh7)) | 0;
          mid = (mid + Math.imul(ah7, bl7)) | 0;
          hi = (hi + Math.imul(ah7, bh7)) | 0;
          lo = (lo + Math.imul(al6, bl8)) | 0;
          mid = (mid + Math.imul(al6, bh8)) | 0;
          mid = (mid + Math.imul(ah6, bl8)) | 0;
          hi = (hi + Math.imul(ah6, bh8)) | 0;
          lo = (lo + Math.imul(al5, bl9)) | 0;
          mid = (mid + Math.imul(al5, bh9)) | 0;
          mid = (mid + Math.imul(ah5, bl9)) | 0;
          hi = (hi + Math.imul(ah5, bh9)) | 0;
          var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
          w14 &= 0x3ffffff;
          /* k = 15 */
          lo = Math.imul(al9, bl6);
          mid = Math.imul(al9, bh6);
          mid = (mid + Math.imul(ah9, bl6)) | 0;
          hi = Math.imul(ah9, bh6);
          lo = (lo + Math.imul(al8, bl7)) | 0;
          mid = (mid + Math.imul(al8, bh7)) | 0;
          mid = (mid + Math.imul(ah8, bl7)) | 0;
          hi = (hi + Math.imul(ah8, bh7)) | 0;
          lo = (lo + Math.imul(al7, bl8)) | 0;
          mid = (mid + Math.imul(al7, bh8)) | 0;
          mid = (mid + Math.imul(ah7, bl8)) | 0;
          hi = (hi + Math.imul(ah7, bh8)) | 0;
          lo = (lo + Math.imul(al6, bl9)) | 0;
          mid = (mid + Math.imul(al6, bh9)) | 0;
          mid = (mid + Math.imul(ah6, bl9)) | 0;
          hi = (hi + Math.imul(ah6, bh9)) | 0;
          var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
          w15 &= 0x3ffffff;
          /* k = 16 */
          lo = Math.imul(al9, bl7);
          mid = Math.imul(al9, bh7);
          mid = (mid + Math.imul(ah9, bl7)) | 0;
          hi = Math.imul(ah9, bh7);
          lo = (lo + Math.imul(al8, bl8)) | 0;
          mid = (mid + Math.imul(al8, bh8)) | 0;
          mid = (mid + Math.imul(ah8, bl8)) | 0;
          hi = (hi + Math.imul(ah8, bh8)) | 0;
          lo = (lo + Math.imul(al7, bl9)) | 0;
          mid = (mid + Math.imul(al7, bh9)) | 0;
          mid = (mid + Math.imul(ah7, bl9)) | 0;
          hi = (hi + Math.imul(ah7, bh9)) | 0;
          var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
          w16 &= 0x3ffffff;
          /* k = 17 */
          lo = Math.imul(al9, bl8);
          mid = Math.imul(al9, bh8);
          mid = (mid + Math.imul(ah9, bl8)) | 0;
          hi = Math.imul(ah9, bh8);
          lo = (lo + Math.imul(al8, bl9)) | 0;
          mid = (mid + Math.imul(al8, bh9)) | 0;
          mid = (mid + Math.imul(ah8, bl9)) | 0;
          hi = (hi + Math.imul(ah8, bh9)) | 0;
          var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
          w17 &= 0x3ffffff;
          /* k = 18 */
          lo = Math.imul(al9, bl9);
          mid = Math.imul(al9, bh9);
          mid = (mid + Math.imul(ah9, bl9)) | 0;
          hi = Math.imul(ah9, bh9);
          var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
          w18 &= 0x3ffffff;
          o[0] = w0;
          o[1] = w1;
          o[2] = w2;
          o[3] = w3;
          o[4] = w4;
          o[5] = w5;
          o[6] = w6;
          o[7] = w7;
          o[8] = w8;
          o[9] = w9;
          o[10] = w10;
          o[11] = w11;
          o[12] = w12;
          o[13] = w13;
          o[14] = w14;
          o[15] = w15;
          o[16] = w16;
          o[17] = w17;
          o[18] = w18;
          if (c !== 0) {
            o[19] = c;
            out.length++;
          }
          return out;
        };

        // Polyfill comb
        if (!Math.imul) {
          comb10MulTo = smallMulTo;
        }

        function bigMulTo(self, num, out) {
          out.negative = num.negative ^ self.negative;
          out.length = self.length + num.length;

          var carry = 0;
          var hncarry = 0;
          for (var k = 0; k < out.length - 1; k++) {
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
              var i = k - j;
              var a = self.words[i] | 0;
              var b = num.words[j] | 0;
              var r = a * b;

              var lo = r & 0x3ffffff;
              ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
              lo = (lo + rword) | 0;
              rword = lo & 0x3ffffff;
              ncarry = (ncarry + (lo >>> 26)) | 0;

              hncarry += ncarry >>> 26;
              ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
          }
          if (carry !== 0) {
            out.words[k] = carry;
          } else {
            out.length--;
          }

          return out.strip();
        }

        function jumboMulTo(self, num, out) {
          var fftm = new FFTM();
          return fftm.mulp(self, num, out);
        }

        BN.prototype.mulTo = function mulTo(num, out) {
          var res;
          var len = this.length + num.length;
          if (this.length === 10 && num.length === 10) {
            res = comb10MulTo(this, num, out);
          } else if (len < 63) {
            res = smallMulTo(this, num, out);
          } else if (len < 1024) {
            res = bigMulTo(this, num, out);
          } else {
            res = jumboMulTo(this, num, out);
          }

          return res;
        };

        // Cooley-Tukey algorithm for FFT
        // slightly revisited to rely on looping instead of recursion

        function FFTM(x, y) {
          this.x = x;
          this.y = y;
        }

        FFTM.prototype.makeRBT = function makeRBT(N) {
          var t = new Array(N);
          var l = BN.prototype._countBits(N) - 1;
          for (var i = 0; i < N; i++) {
            t[i] = this.revBin(i, l, N);
          }

          return t;
        };

        // Returns binary-reversed representation of `x`
        FFTM.prototype.revBin = function revBin(x, l, N) {
          if (x === 0 || x === N - 1) return x;

          var rb = 0;
          for (var i = 0; i < l; i++) {
            rb |= (x & 1) << (l - i - 1);
            x >>= 1;
          }

          return rb;
        };

        // Performs "tweedling" phase, therefore 'emulating'
        // behaviour of the recursive algorithm
        FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
          for (var i = 0; i < N; i++) {
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
          }
        };

        FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
          this.permute(rbt, rws, iws, rtws, itws, N);

          for (var s = 1; s < N; s <<= 1) {
            var l = s << 1;

            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);

            for (var p = 0; p < N; p += l) {
              var rtwdf_ = rtwdf;
              var itwdf_ = itwdf;

              for (var j = 0; j < s; j++) {
                var re = rtws[p + j];
                var ie = itws[p + j];

                var ro = rtws[p + j + s];
                var io = itws[p + j + s];

                var rx = rtwdf_ * ro - itwdf_ * io;

                io = rtwdf_ * io + itwdf_ * ro;
                ro = rx;

                rtws[p + j] = re + ro;
                itws[p + j] = ie + io;

                rtws[p + j + s] = re - ro;
                itws[p + j + s] = ie - io;

                /* jshint maxdepth : false */
                if (j !== l) {
                  rx = rtwdf * rtwdf_ - itwdf * itwdf_;

                  itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                  rtwdf_ = rx;
                }
              }
            }
          }
        };

        FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
          var N = Math.max(m, n) | 1;
          var odd = N & 1;
          var i = 0;
          for (N = N / 2 | 0; N; N = N >>> 1) {
            i++;
          }

          return 1 << i + 1 + odd;
        };

        FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
          if (N <= 1) return;

          for (var i = 0; i < N / 2; i++) {
            var t = rws[i];

            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;

            t = iws[i];

            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
          }
        };

        FFTM.prototype.normalize13b = function normalize13b(ws, N) {
          var carry = 0;
          for (var i = 0; i < N / 2; i++) {
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
              Math.round(ws[2 * i] / N) +
              carry;

            ws[i] = w & 0x3ffffff;

            if (w < 0x4000000) {
              carry = 0;
            } else {
              carry = w / 0x4000000 | 0;
            }
          }

          return ws;
        };

        FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
          var carry = 0;
          for (var i = 0; i < len; i++) {
            carry = carry + (ws[i] | 0);

            rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
          }

          // Pad with zeroes
          for (i = 2 * len; i < N; ++i) {
            rws[i] = 0;
          }

          assert(carry === 0);
          assert((carry & ~0x1fff) === 0);
        };

        FFTM.prototype.stub = function stub(N) {
          var ph = new Array(N);
          for (var i = 0; i < N; i++) {
            ph[i] = 0;
          }

          return ph;
        };

        FFTM.prototype.mulp = function mulp(x, y, out) {
          var N = 2 * this.guessLen13b(x.length, y.length);

          var rbt = this.makeRBT(N);

          var _ = this.stub(N);

          var rws = new Array(N);
          var rwst = new Array(N);
          var iwst = new Array(N);

          var nrws = new Array(N);
          var nrwst = new Array(N);
          var niwst = new Array(N);

          var rmws = out.words;
          rmws.length = N;

          this.convert13b(x.words, x.length, rws, N);
          this.convert13b(y.words, y.length, nrws, N);

          this.transform(rws, _, rwst, iwst, N, rbt);
          this.transform(nrws, _, nrwst, niwst, N, rbt);

          for (var i = 0; i < N; i++) {
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
          }

          this.conjugate(rwst, iwst, N);
          this.transform(rwst, iwst, rmws, _, N, rbt);
          this.conjugate(rmws, _, N);
          this.normalize13b(rmws, N);

          out.negative = x.negative ^ y.negative;
          out.length = x.length + y.length;
          return out.strip();
        };

        // Multiply `this` by `num`
        BN.prototype.mul = function mul(num) {
          var out = new BN(null);
          out.words = new Array(this.length + num.length);
          return this.mulTo(num, out);
        };

        // Multiply employing FFT
        BN.prototype.mulf = function mulf(num) {
          var out = new BN(null);
          out.words = new Array(this.length + num.length);
          return jumboMulTo(this, num, out);
        };

        // In-place Multiplication
        BN.prototype.imul = function imul(num) {
          return this.clone().mulTo(num, this);
        };

        BN.prototype.imuln = function imuln(num) {
          assert(typeof num === 'number');
          assert(num < 0x4000000);

          // Carry
          var carry = 0;
          for (var i = 0; i < this.length; i++) {
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += (w / 0x4000000) | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
          }

          if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
          }

          return this;
        };

        BN.prototype.muln = function muln(num) {
          return this.clone().imuln(num);
        };

        // `this` * `this`
        BN.prototype.sqr = function sqr() {
          return this.mul(this);
        };

        // `this` * `this` in-place
        BN.prototype.isqr = function isqr() {
          return this.imul(this.clone());
        };

        // Math.pow(`this`, `num`)
        BN.prototype.pow = function pow(num) {
          var w = toBitArray(num);
          if (w.length === 0) return new BN(1);

          // Skip leading zeroes
          var res = this;
          for (var i = 0; i < w.length; i++, res = res.sqr()) {
            if (w[i] !== 0) break;
          }

          if (++i < w.length) {
            for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
              if (w[i] === 0) continue;

              res = res.mul(q);
            }
          }

          return res;
        };

        // Shift-left in-place
        BN.prototype.iushln = function iushln(bits) {
          assert(typeof bits === 'number' && bits >= 0);
          var r = bits % 26;
          var s = (bits - r) / 26;
          var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
          var i;

          if (r !== 0) {
            var carry = 0;

            for (i = 0; i < this.length; i++) {
              var newCarry = this.words[i] & carryMask;
              var c = ((this.words[i] | 0) - newCarry) << r;
              this.words[i] = c | carry;
              carry = newCarry >>> (26 - r);
            }

            if (carry) {
              this.words[i] = carry;
              this.length++;
            }
          }

          if (s !== 0) {
            for (i = this.length - 1; i >= 0; i--) {
              this.words[i + s] = this.words[i];
            }

            for (i = 0; i < s; i++) {
              this.words[i] = 0;
            }

            this.length += s;
          }

          return this.strip();
        };

        BN.prototype.ishln = function ishln(bits) {
          // TODO(indutny): implement me
          assert(this.negative === 0);
          return this.iushln(bits);
        };

        // Shift-right in-place
        // NOTE: `hint` is a lowest bit before trailing zeroes
        // NOTE: if `extended` is present - it will be filled with destroyed bits
        BN.prototype.iushrn = function iushrn(bits, hint, extended) {
          assert(typeof bits === 'number' && bits >= 0);
          var h;
          if (hint) {
            h = (hint - (hint % 26)) / 26;
          } else {
            h = 0;
          }

          var r = bits % 26;
          var s = Math.min((bits - r) / 26, this.length);
          var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
          var maskedWords = extended;

          h -= s;
          h = Math.max(0, h);

          // Extended mode, copy masked part
          if (maskedWords) {
            for (var i = 0; i < s; i++) {
              maskedWords.words[i] = this.words[i];
            }
            maskedWords.length = s;
          }

          if (s === 0) {
            // No-op, we should not move anything at all
          } else if (this.length > s) {
            this.length -= s;
            for (i = 0; i < this.length; i++) {
              this.words[i] = this.words[i + s];
            }
          } else {
            this.words[0] = 0;
            this.length = 1;
          }

          var carry = 0;
          for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
            var word = this.words[i] | 0;
            this.words[i] = (carry << (26 - r)) | (word >>> r);
            carry = word & mask;
          }

          // Push carried bits as a mask
          if (maskedWords && carry !== 0) {
            maskedWords.words[maskedWords.length++] = carry;
          }

          if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
          }

          return this.strip();
        };

        BN.prototype.ishrn = function ishrn(bits, hint, extended) {
          // TODO(indutny): implement me
          assert(this.negative === 0);
          return this.iushrn(bits, hint, extended);
        };

        // Shift-left
        BN.prototype.shln = function shln(bits) {
          return this.clone().ishln(bits);
        };

        BN.prototype.ushln = function ushln(bits) {
          return this.clone().iushln(bits);
        };

        // Shift-right
        BN.prototype.shrn = function shrn(bits) {
          return this.clone().ishrn(bits);
        };

        BN.prototype.ushrn = function ushrn(bits) {
          return this.clone().iushrn(bits);
        };

        // Test if n bit is set
        BN.prototype.testn = function testn(bit) {
          assert(typeof bit === 'number' && bit >= 0);
          var r = bit % 26;
          var s = (bit - r) / 26;
          var q = 1 << r;

          // Fast case: bit is much higher than all existing words
          if (this.length <= s) return false;

          // Check bit and return
          var w = this.words[s];

          return !!(w & q);
        };

        // Return only lowers bits of number (in-place)
        BN.prototype.imaskn = function imaskn(bits) {
          assert(typeof bits === 'number' && bits >= 0);
          var r = bits % 26;
          var s = (bits - r) / 26;

          assert(this.negative === 0, 'imaskn works only with positive numbers');

          if (this.length <= s) {
            return this;
          }

          if (r !== 0) {
            s++;
          }
          this.length = Math.min(s, this.length);

          if (r !== 0) {
            var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
            this.words[this.length - 1] &= mask;
          }

          return this.strip();
        };

        // Return only lowers bits of number
        BN.prototype.maskn = function maskn(bits) {
          return this.clone().imaskn(bits);
        };

        // Add plain number `num` to `this`
        BN.prototype.iaddn = function iaddn(num) {
          assert(typeof num === 'number');
          assert(num < 0x4000000);
          if (num < 0) return this.isubn(-num);

          // Possible sign change
          if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
              this.words[0] = num - (this.words[0] | 0);
              this.negative = 0;
              return this;
            }

            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
          }

          // Add without checks
          return this._iaddn(num);
        };

        BN.prototype._iaddn = function _iaddn(num) {
          this.words[0] += num;

          // Carry
          for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) {
              this.words[i + 1] = 1;
            } else {
              this.words[i + 1]++;
            }
          }
          this.length = Math.max(this.length, i + 1);

          return this;
        };

        // Subtract plain number `num` from `this`
        BN.prototype.isubn = function isubn(num) {
          assert(typeof num === 'number');
          assert(num < 0x4000000);
          if (num < 0) return this.iaddn(-num);

          if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
          }

          this.words[0] -= num;

          if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
          } else {
            // Carry
            for (var i = 0; i < this.length && this.words[i] < 0; i++) {
              this.words[i] += 0x4000000;
              this.words[i + 1] -= 1;
            }
          }

          return this.strip();
        };

        BN.prototype.addn = function addn(num) {
          return this.clone().iaddn(num);
        };

        BN.prototype.subn = function subn(num) {
          return this.clone().isubn(num);
        };

        BN.prototype.iabs = function iabs() {
          this.negative = 0;

          return this;
        };

        BN.prototype.abs = function abs() {
          return this.clone().iabs();
        };

        BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
          var len = num.length + shift;
          var i;

          this._expand(len);

          var w;
          var carry = 0;
          for (i = 0; i < num.length; i++) {
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - ((right / 0x4000000) | 0);
            this.words[i + shift] = w & 0x3ffffff;
          }
          for (; i < this.length - shift; i++) {
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
          }

          if (carry === 0) return this.strip();

          // Subtraction overflow
          assert(carry === -1);
          carry = 0;
          for (i = 0; i < this.length; i++) {
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
          }
          this.negative = 1;

          return this.strip();
        };

        BN.prototype._wordDiv = function _wordDiv(num, mode) {
          var shift = this.length - num.length;

          var a = this.clone();
          var b = num;

          // Normalize
          var bhi = b.words[b.length - 1] | 0;
          var bhiBits = this._countBits(bhi);
          shift = 26 - bhiBits;
          if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
          }

          // Initialize quotient
          var m = a.length - b.length;
          var q;

          if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for (var i = 0; i < q.length; i++) {
              q.words[i] = 0;
            }
          }

          var diff = a.clone()._ishlnsubmul(b, 1, m);
          if (diff.negative === 0) {
            a = diff;
            if (q) {
              q.words[m] = 1;
            }
          }

          for (var j = m - 1; j >= 0; j--) {
            var qj = (a.words[b.length + j] | 0) * 0x4000000 +
              (a.words[b.length + j - 1] | 0);

            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min((qj / bhi) | 0, 0x3ffffff);

            a._ishlnsubmul(b, qj, j);
            while (a.negative !== 0) {
              qj--;
              a.negative = 0;
              a._ishlnsubmul(b, 1, j);
              if (!a.isZero()) {
                a.negative ^= 1;
              }
            }
            if (q) {
              q.words[j] = qj;
            }
          }
          if (q) {
            q.strip();
          }
          a.strip();

          // Denormalize
          if (mode !== 'div' && shift !== 0) {
            a.iushrn(shift);
          }

          return {
            div: q || null,
            mod: a
          };
        };

        // NOTE: 1) `mode` can be set to `mod` to request mod only,
        //       to `div` to request div only, or be absent to
        //       request both div & mod
        //       2) `positive` is true if unsigned mod is requested
        BN.prototype.divmod = function divmod(num, mode, positive) {
          assert(!num.isZero());

          if (this.isZero()) {
            return {
              div: new BN(0),
              mod: new BN(0)
            };
          }

          var div, mod, res;
          if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);

            if (mode !== 'mod') {
              div = res.div.neg();
            }

            if (mode !== 'div') {
              mod = res.mod.neg();
              if (positive && mod.negative !== 0) {
                mod.iadd(num);
              }
            }

            return {
              div: div,
              mod: mod
            };
          }

          if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);

            if (mode !== 'mod') {
              div = res.div.neg();
            }

            return {
              div: div,
              mod: res.mod
            };
          }

          if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);

            if (mode !== 'div') {
              mod = res.mod.neg();
              if (positive && mod.negative !== 0) {
                mod.isub(num);
              }
            }

            return {
              div: res.div,
              mod: mod
            };
          }

          // Both numbers are positive at this point

          // Strip both numbers to approximate shift value
          if (num.length > this.length || this.cmp(num) < 0) {
            return {
              div: new BN(0),
              mod: this
            };
          }

          // Very short reduction
          if (num.length === 1) {
            if (mode === 'div') {
              return {
                div: this.divn(num.words[0]),
                mod: null
              };
            }

            if (mode === 'mod') {
              return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
              };
            }

            return {
              div: this.divn(num.words[0]),
              mod: new BN(this.modn(num.words[0]))
            };
          }

          return this._wordDiv(num, mode);
        };

        // Find `this` / `num`
        BN.prototype.div = function div(num) {
          return this.divmod(num, 'div', false).div;
        };

        // Find `this` % `num`
        BN.prototype.mod = function mod(num) {
          return this.divmod(num, 'mod', false).mod;
        };

        BN.prototype.umod = function umod(num) {
          return this.divmod(num, 'mod', true).mod;
        };

        // Find Round(`this` / `num`)
        BN.prototype.divRound = function divRound(num) {
          var dm = this.divmod(num);

          // Fast case - exact division
          if (dm.mod.isZero()) return dm.div;

          var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

          var half = num.ushrn(1);
          var r2 = num.andln(1);
          var cmp = mod.cmp(half);

          // Round down
          if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

          // Round up
          return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
        };

        BN.prototype.modn = function modn(num) {
          assert(num <= 0x3ffffff);
          var p = (1 << 26) % num;

          var acc = 0;
          for (var i = this.length - 1; i >= 0; i--) {
            acc = (p * acc + (this.words[i] | 0)) % num;
          }

          return acc;
        };

        // In-place division by number
        BN.prototype.idivn = function idivn(num) {
          assert(num <= 0x3ffffff);

          var carry = 0;
          for (var i = this.length - 1; i >= 0; i--) {
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = (w / num) | 0;
            carry = w % num;
          }

          return this.strip();
        };

        BN.prototype.divn = function divn(num) {
          return this.clone().idivn(num);
        };

        BN.prototype.egcd = function egcd(p) {
          assert(p.negative === 0);
          assert(!p.isZero());

          var x = this;
          var y = p.clone();

          if (x.negative !== 0) {
            x = x.umod(p);
          } else {
            x = x.clone();
          }

          // A * x + B * y = x
          var A = new BN(1);
          var B = new BN(0);

          // C * x + D * y = y
          var C = new BN(0);
          var D = new BN(1);

          var g = 0;

          while (x.isEven() && y.isEven()) {
            x.iushrn(1);
            y.iushrn(1);
            ++g;
          }

          var yp = y.clone();
          var xp = x.clone();

          while (!x.isZero()) {
            for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
              x.iushrn(i);
              while (i-- > 0) {
                if (A.isOdd() || B.isOdd()) {
                  A.iadd(yp);
                  B.isub(xp);
                }

                A.iushrn(1);
                B.iushrn(1);
              }
            }

            for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
              y.iushrn(j);
              while (j-- > 0) {
                if (C.isOdd() || D.isOdd()) {
                  C.iadd(yp);
                  D.isub(xp);
                }

                C.iushrn(1);
                D.iushrn(1);
              }
            }

            if (x.cmp(y) >= 0) {
              x.isub(y);
              A.isub(C);
              B.isub(D);
            } else {
              y.isub(x);
              C.isub(A);
              D.isub(B);
            }
          }

          return {
            a: C,
            b: D,
            gcd: y.iushln(g)
          };
        };

        // This is reduced incarnation of the binary EEA
        // above, designated to invert members of the
        // _prime_ fields F(p) at a maximal speed
        BN.prototype._invmp = function _invmp(p) {
          assert(p.negative === 0);
          assert(!p.isZero());

          var a = this;
          var b = p.clone();

          if (a.negative !== 0) {
            a = a.umod(p);
          } else {
            a = a.clone();
          }

          var x1 = new BN(1);
          var x2 = new BN(0);

          var delta = b.clone();

          while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
            for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
              a.iushrn(i);
              while (i-- > 0) {
                if (x1.isOdd()) {
                  x1.iadd(delta);
                }

                x1.iushrn(1);
              }
            }

            for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
              b.iushrn(j);
              while (j-- > 0) {
                if (x2.isOdd()) {
                  x2.iadd(delta);
                }

                x2.iushrn(1);
              }
            }

            if (a.cmp(b) >= 0) {
              a.isub(b);
              x1.isub(x2);
            } else {
              b.isub(a);
              x2.isub(x1);
            }
          }

          var res;
          if (a.cmpn(1) === 0) {
            res = x1;
          } else {
            res = x2;
          }

          if (res.cmpn(0) < 0) {
            res.iadd(p);
          }

          return res;
        };

        BN.prototype.gcd = function gcd(num) {
          if (this.isZero()) return num.abs();
          if (num.isZero()) return this.abs();

          var a = this.clone();
          var b = num.clone();
          a.negative = 0;
          b.negative = 0;

          // Remove common factor of two
          for (var shift = 0; a.isEven() && b.isEven(); shift++) {
            a.iushrn(1);
            b.iushrn(1);
          }

          do {
            while (a.isEven()) {
              a.iushrn(1);
            }
            while (b.isEven()) {
              b.iushrn(1);
            }

            var r = a.cmp(b);
            if (r < 0) {
              // Swap `a` and `b` to make `a` always bigger than `b`
              var t = a;
              a = b;
              b = t;
            } else if (r === 0 || b.cmpn(1) === 0) {
              break;
            }

            a.isub(b);
          } while (true);

          return b.iushln(shift);
        };

        // Invert number in the field F(num)
        BN.prototype.invm = function invm(num) {
          return this.egcd(num).a.umod(num);
        };

        BN.prototype.isEven = function isEven() {
          return (this.words[0] & 1) === 0;
        };

        BN.prototype.isOdd = function isOdd() {
          return (this.words[0] & 1) === 1;
        };

        // And first word and num
        BN.prototype.andln = function andln(num) {
          return this.words[0] & num;
        };

        // Increment at the bit position in-line
        BN.prototype.bincn = function bincn(bit) {
          assert(typeof bit === 'number');
          var r = bit % 26;
          var s = (bit - r) / 26;
          var q = 1 << r;

          // Fast case: bit is much higher than all existing words
          if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
          }

          // Add bit and propagate, if needed
          var carry = q;
          for (var i = s; carry !== 0 && i < this.length; i++) {
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
          }
          if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
          }
          return this;
        };

        BN.prototype.isZero = function isZero() {
          return this.length === 1 && this.words[0] === 0;
        };

        BN.prototype.cmpn = function cmpn(num) {
          var negative = num < 0;

          if (this.negative !== 0 && !negative) return -1;
          if (this.negative === 0 && negative) return 1;

          this.strip();

          var res;
          if (this.length > 1) {
            res = 1;
          } else {
            if (negative) {
              num = -num;
            }

            assert(num <= 0x3ffffff, 'Number is too big');

            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
          }
          if (this.negative !== 0) return -res | 0;
          return res;
        };

        // Compare two numbers and return:
        // 1 - if `this` > `num`
        // 0 - if `this` == `num`
        // -1 - if `this` < `num`
        BN.prototype.cmp = function cmp(num) {
          if (this.negative !== 0 && num.negative === 0) return -1;
          if (this.negative === 0 && num.negative !== 0) return 1;

          var res = this.ucmp(num);
          if (this.negative !== 0) return -res | 0;
          return res;
        };

        // Unsigned comparison
        BN.prototype.ucmp = function ucmp(num) {
          // At this point both numbers have the same sign
          if (this.length > num.length) return 1;
          if (this.length < num.length) return -1;

          var res = 0;
          for (var i = this.length - 1; i >= 0; i--) {
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;

            if (a === b) continue;
            if (a < b) {
              res = -1;
            } else if (a > b) {
              res = 1;
            }
            break;
          }
          return res;
        };

        BN.prototype.gtn = function gtn(num) {
          return this.cmpn(num) === 1;
        };

        BN.prototype.gt = function gt(num) {
          return this.cmp(num) === 1;
        };

        BN.prototype.gten = function gten(num) {
          return this.cmpn(num) >= 0;
        };

        BN.prototype.gte = function gte(num) {
          return this.cmp(num) >= 0;
        };

        BN.prototype.ltn = function ltn(num) {
          return this.cmpn(num) === -1;
        };

        BN.prototype.lt = function lt(num) {
          return this.cmp(num) === -1;
        };

        BN.prototype.lten = function lten(num) {
          return this.cmpn(num) <= 0;
        };

        BN.prototype.lte = function lte(num) {
          return this.cmp(num) <= 0;
        };

        BN.prototype.eqn = function eqn(num) {
          return this.cmpn(num) === 0;
        };

        BN.prototype.eq = function eq(num) {
          return this.cmp(num) === 0;
        };

        //
        // A reduce context, could be using montgomery or something better, depending
        // on the `m` itself.
        //
        BN.red = function red(num) {
          return new Red(num);
        };

        BN.prototype.toRed = function toRed(ctx) {
          assert(!this.red, 'Already a number in reduction context');
          assert(this.negative === 0, 'red works only with positives');
          return ctx.convertTo(this)._forceRed(ctx);
        };

        BN.prototype.fromRed = function fromRed() {
          assert(this.red, 'fromRed works only with numbers in reduction context');
          return this.red.convertFrom(this);
        };

        BN.prototype._forceRed = function _forceRed(ctx) {
          this.red = ctx;
          return this;
        };

        BN.prototype.forceRed = function forceRed(ctx) {
          assert(!this.red, 'Already a number in reduction context');
          return this._forceRed(ctx);
        };

        BN.prototype.redAdd = function redAdd(num) {
          assert(this.red, 'redAdd works only with red numbers');
          return this.red.add(this, num);
        };

        BN.prototype.redIAdd = function redIAdd(num) {
          assert(this.red, 'redIAdd works only with red numbers');
          return this.red.iadd(this, num);
        };

        BN.prototype.redSub = function redSub(num) {
          assert(this.red, 'redSub works only with red numbers');
          return this.red.sub(this, num);
        };

        BN.prototype.redISub = function redISub(num) {
          assert(this.red, 'redISub works only with red numbers');
          return this.red.isub(this, num);
        };

        BN.prototype.redShl = function redShl(num) {
          assert(this.red, 'redShl works only with red numbers');
          return this.red.shl(this, num);
        };

        BN.prototype.redMul = function redMul(num) {
          assert(this.red, 'redMul works only with red numbers');
          this.red._verify2(this, num);
          return this.red.mul(this, num);
        };

        BN.prototype.redIMul = function redIMul(num) {
          assert(this.red, 'redMul works only with red numbers');
          this.red._verify2(this, num);
          return this.red.imul(this, num);
        };

        BN.prototype.redSqr = function redSqr() {
          assert(this.red, 'redSqr works only with red numbers');
          this.red._verify1(this);
          return this.red.sqr(this);
        };

        BN.prototype.redISqr = function redISqr() {
          assert(this.red, 'redISqr works only with red numbers');
          this.red._verify1(this);
          return this.red.isqr(this);
        };

        // Square root over p
        BN.prototype.redSqrt = function redSqrt() {
          assert(this.red, 'redSqrt works only with red numbers');
          this.red._verify1(this);
          return this.red.sqrt(this);
        };

        BN.prototype.redInvm = function redInvm() {
          assert(this.red, 'redInvm works only with red numbers');
          this.red._verify1(this);
          return this.red.invm(this);
        };

        // Return negative clone of `this` % `red modulo`
        BN.prototype.redNeg = function redNeg() {
          assert(this.red, 'redNeg works only with red numbers');
          this.red._verify1(this);
          return this.red.neg(this);
        };

        BN.prototype.redPow = function redPow(num) {
          assert(this.red && !num.red, 'redPow(normalNum)');
          this.red._verify1(this);
          return this.red.pow(this, num);
        };

        // Prime numbers with efficient reduction
        var primes = {
          k256: null,
          p224: null,
          p192: null,
          p25519: null
        };

        // Pseudo-Mersenne prime
        function MPrime(name, p) {
          // P = 2 ^ N - K
          this.name = name;
          this.p = new BN(p, 16);
          this.n = this.p.bitLength();
          this.k = new BN(1).iushln(this.n).isub(this.p);

          this.tmp = this._tmp();
        }

        MPrime.prototype._tmp = function _tmp() {
          var tmp = new BN(null);
          tmp.words = new Array(Math.ceil(this.n / 13));
          return tmp;
        };

        MPrime.prototype.ireduce = function ireduce(num) {
          // Assumes that `num` is less than `P^2`
          // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
          var r = num;
          var rlen;

          do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
          } while (rlen > this.n);

          var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
          if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
          } else if (cmp > 0) {
            r.isub(this.p);
          } else {
            if (r.strip !== undefined) {
              // r is BN v4 instance
              r.strip();
            } else {
              // r is BN v5 instance
              r._strip();
            }
          }

          return r;
        };

        MPrime.prototype.split = function split(input, out) {
          input.iushrn(this.n, 0, out);
        };

        MPrime.prototype.imulK = function imulK(num) {
          return num.imul(this.k);
        };

        function K256() {
          MPrime.call(
            this,
            'k256',
            'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
        }
        inherits(K256, MPrime);

        K256.prototype.split = function split(input, output) {
          // 256 = 9 * 26 + 22
          var mask = 0x3fffff;

          var outLen = Math.min(input.length, 9);
          for (var i = 0; i < outLen; i++) {
            output.words[i] = input.words[i];
          }
          output.length = outLen;

          if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
          }

          // Shift by 9 limbs
          var prev = input.words[9];
          output.words[output.length++] = prev & mask;

          for (i = 10; i < input.length; i++) {
            var next = input.words[i] | 0;
            input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
            prev = next;
          }
          prev >>>= 22;
          input.words[i - 10] = prev;
          if (prev === 0 && input.length > 10) {
            input.length -= 10;
          } else {
            input.length -= 9;
          }
        };

        K256.prototype.imulK = function imulK(num) {
          // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
          num.words[num.length] = 0;
          num.words[num.length + 1] = 0;
          num.length += 2;

          // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
          var lo = 0;
          for (var i = 0; i < num.length; i++) {
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + ((lo / 0x4000000) | 0);
          }

          // Fast length reduction
          if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) {
              num.length--;
            }
          }
          return num;
        };

        function P224() {
          MPrime.call(
            this,
            'p224',
            'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
        }
        inherits(P224, MPrime);

        function P192() {
          MPrime.call(
            this,
            'p192',
            'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
        }
        inherits(P192, MPrime);

        function P25519() {
          // 2 ^ 255 - 19
          MPrime.call(
            this,
            '25519',
            '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
        }
        inherits(P25519, MPrime);

        P25519.prototype.imulK = function imulK(num) {
          // K = 0x13
          var carry = 0;
          for (var i = 0; i < num.length; i++) {
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;

            num.words[i] = lo;
            carry = hi;
          }
          if (carry !== 0) {
            num.words[num.length++] = carry;
          }
          return num;
        };

        // Exported mostly for testing purposes, use plain name instead
        BN._prime = function prime(name) {
          // Cached version of prime
          if (primes[name]) return primes[name];

          var prime;
          if (name === 'k256') {
            prime = new K256();
          } else if (name === 'p224') {
            prime = new P224();
          } else if (name === 'p192') {
            prime = new P192();
          } else if (name === 'p25519') {
            prime = new P25519();
          } else {
            throw new Error('Unknown prime ' + name);
          }
          primes[name] = prime;

          return prime;
        };

        //
        // Base reduction engine
        //
        function Red(m) {
          if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
          } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
          }
        }

        Red.prototype._verify1 = function _verify1(a) {
          assert(a.negative === 0, 'red works only with positives');
          assert(a.red, 'red works only with red numbers');
        };

        Red.prototype._verify2 = function _verify2(a, b) {
          assert((a.negative | b.negative) === 0, 'red works only with positives');
          assert(a.red && a.red === b.red,
            'red works only with red numbers');
        };

        Red.prototype.imod = function imod(a) {
          if (this.prime) return this.prime.ireduce(a)._forceRed(this);
          return a.umod(this.m)._forceRed(this);
        };

        Red.prototype.neg = function neg(a) {
          if (a.isZero()) {
            return a.clone();
          }

          return this.m.sub(a)._forceRed(this);
        };

        Red.prototype.add = function add(a, b) {
          this._verify2(a, b);

          var res = a.add(b);
          if (res.cmp(this.m) >= 0) {
            res.isub(this.m);
          }
          return res._forceRed(this);
        };

        Red.prototype.iadd = function iadd(a, b) {
          this._verify2(a, b);

          var res = a.iadd(b);
          if (res.cmp(this.m) >= 0) {
            res.isub(this.m);
          }
          return res;
        };

        Red.prototype.sub = function sub(a, b) {
          this._verify2(a, b);

          var res = a.sub(b);
          if (res.cmpn(0) < 0) {
            res.iadd(this.m);
          }
          return res._forceRed(this);
        };

        Red.prototype.isub = function isub(a, b) {
          this._verify2(a, b);

          var res = a.isub(b);
          if (res.cmpn(0) < 0) {
            res.iadd(this.m);
          }
          return res;
        };

        Red.prototype.shl = function shl(a, num) {
          this._verify1(a);
          return this.imod(a.ushln(num));
        };

        Red.prototype.imul = function imul(a, b) {
          this._verify2(a, b);
          return this.imod(a.imul(b));
        };

        Red.prototype.mul = function mul(a, b) {
          this._verify2(a, b);
          return this.imod(a.mul(b));
        };

        Red.prototype.isqr = function isqr(a) {
          return this.imul(a, a.clone());
        };

        Red.prototype.sqr = function sqr(a) {
          return this.mul(a, a);
        };

        Red.prototype.sqrt = function sqrt(a) {
          if (a.isZero()) return a.clone();

          var mod3 = this.m.andln(3);
          assert(mod3 % 2 === 1);

          // Fast case
          if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
          }

          // Tonelli-Shanks algorithm (Totally unoptimized and slow)
          //
          // Find Q and S, that Q * 2 ^ S = (P - 1)
          var q = this.m.subn(1);
          var s = 0;
          while (!q.isZero() && q.andln(1) === 0) {
            s++;
            q.iushrn(1);
          }
          assert(!q.isZero());

          var one = new BN(1).toRed(this);
          var nOne = one.redNeg();

          // Find quadratic non-residue
          // NOTE: Max is such because of generalized Riemann hypothesis.
          var lpow = this.m.subn(1).iushrn(1);
          var z = this.m.bitLength();
          z = new BN(2 * z * z).toRed(this);

          while (this.pow(z, lpow).cmp(nOne) !== 0) {
            z.redIAdd(nOne);
          }

          var c = this.pow(z, q);
          var r = this.pow(a, q.addn(1).iushrn(1));
          var t = this.pow(a, q);
          var m = s;
          while (t.cmp(one) !== 0) {
            var tmp = t;
            for (var i = 0; tmp.cmp(one) !== 0; i++) {
              tmp = tmp.redSqr();
            }
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));

            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
          }

          return r;
        };

        Red.prototype.invm = function invm(a) {
          var inv = a._invmp(this.m);
          if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
          } else {
            return this.imod(inv);
          }
        };

        Red.prototype.pow = function pow(a, num) {
          if (num.isZero()) return new BN(1).toRed(this);
          if (num.cmpn(1) === 0) return a.clone();

          var windowSize = 4;
          var wnd = new Array(1 << windowSize);
          wnd[0] = new BN(1).toRed(this);
          wnd[1] = a;
          for (var i = 2; i < wnd.length; i++) {
            wnd[i] = this.mul(wnd[i - 1], a);
          }

          var res = wnd[0];
          var current = 0;
          var currentLen = 0;
          var start = num.bitLength() % 26;
          if (start === 0) {
            start = 26;
          }

          for (i = num.length - 1; i >= 0; i--) {
            var word = num.words[i];
            for (var j = start - 1; j >= 0; j--) {
              var bit = (word >> j) & 1;
              if (res !== wnd[0]) {
                res = this.sqr(res);
              }

              if (bit === 0 && current === 0) {
                currentLen = 0;
                continue;
              }

              current <<= 1;
              current |= bit;
              currentLen++;
              if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

              res = this.mul(res, wnd[current]);
              currentLen = 0;
              current = 0;
            }
            start = 26;
          }

          return res;
        };

        Red.prototype.convertTo = function convertTo(num) {
          var r = num.umod(this.m);

          return r === num ? r.clone() : r;
        };

        Red.prototype.convertFrom = function convertFrom(num) {
          var res = num.clone();
          res.red = null;
          return res;
        };

        //
        // Montgomery method engine
        //

        BN.mont = function mont(num) {
          return new Mont(num);
        };

        function Mont(m) {
          Red.call(this, m);

          this.shift = this.m.bitLength();
          if (this.shift % 26 !== 0) {
            this.shift += 26 - (this.shift % 26);
          }

          this.r = new BN(1).iushln(this.shift);
          this.r2 = this.imod(this.r.sqr());
          this.rinv = this.r._invmp(this.m);

          this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
          this.minv = this.minv.umod(this.r);
          this.minv = this.r.sub(this.minv);
        }
        inherits(Mont, Red);

        Mont.prototype.convertTo = function convertTo(num) {
          return this.imod(num.ushln(this.shift));
        };

        Mont.prototype.convertFrom = function convertFrom(num) {
          var r = this.imod(num.mul(this.rinv));
          r.red = null;
          return r;
        };

        Mont.prototype.imul = function imul(a, b) {
          if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
          }

          var t = a.imul(b);
          var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
          var u = t.isub(c).iushrn(this.shift);
          var res = u;

          if (u.cmp(this.m) >= 0) {
            res = u.isub(this.m);
          } else if (u.cmpn(0) < 0) {
            res = u.iadd(this.m);
          }

          return res._forceRed(this);
        };

        Mont.prototype.mul = function mul(a, b) {
          if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

          var t = a.mul(b);
          var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
          var u = t.isub(c).iushrn(this.shift);
          var res = u;
          if (u.cmp(this.m) >= 0) {
            res = u.isub(this.m);
          } else if (u.cmpn(0) < 0) {
            res = u.iadd(this.m);
          }

          return res._forceRed(this);
        };

        Mont.prototype.invm = function invm(a) {
          // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
          var res = this.imod(a._invmp(this.m).mul(this.r2));
          return res._forceRed(this);
        };
      })(typeof module === 'undefined' || module, this);

    }, { "buffer": 172 }], 65: [function (require, module, exports) {
      var r;

      module.exports = function rand(len) {
        if (!r)
          r = new Rand(null);

        return r.generate(len);
      };

      function Rand(rand) {
        this.rand = rand;
      }
      module.exports.Rand = Rand;

      Rand.prototype.generate = function generate(len) {
        return this._rand(len);
      };

      // Emulate crypto API using randy
      Rand.prototype._rand = function _rand(n) {
        if (this.rand.getBytes)
          return this.rand.getBytes(n);

        var res = new Uint8Array(n);
        for (var i = 0; i < res.length; i++)
          res[i] = this.rand.getByte();
        return res;
      };

      if (typeof self === 'object') {
        if (self.crypto && self.crypto.getRandomValues) {
          // Modern browsers
          Rand.prototype._rand = function _rand(n) {
            var arr = new Uint8Array(n);
            self.crypto.getRandomValues(arr);
            return arr;
          };
        } else if (self.msCrypto && self.msCrypto.getRandomValues) {
          // IE
          Rand.prototype._rand = function _rand(n) {
            var arr = new Uint8Array(n);
            self.msCrypto.getRandomValues(arr);
            return arr;
          };

          // Safari's WebWorkers do not have `crypto`
        } else if (typeof window === 'object') {
          // Old junk
          Rand.prototype._rand = function () {
            throw new Error('Not implemented yet');
          };
        }
      } else {
        // Node.js or Web worker with no crypto support
        try {
          var crypto = require('crypto');
          if (typeof crypto.randomBytes !== 'function')
            throw new Error('Not supported');

          Rand.prototype._rand = function _rand(n) {
            return crypto.randomBytes(n);
          };
        } catch (e) {
        }
      }

    }, { "crypto": 172 }], 66: [function (require, module, exports) {
      var basex = require('base-x')
      var ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'

      module.exports = basex(ALPHABET)

    }, { "base-x": 1 }], 67: [function (require, module, exports) {
      'use strict'

      var base58 = require('bs58')
      var Buffer = require('safe-buffer').Buffer

      module.exports = function (checksumFn) {
        // Encode a buffer as a base58-check encoded string
        function encode(payload) {
          var checksum = checksumFn(payload)

          return base58.encode(Buffer.concat([
            payload,
            checksum
          ], payload.length + 4))
        }

        function decodeRaw(buffer) {
          var payload = buffer.slice(0, -4)
          var checksum = buffer.slice(-4)
          var newChecksum = checksumFn(payload)

          if (checksum[0] ^ newChecksum[0] |
            checksum[1] ^ newChecksum[1] |
            checksum[2] ^ newChecksum[2] |
            checksum[3] ^ newChecksum[3]) return

          return payload
        }

        // Decode a base58-check encoded string to a buffer, no result if checksum is wrong
        function decodeUnsafe(string) {
          var buffer = base58.decodeUnsafe(string)
          if (!buffer) return

          return decodeRaw(buffer)
        }

        function decode(string) {
          var buffer = base58.decode(string)
          var payload = decodeRaw(buffer, checksumFn)
          if (!payload) throw new Error('Invalid checksum')
          return payload
        }

        return {
          encode: encode,
          decode: decode,
          decodeUnsafe: decodeUnsafe
        }
      }

    }, { "bs58": 66, "safe-buffer": 133 }], 68: [function (require, module, exports) {
      'use strict'

      var createHash = require('create-hash')
      var bs58checkBase = require('./base')

      // SHA256(SHA256(buffer))
      function sha256x2(buffer) {
        var tmp = createHash('sha256').update(buffer).digest()
        return createHash('sha256').update(tmp).digest()
      }

      module.exports = bs58checkBase(sha256x2)

    }, { "./base": 67, "create-hash": 70 }], 69: [function (require, module, exports) {
      var Buffer = require('safe-buffer').Buffer
      var Transform = require('stream').Transform
      var StringDecoder = require('string_decoder').StringDecoder
      var inherits = require('inherits')

      function CipherBase(hashMode) {
        Transform.call(this)
        this.hashMode = typeof hashMode === 'string'
        if (this.hashMode) {
          this[hashMode] = this._finalOrDigest
        } else {
          this.final = this._finalOrDigest
        }
        if (this._final) {
          this.__final = this._final
          this._final = null
        }
        this._decoder = null
        this._encoding = null
      }
      inherits(CipherBase, Transform)

      CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
        if (typeof data === 'string') {
          data = Buffer.from(data, inputEnc)
        }

        var outData = this._update(data)
        if (this.hashMode) return this

        if (outputEnc) {
          outData = this._toString(outData, outputEnc)
        }

        return outData
      }

      CipherBase.prototype.setAutoPadding = function () { }
      CipherBase.prototype.getAuthTag = function () {
        throw new Error('trying to get auth tag in unsupported state')
      }

      CipherBase.prototype.setAuthTag = function () {
        throw new Error('trying to set auth tag in unsupported state')
      }

      CipherBase.prototype.setAAD = function () {
        throw new Error('trying to set aad in unsupported state')
      }

      CipherBase.prototype._transform = function (data, _, next) {
        var err
        try {
          if (this.hashMode) {
            this._update(data)
          } else {
            this.push(this._update(data))
          }
        } catch (e) {
          err = e
        } finally {
          next(err)
        }
      }
      CipherBase.prototype._flush = function (done) {
        var err
        try {
          this.push(this.__final())
        } catch (e) {
          err = e
        }

        done(err)
      }
      CipherBase.prototype._finalOrDigest = function (outputEnc) {
        var outData = this.__final() || Buffer.alloc(0)
        if (outputEnc) {
          outData = this._toString(outData, outputEnc, true)
        }
        return outData
      }

      CipherBase.prototype._toString = function (value, enc, fin) {
        if (!this._decoder) {
          this._decoder = new StringDecoder(enc)
          this._encoding = enc
        }

        if (this._encoding !== enc) throw new Error('can\'t switch encodings')

        var out = this._decoder.write(value)
        if (fin) {
          out += this._decoder.end()
        }

        return out
      }

      module.exports = CipherBase

    }, { "inherits": 109, "safe-buffer": 133, "stream": 325, "string_decoder": 340 }], 70: [function (require, module, exports) {
      'use strict'
      var inherits = require('inherits')
      var MD5 = require('md5.js')
      var RIPEMD160 = require('ripemd160')
      var sha = require('sha.js')
      var Base = require('cipher-base')

      function Hash(hash) {
        Base.call(this, 'digest')

        this._hash = hash
      }

      inherits(Hash, Base)

      Hash.prototype._update = function (data) {
        this._hash.update(data)
      }

      Hash.prototype._final = function () {
        return this._hash.digest()
      }

      module.exports = function createHash(alg) {
        alg = alg.toLowerCase()
        if (alg === 'md5') return new MD5()
        if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160()

        return new Hash(sha(alg))
      }

    }, { "cipher-base": 69, "inherits": 109, "md5.js": 110, "ripemd160": 132, "sha.js": 135 }], 71: [function (require, module, exports) {
      var MD5 = require('md5.js')

      module.exports = function (buffer) {
        return new MD5().update(buffer).digest()
      }

    }, { "md5.js": 110 }], 72: [function (require, module, exports) {
      'use strict'
      var inherits = require('inherits')
      var Legacy = require('./legacy')
      var Base = require('cipher-base')
      var Buffer = require('safe-buffer').Buffer
      var md5 = require('create-hash/md5')
      var RIPEMD160 = require('ripemd160')

      var sha = require('sha.js')

      var ZEROS = Buffer.alloc(128)

      function Hmac(alg, key) {
        Base.call(this, 'digest')
        if (typeof key === 'string') {
          key = Buffer.from(key)
        }

        var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

        this._alg = alg
        this._key = key
        if (key.length > blocksize) {
          var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
          key = hash.update(key).digest()
        } else if (key.length < blocksize) {
          key = Buffer.concat([key, ZEROS], blocksize)
        }

        var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
        var opad = this._opad = Buffer.allocUnsafe(blocksize)

        for (var i = 0; i < blocksize; i++) {
          ipad[i] = key[i] ^ 0x36
          opad[i] = key[i] ^ 0x5C
        }
        this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
        this._hash.update(ipad)
      }

      inherits(Hmac, Base)

      Hmac.prototype._update = function (data) {
        this._hash.update(data)
      }

      Hmac.prototype._final = function () {
        var h = this._hash.digest()
        var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg)
        return hash.update(this._opad).update(h).digest()
      }

      module.exports = function createHmac(alg, key) {
        alg = alg.toLowerCase()
        if (alg === 'rmd160' || alg === 'ripemd160') {
          return new Hmac('rmd160', key)
        }
        if (alg === 'md5') {
          return new Legacy(md5, key)
        }
        return new Hmac(alg, key)
      }

    }, { "./legacy": 73, "cipher-base": 69, "create-hash/md5": 71, "inherits": 109, "ripemd160": 132, "safe-buffer": 133, "sha.js": 135 }], 73: [function (require, module, exports) {
      'use strict'
      var inherits = require('inherits')
      var Buffer = require('safe-buffer').Buffer

      var Base = require('cipher-base')

      var ZEROS = Buffer.alloc(128)
      var blocksize = 64

      function Hmac(alg, key) {
        Base.call(this, 'digest')
        if (typeof key === 'string') {
          key = Buffer.from(key)
        }

        this._alg = alg
        this._key = key

        if (key.length > blocksize) {
          key = alg(key)
        } else if (key.length < blocksize) {
          key = Buffer.concat([key, ZEROS], blocksize)
        }

        var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
        var opad = this._opad = Buffer.allocUnsafe(blocksize)

        for (var i = 0; i < blocksize; i++) {
          ipad[i] = key[i] ^ 0x36
          opad[i] = key[i] ^ 0x5C
        }

        this._hash = [ipad]
      }

      inherits(Hmac, Base)

      Hmac.prototype._update = function (data) {
        this._hash.push(data)
      }

      Hmac.prototype._final = function () {
        var h = this._alg(Buffer.concat(this._hash))
        return this._alg(Buffer.concat([this._opad, h]))
      }
      module.exports = Hmac

    }, { "cipher-base": 69, "inherits": 109, "safe-buffer": 133 }], 74: [function (require, module, exports) {
      var assert = require('assert')
      var BigInteger = require('bigi')

      var Point = require('./point')

      function Curve(p, a, b, Gx, Gy, n, h) {
        this.p = p
        this.a = a
        this.b = b
        this.G = Point.fromAffine(this, Gx, Gy)
        this.n = n
        this.h = h

        this.infinity = new Point(this, null, null, BigInteger.ZERO)

        // result caching
        this.pOverFour = p.add(BigInteger.ONE).shiftRight(2)

        // determine size of p in bytes
        this.pLength = Math.floor((this.p.bitLength() + 7) / 8)
      }

      Curve.prototype.pointFromX = function (isOdd, x) {
        var alpha = x.pow(3).add(this.a.multiply(x)).add(this.b).mod(this.p)
        var beta = alpha.modPow(this.pOverFour, this.p) // XXX: not compatible with all curves

        var y = beta
        if (beta.isEven() ^ !isOdd) {
          y = this.p.subtract(y) // -y % p
        }

        return Point.fromAffine(this, x, y)
      }

      Curve.prototype.isInfinity = function (Q) {
        if (Q === this.infinity) return true

        return Q.z.signum() === 0 && Q.y.signum() !== 0
      }

      Curve.prototype.isOnCurve = function (Q) {
        if (this.isInfinity(Q)) return true

        var x = Q.affineX
        var y = Q.affineY
        var a = this.a
        var b = this.b
        var p = this.p

        // Check that xQ and yQ are integers in the interval [0, p - 1]
        if (x.signum() < 0 || x.compareTo(p) >= 0) return false
        if (y.signum() < 0 || y.compareTo(p) >= 0) return false

        // and check that y^2 = x^3 + ax + b (mod p)
        var lhs = y.square().mod(p)
        var rhs = x.pow(3).add(a.multiply(x)).add(b).mod(p)
        return lhs.equals(rhs)
      }

      /**
       * Validate an elliptic curve point.
       *
       * See SEC 1, section 3.2.2.1: Elliptic Curve Public Key Validation Primitive
       */
      Curve.prototype.validate = function (Q) {
        // Check Q != O
        assert(!this.isInfinity(Q), 'Point is at infinity')
        assert(this.isOnCurve(Q), 'Point is not on the curve')

        // Check nQ = O (where Q is a scalar multiple of G)
        var nQ = Q.multiply(this.n)
        assert(this.isInfinity(nQ), 'Point is not a scalar multiple of G')

        return true
      }

      module.exports = Curve

    }, { "./point": 78, "assert": 165, "bigi": 5 }], 75: [function (require, module, exports) {
      module.exports = {
        "secp128r1": {
          "p": "fffffffdffffffffffffffffffffffff",
          "a": "fffffffdfffffffffffffffffffffffc",
          "b": "e87579c11079f43dd824993c2cee5ed3",
          "n": "fffffffe0000000075a30d1b9038a115",
          "h": "01",
          "Gx": "161ff7528b899b2d0c28607ca52c5b86",
          "Gy": "cf5ac8395bafeb13c02da292dded7a83"
        },
        "secp160k1": {
          "p": "fffffffffffffffffffffffffffffffeffffac73",
          "a": "00",
          "b": "07",
          "n": "0100000000000000000001b8fa16dfab9aca16b6b3",
          "h": "01",
          "Gx": "3b4c382ce37aa192a4019e763036f4f5dd4d7ebb",
          "Gy": "938cf935318fdced6bc28286531733c3f03c4fee"
        },
        "secp160r1": {
          "p": "ffffffffffffffffffffffffffffffff7fffffff",
          "a": "ffffffffffffffffffffffffffffffff7ffffffc",
          "b": "1c97befc54bd7a8b65acf89f81d4d4adc565fa45",
          "n": "0100000000000000000001f4c8f927aed3ca752257",
          "h": "01",
          "Gx": "4a96b5688ef573284664698968c38bb913cbfc82",
          "Gy": "23a628553168947d59dcc912042351377ac5fb32"
        },
        "secp192k1": {
          "p": "fffffffffffffffffffffffffffffffffffffffeffffee37",
          "a": "00",
          "b": "03",
          "n": "fffffffffffffffffffffffe26f2fc170f69466a74defd8d",
          "h": "01",
          "Gx": "db4ff10ec057e9ae26b07d0280b7f4341da5d1b1eae06c7d",
          "Gy": "9b2f2f6d9c5628a7844163d015be86344082aa88d95e2f9d"
        },
        "secp192r1": {
          "p": "fffffffffffffffffffffffffffffffeffffffffffffffff",
          "a": "fffffffffffffffffffffffffffffffefffffffffffffffc",
          "b": "64210519e59c80e70fa7e9ab72243049feb8deecc146b9b1",
          "n": "ffffffffffffffffffffffff99def836146bc9b1b4d22831",
          "h": "01",
          "Gx": "188da80eb03090f67cbf20eb43a18800f4ff0afd82ff1012",
          "Gy": "07192b95ffc8da78631011ed6b24cdd573f977a11e794811"
        },
        "secp256k1": {
          "p": "fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f",
          "a": "00",
          "b": "07",
          "n": "fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141",
          "h": "01",
          "Gx": "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
          "Gy": "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8"
        },
        "secp256r1": {
          "p": "ffffffff00000001000000000000000000000000ffffffffffffffffffffffff",
          "a": "ffffffff00000001000000000000000000000000fffffffffffffffffffffffc",
          "b": "5ac635d8aa3a93e7b3ebbd55769886bc651d06b0cc53b0f63bce3c3e27d2604b",
          "n": "ffffffff00000000ffffffffffffffffbce6faada7179e84f3b9cac2fc632551",
          "h": "01",
          "Gx": "6b17d1f2e12c4247f8bce6e563a440f277037d812deb33a0f4a13945d898c296",
          "Gy": "4fe342e2fe1a7f9b8ee7eb4a7c0f9e162bce33576b315ececbb6406837bf51f5"
        }
      }

    }, {}], 76: [function (require, module, exports) {
      var Point = require('./point')
      var Curve = require('./curve')

      var getCurveByName = require('./names')

      module.exports = {
        Curve: Curve,
        Point: Point,
        getCurveByName: getCurveByName
      }

    }, { "./curve": 74, "./names": 77, "./point": 78 }], 77: [function (require, module, exports) {
      var BigInteger = require('bigi')

      var curves = require('./curves.json')
      var Curve = require('./curve')

      function getCurveByName(name) {
        var curve = curves[name]
        if (!curve) return null

        var p = new BigInteger(curve.p, 16)
        var a = new BigInteger(curve.a, 16)
        var b = new BigInteger(curve.b, 16)
        var n = new BigInteger(curve.n, 16)
        var h = new BigInteger(curve.h, 16)
        var Gx = new BigInteger(curve.Gx, 16)
        var Gy = new BigInteger(curve.Gy, 16)

        return new Curve(p, a, b, Gx, Gy, n, h)
      }

      module.exports = getCurveByName

    }, { "./curve": 74, "./curves.json": 75, "bigi": 5 }], 78: [function (require, module, exports) {
      var assert = require('assert')
      var Buffer = require('safe-buffer').Buffer
      var BigInteger = require('bigi')

      var THREE = BigInteger.valueOf(3)

      function Point(curve, x, y, z) {
        assert.notStrictEqual(z, undefined, 'Missing Z coordinate')

        this.curve = curve
        this.x = x
        this.y = y
        this.z = z
        this._zInv = null

        this.compressed = true
      }

      Object.defineProperty(Point.prototype, 'zInv', {
        get: function () {
          if (this._zInv === null) {
            this._zInv = this.z.modInverse(this.curve.p)
          }

          return this._zInv
        }
      })

      Object.defineProperty(Point.prototype, 'affineX', {
        get: function () {
          return this.x.multiply(this.zInv).mod(this.curve.p)
        }
      })

      Object.defineProperty(Point.prototype, 'affineY', {
        get: function () {
          return this.y.multiply(this.zInv).mod(this.curve.p)
        }
      })

      Point.fromAffine = function (curve, x, y) {
        return new Point(curve, x, y, BigInteger.ONE)
      }

      Point.prototype.equals = function (other) {
        if (other === this) return true
        if (this.curve.isInfinity(this)) return this.curve.isInfinity(other)
        if (this.curve.isInfinity(other)) return this.curve.isInfinity(this)

        // u = Y2 * Z1 - Y1 * Z2
        var u = other.y.multiply(this.z).subtract(this.y.multiply(other.z)).mod(this.curve.p)

        if (u.signum() !== 0) return false

        // v = X2 * Z1 - X1 * Z2
        var v = other.x.multiply(this.z).subtract(this.x.multiply(other.z)).mod(this.curve.p)

        return v.signum() === 0
      }

      Point.prototype.negate = function () {
        var y = this.curve.p.subtract(this.y)

        return new Point(this.curve, this.x, y, this.z)
      }

      Point.prototype.add = function (b) {
        if (this.curve.isInfinity(this)) return b
        if (this.curve.isInfinity(b)) return this

        var x1 = this.x
        var y1 = this.y
        var x2 = b.x
        var y2 = b.y

        // u = Y2 * Z1 - Y1 * Z2
        var u = y2.multiply(this.z).subtract(y1.multiply(b.z)).mod(this.curve.p)
        // v = X2 * Z1 - X1 * Z2
        var v = x2.multiply(this.z).subtract(x1.multiply(b.z)).mod(this.curve.p)

        if (v.signum() === 0) {
          if (u.signum() === 0) {
            return this.twice() // this == b, so double
          }

          return this.curve.infinity // this = -b, so infinity
        }

        var v2 = v.square()
        var v3 = v2.multiply(v)
        var x1v2 = x1.multiply(v2)
        var zu2 = u.square().multiply(this.z)

        // x3 = v * (z2 * (z1 * u^2 - 2 * x1 * v^2) - v^3)
        var x3 = zu2.subtract(x1v2.shiftLeft(1)).multiply(b.z).subtract(v3).multiply(v).mod(this.curve.p)
        // y3 = z2 * (3 * x1 * u * v^2 - y1 * v^3 - z1 * u^3) + u * v^3
        var y3 = x1v2.multiply(THREE).multiply(u).subtract(y1.multiply(v3)).subtract(zu2.multiply(u)).multiply(b.z).add(u.multiply(v3)).mod(this.curve.p)
        // z3 = v^3 * z1 * z2
        var z3 = v3.multiply(this.z).multiply(b.z).mod(this.curve.p)

        return new Point(this.curve, x3, y3, z3)
      }

      Point.prototype.twice = function () {
        if (this.curve.isInfinity(this)) return this
        if (this.y.signum() === 0) return this.curve.infinity

        var x1 = this.x
        var y1 = this.y

        var y1z1 = y1.multiply(this.z).mod(this.curve.p)
        var y1sqz1 = y1z1.multiply(y1).mod(this.curve.p)
        var a = this.curve.a

        // w = 3 * x1^2 + a * z1^2
        var w = x1.square().multiply(THREE)

        if (a.signum() !== 0) {
          w = w.add(this.z.square().multiply(a))
        }

        w = w.mod(this.curve.p)
        // x3 = 2 * y1 * z1 * (w^2 - 8 * x1 * y1^2 * z1)
        var x3 = w.square().subtract(x1.shiftLeft(3).multiply(y1sqz1)).shiftLeft(1).multiply(y1z1).mod(this.curve.p)
        // y3 = 4 * y1^2 * z1 * (3 * w * x1 - 2 * y1^2 * z1) - w^3
        var y3 = w.multiply(THREE).multiply(x1).subtract(y1sqz1.shiftLeft(1)).shiftLeft(2).multiply(y1sqz1).subtract(w.pow(3)).mod(this.curve.p)
        // z3 = 8 * (y1 * z1)^3
        var z3 = y1z1.pow(3).shiftLeft(3).mod(this.curve.p)

        return new Point(this.curve, x3, y3, z3)
      }

      // Simple NAF (Non-Adjacent Form) multiplication algorithm
      // TODO: modularize the multiplication algorithm
      Point.prototype.multiply = function (k) {
        if (this.curve.isInfinity(this)) return this
        if (k.signum() === 0) return this.curve.infinity

        var e = k
        var h = e.multiply(THREE)

        var neg = this.negate()
        var R = this

        for (var i = h.bitLength() - 2; i > 0; --i) {
          var hBit = h.testBit(i)
          var eBit = e.testBit(i)

          R = R.twice()

          if (hBit !== eBit) {
            R = R.add(hBit ? this : neg)
          }
        }

        return R
      }

      // Compute this*j + x*k (simultaneous multiplication)
      Point.prototype.multiplyTwo = function (j, x, k) {
        var i = Math.max(j.bitLength(), k.bitLength()) - 1
        var R = this.curve.infinity
        var both = this.add(x)

        while (i >= 0) {
          var jBit = j.testBit(i)
          var kBit = k.testBit(i)

          R = R.twice()

          if (jBit) {
            if (kBit) {
              R = R.add(both)
            } else {
              R = R.add(this)
            }
          } else if (kBit) {
            R = R.add(x)
          }
          --i
        }

        return R
      }

      Point.prototype.getEncoded = function (compressed) {
        if (compressed == null) compressed = this.compressed
        if (this.curve.isInfinity(this)) return Buffer.alloc(1, 0) // Infinity point encoded is simply '00'

        var x = this.affineX
        var y = this.affineY
        var byteLength = this.curve.pLength
        var buffer

        // 0x02/0x03 | X
        if (compressed) {
          buffer = Buffer.allocUnsafe(1 + byteLength)
          buffer.writeUInt8(y.isEven() ? 0x02 : 0x03, 0)

          // 0x04 | X | Y
        } else {
          buffer = Buffer.allocUnsafe(1 + byteLength + byteLength)
          buffer.writeUInt8(0x04, 0)

          y.toBuffer(byteLength).copy(buffer, 1 + byteLength)
        }

        x.toBuffer(byteLength).copy(buffer, 1)

        return buffer
      }

      Point.decodeFrom = function (curve, buffer) {
        var type = buffer.readUInt8(0)
        var compressed = (type !== 4)

        var byteLength = Math.floor((curve.p.bitLength() + 7) / 8)
        var x = BigInteger.fromBuffer(buffer.slice(1, 1 + byteLength))

        var Q
        if (compressed) {
          assert.equal(buffer.length, byteLength + 1, 'Invalid sequence length')
          assert(type === 0x02 || type === 0x03, 'Invalid sequence tag')

          var isOdd = (type === 0x03)
          Q = curve.pointFromX(isOdd, x)
        } else {
          assert.equal(buffer.length, 1 + byteLength + byteLength, 'Invalid sequence length')

          var y = BigInteger.fromBuffer(buffer.slice(1 + byteLength))
          Q = Point.fromAffine(curve, x, y)
        }

        Q.compressed = compressed
        return Q
      }

      Point.prototype.toString = function () {
        if (this.curve.isInfinity(this)) return '(INFINITY)'

        return '(' + this.affineX.toString() + ',' + this.affineY.toString() + ')'
      }

      module.exports = Point

    }, { "assert": 165, "bigi": 5, "safe-buffer": 133 }], 79: [function (require, module, exports) {
      'use strict';

      var elliptic = exports;

      elliptic.version = require('../package.json').version;
      elliptic.utils = require('./elliptic/utils');
      elliptic.rand = require('brorand');
      elliptic.curve = require('./elliptic/curve');
      elliptic.curves = require('./elliptic/curves');

      // Protocols
      elliptic.ec = require('./elliptic/ec');
      elliptic.eddsa = require('./elliptic/eddsa');

    }, { "../package.json": 94, "./elliptic/curve": 82, "./elliptic/curves": 85, "./elliptic/ec": 86, "./elliptic/eddsa": 89, "./elliptic/utils": 93, "brorand": 65 }], 80: [function (require, module, exports) {
      'use strict';

      var BN = require('bn.js');
      var utils = require('../utils');
      var getNAF = utils.getNAF;
      var getJSF = utils.getJSF;
      var assert = utils.assert;

      function BaseCurve(type, conf) {
        this.type = type;
        this.p = new BN(conf.p, 16);

        // Use Montgomery, when there is no fast reduction for the prime
        this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

        // Useful for many curves
        this.zero = new BN(0).toRed(this.red);
        this.one = new BN(1).toRed(this.red);
        this.two = new BN(2).toRed(this.red);

        // Curve configuration, optional
        this.n = conf.n && new BN(conf.n, 16);
        this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

        // Temporary arrays
        this._wnafT1 = new Array(4);
        this._wnafT2 = new Array(4);
        this._wnafT3 = new Array(4);
        this._wnafT4 = new Array(4);

        this._bitLength = this.n ? this.n.bitLength() : 0;

        // Generalized Greg Maxwell's trick
        var adjustCount = this.n && this.p.div(this.n);
        if (!adjustCount || adjustCount.cmpn(100) > 0) {
          this.redN = null;
        } else {
          this._maxwellTrick = true;
          this.redN = this.n.toRed(this.red);
        }
      }
      module.exports = BaseCurve;

      BaseCurve.prototype.point = function point() {
        throw new Error('Not implemented');
      };

      BaseCurve.prototype.validate = function validate() {
        throw new Error('Not implemented');
      };

      BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
        assert(p.precomputed);
        var doubles = p._getDoubles();

        var naf = getNAF(k, 1, this._bitLength);
        var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
        I /= 3;

        // Translate into more windowed form
        var repr = [];
        var j;
        var nafW;
        for (j = 0; j < naf.length; j += doubles.step) {
          nafW = 0;
          for (var l = j + doubles.step - 1; l >= j; l--)
            nafW = (nafW << 1) + naf[l];
          repr.push(nafW);
        }

        var a = this.jpoint(null, null, null);
        var b = this.jpoint(null, null, null);
        for (var i = I; i > 0; i--) {
          for (j = 0; j < repr.length; j++) {
            nafW = repr[j];
            if (nafW === i)
              b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i)
              b = b.mixedAdd(doubles.points[j].neg());
          }
          a = a.add(b);
        }
        return a.toP();
      };

      BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
        var w = 4;

        // Precompute window
        var nafPoints = p._getNAFPoints(w);
        w = nafPoints.wnd;
        var wnd = nafPoints.points;

        // Get NAF form
        var naf = getNAF(k, w, this._bitLength);

        // Add `this`*(N+1) for every w-NAF index
        var acc = this.jpoint(null, null, null);
        for (var i = naf.length - 1; i >= 0; i--) {
          // Count zeroes
          for (var l = 0; i >= 0 && naf[i] === 0; i--)
            l++;
          if (i >= 0)
            l++;
          acc = acc.dblp(l);

          if (i < 0)
            break;
          var z = naf[i];
          assert(z !== 0);
          if (p.type === 'affine') {
            // J +- P
            if (z > 0)
              acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
            else
              acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
          } else {
            // J +- J
            if (z > 0)
              acc = acc.add(wnd[(z - 1) >> 1]);
            else
              acc = acc.add(wnd[(-z - 1) >> 1].neg());
          }
        }
        return p.type === 'affine' ? acc.toP() : acc;
      };

      BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
        points,
        coeffs,
        len,
        jacobianResult) {
        var wndWidth = this._wnafT1;
        var wnd = this._wnafT2;
        var naf = this._wnafT3;

        // Fill all arrays
        var max = 0;
        var i;
        var j;
        var p;
        for (i = 0; i < len; i++) {
          p = points[i];
          var nafPoints = p._getNAFPoints(defW);
          wndWidth[i] = nafPoints.wnd;
          wnd[i] = nafPoints.points;
        }

        // Comb small window NAFs
        for (i = len - 1; i >= 1; i -= 2) {
          var a = i - 1;
          var b = i;
          if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
          }

          var comb = [
            points[a], /* 1 */
            null, /* 3 */
            null, /* 5 */
            points[b], /* 7 */
          ];

          // Try to avoid Projective points, if possible
          if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
          } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
          } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
          }

          var index = [
            -3, /* -1 -1 */
            -1, /* -1 0 */
            -5, /* -1 1 */
            -7, /* 0 -1 */
            0, /* 0 0 */
            7, /* 0 1 */
            5, /* 1 -1 */
            1, /* 1 0 */
            3,  /* 1 1 */
          ];

          var jsf = getJSF(coeffs[a], coeffs[b]);
          max = Math.max(jsf[0].length, max);
          naf[a] = new Array(max);
          naf[b] = new Array(max);
          for (j = 0; j < max; j++) {
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;

            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
          }
        }

        var acc = this.jpoint(null, null, null);
        var tmp = this._wnafT4;
        for (i = max; i >= 0; i--) {
          var k = 0;

          while (i >= 0) {
            var zero = true;
            for (j = 0; j < len; j++) {
              tmp[j] = naf[j][i] | 0;
              if (tmp[j] !== 0)
                zero = false;
            }
            if (!zero)
              break;
            k++;
            i--;
          }
          if (i >= 0)
            k++;
          acc = acc.dblp(k);
          if (i < 0)
            break;

          for (j = 0; j < len; j++) {
            var z = tmp[j];
            p;
            if (z === 0)
              continue;
            else if (z > 0)
              p = wnd[j][(z - 1) >> 1];
            else if (z < 0)
              p = wnd[j][(-z - 1) >> 1].neg();

            if (p.type === 'affine')
              acc = acc.mixedAdd(p);
            else
              acc = acc.add(p);
          }
        }
        // Zeroify references
        for (i = 0; i < len; i++)
          wnd[i] = null;

        if (jacobianResult)
          return acc;
        else
          return acc.toP();
      };

      function BasePoint(curve, type) {
        this.curve = curve;
        this.type = type;
        this.precomputed = null;
      }
      BaseCurve.BasePoint = BasePoint;

      BasePoint.prototype.eq = function eq(/*other*/) {
        throw new Error('Not implemented');
      };

      BasePoint.prototype.validate = function validate() {
        return this.curve.validate(this);
      };

      BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
        bytes = utils.toArray(bytes, enc);

        var len = this.p.byteLength();

        // uncompressed, hybrid-odd, hybrid-even
        if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
          bytes.length - 1 === 2 * len) {
          if (bytes[0] === 0x06)
            assert(bytes[bytes.length - 1] % 2 === 0);
          else if (bytes[0] === 0x07)
            assert(bytes[bytes.length - 1] % 2 === 1);

          var res = this.point(bytes.slice(1, 1 + len),
            bytes.slice(1 + len, 1 + 2 * len));

          return res;
        } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
          bytes.length - 1 === len) {
          return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
        }
        throw new Error('Unknown point format');
      };

      BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
        return this.encode(enc, true);
      };

      BasePoint.prototype._encode = function _encode(compact) {
        var len = this.curve.p.byteLength();
        var x = this.getX().toArray('be', len);

        if (compact)
          return [this.getY().isEven() ? 0x02 : 0x03].concat(x);

        return [0x04].concat(x, this.getY().toArray('be', len));
      };

      BasePoint.prototype.encode = function encode(enc, compact) {
        return utils.encode(this._encode(compact), enc);
      };

      BasePoint.prototype.precompute = function precompute(power) {
        if (this.precomputed)
          return this;

        var precomputed = {
          doubles: null,
          naf: null,
          beta: null,
        };
        precomputed.naf = this._getNAFPoints(8);
        precomputed.doubles = this._getDoubles(4, power);
        precomputed.beta = this._getBeta();
        this.precomputed = precomputed;

        return this;
      };

      BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
        if (!this.precomputed)
          return false;

        var doubles = this.precomputed.doubles;
        if (!doubles)
          return false;

        return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
      };

      BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
        if (this.precomputed && this.precomputed.doubles)
          return this.precomputed.doubles;

        var doubles = [this];
        var acc = this;
        for (var i = 0; i < power; i += step) {
          for (var j = 0; j < step; j++)
            acc = acc.dbl();
          doubles.push(acc);
        }
        return {
          step: step,
          points: doubles,
        };
      };

      BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
        if (this.precomputed && this.precomputed.naf)
          return this.precomputed.naf;

        var res = [this];
        var max = (1 << wnd) - 1;
        var dbl = max === 1 ? null : this.dbl();
        for (var i = 1; i < max; i++)
          res[i] = res[i - 1].add(dbl);
        return {
          wnd: wnd,
          points: res,
        };
      };

      BasePoint.prototype._getBeta = function _getBeta() {
        return null;
      };

      BasePoint.prototype.dblp = function dblp(k) {
        var r = this;
        for (var i = 0; i < k; i++)
          r = r.dbl();
        return r;
      };

    }, { "../utils": 93, "bn.js": 64 }], 81: [function (require, module, exports) {
      'use strict';

      var utils = require('../utils');
      var BN = require('bn.js');
      var inherits = require('inherits');
      var Base = require('./base');

      var assert = utils.assert;

      function EdwardsCurve(conf) {
        // NOTE: Important as we are creating point in Base.call()
        this.twisted = (conf.a | 0) !== 1;
        this.mOneA = this.twisted && (conf.a | 0) === -1;
        this.extended = this.mOneA;

        Base.call(this, 'edwards', conf);

        this.a = new BN(conf.a, 16).umod(this.red.m);
        this.a = this.a.toRed(this.red);
        this.c = new BN(conf.c, 16).toRed(this.red);
        this.c2 = this.c.redSqr();
        this.d = new BN(conf.d, 16).toRed(this.red);
        this.dd = this.d.redAdd(this.d);

        assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
        this.oneC = (conf.c | 0) === 1;
      }
      inherits(EdwardsCurve, Base);
      module.exports = EdwardsCurve;

      EdwardsCurve.prototype._mulA = function _mulA(num) {
        if (this.mOneA)
          return num.redNeg();
        else
          return this.a.redMul(num);
      };

      EdwardsCurve.prototype._mulC = function _mulC(num) {
        if (this.oneC)
          return num;
        else
          return this.c.redMul(num);
      };

      // Just for compatibility with Short curve
      EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
        return this.point(x, y, z, t);
      };

      EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
        x = new BN(x, 16);
        if (!x.red)
          x = x.toRed(this.red);

        var x2 = x.redSqr();
        var rhs = this.c2.redSub(this.a.redMul(x2));
        var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

        var y2 = rhs.redMul(lhs.redInvm());
        var y = y2.redSqrt();
        if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
          throw new Error('invalid point');

        var isOdd = y.fromRed().isOdd();
        if (odd && !isOdd || !odd && isOdd)
          y = y.redNeg();

        return this.point(x, y);
      };

      EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
        y = new BN(y, 16);
        if (!y.red)
          y = y.toRed(this.red);

        // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
        var y2 = y.redSqr();
        var lhs = y2.redSub(this.c2);
        var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
        var x2 = lhs.redMul(rhs.redInvm());

        if (x2.cmp(this.zero) === 0) {
          if (odd)
            throw new Error('invalid point');
          else
            return this.point(this.zero, y);
        }

        var x = x2.redSqrt();
        if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
          throw new Error('invalid point');

        if (x.fromRed().isOdd() !== odd)
          x = x.redNeg();

        return this.point(x, y);
      };

      EdwardsCurve.prototype.validate = function validate(point) {
        if (point.isInfinity())
          return true;

        // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
        point.normalize();

        var x2 = point.x.redSqr();
        var y2 = point.y.redSqr();
        var lhs = x2.redMul(this.a).redAdd(y2);
        var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

        return lhs.cmp(rhs) === 0;
      };

      function Point(curve, x, y, z, t) {
        Base.BasePoint.call(this, curve, 'projective');
        if (x === null && y === null && z === null) {
          this.x = this.curve.zero;
          this.y = this.curve.one;
          this.z = this.curve.one;
          this.t = this.curve.zero;
          this.zOne = true;
        } else {
          this.x = new BN(x, 16);
          this.y = new BN(y, 16);
          this.z = z ? new BN(z, 16) : this.curve.one;
          this.t = t && new BN(t, 16);
          if (!this.x.red)
            this.x = this.x.toRed(this.curve.red);
          if (!this.y.red)
            this.y = this.y.toRed(this.curve.red);
          if (!this.z.red)
            this.z = this.z.toRed(this.curve.red);
          if (this.t && !this.t.red)
            this.t = this.t.toRed(this.curve.red);
          this.zOne = this.z === this.curve.one;

          // Use extended coordinates
          if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne)
              this.t = this.t.redMul(this.z.redInvm());
          }
        }
      }
      inherits(Point, Base.BasePoint);

      EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
        return Point.fromJSON(this, obj);
      };

      EdwardsCurve.prototype.point = function point(x, y, z, t) {
        return new Point(this, x, y, z, t);
      };

      Point.fromJSON = function fromJSON(curve, obj) {
        return new Point(curve, obj[0], obj[1], obj[2]);
      };

      Point.prototype.inspect = function inspect() {
        if (this.isInfinity())
          return '<EC Point Infinity>';
        return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
          ' y: ' + this.y.fromRed().toString(16, 2) +
          ' z: ' + this.z.fromRed().toString(16, 2) + '>';
      };

      Point.prototype.isInfinity = function isInfinity() {
        // XXX This code assumes that zero is always zero in red
        return this.x.cmpn(0) === 0 &&
          (this.y.cmp(this.z) === 0 ||
            (this.zOne && this.y.cmp(this.curve.c) === 0));
      };

      Point.prototype._extDbl = function _extDbl() {
        // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
        //     #doubling-dbl-2008-hwcd
        // 4M + 4S

        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = 2 * Z1^2
        var c = this.z.redSqr();
        c = c.redIAdd(c);
        // D = a * A
        var d = this.curve._mulA(a);
        // E = (X1 + Y1)^2 - A - B
        var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
        // G = D + B
        var g = d.redAdd(b);
        // F = G - C
        var f = g.redSub(c);
        // H = D - B
        var h = d.redSub(b);
        // X3 = E * F
        var nx = e.redMul(f);
        // Y3 = G * H
        var ny = g.redMul(h);
        // T3 = E * H
        var nt = e.redMul(h);
        // Z3 = F * G
        var nz = f.redMul(g);
        return this.curve.point(nx, ny, nz, nt);
      };

      Point.prototype._projDbl = function _projDbl() {
        // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
        //     #doubling-dbl-2008-bbjlp
        //     #doubling-dbl-2007-bl
        // and others
        // Generally 3M + 4S or 2M + 4S

        // B = (X1 + Y1)^2
        var b = this.x.redAdd(this.y).redSqr();
        // C = X1^2
        var c = this.x.redSqr();
        // D = Y1^2
        var d = this.y.redSqr();

        var nx;
        var ny;
        var nz;
        var e;
        var h;
        var j;
        if (this.curve.twisted) {
          // E = a * C
          e = this.curve._mulA(c);
          // F = E + D
          var f = e.redAdd(d);
          if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
          } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
          }
        } else {
          // E = C + D
          e = c.redAdd(d);
          // H = (c * Z1)^2
          h = this.curve._mulC(this.z).redSqr();
          // J = E - 2 * H
          j = e.redSub(h).redSub(h);
          // X3 = c * (B - E) * J
          nx = this.curve._mulC(b.redISub(e)).redMul(j);
          // Y3 = c * E * (C - D)
          ny = this.curve._mulC(e).redMul(c.redISub(d));
          // Z3 = E * J
          nz = e.redMul(j);
        }
        return this.curve.point(nx, ny, nz);
      };

      Point.prototype.dbl = function dbl() {
        if (this.isInfinity())
          return this;

        // Double in extended coordinates
        if (this.curve.extended)
          return this._extDbl();
        else
          return this._projDbl();
      };

      Point.prototype._extAdd = function _extAdd(p) {
        // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
        //     #addition-add-2008-hwcd-3
        // 8M

        // A = (Y1 - X1) * (Y2 - X2)
        var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
        // B = (Y1 + X1) * (Y2 + X2)
        var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
        // C = T1 * k * T2
        var c = this.t.redMul(this.curve.dd).redMul(p.t);
        // D = Z1 * 2 * Z2
        var d = this.z.redMul(p.z.redAdd(p.z));
        // E = B - A
        var e = b.redSub(a);
        // F = D - C
        var f = d.redSub(c);
        // G = D + C
        var g = d.redAdd(c);
        // H = B + A
        var h = b.redAdd(a);
        // X3 = E * F
        var nx = e.redMul(f);
        // Y3 = G * H
        var ny = g.redMul(h);
        // T3 = E * H
        var nt = e.redMul(h);
        // Z3 = F * G
        var nz = f.redMul(g);
        return this.curve.point(nx, ny, nz, nt);
      };

      Point.prototype._projAdd = function _projAdd(p) {
        // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
        //     #addition-add-2008-bbjlp
        //     #addition-add-2007-bl
        // 10M + 1S

        // A = Z1 * Z2
        var a = this.z.redMul(p.z);
        // B = A^2
        var b = a.redSqr();
        // C = X1 * X2
        var c = this.x.redMul(p.x);
        // D = Y1 * Y2
        var d = this.y.redMul(p.y);
        // E = d * C * D
        var e = this.curve.d.redMul(c).redMul(d);
        // F = B - E
        var f = b.redSub(e);
        // G = B + E
        var g = b.redAdd(e);
        // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
        var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
        var nx = a.redMul(f).redMul(tmp);
        var ny;
        var nz;
        if (this.curve.twisted) {
          // Y3 = A * G * (D - a * C)
          ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
          // Z3 = F * G
          nz = f.redMul(g);
        } else {
          // Y3 = A * G * (D - C)
          ny = a.redMul(g).redMul(d.redSub(c));
          // Z3 = c * F * G
          nz = this.curve._mulC(f).redMul(g);
        }
        return this.curve.point(nx, ny, nz);
      };

      Point.prototype.add = function add(p) {
        if (this.isInfinity())
          return p;
        if (p.isInfinity())
          return this;

        if (this.curve.extended)
          return this._extAdd(p);
        else
          return this._projAdd(p);
      };

      Point.prototype.mul = function mul(k) {
        if (this._hasDoubles(k))
          return this.curve._fixedNafMul(this, k);
        else
          return this.curve._wnafMul(this, k);
      };

      Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
        return this.curve._wnafMulAdd(1, [this, p], [k1, k2], 2, false);
      };

      Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
        return this.curve._wnafMulAdd(1, [this, p], [k1, k2], 2, true);
      };

      Point.prototype.normalize = function normalize() {
        if (this.zOne)
          return this;

        // Normalize coordinates
        var zi = this.z.redInvm();
        this.x = this.x.redMul(zi);
        this.y = this.y.redMul(zi);
        if (this.t)
          this.t = this.t.redMul(zi);
        this.z = this.curve.one;
        this.zOne = true;
        return this;
      };

      Point.prototype.neg = function neg() {
        return this.curve.point(this.x.redNeg(),
          this.y,
          this.z,
          this.t && this.t.redNeg());
      };

      Point.prototype.getX = function getX() {
        this.normalize();
        return this.x.fromRed();
      };

      Point.prototype.getY = function getY() {
        this.normalize();
        return this.y.fromRed();
      };

      Point.prototype.eq = function eq(other) {
        return this === other ||
          this.getX().cmp(other.getX()) === 0 &&
          this.getY().cmp(other.getY()) === 0;
      };

      Point.prototype.eqXToP = function eqXToP(x) {
        var rx = x.toRed(this.curve.red).redMul(this.z);
        if (this.x.cmp(rx) === 0)
          return true;

        var xc = x.clone();
        var t = this.curve.redN.redMul(this.z);
        for (; ;) {
          xc.iadd(this.curve.n);
          if (xc.cmp(this.curve.p) >= 0)
            return false;

          rx.redIAdd(t);
          if (this.x.cmp(rx) === 0)
            return true;
        }
      };

      // Compatibility with BaseCurve
      Point.prototype.toP = Point.prototype.normalize;
      Point.prototype.mixedAdd = Point.prototype.add;

    }, { "../utils": 93, "./base": 80, "bn.js": 64, "inherits": 109 }], 82: [function (require, module, exports) {
      'use strict';

      var curve = exports;

      curve.base = require('./base');
      curve.short = require('./short');
      curve.mont = require('./mont');
      curve.edwards = require('./edwards');

    }, { "./base": 80, "./edwards": 81, "./mont": 83, "./short": 84 }], 83: [function (require, module, exports) {
      'use strict';

      var BN = require('bn.js');
      var inherits = require('inherits');
      var Base = require('./base');

      var utils = require('../utils');

      function MontCurve(conf) {
        Base.call(this, 'mont', conf);

        this.a = new BN(conf.a, 16).toRed(this.red);
        this.b = new BN(conf.b, 16).toRed(this.red);
        this.i4 = new BN(4).toRed(this.red).redInvm();
        this.two = new BN(2).toRed(this.red);
        this.a24 = this.i4.redMul(this.a.redAdd(this.two));
      }
      inherits(MontCurve, Base);
      module.exports = MontCurve;

      MontCurve.prototype.validate = function validate(point) {
        var x = point.normalize().x;
        var x2 = x.redSqr();
        var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
        var y = rhs.redSqrt();

        return y.redSqr().cmp(rhs) === 0;
      };

      function Point(curve, x, z) {
        Base.BasePoint.call(this, curve, 'projective');
        if (x === null && z === null) {
          this.x = this.curve.one;
          this.z = this.curve.zero;
        } else {
          this.x = new BN(x, 16);
          this.z = new BN(z, 16);
          if (!this.x.red)
            this.x = this.x.toRed(this.curve.red);
          if (!this.z.red)
            this.z = this.z.toRed(this.curve.red);
        }
      }
      inherits(Point, Base.BasePoint);

      MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
        return this.point(utils.toArray(bytes, enc), 1);
      };

      MontCurve.prototype.point = function point(x, z) {
        return new Point(this, x, z);
      };

      MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
        return Point.fromJSON(this, obj);
      };

      Point.prototype.precompute = function precompute() {
        // No-op
      };

      Point.prototype._encode = function _encode() {
        return this.getX().toArray('be', this.curve.p.byteLength());
      };

      Point.fromJSON = function fromJSON(curve, obj) {
        return new Point(curve, obj[0], obj[1] || curve.one);
      };

      Point.prototype.inspect = function inspect() {
        if (this.isInfinity())
          return '<EC Point Infinity>';
        return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
          ' z: ' + this.z.fromRed().toString(16, 2) + '>';
      };

      Point.prototype.isInfinity = function isInfinity() {
        // XXX This code assumes that zero is always zero in red
        return this.z.cmpn(0) === 0;
      };

      Point.prototype.dbl = function dbl() {
        // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
        // 2M + 2S + 4A

        // A = X1 + Z1
        var a = this.x.redAdd(this.z);
        // AA = A^2
        var aa = a.redSqr();
        // B = X1 - Z1
        var b = this.x.redSub(this.z);
        // BB = B^2
        var bb = b.redSqr();
        // C = AA - BB
        var c = aa.redSub(bb);
        // X3 = AA * BB
        var nx = aa.redMul(bb);
        // Z3 = C * (BB + A24 * C)
        var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
        return this.curve.point(nx, nz);
      };

      Point.prototype.add = function add() {
        throw new Error('Not supported on Montgomery curve');
      };

      Point.prototype.diffAdd = function diffAdd(p, diff) {
        // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
        // 4M + 2S + 6A

        // A = X2 + Z2
        var a = this.x.redAdd(this.z);
        // B = X2 - Z2
        var b = this.x.redSub(this.z);
        // C = X3 + Z3
        var c = p.x.redAdd(p.z);
        // D = X3 - Z3
        var d = p.x.redSub(p.z);
        // DA = D * A
        var da = d.redMul(a);
        // CB = C * B
        var cb = c.redMul(b);
        // X5 = Z1 * (DA + CB)^2
        var nx = diff.z.redMul(da.redAdd(cb).redSqr());
        // Z5 = X1 * (DA - CB)^2
        var nz = diff.x.redMul(da.redISub(cb).redSqr());
        return this.curve.point(nx, nz);
      };

      Point.prototype.mul = function mul(k) {
        var t = k.clone();
        var a = this; // (N / 2) * Q + Q
        var b = this.curve.point(null, null); // (N / 2) * Q
        var c = this; // Q

        for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
          bits.push(t.andln(1));

        for (var i = bits.length - 1; i >= 0; i--) {
          if (bits[i] === 0) {
            // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
            a = a.diffAdd(b, c);
            // N * Q = 2 * ((N / 2) * Q + Q))
            b = b.dbl();
          } else {
            // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
            b = a.diffAdd(b, c);
            // N * Q + Q = 2 * ((N / 2) * Q + Q)
            a = a.dbl();
          }
        }
        return b;
      };

      Point.prototype.mulAdd = function mulAdd() {
        throw new Error('Not supported on Montgomery curve');
      };

      Point.prototype.jumlAdd = function jumlAdd() {
        throw new Error('Not supported on Montgomery curve');
      };

      Point.prototype.eq = function eq(other) {
        return this.getX().cmp(other.getX()) === 0;
      };

      Point.prototype.normalize = function normalize() {
        this.x = this.x.redMul(this.z.redInvm());
        this.z = this.curve.one;
        return this;
      };

      Point.prototype.getX = function getX() {
        // Normalize coordinates
        this.normalize();

        return this.x.fromRed();
      };

    }, { "../utils": 93, "./base": 80, "bn.js": 64, "inherits": 109 }], 84: [function (require, module, exports) {
      'use strict';

      var utils = require('../utils');
      var BN = require('bn.js');
      var inherits = require('inherits');
      var Base = require('./base');

      var assert = utils.assert;

      function ShortCurve(conf) {
        Base.call(this, 'short', conf);

        this.a = new BN(conf.a, 16).toRed(this.red);
        this.b = new BN(conf.b, 16).toRed(this.red);
        this.tinv = this.two.redInvm();

        this.zeroA = this.a.fromRed().cmpn(0) === 0;
        this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

        // If the curve is endomorphic, precalculate beta and lambda
        this.endo = this._getEndomorphism(conf);
        this._endoWnafT1 = new Array(4);
        this._endoWnafT2 = new Array(4);
      }
      inherits(ShortCurve, Base);
      module.exports = ShortCurve;

      ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
        // No efficient endomorphism
        if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
          return;

        // Compute beta and lambda, that lambda * P = (beta * Px; Py)
        var beta;
        var lambda;
        if (conf.beta) {
          beta = new BN(conf.beta, 16).toRed(this.red);
        } else {
          var betas = this._getEndoRoots(this.p);
          // Choose the smallest beta
          beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
          beta = beta.toRed(this.red);
        }
        if (conf.lambda) {
          lambda = new BN(conf.lambda, 16);
        } else {
          // Choose the lambda that is matching selected beta
          var lambdas = this._getEndoRoots(this.n);
          if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
            lambda = lambdas[0];
          } else {
            lambda = lambdas[1];
            assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
          }
        }

        // Get basis vectors, used for balanced length-two representation
        var basis;
        if (conf.basis) {
          basis = conf.basis.map(function (vec) {
            return {
              a: new BN(vec.a, 16),
              b: new BN(vec.b, 16),
            };
          });
        } else {
          basis = this._getEndoBasis(lambda);
        }

        return {
          beta: beta,
          lambda: lambda,
          basis: basis,
        };
      };

      ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
        // Find roots of for x^2 + x + 1 in F
        // Root = (-1 +- Sqrt(-3)) / 2
        //
        var red = num === this.p ? this.red : BN.mont(num);
        var tinv = new BN(2).toRed(red).redInvm();
        var ntinv = tinv.redNeg();

        var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

        var l1 = ntinv.redAdd(s).fromRed();
        var l2 = ntinv.redSub(s).fromRed();
        return [l1, l2];
      };

      ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
        // aprxSqrt >= sqrt(this.n)
        var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

        // 3.74
        // Run EGCD, until r(L + 1) < aprxSqrt
        var u = lambda;
        var v = this.n.clone();
        var x1 = new BN(1);
        var y1 = new BN(0);
        var x2 = new BN(0);
        var y2 = new BN(1);

        // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
        var a0;
        var b0;
        // First vector
        var a1;
        var b1;
        // Second vector
        var a2;
        var b2;

        var prevR;
        var i = 0;
        var r;
        var x;
        while (u.cmpn(0) !== 0) {
          var q = v.div(u);
          r = v.sub(q.mul(u));
          x = x2.sub(q.mul(x1));
          var y = y2.sub(q.mul(y1));

          if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
          } else if (a1 && ++i === 2) {
            break;
          }
          prevR = r;

          v = u;
          u = r;
          x2 = x1;
          x1 = x;
          y2 = y1;
          y1 = y;
        }
        a2 = r.neg();
        b2 = x;

        var len1 = a1.sqr().add(b1.sqr());
        var len2 = a2.sqr().add(b2.sqr());
        if (len2.cmp(len1) >= 0) {
          a2 = a0;
          b2 = b0;
        }

        // Normalize signs
        if (a1.negative) {
          a1 = a1.neg();
          b1 = b1.neg();
        }
        if (a2.negative) {
          a2 = a2.neg();
          b2 = b2.neg();
        }

        return [
          { a: a1, b: b1 },
          { a: a2, b: b2 },
        ];
      };

      ShortCurve.prototype._endoSplit = function _endoSplit(k) {
        var basis = this.endo.basis;
        var v1 = basis[0];
        var v2 = basis[1];

        var c1 = v2.b.mul(k).divRound(this.n);
        var c2 = v1.b.neg().mul(k).divRound(this.n);

        var p1 = c1.mul(v1.a);
        var p2 = c2.mul(v2.a);
        var q1 = c1.mul(v1.b);
        var q2 = c2.mul(v2.b);

        // Calculate answer
        var k1 = k.sub(p1).sub(p2);
        var k2 = q1.add(q2).neg();
        return { k1: k1, k2: k2 };
      };

      ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
        x = new BN(x, 16);
        if (!x.red)
          x = x.toRed(this.red);

        var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
        var y = y2.redSqrt();
        if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
          throw new Error('invalid point');

        // XXX Is there any way to tell if the number is odd without converting it
        // to non-red form?
        var isOdd = y.fromRed().isOdd();
        if (odd && !isOdd || !odd && isOdd)
          y = y.redNeg();

        return this.point(x, y);
      };

      ShortCurve.prototype.validate = function validate(point) {
        if (point.inf)
          return true;

        var x = point.x;
        var y = point.y;

        var ax = this.a.redMul(x);
        var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
        return y.redSqr().redISub(rhs).cmpn(0) === 0;
      };

      ShortCurve.prototype._endoWnafMulAdd =
        function _endoWnafMulAdd(points, coeffs, jacobianResult) {
          var npoints = this._endoWnafT1;
          var ncoeffs = this._endoWnafT2;
          for (var i = 0; i < points.length; i++) {
            var split = this._endoSplit(coeffs[i]);
            var p = points[i];
            var beta = p._getBeta();

            if (split.k1.negative) {
              split.k1.ineg();
              p = p.neg(true);
            }
            if (split.k2.negative) {
              split.k2.ineg();
              beta = beta.neg(true);
            }

            npoints[i * 2] = p;
            npoints[i * 2 + 1] = beta;
            ncoeffs[i * 2] = split.k1;
            ncoeffs[i * 2 + 1] = split.k2;
          }
          var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

          // Clean-up references to points and coefficients
          for (var j = 0; j < i * 2; j++) {
            npoints[j] = null;
            ncoeffs[j] = null;
          }
          return res;
        };

      function Point(curve, x, y, isRed) {
        Base.BasePoint.call(this, curve, 'affine');
        if (x === null && y === null) {
          this.x = null;
          this.y = null;
          this.inf = true;
        } else {
          this.x = new BN(x, 16);
          this.y = new BN(y, 16);
          // Force redgomery representation when loading from JSON
          if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
          }
          if (!this.x.red)
            this.x = this.x.toRed(this.curve.red);
          if (!this.y.red)
            this.y = this.y.toRed(this.curve.red);
          this.inf = false;
        }
      }
      inherits(Point, Base.BasePoint);

      ShortCurve.prototype.point = function point(x, y, isRed) {
        return new Point(this, x, y, isRed);
      };

      ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
        return Point.fromJSON(this, obj, red);
      };

      Point.prototype._getBeta = function _getBeta() {
        if (!this.curve.endo)
          return;

        var pre = this.precomputed;
        if (pre && pre.beta)
          return pre.beta;

        var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
        if (pre) {
          var curve = this.curve;
          var endoMul = function (p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
          };
          pre.beta = beta;
          beta.precomputed = {
            beta: null,
            naf: pre.naf && {
              wnd: pre.naf.wnd,
              points: pre.naf.points.map(endoMul),
            },
            doubles: pre.doubles && {
              step: pre.doubles.step,
              points: pre.doubles.points.map(endoMul),
            },
          };
        }
        return beta;
      };

      Point.prototype.toJSON = function toJSON() {
        if (!this.precomputed)
          return [this.x, this.y];

        return [this.x, this.y, this.precomputed && {
          doubles: this.precomputed.doubles && {
            step: this.precomputed.doubles.step,
            points: this.precomputed.doubles.points.slice(1),
          },
          naf: this.precomputed.naf && {
            wnd: this.precomputed.naf.wnd,
            points: this.precomputed.naf.points.slice(1),
          },
        }];
      };

      Point.fromJSON = function fromJSON(curve, obj, red) {
        if (typeof obj === 'string')
          obj = JSON.parse(obj);
        var res = curve.point(obj[0], obj[1], red);
        if (!obj[2])
          return res;

        function obj2point(obj) {
          return curve.point(obj[0], obj[1], red);
        }

        var pre = obj[2];
        res.precomputed = {
          beta: null,
          doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [res].concat(pre.doubles.points.map(obj2point)),
          },
          naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [res].concat(pre.naf.points.map(obj2point)),
          },
        };
        return res;
      };

      Point.prototype.inspect = function inspect() {
        if (this.isInfinity())
          return '<EC Point Infinity>';
        return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
          ' y: ' + this.y.fromRed().toString(16, 2) + '>';
      };

      Point.prototype.isInfinity = function isInfinity() {
        return this.inf;
      };

      Point.prototype.add = function add(p) {
        // O + P = P
        if (this.inf)
          return p;

        // P + O = P
        if (p.inf)
          return this;

        // P + P = 2P
        if (this.eq(p))
          return this.dbl();

        // P + (-P) = O
        if (this.neg().eq(p))
          return this.curve.point(null, null);

        // P + Q = O
        if (this.x.cmp(p.x) === 0)
          return this.curve.point(null, null);

        var c = this.y.redSub(p.y);
        if (c.cmpn(0) !== 0)
          c = c.redMul(this.x.redSub(p.x).redInvm());
        var nx = c.redSqr().redISub(this.x).redISub(p.x);
        var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
        return this.curve.point(nx, ny);
      };

      Point.prototype.dbl = function dbl() {
        if (this.inf)
          return this;

        // 2P = O
        var ys1 = this.y.redAdd(this.y);
        if (ys1.cmpn(0) === 0)
          return this.curve.point(null, null);

        var a = this.curve.a;

        var x2 = this.x.redSqr();
        var dyinv = ys1.redInvm();
        var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

        var nx = c.redSqr().redISub(this.x.redAdd(this.x));
        var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
        return this.curve.point(nx, ny);
      };

      Point.prototype.getX = function getX() {
        return this.x.fromRed();
      };

      Point.prototype.getY = function getY() {
        return this.y.fromRed();
      };

      Point.prototype.mul = function mul(k) {
        k = new BN(k, 16);
        if (this.isInfinity())
          return this;
        else if (this._hasDoubles(k))
          return this.curve._fixedNafMul(this, k);
        else if (this.curve.endo)
          return this.curve._endoWnafMulAdd([this], [k]);
        else
          return this.curve._wnafMul(this, k);
      };

      Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
        var points = [this, p2];
        var coeffs = [k1, k2];
        if (this.curve.endo)
          return this.curve._endoWnafMulAdd(points, coeffs);
        else
          return this.curve._wnafMulAdd(1, points, coeffs, 2);
      };

      Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
        var points = [this, p2];
        var coeffs = [k1, k2];
        if (this.curve.endo)
          return this.curve._endoWnafMulAdd(points, coeffs, true);
        else
          return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
      };

      Point.prototype.eq = function eq(p) {
        return this === p ||
          this.inf === p.inf &&
          (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
      };

      Point.prototype.neg = function neg(_precompute) {
        if (this.inf)
          return this;

        var res = this.curve.point(this.x, this.y.redNeg());
        if (_precompute && this.precomputed) {
          var pre = this.precomputed;
          var negate = function (p) {
            return p.neg();
          };
          res.precomputed = {
            naf: pre.naf && {
              wnd: pre.naf.wnd,
              points: pre.naf.points.map(negate),
            },
            doubles: pre.doubles && {
              step: pre.doubles.step,
              points: pre.doubles.points.map(negate),
            },
          };
        }
        return res;
      };

      Point.prototype.toJ = function toJ() {
        if (this.inf)
          return this.curve.jpoint(null, null, null);

        var res = this.curve.jpoint(this.x, this.y, this.curve.one);
        return res;
      };

      function JPoint(curve, x, y, z) {
        Base.BasePoint.call(this, curve, 'jacobian');
        if (x === null && y === null && z === null) {
          this.x = this.curve.one;
          this.y = this.curve.one;
          this.z = new BN(0);
        } else {
          this.x = new BN(x, 16);
          this.y = new BN(y, 16);
          this.z = new BN(z, 16);
        }
        if (!this.x.red)
          this.x = this.x.toRed(this.curve.red);
        if (!this.y.red)
          this.y = this.y.toRed(this.curve.red);
        if (!this.z.red)
          this.z = this.z.toRed(this.curve.red);

        this.zOne = this.z === this.curve.one;
      }
      inherits(JPoint, Base.BasePoint);

      ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
        return new JPoint(this, x, y, z);
      };

      JPoint.prototype.toP = function toP() {
        if (this.isInfinity())
          return this.curve.point(null, null);

        var zinv = this.z.redInvm();
        var zinv2 = zinv.redSqr();
        var ax = this.x.redMul(zinv2);
        var ay = this.y.redMul(zinv2).redMul(zinv);

        return this.curve.point(ax, ay);
      };

      JPoint.prototype.neg = function neg() {
        return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
      };

      JPoint.prototype.add = function add(p) {
        // O + P = P
        if (this.isInfinity())
          return p;

        // P + O = P
        if (p.isInfinity())
          return this;

        // 12M + 4S + 7A
        var pz2 = p.z.redSqr();
        var z2 = this.z.redSqr();
        var u1 = this.x.redMul(pz2);
        var u2 = p.x.redMul(z2);
        var s1 = this.y.redMul(pz2.redMul(p.z));
        var s2 = p.y.redMul(z2.redMul(this.z));

        var h = u1.redSub(u2);
        var r = s1.redSub(s2);
        if (h.cmpn(0) === 0) {
          if (r.cmpn(0) !== 0)
            return this.curve.jpoint(null, null, null);
          else
            return this.dbl();
        }

        var h2 = h.redSqr();
        var h3 = h2.redMul(h);
        var v = u1.redMul(h2);

        var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
        var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
        var nz = this.z.redMul(p.z).redMul(h);

        return this.curve.jpoint(nx, ny, nz);
      };

      JPoint.prototype.mixedAdd = function mixedAdd(p) {
        // O + P = P
        if (this.isInfinity())
          return p.toJ();

        // P + O = P
        if (p.isInfinity())
          return this;

        // 8M + 3S + 7A
        var z2 = this.z.redSqr();
        var u1 = this.x;
        var u2 = p.x.redMul(z2);
        var s1 = this.y;
        var s2 = p.y.redMul(z2).redMul(this.z);

        var h = u1.redSub(u2);
        var r = s1.redSub(s2);
        if (h.cmpn(0) === 0) {
          if (r.cmpn(0) !== 0)
            return this.curve.jpoint(null, null, null);
          else
            return this.dbl();
        }

        var h2 = h.redSqr();
        var h3 = h2.redMul(h);
        var v = u1.redMul(h2);

        var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
        var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
        var nz = this.z.redMul(h);

        return this.curve.jpoint(nx, ny, nz);
      };

      JPoint.prototype.dblp = function dblp(pow) {
        if (pow === 0)
          return this;
        if (this.isInfinity())
          return this;
        if (!pow)
          return this.dbl();

        var i;
        if (this.curve.zeroA || this.curve.threeA) {
          var r = this;
          for (i = 0; i < pow; i++)
            r = r.dbl();
          return r;
        }

        // 1M + 2S + 1A + N * (4S + 5M + 8A)
        // N = 1 => 6M + 6S + 9A
        var a = this.curve.a;
        var tinv = this.curve.tinv;

        var jx = this.x;
        var jy = this.y;
        var jz = this.z;
        var jz4 = jz.redSqr().redSqr();

        // Reuse results
        var jyd = jy.redAdd(jy);
        for (i = 0; i < pow; i++) {
          var jx2 = jx.redSqr();
          var jyd2 = jyd.redSqr();
          var jyd4 = jyd2.redSqr();
          var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

          var t1 = jx.redMul(jyd2);
          var nx = c.redSqr().redISub(t1.redAdd(t1));
          var t2 = t1.redISub(nx);
          var dny = c.redMul(t2);
          dny = dny.redIAdd(dny).redISub(jyd4);
          var nz = jyd.redMul(jz);
          if (i + 1 < pow)
            jz4 = jz4.redMul(jyd4);

          jx = nx;
          jz = nz;
          jyd = dny;
        }

        return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
      };

      JPoint.prototype.dbl = function dbl() {
        if (this.isInfinity())
          return this;

        if (this.curve.zeroA)
          return this._zeroDbl();
        else if (this.curve.threeA)
          return this._threeDbl();
        else
          return this._dbl();
      };

      JPoint.prototype._zeroDbl = function _zeroDbl() {
        var nx;
        var ny;
        var nz;
        // Z = 1
        if (this.zOne) {
          // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
          //     #doubling-mdbl-2007-bl
          // 1M + 5S + 14A

          // XX = X1^2
          var xx = this.x.redSqr();
          // YY = Y1^2
          var yy = this.y.redSqr();
          // YYYY = YY^2
          var yyyy = yy.redSqr();
          // S = 2 * ((X1 + YY)^2 - XX - YYYY)
          var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
          s = s.redIAdd(s);
          // M = 3 * XX + a; a = 0
          var m = xx.redAdd(xx).redIAdd(xx);
          // T = M ^ 2 - 2*S
          var t = m.redSqr().redISub(s).redISub(s);

          // 8 * YYYY
          var yyyy8 = yyyy.redIAdd(yyyy);
          yyyy8 = yyyy8.redIAdd(yyyy8);
          yyyy8 = yyyy8.redIAdd(yyyy8);

          // X3 = T
          nx = t;
          // Y3 = M * (S - T) - 8 * YYYY
          ny = m.redMul(s.redISub(t)).redISub(yyyy8);
          // Z3 = 2*Y1
          nz = this.y.redAdd(this.y);
        } else {
          // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
          //     #doubling-dbl-2009-l
          // 2M + 5S + 13A

          // A = X1^2
          var a = this.x.redSqr();
          // B = Y1^2
          var b = this.y.redSqr();
          // C = B^2
          var c = b.redSqr();
          // D = 2 * ((X1 + B)^2 - A - C)
          var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
          d = d.redIAdd(d);
          // E = 3 * A
          var e = a.redAdd(a).redIAdd(a);
          // F = E^2
          var f = e.redSqr();

          // 8 * C
          var c8 = c.redIAdd(c);
          c8 = c8.redIAdd(c8);
          c8 = c8.redIAdd(c8);

          // X3 = F - 2 * D
          nx = f.redISub(d).redISub(d);
          // Y3 = E * (D - X3) - 8 * C
          ny = e.redMul(d.redISub(nx)).redISub(c8);
          // Z3 = 2 * Y1 * Z1
          nz = this.y.redMul(this.z);
          nz = nz.redIAdd(nz);
        }

        return this.curve.jpoint(nx, ny, nz);
      };

      JPoint.prototype._threeDbl = function _threeDbl() {
        var nx;
        var ny;
        var nz;
        // Z = 1
        if (this.zOne) {
          // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
          //     #doubling-mdbl-2007-bl
          // 1M + 5S + 15A

          // XX = X1^2
          var xx = this.x.redSqr();
          // YY = Y1^2
          var yy = this.y.redSqr();
          // YYYY = YY^2
          var yyyy = yy.redSqr();
          // S = 2 * ((X1 + YY)^2 - XX - YYYY)
          var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
          s = s.redIAdd(s);
          // M = 3 * XX + a
          var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
          // T = M^2 - 2 * S
          var t = m.redSqr().redISub(s).redISub(s);
          // X3 = T
          nx = t;
          // Y3 = M * (S - T) - 8 * YYYY
          var yyyy8 = yyyy.redIAdd(yyyy);
          yyyy8 = yyyy8.redIAdd(yyyy8);
          yyyy8 = yyyy8.redIAdd(yyyy8);
          ny = m.redMul(s.redISub(t)).redISub(yyyy8);
          // Z3 = 2 * Y1
          nz = this.y.redAdd(this.y);
        } else {
          // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
          // 3M + 5S

          // delta = Z1^2
          var delta = this.z.redSqr();
          // gamma = Y1^2
          var gamma = this.y.redSqr();
          // beta = X1 * gamma
          var beta = this.x.redMul(gamma);
          // alpha = 3 * (X1 - delta) * (X1 + delta)
          var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
          alpha = alpha.redAdd(alpha).redIAdd(alpha);
          // X3 = alpha^2 - 8 * beta
          var beta4 = beta.redIAdd(beta);
          beta4 = beta4.redIAdd(beta4);
          var beta8 = beta4.redAdd(beta4);
          nx = alpha.redSqr().redISub(beta8);
          // Z3 = (Y1 + Z1)^2 - gamma - delta
          nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
          // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
          var ggamma8 = gamma.redSqr();
          ggamma8 = ggamma8.redIAdd(ggamma8);
          ggamma8 = ggamma8.redIAdd(ggamma8);
          ggamma8 = ggamma8.redIAdd(ggamma8);
          ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
        }

        return this.curve.jpoint(nx, ny, nz);
      };

      JPoint.prototype._dbl = function _dbl() {
        var a = this.curve.a;

        // 4M + 6S + 10A
        var jx = this.x;
        var jy = this.y;
        var jz = this.z;
        var jz4 = jz.redSqr().redSqr();

        var jx2 = jx.redSqr();
        var jy2 = jy.redSqr();

        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

        var jxd4 = jx.redAdd(jx);
        jxd4 = jxd4.redIAdd(jxd4);
        var t1 = jxd4.redMul(jy2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);

        var jyd8 = jy2.redSqr();
        jyd8 = jyd8.redIAdd(jyd8);
        jyd8 = jyd8.redIAdd(jyd8);
        jyd8 = jyd8.redIAdd(jyd8);
        var ny = c.redMul(t2).redISub(jyd8);
        var nz = jy.redAdd(jy).redMul(jz);

        return this.curve.jpoint(nx, ny, nz);
      };

      JPoint.prototype.trpl = function trpl() {
        if (!this.curve.zeroA)
          return this.dbl().add(this);

        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
        // 5M + 10S + ...

        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // ZZ = Z1^2
        var zz = this.z.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // M = 3 * XX + a * ZZ2; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // MM = M^2
        var mm = m.redSqr();
        // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
        var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        e = e.redIAdd(e);
        e = e.redAdd(e).redIAdd(e);
        e = e.redISub(mm);
        // EE = E^2
        var ee = e.redSqr();
        // T = 16*YYYY
        var t = yyyy.redIAdd(yyyy);
        t = t.redIAdd(t);
        t = t.redIAdd(t);
        t = t.redIAdd(t);
        // U = (M + E)^2 - MM - EE - T
        var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
        // X3 = 4 * (X1 * EE - 4 * YY * U)
        var yyu4 = yy.redMul(u);
        yyu4 = yyu4.redIAdd(yyu4);
        yyu4 = yyu4.redIAdd(yyu4);
        var nx = this.x.redMul(ee).redISub(yyu4);
        nx = nx.redIAdd(nx);
        nx = nx.redIAdd(nx);
        // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
        var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
        ny = ny.redIAdd(ny);
        ny = ny.redIAdd(ny);
        ny = ny.redIAdd(ny);
        // Z3 = (Z1 + E)^2 - ZZ - EE
        var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

        return this.curve.jpoint(nx, ny, nz);
      };

      JPoint.prototype.mul = function mul(k, kbase) {
        k = new BN(k, kbase);

        return this.curve._wnafMul(this, k);
      };

      JPoint.prototype.eq = function eq(p) {
        if (p.type === 'affine')
          return this.eq(p.toJ());

        if (this === p)
          return true;

        // x1 * z2^2 == x2 * z1^2
        var z2 = this.z.redSqr();
        var pz2 = p.z.redSqr();
        if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
          return false;

        // y1 * z2^3 == y2 * z1^3
        var z3 = z2.redMul(this.z);
        var pz3 = pz2.redMul(p.z);
        return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
      };

      JPoint.prototype.eqXToP = function eqXToP(x) {
        var zs = this.z.redSqr();
        var rx = x.toRed(this.curve.red).redMul(zs);
        if (this.x.cmp(rx) === 0)
          return true;

        var xc = x.clone();
        var t = this.curve.redN.redMul(zs);
        for (; ;) {
          xc.iadd(this.curve.n);
          if (xc.cmp(this.curve.p) >= 0)
            return false;

          rx.redIAdd(t);
          if (this.x.cmp(rx) === 0)
            return true;
        }
      };

      JPoint.prototype.inspect = function inspect() {
        if (this.isInfinity())
          return '<EC JPoint Infinity>';
        return '<EC JPoint x: ' + this.x.toString(16, 2) +
          ' y: ' + this.y.toString(16, 2) +
          ' z: ' + this.z.toString(16, 2) + '>';
      };

      JPoint.prototype.isInfinity = function isInfinity() {
        // XXX This code assumes that zero is always zero in red
        return this.z.cmpn(0) === 0;
      };

    }, { "../utils": 93, "./base": 80, "bn.js": 64, "inherits": 109 }], 85: [function (require, module, exports) {
      'use strict';

      var curves = exports;

      var hash = require('hash.js');
      var curve = require('./curve');
      var utils = require('./utils');

      var assert = utils.assert;

      function PresetCurve(options) {
        if (options.type === 'short')
          this.curve = new curve.short(options);
        else if (options.type === 'edwards')
          this.curve = new curve.edwards(options);
        else
          this.curve = new curve.mont(options);
        this.g = this.curve.g;
        this.n = this.curve.n;
        this.hash = options.hash;

        assert(this.g.validate(), 'Invalid curve');
        assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
      }
      curves.PresetCurve = PresetCurve;

      function defineCurve(name, options) {
        Object.defineProperty(curves, name, {
          configurable: true,
          enumerable: true,
          get: function () {
            var curve = new PresetCurve(options);
            Object.defineProperty(curves, name, {
              configurable: true,
              enumerable: true,
              value: curve,
            });
            return curve;
          },
        });
      }

      defineCurve('p192', {
        type: 'short',
        prime: 'p192',
        p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
        a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
        b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
        n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
        hash: hash.sha256,
        gRed: false,
        g: [
          '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
          '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811',
        ],
      });

      defineCurve('p224', {
        type: 'short',
        prime: 'p224',
        p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
        a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
        b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
        n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
        hash: hash.sha256,
        gRed: false,
        g: [
          'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
          'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34',
        ],
      });

      defineCurve('p256', {
        type: 'short',
        prime: null,
        p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
        a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
        b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
        n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
        hash: hash.sha256,
        gRed: false,
        g: [
          '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
          '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5',
        ],
      });

      defineCurve('p384', {
        type: 'short',
        prime: null,
        p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
          'fffffffe ffffffff 00000000 00000000 ffffffff',
        a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
          'fffffffe ffffffff 00000000 00000000 fffffffc',
        b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
          '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
        n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
          'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
        hash: hash.sha384,
        gRed: false,
        g: [
          'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
          '5502f25d bf55296c 3a545e38 72760ab7',
          '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
          '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f',
        ],
      });

      defineCurve('p521', {
        type: 'short',
        prime: null,
        p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
          'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
          'ffffffff ffffffff ffffffff ffffffff ffffffff',
        a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
          'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
          'ffffffff ffffffff ffffffff ffffffff fffffffc',
        b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
          '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
          '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
        n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
          'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
          'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
        hash: hash.sha512,
        gRed: false,
        g: [
          '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
          '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
          'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
          '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
          '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
          '3fad0761 353c7086 a272c240 88be9476 9fd16650',
        ],
      });

      defineCurve('curve25519', {
        type: 'mont',
        prime: 'p25519',
        p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
        a: '76d06',
        b: '1',
        n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
        hash: hash.sha256,
        gRed: false,
        g: [
          '9',
        ],
      });

      defineCurve('ed25519', {
        type: 'edwards',
        prime: 'p25519',
        p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
        a: '-1',
        c: '1',
        // -121665 * (121666^(-1)) (mod P)
        d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
        n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
        hash: hash.sha256,
        gRed: false,
        g: [
          '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

          // 4/5
          '6666666666666666666666666666666666666666666666666666666666666658',
        ],
      });

      var pre;
      try {
        pre = require('./precomputed/secp256k1');
      } catch (e) {
        pre = undefined;
      }

      defineCurve('secp256k1', {
        type: 'short',
        prime: 'k256',
        p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
        a: '0',
        b: '7',
        n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
        h: '1',
        hash: hash.sha256,

        // Precomputed endomorphism
        beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
        lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
        basis: [
          {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3',
          },
          {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15',
          },
        ],

        gRed: false,
        g: [
          '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
          '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
          pre,
        ],
      });

    }, { "./curve": 82, "./precomputed/secp256k1": 92, "./utils": 93, "hash.js": 96 }], 86: [function (require, module, exports) {
      'use strict';

      var BN = require('bn.js');
      var HmacDRBG = require('hmac-drbg');
      var utils = require('../utils');
      var curves = require('../curves');
      var rand = require('brorand');
      var assert = utils.assert;

      var KeyPair = require('./key');
      var Signature = require('./signature');

      function EC(options) {
        if (!(this instanceof EC))
          return new EC(options);

        // Shortcut `elliptic.ec(curve-name)`
        if (typeof options === 'string') {
          assert(Object.prototype.hasOwnProperty.call(curves, options),
            'Unknown curve ' + options);

          options = curves[options];
        }

        // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
        if (options instanceof curves.PresetCurve)
          options = { curve: options };

        this.curve = options.curve.curve;
        this.n = this.curve.n;
        this.nh = this.n.ushrn(1);
        this.g = this.curve.g;

        // Point on curve
        this.g = options.curve.g;
        this.g.precompute(options.curve.n.bitLength() + 1);

        // Hash for function for DRBG
        this.hash = options.hash || options.curve.hash;
      }
      module.exports = EC;

      EC.prototype.keyPair = function keyPair(options) {
        return new KeyPair(this, options);
      };

      EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
        return KeyPair.fromPrivate(this, priv, enc);
      };

      EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
        return KeyPair.fromPublic(this, pub, enc);
      };

      EC.prototype.genKeyPair = function genKeyPair(options) {
        if (!options)
          options = {};

        // Instantiate Hmac_DRBG
        var drbg = new HmacDRBG({
          hash: this.hash,
          pers: options.pers,
          persEnc: options.persEnc || 'utf8',
          entropy: options.entropy || rand(this.hash.hmacStrength),
          entropyEnc: options.entropy && options.entropyEnc || 'utf8',
          nonce: this.n.toArray(),
        });

        var bytes = this.n.byteLength();
        var ns2 = this.n.sub(new BN(2));
        for (; ;) {
          var priv = new BN(drbg.generate(bytes));
          if (priv.cmp(ns2) > 0)
            continue;

          priv.iaddn(1);
          return this.keyFromPrivate(priv);
        }
      };

      EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
        var delta = msg.byteLength() * 8 - this.n.bitLength();
        if (delta > 0)
          msg = msg.ushrn(delta);
        if (!truncOnly && msg.cmp(this.n) >= 0)
          return msg.sub(this.n);
        else
          return msg;
      };

      EC.prototype.sign = function sign(msg, key, enc, options) {
        if (typeof enc === 'object') {
          options = enc;
          enc = null;
        }
        if (!options)
          options = {};

        key = this.keyFromPrivate(key, enc);
        msg = this._truncateToN(new BN(msg, 16));

        // Zero-extend key to provide enough entropy
        var bytes = this.n.byteLength();
        var bkey = key.getPrivate().toArray('be', bytes);

        // Zero-extend nonce to have the same byte size as N
        var nonce = msg.toArray('be', bytes);

        // Instantiate Hmac_DRBG
        var drbg = new HmacDRBG({
          hash: this.hash,
          entropy: bkey,
          nonce: nonce,
          pers: options.pers,
          persEnc: options.persEnc || 'utf8',
        });

        // Number of bytes to generate
        var ns1 = this.n.sub(new BN(1));

        for (var iter = 0; ; iter++) {
          var k = options.k ?
            options.k(iter) :
            new BN(drbg.generate(this.n.byteLength()));
          k = this._truncateToN(k, true);
          if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
            continue;

          var kp = this.g.mul(k);
          if (kp.isInfinity())
            continue;

          var kpX = kp.getX();
          var r = kpX.umod(this.n);
          if (r.cmpn(0) === 0)
            continue;

          var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
          s = s.umod(this.n);
          if (s.cmpn(0) === 0)
            continue;

          var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
            (kpX.cmp(r) !== 0 ? 2 : 0);

          // Use complement of `s`, if it is > `n / 2`
          if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
          }

          return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
        }
      };

      EC.prototype.verify = function verify(msg, signature, key, enc) {
        msg = this._truncateToN(new BN(msg, 16));
        key = this.keyFromPublic(key, enc);
        signature = new Signature(signature, 'hex');

        // Perform primitive values validation
        var r = signature.r;
        var s = signature.s;
        if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
          return false;
        if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
          return false;

        // Validate signature
        var sinv = s.invm(this.n);
        var u1 = sinv.mul(msg).umod(this.n);
        var u2 = sinv.mul(r).umod(this.n);
        var p;

        if (!this.curve._maxwellTrick) {
          p = this.g.mulAdd(u1, key.getPublic(), u2);
          if (p.isInfinity())
            return false;

          return p.getX().umod(this.n).cmp(r) === 0;
        }

        // NOTE: Greg Maxwell's trick, inspired by:
        // https://git.io/vad3K

        p = this.g.jmulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity())
          return false;

        // Compare `p.x` of Jacobian point with `r`,
        // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
        // inverse of `p.z^2`
        return p.eqXToP(r);
      };

      EC.prototype.recoverPubKey = function (msg, signature, j, enc) {
        assert((3 & j) === j, 'The recovery param is more than two bits');
        signature = new Signature(signature, enc);

        var n = this.n;
        var e = new BN(msg);
        var r = signature.r;
        var s = signature.s;

        // A set LSB signifies that the y-coordinate is odd
        var isYOdd = j & 1;
        var isSecondKey = j >> 1;
        if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
          throw new Error('Unable to find sencond key candinate');

        // 1.1. Let x = r + jn.
        if (isSecondKey)
          r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
        else
          r = this.curve.pointFromX(r, isYOdd);

        var rInv = signature.r.invm(n);
        var s1 = n.sub(e).mul(rInv).umod(n);
        var s2 = s.mul(rInv).umod(n);

        // 1.6.1 Compute Q = r^-1 (sR -  eG)
        //               Q = r^-1 (sR + -eG)
        return this.g.mulAdd(s1, r, s2);
      };

      EC.prototype.getKeyRecoveryParam = function (e, signature, Q, enc) {
        signature = new Signature(signature, enc);
        if (signature.recoveryParam !== null)
          return signature.recoveryParam;

        for (var i = 0; i < 4; i++) {
          var Qprime;
          try {
            Qprime = this.recoverPubKey(e, signature, i);
          } catch (e) {
            continue;
          }

          if (Qprime.eq(Q))
            return i;
        }
        throw new Error('Unable to find valid recovery factor');
      };

    }, { "../curves": 85, "../utils": 93, "./key": 87, "./signature": 88, "bn.js": 64, "brorand": 65, "hmac-drbg": 108 }], 87: [function (require, module, exports) {
      'use strict';

      var BN = require('bn.js');
      var utils = require('../utils');
      var assert = utils.assert;

      function KeyPair(ec, options) {
        this.ec = ec;
        this.priv = null;
        this.pub = null;

        // KeyPair(ec, { priv: ..., pub: ... })
        if (options.priv)
          this._importPrivate(options.priv, options.privEnc);
        if (options.pub)
          this._importPublic(options.pub, options.pubEnc);
      }
      module.exports = KeyPair;

      KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
        if (pub instanceof KeyPair)
          return pub;

        return new KeyPair(ec, {
          pub: pub,
          pubEnc: enc,
        });
      };

      KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
        if (priv instanceof KeyPair)
          return priv;

        return new KeyPair(ec, {
          priv: priv,
          privEnc: enc,
        });
      };

      KeyPair.prototype.validate = function validate() {
        var pub = this.getPublic();

        if (pub.isInfinity())
          return { result: false, reason: 'Invalid public key' };
        if (!pub.validate())
          return { result: false, reason: 'Public key is not a point' };
        if (!pub.mul(this.ec.curve.n).isInfinity())
          return { result: false, reason: 'Public key * N != O' };

        return { result: true, reason: null };
      };

      KeyPair.prototype.getPublic = function getPublic(compact, enc) {
        // compact is optional argument
        if (typeof compact === 'string') {
          enc = compact;
          compact = null;
        }

        if (!this.pub)
          this.pub = this.ec.g.mul(this.priv);

        if (!enc)
          return this.pub;

        return this.pub.encode(enc, compact);
      };

      KeyPair.prototype.getPrivate = function getPrivate(enc) {
        if (enc === 'hex')
          return this.priv.toString(16, 2);
        else
          return this.priv;
      };

      KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
        this.priv = new BN(key, enc || 16);

        // Ensure that the priv won't be bigger than n, otherwise we may fail
        // in fixed multiplication method
        this.priv = this.priv.umod(this.ec.curve.n);
      };

      KeyPair.prototype._importPublic = function _importPublic(key, enc) {
        if (key.x || key.y) {
          // Montgomery points only have an `x` coordinate.
          // Weierstrass/Edwards points on the other hand have both `x` and
          // `y` coordinates.
          if (this.ec.curve.type === 'mont') {
            assert(key.x, 'Need x coordinate');
          } else if (this.ec.curve.type === 'short' ||
            this.ec.curve.type === 'edwards') {
            assert(key.x && key.y, 'Need both x and y coordinate');
          }
          this.pub = this.ec.curve.point(key.x, key.y);
          return;
        }
        this.pub = this.ec.curve.decodePoint(key, enc);
      };

      // ECDH
      KeyPair.prototype.derive = function derive(pub) {
        if (!pub.validate()) {
          assert(pub.validate(), 'public point not validated');
        }
        return pub.mul(this.priv).getX();
      };

      // ECDSA
      KeyPair.prototype.sign = function sign(msg, enc, options) {
        return this.ec.sign(msg, this, enc, options);
      };

      KeyPair.prototype.verify = function verify(msg, signature) {
        return this.ec.verify(msg, signature, this);
      };

      KeyPair.prototype.inspect = function inspect() {
        return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
          ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
      };

    }, { "../utils": 93, "bn.js": 64 }], 88: [function (require, module, exports) {
      'use strict';

      var BN = require('bn.js');

      var utils = require('../utils');
      var assert = utils.assert;

      function Signature(options, enc) {
        if (options instanceof Signature)
          return options;

        if (this._importDER(options, enc))
          return;

        assert(options.r && options.s, 'Signature without r or s');
        this.r = new BN(options.r, 16);
        this.s = new BN(options.s, 16);
        if (options.recoveryParam === undefined)
          this.recoveryParam = null;
        else
          this.recoveryParam = options.recoveryParam;
      }
      module.exports = Signature;

      function Position() {
        this.place = 0;
      }

      function getLength(buf, p) {
        var initial = buf[p.place++];
        if (!(initial & 0x80)) {
          return initial;
        }
        var octetLen = initial & 0xf;

        // Indefinite length or overflow
        if (octetLen === 0 || octetLen > 4) {
          return false;
        }

        var val = 0;
        for (var i = 0, off = p.place; i < octetLen; i++, off++) {
          val <<= 8;
          val |= buf[off];
          val >>>= 0;
        }

        // Leading zeroes
        if (val <= 0x7f) {
          return false;
        }

        p.place = off;
        return val;
      }

      function rmPadding(buf) {
        var i = 0;
        var len = buf.length - 1;
        while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
          i++;
        }
        if (i === 0) {
          return buf;
        }
        return buf.slice(i);
      }

      Signature.prototype._importDER = function _importDER(data, enc) {
        data = utils.toArray(data, enc);
        var p = new Position();
        if (data[p.place++] !== 0x30) {
          return false;
        }
        var len = getLength(data, p);
        if (len === false) {
          return false;
        }
        if ((len + p.place) !== data.length) {
          return false;
        }
        if (data[p.place++] !== 0x02) {
          return false;
        }
        var rlen = getLength(data, p);
        if (rlen === false) {
          return false;
        }
        var r = data.slice(p.place, rlen + p.place);
        p.place += rlen;
        if (data[p.place++] !== 0x02) {
          return false;
        }
        var slen = getLength(data, p);
        if (slen === false) {
          return false;
        }
        if (data.length !== slen + p.place) {
          return false;
        }
        var s = data.slice(p.place, slen + p.place);
        if (r[0] === 0) {
          if (r[1] & 0x80) {
            r = r.slice(1);
          } else {
            // Leading zeroes
            return false;
          }
        }
        if (s[0] === 0) {
          if (s[1] & 0x80) {
            s = s.slice(1);
          } else {
            // Leading zeroes
            return false;
          }
        }

        this.r = new BN(r);
        this.s = new BN(s);
        this.recoveryParam = null;

        return true;
      };

      function constructLength(arr, len) {
        if (len < 0x80) {
          arr.push(len);
          return;
        }
        var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
        arr.push(octets | 0x80);
        while (--octets) {
          arr.push((len >>> (octets << 3)) & 0xff);
        }
        arr.push(len);
      }

      Signature.prototype.toDER = function toDER(enc) {
        var r = this.r.toArray();
        var s = this.s.toArray();

        // Pad values
        if (r[0] & 0x80)
          r = [0].concat(r);
        // Pad values
        if (s[0] & 0x80)
          s = [0].concat(s);

        r = rmPadding(r);
        s = rmPadding(s);

        while (!s[0] && !(s[1] & 0x80)) {
          s = s.slice(1);
        }
        var arr = [0x02];
        constructLength(arr, r.length);
        arr = arr.concat(r);
        arr.push(0x02);
        constructLength(arr, s.length);
        var backHalf = arr.concat(s);
        var res = [0x30];
        constructLength(res, backHalf.length);
        res = res.concat(backHalf);
        return utils.encode(res, enc);
      };

    }, { "../utils": 93, "bn.js": 64 }], 89: [function (require, module, exports) {
      'use strict';

      var hash = require('hash.js');
      var curves = require('../curves');
      var utils = require('../utils');
      var assert = utils.assert;
      var parseBytes = utils.parseBytes;
      var KeyPair = require('./key');
      var Signature = require('./signature');

      function EDDSA(curve) {
        assert(curve === 'ed25519', 'only tested with ed25519 so far');

        if (!(this instanceof EDDSA))
          return new EDDSA(curve);

        curve = curves[curve].curve;
        this.curve = curve;
        this.g = curve.g;
        this.g.precompute(curve.n.bitLength() + 1);

        this.pointClass = curve.point().constructor;
        this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
        this.hash = hash.sha512;
      }

      module.exports = EDDSA;

      /**
      * @param {Array|String} message - message bytes
      * @param {Array|String|KeyPair} secret - secret bytes or a keypair
      * @returns {Signature} - signature
      */
      EDDSA.prototype.sign = function sign(message, secret) {
        message = parseBytes(message);
        var key = this.keyFromSecret(secret);
        var r = this.hashInt(key.messagePrefix(), message);
        var R = this.g.mul(r);
        var Rencoded = this.encodePoint(R);
        var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
          .mul(key.priv());
        var S = r.add(s_).umod(this.curve.n);
        return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
      };

      /**
      * @param {Array} message - message bytes
      * @param {Array|String|Signature} sig - sig bytes
      * @param {Array|String|Point|KeyPair} pub - public key
      * @returns {Boolean} - true if public key matches sig of message
      */
      EDDSA.prototype.verify = function verify(message, sig, pub) {
        message = parseBytes(message);
        sig = this.makeSignature(sig);
        var key = this.keyFromPublic(pub);
        var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
        var SG = this.g.mul(sig.S());
        var RplusAh = sig.R().add(key.pub().mul(h));
        return RplusAh.eq(SG);
      };

      EDDSA.prototype.hashInt = function hashInt() {
        var hash = this.hash();
        for (var i = 0; i < arguments.length; i++)
          hash.update(arguments[i]);
        return utils.intFromLE(hash.digest()).umod(this.curve.n);
      };

      EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
        return KeyPair.fromPublic(this, pub);
      };

      EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
        return KeyPair.fromSecret(this, secret);
      };

      EDDSA.prototype.makeSignature = function makeSignature(sig) {
        if (sig instanceof Signature)
          return sig;
        return new Signature(this, sig);
      };

      /**
      * * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
      *
      * EDDSA defines methods for encoding and decoding points and integers. These are
      * helper convenience methods, that pass along to utility functions implied
      * parameters.
      *
      */
      EDDSA.prototype.encodePoint = function encodePoint(point) {
        var enc = point.getY().toArray('le', this.encodingLength);
        enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
        return enc;
      };

      EDDSA.prototype.decodePoint = function decodePoint(bytes) {
        bytes = utils.parseBytes(bytes);

        var lastIx = bytes.length - 1;
        var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
        var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

        var y = utils.intFromLE(normed);
        return this.curve.pointFromY(y, xIsOdd);
      };

      EDDSA.prototype.encodeInt = function encodeInt(num) {
        return num.toArray('le', this.encodingLength);
      };

      EDDSA.prototype.decodeInt = function decodeInt(bytes) {
        return utils.intFromLE(bytes);
      };

      EDDSA.prototype.isPoint = function isPoint(val) {
        return val instanceof this.pointClass;
      };

    }, { "../curves": 85, "../utils": 93, "./key": 90, "./signature": 91, "hash.js": 96 }], 90: [function (require, module, exports) {
      'use strict';

      var utils = require('../utils');
      var assert = utils.assert;
      var parseBytes = utils.parseBytes;
      var cachedProperty = utils.cachedProperty;

      /**
      * @param {EDDSA} eddsa - instance
      * @param {Object} params - public/private key parameters
      *
      * @param {Array<Byte>} [params.secret] - secret seed bytes
      * @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
      * @param {Array<Byte>} [params.pub] - public key point encoded as bytes
      *
      */
      function KeyPair(eddsa, params) {
        this.eddsa = eddsa;
        this._secret = parseBytes(params.secret);
        if (eddsa.isPoint(params.pub))
          this._pub = params.pub;
        else
          this._pubBytes = parseBytes(params.pub);
      }

      KeyPair.fromPublic = function fromPublic(eddsa, pub) {
        if (pub instanceof KeyPair)
          return pub;
        return new KeyPair(eddsa, { pub: pub });
      };

      KeyPair.fromSecret = function fromSecret(eddsa, secret) {
        if (secret instanceof KeyPair)
          return secret;
        return new KeyPair(eddsa, { secret: secret });
      };

      KeyPair.prototype.secret = function secret() {
        return this._secret;
      };

      cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
        return this.eddsa.encodePoint(this.pub());
      });

      cachedProperty(KeyPair, 'pub', function pub() {
        if (this._pubBytes)
          return this.eddsa.decodePoint(this._pubBytes);
        return this.eddsa.g.mul(this.priv());
      });

      cachedProperty(KeyPair, 'privBytes', function privBytes() {
        var eddsa = this.eddsa;
        var hash = this.hash();
        var lastIx = eddsa.encodingLength - 1;

        var a = hash.slice(0, eddsa.encodingLength);
        a[0] &= 248;
        a[lastIx] &= 127;
        a[lastIx] |= 64;

        return a;
      });

      cachedProperty(KeyPair, 'priv', function priv() {
        return this.eddsa.decodeInt(this.privBytes());
      });

      cachedProperty(KeyPair, 'hash', function hash() {
        return this.eddsa.hash().update(this.secret()).digest();
      });

      cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
        return this.hash().slice(this.eddsa.encodingLength);
      });

      KeyPair.prototype.sign = function sign(message) {
        assert(this._secret, 'KeyPair can only verify');
        return this.eddsa.sign(message, this);
      };

      KeyPair.prototype.verify = function verify(message, sig) {
        return this.eddsa.verify(message, sig, this);
      };

      KeyPair.prototype.getSecret = function getSecret(enc) {
        assert(this._secret, 'KeyPair is public only');
        return utils.encode(this.secret(), enc);
      };

      KeyPair.prototype.getPublic = function getPublic(enc) {
        return utils.encode(this.pubBytes(), enc);
      };

      module.exports = KeyPair;

    }, { "../utils": 93 }], 91: [function (require, module, exports) {
      'use strict';

      var BN = require('bn.js');
      var utils = require('../utils');
      var assert = utils.assert;
      var cachedProperty = utils.cachedProperty;
      var parseBytes = utils.parseBytes;

      /**
      * @param {EDDSA} eddsa - eddsa instance
      * @param {Array<Bytes>|Object} sig -
      * @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
      * @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
      * @param {Array<Bytes>} [sig.Rencoded] - R point encoded
      * @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
      */
      function Signature(eddsa, sig) {
        this.eddsa = eddsa;

        if (typeof sig !== 'object')
          sig = parseBytes(sig);

        if (Array.isArray(sig)) {
          sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength),
          };
        }

        assert(sig.R && sig.S, 'Signature without R or S');

        if (eddsa.isPoint(sig.R))
          this._R = sig.R;
        if (sig.S instanceof BN)
          this._S = sig.S;

        this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
        this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
      }

      cachedProperty(Signature, 'S', function S() {
        return this.eddsa.decodeInt(this.Sencoded());
      });

      cachedProperty(Signature, 'R', function R() {
        return this.eddsa.decodePoint(this.Rencoded());
      });

      cachedProperty(Signature, 'Rencoded', function Rencoded() {
        return this.eddsa.encodePoint(this.R());
      });

      cachedProperty(Signature, 'Sencoded', function Sencoded() {
        return this.eddsa.encodeInt(this.S());
      });

      Signature.prototype.toBytes = function toBytes() {
        return this.Rencoded().concat(this.Sencoded());
      };

      Signature.prototype.toHex = function toHex() {
        return utils.encode(this.toBytes(), 'hex').toUpperCase();
      };

      module.exports = Signature;

    }, { "../utils": 93, "bn.js": 64 }], 92: [function (require, module, exports) {
      module.exports = {
        doubles: {
          step: 4,
          points: [
            [
              'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
              'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821',
            ],
            [
              '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
              '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf',
            ],
            [
              '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
              'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695',
            ],
            [
              '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
              '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9',
            ],
            [
              '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
              '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36',
            ],
            [
              '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
              '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f',
            ],
            [
              'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
              '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999',
            ],
            [
              '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
              'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09',
            ],
            [
              'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
              '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d',
            ],
            [
              'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
              'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088',
            ],
            [
              'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
              '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d',
            ],
            [
              '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
              '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8',
            ],
            [
              '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
              '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a',
            ],
            [
              '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
              '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453',
            ],
            [
              '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
              '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160',
            ],
            [
              '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
              '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0',
            ],
            [
              '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
              '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6',
            ],
            [
              '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
              '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589',
            ],
            [
              '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
              'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17',
            ],
            [
              'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
              '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda',
            ],
            [
              'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
              '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd',
            ],
            [
              '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
              '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2',
            ],
            [
              '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
              '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6',
            ],
            [
              'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
              '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f',
            ],
            [
              '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
              'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01',
            ],
            [
              'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
              '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3',
            ],
            [
              'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
              'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f',
            ],
            [
              'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
              '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7',
            ],
            [
              'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
              'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78',
            ],
            [
              'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
              '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1',
            ],
            [
              '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
              'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150',
            ],
            [
              '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
              '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82',
            ],
            [
              'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
              '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc',
            ],
            [
              '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
              'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b',
            ],
            [
              'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
              '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51',
            ],
            [
              'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
              '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45',
            ],
            [
              'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
              'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120',
            ],
            [
              '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
              '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84',
            ],
            [
              '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
              '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d',
            ],
            [
              '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
              'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d',
            ],
            [
              '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
              '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8',
            ],
            [
              'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
              '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8',
            ],
            [
              '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
              '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac',
            ],
            [
              '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
              'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f',
            ],
            [
              '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
              '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962',
            ],
            [
              'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
              '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907',
            ],
            [
              '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
              'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec',
            ],
            [
              'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
              'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d',
            ],
            [
              'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
              '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414',
            ],
            [
              '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
              'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd',
            ],
            [
              '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
              'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0',
            ],
            [
              'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
              '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811',
            ],
            [
              'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
              '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1',
            ],
            [
              'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
              '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c',
            ],
            [
              '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
              'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73',
            ],
            [
              '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
              '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd',
            ],
            [
              'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
              'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405',
            ],
            [
              '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
              'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589',
            ],
            [
              '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
              '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e',
            ],
            [
              '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
              '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27',
            ],
            [
              'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
              'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1',
            ],
            [
              '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
              '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482',
            ],
            [
              '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
              '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945',
            ],
            [
              'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
              '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573',
            ],
            [
              'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
              'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82',
            ],
          ],
        },
        naf: {
          wnd: 7,
          points: [
            [
              'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
              '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672',
            ],
            [
              '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
              'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6',
            ],
            [
              '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
              '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da',
            ],
            [
              'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
              'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37',
            ],
            [
              '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
              'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b',
            ],
            [
              'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
              'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81',
            ],
            [
              'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
              '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58',
            ],
            [
              'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
              '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77',
            ],
            [
              '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
              '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a',
            ],
            [
              '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
              '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c',
            ],
            [
              '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
              '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67',
            ],
            [
              '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
              '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402',
            ],
            [
              'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
              'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55',
            ],
            [
              'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
              '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482',
            ],
            [
              '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
              'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82',
            ],
            [
              '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
              'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396',
            ],
            [
              '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
              '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49',
            ],
            [
              '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
              '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf',
            ],
            [
              '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
              '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a',
            ],
            [
              '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
              'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7',
            ],
            [
              'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
              'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933',
            ],
            [
              '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
              '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a',
            ],
            [
              '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
              '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6',
            ],
            [
              'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
              'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37',
            ],
            [
              '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
              '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e',
            ],
            [
              'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
              'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6',
            ],
            [
              'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
              'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476',
            ],
            [
              '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
              '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40',
            ],
            [
              '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
              '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61',
            ],
            [
              '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
              '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683',
            ],
            [
              'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
              '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5',
            ],
            [
              '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
              '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b',
            ],
            [
              'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
              '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417',
            ],
            [
              '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
              'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868',
            ],
            [
              '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
              'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a',
            ],
            [
              'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
              'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6',
            ],
            [
              '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
              '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996',
            ],
            [
              '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
              'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e',
            ],
            [
              'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
              'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d',
            ],
            [
              '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
              '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2',
            ],
            [
              '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
              'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e',
            ],
            [
              '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
              '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437',
            ],
            [
              '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
              'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311',
            ],
            [
              'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
              '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4',
            ],
            [
              '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
              '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575',
            ],
            [
              '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
              'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d',
            ],
            [
              '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
              'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d',
            ],
            [
              'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
              'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629',
            ],
            [
              'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
              'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06',
            ],
            [
              '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
              '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374',
            ],
            [
              '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
              '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee',
            ],
            [
              'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
              '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1',
            ],
            [
              'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
              'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b',
            ],
            [
              '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
              '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661',
            ],
            [
              '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
              '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6',
            ],
            [
              'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
              '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e',
            ],
            [
              '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
              '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d',
            ],
            [
              'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
              'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc',
            ],
            [
              '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
              'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4',
            ],
            [
              '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
              '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c',
            ],
            [
              'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
              '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b',
            ],
            [
              'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
              '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913',
            ],
            [
              '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
              '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154',
            ],
            [
              '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
              '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865',
            ],
            [
              '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
              'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc',
            ],
            [
              '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
              'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224',
            ],
            [
              '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
              '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e',
            ],
            [
              '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
              '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6',
            ],
            [
              '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
              '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511',
            ],
            [
              '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
              'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b',
            ],
            [
              'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
              'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2',
            ],
            [
              '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
              'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c',
            ],
            [
              'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
              '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3',
            ],
            [
              'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
              '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d',
            ],
            [
              'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
              '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700',
            ],
            [
              'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
              '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4',
            ],
            [
              '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
              'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196',
            ],
            [
              '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
              '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4',
            ],
            [
              '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
              'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257',
            ],
            [
              'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
              'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13',
            ],
            [
              'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
              '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096',
            ],
            [
              'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
              'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38',
            ],
            [
              'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
              '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f',
            ],
            [
              '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
              '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448',
            ],
            [
              'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
              '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a',
            ],
            [
              'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
              '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4',
            ],
            [
              '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
              '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437',
            ],
            [
              '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
              'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7',
            ],
            [
              'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
              '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d',
            ],
            [
              'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
              '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a',
            ],
            [
              'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
              '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54',
            ],
            [
              '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
              '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77',
            ],
            [
              'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
              'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517',
            ],
            [
              '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
              'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10',
            ],
            [
              'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
              'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125',
            ],
            [
              'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
              '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e',
            ],
            [
              '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
              'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1',
            ],
            [
              'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
              '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2',
            ],
            [
              'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
              '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423',
            ],
            [
              'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
              '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8',
            ],
            [
              '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
              'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758',
            ],
            [
              '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
              'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375',
            ],
            [
              'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
              '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d',
            ],
            [
              '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
              'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec',
            ],
            [
              '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
              '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0',
            ],
            [
              '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
              'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c',
            ],
            [
              'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
              'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4',
            ],
            [
              '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
              'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f',
            ],
            [
              '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
              '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649',
            ],
            [
              '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
              'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826',
            ],
            [
              '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
              '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5',
            ],
            [
              'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
              'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87',
            ],
            [
              '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
              '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b',
            ],
            [
              'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
              '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc',
            ],
            [
              '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
              '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c',
            ],
            [
              'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
              'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f',
            ],
            [
              'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
              '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a',
            ],
            [
              'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
              'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46',
            ],
            [
              '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
              'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f',
            ],
            [
              '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
              '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03',
            ],
            [
              '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
              'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08',
            ],
            [
              '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
              '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8',
            ],
            [
              '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
              '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373',
            ],
            [
              '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
              'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3',
            ],
            [
              '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
              '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8',
            ],
            [
              '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
              '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1',
            ],
            [
              '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
              '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9',
            ],
          ],
        },
      };

    }, {}], 93: [function (require, module, exports) {
      'use strict';

      var utils = exports;
      var BN = require('bn.js');
      var minAssert = require('minimalistic-assert');
      var minUtils = require('minimalistic-crypto-utils');

      utils.assert = minAssert;
      utils.toArray = minUtils.toArray;
      utils.zero2 = minUtils.zero2;
      utils.toHex = minUtils.toHex;
      utils.encode = minUtils.encode;

      // Represent num in a w-NAF form
      function getNAF(num, w, bits) {
        var naf = new Array(Math.max(num.bitLength(), bits) + 1);
        naf.fill(0);

        var ws = 1 << (w + 1);
        var k = num.clone();

        for (var i = 0; i < naf.length; i++) {
          var z;
          var mod = k.andln(ws - 1);
          if (k.isOdd()) {
            if (mod > (ws >> 1) - 1)
              z = (ws >> 1) - mod;
            else
              z = mod;
            k.isubn(z);
          } else {
            z = 0;
          }

          naf[i] = z;
          k.iushrn(1);
        }

        return naf;
      }
      utils.getNAF = getNAF;

      // Represent k1, k2 in a Joint Sparse Form
      function getJSF(k1, k2) {
        var jsf = [
          [],
          [],
        ];

        k1 = k1.clone();
        k2 = k2.clone();
        var d1 = 0;
        var d2 = 0;
        var m8;
        while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {
          // First phase
          var m14 = (k1.andln(3) + d1) & 3;
          var m24 = (k2.andln(3) + d2) & 3;
          if (m14 === 3)
            m14 = -1;
          if (m24 === 3)
            m24 = -1;
          var u1;
          if ((m14 & 1) === 0) {
            u1 = 0;
          } else {
            m8 = (k1.andln(7) + d1) & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2)
              u1 = -m14;
            else
              u1 = m14;
          }
          jsf[0].push(u1);

          var u2;
          if ((m24 & 1) === 0) {
            u2 = 0;
          } else {
            m8 = (k2.andln(7) + d2) & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2)
              u2 = -m24;
            else
              u2 = m24;
          }
          jsf[1].push(u2);

          // Second phase
          if (2 * d1 === u1 + 1)
            d1 = 1 - d1;
          if (2 * d2 === u2 + 1)
            d2 = 1 - d2;
          k1.iushrn(1);
          k2.iushrn(1);
        }

        return jsf;
      }
      utils.getJSF = getJSF;

      function cachedProperty(obj, name, computer) {
        var key = '_' + name;
        obj.prototype[name] = function cachedProperty() {
          return this[key] !== undefined ? this[key] :
            this[key] = computer.call(this);
        };
      }
      utils.cachedProperty = cachedProperty;

      function parseBytes(bytes) {
        return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
          bytes;
      }
      utils.parseBytes = parseBytes;

      function intFromLE(bytes) {
        return new BN(bytes, 'hex', 'le');
      }
      utils.intFromLE = intFromLE;


    }, { "bn.js": 64, "minimalistic-assert": 112, "minimalistic-crypto-utils": 113 }], 94: [function (require, module, exports) {
      module.exports = {
        "name": "elliptic",
        "version": "6.5.4",
        "description": "EC cryptography",
        "main": "lib/elliptic.js",
        "files": [
          "lib"
        ],
        "scripts": {
          "lint": "eslint lib test",
          "lint:fix": "npm run lint -- --fix",
          "unit": "istanbul test _mocha --reporter=spec test/index.js",
          "test": "npm run lint && npm run unit",
          "version": "grunt dist && git add dist/"
        },
        "repository": {
          "type": "git",
          "url": "git@github.com:indutny/elliptic"
        },
        "keywords": [
          "EC",
          "Elliptic",
          "curve",
          "Cryptography"
        ],
        "author": "Fedor Indutny <fedor@indutny.com>",
        "license": "MIT",
        "bugs": {
          "url": "https://github.com/indutny/elliptic/issues"
        },
        "homepage": "https://github.com/indutny/elliptic",
        "devDependencies": {
          "brfs": "^2.0.2",
          "coveralls": "^3.1.0",
          "eslint": "^7.6.0",
          "grunt": "^1.2.1",
          "grunt-browserify": "^5.3.0",
          "grunt-cli": "^1.3.2",
          "grunt-contrib-connect": "^3.0.0",
          "grunt-contrib-copy": "^1.0.0",
          "grunt-contrib-uglify": "^5.0.0",
          "grunt-mocha-istanbul": "^5.0.2",
          "grunt-saucelabs": "^9.0.1",
          "istanbul": "^0.4.5",
          "mocha": "^8.0.1"
        },
        "dependencies": {
          "bn.js": "^4.11.9",
          "brorand": "^1.1.0",
          "hash.js": "^1.0.0",
          "hmac-drbg": "^1.0.1",
          "inherits": "^2.0.4",
          "minimalistic-assert": "^1.0.1",
          "minimalistic-crypto-utils": "^1.0.1"
        }
      }

    }, {}], 95: [function (require, module, exports) {
      'use strict'
      var Buffer = require('safe-buffer').Buffer
      var Transform = require('readable-stream').Transform
      var inherits = require('inherits')

      function throwIfNotStringOrBuffer(val, prefix) {
        if (!Buffer.isBuffer(val) && typeof val !== 'string') {
          throw new TypeError(prefix + ' must be a string or a buffer')
        }
      }

      function HashBase(blockSize) {
        Transform.call(this)

        this._block = Buffer.allocUnsafe(blockSize)
        this._blockSize = blockSize
        this._blockOffset = 0
        this._length = [0, 0, 0, 0]

        this._finalized = false
      }

      inherits(HashBase, Transform)

      HashBase.prototype._transform = function (chunk, encoding, callback) {
        var error = null
        try {
          this.update(chunk, encoding)
        } catch (err) {
          error = err
        }

        callback(error)
      }

      HashBase.prototype._flush = function (callback) {
        var error = null
        try {
          this.push(this.digest())
        } catch (err) {
          error = err
        }

        callback(error)
      }

      HashBase.prototype.update = function (data, encoding) {
        throwIfNotStringOrBuffer(data, 'Data')
        if (this._finalized) throw new Error('Digest already called')
        if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding)

        // consume data
        var block = this._block
        var offset = 0
        while (this._blockOffset + data.length - offset >= this._blockSize) {
          for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++]
          this._update()
          this._blockOffset = 0
        }
        while (offset < data.length) block[this._blockOffset++] = data[offset++]

        // update length
        for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
          this._length[j] += carry
          carry = (this._length[j] / 0x0100000000) | 0
          if (carry > 0) this._length[j] -= 0x0100000000 * carry
        }

        return this
      }

      HashBase.prototype._update = function () {
        throw new Error('_update is not implemented')
      }

      HashBase.prototype.digest = function (encoding) {
        if (this._finalized) throw new Error('Digest already called')
        this._finalized = true

        var digest = this._digest()
        if (encoding !== undefined) digest = digest.toString(encoding)

        // reset state
        this._block.fill(0)
        this._blockOffset = 0
        for (var i = 0; i < 4; ++i) this._length[i] = 0

        return digest
      }

      HashBase.prototype._digest = function () {
        throw new Error('_digest is not implemented')
      }

      module.exports = HashBase

    }, { "inherits": 109, "readable-stream": 131, "safe-buffer": 133 }], 96: [function (require, module, exports) {
      var hash = exports;

      hash.utils = require('./hash/utils');
      hash.common = require('./hash/common');
      hash.sha = require('./hash/sha');
      hash.ripemd = require('./hash/ripemd');
      hash.hmac = require('./hash/hmac');

      // Proxy hash functions to the main object
      hash.sha1 = hash.sha.sha1;
      hash.sha256 = hash.sha.sha256;
      hash.sha224 = hash.sha.sha224;
      hash.sha384 = hash.sha.sha384;
      hash.sha512 = hash.sha.sha512;
      hash.ripemd160 = hash.ripemd.ripemd160;

    }, { "./hash/common": 97, "./hash/hmac": 98, "./hash/ripemd": 99, "./hash/sha": 100, "./hash/utils": 107 }], 97: [function (require, module, exports) {
      'use strict';

      var utils = require('./utils');
      var assert = require('minimalistic-assert');

      function BlockHash() {
        this.pending = null;
        this.pendingTotal = 0;
        this.blockSize = this.constructor.blockSize;
        this.outSize = this.constructor.outSize;
        this.hmacStrength = this.constructor.hmacStrength;
        this.padLength = this.constructor.padLength / 8;
        this.endian = 'big';

        this._delta8 = this.blockSize / 8;
        this._delta32 = this.blockSize / 32;
      }
      exports.BlockHash = BlockHash;

      BlockHash.prototype.update = function update(msg, enc) {
        // Convert message to array, pad it, and join into 32bit blocks
        msg = utils.toArray(msg, enc);
        if (!this.pending)
          this.pending = msg;
        else
          this.pending = this.pending.concat(msg);
        this.pendingTotal += msg.length;

        // Enough data, try updating
        if (this.pending.length >= this._delta8) {
          msg = this.pending;

          // Process pending data in blocks
          var r = msg.length % this._delta8;
          this.pending = msg.slice(msg.length - r, msg.length);
          if (this.pending.length === 0)
            this.pending = null;

          msg = utils.join32(msg, 0, msg.length - r, this.endian);
          for (var i = 0; i < msg.length; i += this._delta32)
            this._update(msg, i, i + this._delta32);
        }

        return this;
      };

      BlockHash.prototype.digest = function digest(enc) {
        this.update(this._pad());
        assert(this.pending === null);

        return this._digest(enc);
      };

      BlockHash.prototype._pad = function pad() {
        var len = this.pendingTotal;
        var bytes = this._delta8;
        var k = bytes - ((len + this.padLength) % bytes);
        var res = new Array(k + this.padLength);
        res[0] = 0x80;
        for (var i = 1; i < k; i++)
          res[i] = 0;

        // Append length
        len <<= 3;
        if (this.endian === 'big') {
          for (var t = 8; t < this.padLength; t++)
            res[i++] = 0;

          res[i++] = 0;
          res[i++] = 0;
          res[i++] = 0;
          res[i++] = 0;
          res[i++] = (len >>> 24) & 0xff;
          res[i++] = (len >>> 16) & 0xff;
          res[i++] = (len >>> 8) & 0xff;
          res[i++] = len & 0xff;
        } else {
          res[i++] = len & 0xff;
          res[i++] = (len >>> 8) & 0xff;
          res[i++] = (len >>> 16) & 0xff;
          res[i++] = (len >>> 24) & 0xff;
          res[i++] = 0;
          res[i++] = 0;
          res[i++] = 0;
          res[i++] = 0;

          for (t = 8; t < this.padLength; t++)
            res[i++] = 0;
        }

        return res;
      };

    }, { "./utils": 107, "minimalistic-assert": 112 }], 98: [function (require, module, exports) {
      'use strict';

      var utils = require('./utils');
      var assert = require('minimalistic-assert');

      function Hmac(hash, key, enc) {
        if (!(this instanceof Hmac))
          return new Hmac(hash, key, enc);
        this.Hash = hash;
        this.blockSize = hash.blockSize / 8;
        this.outSize = hash.outSize / 8;
        this.inner = null;
        this.outer = null;

        this._init(utils.toArray(key, enc));
      }
      module.exports = Hmac;

      Hmac.prototype._init = function init(key) {
        // Shorten key, if needed
        if (key.length > this.blockSize)
          key = new this.Hash().update(key).digest();
        assert(key.length <= this.blockSize);

        // Add padding to key
        for (var i = key.length; i < this.blockSize; i++)
          key.push(0);

        for (i = 0; i < key.length; i++)
          key[i] ^= 0x36;
        this.inner = new this.Hash().update(key);

        // 0x36 ^ 0x5c = 0x6a
        for (i = 0; i < key.length; i++)
          key[i] ^= 0x6a;
        this.outer = new this.Hash().update(key);
      };

      Hmac.prototype.update = function update(msg, enc) {
        this.inner.update(msg, enc);
        return this;
      };

      Hmac.prototype.digest = function digest(enc) {
        this.outer.update(this.inner.digest());
        return this.outer.digest(enc);
      };

    }, { "./utils": 107, "minimalistic-assert": 112 }], 99: [function (require, module, exports) {
      'use strict';

      var utils = require('./utils');
      var common = require('./common');

      var rotl32 = utils.rotl32;
      var sum32 = utils.sum32;
      var sum32_3 = utils.sum32_3;
      var sum32_4 = utils.sum32_4;
      var BlockHash = common.BlockHash;

      function RIPEMD160() {
        if (!(this instanceof RIPEMD160))
          return new RIPEMD160();

        BlockHash.call(this);

        this.h = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];
        this.endian = 'little';
      }
      utils.inherits(RIPEMD160, BlockHash);
      exports.ripemd160 = RIPEMD160;

      RIPEMD160.blockSize = 512;
      RIPEMD160.outSize = 160;
      RIPEMD160.hmacStrength = 192;
      RIPEMD160.padLength = 64;

      RIPEMD160.prototype._update = function update(msg, start) {
        var A = this.h[0];
        var B = this.h[1];
        var C = this.h[2];
        var D = this.h[3];
        var E = this.h[4];
        var Ah = A;
        var Bh = B;
        var Ch = C;
        var Dh = D;
        var Eh = E;
        for (var j = 0; j < 80; j++) {
          var T = sum32(
            rotl32(
              sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
              s[j]),
            E);
          A = E;
          E = D;
          D = rotl32(C, 10);
          C = B;
          B = T;
          T = sum32(
            rotl32(
              sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
              sh[j]),
            Eh);
          Ah = Eh;
          Eh = Dh;
          Dh = rotl32(Ch, 10);
          Ch = Bh;
          Bh = T;
        }
        T = sum32_3(this.h[1], C, Dh);
        this.h[1] = sum32_3(this.h[2], D, Eh);
        this.h[2] = sum32_3(this.h[3], E, Ah);
        this.h[3] = sum32_3(this.h[4], A, Bh);
        this.h[4] = sum32_3(this.h[0], B, Ch);
        this.h[0] = T;
      };

      RIPEMD160.prototype._digest = function digest(enc) {
        if (enc === 'hex')
          return utils.toHex32(this.h, 'little');
        else
          return utils.split32(this.h, 'little');
      };

      function f(j, x, y, z) {
        if (j <= 15)
          return x ^ y ^ z;
        else if (j <= 31)
          return (x & y) | ((~x) & z);
        else if (j <= 47)
          return (x | (~y)) ^ z;
        else if (j <= 63)
          return (x & z) | (y & (~z));
        else
          return x ^ (y | (~z));
      }

      function K(j) {
        if (j <= 15)
          return 0x00000000;
        else if (j <= 31)
          return 0x5a827999;
        else if (j <= 47)
          return 0x6ed9eba1;
        else if (j <= 63)
          return 0x8f1bbcdc;
        else
          return 0xa953fd4e;
      }

      function Kh(j) {
        if (j <= 15)
          return 0x50a28be6;
        else if (j <= 31)
          return 0x5c4dd124;
        else if (j <= 47)
          return 0x6d703ef3;
        else if (j <= 63)
          return 0x7a6d76e9;
        else
          return 0x00000000;
      }

      var r = [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
        7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
        3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
        1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
        4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
      ];

      var rh = [
        5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
        6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
        15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
        8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
        12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
      ];

      var s = [
        11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
        7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
        11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
        11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
        9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
      ];

      var sh = [
        8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
        9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
        9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
        15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
        8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
      ];

    }, { "./common": 97, "./utils": 107 }], 100: [function (require, module, exports) {
      'use strict';

      exports.sha1 = require('./sha/1');
      exports.sha224 = require('./sha/224');
      exports.sha256 = require('./sha/256');
      exports.sha384 = require('./sha/384');
      exports.sha512 = require('./sha/512');

    }, { "./sha/1": 101, "./sha/224": 102, "./sha/256": 103, "./sha/384": 104, "./sha/512": 105 }], 101: [function (require, module, exports) {
      'use strict';

      var utils = require('../utils');
      var common = require('../common');
      var shaCommon = require('./common');

      var rotl32 = utils.rotl32;
      var sum32 = utils.sum32;
      var sum32_5 = utils.sum32_5;
      var ft_1 = shaCommon.ft_1;
      var BlockHash = common.BlockHash;

      var sha1_K = [
        0x5A827999, 0x6ED9EBA1,
        0x8F1BBCDC, 0xCA62C1D6
      ];

      function SHA1() {
        if (!(this instanceof SHA1))
          return new SHA1();

        BlockHash.call(this);
        this.h = [
          0x67452301, 0xefcdab89, 0x98badcfe,
          0x10325476, 0xc3d2e1f0];
        this.W = new Array(80);
      }

      utils.inherits(SHA1, BlockHash);
      module.exports = SHA1;

      SHA1.blockSize = 512;
      SHA1.outSize = 160;
      SHA1.hmacStrength = 80;
      SHA1.padLength = 64;

      SHA1.prototype._update = function _update(msg, start) {
        var W = this.W;

        for (var i = 0; i < 16; i++)
          W[i] = msg[start + i];

        for (; i < W.length; i++)
          W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

        var a = this.h[0];
        var b = this.h[1];
        var c = this.h[2];
        var d = this.h[3];
        var e = this.h[4];

        for (i = 0; i < W.length; i++) {
          var s = ~~(i / 20);
          var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
          e = d;
          d = c;
          c = rotl32(b, 30);
          b = a;
          a = t;
        }

        this.h[0] = sum32(this.h[0], a);
        this.h[1] = sum32(this.h[1], b);
        this.h[2] = sum32(this.h[2], c);
        this.h[3] = sum32(this.h[3], d);
        this.h[4] = sum32(this.h[4], e);
      };

      SHA1.prototype._digest = function digest(enc) {
        if (enc === 'hex')
          return utils.toHex32(this.h, 'big');
        else
          return utils.split32(this.h, 'big');
      };

    }, { "../common": 97, "../utils": 107, "./common": 106 }], 102: [function (require, module, exports) {
      'use strict';

      var utils = require('../utils');
      var SHA256 = require('./256');

      function SHA224() {
        if (!(this instanceof SHA224))
          return new SHA224();

        SHA256.call(this);
        this.h = [
          0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
          0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4];
      }
      utils.inherits(SHA224, SHA256);
      module.exports = SHA224;

      SHA224.blockSize = 512;
      SHA224.outSize = 224;
      SHA224.hmacStrength = 192;
      SHA224.padLength = 64;

      SHA224.prototype._digest = function digest(enc) {
        // Just truncate output
        if (enc === 'hex')
          return utils.toHex32(this.h.slice(0, 7), 'big');
        else
          return utils.split32(this.h.slice(0, 7), 'big');
      };


    }, { "../utils": 107, "./256": 103 }], 103: [function (require, module, exports) {
      'use strict';

      var utils = require('../utils');
      var common = require('../common');
      var shaCommon = require('./common');
      var assert = require('minimalistic-assert');

      var sum32 = utils.sum32;
      var sum32_4 = utils.sum32_4;
      var sum32_5 = utils.sum32_5;
      var ch32 = shaCommon.ch32;
      var maj32 = shaCommon.maj32;
      var s0_256 = shaCommon.s0_256;
      var s1_256 = shaCommon.s1_256;
      var g0_256 = shaCommon.g0_256;
      var g1_256 = shaCommon.g1_256;

      var BlockHash = common.BlockHash;

      var sha256_K = [
        0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
        0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
        0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
        0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
        0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
        0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
        0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
        0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
        0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
        0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
        0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
        0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
        0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
        0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
        0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
        0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
      ];

      function SHA256() {
        if (!(this instanceof SHA256))
          return new SHA256();

        BlockHash.call(this);
        this.h = [
          0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
          0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
        ];
        this.k = sha256_K;
        this.W = new Array(64);
      }
      utils.inherits(SHA256, BlockHash);
      module.exports = SHA256;

      SHA256.blockSize = 512;
      SHA256.outSize = 256;
      SHA256.hmacStrength = 192;
      SHA256.padLength = 64;

      SHA256.prototype._update = function _update(msg, start) {
        var W = this.W;

        for (var i = 0; i < 16; i++)
          W[i] = msg[start + i];
        for (; i < W.length; i++)
          W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

        var a = this.h[0];
        var b = this.h[1];
        var c = this.h[2];
        var d = this.h[3];
        var e = this.h[4];
        var f = this.h[5];
        var g = this.h[6];
        var h = this.h[7];

        assert(this.k.length === W.length);
        for (i = 0; i < W.length; i++) {
          var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
          var T2 = sum32(s0_256(a), maj32(a, b, c));
          h = g;
          g = f;
          f = e;
          e = sum32(d, T1);
          d = c;
          c = b;
          b = a;
          a = sum32(T1, T2);
        }

        this.h[0] = sum32(this.h[0], a);
        this.h[1] = sum32(this.h[1], b);
        this.h[2] = sum32(this.h[2], c);
        this.h[3] = sum32(this.h[3], d);
        this.h[4] = sum32(this.h[4], e);
        this.h[5] = sum32(this.h[5], f);
        this.h[6] = sum32(this.h[6], g);
        this.h[7] = sum32(this.h[7], h);
      };

      SHA256.prototype._digest = function digest(enc) {
        if (enc === 'hex')
          return utils.toHex32(this.h, 'big');
        else
          return utils.split32(this.h, 'big');
      };

    }, { "../common": 97, "../utils": 107, "./common": 106, "minimalistic-assert": 112 }], 104: [function (require, module, exports) {
      'use strict';

      var utils = require('../utils');

      var SHA512 = require('./512');

      function SHA384() {
        if (!(this instanceof SHA384))
          return new SHA384();

        SHA512.call(this);
        this.h = [
          0xcbbb9d5d, 0xc1059ed8,
          0x629a292a, 0x367cd507,
          0x9159015a, 0x3070dd17,
          0x152fecd8, 0xf70e5939,
          0x67332667, 0xffc00b31,
          0x8eb44a87, 0x68581511,
          0xdb0c2e0d, 0x64f98fa7,
          0x47b5481d, 0xbefa4fa4];
      }
      utils.inherits(SHA384, SHA512);
      module.exports = SHA384;

      SHA384.blockSize = 1024;
      SHA384.outSize = 384;
      SHA384.hmacStrength = 192;
      SHA384.padLength = 128;

      SHA384.prototype._digest = function digest(enc) {
        if (enc === 'hex')
          return utils.toHex32(this.h.slice(0, 12), 'big');
        else
          return utils.split32(this.h.slice(0, 12), 'big');
      };

    }, { "../utils": 107, "./512": 105 }], 105: [function (require, module, exports) {
      'use strict';

      var utils = require('../utils');
      var common = require('../common');
      var assert = require('minimalistic-assert');

      var rotr64_hi = utils.rotr64_hi;
      var rotr64_lo = utils.rotr64_lo;
      var shr64_hi = utils.shr64_hi;
      var shr64_lo = utils.shr64_lo;
      var sum64 = utils.sum64;
      var sum64_hi = utils.sum64_hi;
      var sum64_lo = utils.sum64_lo;
      var sum64_4_hi = utils.sum64_4_hi;
      var sum64_4_lo = utils.sum64_4_lo;
      var sum64_5_hi = utils.sum64_5_hi;
      var sum64_5_lo = utils.sum64_5_lo;

      var BlockHash = common.BlockHash;

      var sha512_K = [
        0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
        0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
        0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
        0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
        0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
        0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
        0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
        0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
        0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
        0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
        0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
        0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
        0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
        0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
        0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
        0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
        0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
        0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
        0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
        0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
        0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
        0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
        0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
        0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
        0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
        0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
        0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
        0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
        0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
        0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
        0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
        0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
        0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
        0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
        0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
        0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
        0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
        0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
        0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
        0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
      ];

      function SHA512() {
        if (!(this instanceof SHA512))
          return new SHA512();

        BlockHash.call(this);
        this.h = [
          0x6a09e667, 0xf3bcc908,
          0xbb67ae85, 0x84caa73b,
          0x3c6ef372, 0xfe94f82b,
          0xa54ff53a, 0x5f1d36f1,
          0x510e527f, 0xade682d1,
          0x9b05688c, 0x2b3e6c1f,
          0x1f83d9ab, 0xfb41bd6b,
          0x5be0cd19, 0x137e2179];
        this.k = sha512_K;
        this.W = new Array(160);
      }
      utils.inherits(SHA512, BlockHash);
      module.exports = SHA512;

      SHA512.blockSize = 1024;
      SHA512.outSize = 512;
      SHA512.hmacStrength = 192;
      SHA512.padLength = 128;

      SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
        var W = this.W;

        // 32 x 32bit words
        for (var i = 0; i < 32; i++)
          W[i] = msg[start + i];
        for (; i < W.length; i += 2) {
          var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
          var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
          var c1_hi = W[i - 14];  // i - 7
          var c1_lo = W[i - 13];
          var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
          var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
          var c3_hi = W[i - 32];  // i - 16
          var c3_lo = W[i - 31];

          W[i] = sum64_4_hi(
            c0_hi, c0_lo,
            c1_hi, c1_lo,
            c2_hi, c2_lo,
            c3_hi, c3_lo);
          W[i + 1] = sum64_4_lo(
            c0_hi, c0_lo,
            c1_hi, c1_lo,
            c2_hi, c2_lo,
            c3_hi, c3_lo);
        }
      };

      SHA512.prototype._update = function _update(msg, start) {
        this._prepareBlock(msg, start);

        var W = this.W;

        var ah = this.h[0];
        var al = this.h[1];
        var bh = this.h[2];
        var bl = this.h[3];
        var ch = this.h[4];
        var cl = this.h[5];
        var dh = this.h[6];
        var dl = this.h[7];
        var eh = this.h[8];
        var el = this.h[9];
        var fh = this.h[10];
        var fl = this.h[11];
        var gh = this.h[12];
        var gl = this.h[13];
        var hh = this.h[14];
        var hl = this.h[15];

        assert(this.k.length === W.length);
        for (var i = 0; i < W.length; i += 2) {
          var c0_hi = hh;
          var c0_lo = hl;
          var c1_hi = s1_512_hi(eh, el);
          var c1_lo = s1_512_lo(eh, el);
          var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
          var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
          var c3_hi = this.k[i];
          var c3_lo = this.k[i + 1];
          var c4_hi = W[i];
          var c4_lo = W[i + 1];

          var T1_hi = sum64_5_hi(
            c0_hi, c0_lo,
            c1_hi, c1_lo,
            c2_hi, c2_lo,
            c3_hi, c3_lo,
            c4_hi, c4_lo);
          var T1_lo = sum64_5_lo(
            c0_hi, c0_lo,
            c1_hi, c1_lo,
            c2_hi, c2_lo,
            c3_hi, c3_lo,
            c4_hi, c4_lo);

          c0_hi = s0_512_hi(ah, al);
          c0_lo = s0_512_lo(ah, al);
          c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
          c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

          var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
          var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

          hh = gh;
          hl = gl;

          gh = fh;
          gl = fl;

          fh = eh;
          fl = el;

          eh = sum64_hi(dh, dl, T1_hi, T1_lo);
          el = sum64_lo(dl, dl, T1_hi, T1_lo);

          dh = ch;
          dl = cl;

          ch = bh;
          cl = bl;

          bh = ah;
          bl = al;

          ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
          al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
        }

        sum64(this.h, 0, ah, al);
        sum64(this.h, 2, bh, bl);
        sum64(this.h, 4, ch, cl);
        sum64(this.h, 6, dh, dl);
        sum64(this.h, 8, eh, el);
        sum64(this.h, 10, fh, fl);
        sum64(this.h, 12, gh, gl);
        sum64(this.h, 14, hh, hl);
      };

      SHA512.prototype._digest = function digest(enc) {
        if (enc === 'hex')
          return utils.toHex32(this.h, 'big');
        else
          return utils.split32(this.h, 'big');
      };

      function ch64_hi(xh, xl, yh, yl, zh) {
        var r = (xh & yh) ^ ((~xh) & zh);
        if (r < 0)
          r += 0x100000000;
        return r;
      }

      function ch64_lo(xh, xl, yh, yl, zh, zl) {
        var r = (xl & yl) ^ ((~xl) & zl);
        if (r < 0)
          r += 0x100000000;
        return r;
      }

      function maj64_hi(xh, xl, yh, yl, zh) {
        var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
        if (r < 0)
          r += 0x100000000;
        return r;
      }

      function maj64_lo(xh, xl, yh, yl, zh, zl) {
        var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
        if (r < 0)
          r += 0x100000000;
        return r;
      }

      function s0_512_hi(xh, xl) {
        var c0_hi = rotr64_hi(xh, xl, 28);
        var c1_hi = rotr64_hi(xl, xh, 2);  // 34
        var c2_hi = rotr64_hi(xl, xh, 7);  // 39

        var r = c0_hi ^ c1_hi ^ c2_hi;
        if (r < 0)
          r += 0x100000000;
        return r;
      }

      function s0_512_lo(xh, xl) {
        var c0_lo = rotr64_lo(xh, xl, 28);
        var c1_lo = rotr64_lo(xl, xh, 2);  // 34
        var c2_lo = rotr64_lo(xl, xh, 7);  // 39

        var r = c0_lo ^ c1_lo ^ c2_lo;
        if (r < 0)
          r += 0x100000000;
        return r;
      }

      function s1_512_hi(xh, xl) {
        var c0_hi = rotr64_hi(xh, xl, 14);
        var c1_hi = rotr64_hi(xh, xl, 18);
        var c2_hi = rotr64_hi(xl, xh, 9);  // 41

        var r = c0_hi ^ c1_hi ^ c2_hi;
        if (r < 0)
          r += 0x100000000;
        return r;
      }

      function s1_512_lo(xh, xl) {
        var c0_lo = rotr64_lo(xh, xl, 14);
        var c1_lo = rotr64_lo(xh, xl, 18);
        var c2_lo = rotr64_lo(xl, xh, 9);  // 41

        var r = c0_lo ^ c1_lo ^ c2_lo;
        if (r < 0)
          r += 0x100000000;
        return r;
      }

      function g0_512_hi(xh, xl) {
        var c0_hi = rotr64_hi(xh, xl, 1);
        var c1_hi = rotr64_hi(xh, xl, 8);
        var c2_hi = shr64_hi(xh, xl, 7);

        var r = c0_hi ^ c1_hi ^ c2_hi;
        if (r < 0)
          r += 0x100000000;
        return r;
      }

      function g0_512_lo(xh, xl) {
        var c0_lo = rotr64_lo(xh, xl, 1);
        var c1_lo = rotr64_lo(xh, xl, 8);
        var c2_lo = shr64_lo(xh, xl, 7);

        var r = c0_lo ^ c1_lo ^ c2_lo;
        if (r < 0)
          r += 0x100000000;
        return r;
      }

      function g1_512_hi(xh, xl) {
        var c0_hi = rotr64_hi(xh, xl, 19);
        var c1_hi = rotr64_hi(xl, xh, 29);  // 61
        var c2_hi = shr64_hi(xh, xl, 6);

        var r = c0_hi ^ c1_hi ^ c2_hi;
        if (r < 0)
          r += 0x100000000;
        return r;
      }

      function g1_512_lo(xh, xl) {
        var c0_lo = rotr64_lo(xh, xl, 19);
        var c1_lo = rotr64_lo(xl, xh, 29);  // 61
        var c2_lo = shr64_lo(xh, xl, 6);

        var r = c0_lo ^ c1_lo ^ c2_lo;
        if (r < 0)
          r += 0x100000000;
        return r;
      }

    }, { "../common": 97, "../utils": 107, "minimalistic-assert": 112 }], 106: [function (require, module, exports) {
      'use strict';

      var utils = require('../utils');
      var rotr32 = utils.rotr32;

      function ft_1(s, x, y, z) {
        if (s === 0)
          return ch32(x, y, z);
        if (s === 1 || s === 3)
          return p32(x, y, z);
        if (s === 2)
          return maj32(x, y, z);
      }
      exports.ft_1 = ft_1;

      function ch32(x, y, z) {
        return (x & y) ^ ((~x) & z);
      }
      exports.ch32 = ch32;

      function maj32(x, y, z) {
        return (x & y) ^ (x & z) ^ (y & z);
      }
      exports.maj32 = maj32;

      function p32(x, y, z) {
        return x ^ y ^ z;
      }
      exports.p32 = p32;

      function s0_256(x) {
        return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
      }
      exports.s0_256 = s0_256;

      function s1_256(x) {
        return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
      }
      exports.s1_256 = s1_256;

      function g0_256(x) {
        return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
      }
      exports.g0_256 = g0_256;

      function g1_256(x) {
        return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
      }
      exports.g1_256 = g1_256;

    }, { "../utils": 107 }], 107: [function (require, module, exports) {
      'use strict';

      var assert = require('minimalistic-assert');
      var inherits = require('inherits');

      exports.inherits = inherits;

      function isSurrogatePair(msg, i) {
        if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
          return false;
        }
        if (i < 0 || i + 1 >= msg.length) {
          return false;
        }
        return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
      }

      function toArray(msg, enc) {
        if (Array.isArray(msg))
          return msg.slice();
        if (!msg)
          return [];
        var res = [];
        if (typeof msg === 'string') {
          if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for (var i = 0; i < msg.length; i++) {
              var c = msg.charCodeAt(i);
              if (c < 128) {
                res[p++] = c;
              } else if (c < 2048) {
                res[p++] = (c >> 6) | 192;
                res[p++] = (c & 63) | 128;
              } else if (isSurrogatePair(msg, i)) {
                c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                res[p++] = (c >> 18) | 240;
                res[p++] = ((c >> 12) & 63) | 128;
                res[p++] = ((c >> 6) & 63) | 128;
                res[p++] = (c & 63) | 128;
              } else {
                res[p++] = (c >> 12) | 224;
                res[p++] = ((c >> 6) & 63) | 128;
                res[p++] = (c & 63) | 128;
              }
            }
          } else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0)
              msg = '0' + msg;
            for (i = 0; i < msg.length; i += 2)
              res.push(parseInt(msg[i] + msg[i + 1], 16));
          }
        } else {
          for (i = 0; i < msg.length; i++)
            res[i] = msg[i] | 0;
        }
        return res;
      }
      exports.toArray = toArray;

      function toHex(msg) {
        var res = '';
        for (var i = 0; i < msg.length; i++)
          res += zero2(msg[i].toString(16));
        return res;
      }
      exports.toHex = toHex;

      function htonl(w) {
        var res = (w >>> 24) |
          ((w >>> 8) & 0xff00) |
          ((w << 8) & 0xff0000) |
          ((w & 0xff) << 24);
        return res >>> 0;
      }
      exports.htonl = htonl;

      function toHex32(msg, endian) {
        var res = '';
        for (var i = 0; i < msg.length; i++) {
          var w = msg[i];
          if (endian === 'little')
            w = htonl(w);
          res += zero8(w.toString(16));
        }
        return res;
      }
      exports.toHex32 = toHex32;

      function zero2(word) {
        if (word.length === 1)
          return '0' + word;
        else
          return word;
      }
      exports.zero2 = zero2;

      function zero8(word) {
        if (word.length === 7)
          return '0' + word;
        else if (word.length === 6)
          return '00' + word;
        else if (word.length === 5)
          return '000' + word;
        else if (word.length === 4)
          return '0000' + word;
        else if (word.length === 3)
          return '00000' + word;
        else if (word.length === 2)
          return '000000' + word;
        else if (word.length === 1)
          return '0000000' + word;
        else
          return word;
      }
      exports.zero8 = zero8;

      function join32(msg, start, end, endian) {
        var len = end - start;
        assert(len % 4 === 0);
        var res = new Array(len / 4);
        for (var i = 0, k = start; i < res.length; i++, k += 4) {
          var w;
          if (endian === 'big')
            w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
          else
            w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
          res[i] = w >>> 0;
        }
        return res;
      }
      exports.join32 = join32;

      function split32(msg, endian) {
        var res = new Array(msg.length * 4);
        for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
          var m = msg[i];
          if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = (m >>> 16) & 0xff;
            res[k + 2] = (m >>> 8) & 0xff;
            res[k + 3] = m & 0xff;
          } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = (m >>> 16) & 0xff;
            res[k + 1] = (m >>> 8) & 0xff;
            res[k] = m & 0xff;
          }
        }
        return res;
      }
      exports.split32 = split32;

      function rotr32(w, b) {
        return (w >>> b) | (w << (32 - b));
      }
      exports.rotr32 = rotr32;

      function rotl32(w, b) {
        return (w << b) | (w >>> (32 - b));
      }
      exports.rotl32 = rotl32;

      function sum32(a, b) {
        return (a + b) >>> 0;
      }
      exports.sum32 = sum32;

      function sum32_3(a, b, c) {
        return (a + b + c) >>> 0;
      }
      exports.sum32_3 = sum32_3;

      function sum32_4(a, b, c, d) {
        return (a + b + c + d) >>> 0;
      }
      exports.sum32_4 = sum32_4;

      function sum32_5(a, b, c, d, e) {
        return (a + b + c + d + e) >>> 0;
      }
      exports.sum32_5 = sum32_5;

      function sum64(buf, pos, ah, al) {
        var bh = buf[pos];
        var bl = buf[pos + 1];

        var lo = (al + bl) >>> 0;
        var hi = (lo < al ? 1 : 0) + ah + bh;
        buf[pos] = hi >>> 0;
        buf[pos + 1] = lo;
      }
      exports.sum64 = sum64;

      function sum64_hi(ah, al, bh, bl) {
        var lo = (al + bl) >>> 0;
        var hi = (lo < al ? 1 : 0) + ah + bh;
        return hi >>> 0;
      }
      exports.sum64_hi = sum64_hi;

      function sum64_lo(ah, al, bh, bl) {
        var lo = al + bl;
        return lo >>> 0;
      }
      exports.sum64_lo = sum64_lo;

      function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
        var carry = 0;
        var lo = al;
        lo = (lo + bl) >>> 0;
        carry += lo < al ? 1 : 0;
        lo = (lo + cl) >>> 0;
        carry += lo < cl ? 1 : 0;
        lo = (lo + dl) >>> 0;
        carry += lo < dl ? 1 : 0;

        var hi = ah + bh + ch + dh + carry;
        return hi >>> 0;
      }
      exports.sum64_4_hi = sum64_4_hi;

      function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
        var lo = al + bl + cl + dl;
        return lo >>> 0;
      }
      exports.sum64_4_lo = sum64_4_lo;

      function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
        var carry = 0;
        var lo = al;
        lo = (lo + bl) >>> 0;
        carry += lo < al ? 1 : 0;
        lo = (lo + cl) >>> 0;
        carry += lo < cl ? 1 : 0;
        lo = (lo + dl) >>> 0;
        carry += lo < dl ? 1 : 0;
        lo = (lo + el) >>> 0;
        carry += lo < el ? 1 : 0;

        var hi = ah + bh + ch + dh + eh + carry;
        return hi >>> 0;
      }
      exports.sum64_5_hi = sum64_5_hi;

      function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
        var lo = al + bl + cl + dl + el;

        return lo >>> 0;
      }
      exports.sum64_5_lo = sum64_5_lo;

      function rotr64_hi(ah, al, num) {
        var r = (al << (32 - num)) | (ah >>> num);
        return r >>> 0;
      }
      exports.rotr64_hi = rotr64_hi;

      function rotr64_lo(ah, al, num) {
        var r = (ah << (32 - num)) | (al >>> num);
        return r >>> 0;
      }
      exports.rotr64_lo = rotr64_lo;

      function shr64_hi(ah, al, num) {
        return ah >>> num;
      }
      exports.shr64_hi = shr64_hi;

      function shr64_lo(ah, al, num) {
        var r = (ah << (32 - num)) | (al >>> num);
        return r >>> 0;
      }
      exports.shr64_lo = shr64_lo;

    }, { "inherits": 109, "minimalistic-assert": 112 }], 108: [function (require, module, exports) {
      'use strict';

      var hash = require('hash.js');
      var utils = require('minimalistic-crypto-utils');
      var assert = require('minimalistic-assert');

      function HmacDRBG(options) {
        if (!(this instanceof HmacDRBG))
          return new HmacDRBG(options);
        this.hash = options.hash;
        this.predResist = !!options.predResist;

        this.outLen = this.hash.outSize;
        this.minEntropy = options.minEntropy || this.hash.hmacStrength;

        this._reseed = null;
        this.reseedInterval = null;
        this.K = null;
        this.V = null;

        var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
        var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
        var pers = utils.toArray(options.pers, options.persEnc || 'hex');
        assert(entropy.length >= (this.minEntropy / 8),
          'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
        this._init(entropy, nonce, pers);
      }
      module.exports = HmacDRBG;

      HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
        var seed = entropy.concat(nonce).concat(pers);

        this.K = new Array(this.outLen / 8);
        this.V = new Array(this.outLen / 8);
        for (var i = 0; i < this.V.length; i++) {
          this.K[i] = 0x00;
          this.V[i] = 0x01;
        }

        this._update(seed);
        this._reseed = 1;
        this.reseedInterval = 0x1000000000000;  // 2^48
      };

      HmacDRBG.prototype._hmac = function hmac() {
        return new hash.hmac(this.hash, this.K);
      };

      HmacDRBG.prototype._update = function update(seed) {
        var kmac = this._hmac()
          .update(this.V)
          .update([0x00]);
        if (seed)
          kmac = kmac.update(seed);
        this.K = kmac.digest();
        this.V = this._hmac().update(this.V).digest();
        if (!seed)
          return;

        this.K = this._hmac()
          .update(this.V)
          .update([0x01])
          .update(seed)
          .digest();
        this.V = this._hmac().update(this.V).digest();
      };

      HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
        // Optional entropy enc
        if (typeof entropyEnc !== 'string') {
          addEnc = add;
          add = entropyEnc;
          entropyEnc = null;
        }

        entropy = utils.toArray(entropy, entropyEnc);
        add = utils.toArray(add, addEnc);

        assert(entropy.length >= (this.minEntropy / 8),
          'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

        this._update(entropy.concat(add || []));
        this._reseed = 1;
      };

      HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
        if (this._reseed > this.reseedInterval)
          throw new Error('Reseed is required');

        // Optional encoding
        if (typeof enc !== 'string') {
          addEnc = add;
          add = enc;
          enc = null;
        }

        // Optional additional data
        if (add) {
          add = utils.toArray(add, addEnc || 'hex');
          this._update(add);
        }

        var temp = [];
        while (temp.length < len) {
          this.V = this._hmac().update(this.V).digest();
          temp = temp.concat(this.V);
        }

        var res = temp.slice(0, len);
        this._update(add);
        this._reseed++;
        return utils.encode(res, enc);
      };

    }, { "hash.js": 96, "minimalistic-assert": 112, "minimalistic-crypto-utils": 113 }], 109: [function (require, module, exports) {
      if (typeof Object.create === 'function') {
        // implementation from standard node.js 'util' module
        module.exports = function inherits(ctor, superCtor) {
          if (superCtor) {
            ctor.super_ = superCtor
            ctor.prototype = Object.create(superCtor.prototype, {
              constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
              }
            })
          }
        };
      } else {
        // old school shim for old browsers
        module.exports = function inherits(ctor, superCtor) {
          if (superCtor) {
            ctor.super_ = superCtor
            var TempCtor = function () { }
            TempCtor.prototype = superCtor.prototype
            ctor.prototype = new TempCtor()
            ctor.prototype.constructor = ctor
          }
        }
      }

    }, {}], 110: [function (require, module, exports) {
      'use strict'
      var inherits = require('inherits')
      var HashBase = require('hash-base')
      var Buffer = require('safe-buffer').Buffer

      var ARRAY16 = new Array(16)

      function MD5() {
        HashBase.call(this, 64)

        // state
        this._a = 0x67452301
        this._b = 0xefcdab89
        this._c = 0x98badcfe
        this._d = 0x10325476
      }

      inherits(MD5, HashBase)

      MD5.prototype._update = function () {
        var M = ARRAY16
        for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4)

        var a = this._a
        var b = this._b
        var c = this._c
        var d = this._d

        a = fnF(a, b, c, d, M[0], 0xd76aa478, 7)
        d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12)
        c = fnF(c, d, a, b, M[2], 0x242070db, 17)
        b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22)
        a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7)
        d = fnF(d, a, b, c, M[5], 0x4787c62a, 12)
        c = fnF(c, d, a, b, M[6], 0xa8304613, 17)
        b = fnF(b, c, d, a, M[7], 0xfd469501, 22)
        a = fnF(a, b, c, d, M[8], 0x698098d8, 7)
        d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12)
        c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17)
        b = fnF(b, c, d, a, M[11], 0x895cd7be, 22)
        a = fnF(a, b, c, d, M[12], 0x6b901122, 7)
        d = fnF(d, a, b, c, M[13], 0xfd987193, 12)
        c = fnF(c, d, a, b, M[14], 0xa679438e, 17)
        b = fnF(b, c, d, a, M[15], 0x49b40821, 22)

        a = fnG(a, b, c, d, M[1], 0xf61e2562, 5)
        d = fnG(d, a, b, c, M[6], 0xc040b340, 9)
        c = fnG(c, d, a, b, M[11], 0x265e5a51, 14)
        b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20)
        a = fnG(a, b, c, d, M[5], 0xd62f105d, 5)
        d = fnG(d, a, b, c, M[10], 0x02441453, 9)
        c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14)
        b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20)
        a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5)
        d = fnG(d, a, b, c, M[14], 0xc33707d6, 9)
        c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14)
        b = fnG(b, c, d, a, M[8], 0x455a14ed, 20)
        a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5)
        d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9)
        c = fnG(c, d, a, b, M[7], 0x676f02d9, 14)
        b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20)

        a = fnH(a, b, c, d, M[5], 0xfffa3942, 4)
        d = fnH(d, a, b, c, M[8], 0x8771f681, 11)
        c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16)
        b = fnH(b, c, d, a, M[14], 0xfde5380c, 23)
        a = fnH(a, b, c, d, M[1], 0xa4beea44, 4)
        d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11)
        c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16)
        b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23)
        a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4)
        d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11)
        c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16)
        b = fnH(b, c, d, a, M[6], 0x04881d05, 23)
        a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4)
        d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11)
        c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16)
        b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23)

        a = fnI(a, b, c, d, M[0], 0xf4292244, 6)
        d = fnI(d, a, b, c, M[7], 0x432aff97, 10)
        c = fnI(c, d, a, b, M[14], 0xab9423a7, 15)
        b = fnI(b, c, d, a, M[5], 0xfc93a039, 21)
        a = fnI(a, b, c, d, M[12], 0x655b59c3, 6)
        d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10)
        c = fnI(c, d, a, b, M[10], 0xffeff47d, 15)
        b = fnI(b, c, d, a, M[1], 0x85845dd1, 21)
        a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6)
        d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10)
        c = fnI(c, d, a, b, M[6], 0xa3014314, 15)
        b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21)
        a = fnI(a, b, c, d, M[4], 0xf7537e82, 6)
        d = fnI(d, a, b, c, M[11], 0xbd3af235, 10)
        c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15)
        b = fnI(b, c, d, a, M[9], 0xeb86d391, 21)

        this._a = (this._a + a) | 0
        this._b = (this._b + b) | 0
        this._c = (this._c + c) | 0
        this._d = (this._d + d) | 0
      }

      MD5.prototype._digest = function () {
        // create padding and handle blocks
        this._block[this._blockOffset++] = 0x80
        if (this._blockOffset > 56) {
          this._block.fill(0, this._blockOffset, 64)
          this._update()
          this._blockOffset = 0
        }

        this._block.fill(0, this._blockOffset, 56)
        this._block.writeUInt32LE(this._length[0], 56)
        this._block.writeUInt32LE(this._length[1], 60)
        this._update()

        // produce result
        var buffer = Buffer.allocUnsafe(16)
        buffer.writeInt32LE(this._a, 0)
        buffer.writeInt32LE(this._b, 4)
        buffer.writeInt32LE(this._c, 8)
        buffer.writeInt32LE(this._d, 12)
        return buffer
      }

      function rotl(x, n) {
        return (x << n) | (x >>> (32 - n))
      }

      function fnF(a, b, c, d, m, k, s) {
        return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
      }

      function fnG(a, b, c, d, m, k, s) {
        return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
      }

      function fnH(a, b, c, d, m, k, s) {
        return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
      }

      function fnI(a, b, c, d, m, k, s) {
        return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
      }

      module.exports = MD5

    }, { "hash-base": 95, "inherits": 109, "safe-buffer": 133 }], 111: [function (require, module, exports) {
      (function (Buffer) {
        (function () {
          // constant-space merkle root calculation algorithm
          module.exports = function fastRoot(values, digestFn) {
            if (!Array.isArray(values)) throw TypeError('Expected values Array')
            if (typeof digestFn !== 'function') throw TypeError('Expected digest Function')

            var length = values.length
            var results = values.concat()

            while (length > 1) {
              var j = 0

              for (var i = 0; i < length; i += 2, ++j) {
                var left = results[i]
                var right = i + 1 === length ? left : results[i + 1]
                var data = Buffer.concat([left, right])

                results[j] = digestFn(data)
              }

              length = j
            }

            return results[0]
          }

        }).call(this)
      }).call(this, require("buffer").Buffer)
    }, { "buffer": 216 }], 112: [function (require, module, exports) {
      module.exports = assert;

      function assert(val, msg) {
        if (!val)
          throw new Error(msg || 'Assertion failed');
      }

      assert.equal = function assertEqual(l, r, msg) {
        if (l != r)
          throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
      };

    }, {}], 113: [function (require, module, exports) {
      'use strict';

      var utils = exports;

      function toArray(msg, enc) {
        if (Array.isArray(msg))
          return msg.slice();
        if (!msg)
          return [];
        var res = [];
        if (typeof msg !== 'string') {
          for (var i = 0; i < msg.length; i++)
            res[i] = msg[i] | 0;
          return res;
        }
        if (enc === 'hex') {
          msg = msg.replace(/[^a-z0-9]+/ig, '');
          if (msg.length % 2 !== 0)
            msg = '0' + msg;
          for (var i = 0; i < msg.length; i += 2)
            res.push(parseInt(msg[i] + msg[i + 1], 16));
        } else {
          for (var i = 0; i < msg.length; i++) {
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi)
              res.push(hi, lo);
            else
              res.push(lo);
          }
        }
        return res;
      }
      utils.toArray = toArray;

      function zero2(word) {
        if (word.length === 1)
          return '0' + word;
        else
          return word;
      }
      utils.zero2 = zero2;

      function toHex(msg) {
        var res = '';
        for (var i = 0; i < msg.length; i++)
          res += zero2(msg[i].toString(16));
        return res;
      }
      utils.toHex = toHex;

      utils.encode = function encode(arr, enc) {
        if (enc === 'hex')
          return toHex(arr);
        else
          return arr;
      };

    }, {}], 114: [function (require, module, exports) {
      assert.notEqual = notEqual
      assert.notOk = notOk
      assert.equal = equal
      assert.ok = assert

      module.exports = assert

      function equal(a, b, m) {
        assert(a == b, m) // eslint-disable-line eqeqeq
      }

      function notEqual(a, b, m) {
        assert(a != b, m) // eslint-disable-line eqeqeq
      }

      function notOk(t, m) {
        assert(!t, m)
      }

      function assert(t, m) {
        if (!t) throw new Error(m || 'AssertionError')
      }

    }, {}], 115: [function (require, module, exports) {
      var OPS = require('bitcoin-ops')

      function encodingLength(i) {
        return i < OPS.OP_PUSHDATA1 ? 1
          : i <= 0xff ? 2
            : i <= 0xffff ? 3
              : 5
      }

      function encode(buffer, number, offset) {
        var size = encodingLength(number)

        // ~6 bit
        if (size === 1) {
          buffer.writeUInt8(number, offset)

          // 8 bit
        } else if (size === 2) {
          buffer.writeUInt8(OPS.OP_PUSHDATA1, offset)
          buffer.writeUInt8(number, offset + 1)

          // 16 bit
        } else if (size === 3) {
          buffer.writeUInt8(OPS.OP_PUSHDATA2, offset)
          buffer.writeUInt16LE(number, offset + 1)

          // 32 bit
        } else {
          buffer.writeUInt8(OPS.OP_PUSHDATA4, offset)
          buffer.writeUInt32LE(number, offset + 1)
        }

        return size
      }

      function decode(buffer, offset) {
        var opcode = buffer.readUInt8(offset)
        var number, size

        // ~6 bit
        if (opcode < OPS.OP_PUSHDATA1) {
          number = opcode
          size = 1

          // 8 bit
        } else if (opcode === OPS.OP_PUSHDATA1) {
          if (offset + 2 > buffer.length) return null
          number = buffer.readUInt8(offset + 1)
          size = 2

          // 16 bit
        } else if (opcode === OPS.OP_PUSHDATA2) {
          if (offset + 3 > buffer.length) return null
          number = buffer.readUInt16LE(offset + 1)
          size = 3

          // 32 bit
        } else {
          if (offset + 5 > buffer.length) return null
          if (opcode !== OPS.OP_PUSHDATA4) throw new Error('Unexpected opcode')

          number = buffer.readUInt32LE(offset + 1)
          size = 5
        }

        return {
          opcode: opcode,
          number: number,
          size: size
        }
      }

      module.exports = {
        encodingLength: encodingLength,
        encode: encode,
        decode: decode
      }

    }, { "bitcoin-ops": 8 }], 116: [function (require, module, exports) {
      (function (process, global) {
        (function () {
          'use strict'

          // limit of Crypto.getRandomValues()
          // https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
          var MAX_BYTES = 65536

          // Node supports requesting up to this number of bytes
          // https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
          var MAX_UINT32 = 4294967295

          function oldBrowser() {
            throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
          }

          var Buffer = require('safe-buffer').Buffer
          var crypto = global.crypto || global.msCrypto

          if (crypto && crypto.getRandomValues) {
            module.exports = randomBytes
          } else {
            module.exports = oldBrowser
          }

          function randomBytes(size, cb) {
            // phantomjs needs to throw
            if (size > MAX_UINT32) throw new RangeError('requested too many random bytes')

            var bytes = Buffer.allocUnsafe(size)

            if (size > 0) {  // getRandomValues fails on IE if size == 0
              if (size > MAX_BYTES) { // this is the max bytes crypto.getRandomValues
                // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
                for (var generated = 0; generated < size; generated += MAX_BYTES) {
                  // buffer.slice automatically checks if the end is past the end of
                  // the buffer so we don't have to here
                  crypto.getRandomValues(bytes.slice(generated, generated + MAX_BYTES))
                }
              } else {
                crypto.getRandomValues(bytes)
              }
            }

            if (typeof cb === 'function') {
              return process.nextTick(function () {
                cb(null, bytes)
              })
            }

            return bytes
          }

        }).call(this)
      }).call(this, require('_process'), typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
    }, { "_process": 304, "safe-buffer": 133 }], 117: [function (require, module, exports) {
      'use strict';

      function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

      var codes = {};

      function createErrorType(code, message, Base) {
        if (!Base) {
          Base = Error;
        }

        function getMessage(arg1, arg2, arg3) {
          if (typeof message === 'string') {
            return message;
          } else {
            return message(arg1, arg2, arg3);
          }
        }

        var NodeError =
          /*#__PURE__*/
          function (_Base) {
            _inheritsLoose(NodeError, _Base);

            function NodeError(arg1, arg2, arg3) {
              return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
            }

            return NodeError;
          }(Base);

        NodeError.prototype.name = Base.name;
        NodeError.prototype.code = code;
        codes[code] = NodeError;
      } // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


      function oneOf(expected, thing) {
        if (Array.isArray(expected)) {
          var len = expected.length;
          expected = expected.map(function (i) {
            return String(i);
          });

          if (len > 2) {
            return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
          } else if (len === 2) {
            return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
          } else {
            return "of ".concat(thing, " ").concat(expected[0]);
          }
        } else {
          return "of ".concat(thing, " ").concat(String(expected));
        }
      } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


      function startsWith(str, search, pos) {
        return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
      } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


      function endsWith(str, search, this_len) {
        if (this_len === undefined || this_len > str.length) {
          this_len = str.length;
        }

        return str.substring(this_len - search.length, this_len) === search;
      } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


      function includes(str, search, start) {
        if (typeof start !== 'number') {
          start = 0;
        }

        if (start + search.length > str.length) {
          return false;
        } else {
          return str.indexOf(search, start) !== -1;
        }
      }

      createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
        return 'The value "' + value + '" is invalid for option "' + name + '"';
      }, TypeError);
      createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
        // determiner: 'must be' or 'must not be'
        var determiner;

        if (typeof expected === 'string' && startsWith(expected, 'not ')) {
          determiner = 'must not be';
          expected = expected.replace(/^not /, '');
        } else {
          determiner = 'must be';
        }

        var msg;

        if (endsWith(name, ' argument')) {
          // For cases like 'first argument'
          msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
        } else {
          var type = includes(name, '.') ? 'property' : 'argument';
          msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
        }

        msg += ". Received type ".concat(typeof actual);
        return msg;
      }, TypeError);
      createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
      createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
        return 'The ' + name + ' method is not implemented';
      });
      createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
      createErrorType('ERR_STREAM_DESTROYED', function (name) {
        return 'Cannot call ' + name + ' after a stream was destroyed';
      });
      createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
      createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
      createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
      createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
      createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
        return 'Unknown encoding: ' + arg;
      }, TypeError);
      createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
      module.exports.codes = codes;

    }, {}], 118: [function (require, module, exports) {
      (function (process) {
        (function () {
          // Copyright Joyent, Inc. and other Node contributors.
          //
          // Permission is hereby granted, free of charge, to any person obtaining a
          // copy of this software and associated documentation files (the
          // "Software"), to deal in the Software without restriction, including
          // without limitation the rights to use, copy, modify, merge, publish,
          // distribute, sublicense, and/or sell copies of the Software, and to permit
          // persons to whom the Software is furnished to do so, subject to the
          // following conditions:
          //
          // The above copyright notice and this permission notice shall be included
          // in all copies or substantial portions of the Software.
          //
          // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
          // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
          // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
          // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
          // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
          // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
          // USE OR OTHER DEALINGS IN THE SOFTWARE.
          // a duplex stream is just a stream that is both readable and writable.
          // Since JS doesn't have multiple prototypal inheritance, this class
          // prototypally inherits from Readable, and then parasitically from
          // Writable.
          'use strict';
          /*<replacement>*/

          var objectKeys = Object.keys || function (obj) {
            var keys = [];

            for (var key in obj) {
              keys.push(key);
            }

            return keys;
          };
          /*</replacement>*/


          module.exports = Duplex;

          var Readable = require('./_stream_readable');

          var Writable = require('./_stream_writable');

          require('inherits')(Duplex, Readable);

          {
            // Allow the keys array to be GC'ed.
            var keys = objectKeys(Writable.prototype);

            for (var v = 0; v < keys.length; v++) {
              var method = keys[v];
              if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
            }
          }

          function Duplex(options) {
            if (!(this instanceof Duplex)) return new Duplex(options);
            Readable.call(this, options);
            Writable.call(this, options);
            this.allowHalfOpen = true;

            if (options) {
              if (options.readable === false) this.readable = false;
              if (options.writable === false) this.writable = false;

              if (options.allowHalfOpen === false) {
                this.allowHalfOpen = false;
                this.once('end', onend);
              }
            }
          }

          Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._writableState.highWaterMark;
            }
          });
          Object.defineProperty(Duplex.prototype, 'writableBuffer', {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._writableState && this._writableState.getBuffer();
            }
          });
          Object.defineProperty(Duplex.prototype, 'writableLength', {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._writableState.length;
            }
          }); // the no-half-open enforcer

          function onend() {
            // If the writable side ended, then we're ok.
            if (this._writableState.ended) return; // no more data can be written.
            // But allow more writes to happen in this tick.

            process.nextTick(onEndNT, this);
          }

          function onEndNT(self) {
            self.end();
          }

          Object.defineProperty(Duplex.prototype, 'destroyed', {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              if (this._readableState === undefined || this._writableState === undefined) {
                return false;
              }

              return this._readableState.destroyed && this._writableState.destroyed;
            },
            set: function set(value) {
              // we ignore the value if the stream
              // has not been initialized yet
              if (this._readableState === undefined || this._writableState === undefined) {
                return;
              } // backward compatibility, the user is explicitly
              // managing destroyed


              this._readableState.destroyed = value;
              this._writableState.destroyed = value;
            }
          });
        }).call(this)
      }).call(this, require('_process'))
    }, { "./_stream_readable": 120, "./_stream_writable": 122, "_process": 304, "inherits": 109 }], 119: [function (require, module, exports) {
      // Copyright Joyent, Inc. and other Node contributors.
      //
      // Permission is hereby granted, free of charge, to any person obtaining a
      // copy of this software and associated documentation files (the
      // "Software"), to deal in the Software without restriction, including
      // without limitation the rights to use, copy, modify, merge, publish,
      // distribute, sublicense, and/or sell copies of the Software, and to permit
      // persons to whom the Software is furnished to do so, subject to the
      // following conditions:
      //
      // The above copyright notice and this permission notice shall be included
      // in all copies or substantial portions of the Software.
      //
      // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
      // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
      // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
      // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
      // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
      // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
      // USE OR OTHER DEALINGS IN THE SOFTWARE.
      // a passthrough stream.
      // basically just the most minimal sort of Transform stream.
      // Every written chunk gets output as-is.
      'use strict';

      module.exports = PassThrough;

      var Transform = require('./_stream_transform');

      require('inherits')(PassThrough, Transform);

      function PassThrough(options) {
        if (!(this instanceof PassThrough)) return new PassThrough(options);
        Transform.call(this, options);
      }

      PassThrough.prototype._transform = function (chunk, encoding, cb) {
        cb(null, chunk);
      };
    }, { "./_stream_transform": 121, "inherits": 109 }], 120: [function (require, module, exports) {
      (function (process, global) {
        (function () {
          // Copyright Joyent, Inc. and other Node contributors.
          //
          // Permission is hereby granted, free of charge, to any person obtaining a
          // copy of this software and associated documentation files (the
          // "Software"), to deal in the Software without restriction, including
          // without limitation the rights to use, copy, modify, merge, publish,
          // distribute, sublicense, and/or sell copies of the Software, and to permit
          // persons to whom the Software is furnished to do so, subject to the
          // following conditions:
          //
          // The above copyright notice and this permission notice shall be included
          // in all copies or substantial portions of the Software.
          //
          // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
          // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
          // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
          // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
          // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
          // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
          // USE OR OTHER DEALINGS IN THE SOFTWARE.
          'use strict';

          module.exports = Readable;
          /*<replacement>*/

          var Duplex;
          /*</replacement>*/

          Readable.ReadableState = ReadableState;
          /*<replacement>*/

          var EE = require('events').EventEmitter;

          var EElistenerCount = function EElistenerCount(emitter, type) {
            return emitter.listeners(type).length;
          };
          /*</replacement>*/

          /*<replacement>*/


          var Stream = require('./internal/streams/stream');
          /*</replacement>*/


          var Buffer = require('buffer').Buffer;

          var OurUint8Array = global.Uint8Array || function () { };

          function _uint8ArrayToBuffer(chunk) {
            return Buffer.from(chunk);
          }

          function _isUint8Array(obj) {
            return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
          }
          /*<replacement>*/


          var debugUtil = require('util');

          var debug;

          if (debugUtil && debugUtil.debuglog) {
            debug = debugUtil.debuglog('stream');
          } else {
            debug = function debug() { };
          }
          /*</replacement>*/


          var BufferList = require('./internal/streams/buffer_list');

          var destroyImpl = require('./internal/streams/destroy');

          var _require = require('./internal/streams/state'),
            getHighWaterMark = _require.getHighWaterMark;

          var _require$codes = require('../errors').codes,
            ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
            ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
            ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
            ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT; // Lazy loaded to improve the startup performance.


          var StringDecoder;
          var createReadableStreamAsyncIterator;
          var from;

          require('inherits')(Readable, Stream);

          var errorOrDestroy = destroyImpl.errorOrDestroy;
          var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

          function prependListener(emitter, event, fn) {
            // Sadly this is not cacheable as some libraries bundle their own
            // event emitter implementation with them.
            if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn); // This is a hack to make sure that our error handler is attached before any
            // userland ones.  NEVER DO THIS. This is here only because this code needs
            // to continue to work with older versions of Node.js that do not include
            // the prependListener() method. The goal is to eventually remove this hack.

            if (!emitter._events || !emitter._events[event]) emitter.on(event, fn); else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn); else emitter._events[event] = [fn, emitter._events[event]];
          }

          function ReadableState(options, stream, isDuplex) {
            Duplex = Duplex || require('./_stream_duplex');
            options = options || {}; // Duplex streams are both readable and writable, but share
            // the same options object.
            // However, some cases require setting options to different
            // values for the readable and the writable sides of the duplex stream.
            // These options can be provided separately as readableXXX and writableXXX.

            if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex; // object stream flag. Used to make read(n) ignore n and to
            // make all the buffer merging and length checks go away

            this.objectMode = !!options.objectMode;
            if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
            // Note: 0 is a valid value, means "don't call _read preemptively ever"

            this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex); // A linked list is used to store data chunks instead of an array because the
            // linked list can remove elements from the beginning faster than
            // array.shift()

            this.buffer = new BufferList();
            this.length = 0;
            this.pipes = null;
            this.pipesCount = 0;
            this.flowing = null;
            this.ended = false;
            this.endEmitted = false;
            this.reading = false; // a flag to be able to tell if the event 'readable'/'data' is emitted
            // immediately, or on a later tick.  We set this to true at first, because
            // any actions that shouldn't happen until "later" should generally also
            // not happen before the first read call.

            this.sync = true; // whenever we return null, then we set a flag to say
            // that we're awaiting a 'readable' event emission.

            this.needReadable = false;
            this.emittedReadable = false;
            this.readableListening = false;
            this.resumeScheduled = false;
            this.paused = true; // Should close be emitted on destroy. Defaults to true.

            this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'end' (and potentially 'finish')

            this.autoDestroy = !!options.autoDestroy; // has it been destroyed

            this.destroyed = false; // Crypto is kind of old and crusty.  Historically, its default string
            // encoding is 'binary' so we have to make this configurable.
            // Everything else in the universe uses 'utf8', though.

            this.defaultEncoding = options.defaultEncoding || 'utf8'; // the number of writers that are awaiting a drain event in .pipe()s

            this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled

            this.readingMore = false;
            this.decoder = null;
            this.encoding = null;

            if (options.encoding) {
              if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
              this.decoder = new StringDecoder(options.encoding);
              this.encoding = options.encoding;
            }
          }

          function Readable(options) {
            Duplex = Duplex || require('./_stream_duplex');
            if (!(this instanceof Readable)) return new Readable(options); // Checking for a Stream.Duplex instance is faster here instead of inside
            // the ReadableState constructor, at least with V8 6.5

            var isDuplex = this instanceof Duplex;
            this._readableState = new ReadableState(options, this, isDuplex); // legacy

            this.readable = true;

            if (options) {
              if (typeof options.read === 'function') this._read = options.read;
              if (typeof options.destroy === 'function') this._destroy = options.destroy;
            }

            Stream.call(this);
          }

          Object.defineProperty(Readable.prototype, 'destroyed', {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              if (this._readableState === undefined) {
                return false;
              }

              return this._readableState.destroyed;
            },
            set: function set(value) {
              // we ignore the value if the stream
              // has not been initialized yet
              if (!this._readableState) {
                return;
              } // backward compatibility, the user is explicitly
              // managing destroyed


              this._readableState.destroyed = value;
            }
          });
          Readable.prototype.destroy = destroyImpl.destroy;
          Readable.prototype._undestroy = destroyImpl.undestroy;

          Readable.prototype._destroy = function (err, cb) {
            cb(err);
          }; // Manually shove something into the read() buffer.
          // This returns true if the highWaterMark has not been hit yet,
          // similar to how Writable.write() returns true if you should
          // write() some more.


          Readable.prototype.push = function (chunk, encoding) {
            var state = this._readableState;
            var skipChunkCheck;

            if (!state.objectMode) {
              if (typeof chunk === 'string') {
                encoding = encoding || state.defaultEncoding;

                if (encoding !== state.encoding) {
                  chunk = Buffer.from(chunk, encoding);
                  encoding = '';
                }

                skipChunkCheck = true;
              }
            } else {
              skipChunkCheck = true;
            }

            return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
          }; // Unshift should *always* be something directly out of read()


          Readable.prototype.unshift = function (chunk) {
            return readableAddChunk(this, chunk, null, true, false);
          };

          function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
            debug('readableAddChunk', chunk);
            var state = stream._readableState;

            if (chunk === null) {
              state.reading = false;
              onEofChunk(stream, state);
            } else {
              var er;
              if (!skipChunkCheck) er = chunkInvalid(state, chunk);

              if (er) {
                errorOrDestroy(stream, er);
              } else if (state.objectMode || chunk && chunk.length > 0) {
                if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
                  chunk = _uint8ArrayToBuffer(chunk);
                }

                if (addToFront) {
                  if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT()); else addChunk(stream, state, chunk, true);
                } else if (state.ended) {
                  errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
                } else if (state.destroyed) {
                  return false;
                } else {
                  state.reading = false;

                  if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false); else maybeReadMore(stream, state);
                  } else {
                    addChunk(stream, state, chunk, false);
                  }
                }
              } else if (!addToFront) {
                state.reading = false;
                maybeReadMore(stream, state);
              }
            } // We can push more data if we are below the highWaterMark.
            // Also, if we have no data yet, we can stand some more bytes.
            // This is to work around cases where hwm=0, such as the repl.


            return !state.ended && (state.length < state.highWaterMark || state.length === 0);
          }

          function addChunk(stream, state, chunk, addToFront) {
            if (state.flowing && state.length === 0 && !state.sync) {
              state.awaitDrain = 0;
              stream.emit('data', chunk);
            } else {
              // update the buffer info.
              state.length += state.objectMode ? 1 : chunk.length;
              if (addToFront) state.buffer.unshift(chunk); else state.buffer.push(chunk);
              if (state.needReadable) emitReadable(stream);
            }

            maybeReadMore(stream, state);
          }

          function chunkInvalid(state, chunk) {
            var er;

            if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
              er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
            }

            return er;
          }

          Readable.prototype.isPaused = function () {
            return this._readableState.flowing === false;
          }; // backwards compatibility.


          Readable.prototype.setEncoding = function (enc) {
            if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
            var decoder = new StringDecoder(enc);
            this._readableState.decoder = decoder; // If setEncoding(null), decoder.encoding equals utf8

            this._readableState.encoding = this._readableState.decoder.encoding; // Iterate over current buffer to convert already stored Buffers:

            var p = this._readableState.buffer.head;
            var content = '';

            while (p !== null) {
              content += decoder.write(p.data);
              p = p.next;
            }

            this._readableState.buffer.clear();

            if (content !== '') this._readableState.buffer.push(content);
            this._readableState.length = content.length;
            return this;
          }; // Don't raise the hwm > 1GB


          var MAX_HWM = 0x40000000;

          function computeNewHighWaterMark(n) {
            if (n >= MAX_HWM) {
              // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
              n = MAX_HWM;
            } else {
              // Get the next highest power of 2 to prevent increasing hwm excessively in
              // tiny amounts
              n--;
              n |= n >>> 1;
              n |= n >>> 2;
              n |= n >>> 4;
              n |= n >>> 8;
              n |= n >>> 16;
              n++;
            }

            return n;
          } // This function is designed to be inlinable, so please take care when making
          // changes to the function body.


          function howMuchToRead(n, state) {
            if (n <= 0 || state.length === 0 && state.ended) return 0;
            if (state.objectMode) return 1;

            if (n !== n) {
              // Only flow one buffer at a time
              if (state.flowing && state.length) return state.buffer.head.data.length; else return state.length;
            } // If we're asking for more than the current hwm, then raise the hwm.


            if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
            if (n <= state.length) return n; // Don't have enough

            if (!state.ended) {
              state.needReadable = true;
              return 0;
            }

            return state.length;
          } // you can override either this method, or the async _read(n) below.


          Readable.prototype.read = function (n) {
            debug('read', n);
            n = parseInt(n, 10);
            var state = this._readableState;
            var nOrig = n;
            if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
            // already have a bunch of data in the buffer, then just trigger
            // the 'readable' event and move on.

            if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
              debug('read: emitReadable', state.length, state.ended);
              if (state.length === 0 && state.ended) endReadable(this); else emitReadable(this);
              return null;
            }

            n = howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.

            if (n === 0 && state.ended) {
              if (state.length === 0) endReadable(this);
              return null;
            } // All the actual chunk generation logic needs to be
            // *below* the call to _read.  The reason is that in certain
            // synthetic stream cases, such as passthrough streams, _read
            // may be a completely synchronous operation which may change
            // the state of the read buffer, providing enough data when
            // before there was *not* enough.
            //
            // So, the steps are:
            // 1. Figure out what the state of things will be after we do
            // a read from the buffer.
            //
            // 2. If that resulting state will trigger a _read, then call _read.
            // Note that this may be asynchronous, or synchronous.  Yes, it is
            // deeply ugly to write APIs this way, but that still doesn't mean
            // that the Readable class should behave improperly, as streams are
            // designed to be sync/async agnostic.
            // Take note if the _read call is sync or async (ie, if the read call
            // has returned yet), so that we know whether or not it's safe to emit
            // 'readable' etc.
            //
            // 3. Actually pull the requested chunks out of the buffer and return.
            // if we need a readable event, then we need to do some reading.


            var doRead = state.needReadable;
            debug('need readable', doRead); // if we currently have less than the highWaterMark, then also read some

            if (state.length === 0 || state.length - n < state.highWaterMark) {
              doRead = true;
              debug('length less than watermark', doRead);
            } // however, if we've ended, then there's no point, and if we're already
            // reading, then it's unnecessary.


            if (state.ended || state.reading) {
              doRead = false;
              debug('reading or ended', doRead);
            } else if (doRead) {
              debug('do read');
              state.reading = true;
              state.sync = true; // if the length is currently zero, then we *need* a readable event.

              if (state.length === 0) state.needReadable = true; // call internal read method

              this._read(state.highWaterMark);

              state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
              // and we need to re-evaluate how much data we can return to the user.

              if (!state.reading) n = howMuchToRead(nOrig, state);
            }

            var ret;
            if (n > 0) ret = fromList(n, state); else ret = null;

            if (ret === null) {
              state.needReadable = state.length <= state.highWaterMark;
              n = 0;
            } else {
              state.length -= n;
              state.awaitDrain = 0;
            }

            if (state.length === 0) {
              // If we have nothing in the buffer, then we want to know
              // as soon as we *do* get something into the buffer.
              if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.

              if (nOrig !== n && state.ended) endReadable(this);
            }

            if (ret !== null) this.emit('data', ret);
            return ret;
          };

          function onEofChunk(stream, state) {
            debug('onEofChunk');
            if (state.ended) return;

            if (state.decoder) {
              var chunk = state.decoder.end();

              if (chunk && chunk.length) {
                state.buffer.push(chunk);
                state.length += state.objectMode ? 1 : chunk.length;
              }
            }

            state.ended = true;

            if (state.sync) {
              // if we are sync, wait until next tick to emit the data.
              // Otherwise we risk emitting data in the flow()
              // the readable code triggers during a read() call
              emitReadable(stream);
            } else {
              // emit 'readable' now to make sure it gets picked up.
              state.needReadable = false;

              if (!state.emittedReadable) {
                state.emittedReadable = true;
                emitReadable_(stream);
              }
            }
          } // Don't emit readable right away in sync mode, because this can trigger
          // another read() call => stack overflow.  This way, it might trigger
          // a nextTick recursion warning, but that's not so bad.


          function emitReadable(stream) {
            var state = stream._readableState;
            debug('emitReadable', state.needReadable, state.emittedReadable);
            state.needReadable = false;

            if (!state.emittedReadable) {
              debug('emitReadable', state.flowing);
              state.emittedReadable = true;
              process.nextTick(emitReadable_, stream);
            }
          }

          function emitReadable_(stream) {
            var state = stream._readableState;
            debug('emitReadable_', state.destroyed, state.length, state.ended);

            if (!state.destroyed && (state.length || state.ended)) {
              stream.emit('readable');
              state.emittedReadable = false;
            } // The stream needs another readable event if
            // 1. It is not flowing, as the flow mechanism will take
            //    care of it.
            // 2. It is not ended.
            // 3. It is below the highWaterMark, so we can schedule
            //    another readable later.


            state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
            flow(stream);
          } // at this point, the user has presumably seen the 'readable' event,
          // and called read() to consume some data.  that may have triggered
          // in turn another _read(n) call, in which case reading = true if
          // it's in progress.
          // However, if we're not ended, or reading, and the length < hwm,
          // then go ahead and try to read some more preemptively.


          function maybeReadMore(stream, state) {
            if (!state.readingMore) {
              state.readingMore = true;
              process.nextTick(maybeReadMore_, stream, state);
            }
          }

          function maybeReadMore_(stream, state) {
            // Attempt to read more data if we should.
            //
            // The conditions for reading more data are (one of):
            // - Not enough data buffered (state.length < state.highWaterMark). The loop
            //   is responsible for filling the buffer with enough data if such data
            //   is available. If highWaterMark is 0 and we are not in the flowing mode
            //   we should _not_ attempt to buffer any extra data. We'll get more data
            //   when the stream consumer calls read() instead.
            // - No data in the buffer, and the stream is in flowing mode. In this mode
            //   the loop below is responsible for ensuring read() is called. Failing to
            //   call read here would abort the flow and there's no other mechanism for
            //   continuing the flow if the stream consumer has just subscribed to the
            //   'data' event.
            //
            // In addition to the above conditions to keep reading data, the following
            // conditions prevent the data from being read:
            // - The stream has ended (state.ended).
            // - There is already a pending 'read' operation (state.reading). This is a
            //   case where the the stream has called the implementation defined _read()
            //   method, but they are processing the call asynchronously and have _not_
            //   called push() with new data. In this case we skip performing more
            //   read()s. The execution ends in this method again after the _read() ends
            //   up calling push() with more data.
            while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
              var len = state.length;
              debug('maybeReadMore read 0');
              stream.read(0);
              if (len === state.length) // didn't get any data, stop spinning.
                break;
            }

            state.readingMore = false;
          } // abstract method.  to be overridden in specific implementation classes.
          // call cb(er, data) where data is <= n in length.
          // for virtual (non-string, non-buffer) streams, "length" is somewhat
          // arbitrary, and perhaps not very meaningful.


          Readable.prototype._read = function (n) {
            errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
          };

          Readable.prototype.pipe = function (dest, pipeOpts) {
            var src = this;
            var state = this._readableState;

            switch (state.pipesCount) {
              case 0:
                state.pipes = dest;
                break;

              case 1:
                state.pipes = [state.pipes, dest];
                break;

              default:
                state.pipes.push(dest);
                break;
            }

            state.pipesCount += 1;
            debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
            var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
            var endFn = doEnd ? onend : unpipe;
            if (state.endEmitted) process.nextTick(endFn); else src.once('end', endFn);
            dest.on('unpipe', onunpipe);

            function onunpipe(readable, unpipeInfo) {
              debug('onunpipe');

              if (readable === src) {
                if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                  unpipeInfo.hasUnpiped = true;
                  cleanup();
                }
              }
            }

            function onend() {
              debug('onend');
              dest.end();
            } // when the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.


            var ondrain = pipeOnDrain(src);
            dest.on('drain', ondrain);
            var cleanedUp = false;

            function cleanup() {
              debug('cleanup'); // cleanup event handlers once the pipe is broken

              dest.removeListener('close', onclose);
              dest.removeListener('finish', onfinish);
              dest.removeListener('drain', ondrain);
              dest.removeListener('error', onerror);
              dest.removeListener('unpipe', onunpipe);
              src.removeListener('end', onend);
              src.removeListener('end', unpipe);
              src.removeListener('data', ondata);
              cleanedUp = true; // if the reader is waiting for a drain event from this
              // specific writer, then it would cause it to never start
              // flowing again.
              // So, if this is awaiting a drain, then we just call it now.
              // If we don't know, then assume that we are waiting for one.

              if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
            }

            src.on('data', ondata);

            function ondata(chunk) {
              debug('ondata');
              var ret = dest.write(chunk);
              debug('dest.write', ret);

              if (ret === false) {
                // If the user unpiped during `dest.write()`, it is possible
                // to get stuck in a permanently paused state if that write
                // also returned false.
                // => Check whether `dest` is still a piping destination.
                if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                  debug('false write response, pause', state.awaitDrain);
                  state.awaitDrain++;
                }

                src.pause();
              }
            } // if the dest has an error, then stop piping into it.
            // however, don't suppress the throwing behavior for this.


            function onerror(er) {
              debug('onerror', er);
              unpipe();
              dest.removeListener('error', onerror);
              if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
            } // Make sure our error handler is attached before userland ones.


            prependListener(dest, 'error', onerror); // Both close and finish should trigger unpipe, but only once.

            function onclose() {
              dest.removeListener('finish', onfinish);
              unpipe();
            }

            dest.once('close', onclose);

            function onfinish() {
              debug('onfinish');
              dest.removeListener('close', onclose);
              unpipe();
            }

            dest.once('finish', onfinish);

            function unpipe() {
              debug('unpipe');
              src.unpipe(dest);
            } // tell the dest that it's being piped to


            dest.emit('pipe', src); // start the flow if it hasn't been started already.

            if (!state.flowing) {
              debug('pipe resume');
              src.resume();
            }

            return dest;
          };

          function pipeOnDrain(src) {
            return function pipeOnDrainFunctionResult() {
              var state = src._readableState;
              debug('pipeOnDrain', state.awaitDrain);
              if (state.awaitDrain) state.awaitDrain--;

              if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
                state.flowing = true;
                flow(src);
              }
            };
          }

          Readable.prototype.unpipe = function (dest) {
            var state = this._readableState;
            var unpipeInfo = {
              hasUnpiped: false
            }; // if we're not piping anywhere, then do nothing.

            if (state.pipesCount === 0) return this; // just one destination.  most common case.

            if (state.pipesCount === 1) {
              // passed in one, but it's not the right one.
              if (dest && dest !== state.pipes) return this;
              if (!dest) dest = state.pipes; // got a match.

              state.pipes = null;
              state.pipesCount = 0;
              state.flowing = false;
              if (dest) dest.emit('unpipe', this, unpipeInfo);
              return this;
            } // slow case. multiple pipe destinations.


            if (!dest) {
              // remove all.
              var dests = state.pipes;
              var len = state.pipesCount;
              state.pipes = null;
              state.pipesCount = 0;
              state.flowing = false;

              for (var i = 0; i < len; i++) {
                dests[i].emit('unpipe', this, {
                  hasUnpiped: false
                });
              }

              return this;
            } // try to find the right one.


            var index = indexOf(state.pipes, dest);
            if (index === -1) return this;
            state.pipes.splice(index, 1);
            state.pipesCount -= 1;
            if (state.pipesCount === 1) state.pipes = state.pipes[0];
            dest.emit('unpipe', this, unpipeInfo);
            return this;
          }; // set up data events if they are asked for
          // Ensure readable listeners eventually get something


          Readable.prototype.on = function (ev, fn) {
            var res = Stream.prototype.on.call(this, ev, fn);
            var state = this._readableState;

            if (ev === 'data') {
              // update readableListening so that resume() may be a no-op
              // a few lines down. This is needed to support once('readable').
              state.readableListening = this.listenerCount('readable') > 0; // Try start flowing on next tick if stream isn't explicitly paused

              if (state.flowing !== false) this.resume();
            } else if (ev === 'readable') {
              if (!state.endEmitted && !state.readableListening) {
                state.readableListening = state.needReadable = true;
                state.flowing = false;
                state.emittedReadable = false;
                debug('on readable', state.length, state.reading);

                if (state.length) {
                  emitReadable(this);
                } else if (!state.reading) {
                  process.nextTick(nReadingNextTick, this);
                }
              }
            }

            return res;
          };

          Readable.prototype.addListener = Readable.prototype.on;

          Readable.prototype.removeListener = function (ev, fn) {
            var res = Stream.prototype.removeListener.call(this, ev, fn);

            if (ev === 'readable') {
              // We need to check if there is someone still listening to
              // readable and reset the state. However this needs to happen
              // after readable has been emitted but before I/O (nextTick) to
              // support once('readable', fn) cycles. This means that calling
              // resume within the same tick will have no
              // effect.
              process.nextTick(updateReadableListening, this);
            }

            return res;
          };

          Readable.prototype.removeAllListeners = function (ev) {
            var res = Stream.prototype.removeAllListeners.apply(this, arguments);

            if (ev === 'readable' || ev === undefined) {
              // We need to check if there is someone still listening to
              // readable and reset the state. However this needs to happen
              // after readable has been emitted but before I/O (nextTick) to
              // support once('readable', fn) cycles. This means that calling
              // resume within the same tick will have no
              // effect.
              process.nextTick(updateReadableListening, this);
            }

            return res;
          };

          function updateReadableListening(self) {
            var state = self._readableState;
            state.readableListening = self.listenerCount('readable') > 0;

            if (state.resumeScheduled && !state.paused) {
              // flowing needs to be set to true now, otherwise
              // the upcoming resume will not flow.
              state.flowing = true; // crude way to check if we should resume
            } else if (self.listenerCount('data') > 0) {
              self.resume();
            }
          }

          function nReadingNextTick(self) {
            debug('readable nexttick read 0');
            self.read(0);
          } // pause() and resume() are remnants of the legacy readable stream API
          // If the user uses them, then switch into old mode.


          Readable.prototype.resume = function () {
            var state = this._readableState;

            if (!state.flowing) {
              debug('resume'); // we flow only if there is no one listening
              // for readable, but we still have to call
              // resume()

              state.flowing = !state.readableListening;
              resume(this, state);
            }

            state.paused = false;
            return this;
          };

          function resume(stream, state) {
            if (!state.resumeScheduled) {
              state.resumeScheduled = true;
              process.nextTick(resume_, stream, state);
            }
          }

          function resume_(stream, state) {
            debug('resume', state.reading);

            if (!state.reading) {
              stream.read(0);
            }

            state.resumeScheduled = false;
            stream.emit('resume');
            flow(stream);
            if (state.flowing && !state.reading) stream.read(0);
          }

          Readable.prototype.pause = function () {
            debug('call pause flowing=%j', this._readableState.flowing);

            if (this._readableState.flowing !== false) {
              debug('pause');
              this._readableState.flowing = false;
              this.emit('pause');
            }

            this._readableState.paused = true;
            return this;
          };

          function flow(stream) {
            var state = stream._readableState;
            debug('flow', state.flowing);

            while (state.flowing && stream.read() !== null) {
              ;
            }
          } // wrap an old-style stream as the async data source.
          // This is *not* part of the readable stream interface.
          // It is an ugly unfortunate mess of history.


          Readable.prototype.wrap = function (stream) {
            var _this = this;

            var state = this._readableState;
            var paused = false;
            stream.on('end', function () {
              debug('wrapped end');

              if (state.decoder && !state.ended) {
                var chunk = state.decoder.end();
                if (chunk && chunk.length) _this.push(chunk);
              }

              _this.push(null);
            });
            stream.on('data', function (chunk) {
              debug('wrapped data');
              if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode

              if (state.objectMode && (chunk === null || chunk === undefined)) return; else if (!state.objectMode && (!chunk || !chunk.length)) return;

              var ret = _this.push(chunk);

              if (!ret) {
                paused = true;
                stream.pause();
              }
            }); // proxy all the other methods.
            // important when wrapping filters and duplexes.

            for (var i in stream) {
              if (this[i] === undefined && typeof stream[i] === 'function') {
                this[i] = function methodWrap(method) {
                  return function methodWrapReturnFunction() {
                    return stream[method].apply(stream, arguments);
                  };
                }(i);
              }
            } // proxy certain important events.


            for (var n = 0; n < kProxyEvents.length; n++) {
              stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
            } // when we try to consume some more bytes, simply unpause the
            // underlying stream.


            this._read = function (n) {
              debug('wrapped _read', n);

              if (paused) {
                paused = false;
                stream.resume();
              }
            };

            return this;
          };

          if (typeof Symbol === 'function') {
            Readable.prototype[Symbol.asyncIterator] = function () {
              if (createReadableStreamAsyncIterator === undefined) {
                createReadableStreamAsyncIterator = require('./internal/streams/async_iterator');
              }

              return createReadableStreamAsyncIterator(this);
            };
          }

          Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._readableState.highWaterMark;
            }
          });
          Object.defineProperty(Readable.prototype, 'readableBuffer', {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._readableState && this._readableState.buffer;
            }
          });
          Object.defineProperty(Readable.prototype, 'readableFlowing', {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._readableState.flowing;
            },
            set: function set(state) {
              if (this._readableState) {
                this._readableState.flowing = state;
              }
            }
          }); // exposed for testing purposes only.

          Readable._fromList = fromList;
          Object.defineProperty(Readable.prototype, 'readableLength', {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._readableState.length;
            }
          }); // Pluck off n bytes from an array of buffers.
          // Length is the combined lengths of all the buffers in the list.
          // This function is designed to be inlinable, so please take care when making
          // changes to the function body.

          function fromList(n, state) {
            // nothing buffered
            if (state.length === 0) return null;
            var ret;
            if (state.objectMode) ret = state.buffer.shift(); else if (!n || n >= state.length) {
              // read it all, truncate the list
              if (state.decoder) ret = state.buffer.join(''); else if (state.buffer.length === 1) ret = state.buffer.first(); else ret = state.buffer.concat(state.length);
              state.buffer.clear();
            } else {
              // read part of list
              ret = state.buffer.consume(n, state.decoder);
            }
            return ret;
          }

          function endReadable(stream) {
            var state = stream._readableState;
            debug('endReadable', state.endEmitted);

            if (!state.endEmitted) {
              state.ended = true;
              process.nextTick(endReadableNT, state, stream);
            }
          }

          function endReadableNT(state, stream) {
            debug('endReadableNT', state.endEmitted, state.length); // Check that we didn't get one last unshift.

            if (!state.endEmitted && state.length === 0) {
              state.endEmitted = true;
              stream.readable = false;
              stream.emit('end');

              if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the writable side is ready for autoDestroy as well
                var wState = stream._writableState;

                if (!wState || wState.autoDestroy && wState.finished) {
                  stream.destroy();
                }
              }
            }
          }

          if (typeof Symbol === 'function') {
            Readable.from = function (iterable, opts) {
              if (from === undefined) {
                from = require('./internal/streams/from');
              }

              return from(Readable, iterable, opts);
            };
          }

          function indexOf(xs, x) {
            for (var i = 0, l = xs.length; i < l; i++) {
              if (xs[i] === x) return i;
            }

            return -1;
          }
        }).call(this)
      }).call(this, require('_process'), typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
    }, { "../errors": 117, "./_stream_duplex": 118, "./internal/streams/async_iterator": 123, "./internal/streams/buffer_list": 124, "./internal/streams/destroy": 125, "./internal/streams/from": 127, "./internal/streams/state": 129, "./internal/streams/stream": 130, "_process": 304, "buffer": 216, "events": 253, "inherits": 109, "string_decoder/": 142, "util": 172 }], 121: [function (require, module, exports) {
      // Copyright Joyent, Inc. and other Node contributors.
      //
      // Permission is hereby granted, free of charge, to any person obtaining a
      // copy of this software and associated documentation files (the
      // "Software"), to deal in the Software without restriction, including
      // without limitation the rights to use, copy, modify, merge, publish,
      // distribute, sublicense, and/or sell copies of the Software, and to permit
      // persons to whom the Software is furnished to do so, subject to the
      // following conditions:
      //
      // The above copyright notice and this permission notice shall be included
      // in all copies or substantial portions of the Software.
      //
      // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
      // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
      // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
      // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
      // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
      // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
      // USE OR OTHER DEALINGS IN THE SOFTWARE.
      // a transform stream is a readable/writable stream where you do
      // something with the data.  Sometimes it's called a "filter",
      // but that's not a great name for it, since that implies a thing where
      // some bits pass through, and others are simply ignored.  (That would
      // be a valid example of a transform, of course.)
      //
      // While the output is causally related to the input, it's not a
      // necessarily symmetric or synchronous transformation.  For example,
      // a zlib stream might take multiple plain-text writes(), and then
      // emit a single compressed chunk some time in the future.
      //
      // Here's how this works:
      //
      // The Transform stream has all the aspects of the readable and writable
      // stream classes.  When you write(chunk), that calls _write(chunk,cb)
      // internally, and returns false if there's a lot of pending writes
      // buffered up.  When you call read(), that calls _read(n) until
      // there's enough pending readable data buffered up.
      //
      // In a transform stream, the written data is placed in a buffer.  When
      // _read(n) is called, it transforms the queued up data, calling the
      // buffered _write cb's as it consumes chunks.  If consuming a single
      // written chunk would result in multiple output chunks, then the first
      // outputted bit calls the readcb, and subsequent chunks just go into
      // the read buffer, and will cause it to emit 'readable' if necessary.
      //
      // This way, back-pressure is actually determined by the reading side,
      // since _read has to be called to start processing a new chunk.  However,
      // a pathological inflate type of transform can cause excessive buffering
      // here.  For example, imagine a stream where every byte of input is
      // interpreted as an integer from 0-255, and then results in that many
      // bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
      // 1kb of data being output.  In this case, you could write a very small
      // amount of input, and end up with a very large amount of output.  In
      // such a pathological inflating mechanism, there'd be no way to tell
      // the system to stop doing the transform.  A single 4MB write could
      // cause the system to run out of memory.
      //
      // However, even in such a pathological case, only a single written chunk
      // would be consumed, and then the rest would wait (un-transformed) until
      // the results of the previous transformed chunk were consumed.
      'use strict';

      module.exports = Transform;

      var _require$codes = require('../errors').codes,
        ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
        ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
        ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING,
        ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

      var Duplex = require('./_stream_duplex');

      require('inherits')(Transform, Duplex);

      function afterTransform(er, data) {
        var ts = this._transformState;
        ts.transforming = false;
        var cb = ts.writecb;

        if (cb === null) {
          return this.emit('error', new ERR_MULTIPLE_CALLBACK());
        }

        ts.writechunk = null;
        ts.writecb = null;
        if (data != null) // single equals check for both `null` and `undefined`
          this.push(data);
        cb(er);
        var rs = this._readableState;
        rs.reading = false;

        if (rs.needReadable || rs.length < rs.highWaterMark) {
          this._read(rs.highWaterMark);
        }
      }

      function Transform(options) {
        if (!(this instanceof Transform)) return new Transform(options);
        Duplex.call(this, options);
        this._transformState = {
          afterTransform: afterTransform.bind(this),
          needTransform: false,
          transforming: false,
          writecb: null,
          writechunk: null,
          writeencoding: null
        }; // start out asking for a readable event once data is transformed.

        this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
        // that Readable wants before the first _read call, so unset the
        // sync guard flag.

        this._readableState.sync = false;

        if (options) {
          if (typeof options.transform === 'function') this._transform = options.transform;
          if (typeof options.flush === 'function') this._flush = options.flush;
        } // When the writable side finishes, then flush out anything remaining.


        this.on('prefinish', prefinish);
      }

      function prefinish() {
        var _this = this;

        if (typeof this._flush === 'function' && !this._readableState.destroyed) {
          this._flush(function (er, data) {
            done(_this, er, data);
          });
        } else {
          done(this, null, null);
        }
      }

      Transform.prototype.push = function (chunk, encoding) {
        this._transformState.needTransform = false;
        return Duplex.prototype.push.call(this, chunk, encoding);
      }; // This is the part where you do stuff!
      // override this function in implementation classes.
      // 'chunk' is an input chunk.
      //
      // Call `push(newChunk)` to pass along transformed output
      // to the readable side.  You may call 'push' zero or more times.
      //
      // Call `cb(err)` when you are done with this chunk.  If you pass
      // an error, then that'll put the hurt on the whole operation.  If you
      // never call cb(), then you'll never get another chunk.


      Transform.prototype._transform = function (chunk, encoding, cb) {
        cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
      };

      Transform.prototype._write = function (chunk, encoding, cb) {
        var ts = this._transformState;
        ts.writecb = cb;
        ts.writechunk = chunk;
        ts.writeencoding = encoding;

        if (!ts.transforming) {
          var rs = this._readableState;
          if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
        }
      }; // Doesn't matter what the args are here.
      // _transform does all the work.
      // That we got here means that the readable side wants more data.


      Transform.prototype._read = function (n) {
        var ts = this._transformState;

        if (ts.writechunk !== null && !ts.transforming) {
          ts.transforming = true;

          this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
        } else {
          // mark that we need a transform, so that any data that comes in
          // will get processed, now that we've asked for it.
          ts.needTransform = true;
        }
      };

      Transform.prototype._destroy = function (err, cb) {
        Duplex.prototype._destroy.call(this, err, function (err2) {
          cb(err2);
        });
      };

      function done(stream, er, data) {
        if (er) return stream.emit('error', er);
        if (data != null) // single equals check for both `null` and `undefined`
          stream.push(data); // TODO(BridgeAR): Write a test for these two error cases
        // if there's nothing in the write buffer, then that means
        // that nothing more will ever be provided

        if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
        if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
        return stream.push(null);
      }
    }, { "../errors": 117, "./_stream_duplex": 118, "inherits": 109 }], 122: [function (require, module, exports) {
      (function (process, global) {
        (function () {
          // Copyright Joyent, Inc. and other Node contributors.
          //
          // Permission is hereby granted, free of charge, to any person obtaining a
          // copy of this software and associated documentation files (the
          // "Software"), to deal in the Software without restriction, including
          // without limitation the rights to use, copy, modify, merge, publish,
          // distribute, sublicense, and/or sell copies of the Software, and to permit
          // persons to whom the Software is furnished to do so, subject to the
          // following conditions:
          //
          // The above copyright notice and this permission notice shall be included
          // in all copies or substantial portions of the Software.
          //
          // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
          // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
          // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
          // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
          // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
          // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
          // USE OR OTHER DEALINGS IN THE SOFTWARE.
          // A bit simpler than readable streams.
          // Implement an async ._write(chunk, encoding, cb), and it'll handle all
          // the drain event emission and buffering.
          'use strict';

          module.exports = Writable;
          /* <replacement> */

          function WriteReq(chunk, encoding, cb) {
            this.chunk = chunk;
            this.encoding = encoding;
            this.callback = cb;
            this.next = null;
          } // It seems a linked list but it is not
          // there will be only 2 of these for each stream


          function CorkedRequest(state) {
            var _this = this;

            this.next = null;
            this.entry = null;

            this.finish = function () {
              onCorkedFinish(_this, state);
            };
          }
          /* </replacement> */

          /*<replacement>*/


          var Duplex;
          /*</replacement>*/

          Writable.WritableState = WritableState;
          /*<replacement>*/

          var internalUtil = {
            deprecate: require('util-deprecate')
          };
          /*</replacement>*/

          /*<replacement>*/

          var Stream = require('./internal/streams/stream');
          /*</replacement>*/


          var Buffer = require('buffer').Buffer;

          var OurUint8Array = global.Uint8Array || function () { };

          function _uint8ArrayToBuffer(chunk) {
            return Buffer.from(chunk);
          }

          function _isUint8Array(obj) {
            return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
          }

          var destroyImpl = require('./internal/streams/destroy');

          var _require = require('./internal/streams/state'),
            getHighWaterMark = _require.getHighWaterMark;

          var _require$codes = require('../errors').codes,
            ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
            ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
            ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
            ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
            ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
            ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
            ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
            ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;

          var errorOrDestroy = destroyImpl.errorOrDestroy;

          require('inherits')(Writable, Stream);

          function nop() { }

          function WritableState(options, stream, isDuplex) {
            Duplex = Duplex || require('./_stream_duplex');
            options = options || {}; // Duplex streams are both readable and writable, but share
            // the same options object.
            // However, some cases require setting options to different
            // values for the readable and the writable sides of the duplex stream,
            // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.

            if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex; // object stream flag to indicate whether or not this stream
            // contains buffers or objects.

            this.objectMode = !!options.objectMode;
            if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
            // Note: 0 is a valid value, means that we always return false if
            // the entire buffer is not flushed immediately on write()

            this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex); // if _final has been called

            this.finalCalled = false; // drain event flag.

            this.needDrain = false; // at the start of calling end()

            this.ending = false; // when end() has been called, and returned

            this.ended = false; // when 'finish' is emitted

            this.finished = false; // has it been destroyed

            this.destroyed = false; // should we decode strings into buffers before passing to _write?
            // this is here so that some node-core streams can optimize string
            // handling at a lower level.

            var noDecode = options.decodeStrings === false;
            this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
            // encoding is 'binary' so we have to make this configurable.
            // Everything else in the universe uses 'utf8', though.

            this.defaultEncoding = options.defaultEncoding || 'utf8'; // not an actual buffer we keep track of, but a measurement
            // of how much we're waiting to get pushed to some underlying
            // socket or file.

            this.length = 0; // a flag to see when we're in the middle of a write.

            this.writing = false; // when true all writes will be buffered until .uncork() call

            this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
            // or on a later tick.  We set this to true at first, because any
            // actions that shouldn't happen until "later" should generally also
            // not happen before the first write call.

            this.sync = true; // a flag to know if we're processing previously buffered items, which
            // may call the _write() callback in the same tick, so that we don't
            // end up in an overlapped onwrite situation.

            this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)

            this.onwrite = function (er) {
              onwrite(stream, er);
            }; // the callback that the user supplies to write(chunk,encoding,cb)


            this.writecb = null; // the amount that is being written when _write is called.

            this.writelen = 0;
            this.bufferedRequest = null;
            this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
            // this must be 0 before 'finish' can be emitted

            this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
            // This is relevant for synchronous Transform streams

            this.prefinished = false; // True if the error was already emitted and should not be thrown again

            this.errorEmitted = false; // Should close be emitted on destroy. Defaults to true.

            this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'finish' (and potentially 'end')

            this.autoDestroy = !!options.autoDestroy; // count buffered requests

            this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
            // one allocated and free to use, and we maintain at most two

            this.corkedRequestsFree = new CorkedRequest(this);
          }

          WritableState.prototype.getBuffer = function getBuffer() {
            var current = this.bufferedRequest;
            var out = [];

            while (current) {
              out.push(current);
              current = current.next;
            }

            return out;
          };

          (function () {
            try {
              Object.defineProperty(WritableState.prototype, 'buffer', {
                get: internalUtil.deprecate(function writableStateBufferGetter() {
                  return this.getBuffer();
                }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
              });
            } catch (_) { }
          })(); // Test _writableState for inheritance to account for Duplex streams,
          // whose prototype chain only points to Readable.


          var realHasInstance;

          if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
            realHasInstance = Function.prototype[Symbol.hasInstance];
            Object.defineProperty(Writable, Symbol.hasInstance, {
              value: function value(object) {
                if (realHasInstance.call(this, object)) return true;
                if (this !== Writable) return false;
                return object && object._writableState instanceof WritableState;
              }
            });
          } else {
            realHasInstance = function realHasInstance(object) {
              return object instanceof this;
            };
          }

          function Writable(options) {
            Duplex = Duplex || require('./_stream_duplex'); // Writable ctor is applied to Duplexes, too.
            // `realHasInstance` is necessary because using plain `instanceof`
            // would return false, as no `_writableState` property is attached.
            // Trying to use the custom `instanceof` for Writable here will also break the
            // Node.js LazyTransform implementation, which has a non-trivial getter for
            // `_writableState` that would lead to infinite recursion.
            // Checking for a Stream.Duplex instance is faster here instead of inside
            // the WritableState constructor, at least with V8 6.5

            var isDuplex = this instanceof Duplex;
            if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
            this._writableState = new WritableState(options, this, isDuplex); // legacy.

            this.writable = true;

            if (options) {
              if (typeof options.write === 'function') this._write = options.write;
              if (typeof options.writev === 'function') this._writev = options.writev;
              if (typeof options.destroy === 'function') this._destroy = options.destroy;
              if (typeof options.final === 'function') this._final = options.final;
            }

            Stream.call(this);
          } // Otherwise people can pipe Writable streams, which is just wrong.


          Writable.prototype.pipe = function () {
            errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
          };

          function writeAfterEnd(stream, cb) {
            var er = new ERR_STREAM_WRITE_AFTER_END(); // TODO: defer error events consistently everywhere, not just the cb

            errorOrDestroy(stream, er);
            process.nextTick(cb, er);
          } // Checks that a user-supplied chunk is valid, especially for the particular
          // mode the stream is in. Currently this means that `null` is never accepted
          // and undefined/non-string values are only allowed in object mode.


          function validChunk(stream, state, chunk, cb) {
            var er;

            if (chunk === null) {
              er = new ERR_STREAM_NULL_VALUES();
            } else if (typeof chunk !== 'string' && !state.objectMode) {
              er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
            }

            if (er) {
              errorOrDestroy(stream, er);
              process.nextTick(cb, er);
              return false;
            }

            return true;
          }

          Writable.prototype.write = function (chunk, encoding, cb) {
            var state = this._writableState;
            var ret = false;

            var isBuf = !state.objectMode && _isUint8Array(chunk);

            if (isBuf && !Buffer.isBuffer(chunk)) {
              chunk = _uint8ArrayToBuffer(chunk);
            }

            if (typeof encoding === 'function') {
              cb = encoding;
              encoding = null;
            }

            if (isBuf) encoding = 'buffer'; else if (!encoding) encoding = state.defaultEncoding;
            if (typeof cb !== 'function') cb = nop;
            if (state.ending) writeAfterEnd(this, cb); else if (isBuf || validChunk(this, state, chunk, cb)) {
              state.pendingcb++;
              ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
            }
            return ret;
          };

          Writable.prototype.cork = function () {
            this._writableState.corked++;
          };

          Writable.prototype.uncork = function () {
            var state = this._writableState;

            if (state.corked) {
              state.corked--;
              if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
            }
          };

          Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
            // node::ParseEncoding() requires lower case.
            if (typeof encoding === 'string') encoding = encoding.toLowerCase();
            if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
            this._writableState.defaultEncoding = encoding;
            return this;
          };

          Object.defineProperty(Writable.prototype, 'writableBuffer', {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._writableState && this._writableState.getBuffer();
            }
          });

          function decodeChunk(state, chunk, encoding) {
            if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
              chunk = Buffer.from(chunk, encoding);
            }

            return chunk;
          }

          Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._writableState.highWaterMark;
            }
          }); // if we're already writing something, then just put this
          // in the queue, and wait our turn.  Otherwise, call _write
          // If we return false, then we need a drain event, so set that flag.

          function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
            if (!isBuf) {
              var newChunk = decodeChunk(state, chunk, encoding);

              if (chunk !== newChunk) {
                isBuf = true;
                encoding = 'buffer';
                chunk = newChunk;
              }
            }

            var len = state.objectMode ? 1 : chunk.length;
            state.length += len;
            var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.

            if (!ret) state.needDrain = true;

            if (state.writing || state.corked) {
              var last = state.lastBufferedRequest;
              state.lastBufferedRequest = {
                chunk: chunk,
                encoding: encoding,
                isBuf: isBuf,
                callback: cb,
                next: null
              };

              if (last) {
                last.next = state.lastBufferedRequest;
              } else {
                state.bufferedRequest = state.lastBufferedRequest;
              }

              state.bufferedRequestCount += 1;
            } else {
              doWrite(stream, state, false, len, chunk, encoding, cb);
            }

            return ret;
          }

          function doWrite(stream, state, writev, len, chunk, encoding, cb) {
            state.writelen = len;
            state.writecb = cb;
            state.writing = true;
            state.sync = true;
            if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write')); else if (writev) stream._writev(chunk, state.onwrite); else stream._write(chunk, encoding, state.onwrite);
            state.sync = false;
          }

          function onwriteError(stream, state, sync, er, cb) {
            --state.pendingcb;

            if (sync) {
              // defer the callback if we are being called synchronously
              // to avoid piling up things on the stack
              process.nextTick(cb, er); // this can emit finish, and it will always happen
              // after error

              process.nextTick(finishMaybe, stream, state);
              stream._writableState.errorEmitted = true;
              errorOrDestroy(stream, er);
            } else {
              // the caller expect this to happen before if
              // it is async
              cb(er);
              stream._writableState.errorEmitted = true;
              errorOrDestroy(stream, er); // this can emit finish, but finish must
              // always follow error

              finishMaybe(stream, state);
            }
          }

          function onwriteStateUpdate(state) {
            state.writing = false;
            state.writecb = null;
            state.length -= state.writelen;
            state.writelen = 0;
          }

          function onwrite(stream, er) {
            var state = stream._writableState;
            var sync = state.sync;
            var cb = state.writecb;
            if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
            onwriteStateUpdate(state);
            if (er) onwriteError(stream, state, sync, er, cb); else {
              // Check if we're actually ready to finish, but don't emit yet
              var finished = needFinish(state) || stream.destroyed;

              if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
                clearBuffer(stream, state);
              }

              if (sync) {
                process.nextTick(afterWrite, stream, state, finished, cb);
              } else {
                afterWrite(stream, state, finished, cb);
              }
            }
          }

          function afterWrite(stream, state, finished, cb) {
            if (!finished) onwriteDrain(stream, state);
            state.pendingcb--;
            cb();
            finishMaybe(stream, state);
          } // Must force callback to be called on nextTick, so that we don't
          // emit 'drain' before the write() consumer gets the 'false' return
          // value, and has a chance to attach a 'drain' listener.


          function onwriteDrain(stream, state) {
            if (state.length === 0 && state.needDrain) {
              state.needDrain = false;
              stream.emit('drain');
            }
          } // if there's something in the buffer waiting, then process it


          function clearBuffer(stream, state) {
            state.bufferProcessing = true;
            var entry = state.bufferedRequest;

            if (stream._writev && entry && entry.next) {
              // Fast case, write everything using _writev()
              var l = state.bufferedRequestCount;
              var buffer = new Array(l);
              var holder = state.corkedRequestsFree;
              holder.entry = entry;
              var count = 0;
              var allBuffers = true;

              while (entry) {
                buffer[count] = entry;
                if (!entry.isBuf) allBuffers = false;
                entry = entry.next;
                count += 1;
              }

              buffer.allBuffers = allBuffers;
              doWrite(stream, state, true, state.length, buffer, '', holder.finish); // doWrite is almost always async, defer these to save a bit of time
              // as the hot path ends with doWrite

              state.pendingcb++;
              state.lastBufferedRequest = null;

              if (holder.next) {
                state.corkedRequestsFree = holder.next;
                holder.next = null;
              } else {
                state.corkedRequestsFree = new CorkedRequest(state);
              }

              state.bufferedRequestCount = 0;
            } else {
              // Slow case, write chunks one-by-one
              while (entry) {
                var chunk = entry.chunk;
                var encoding = entry.encoding;
                var cb = entry.callback;
                var len = state.objectMode ? 1 : chunk.length;
                doWrite(stream, state, false, len, chunk, encoding, cb);
                entry = entry.next;
                state.bufferedRequestCount--; // if we didn't call the onwrite immediately, then
                // it means that we need to wait until it does.
                // also, that means that the chunk and cb are currently
                // being processed, so move the buffer counter past them.

                if (state.writing) {
                  break;
                }
              }

              if (entry === null) state.lastBufferedRequest = null;
            }

            state.bufferedRequest = entry;
            state.bufferProcessing = false;
          }

          Writable.prototype._write = function (chunk, encoding, cb) {
            cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
          };

          Writable.prototype._writev = null;

          Writable.prototype.end = function (chunk, encoding, cb) {
            var state = this._writableState;

            if (typeof chunk === 'function') {
              cb = chunk;
              chunk = null;
              encoding = null;
            } else if (typeof encoding === 'function') {
              cb = encoding;
              encoding = null;
            }

            if (chunk !== null && chunk !== undefined) this.write(chunk, encoding); // .end() fully uncorks

            if (state.corked) {
              state.corked = 1;
              this.uncork();
            } // ignore unnecessary end() calls.


            if (!state.ending) endWritable(this, state, cb);
            return this;
          };

          Object.defineProperty(Writable.prototype, 'writableLength', {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              return this._writableState.length;
            }
          });

          function needFinish(state) {
            return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
          }

          function callFinal(stream, state) {
            stream._final(function (err) {
              state.pendingcb--;

              if (err) {
                errorOrDestroy(stream, err);
              }

              state.prefinished = true;
              stream.emit('prefinish');
              finishMaybe(stream, state);
            });
          }

          function prefinish(stream, state) {
            if (!state.prefinished && !state.finalCalled) {
              if (typeof stream._final === 'function' && !state.destroyed) {
                state.pendingcb++;
                state.finalCalled = true;
                process.nextTick(callFinal, stream, state);
              } else {
                state.prefinished = true;
                stream.emit('prefinish');
              }
            }
          }

          function finishMaybe(stream, state) {
            var need = needFinish(state);

            if (need) {
              prefinish(stream, state);

              if (state.pendingcb === 0) {
                state.finished = true;
                stream.emit('finish');

                if (state.autoDestroy) {
                  // In case of duplex streams we need a way to detect
                  // if the readable side is ready for autoDestroy as well
                  var rState = stream._readableState;

                  if (!rState || rState.autoDestroy && rState.endEmitted) {
                    stream.destroy();
                  }
                }
              }
            }

            return need;
          }

          function endWritable(stream, state, cb) {
            state.ending = true;
            finishMaybe(stream, state);

            if (cb) {
              if (state.finished) process.nextTick(cb); else stream.once('finish', cb);
            }

            state.ended = true;
            stream.writable = false;
          }

          function onCorkedFinish(corkReq, state, err) {
            var entry = corkReq.entry;
            corkReq.entry = null;

            while (entry) {
              var cb = entry.callback;
              state.pendingcb--;
              cb(err);
              entry = entry.next;
            } // reuse the free corkReq.


            state.corkedRequestsFree.next = corkReq;
          }

          Object.defineProperty(Writable.prototype, 'destroyed', {
            // making it explicit this property is not enumerable
            // because otherwise some prototype manipulation in
            // userland will fail
            enumerable: false,
            get: function get() {
              if (this._writableState === undefined) {
                return false;
              }

              return this._writableState.destroyed;
            },
            set: function set(value) {
              // we ignore the value if the stream
              // has not been initialized yet
              if (!this._writableState) {
                return;
              } // backward compatibility, the user is explicitly
              // managing destroyed


              this._writableState.destroyed = value;
            }
          });
          Writable.prototype.destroy = destroyImpl.destroy;
          Writable.prototype._undestroy = destroyImpl.undestroy;

          Writable.prototype._destroy = function (err, cb) {
            cb(err);
          };
        }).call(this)
      }).call(this, require('_process'), typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
    }, { "../errors": 117, "./_stream_duplex": 118, "./internal/streams/destroy": 125, "./internal/streams/state": 129, "./internal/streams/stream": 130, "_process": 304, "buffer": 216, "inherits": 109, "util-deprecate": 147 }], 123: [function (require, module, exports) {
      (function (process) {
        (function () {
          'use strict';

          var _Object$setPrototypeO;

          function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

          var finished = require('./end-of-stream');

          var kLastResolve = Symbol('lastResolve');
          var kLastReject = Symbol('lastReject');
          var kError = Symbol('error');
          var kEnded = Symbol('ended');
          var kLastPromise = Symbol('lastPromise');
          var kHandlePromise = Symbol('handlePromise');
          var kStream = Symbol('stream');

          function createIterResult(value, done) {
            return {
              value: value,
              done: done
            };
          }

          function readAndResolve(iter) {
            var resolve = iter[kLastResolve];

            if (resolve !== null) {
              var data = iter[kStream].read(); // we defer if data is null
              // we can be expecting either 'end' or
              // 'error'

              if (data !== null) {
                iter[kLastPromise] = null;
                iter[kLastResolve] = null;
                iter[kLastReject] = null;
                resolve(createIterResult(data, false));
              }
            }
          }

          function onReadable(iter) {
            // we wait for the next tick, because it might
            // emit an error with process.nextTick
            process.nextTick(readAndResolve, iter);
          }

          function wrapForNext(lastPromise, iter) {
            return function (resolve, reject) {
              lastPromise.then(function () {
                if (iter[kEnded]) {
                  resolve(createIterResult(undefined, true));
                  return;
                }

                iter[kHandlePromise](resolve, reject);
              }, reject);
            };
          }

          var AsyncIteratorPrototype = Object.getPrototypeOf(function () { });
          var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
            get stream() {
              return this[kStream];
            },

            next: function next() {
              var _this = this;

              // if we have detected an error in the meanwhile
              // reject straight away
              var error = this[kError];

              if (error !== null) {
                return Promise.reject(error);
              }

              if (this[kEnded]) {
                return Promise.resolve(createIterResult(undefined, true));
              }

              if (this[kStream].destroyed) {
                // We need to defer via nextTick because if .destroy(err) is
                // called, the error will be emitted via nextTick, and
                // we cannot guarantee that there is no error lingering around
                // waiting to be emitted.
                return new Promise(function (resolve, reject) {
                  process.nextTick(function () {
                    if (_this[kError]) {
                      reject(_this[kError]);
                    } else {
                      resolve(createIterResult(undefined, true));
                    }
                  });
                });
              } // if we have multiple next() calls
              // we will wait for the previous Promise to finish
              // this logic is optimized to support for await loops,
              // where next() is only called once at a time


              var lastPromise = this[kLastPromise];
              var promise;

              if (lastPromise) {
                promise = new Promise(wrapForNext(lastPromise, this));
              } else {
                // fast path needed to support multiple this.push()
                // without triggering the next() queue
                var data = this[kStream].read();

                if (data !== null) {
                  return Promise.resolve(createIterResult(data, false));
                }

                promise = new Promise(this[kHandlePromise]);
              }

              this[kLastPromise] = promise;
              return promise;
            }
          }, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function () {
            return this;
          }), _defineProperty(_Object$setPrototypeO, "return", function _return() {
            var _this2 = this;

            // destroy(err, cb) is a private API
            // we can guarantee we have that here, because we control the
            // Readable class this is attached to
            return new Promise(function (resolve, reject) {
              _this2[kStream].destroy(null, function (err) {
                if (err) {
                  reject(err);
                  return;
                }

                resolve(createIterResult(undefined, true));
              });
            });
          }), _Object$setPrototypeO), AsyncIteratorPrototype);

          var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
            var _Object$create;

            var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
              value: stream,
              writable: true
            }), _defineProperty(_Object$create, kLastResolve, {
              value: null,
              writable: true
            }), _defineProperty(_Object$create, kLastReject, {
              value: null,
              writable: true
            }), _defineProperty(_Object$create, kError, {
              value: null,
              writable: true
            }), _defineProperty(_Object$create, kEnded, {
              value: stream._readableState.endEmitted,
              writable: true
            }), _defineProperty(_Object$create, kHandlePromise, {
              value: function value(resolve, reject) {
                var data = iterator[kStream].read();

                if (data) {
                  iterator[kLastPromise] = null;
                  iterator[kLastResolve] = null;
                  iterator[kLastReject] = null;
                  resolve(createIterResult(data, false));
                } else {
                  iterator[kLastResolve] = resolve;
                  iterator[kLastReject] = reject;
                }
              },
              writable: true
            }), _Object$create));
            iterator[kLastPromise] = null;
            finished(stream, function (err) {
              if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
                var reject = iterator[kLastReject]; // reject if we are waiting for data in the Promise
                // returned by next() and store the error

                if (reject !== null) {
                  iterator[kLastPromise] = null;
                  iterator[kLastResolve] = null;
                  iterator[kLastReject] = null;
                  reject(err);
                }

                iterator[kError] = err;
                return;
              }

              var resolve = iterator[kLastResolve];

              if (resolve !== null) {
                iterator[kLastPromise] = null;
                iterator[kLastResolve] = null;
                iterator[kLastReject] = null;
                resolve(createIterResult(undefined, true));
              }

              iterator[kEnded] = true;
            });
            stream.on('readable', onReadable.bind(null, iterator));
            return iterator;
          };

          module.exports = createReadableStreamAsyncIterator;
        }).call(this)
      }).call(this, require('_process'))
    }, { "./end-of-stream": 126, "_process": 304 }], 124: [function (require, module, exports) {
      'use strict';

      function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

      function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

      function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

      function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

      function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

      function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

      var _require = require('buffer'),
        Buffer = _require.Buffer;

      var _require2 = require('util'),
        inspect = _require2.inspect;

      var custom = inspect && inspect.custom || 'inspect';

      function copyBuffer(src, target, offset) {
        Buffer.prototype.copy.call(src, target, offset);
      }

      module.exports =
        /*#__PURE__*/
        function () {
          function BufferList() {
            _classCallCheck(this, BufferList);

            this.head = null;
            this.tail = null;
            this.length = 0;
          }

          _createClass(BufferList, [{
            key: "push",
            value: function push(v) {
              var entry = {
                data: v,
                next: null
              };
              if (this.length > 0) this.tail.next = entry; else this.head = entry;
              this.tail = entry;
              ++this.length;
            }
          }, {
            key: "unshift",
            value: function unshift(v) {
              var entry = {
                data: v,
                next: this.head
              };
              if (this.length === 0) this.tail = entry;
              this.head = entry;
              ++this.length;
            }
          }, {
            key: "shift",
            value: function shift() {
              if (this.length === 0) return;
              var ret = this.head.data;
              if (this.length === 1) this.head = this.tail = null; else this.head = this.head.next;
              --this.length;
              return ret;
            }
          }, {
            key: "clear",
            value: function clear() {
              this.head = this.tail = null;
              this.length = 0;
            }
          }, {
            key: "join",
            value: function join(s) {
              if (this.length === 0) return '';
              var p = this.head;
              var ret = '' + p.data;

              while (p = p.next) {
                ret += s + p.data;
              }

              return ret;
            }
          }, {
            key: "concat",
            value: function concat(n) {
              if (this.length === 0) return Buffer.alloc(0);
              var ret = Buffer.allocUnsafe(n >>> 0);
              var p = this.head;
              var i = 0;

              while (p) {
                copyBuffer(p.data, ret, i);
                i += p.data.length;
                p = p.next;
              }

              return ret;
            } // Consumes a specified amount of bytes or characters from the buffered data.

          }, {
            key: "consume",
            value: function consume(n, hasStrings) {
              var ret;

              if (n < this.head.data.length) {
                // `slice` is the same for buffers and strings.
                ret = this.head.data.slice(0, n);
                this.head.data = this.head.data.slice(n);
              } else if (n === this.head.data.length) {
                // First chunk is a perfect match.
                ret = this.shift();
              } else {
                // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
              }

              return ret;
            }
          }, {
            key: "first",
            value: function first() {
              return this.head.data;
            } // Consumes a specified amount of characters from the buffered data.

          }, {
            key: "_getString",
            value: function _getString(n) {
              var p = this.head;
              var c = 1;
              var ret = p.data;
              n -= ret.length;

              while (p = p.next) {
                var str = p.data;
                var nb = n > str.length ? str.length : n;
                if (nb === str.length) ret += str; else ret += str.slice(0, n);
                n -= nb;

                if (n === 0) {
                  if (nb === str.length) {
                    ++c;
                    if (p.next) this.head = p.next; else this.head = this.tail = null;
                  } else {
                    this.head = p;
                    p.data = str.slice(nb);
                  }

                  break;
                }

                ++c;
              }

              this.length -= c;
              return ret;
            } // Consumes a specified amount of bytes from the buffered data.

          }, {
            key: "_getBuffer",
            value: function _getBuffer(n) {
              var ret = Buffer.allocUnsafe(n);
              var p = this.head;
              var c = 1;
              p.data.copy(ret);
              n -= p.data.length;

              while (p = p.next) {
                var buf = p.data;
                var nb = n > buf.length ? buf.length : n;
                buf.copy(ret, ret.length - n, 0, nb);
                n -= nb;

                if (n === 0) {
                  if (nb === buf.length) {
                    ++c;
                    if (p.next) this.head = p.next; else this.head = this.tail = null;
                  } else {
                    this.head = p;
                    p.data = buf.slice(nb);
                  }

                  break;
                }

                ++c;
              }

              this.length -= c;
              return ret;
            } // Make sure the linked list only shows the minimal necessary information.

          }, {
            key: custom,
            value: function value(_, options) {
              return inspect(this, _objectSpread({}, options, {
                // Only inspect one level.
                depth: 0,
                // It should not recurse.
                customInspect: false
              }));
            }
          }]);

          return BufferList;
        }();
    }, { "buffer": 216, "util": 172 }], 125: [function (require, module, exports) {
      (function (process) {
        (function () {
          'use strict'; // undocumented cb() API, needed for core, not for public API

          function destroy(err, cb) {
            var _this = this;

            var readableDestroyed = this._readableState && this._readableState.destroyed;
            var writableDestroyed = this._writableState && this._writableState.destroyed;

            if (readableDestroyed || writableDestroyed) {
              if (cb) {
                cb(err);
              } else if (err) {
                if (!this._writableState) {
                  process.nextTick(emitErrorNT, this, err);
                } else if (!this._writableState.errorEmitted) {
                  this._writableState.errorEmitted = true;
                  process.nextTick(emitErrorNT, this, err);
                }
              }

              return this;
            } // we set destroyed to true before firing error callbacks in order
            // to make it re-entrance safe in case destroy() is called within callbacks


            if (this._readableState) {
              this._readableState.destroyed = true;
            } // if this is a duplex stream mark the writable part as destroyed as well


            if (this._writableState) {
              this._writableState.destroyed = true;
            }

            this._destroy(err || null, function (err) {
              if (!cb && err) {
                if (!_this._writableState) {
                  process.nextTick(emitErrorAndCloseNT, _this, err);
                } else if (!_this._writableState.errorEmitted) {
                  _this._writableState.errorEmitted = true;
                  process.nextTick(emitErrorAndCloseNT, _this, err);
                } else {
                  process.nextTick(emitCloseNT, _this);
                }
              } else if (cb) {
                process.nextTick(emitCloseNT, _this);
                cb(err);
              } else {
                process.nextTick(emitCloseNT, _this);
              }
            });

            return this;
          }

          function emitErrorAndCloseNT(self, err) {
            emitErrorNT(self, err);
            emitCloseNT(self);
          }

          function emitCloseNT(self) {
            if (self._writableState && !self._writableState.emitClose) return;
            if (self._readableState && !self._readableState.emitClose) return;
            self.emit('close');
          }

          function undestroy() {
            if (this._readableState) {
              this._readableState.destroyed = false;
              this._readableState.reading = false;
              this._readableState.ended = false;
              this._readableState.endEmitted = false;
            }

            if (this._writableState) {
              this._writableState.destroyed = false;
              this._writableState.ended = false;
              this._writableState.ending = false;
              this._writableState.finalCalled = false;
              this._writableState.prefinished = false;
              this._writableState.finished = false;
              this._writableState.errorEmitted = false;
            }
          }

          function emitErrorNT(self, err) {
            self.emit('error', err);
          }

          function errorOrDestroy(stream, err) {
            // We have tests that rely on errors being emitted
            // in the same tick, so changing this is semver major.
            // For now when you opt-in to autoDestroy we allow
            // the error to be emitted nextTick. In a future
            // semver major update we should change the default to this.
            var rState = stream._readableState;
            var wState = stream._writableState;
            if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err); else stream.emit('error', err);
          }

          module.exports = {
            destroy: destroy,
            undestroy: undestroy,
            errorOrDestroy: errorOrDestroy
          };
        }).call(this)
      }).call(this, require('_process'))
    }, { "_process": 304 }], 126: [function (require, module, exports) {
      // Ported from https://github.com/mafintosh/end-of-stream with
      // permission from the author, Mathias Buus (@mafintosh).
      'use strict';

      var ERR_STREAM_PREMATURE_CLOSE = require('../../../errors').codes.ERR_STREAM_PREMATURE_CLOSE;

      function once(callback) {
        var called = false;
        return function () {
          if (called) return;
          called = true;

          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          callback.apply(this, args);
        };
      }

      function noop() { }

      function isRequest(stream) {
        return stream.setHeader && typeof stream.abort === 'function';
      }

      function eos(stream, opts, callback) {
        if (typeof opts === 'function') return eos(stream, null, opts);
        if (!opts) opts = {};
        callback = once(callback || noop);
        var readable = opts.readable || opts.readable !== false && stream.readable;
        var writable = opts.writable || opts.writable !== false && stream.writable;

        var onlegacyfinish = function onlegacyfinish() {
          if (!stream.writable) onfinish();
        };

        var writableEnded = stream._writableState && stream._writableState.finished;

        var onfinish = function onfinish() {
          writable = false;
          writableEnded = true;
          if (!readable) callback.call(stream);
        };

        var readableEnded = stream._readableState && stream._readableState.endEmitted;

        var onend = function onend() {
          readable = false;
          readableEnded = true;
          if (!writable) callback.call(stream);
        };

        var onerror = function onerror(err) {
          callback.call(stream, err);
        };

        var onclose = function onclose() {
          var err;

          if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
          }

          if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
          }
        };

        var onrequest = function onrequest() {
          stream.req.on('finish', onfinish);
        };

        if (isRequest(stream)) {
          stream.on('complete', onfinish);
          stream.on('abort', onclose);
          if (stream.req) onrequest(); else stream.on('request', onrequest);
        } else if (writable && !stream._writableState) {
          // legacy streams
          stream.on('end', onlegacyfinish);
          stream.on('close', onlegacyfinish);
        }

        stream.on('end', onend);
        stream.on('finish', onfinish);
        if (opts.error !== false) stream.on('error', onerror);
        stream.on('close', onclose);
        return function () {
          stream.removeListener('complete', onfinish);
          stream.removeListener('abort', onclose);
          stream.removeListener('request', onrequest);
          if (stream.req) stream.req.removeListener('finish', onfinish);
          stream.removeListener('end', onlegacyfinish);
          stream.removeListener('close', onlegacyfinish);
          stream.removeListener('finish', onfinish);
          stream.removeListener('end', onend);
          stream.removeListener('error', onerror);
          stream.removeListener('close', onclose);
        };
      }

      module.exports = eos;
    }, { "../../../errors": 117 }], 127: [function (require, module, exports) {
      module.exports = function () {
        throw new Error('Readable.from is not available in the browser')
      };

    }, {}], 128: [function (require, module, exports) {
      // Ported from https://github.com/mafintosh/pump with
      // permission from the author, Mathias Buus (@mafintosh).
      'use strict';

      var eos;

      function once(callback) {
        var called = false;
        return function () {
          if (called) return;
          called = true;
          callback.apply(void 0, arguments);
        };
      }

      var _require$codes = require('../../../errors').codes,
        ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
        ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;

      function noop(err) {
        // Rethrow the error if it exists to avoid swallowing it
        if (err) throw err;
      }

      function isRequest(stream) {
        return stream.setHeader && typeof stream.abort === 'function';
      }

      function destroyer(stream, reading, writing, callback) {
        callback = once(callback);
        var closed = false;
        stream.on('close', function () {
          closed = true;
        });
        if (eos === undefined) eos = require('./end-of-stream');
        eos(stream, {
          readable: reading,
          writable: writing
        }, function (err) {
          if (err) return callback(err);
          closed = true;
          callback();
        });
        var destroyed = false;
        return function (err) {
          if (closed) return;
          if (destroyed) return;
          destroyed = true; // request.destroy just do .end - .abort is what we want

          if (isRequest(stream)) return stream.abort();
          if (typeof stream.destroy === 'function') return stream.destroy();
          callback(err || new ERR_STREAM_DESTROYED('pipe'));
        };
      }

      function call(fn) {
        fn();
      }

      function pipe(from, to) {
        return from.pipe(to);
      }

      function popCallback(streams) {
        if (!streams.length) return noop;
        if (typeof streams[streams.length - 1] !== 'function') return noop;
        return streams.pop();
      }

      function pipeline() {
        for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
          streams[_key] = arguments[_key];
        }

        var callback = popCallback(streams);
        if (Array.isArray(streams[0])) streams = streams[0];

        if (streams.length < 2) {
          throw new ERR_MISSING_ARGS('streams');
        }

        var error;
        var destroys = streams.map(function (stream, i) {
          var reading = i < streams.length - 1;
          var writing = i > 0;
          return destroyer(stream, reading, writing, function (err) {
            if (!error) error = err;
            if (err) destroys.forEach(call);
            if (reading) return;
            destroys.forEach(call);
            callback(error);
          });
        });
        return streams.reduce(pipe);
      }

      module.exports = pipeline;
    }, { "../../../errors": 117, "./end-of-stream": 126 }], 129: [function (require, module, exports) {
      'use strict';

      var ERR_INVALID_OPT_VALUE = require('../../../errors').codes.ERR_INVALID_OPT_VALUE;

      function highWaterMarkFrom(options, isDuplex, duplexKey) {
        return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
      }

      function getHighWaterMark(state, options, duplexKey, isDuplex) {
        var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);

        if (hwm != null) {
          if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new ERR_INVALID_OPT_VALUE(name, hwm);
          }

          return Math.floor(hwm);
        } // Default value


        return state.objectMode ? 16 : 16 * 1024;
      }

      module.exports = {
        getHighWaterMark: getHighWaterMark
      };
    }, { "../../../errors": 117 }], 130: [function (require, module, exports) {
      module.exports = require('events').EventEmitter;

    }, { "events": 253 }], 131: [function (require, module, exports) {
      exports = module.exports = require('./lib/_stream_readable.js');
      exports.Stream = exports;
      exports.Readable = exports;
      exports.Writable = require('./lib/_stream_writable.js');
      exports.Duplex = require('./lib/_stream_duplex.js');
      exports.Transform = require('./lib/_stream_transform.js');
      exports.PassThrough = require('./lib/_stream_passthrough.js');
      exports.finished = require('./lib/internal/streams/end-of-stream.js');
      exports.pipeline = require('./lib/internal/streams/pipeline.js');

    }, { "./lib/_stream_duplex.js": 118, "./lib/_stream_passthrough.js": 119, "./lib/_stream_readable.js": 120, "./lib/_stream_transform.js": 121, "./lib/_stream_writable.js": 122, "./lib/internal/streams/end-of-stream.js": 126, "./lib/internal/streams/pipeline.js": 128 }], 132: [function (require, module, exports) {
      'use strict'
      var Buffer = require('buffer').Buffer
      var inherits = require('inherits')
      var HashBase = require('hash-base')

      var ARRAY16 = new Array(16)

      var zl = [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
        7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
        3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
        1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
        4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
      ]

      var zr = [
        5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
        6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
        15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
        8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
        12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
      ]

      var sl = [
        11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
        7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
        11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
        11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
        9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
      ]

      var sr = [
        8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
        9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
        9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
        15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
        8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
      ]

      var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e]
      var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000]

      function RIPEMD160() {
        HashBase.call(this, 64)

        // state
        this._a = 0x67452301
        this._b = 0xefcdab89
        this._c = 0x98badcfe
        this._d = 0x10325476
        this._e = 0xc3d2e1f0
      }

      inherits(RIPEMD160, HashBase)

      RIPEMD160.prototype._update = function () {
        var words = ARRAY16
        for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4)

        var al = this._a | 0
        var bl = this._b | 0
        var cl = this._c | 0
        var dl = this._d | 0
        var el = this._e | 0

        var ar = this._a | 0
        var br = this._b | 0
        var cr = this._c | 0
        var dr = this._d | 0
        var er = this._e | 0

        // computation
        for (var i = 0; i < 80; i += 1) {
          var tl
          var tr
          if (i < 16) {
            tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i])
            tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i])
          } else if (i < 32) {
            tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i])
            tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i])
          } else if (i < 48) {
            tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i])
            tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i])
          } else if (i < 64) {
            tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i])
            tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i])
          } else { // if (i<80) {
            tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i])
            tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i])
          }

          al = el
          el = dl
          dl = rotl(cl, 10)
          cl = bl
          bl = tl

          ar = er
          er = dr
          dr = rotl(cr, 10)
          cr = br
          br = tr
        }

        // update state
        var t = (this._b + cl + dr) | 0
        this._b = (this._c + dl + er) | 0
        this._c = (this._d + el + ar) | 0
        this._d = (this._e + al + br) | 0
        this._e = (this._a + bl + cr) | 0
        this._a = t
      }

      RIPEMD160.prototype._digest = function () {
        // create padding and handle blocks
        this._block[this._blockOffset++] = 0x80
        if (this._blockOffset > 56) {
          this._block.fill(0, this._blockOffset, 64)
          this._update()
          this._blockOffset = 0
        }

        this._block.fill(0, this._blockOffset, 56)
        this._block.writeUInt32LE(this._length[0], 56)
        this._block.writeUInt32LE(this._length[1], 60)
        this._update()

        // produce result
        var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20)
        buffer.writeInt32LE(this._a, 0)
        buffer.writeInt32LE(this._b, 4)
        buffer.writeInt32LE(this._c, 8)
        buffer.writeInt32LE(this._d, 12)
        buffer.writeInt32LE(this._e, 16)
        return buffer
      }

      function rotl(x, n) {
        return (x << n) | (x >>> (32 - n))
      }

      function fn1(a, b, c, d, e, m, k, s) {
        return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
      }

      function fn2(a, b, c, d, e, m, k, s) {
        return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
      }

      function fn3(a, b, c, d, e, m, k, s) {
        return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
      }

      function fn4(a, b, c, d, e, m, k, s) {
        return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
      }

      function fn5(a, b, c, d, e, m, k, s) {
        return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
      }

      module.exports = RIPEMD160

    }, { "buffer": 216, "hash-base": 95, "inherits": 109 }], 133: [function (require, module, exports) {
      /*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
      /* eslint-disable node/no-deprecated-api */
      var buffer = require('buffer')
      var Buffer = buffer.Buffer

      // alternative to using Object.keys for old browsers
      function copyProps(src, dst) {
        for (var key in src) {
          dst[key] = src[key]
        }
      }
      if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
        module.exports = buffer
      } else {
        // Copy properties from require('buffer')
        copyProps(buffer, exports)
        exports.Buffer = SafeBuffer
      }

      function SafeBuffer(arg, encodingOrOffset, length) {
        return Buffer(arg, encodingOrOffset, length)
      }

      SafeBuffer.prototype = Object.create(Buffer.prototype)

      // Copy static methods from Buffer
      copyProps(Buffer, SafeBuffer)

      SafeBuffer.from = function (arg, encodingOrOffset, length) {
        if (typeof arg === 'number') {
          throw new TypeError('Argument must not be a number')
        }
        return Buffer(arg, encodingOrOffset, length)
      }

      SafeBuffer.alloc = function (size, fill, encoding) {
        if (typeof size !== 'number') {
          throw new TypeError('Argument must be a number')
        }
        var buf = Buffer(size)
        if (fill !== undefined) {
          if (typeof encoding === 'string') {
            buf.fill(fill, encoding)
          } else {
            buf.fill(fill)
          }
        } else {
          buf.fill(0)
        }
        return buf
      }

      SafeBuffer.allocUnsafe = function (size) {
        if (typeof size !== 'number') {
          throw new TypeError('Argument must be a number')
        }
        return Buffer(size)
      }

      SafeBuffer.allocUnsafeSlow = function (size) {
        if (typeof size !== 'number') {
          throw new TypeError('Argument must be a number')
        }
        return buffer.SlowBuffer(size)
      }

    }, { "buffer": 216 }], 134: [function (require, module, exports) {
      var Buffer = require('safe-buffer').Buffer

      // prototype class for hash functions
      function Hash(blockSize, finalSize) {
        this._block = Buffer.alloc(blockSize)
        this._finalSize = finalSize
        this._blockSize = blockSize
        this._len = 0
      }

      Hash.prototype.update = function (data, enc) {
        if (typeof data === 'string') {
          enc = enc || 'utf8'
          data = Buffer.from(data, enc)
        }

        var block = this._block
        var blockSize = this._blockSize
        var length = data.length
        var accum = this._len

        for (var offset = 0; offset < length;) {
          var assigned = accum % blockSize
          var remainder = Math.min(length - offset, blockSize - assigned)

          for (var i = 0; i < remainder; i++) {
            block[assigned + i] = data[offset + i]
          }

          accum += remainder
          offset += remainder

          if ((accum % blockSize) === 0) {
            this._update(block)
          }
        }

        this._len += length
        return this
      }

      Hash.prototype.digest = function (enc) {
        var rem = this._len % this._blockSize

        this._block[rem] = 0x80

        // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
        // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
        this._block.fill(0, rem + 1)

        if (rem >= this._finalSize) {
          this._update(this._block)
          this._block.fill(0)
        }

        var bits = this._len * 8

        // uint32
        if (bits <= 0xffffffff) {
          this._block.writeUInt32BE(bits, this._blockSize - 4)

          // uint64
        } else {
          var lowBits = (bits & 0xffffffff) >>> 0
          var highBits = (bits - lowBits) / 0x100000000

          this._block.writeUInt32BE(highBits, this._blockSize - 8)
          this._block.writeUInt32BE(lowBits, this._blockSize - 4)
        }

        this._update(this._block)
        var hash = this._hash()

        return enc ? hash.toString(enc) : hash
      }

      Hash.prototype._update = function () {
        throw new Error('_update must be implemented by subclass')
      }

      module.exports = Hash

    }, { "safe-buffer": 133 }], 135: [function (require, module, exports) {
      var exports = module.exports = function SHA(algorithm) {
        algorithm = algorithm.toLowerCase()

        var Algorithm = exports[algorithm]
        if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

        return new Algorithm()
      }

      exports.sha = require('./sha')
      exports.sha1 = require('./sha1')
      exports.sha224 = require('./sha224')
      exports.sha256 = require('./sha256')
      exports.sha384 = require('./sha384')
      exports.sha512 = require('./sha512')

    }, { "./sha": 136, "./sha1": 137, "./sha224": 138, "./sha256": 139, "./sha384": 140, "./sha512": 141 }], 136: [function (require, module, exports) {
      /*
       * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
       * in FIPS PUB 180-1
       * This source code is derived from sha1.js of the same repository.
       * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
       * operation was added.
       */

      var inherits = require('inherits')
      var Hash = require('./hash')
      var Buffer = require('safe-buffer').Buffer

      var K = [
        0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
      ]

      var W = new Array(80)

      function Sha() {
        this.init()
        this._w = W

        Hash.call(this, 64, 56)
      }

      inherits(Sha, Hash)

      Sha.prototype.init = function () {
        this._a = 0x67452301
        this._b = 0xefcdab89
        this._c = 0x98badcfe
        this._d = 0x10325476
        this._e = 0xc3d2e1f0

        return this
      }

      function rotl5(num) {
        return (num << 5) | (num >>> 27)
      }

      function rotl30(num) {
        return (num << 30) | (num >>> 2)
      }

      function ft(s, b, c, d) {
        if (s === 0) return (b & c) | ((~b) & d)
        if (s === 2) return (b & c) | (b & d) | (c & d)
        return b ^ c ^ d
      }

      Sha.prototype._update = function (M) {
        var W = this._w

        var a = this._a | 0
        var b = this._b | 0
        var c = this._c | 0
        var d = this._d | 0
        var e = this._e | 0

        for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
        for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]

        for (var j = 0; j < 80; ++j) {
          var s = ~~(j / 20)
          var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

          e = d
          d = c
          c = rotl30(b)
          b = a
          a = t
        }

        this._a = (a + this._a) | 0
        this._b = (b + this._b) | 0
        this._c = (c + this._c) | 0
        this._d = (d + this._d) | 0
        this._e = (e + this._e) | 0
      }

      Sha.prototype._hash = function () {
        var H = Buffer.allocUnsafe(20)

        H.writeInt32BE(this._a | 0, 0)
        H.writeInt32BE(this._b | 0, 4)
        H.writeInt32BE(this._c | 0, 8)
        H.writeInt32BE(this._d | 0, 12)
        H.writeInt32BE(this._e | 0, 16)

        return H
      }

      module.exports = Sha

    }, { "./hash": 134, "inherits": 109, "safe-buffer": 133 }], 137: [function (require, module, exports) {
      /*
       * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
       * in FIPS PUB 180-1
       * Version 2.1a Copyright Paul Johnston 2000 - 2002.
       * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
       * Distributed under the BSD License
       * See http://pajhome.org.uk/crypt/md5 for details.
       */

      var inherits = require('inherits')
      var Hash = require('./hash')
      var Buffer = require('safe-buffer').Buffer

      var K = [
        0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
      ]

      var W = new Array(80)

      function Sha1() {
        this.init()
        this._w = W

        Hash.call(this, 64, 56)
      }

      inherits(Sha1, Hash)

      Sha1.prototype.init = function () {
        this._a = 0x67452301
        this._b = 0xefcdab89
        this._c = 0x98badcfe
        this._d = 0x10325476
        this._e = 0xc3d2e1f0

        return this
      }

      function rotl1(num) {
        return (num << 1) | (num >>> 31)
      }

      function rotl5(num) {
        return (num << 5) | (num >>> 27)
      }

      function rotl30(num) {
        return (num << 30) | (num >>> 2)
      }

      function ft(s, b, c, d) {
        if (s === 0) return (b & c) | ((~b) & d)
        if (s === 2) return (b & c) | (b & d) | (c & d)
        return b ^ c ^ d
      }

      Sha1.prototype._update = function (M) {
        var W = this._w

        var a = this._a | 0
        var b = this._b | 0
        var c = this._c | 0
        var d = this._d | 0
        var e = this._e | 0

        for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
        for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])

        for (var j = 0; j < 80; ++j) {
          var s = ~~(j / 20)
          var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

          e = d
          d = c
          c = rotl30(b)
          b = a
          a = t
        }

        this._a = (a + this._a) | 0
        this._b = (b + this._b) | 0
        this._c = (c + this._c) | 0
        this._d = (d + this._d) | 0
        this._e = (e + this._e) | 0
      }

      Sha1.prototype._hash = function () {
        var H = Buffer.allocUnsafe(20)

        H.writeInt32BE(this._a | 0, 0)
        H.writeInt32BE(this._b | 0, 4)
        H.writeInt32BE(this._c | 0, 8)
        H.writeInt32BE(this._d | 0, 12)
        H.writeInt32BE(this._e | 0, 16)

        return H
      }

      module.exports = Sha1

    }, { "./hash": 134, "inherits": 109, "safe-buffer": 133 }], 138: [function (require, module, exports) {
      /**
       * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
       * in FIPS 180-2
       * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
       * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
       *
       */

      var inherits = require('inherits')
      var Sha256 = require('./sha256')
      var Hash = require('./hash')
      var Buffer = require('safe-buffer').Buffer

      var W = new Array(64)

      function Sha224() {
        this.init()

        this._w = W // new Array(64)

        Hash.call(this, 64, 56)
      }

      inherits(Sha224, Sha256)

      Sha224.prototype.init = function () {
        this._a = 0xc1059ed8
        this._b = 0x367cd507
        this._c = 0x3070dd17
        this._d = 0xf70e5939
        this._e = 0xffc00b31
        this._f = 0x68581511
        this._g = 0x64f98fa7
        this._h = 0xbefa4fa4

        return this
      }

      Sha224.prototype._hash = function () {
        var H = Buffer.allocUnsafe(28)

        H.writeInt32BE(this._a, 0)
        H.writeInt32BE(this._b, 4)
        H.writeInt32BE(this._c, 8)
        H.writeInt32BE(this._d, 12)
        H.writeInt32BE(this._e, 16)
        H.writeInt32BE(this._f, 20)
        H.writeInt32BE(this._g, 24)

        return H
      }

      module.exports = Sha224

    }, { "./hash": 134, "./sha256": 139, "inherits": 109, "safe-buffer": 133 }], 139: [function (require, module, exports) {
      /**
       * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
       * in FIPS 180-2
       * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
       * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
       *
       */

      var inherits = require('inherits')
      var Hash = require('./hash')
      var Buffer = require('safe-buffer').Buffer

      var K = [
        0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
        0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
        0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
        0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
        0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
        0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
        0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
        0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
        0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
        0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
        0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
        0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
        0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
        0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
        0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
        0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
      ]

      var W = new Array(64)

      function Sha256() {
        this.init()

        this._w = W // new Array(64)

        Hash.call(this, 64, 56)
      }

      inherits(Sha256, Hash)

      Sha256.prototype.init = function () {
        this._a = 0x6a09e667
        this._b = 0xbb67ae85
        this._c = 0x3c6ef372
        this._d = 0xa54ff53a
        this._e = 0x510e527f
        this._f = 0x9b05688c
        this._g = 0x1f83d9ab
        this._h = 0x5be0cd19

        return this
      }

      function ch(x, y, z) {
        return z ^ (x & (y ^ z))
      }

      function maj(x, y, z) {
        return (x & y) | (z & (x | y))
      }

      function sigma0(x) {
        return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
      }

      function sigma1(x) {
        return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
      }

      function gamma0(x) {
        return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
      }

      function gamma1(x) {
        return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
      }

      Sha256.prototype._update = function (M) {
        var W = this._w

        var a = this._a | 0
        var b = this._b | 0
        var c = this._c | 0
        var d = this._d | 0
        var e = this._e | 0
        var f = this._f | 0
        var g = this._g | 0
        var h = this._h | 0

        for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
        for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0

        for (var j = 0; j < 64; ++j) {
          var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
          var T2 = (sigma0(a) + maj(a, b, c)) | 0

          h = g
          g = f
          f = e
          e = (d + T1) | 0
          d = c
          c = b
          b = a
          a = (T1 + T2) | 0
        }

        this._a = (a + this._a) | 0
        this._b = (b + this._b) | 0
        this._c = (c + this._c) | 0
        this._d = (d + this._d) | 0
        this._e = (e + this._e) | 0
        this._f = (f + this._f) | 0
        this._g = (g + this._g) | 0
        this._h = (h + this._h) | 0
      }

      Sha256.prototype._hash = function () {
        var H = Buffer.allocUnsafe(32)

        H.writeInt32BE(this._a, 0)
        H.writeInt32BE(this._b, 4)
        H.writeInt32BE(this._c, 8)
        H.writeInt32BE(this._d, 12)
        H.writeInt32BE(this._e, 16)
        H.writeInt32BE(this._f, 20)
        H.writeInt32BE(this._g, 24)
        H.writeInt32BE(this._h, 28)

        return H
      }

      module.exports = Sha256

    }, { "./hash": 134, "inherits": 109, "safe-buffer": 133 }], 140: [function (require, module, exports) {
      var inherits = require('inherits')
      var SHA512 = require('./sha512')
      var Hash = require('./hash')
      var Buffer = require('safe-buffer').Buffer

      var W = new Array(160)

      function Sha384() {
        this.init()
        this._w = W

        Hash.call(this, 128, 112)
      }

      inherits(Sha384, SHA512)

      Sha384.prototype.init = function () {
        this._ah = 0xcbbb9d5d
        this._bh = 0x629a292a
        this._ch = 0x9159015a
        this._dh = 0x152fecd8
        this._eh = 0x67332667
        this._fh = 0x8eb44a87
        this._gh = 0xdb0c2e0d
        this._hh = 0x47b5481d

        this._al = 0xc1059ed8
        this._bl = 0x367cd507
        this._cl = 0x3070dd17
        this._dl = 0xf70e5939
        this._el = 0xffc00b31
        this._fl = 0x68581511
        this._gl = 0x64f98fa7
        this._hl = 0xbefa4fa4

        return this
      }

      Sha384.prototype._hash = function () {
        var H = Buffer.allocUnsafe(48)

        function writeInt64BE(h, l, offset) {
          H.writeInt32BE(h, offset)
          H.writeInt32BE(l, offset + 4)
        }

        writeInt64BE(this._ah, this._al, 0)
        writeInt64BE(this._bh, this._bl, 8)
        writeInt64BE(this._ch, this._cl, 16)
        writeInt64BE(this._dh, this._dl, 24)
        writeInt64BE(this._eh, this._el, 32)
        writeInt64BE(this._fh, this._fl, 40)

        return H
      }

      module.exports = Sha384

    }, { "./hash": 134, "./sha512": 141, "inherits": 109, "safe-buffer": 133 }], 141: [function (require, module, exports) {
      var inherits = require('inherits')
      var Hash = require('./hash')
      var Buffer = require('safe-buffer').Buffer

      var K = [
        0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
        0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
        0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
        0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
        0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
        0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
        0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
        0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
        0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
        0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
        0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
        0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
        0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
        0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
        0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
        0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
        0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
        0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
        0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
        0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
        0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
        0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
        0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
        0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
        0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
        0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
        0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
        0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
        0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
        0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
        0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
        0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
        0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
        0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
        0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
        0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
        0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
        0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
        0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
        0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
      ]

      var W = new Array(160)

      function Sha512() {
        this.init()
        this._w = W

        Hash.call(this, 128, 112)
      }

      inherits(Sha512, Hash)

      Sha512.prototype.init = function () {
        this._ah = 0x6a09e667
        this._bh = 0xbb67ae85
        this._ch = 0x3c6ef372
        this._dh = 0xa54ff53a
        this._eh = 0x510e527f
        this._fh = 0x9b05688c
        this._gh = 0x1f83d9ab
        this._hh = 0x5be0cd19

        this._al = 0xf3bcc908
        this._bl = 0x84caa73b
        this._cl = 0xfe94f82b
        this._dl = 0x5f1d36f1
        this._el = 0xade682d1
        this._fl = 0x2b3e6c1f
        this._gl = 0xfb41bd6b
        this._hl = 0x137e2179

        return this
      }

      function Ch(x, y, z) {
        return z ^ (x & (y ^ z))
      }

      function maj(x, y, z) {
        return (x & y) | (z & (x | y))
      }

      function sigma0(x, xl) {
        return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
      }

      function sigma1(x, xl) {
        return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
      }

      function Gamma0(x, xl) {
        return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
      }

      function Gamma0l(x, xl) {
        return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
      }

      function Gamma1(x, xl) {
        return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
      }

      function Gamma1l(x, xl) {
        return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
      }

      function getCarry(a, b) {
        return (a >>> 0) < (b >>> 0) ? 1 : 0
      }

      Sha512.prototype._update = function (M) {
        var W = this._w

        var ah = this._ah | 0
        var bh = this._bh | 0
        var ch = this._ch | 0
        var dh = this._dh | 0
        var eh = this._eh | 0
        var fh = this._fh | 0
        var gh = this._gh | 0
        var hh = this._hh | 0

        var al = this._al | 0
        var bl = this._bl | 0
        var cl = this._cl | 0
        var dl = this._dl | 0
        var el = this._el | 0
        var fl = this._fl | 0
        var gl = this._gl | 0
        var hl = this._hl | 0

        for (var i = 0; i < 32; i += 2) {
          W[i] = M.readInt32BE(i * 4)
          W[i + 1] = M.readInt32BE(i * 4 + 4)
        }
        for (; i < 160; i += 2) {
          var xh = W[i - 15 * 2]
          var xl = W[i - 15 * 2 + 1]
          var gamma0 = Gamma0(xh, xl)
          var gamma0l = Gamma0l(xl, xh)

          xh = W[i - 2 * 2]
          xl = W[i - 2 * 2 + 1]
          var gamma1 = Gamma1(xh, xl)
          var gamma1l = Gamma1l(xl, xh)

          // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
          var Wi7h = W[i - 7 * 2]
          var Wi7l = W[i - 7 * 2 + 1]

          var Wi16h = W[i - 16 * 2]
          var Wi16l = W[i - 16 * 2 + 1]

          var Wil = (gamma0l + Wi7l) | 0
          var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
          Wil = (Wil + gamma1l) | 0
          Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
          Wil = (Wil + Wi16l) | 0
          Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0

          W[i] = Wih
          W[i + 1] = Wil
        }

        for (var j = 0; j < 160; j += 2) {
          Wih = W[j]
          Wil = W[j + 1]

          var majh = maj(ah, bh, ch)
          var majl = maj(al, bl, cl)

          var sigma0h = sigma0(ah, al)
          var sigma0l = sigma0(al, ah)
          var sigma1h = sigma1(eh, el)
          var sigma1l = sigma1(el, eh)

          // t1 = h + sigma1 + ch + K[j] + W[j]
          var Kih = K[j]
          var Kil = K[j + 1]

          var chh = Ch(eh, fh, gh)
          var chl = Ch(el, fl, gl)

          var t1l = (hl + sigma1l) | 0
          var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
          t1l = (t1l + chl) | 0
          t1h = (t1h + chh + getCarry(t1l, chl)) | 0
          t1l = (t1l + Kil) | 0
          t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
          t1l = (t1l + Wil) | 0
          t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0

          // t2 = sigma0 + maj
          var t2l = (sigma0l + majl) | 0
          var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0

          hh = gh
          hl = gl
          gh = fh
          gl = fl
          fh = eh
          fl = el
          el = (dl + t1l) | 0
          eh = (dh + t1h + getCarry(el, dl)) | 0
          dh = ch
          dl = cl
          ch = bh
          cl = bl
          bh = ah
          bl = al
          al = (t1l + t2l) | 0
          ah = (t1h + t2h + getCarry(al, t1l)) | 0
        }

        this._al = (this._al + al) | 0
        this._bl = (this._bl + bl) | 0
        this._cl = (this._cl + cl) | 0
        this._dl = (this._dl + dl) | 0
        this._el = (this._el + el) | 0
        this._fl = (this._fl + fl) | 0
        this._gl = (this._gl + gl) | 0
        this._hl = (this._hl + hl) | 0

        this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
        this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
        this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
        this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
        this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
        this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
        this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
        this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
      }

      Sha512.prototype._hash = function () {
        var H = Buffer.allocUnsafe(64)

        function writeInt64BE(h, l, offset) {
          H.writeInt32BE(h, offset)
          H.writeInt32BE(l, offset + 4)
        }

        writeInt64BE(this._ah, this._al, 0)
        writeInt64BE(this._bh, this._bl, 8)
        writeInt64BE(this._ch, this._cl, 16)
        writeInt64BE(this._dh, this._dl, 24)
        writeInt64BE(this._eh, this._el, 32)
        writeInt64BE(this._fh, this._fl, 40)
        writeInt64BE(this._gh, this._gl, 48)
        writeInt64BE(this._hh, this._hl, 56)

        return H
      }

      module.exports = Sha512

    }, { "./hash": 134, "inherits": 109, "safe-buffer": 133 }], 142: [function (require, module, exports) {
      // Copyright Joyent, Inc. and other Node contributors.
      //
      // Permission is hereby granted, free of charge, to any person obtaining a
      // copy of this software and associated documentation files (the
      // "Software"), to deal in the Software without restriction, including
      // without limitation the rights to use, copy, modify, merge, publish,
      // distribute, sublicense, and/or sell copies of the Software, and to permit
      // persons to whom the Software is furnished to do so, subject to the
      // following conditions:
      //
      // The above copyright notice and this permission notice shall be included
      // in all copies or substantial portions of the Software.
      //
      // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
      // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
      // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
      // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
      // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
      // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
      // USE OR OTHER DEALINGS IN THE SOFTWARE.

      'use strict';

      /*<replacement>*/

      var Buffer = require('safe-buffer').Buffer;
      /*</replacement>*/

      var isEncoding = Buffer.isEncoding || function (encoding) {
        encoding = '' + encoding;
        switch (encoding && encoding.toLowerCase()) {
          case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw':
            return true;
          default:
            return false;
        }
      };

      function _normalizeEncoding(enc) {
        if (!enc) return 'utf8';
        var retried;
        while (true) {
          switch (enc) {
            case 'utf8':
            case 'utf-8':
              return 'utf8';
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
              return 'utf16le';
            case 'latin1':
            case 'binary':
              return 'latin1';
            case 'base64':
            case 'ascii':
            case 'hex':
              return enc;
            default:
              if (retried) return; // undefined
              enc = ('' + enc).toLowerCase();
              retried = true;
          }
        }
      };

      // Do not cache `Buffer.isEncoding` when checking encoding names as some
      // modules monkey-patch it to support additional encodings
      function normalizeEncoding(enc) {
        var nenc = _normalizeEncoding(enc);
        if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
        return nenc || enc;
      }

      // StringDecoder provides an interface for efficiently splitting a series of
      // buffers into a series of JS strings without breaking apart multi-byte
      // characters.
      exports.StringDecoder = StringDecoder;
      function StringDecoder(encoding) {
        this.encoding = normalizeEncoding(encoding);
        var nb;
        switch (this.encoding) {
          case 'utf16le':
            this.text = utf16Text;
            this.end = utf16End;
            nb = 4;
            break;
          case 'utf8':
            this.fillLast = utf8FillLast;
            nb = 4;
            break;
          case 'base64':
            this.text = base64Text;
            this.end = base64End;
            nb = 3;
            break;
          default:
            this.write = simpleWrite;
            this.end = simpleEnd;
            return;
        }
        this.lastNeed = 0;
        this.lastTotal = 0;
        this.lastChar = Buffer.allocUnsafe(nb);
      }

      StringDecoder.prototype.write = function (buf) {
        if (buf.length === 0) return '';
        var r;
        var i;
        if (this.lastNeed) {
          r = this.fillLast(buf);
          if (r === undefined) return '';
          i = this.lastNeed;
          this.lastNeed = 0;
        } else {
          i = 0;
        }
        if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
        return r || '';
      };

      StringDecoder.prototype.end = utf8End;

      // Returns only complete characters in a Buffer
      StringDecoder.prototype.text = utf8Text;

      // Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
      StringDecoder.prototype.fillLast = function (buf) {
        if (this.lastNeed <= buf.length) {
          buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
          return this.lastChar.toString(this.encoding, 0, this.lastTotal);
        }
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
        this.lastNeed -= buf.length;
      };

      // Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
      // continuation byte. If an invalid byte is detected, -2 is returned.
      function utf8CheckByte(byte) {
        if (byte <= 0x7F) return 0; else if (byte >> 5 === 0x06) return 2; else if (byte >> 4 === 0x0E) return 3; else if (byte >> 3 === 0x1E) return 4;
        return byte >> 6 === 0x02 ? -1 : -2;
      }

      // Checks at most 3 bytes at the end of a Buffer in order to detect an
      // incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
      // needed to complete the UTF-8 character (if applicable) are returned.
      function utf8CheckIncomplete(self, buf, i) {
        var j = buf.length - 1;
        if (j < i) return 0;
        var nb = utf8CheckByte(buf[j]);
        if (nb >= 0) {
          if (nb > 0) self.lastNeed = nb - 1;
          return nb;
        }
        if (--j < i || nb === -2) return 0;
        nb = utf8CheckByte(buf[j]);
        if (nb >= 0) {
          if (nb > 0) self.lastNeed = nb - 2;
          return nb;
        }
        if (--j < i || nb === -2) return 0;
        nb = utf8CheckByte(buf[j]);
        if (nb >= 0) {
          if (nb > 0) {
            if (nb === 2) nb = 0; else self.lastNeed = nb - 3;
          }
          return nb;
        }
        return 0;
      }

      // Validates as many continuation bytes for a multi-byte UTF-8 character as
      // needed or are available. If we see a non-continuation byte where we expect
      // one, we "replace" the validated continuation bytes we've seen so far with
      // a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
      // behavior. The continuation byte check is included three times in the case
      // where all of the continuation bytes for a character exist in the same buffer.
      // It is also done this way as a slight performance increase instead of using a
      // loop.
      function utf8CheckExtraBytes(self, buf, p) {
        if ((buf[0] & 0xC0) !== 0x80) {
          self.lastNeed = 0;
          return '\ufffd';
        }
        if (self.lastNeed > 1 && buf.length > 1) {
          if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
          }
          if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
              self.lastNeed = 2;
              return '\ufffd';
            }
          }
        }
      }

      // Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
      function utf8FillLast(buf) {
        var p = this.lastTotal - this.lastNeed;
        var r = utf8CheckExtraBytes(this, buf, p);
        if (r !== undefined) return r;
        if (this.lastNeed <= buf.length) {
          buf.copy(this.lastChar, p, 0, this.lastNeed);
          return this.lastChar.toString(this.encoding, 0, this.lastTotal);
        }
        buf.copy(this.lastChar, p, 0, buf.length);
        this.lastNeed -= buf.length;
      }

      // Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
      // partial character, the character's bytes are buffered until the required
      // number of bytes are available.
      function utf8Text(buf, i) {
        var total = utf8CheckIncomplete(this, buf, i);
        if (!this.lastNeed) return buf.toString('utf8', i);
        this.lastTotal = total;
        var end = buf.length - (total - this.lastNeed);
        buf.copy(this.lastChar, 0, end);
        return buf.toString('utf8', i, end);
      }

      // For UTF-8, a replacement character is added when ending on a partial
      // character.
      function utf8End(buf) {
        var r = buf && buf.length ? this.write(buf) : '';
        if (this.lastNeed) return r + '\ufffd';
        return r;
      }

      // UTF-16LE typically needs two bytes per character, but even if we have an even
      // number of bytes available, we need to check if we end on a leading/high
      // surrogate. In that case, we need to wait for the next two bytes in order to
      // decode the last character properly.
      function utf16Text(buf, i) {
        if ((buf.length - i) % 2 === 0) {
          var r = buf.toString('utf16le', i);
          if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
              this.lastNeed = 2;
              this.lastTotal = 4;
              this.lastChar[0] = buf[buf.length - 2];
              this.lastChar[1] = buf[buf.length - 1];
              return r.slice(0, -1);
            }
          }
          return r;
        }
        this.lastNeed = 1;
        this.lastTotal = 2;
        this.lastChar[0] = buf[buf.length - 1];
        return buf.toString('utf16le', i, buf.length - 1);
      }

      // For UTF-16LE we do not explicitly append special replacement characters if we
      // end on a partial character, we simply let v8 handle that.
      function utf16End(buf) {
        var r = buf && buf.length ? this.write(buf) : '';
        if (this.lastNeed) {
          var end = this.lastTotal - this.lastNeed;
          return r + this.lastChar.toString('utf16le', 0, end);
        }
        return r;
      }

      function base64Text(buf, i) {
        var n = (buf.length - i) % 3;
        if (n === 0) return buf.toString('base64', i);
        this.lastNeed = 3 - n;
        this.lastTotal = 3;
        if (n === 1) {
          this.lastChar[0] = buf[buf.length - 1];
        } else {
          this.lastChar[0] = buf[buf.length - 2];
          this.lastChar[1] = buf[buf.length - 1];
        }
        return buf.toString('base64', i, buf.length - n);
      }

      function base64End(buf) {
        var r = buf && buf.length ? this.write(buf) : '';
        if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
        return r;
      }

      // Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
      function simpleWrite(buf) {
        return buf.toString(this.encoding);
      }

      function simpleEnd(buf) {
        return buf && buf.length ? this.write(buf) : '';
      }
    }, { "safe-buffer": 133 }], 143: [function (require, module, exports) {
      var native = require('./native')

      function getTypeName(fn) {
        return fn.name || fn.toString().match(/function (.*?)\s*\(/)[1]
      }

      function getValueTypeName(value) {
        return native.Nil(value) ? '' : getTypeName(value.constructor)
      }

      function getValue(value) {
        if (native.Function(value)) return ''
        if (native.String(value)) return JSON.stringify(value)
        if (value && native.Object(value)) return ''
        return value
      }

      function captureStackTrace(e, t) {
        if (Error.captureStackTrace) {
          Error.captureStackTrace(e, t)
        }
      }

      function tfJSON(type) {
        if (native.Function(type)) return type.toJSON ? type.toJSON() : getTypeName(type)
        if (native.Array(type)) return 'Array'
        if (type && native.Object(type)) return 'Object'

        return type !== undefined ? type : ''
      }

      function tfErrorString(type, value, valueTypeName) {
        var valueJson = getValue(value)

        return 'Expected ' + tfJSON(type) + ', got' +
          (valueTypeName !== '' ? ' ' + valueTypeName : '') +
          (valueJson !== '' ? ' ' + valueJson : '')
      }

      function TfTypeError(type, value, valueTypeName) {
        valueTypeName = valueTypeName || getValueTypeName(value)
        this.message = tfErrorString(type, value, valueTypeName)

        captureStackTrace(this, TfTypeError)
        this.__type = type
        this.__value = value
        this.__valueTypeName = valueTypeName
      }

      TfTypeError.prototype = Object.create(Error.prototype)
      TfTypeError.prototype.constructor = TfTypeError

      function tfPropertyErrorString(type, label, name, value, valueTypeName) {
        var description = '" of type '
        if (label === 'key') description = '" with key type '

        return tfErrorString('property "' + tfJSON(name) + description + tfJSON(type), value, valueTypeName)
      }

      function TfPropertyTypeError(type, property, label, value, valueTypeName) {
        if (type) {
          valueTypeName = valueTypeName || getValueTypeName(value)
          this.message = tfPropertyErrorString(type, label, property, value, valueTypeName)
        } else {
          this.message = 'Unexpected property "' + property + '"'
        }

        captureStackTrace(this, TfTypeError)
        this.__label = label
        this.__property = property
        this.__type = type
        this.__value = value
        this.__valueTypeName = valueTypeName
      }

      TfPropertyTypeError.prototype = Object.create(Error.prototype)
      TfPropertyTypeError.prototype.constructor = TfTypeError

      function tfCustomError(expected, actual) {
        return new TfTypeError(expected, {}, actual)
      }

      function tfSubError(e, property, label) {
        // sub child?
        if (e instanceof TfPropertyTypeError) {
          property = property + '.' + e.__property

          e = new TfPropertyTypeError(
            e.__type, property, e.__label, e.__value, e.__valueTypeName
          )

          // child?
        } else if (e instanceof TfTypeError) {
          e = new TfPropertyTypeError(
            e.__type, property, label, e.__value, e.__valueTypeName
          )
        }

        captureStackTrace(e)
        return e
      }

      module.exports = {
        TfTypeError: TfTypeError,
        TfPropertyTypeError: TfPropertyTypeError,
        tfCustomError: tfCustomError,
        tfSubError: tfSubError,
        tfJSON: tfJSON,
        getValueTypeName: getValueTypeName
      }

    }, { "./native": 146 }], 144: [function (require, module, exports) {
      (function (Buffer) {
        (function () {
          var NATIVE = require('./native')
          var ERRORS = require('./errors')

          function _Buffer(value) {
            return Buffer.isBuffer(value)
          }

          function Hex(value) {
            return typeof value === 'string' && /^([0-9a-f]{2})+$/i.test(value)
          }

          function _LengthN(type, length) {
            var name = type.toJSON()

            function Length(value) {
              if (!type(value)) return false
              if (value.length === length) return true

              throw ERRORS.tfCustomError(name + '(Length: ' + length + ')', name + '(Length: ' + value.length + ')')
            }
            Length.toJSON = function () { return name }

            return Length
          }

          var _ArrayN = _LengthN.bind(null, NATIVE.Array)
          var _BufferN = _LengthN.bind(null, _Buffer)
          var _HexN = _LengthN.bind(null, Hex)
          var _StringN = _LengthN.bind(null, NATIVE.String)

          function Range(a, b, f) {
            f = f || NATIVE.Number
            function _range(value, strict) {
              return f(value, strict) && (value > a) && (value < b)
            }
            _range.toJSON = function () {
              return `${f.toJSON()} between [${a}, ${b}]`
            }
            return _range
          }

          var INT53_MAX = Math.pow(2, 53) - 1

          function Finite(value) {
            return typeof value === 'number' && isFinite(value)
          }
          function Int8(value) { return ((value << 24) >> 24) === value }
          function Int16(value) { return ((value << 16) >> 16) === value }
          function Int32(value) { return (value | 0) === value }
          function Int53(value) {
            return typeof value === 'number' &&
              value >= -INT53_MAX &&
              value <= INT53_MAX &&
              Math.floor(value) === value
          }
          function UInt8(value) { return (value & 0xff) === value }
          function UInt16(value) { return (value & 0xffff) === value }
          function UInt32(value) { return (value >>> 0) === value }
          function UInt53(value) {
            return typeof value === 'number' &&
              value >= 0 &&
              value <= INT53_MAX &&
              Math.floor(value) === value
          }

          var types = {
            ArrayN: _ArrayN,
            Buffer: _Buffer,
            BufferN: _BufferN,
            Finite: Finite,
            Hex: Hex,
            HexN: _HexN,
            Int8: Int8,
            Int16: Int16,
            Int32: Int32,
            Int53: Int53,
            Range: Range,
            StringN: _StringN,
            UInt8: UInt8,
            UInt16: UInt16,
            UInt32: UInt32,
            UInt53: UInt53
          }

          for (var typeName in types) {
            types[typeName].toJSON = function (t) {
              return t
            }.bind(null, typeName)
          }

          module.exports = types

        }).call(this)
      }).call(this, { "isBuffer": require("../../../../../../usr/lib/node_modules/browserify/node_modules/is-buffer/index.js") })
    }, { "../../../../../../usr/lib/node_modules/browserify/node_modules/is-buffer/index.js": 286, "./errors": 143, "./native": 146 }], 145: [function (require, module, exports) {
      var ERRORS = require('./errors')
      var NATIVE = require('./native')

      // short-hand
      var tfJSON = ERRORS.tfJSON
      var TfTypeError = ERRORS.TfTypeError
      var TfPropertyTypeError = ERRORS.TfPropertyTypeError
      var tfSubError = ERRORS.tfSubError
      var getValueTypeName = ERRORS.getValueTypeName

      var TYPES = {
        arrayOf: function arrayOf(type, options) {
          type = compile(type)
          options = options || {}

          function _arrayOf(array, strict) {
            if (!NATIVE.Array(array)) return false
            if (NATIVE.Nil(array)) return false
            if (options.minLength !== undefined && array.length < options.minLength) return false
            if (options.maxLength !== undefined && array.length > options.maxLength) return false
            if (options.length !== undefined && array.length !== options.length) return false

            return array.every(function (value, i) {
              try {
                return typeforce(type, value, strict)
              } catch (e) {
                throw tfSubError(e, i)
              }
            })
          }
          _arrayOf.toJSON = function () {
            var str = '[' + tfJSON(type) + ']'
            if (options.length !== undefined) {
              str += '{' + options.length + '}'
            } else if (options.minLength !== undefined || options.maxLength !== undefined) {
              str += '{' +
                (options.minLength === undefined ? 0 : options.minLength) + ',' +
                (options.maxLength === undefined ? Infinity : options.maxLength) + '}'
            }
            return str
          }

          return _arrayOf
        },

        maybe: function maybe(type) {
          type = compile(type)

          function _maybe(value, strict) {
            return NATIVE.Nil(value) || type(value, strict, maybe)
          }
          _maybe.toJSON = function () { return '?' + tfJSON(type) }

          return _maybe
        },

        map: function map(propertyType, propertyKeyType) {
          propertyType = compile(propertyType)
          if (propertyKeyType) propertyKeyType = compile(propertyKeyType)

          function _map(value, strict) {
            if (!NATIVE.Object(value)) return false
            if (NATIVE.Nil(value)) return false

            for (var propertyName in value) {
              try {
                if (propertyKeyType) {
                  typeforce(propertyKeyType, propertyName, strict)
                }
              } catch (e) {
                throw tfSubError(e, propertyName, 'key')
              }

              try {
                var propertyValue = value[propertyName]
                typeforce(propertyType, propertyValue, strict)
              } catch (e) {
                throw tfSubError(e, propertyName)
              }
            }

            return true
          }

          if (propertyKeyType) {
            _map.toJSON = function () {
              return '{' + tfJSON(propertyKeyType) + ': ' + tfJSON(propertyType) + '}'
            }
          } else {
            _map.toJSON = function () { return '{' + tfJSON(propertyType) + '}' }
          }

          return _map
        },

        object: function object(uncompiled) {
          var type = {}

          for (var typePropertyName in uncompiled) {
            type[typePropertyName] = compile(uncompiled[typePropertyName])
          }

          function _object(value, strict) {
            if (!NATIVE.Object(value)) return false
            if (NATIVE.Nil(value)) return false

            var propertyName

            try {
              for (propertyName in type) {
                var propertyType = type[propertyName]
                var propertyValue = value[propertyName]

                typeforce(propertyType, propertyValue, strict)
              }
            } catch (e) {
              throw tfSubError(e, propertyName)
            }

            if (strict) {
              for (propertyName in value) {
                if (type[propertyName]) continue

                throw new TfPropertyTypeError(undefined, propertyName)
              }
            }

            return true
          }
          _object.toJSON = function () { return tfJSON(type) }

          return _object
        },

        anyOf: function anyOf() {
          var types = [].slice.call(arguments).map(compile)

          function _anyOf(value, strict) {
            return types.some(function (type) {
              try {
                return typeforce(type, value, strict)
              } catch (e) {
                return false
              }
            })
          }
          _anyOf.toJSON = function () { return types.map(tfJSON).join('|') }

          return _anyOf
        },

        allOf: function allOf() {
          var types = [].slice.call(arguments).map(compile)

          function _allOf(value, strict) {
            return types.every(function (type) {
              try {
                return typeforce(type, value, strict)
              } catch (e) {
                return false
              }
            })
          }
          _allOf.toJSON = function () { return types.map(tfJSON).join(' & ') }

          return _allOf
        },

        quacksLike: function quacksLike(type) {
          function _quacksLike(value) {
            return type === getValueTypeName(value)
          }
          _quacksLike.toJSON = function () { return type }

          return _quacksLike
        },

        tuple: function tuple() {
          var types = [].slice.call(arguments).map(compile)

          function _tuple(values, strict) {
            if (NATIVE.Nil(values)) return false
            if (NATIVE.Nil(values.length)) return false
            if (strict && (values.length !== types.length)) return false

            return types.every(function (type, i) {
              try {
                return typeforce(type, values[i], strict)
              } catch (e) {
                throw tfSubError(e, i)
              }
            })
          }
          _tuple.toJSON = function () { return '(' + types.map(tfJSON).join(', ') + ')' }

          return _tuple
        },

        value: function value(expected) {
          function _value(actual) {
            return actual === expected
          }
          _value.toJSON = function () { return expected }

          return _value
        }
      }

      // TODO: deprecate
      TYPES.oneOf = TYPES.anyOf

      function compile(type) {
        if (NATIVE.String(type)) {
          if (type[0] === '?') return TYPES.maybe(type.slice(1))

          return NATIVE[type] || TYPES.quacksLike(type)
        } else if (type && NATIVE.Object(type)) {
          if (NATIVE.Array(type)) {
            if (type.length !== 1) throw new TypeError('Expected compile() parameter of type Array of length 1')
            return TYPES.arrayOf(type[0])
          }

          return TYPES.object(type)
        } else if (NATIVE.Function(type)) {
          return type
        }

        return TYPES.value(type)
      }

      function typeforce(type, value, strict, surrogate) {
        if (NATIVE.Function(type)) {
          if (type(value, strict)) return true

          throw new TfTypeError(surrogate || type, value)
        }

        // JIT
        return typeforce(compile(type), value, strict)
      }

      // assign types to typeforce function
      for (var typeName in NATIVE) {
        typeforce[typeName] = NATIVE[typeName]
      }

      for (typeName in TYPES) {
        typeforce[typeName] = TYPES[typeName]
      }

      var EXTRA = require('./extra')
      for (typeName in EXTRA) {
        typeforce[typeName] = EXTRA[typeName]
      }

      typeforce.compile = compile
      typeforce.TfTypeError = TfTypeError
      typeforce.TfPropertyTypeError = TfPropertyTypeError

      module.exports = typeforce

    }, { "./errors": 143, "./extra": 144, "./native": 146 }], 146: [function (require, module, exports) {
      var types = {
        Array: function (value) { return value !== null && value !== undefined && value.constructor === Array },
        Boolean: function (value) { return typeof value === 'boolean' },
        Function: function (value) { return typeof value === 'function' },
        Nil: function (value) { return value === undefined || value === null },
        Number: function (value) { return typeof value === 'number' },
        Object: function (value) { return typeof value === 'object' },
        String: function (value) { return typeof value === 'string' },
        '': function () { return true }
      }

      // TODO: deprecate
      types.Null = types.Nil

      for (var typeName in types) {
        types[typeName].toJSON = function (t) {
          return t
        }.bind(null, typeName)
      }

      module.exports = types

    }, {}], 147: [function (require, module, exports) {
      (function (global) {
        (function () {

          /**
           * Module exports.
           */

          module.exports = deprecate;

          /**
           * Mark that a method should not be used.
           * Returns a modified function which warns once by default.
           *
           * If `localStorage.noDeprecation = true` is set, then it is a no-op.
           *
           * If `localStorage.throwDeprecation = true` is set, then deprecated functions
           * will throw an Error when invoked.
           *
           * If `localStorage.traceDeprecation = true` is set, then deprecated functions
           * will invoke `console.trace()` instead of `console.error()`.
           *
           * @param {Function} fn - the function to deprecate
           * @param {String} msg - the string to print to the console when `fn` is invoked
           * @returns {Function} a new "deprecated" version of `fn`
           * @api public
           */

          function deprecate(fn, msg) {
            if (config('noDeprecation')) {
              return fn;
            }

            var warned = false;
            function deprecated() {
              if (!warned) {
                if (config('throwDeprecation')) {
                  throw new Error(msg);
                } else if (config('traceDeprecation')) {
                  console.trace(msg);
                } else {
                  console.warn(msg);
                }
                warned = true;
              }
              return fn.apply(this, arguments);
            }

            return deprecated;
          }

          /**
           * Checks `localStorage` for boolean values for the given `name`.
           *
           * @param {String} name
           * @returns {Boolean}
           * @api private
           */

          function config(name) {
            // accessing global.localStorage can trigger a DOMException in sandboxed iframes
            try {
              if (!global.localStorage) return false;
            } catch (_) {
              return false;
            }
            var val = global.localStorage[name];
            if (null == val) return false;
            return String(val).toLowerCase() === 'true';
          }

        }).call(this)
      }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
    }, {}], 148: [function (require, module, exports) {
      'use strict'
      var Buffer = require('safe-buffer').Buffer

      // Number.MAX_SAFE_INTEGER
      var MAX_SAFE_INTEGER = 9007199254740991

      function checkUInt53(n) {
        if (n < 0 || n > MAX_SAFE_INTEGER || n % 1 !== 0) throw new RangeError('value out of range')
      }

      function encode(number, buffer, offset) {
        checkUInt53(number)

        if (!buffer) buffer = Buffer.allocUnsafe(encodingLength(number))
        if (!Buffer.isBuffer(buffer)) throw new TypeError('buffer must be a Buffer instance')
        if (!offset) offset = 0

        // 8 bit
        if (number < 0xfd) {
          buffer.writeUInt8(number, offset)
          encode.bytes = 1

          // 16 bit
        } else if (number <= 0xffff) {
          buffer.writeUInt8(0xfd, offset)
          buffer.writeUInt16LE(number, offset + 1)
          encode.bytes = 3

          // 32 bit
        } else if (number <= 0xffffffff) {
          buffer.writeUInt8(0xfe, offset)
          buffer.writeUInt32LE(number, offset + 1)
          encode.bytes = 5

          // 64 bit
        } else {
          buffer.writeUInt8(0xff, offset)
          buffer.writeUInt32LE(number >>> 0, offset + 1)
          buffer.writeUInt32LE((number / 0x100000000) | 0, offset + 5)
          encode.bytes = 9
        }

        return buffer
      }

      function decode(buffer, offset) {
        if (!Buffer.isBuffer(buffer)) throw new TypeError('buffer must be a Buffer instance')
        if (!offset) offset = 0

        var first = buffer.readUInt8(offset)

        // 8 bit
        if (first < 0xfd) {
          decode.bytes = 1
          return first

          // 16 bit
        } else if (first === 0xfd) {
          decode.bytes = 3
          return buffer.readUInt16LE(offset + 1)

          // 32 bit
        } else if (first === 0xfe) {
          decode.bytes = 5
          return buffer.readUInt32LE(offset + 1)

          // 64 bit
        } else {
          decode.bytes = 9
          var lo = buffer.readUInt32LE(offset + 1)
          var hi = buffer.readUInt32LE(offset + 5)
          var number = hi * 0x0100000000 + lo
          checkUInt53(number)

          return number
        }
      }

      function encodingLength(number) {
        checkUInt53(number)

        return (
          number < 0xfd ? 1
            : number <= 0xffff ? 3
              : number <= 0xffffffff ? 5
                : 9
        )
      }

      module.exports = { encode: encode, decode: decode, encodingLength: encodingLength }

    }, { "safe-buffer": 133 }], 149: [function (require, module, exports) {
      (function (Buffer) {
        (function () {
          var bs58check = require('bs58check')

          function decodeRaw(buffer, version) {
            // check version only if defined
            if (version !== undefined && buffer[0] !== version) throw new Error('Invalid network version')

            // uncompressed
            if (buffer.length === 33) {
              return {
                version: buffer[0],
                privateKey: buffer.slice(1, 33),
                compressed: false
              }
            }

            // invalid length
            if (buffer.length !== 34) throw new Error('Invalid WIF length')

            // invalid compression flag
            if (buffer[33] !== 0x01) throw new Error('Invalid compression flag')

            return {
              version: buffer[0],
              privateKey: buffer.slice(1, 33),
              compressed: true
            }
          }

          function encodeRaw(version, privateKey, compressed) {
            var result = new Buffer(compressed ? 34 : 33)

            result.writeUInt8(version, 0)
            privateKey.copy(result, 1)

            if (compressed) {
              result[33] = 0x01
            }

            return result
          }

          function decode(string, version) {
            return decodeRaw(bs58check.decode(string), version)
          }

          function encode(version, privateKey, compressed) {
            if (typeof version === 'number') return bs58check.encode(encodeRaw(version, privateKey, compressed))

            return bs58check.encode(
              encodeRaw(
                version.version,
                version.privateKey,
                version.compressed
              )
            )
          }

          module.exports = {
            decode: decode,
            decodeRaw: decodeRaw,
            encode: encode,
            encodeRaw: encodeRaw
          }

        }).call(this)
      }).call(this, require("buffer").Buffer)
    }, { "bs58check": 68, "buffer": 216 }], 150: [function (require, module, exports) {
      'use strict';

      const asn1 = exports;

      asn1.bignum = require('bn.js');

      asn1.define = require('./asn1/api').define;
      asn1.base = require('./asn1/base');
      asn1.constants = require('./asn1/constants');
      asn1.decoders = require('./asn1/decoders');
      asn1.encoders = require('./asn1/encoders');

    }, { "./asn1/api": 151, "./asn1/base": 153, "./asn1/constants": 157, "./asn1/decoders": 159, "./asn1/encoders": 162, "bn.js": 164 }], 151: [function (require, module, exports) {
      'use strict';

      const encoders = require('./encoders');
      const decoders = require('./decoders');
      const inherits = require('inherits');

      const api = exports;

      api.define = function define(name, body) {
        return new Entity(name, body);
      };

      function Entity(name, body) {
        this.name = name;
        this.body = body;

        this.decoders = {};
        this.encoders = {};
      }

      Entity.prototype._createNamed = function createNamed(Base) {
        const name = this.name;

        function Generated(entity) {
          this._initNamed(entity, name);
        }
        inherits(Generated, Base);
        Generated.prototype._initNamed = function _initNamed(entity, name) {
          Base.call(this, entity, name);
        };

        return new Generated(this);
      };

      Entity.prototype._getDecoder = function _getDecoder(enc) {
        enc = enc || 'der';
        // Lazily create decoder
        if (!this.decoders.hasOwnProperty(enc))
          this.decoders[enc] = this._createNamed(decoders[enc]);
        return this.decoders[enc];
      };

      Entity.prototype.decode = function decode(data, enc, options) {
        return this._getDecoder(enc).decode(data, options);
      };

      Entity.prototype._getEncoder = function _getEncoder(enc) {
        enc = enc || 'der';
        // Lazily create encoder
        if (!this.encoders.hasOwnProperty(enc))
          this.encoders[enc] = this._createNamed(encoders[enc]);
        return this.encoders[enc];
      };

      Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
        return this._getEncoder(enc).encode(data, reporter);
      };

    }, { "./decoders": 159, "./encoders": 162, "inherits": 285 }], 152: [function (require, module, exports) {
      'use strict';

      const inherits = require('inherits');
      const Reporter = require('../base/reporter').Reporter;
      const Buffer = require('safer-buffer').Buffer;

      function DecoderBuffer(base, options) {
        Reporter.call(this, options);
        if (!Buffer.isBuffer(base)) {
          this.error('Input not Buffer');
          return;
        }

        this.base = base;
        this.offset = 0;
        this.length = base.length;
      }
      inherits(DecoderBuffer, Reporter);
      exports.DecoderBuffer = DecoderBuffer;

      DecoderBuffer.isDecoderBuffer = function isDecoderBuffer(data) {
        if (data instanceof DecoderBuffer) {
          return true;
        }

        // Or accept compatible API
        const isCompatible = typeof data === 'object' &&
          Buffer.isBuffer(data.base) &&
          data.constructor.name === 'DecoderBuffer' &&
          typeof data.offset === 'number' &&
          typeof data.length === 'number' &&
          typeof data.save === 'function' &&
          typeof data.restore === 'function' &&
          typeof data.isEmpty === 'function' &&
          typeof data.readUInt8 === 'function' &&
          typeof data.skip === 'function' &&
          typeof data.raw === 'function';

        return isCompatible;
      };

      DecoderBuffer.prototype.save = function save() {
        return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
      };

      DecoderBuffer.prototype.restore = function restore(save) {
        // Return skipped data
        const res = new DecoderBuffer(this.base);
        res.offset = save.offset;
        res.length = this.offset;

        this.offset = save.offset;
        Reporter.prototype.restore.call(this, save.reporter);

        return res;
      };

      DecoderBuffer.prototype.isEmpty = function isEmpty() {
        return this.offset === this.length;
      };

      DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
        if (this.offset + 1 <= this.length)
          return this.base.readUInt8(this.offset++, true);
        else
          return this.error(fail || 'DecoderBuffer overrun');
      };

      DecoderBuffer.prototype.skip = function skip(bytes, fail) {
        if (!(this.offset + bytes <= this.length))
          return this.error(fail || 'DecoderBuffer overrun');

        const res = new DecoderBuffer(this.base);

        // Share reporter state
        res._reporterState = this._reporterState;

        res.offset = this.offset;
        res.length = this.offset + bytes;
        this.offset += bytes;
        return res;
      };

      DecoderBuffer.prototype.raw = function raw(save) {
        return this.base.slice(save ? save.offset : this.offset, this.length);
      };

      function EncoderBuffer(value, reporter) {
        if (Array.isArray(value)) {
          this.length = 0;
          this.value = value.map(function (item) {
            if (!EncoderBuffer.isEncoderBuffer(item))
              item = new EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
          }, this);
        } else if (typeof value === 'number') {
          if (!(0 <= value && value <= 0xff))
            return reporter.error('non-byte EncoderBuffer value');
          this.value = value;
          this.length = 1;
        } else if (typeof value === 'string') {
          this.value = value;
          this.length = Buffer.byteLength(value);
        } else if (Buffer.isBuffer(value)) {
          this.value = value;
          this.length = value.length;
        } else {
          return reporter.error('Unsupported type: ' + typeof value);
        }
      }
      exports.EncoderBuffer = EncoderBuffer;

      EncoderBuffer.isEncoderBuffer = function isEncoderBuffer(data) {
        if (data instanceof EncoderBuffer) {
          return true;
        }

        // Or accept compatible API
        const isCompatible = typeof data === 'object' &&
          data.constructor.name === 'EncoderBuffer' &&
          typeof data.length === 'number' &&
          typeof data.join === 'function';

        return isCompatible;
      };

      EncoderBuffer.prototype.join = function join(out, offset) {
        if (!out)
          out = Buffer.alloc(this.length);
        if (!offset)
          offset = 0;

        if (this.length === 0)
          return out;

        if (Array.isArray(this.value)) {
          this.value.forEach(function (item) {
            item.join(out, offset);
            offset += item.length;
          });
        } else {
          if (typeof this.value === 'number')
            out[offset] = this.value;
          else if (typeof this.value === 'string')
            out.write(this.value, offset);
          else if (Buffer.isBuffer(this.value))
            this.value.copy(out, offset);
          offset += this.length;
        }

        return out;
      };

    }, { "../base/reporter": 155, "inherits": 285, "safer-buffer": 316 }], 153: [function (require, module, exports) {
      'use strict';

      const base = exports;

      base.Reporter = require('./reporter').Reporter;
      base.DecoderBuffer = require('./buffer').DecoderBuffer;
      base.EncoderBuffer = require('./buffer').EncoderBuffer;
      base.Node = require('./node');

    }, { "./buffer": 152, "./node": 154, "./reporter": 155 }], 154: [function (require, module, exports) {
      'use strict';

      const Reporter = require('../base/reporter').Reporter;
      const EncoderBuffer = require('../base/buffer').EncoderBuffer;
      const DecoderBuffer = require('../base/buffer').DecoderBuffer;
      const assert = require('minimalistic-assert');

      // Supported tags
      const tags = [
        'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
        'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
        'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
        'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
      ];

      // Public methods list
      const methods = [
        'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
        'any', 'contains'
      ].concat(tags);

      // Overrided methods list
      const overrided = [
        '_peekTag', '_decodeTag', '_use',
        '_decodeStr', '_decodeObjid', '_decodeTime',
        '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

        '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
        '_encodeNull', '_encodeInt', '_encodeBool'
      ];

      function Node(enc, parent, name) {
        const state = {};
        this._baseState = state;

        state.name = name;
        state.enc = enc;

        state.parent = parent || null;
        state.children = null;

        // State
        state.tag = null;
        state.args = null;
        state.reverseArgs = null;
        state.choice = null;
        state.optional = false;
        state.any = false;
        state.obj = false;
        state.use = null;
        state.useDecoder = null;
        state.key = null;
        state['default'] = null;
        state.explicit = null;
        state.implicit = null;
        state.contains = null;

        // Should create new instance on each method
        if (!state.parent) {
          state.children = [];
          this._wrap();
        }
      }
      module.exports = Node;

      const stateProps = [
        'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
        'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
        'implicit', 'contains'
      ];

      Node.prototype.clone = function clone() {
        const state = this._baseState;
        const cstate = {};
        stateProps.forEach(function (prop) {
          cstate[prop] = state[prop];
        });
        const res = new this.constructor(cstate.parent);
        res._baseState = cstate;
        return res;
      };

      Node.prototype._wrap = function wrap() {
        const state = this._baseState;
        methods.forEach(function (method) {
          this[method] = function _wrappedMethod() {
            const clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
          };
        }, this);
      };

      Node.prototype._init = function init(body) {
        const state = this._baseState;

        assert(state.parent === null);
        body.call(this);

        // Filter children
        state.children = state.children.filter(function (child) {
          return child._baseState.parent === this;
        }, this);
        assert.equal(state.children.length, 1, 'Root node can have only one child');
      };

      Node.prototype._useArgs = function useArgs(args) {
        const state = this._baseState;

        // Filter children and args
        const children = args.filter(function (arg) {
          return arg instanceof this.constructor;
        }, this);
        args = args.filter(function (arg) {
          return !(arg instanceof this.constructor);
        }, this);

        if (children.length !== 0) {
          assert(state.children === null);
          state.children = children;

          // Replace parent to maintain backward link
          children.forEach(function (child) {
            child._baseState.parent = this;
          }, this);
        }
        if (args.length !== 0) {
          assert(state.args === null);
          state.args = args;
          state.reverseArgs = args.map(function (arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object)
              return arg;

            const res = {};
            Object.keys(arg).forEach(function (key) {
              if (key == (key | 0))
                key |= 0;
              const value = arg[key];
              res[value] = key;
            });
            return res;
          });
        }
      };

      //
      // Overrided methods
      //

      overrided.forEach(function (method) {
        Node.prototype[method] = function _overrided() {
          const state = this._baseState;
          throw new Error(method + ' not implemented for encoding: ' + state.enc);
        };
      });

      //
      // Public methods
      //

      tags.forEach(function (tag) {
        Node.prototype[tag] = function _tagMethod() {
          const state = this._baseState;
          const args = Array.prototype.slice.call(arguments);

          assert(state.tag === null);
          state.tag = tag;

          this._useArgs(args);

          return this;
        };
      });

      Node.prototype.use = function use(item) {
        assert(item);
        const state = this._baseState;

        assert(state.use === null);
        state.use = item;

        return this;
      };

      Node.prototype.optional = function optional() {
        const state = this._baseState;

        state.optional = true;

        return this;
      };

      Node.prototype.def = function def(val) {
        const state = this._baseState;

        assert(state['default'] === null);
        state['default'] = val;
        state.optional = true;

        return this;
      };

      Node.prototype.explicit = function explicit(num) {
        const state = this._baseState;

        assert(state.explicit === null && state.implicit === null);
        state.explicit = num;

        return this;
      };

      Node.prototype.implicit = function implicit(num) {
        const state = this._baseState;

        assert(state.explicit === null && state.implicit === null);
        state.implicit = num;

        return this;
      };

      Node.prototype.obj = function obj() {
        const state = this._baseState;
        const args = Array.prototype.slice.call(arguments);

        state.obj = true;

        if (args.length !== 0)
          this._useArgs(args);

        return this;
      };

      Node.prototype.key = function key(newKey) {
        const state = this._baseState;

        assert(state.key === null);
        state.key = newKey;

        return this;
      };

      Node.prototype.any = function any() {
        const state = this._baseState;

        state.any = true;

        return this;
      };

      Node.prototype.choice = function choice(obj) {
        const state = this._baseState;

        assert(state.choice === null);
        state.choice = obj;
        this._useArgs(Object.keys(obj).map(function (key) {
          return obj[key];
        }));

        return this;
      };

      Node.prototype.contains = function contains(item) {
        const state = this._baseState;

        assert(state.use === null);
        state.contains = item;

        return this;
      };

      //
      // Decoding
      //

      Node.prototype._decode = function decode(input, options) {
        const state = this._baseState;

        // Decode root node
        if (state.parent === null)
          return input.wrapResult(state.children[0]._decode(input, options));

        let result = state['default'];
        let present = true;

        let prevKey = null;
        if (state.key !== null)
          prevKey = input.enterKey(state.key);

        // Check if tag is there
        if (state.optional) {
          let tag = null;
          if (state.explicit !== null)
            tag = state.explicit;
          else if (state.implicit !== null)
            tag = state.implicit;
          else if (state.tag !== null)
            tag = state.tag;

          if (tag === null && !state.any) {
            // Trial and Error
            const save = input.save();
            try {
              if (state.choice === null)
                this._decodeGeneric(state.tag, input, options);
              else
                this._decodeChoice(input, options);
              present = true;
            } catch (e) {
              present = false;
            }
            input.restore(save);
          } else {
            present = this._peekTag(input, tag, state.any);

            if (input.isError(present))
              return present;
          }
        }

        // Push object on stack
        let prevObj;
        if (state.obj && present)
          prevObj = input.enterObject();

        if (present) {
          // Unwrap explicit values
          if (state.explicit !== null) {
            const explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit))
              return explicit;
            input = explicit;
          }

          const start = input.offset;

          // Unwrap implicit and normal values
          if (state.use === null && state.choice === null) {
            let save;
            if (state.any)
              save = input.save();
            const body = this._decodeTag(
              input,
              state.implicit !== null ? state.implicit : state.tag,
              state.any
            );
            if (input.isError(body))
              return body;

            if (state.any)
              result = input.raw(save);
            else
              input = body;
          }

          if (options && options.track && state.tag !== null)
            options.track(input.path(), start, input.length, 'tagged');

          if (options && options.track && state.tag !== null)
            options.track(input.path(), input.offset, input.length, 'content');

          // Select proper method for tag
          if (state.any) {
            // no-op
          } else if (state.choice === null) {
            result = this._decodeGeneric(state.tag, input, options);
          } else {
            result = this._decodeChoice(input, options);
          }

          if (input.isError(result))
            return result;

          // Decode children
          if (!state.any && state.choice === null && state.children !== null) {
            state.children.forEach(function decodeChildren(child) {
              // NOTE: We are ignoring errors here, to let parser continue with other
              // parts of encoded data
              child._decode(input, options);
            });
          }

          // Decode contained/encoded by schema, only in bit or octet strings
          if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            const data = new DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)
              ._decode(data, options);
          }
        }

        // Pop object
        if (state.obj && present)
          result = input.leaveObject(prevObj);

        // Set key
        if (state.key !== null && (result !== null || present === true))
          input.leaveKey(prevKey, state.key, result);
        else if (prevKey !== null)
          input.exitKey(prevKey);

        return result;
      };

      Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
        const state = this._baseState;

        if (tag === 'seq' || tag === 'set')
          return null;
        if (tag === 'seqof' || tag === 'setof')
          return this._decodeList(input, tag, state.args[0], options);
        else if (/str$/.test(tag))
          return this._decodeStr(input, tag, options);
        else if (tag === 'objid' && state.args)
          return this._decodeObjid(input, state.args[0], state.args[1], options);
        else if (tag === 'objid')
          return this._decodeObjid(input, null, null, options);
        else if (tag === 'gentime' || tag === 'utctime')
          return this._decodeTime(input, tag, options);
        else if (tag === 'null_')
          return this._decodeNull(input, options);
        else if (tag === 'bool')
          return this._decodeBool(input, options);
        else if (tag === 'objDesc')
          return this._decodeStr(input, tag, options);
        else if (tag === 'int' || tag === 'enum')
          return this._decodeInt(input, state.args && state.args[0], options);

        if (state.use !== null) {
          return this._getUse(state.use, input._reporterState.obj)
            ._decode(input, options);
        } else {
          return input.error('unknown tag: ' + tag);
        }
      };

      Node.prototype._getUse = function _getUse(entity, obj) {

        const state = this._baseState;
        // Create altered use decoder if implicit is set
        state.useDecoder = this._use(entity, obj);
        assert(state.useDecoder._baseState.parent === null);
        state.useDecoder = state.useDecoder._baseState.children[0];
        if (state.implicit !== state.useDecoder._baseState.implicit) {
          state.useDecoder = state.useDecoder.clone();
          state.useDecoder._baseState.implicit = state.implicit;
        }
        return state.useDecoder;
      };

      Node.prototype._decodeChoice = function decodeChoice(input, options) {
        const state = this._baseState;
        let result = null;
        let match = false;

        Object.keys(state.choice).some(function (key) {
          const save = input.save();
          const node = state.choice[key];
          try {
            const value = node._decode(input, options);
            if (input.isError(value))
              return false;

            result = { type: key, value: value };
            match = true;
          } catch (e) {
            input.restore(save);
            return false;
          }
          return true;
        }, this);

        if (!match)
          return input.error('Choice not matched');

        return result;
      };

      //
      // Encoding
      //

      Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
        return new EncoderBuffer(data, this.reporter);
      };

      Node.prototype._encode = function encode(data, reporter, parent) {
        const state = this._baseState;
        if (state['default'] !== null && state['default'] === data)
          return;

        const result = this._encodeValue(data, reporter, parent);
        if (result === undefined)
          return;

        if (this._skipDefault(result, reporter, parent))
          return;

        return result;
      };

      Node.prototype._encodeValue = function encode(data, reporter, parent) {
        const state = this._baseState;

        // Decode root node
        if (state.parent === null)
          return state.children[0]._encode(data, reporter || new Reporter());

        let result = null;

        // Set reporter to share it with a child class
        this.reporter = reporter;

        // Check if data is there
        if (state.optional && data === undefined) {
          if (state['default'] !== null)
            data = state['default'];
          else
            return;
        }

        // Encode children first
        let content = null;
        let primitive = false;
        if (state.any) {
          // Anything that was given is translated to buffer
          result = this._createEncoderBuffer(data);
        } else if (state.choice) {
          result = this._encodeChoice(data, reporter);
        } else if (state.contains) {
          content = this._getUse(state.contains, parent)._encode(data, reporter);
          primitive = true;
        } else if (state.children) {
          content = state.children.map(function (child) {
            if (child._baseState.tag === 'null_')
              return child._encode(null, reporter, data);

            if (child._baseState.key === null)
              return reporter.error('Child should have a key');
            const prevKey = reporter.enterKey(child._baseState.key);

            if (typeof data !== 'object')
              return reporter.error('Child expected, but input is not object');

            const res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);

            return res;
          }, this).filter(function (child) {
            return child;
          });
          content = this._createEncoderBuffer(content);
        } else {
          if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1))
              return reporter.error('Too many args for : ' + state.tag);

            if (!Array.isArray(data))
              return reporter.error('seqof/setof, but data is not Array');

            const child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function (item) {
              const state = this._baseState;

              return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
          } else if (state.use !== null) {
            result = this._getUse(state.use, parent)._encode(data, reporter);
          } else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
          }
        }

        // Encode data itself
        if (!state.any && state.choice === null) {
          const tag = state.implicit !== null ? state.implicit : state.tag;
          const cls = state.implicit === null ? 'universal' : 'context';

          if (tag === null) {
            if (state.use === null)
              reporter.error('Tag could be omitted only for .use()');
          } else {
            if (state.use === null)
              result = this._encodeComposite(tag, primitive, cls, content);
          }
        }

        // Wrap in explicit
        if (state.explicit !== null)
          result = this._encodeComposite(state.explicit, false, 'context', result);

        return result;
      };

      Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
        const state = this._baseState;

        const node = state.choice[data.type];
        if (!node) {
          assert(
            false,
            data.type + ' not found in ' +
            JSON.stringify(Object.keys(state.choice)));
        }
        return node._encode(data.value, reporter);
      };

      Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
        const state = this._baseState;

        if (/str$/.test(tag))
          return this._encodeStr(data, tag);
        else if (tag === 'objid' && state.args)
          return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
        else if (tag === 'objid')
          return this._encodeObjid(data, null, null);
        else if (tag === 'gentime' || tag === 'utctime')
          return this._encodeTime(data, tag);
        else if (tag === 'null_')
          return this._encodeNull();
        else if (tag === 'int' || tag === 'enum')
          return this._encodeInt(data, state.args && state.reverseArgs[0]);
        else if (tag === 'bool')
          return this._encodeBool(data);
        else if (tag === 'objDesc')
          return this._encodeStr(data, tag);
        else
          throw new Error('Unsupported tag: ' + tag);
      };

      Node.prototype._isNumstr = function isNumstr(str) {
        return /^[0-9 ]*$/.test(str);
      };

      Node.prototype._isPrintstr = function isPrintstr(str) {
        return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(str);
      };

    }, { "../base/buffer": 152, "../base/reporter": 155, "minimalistic-assert": 290 }], 155: [function (require, module, exports) {
      'use strict';

      const inherits = require('inherits');

      function Reporter(options) {
        this._reporterState = {
          obj: null,
          path: [],
          options: options || {},
          errors: []
        };
      }
      exports.Reporter = Reporter;

      Reporter.prototype.isError = function isError(obj) {
        return obj instanceof ReporterError;
      };

      Reporter.prototype.save = function save() {
        const state = this._reporterState;

        return { obj: state.obj, pathLen: state.path.length };
      };

      Reporter.prototype.restore = function restore(data) {
        const state = this._reporterState;

        state.obj = data.obj;
        state.path = state.path.slice(0, data.pathLen);
      };

      Reporter.prototype.enterKey = function enterKey(key) {
        return this._reporterState.path.push(key);
      };

      Reporter.prototype.exitKey = function exitKey(index) {
        const state = this._reporterState;

        state.path = state.path.slice(0, index - 1);
      };

      Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
        const state = this._reporterState;

        this.exitKey(index);
        if (state.obj !== null)
          state.obj[key] = value;
      };

      Reporter.prototype.path = function path() {
        return this._reporterState.path.join('/');
      };

      Reporter.prototype.enterObject = function enterObject() {
        const state = this._reporterState;

        const prev = state.obj;
        state.obj = {};
        return prev;
      };

      Reporter.prototype.leaveObject = function leaveObject(prev) {
        const state = this._reporterState;

        const now = state.obj;
        state.obj = prev;
        return now;
      };

      Reporter.prototype.error = function error(msg) {
        let err;
        const state = this._reporterState;

        const inherited = msg instanceof ReporterError;
        if (inherited) {
          err = msg;
        } else {
          err = new ReporterError(state.path.map(function (elem) {
            return '[' + JSON.stringify(elem) + ']';
          }).join(''), msg.message || msg, msg.stack);
        }

        if (!state.options.partial)
          throw err;

        if (!inherited)
          state.errors.push(err);

        return err;
      };

      Reporter.prototype.wrapResult = function wrapResult(result) {
        const state = this._reporterState;
        if (!state.options.partial)
          return result;

        return {
          result: this.isError(result) ? null : result,
          errors: state.errors
        };
      };

      function ReporterError(path, msg) {
        this.path = path;
        this.rethrow(msg);
      }
      inherits(ReporterError, Error);

      ReporterError.prototype.rethrow = function rethrow(msg) {
        this.message = msg + ' at: ' + (this.path || '(shallow)');
        if (Error.captureStackTrace)
          Error.captureStackTrace(this, ReporterError);

        if (!this.stack) {
          try {
            // IE only adds stack when thrown
            throw new Error(this.message);
          } catch (e) {
            this.stack = e.stack;
          }
        }
        return this;
      };

    }, { "inherits": 285 }], 156: [function (require, module, exports) {
      'use strict';

      // Helper
      function reverse(map) {
        const res = {};

        Object.keys(map).forEach(function (key) {
          // Convert key to integer if it is stringified
          if ((key | 0) == key)
            key = key | 0;

          const value = map[key];
          res[value] = key;
        });

        return res;
      }

      exports.tagClass = {
        0: 'universal',
        1: 'application',
        2: 'context',
        3: 'private'
      };
      exports.tagClassByName = reverse(exports.tagClass);

      exports.tag = {
        0x00: 'end',
        0x01: 'bool',
        0x02: 'int',
        0x03: 'bitstr',
        0x04: 'octstr',
        0x05: 'null_',
        0x06: 'objid',
        0x07: 'objDesc',
        0x08: 'external',
        0x09: 'real',
        0x0a: 'enum',
        0x0b: 'embed',
        0x0c: 'utf8str',
        0x0d: 'relativeOid',
        0x10: 'seq',
        0x11: 'set',
        0x12: 'numstr',
        0x13: 'printstr',
        0x14: 't61str',
        0x15: 'videostr',
        0x16: 'ia5str',
        0x17: 'utctime',
        0x18: 'gentime',
        0x19: 'graphstr',
        0x1a: 'iso646str',
        0x1b: 'genstr',
        0x1c: 'unistr',
        0x1d: 'charstr',
        0x1e: 'bmpstr'
      };
      exports.tagByName = reverse(exports.tag);

    }, {}], 157: [function (require, module, exports) {
      'use strict';

      const constants = exports;

      // Helper
      constants._reverse = function reverse(map) {
        const res = {};

        Object.keys(map).forEach(function (key) {
          // Convert key to integer if it is stringified
          if ((key | 0) == key)
            key = key | 0;

          const value = map[key];
          res[value] = key;
        });

        return res;
      };

      constants.der = require('./der');

    }, { "./der": 156 }], 158: [function (require, module, exports) {
      'use strict';

      const inherits = require('inherits');

      const bignum = require('bn.js');
      const DecoderBuffer = require('../base/buffer').DecoderBuffer;
      const Node = require('../base/node');

      // Import DER constants
      const der = require('../constants/der');

      function DERDecoder(entity) {
        this.enc = 'der';
        this.name = entity.name;
        this.entity = entity;

        // Construct base tree
        this.tree = new DERNode();
        this.tree._init(entity.body);
      }
      module.exports = DERDecoder;

      DERDecoder.prototype.decode = function decode(data, options) {
        if (!DecoderBuffer.isDecoderBuffer(data)) {
          data = new DecoderBuffer(data, options);
        }

        return this.tree._decode(data, options);
      };

      // Tree methods

      function DERNode(parent) {
        Node.call(this, 'der', parent);
      }
      inherits(DERNode, Node);

      DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
        if (buffer.isEmpty())
          return false;

        const state = buffer.save();
        const decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
        if (buffer.isError(decodedTag))
          return decodedTag;

        buffer.restore(state);

        return decodedTag.tag === tag || decodedTag.tagStr === tag ||
          (decodedTag.tagStr + 'of') === tag || any;
      };

      DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
        const decodedTag = derDecodeTag(buffer,
          'Failed to decode tag of "' + tag + '"');
        if (buffer.isError(decodedTag))
          return decodedTag;

        let len = derDecodeLen(buffer,
          decodedTag.primitive,
          'Failed to get length of "' + tag + '"');

        // Failure
        if (buffer.isError(len))
          return len;

        if (!any &&
          decodedTag.tag !== tag &&
          decodedTag.tagStr !== tag &&
          decodedTag.tagStr + 'of' !== tag) {
          return buffer.error('Failed to match tag: "' + tag + '"');
        }

        if (decodedTag.primitive || len !== null)
          return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

        // Indefinite length... find END tag
        const state = buffer.save();
        const res = this._skipUntilEnd(
          buffer,
          'Failed to skip indefinite length body: "' + this.tag + '"');
        if (buffer.isError(res))
          return res;

        len = buffer.offset - state.offset;
        buffer.restore(state);
        return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
      };

      DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
        for (; ;) {
          const tag = derDecodeTag(buffer, fail);
          if (buffer.isError(tag))
            return tag;
          const len = derDecodeLen(buffer, tag.primitive, fail);
          if (buffer.isError(len))
            return len;

          let res;
          if (tag.primitive || len !== null)
            res = buffer.skip(len);
          else
            res = this._skipUntilEnd(buffer, fail);

          // Failure
          if (buffer.isError(res))
            return res;

          if (tag.tagStr === 'end')
            break;
        }
      };

      DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
        options) {
        const result = [];
        while (!buffer.isEmpty()) {
          const possibleEnd = this._peekTag(buffer, 'end');
          if (buffer.isError(possibleEnd))
            return possibleEnd;

          const res = decoder.decode(buffer, 'der', options);
          if (buffer.isError(res) && possibleEnd)
            break;
          result.push(res);
        }
        return result;
      };

      DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
        if (tag === 'bitstr') {
          const unused = buffer.readUInt8();
          if (buffer.isError(unused))
            return unused;
          return { unused: unused, data: buffer.raw() };
        } else if (tag === 'bmpstr') {
          const raw = buffer.raw();
          if (raw.length % 2 === 1)
            return buffer.error('Decoding of string type: bmpstr length mismatch');

          let str = '';
          for (let i = 0; i < raw.length / 2; i++) {
            str += String.fromCharCode(raw.readUInt16BE(i * 2));
          }
          return str;
        } else if (tag === 'numstr') {
          const numstr = buffer.raw().toString('ascii');
          if (!this._isNumstr(numstr)) {
            return buffer.error('Decoding of string type: ' +
              'numstr unsupported characters');
          }
          return numstr;
        } else if (tag === 'octstr') {
          return buffer.raw();
        } else if (tag === 'objDesc') {
          return buffer.raw();
        } else if (tag === 'printstr') {
          const printstr = buffer.raw().toString('ascii');
          if (!this._isPrintstr(printstr)) {
            return buffer.error('Decoding of string type: ' +
              'printstr unsupported characters');
          }
          return printstr;
        } else if (/str$/.test(tag)) {
          return buffer.raw().toString();
        } else {
          return buffer.error('Decoding of string type: ' + tag + ' unsupported');
        }
      };

      DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
        let result;
        const identifiers = [];
        let ident = 0;
        let subident = 0;
        while (!buffer.isEmpty()) {
          subident = buffer.readUInt8();
          ident <<= 7;
          ident |= subident & 0x7f;
          if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
          }
        }
        if (subident & 0x80)
          identifiers.push(ident);

        const first = (identifiers[0] / 40) | 0;
        const second = identifiers[0] % 40;

        if (relative)
          result = identifiers;
        else
          result = [first, second].concat(identifiers.slice(1));

        if (values) {
          let tmp = values[result.join(' ')];
          if (tmp === undefined)
            tmp = values[result.join('.')];
          if (tmp !== undefined)
            result = tmp;
        }

        return result;
      };

      DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
        const str = buffer.raw().toString();

        let year;
        let mon;
        let day;
        let hour;
        let min;
        let sec;
        if (tag === 'gentime') {
          year = str.slice(0, 4) | 0;
          mon = str.slice(4, 6) | 0;
          day = str.slice(6, 8) | 0;
          hour = str.slice(8, 10) | 0;
          min = str.slice(10, 12) | 0;
          sec = str.slice(12, 14) | 0;
        } else if (tag === 'utctime') {
          year = str.slice(0, 2) | 0;
          mon = str.slice(2, 4) | 0;
          day = str.slice(4, 6) | 0;
          hour = str.slice(6, 8) | 0;
          min = str.slice(8, 10) | 0;
          sec = str.slice(10, 12) | 0;
          if (year < 70)
            year = 2000 + year;
          else
            year = 1900 + year;
        } else {
          return buffer.error('Decoding ' + tag + ' time is not supported yet');
        }

        return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
      };

      DERNode.prototype._decodeNull = function decodeNull() {
        return null;
      };

      DERNode.prototype._decodeBool = function decodeBool(buffer) {
        const res = buffer.readUInt8();
        if (buffer.isError(res))
          return res;
        else
          return res !== 0;
      };

      DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
        // Bigint, return as it is (assume big endian)
        const raw = buffer.raw();
        let res = new bignum(raw);

        if (values)
          res = values[res.toString(10)] || res;

        return res;
      };

      DERNode.prototype._use = function use(entity, obj) {
        if (typeof entity === 'function')
          entity = entity(obj);
        return entity._getDecoder('der').tree;
      };

      // Utility methods

      function derDecodeTag(buf, fail) {
        let tag = buf.readUInt8(fail);
        if (buf.isError(tag))
          return tag;

        const cls = der.tagClass[tag >> 6];
        const primitive = (tag & 0x20) === 0;

        // Multi-octet tag - load
        if ((tag & 0x1f) === 0x1f) {
          let oct = tag;
          tag = 0;
          while ((oct & 0x80) === 0x80) {
            oct = buf.readUInt8(fail);
            if (buf.isError(oct))
              return oct;

            tag <<= 7;
            tag |= oct & 0x7f;
          }
        } else {
          tag &= 0x1f;
        }
        const tagStr = der.tag[tag];

        return {
          cls: cls,
          primitive: primitive,
          tag: tag,
          tagStr: tagStr
        };
      }

      function derDecodeLen(buf, primitive, fail) {
        let len = buf.readUInt8(fail);
        if (buf.isError(len))
          return len;

        // Indefinite form
        if (!primitive && len === 0x80)
          return null;

        // Definite form
        if ((len & 0x80) === 0) {
          // Short form
          return len;
        }

        // Long form
        const num = len & 0x7f;
        if (num > 4)
          return buf.error('length octect is too long');

        len = 0;
        for (let i = 0; i < num; i++) {
          len <<= 8;
          const j = buf.readUInt8(fail);
          if (buf.isError(j))
            return j;
          len |= j;
        }

        return len;
      }

    }, { "../base/buffer": 152, "../base/node": 154, "../constants/der": 156, "bn.js": 164, "inherits": 285 }], 159: [function (require, module, exports) {
      'use strict';

      const decoders = exports;

      decoders.der = require('./der');
      decoders.pem = require('./pem');

    }, { "./der": 158, "./pem": 160 }], 160: [function (require, module, exports) {
      'use strict';

      const inherits = require('inherits');
      const Buffer = require('safer-buffer').Buffer;

      const DERDecoder = require('./der');

      function PEMDecoder(entity) {
        DERDecoder.call(this, entity);
        this.enc = 'pem';
      }
      inherits(PEMDecoder, DERDecoder);
      module.exports = PEMDecoder;

      PEMDecoder.prototype.decode = function decode(data, options) {
        const lines = data.toString().split(/[\r\n]+/g);

        const label = options.label.toUpperCase();

        const re = /^-----(BEGIN|END) ([^-]+)-----$/;
        let start = -1;
        let end = -1;
        for (let i = 0; i < lines.length; i++) {
          const match = lines[i].match(re);
          if (match === null)
            continue;

          if (match[2] !== label)
            continue;

          if (start === -1) {
            if (match[1] !== 'BEGIN')
              break;
            start = i;
          } else {
            if (match[1] !== 'END')
              break;
            end = i;
            break;
          }
        }
        if (start === -1 || end === -1)
          throw new Error('PEM section not found for: ' + label);

        const base64 = lines.slice(start + 1, end).join('');
        // Remove excessive symbols
        base64.replace(/[^a-z0-9+/=]+/gi, '');

        const input = Buffer.from(base64, 'base64');
        return DERDecoder.prototype.decode.call(this, input, options);
      };

    }, { "./der": 158, "inherits": 285, "safer-buffer": 316 }], 161: [function (require, module, exports) {
      'use strict';

      const inherits = require('inherits');
      const Buffer = require('safer-buffer').Buffer;
      const Node = require('../base/node');

      // Import DER constants
      const der = require('../constants/der');

      function DEREncoder(entity) {
        this.enc = 'der';
        this.name = entity.name;
        this.entity = entity;

        // Construct base tree
        this.tree = new DERNode();
        this.tree._init(entity.body);
      }
      module.exports = DEREncoder;

      DEREncoder.prototype.encode = function encode(data, reporter) {
        return this.tree._encode(data, reporter).join();
      };

      // Tree methods

      function DERNode(parent) {
        Node.call(this, 'der', parent);
      }
      inherits(DERNode, Node);

      DERNode.prototype._encodeComposite = function encodeComposite(tag,
        primitive,
        cls,
        content) {
        const encodedTag = encodeTag(tag, primitive, cls, this.reporter);

        // Short form
        if (content.length < 0x80) {
          const header = Buffer.alloc(2);
          header[0] = encodedTag;
          header[1] = content.length;
          return this._createEncoderBuffer([header, content]);
        }

        // Long form
        // Count octets required to store length
        let lenOctets = 1;
        for (let i = content.length; i >= 0x100; i >>= 8)
          lenOctets++;

        const header = Buffer.alloc(1 + 1 + lenOctets);
        header[0] = encodedTag;
        header[1] = 0x80 | lenOctets;

        for (let i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
          header[i] = j & 0xff;

        return this._createEncoderBuffer([header, content]);
      };

      DERNode.prototype._encodeStr = function encodeStr(str, tag) {
        if (tag === 'bitstr') {
          return this._createEncoderBuffer([str.unused | 0, str.data]);
        } else if (tag === 'bmpstr') {
          const buf = Buffer.alloc(str.length * 2);
          for (let i = 0; i < str.length; i++) {
            buf.writeUInt16BE(str.charCodeAt(i), i * 2);
          }
          return this._createEncoderBuffer(buf);
        } else if (tag === 'numstr') {
          if (!this._isNumstr(str)) {
            return this.reporter.error('Encoding of string type: numstr supports ' +
              'only digits and space');
          }
          return this._createEncoderBuffer(str);
        } else if (tag === 'printstr') {
          if (!this._isPrintstr(str)) {
            return this.reporter.error('Encoding of string type: printstr supports ' +
              'only latin upper and lower case letters, ' +
              'digits, space, apostrophe, left and rigth ' +
              'parenthesis, plus sign, comma, hyphen, ' +
              'dot, slash, colon, equal sign, ' +
              'question mark');
          }
          return this._createEncoderBuffer(str);
        } else if (/str$/.test(tag)) {
          return this._createEncoderBuffer(str);
        } else if (tag === 'objDesc') {
          return this._createEncoderBuffer(str);
        } else {
          return this.reporter.error('Encoding of string type: ' + tag +
            ' unsupported');
        }
      };

      DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
        if (typeof id === 'string') {
          if (!values)
            return this.reporter.error('string objid given, but no values map found');
          if (!values.hasOwnProperty(id))
            return this.reporter.error('objid not found in values map');
          id = values[id].split(/[\s.]+/g);
          for (let i = 0; i < id.length; i++)
            id[i] |= 0;
        } else if (Array.isArray(id)) {
          id = id.slice();
          for (let i = 0; i < id.length; i++)
            id[i] |= 0;
        }

        if (!Array.isArray(id)) {
          return this.reporter.error('objid() should be either array or string, ' +
            'got: ' + JSON.stringify(id));
        }

        if (!relative) {
          if (id[1] >= 40)
            return this.reporter.error('Second objid identifier OOB');
          id.splice(0, 2, id[0] * 40 + id[1]);
        }

        // Count number of octets
        let size = 0;
        for (let i = 0; i < id.length; i++) {
          let ident = id[i];
          for (size++; ident >= 0x80; ident >>= 7)
            size++;
        }

        const objid = Buffer.alloc(size);
        let offset = objid.length - 1;
        for (let i = id.length - 1; i >= 0; i--) {
          let ident = id[i];
          objid[offset--] = ident & 0x7f;
          while ((ident >>= 7) > 0)
            objid[offset--] = 0x80 | (ident & 0x7f);
        }

        return this._createEncoderBuffer(objid);
      };

      function two(num) {
        if (num < 10)
          return '0' + num;
        else
          return num;
      }

      DERNode.prototype._encodeTime = function encodeTime(time, tag) {
        let str;
        const date = new Date(time);

        if (tag === 'gentime') {
          str = [
            two(date.getUTCFullYear()),
            two(date.getUTCMonth() + 1),
            two(date.getUTCDate()),
            two(date.getUTCHours()),
            two(date.getUTCMinutes()),
            two(date.getUTCSeconds()),
            'Z'
          ].join('');
        } else if (tag === 'utctime') {
          str = [
            two(date.getUTCFullYear() % 100),
            two(date.getUTCMonth() + 1),
            two(date.getUTCDate()),
            two(date.getUTCHours()),
            two(date.getUTCMinutes()),
            two(date.getUTCSeconds()),
            'Z'
          ].join('');
        } else {
          this.reporter.error('Encoding ' + tag + ' time is not supported yet');
        }

        return this._encodeStr(str, 'octstr');
      };

      DERNode.prototype._encodeNull = function encodeNull() {
        return this._createEncoderBuffer('');
      };

      DERNode.prototype._encodeInt = function encodeInt(num, values) {
        if (typeof num === 'string') {
          if (!values)
            return this.reporter.error('String int or enum given, but no values map');
          if (!values.hasOwnProperty(num)) {
            return this.reporter.error('Values map doesn\'t contain: ' +
              JSON.stringify(num));
          }
          num = values[num];
        }

        // Bignum, assume big endian
        if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
          const numArray = num.toArray();
          if (!num.sign && numArray[0] & 0x80) {
            numArray.unshift(0);
          }
          num = Buffer.from(numArray);
        }

        if (Buffer.isBuffer(num)) {
          let size = num.length;
          if (num.length === 0)
            size++;

          const out = Buffer.alloc(size);
          num.copy(out);
          if (num.length === 0)
            out[0] = 0;
          return this._createEncoderBuffer(out);
        }

        if (num < 0x80)
          return this._createEncoderBuffer(num);

        if (num < 0x100)
          return this._createEncoderBuffer([0, num]);

        let size = 1;
        for (let i = num; i >= 0x100; i >>= 8)
          size++;

        const out = new Array(size);
        for (let i = out.length - 1; i >= 0; i--) {
          out[i] = num & 0xff;
          num >>= 8;
        }
        if (out[0] & 0x80) {
          out.unshift(0);
        }

        return this._createEncoderBuffer(Buffer.from(out));
      };

      DERNode.prototype._encodeBool = function encodeBool(value) {
        return this._createEncoderBuffer(value ? 0xff : 0);
      };

      DERNode.prototype._use = function use(entity, obj) {
        if (typeof entity === 'function')
          entity = entity(obj);
        return entity._getEncoder('der').tree;
      };

      DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
        const state = this._baseState;
        let i;
        if (state['default'] === null)
          return false;

        const data = dataBuffer.join();
        if (state.defaultBuffer === undefined)
          state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

        if (data.length !== state.defaultBuffer.length)
          return false;

        for (i = 0; i < data.length; i++)
          if (data[i] !== state.defaultBuffer[i])
            return false;

        return true;
      };

      // Utility methods

      function encodeTag(tag, primitive, cls, reporter) {
        let res;

        if (tag === 'seqof')
          tag = 'seq';
        else if (tag === 'setof')
          tag = 'set';

        if (der.tagByName.hasOwnProperty(tag))
          res = der.tagByName[tag];
        else if (typeof tag === 'number' && (tag | 0) === tag)
          res = tag;
        else
          return reporter.error('Unknown tag: ' + tag);

        if (res >= 0x1f)
          return reporter.error('Multi-octet tag encoding unsupported');

        if (!primitive)
          res |= 0x20;

        res |= (der.tagClassByName[cls || 'universal'] << 6);

        return res;
      }

    }, { "../base/node": 154, "../constants/der": 156, "inherits": 285, "safer-buffer": 316 }], 162: [function (require, module, exports) {
      'use strict';

      const encoders = exports;

      encoders.der = require('./der');
      encoders.pem = require('./pem');

    }, { "./der": 161, "./pem": 163 }], 163: [function (require, module, exports) {
      'use strict';

      const inherits = require('inherits');

      const DEREncoder = require('./der');

      function PEMEncoder(entity) {
        DEREncoder.call(this, entity);
        this.enc = 'pem';
      }
      inherits(PEMEncoder, DEREncoder);
      module.exports = PEMEncoder;

      PEMEncoder.prototype.encode = function encode(data, options) {
        const buf = DEREncoder.prototype.encode.call(this, data);

        const p = buf.toString('base64');
        const out = ['-----BEGIN ' + options.label + '-----'];
        for (let i = 0; i < p.length; i += 64)
          out.push(p.slice(i, i + 64));
        out.push('-----END ' + options.label + '-----');
        return out.join('\n');
      };

    }, { "./der": 161, "inherits": 285 }], 164: [function (require, module, exports) {
      arguments[4][64][0].apply(exports, arguments)
    }, { "buffer": 172, "dup": 64 }], 165: [function (require, module, exports) {
      (function (global) {
        (function () {
          'use strict';

          var objectAssign = require('object-assign');

          // compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
          // original notice:

          /*!
           * The buffer module from node.js, for the browser.
           *
           * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
           * @license  MIT
           */
          function compare(a, b) {
            if (a === b) {
              return 0;
            }

            var x = a.length;
            var y = b.length;

            for (var i = 0, len = Math.min(x, y); i < len; ++i) {
              if (a[i] !== b[i]) {
                x = a[i];
                y = b[i];
                break;
              }
            }

            if (x < y) {
              return -1;
            }
            if (y < x) {
              return 1;
            }
            return 0;
          }
          function isBuffer(b) {
            if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
              return global.Buffer.isBuffer(b);
            }
            return !!(b != null && b._isBuffer);
          }

          // based on node assert, original notice:
          // NB: The URL to the CommonJS spec is kept just for tradition.
          //     node-assert has evolved a lot since then, both in API and behavior.

          // http://wiki.commonjs.org/wiki/Unit_Testing/1.0
          //
          // THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
          //
          // Originally from narwhal.js (http://narwhaljs.org)
          // Copyright (c) 2009 Thomas Robinson <280north.com>
          //
          // Permission is hereby granted, free of charge, to any person obtaining a copy
          // of this software and associated documentation files (the 'Software'), to
          // deal in the Software without restriction, including without limitation the
          // rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
          // sell copies of the Software, and to permit persons to whom the Software is
          // furnished to do so, subject to the following conditions:
          //
          // The above copyright notice and this permission notice shall be included in
          // all copies or substantial portions of the Software.
          //
          // THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
          // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
          // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
          // AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
          // ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
          // WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

          var util = require('util/');
          var hasOwn = Object.prototype.hasOwnProperty;
          var pSlice = Array.prototype.slice;
          var functionsHaveNames = (function () {
            return function foo() { }.name === 'foo';
          }());
          function pToString(obj) {
            return Object.prototype.toString.call(obj);
          }
          function isView(arrbuf) {
            if (isBuffer(arrbuf)) {
              return false;
            }
            if (typeof global.ArrayBuffer !== 'function') {
              return false;
            }
            if (typeof ArrayBuffer.isView === 'function') {
              return ArrayBuffer.isView(arrbuf);
            }
            if (!arrbuf) {
              return false;
            }
            if (arrbuf instanceof DataView) {
              return true;
            }
            if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
              return true;
            }
            return false;
          }
          // 1. The assert module provides functions that throw
          // AssertionError's when particular conditions are not met. The
          // assert module must conform to the following interface.

          var assert = module.exports = ok;

          // 2. The AssertionError is defined in assert.
          // new assert.AssertionError({ message: message,
          //                             actual: actual,
          //                             expected: expected })

          var regex = /\s*function\s+([^\(\s]*)\s*/;
          // based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
          function getName(func) {
            if (!util.isFunction(func)) {
              return;
            }
            if (functionsHaveNames) {
              return func.name;
            }
            var str = func.toString();
            var match = str.match(regex);
            return match && match[1];
          }
          assert.AssertionError = function AssertionError(options) {
            this.name = 'AssertionError';
            this.actual = options.actual;
            this.expected = options.expected;
            this.operator = options.operator;
            if (options.message) {
              this.message = options.message;
              this.generatedMessage = false;
            } else {
              this.message = getMessage(this);
              this.generatedMessage = true;
            }
            var stackStartFunction = options.stackStartFunction || fail;
            if (Error.captureStackTrace) {
              Error.captureStackTrace(this, stackStartFunction);
            } else {
              // non v8 browsers so we can have a stacktrace
              var err = new Error();
              if (err.stack) {
                var out = err.stack;

                // try to strip useless frames
                var fn_name = getName(stackStartFunction);
                var idx = out.indexOf('\n' + fn_name);
                if (idx >= 0) {
                  // once we have located the function frame
                  // we need to strip out everything before it (and its line)
                  var next_line = out.indexOf('\n', idx + 1);
                  out = out.substring(next_line + 1);
                }

                this.stack = out;
              }
            }
          };

          // assert.AssertionError instanceof Error
          util.inherits(assert.AssertionError, Error);

          function truncate(s, n) {
            if (typeof s === 'string') {
              return s.length < n ? s : s.slice(0, n);
            } else {
              return s;
            }
          }
          function inspect(something) {
            if (functionsHaveNames || !util.isFunction(something)) {
              return util.inspect(something);
            }
            var rawname = getName(something);
            var name = rawname ? ': ' + rawname : '';
            return '[Function' + name + ']';
          }
          function getMessage(self) {
            return truncate(inspect(self.actual), 128) + ' ' +
              self.operator + ' ' +
              truncate(inspect(self.expected), 128);
          }

          // At present only the three keys mentioned above are used and
          // understood by the spec. Implementations or sub modules can pass
          // other keys to the AssertionError's constructor - they will be
          // ignored.

          // 3. All of the following functions must throw an AssertionError
          // when a corresponding condition is not met, with a message that
          // may be undefined if not provided.  All assertion methods provide
          // both the actual and expected values to the assertion error for
          // display purposes.

          function fail(actual, expected, message, operator, stackStartFunction) {
            throw new assert.AssertionError({
              message: message,
              actual: actual,
              expected: expected,
              operator: operator,
              stackStartFunction: stackStartFunction
            });
          }

          // EXTENSION! allows for well behaved errors defined elsewhere.
          assert.fail = fail;

          // 4. Pure assertion tests whether a value is truthy, as determined
          // by !!guard.
          // assert.ok(guard, message_opt);
          // This statement is equivalent to assert.equal(true, !!guard,
          // message_opt);. To test strictly for the value true, use
          // assert.strictEqual(true, guard, message_opt);.

          function ok(value, message) {
            if (!value) fail(value, true, message, '==', assert.ok);
          }
          assert.ok = ok;

          // 5. The equality assertion tests shallow, coercive equality with
          // ==.
          // assert.equal(actual, expected, message_opt);

          assert.equal = function equal(actual, expected, message) {
            if (actual != expected) fail(actual, expected, message, '==', assert.equal);
          };

          // 6. The non-equality assertion tests for whether two objects are not equal
          // with != assert.notEqual(actual, expected, message_opt);

          assert.notEqual = function notEqual(actual, expected, message) {
            if (actual == expected) {
              fail(actual, expected, message, '!=', assert.notEqual);
            }
          };

          // 7. The equivalence assertion tests a deep equality relation.
          // assert.deepEqual(actual, expected, message_opt);

          assert.deepEqual = function deepEqual(actual, expected, message) {
            if (!_deepEqual(actual, expected, false)) {
              fail(actual, expected, message, 'deepEqual', assert.deepEqual);
            }
          };

          assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
            if (!_deepEqual(actual, expected, true)) {
              fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
            }
          };

          function _deepEqual(actual, expected, strict, memos) {
            // 7.1. All identical values are equivalent, as determined by ===.
            if (actual === expected) {
              return true;
            } else if (isBuffer(actual) && isBuffer(expected)) {
              return compare(actual, expected) === 0;

              // 7.2. If the expected value is a Date object, the actual value is
              // equivalent if it is also a Date object that refers to the same time.
            } else if (util.isDate(actual) && util.isDate(expected)) {
              return actual.getTime() === expected.getTime();

              // 7.3 If the expected value is a RegExp object, the actual value is
              // equivalent if it is also a RegExp object with the same source and
              // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
            } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
              return actual.source === expected.source &&
                actual.global === expected.global &&
                actual.multiline === expected.multiline &&
                actual.lastIndex === expected.lastIndex &&
                actual.ignoreCase === expected.ignoreCase;

              // 7.4. Other pairs that do not both pass typeof value == 'object',
              // equivalence is determined by ==.
            } else if ((actual === null || typeof actual !== 'object') &&
              (expected === null || typeof expected !== 'object')) {
              return strict ? actual === expected : actual == expected;

              // If both values are instances of typed arrays, wrap their underlying
              // ArrayBuffers in a Buffer each to increase performance
              // This optimization requires the arrays to have the same type as checked by
              // Object.prototype.toString (aka pToString). Never perform binary
              // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
              // bit patterns are not identical.
            } else if (isView(actual) && isView(expected) &&
              pToString(actual) === pToString(expected) &&
              !(actual instanceof Float32Array ||
                actual instanceof Float64Array)) {
              return compare(new Uint8Array(actual.buffer),
                new Uint8Array(expected.buffer)) === 0;

              // 7.5 For all other Object pairs, including Array objects, equivalence is
              // determined by having the same number of owned properties (as verified
              // with Object.prototype.hasOwnProperty.call), the same set of keys
              // (although not necessarily the same order), equivalent values for every
              // corresponding key, and an identical 'prototype' property. Note: this
              // accounts for both named and indexed properties on Arrays.
            } else if (isBuffer(actual) !== isBuffer(expected)) {
              return false;
            } else {
              memos = memos || { actual: [], expected: [] };

              var actualIndex = memos.actual.indexOf(actual);
              if (actualIndex !== -1) {
                if (actualIndex === memos.expected.indexOf(expected)) {
                  return true;
                }
              }

              memos.actual.push(actual);
              memos.expected.push(expected);

              return objEquiv(actual, expected, strict, memos);
            }
          }

          function isArguments(object) {
            return Object.prototype.toString.call(object) == '[object Arguments]';
          }

          function objEquiv(a, b, strict, actualVisitedObjects) {
            if (a === null || a === undefined || b === null || b === undefined)
              return false;
            // if one is a primitive, the other must be same
            if (util.isPrimitive(a) || util.isPrimitive(b))
              return a === b;
            if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
              return false;
            var aIsArgs = isArguments(a);
            var bIsArgs = isArguments(b);
            if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
              return false;
            if (aIsArgs) {
              a = pSlice.call(a);
              b = pSlice.call(b);
              return _deepEqual(a, b, strict);
            }
            var ka = objectKeys(a);
            var kb = objectKeys(b);
            var key, i;
            // having the same number of owned properties (keys incorporates
            // hasOwnProperty)
            if (ka.length !== kb.length)
              return false;
            //the same set of keys (although not necessarily the same order),
            ka.sort();
            kb.sort();
            //~~~cheap key test
            for (i = ka.length - 1; i >= 0; i--) {
              if (ka[i] !== kb[i])
                return false;
            }
            //equivalent values for every corresponding key, and
            //~~~possibly expensive deep test
            for (i = ka.length - 1; i >= 0; i--) {
              key = ka[i];
              if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
                return false;
            }
            return true;
          }

          // 8. The non-equivalence assertion tests for any deep inequality.
          // assert.notDeepEqual(actual, expected, message_opt);

          assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
            if (_deepEqual(actual, expected, false)) {
              fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
            }
          };

          assert.notDeepStrictEqual = notDeepStrictEqual;
          function notDeepStrictEqual(actual, expected, message) {
            if (_deepEqual(actual, expected, true)) {
              fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
            }
          }


          // 9. The strict equality assertion tests strict equality, as determined by ===.
          // assert.strictEqual(actual, expected, message_opt);

          assert.strictEqual = function strictEqual(actual, expected, message) {
            if (actual !== expected) {
              fail(actual, expected, message, '===', assert.strictEqual);
            }
          };

          // 10. The strict non-equality assertion tests for strict inequality, as
          // determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

          assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
            if (actual === expected) {
              fail(actual, expected, message, '!==', assert.notStrictEqual);
            }
          };

          function expectedException(actual, expected) {
            if (!actual || !expected) {
              return false;
            }

            if (Object.prototype.toString.call(expected) == '[object RegExp]') {
              return expected.test(actual);
            }

            try {
              if (actual instanceof expected) {
                return true;
              }
            } catch (e) {
              // Ignore.  The instanceof check doesn't work for arrow functions.
            }

            if (Error.isPrototypeOf(expected)) {
              return false;
            }

            return expected.call({}, actual) === true;
          }

          function _tryBlock(block) {
            var error;
            try {
              block();
            } catch (e) {
              error = e;
            }
            return error;
          }

          function _throws(shouldThrow, block, expected, message) {
            var actual;

            if (typeof block !== 'function') {
              throw new TypeError('"block" argument must be a function');
            }

            if (typeof expected === 'string') {
              message = expected;
              expected = null;
            }

            actual = _tryBlock(block);

            message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
              (message ? ' ' + message : '.');

            if (shouldThrow && !actual) {
              fail(actual, expected, 'Missing expected exception' + message);
            }

            var userProvidedMessage = typeof message === 'string';
            var isUnwantedException = !shouldThrow && util.isError(actual);
            var isUnexpectedException = !shouldThrow && actual && !expected;

            if ((isUnwantedException &&
              userProvidedMessage &&
              expectedException(actual, expected)) ||
              isUnexpectedException) {
              fail(actual, expected, 'Got unwanted exception' + message);
            }

            if ((shouldThrow && actual && expected &&
              !expectedException(actual, expected)) || (!shouldThrow && actual)) {
              throw actual;
            }
          }

          // 11. Expected to throw an error:
          // assert.throws(block, Error_opt, message_opt);

          assert.throws = function (block, /*optional*/error, /*optional*/message) {
            _throws(true, block, error, message);
          };

          // EXTENSION! This is annoying to write outside this module.
          assert.doesNotThrow = function (block, /*optional*/error, /*optional*/message) {
            _throws(false, block, error, message);
          };

          assert.ifError = function (err) { if (err) throw err; };

          // Expose a strict only variant of assert
          function strict(value, message) {
            if (!value) fail(value, true, message, '==', strict);
          }
          assert.strict = objectAssign(strict, assert, {
            equal: assert.strictEqual,
            deepEqual: assert.deepStrictEqual,
            notEqual: assert.notStrictEqual,
            notDeepEqual: assert.notDeepStrictEqual
          });
          assert.strict.strict = assert.strict;

          var objectKeys = Object.keys || function (obj) {
            var keys = [];
            for (var key in obj) {
              if (hasOwn.call(obj, key)) keys.push(key);
            }
            return keys;
          };

        }).call(this)
      }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
    }, { "object-assign": 292, "util/": 168 }], 166: [function (require, module, exports) {
      if (typeof Object.create === 'function') {
        // implementation from standard node.js 'util' module
        module.exports = function inherits(ctor, superCtor) {
          ctor.super_ = superCtor
          ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
              value: ctor,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
        };
      } else {
        // old school shim for old browsers
        module.exports = function inherits(ctor, superCtor) {
          ctor.super_ = superCtor
          var TempCtor = function () { }
          TempCtor.prototype = superCtor.prototype
          ctor.prototype = new TempCtor()
          ctor.prototype.constructor = ctor
        }
      }

    }, {}], 167: [function (require, module, exports) {
      module.exports = function isBuffer(arg) {
        return arg && typeof arg === 'object'
          && typeof arg.copy === 'function'
          && typeof arg.fill === 'function'
          && typeof arg.readUInt8 === 'function';
      }
    }, {}], 168: [function (require, module, exports) {
      (function (process, global) {
        (function () {
          // Copyright Joyent, Inc. and other Node contributors.
          //
          // Permission is hereby granted, free of charge, to any person obtaining a
          // copy of this software and associated documentation files (the
          // "Software"), to deal in the Software without restriction, including
          // without limitation the rights to use, copy, modify, merge, publish,
          // distribute, sublicense, and/or sell copies of the Software, and to permit
          // persons to whom the Software is furnished to do so, subject to the
          // following conditions:
          //
          // The above copyright notice and this permission notice shall be included
          // in all copies or substantial portions of the Software.
          //
          // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
          // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
          // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
          // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
          // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
          // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
          // USE OR OTHER DEALINGS IN THE SOFTWARE.

          var formatRegExp = /%[sdj%]/g;
          exports.format = function (f) {
            if (!isString(f)) {
              var objects = [];
              for (var i = 0; i < arguments.length; i++) {
                objects.push(inspect(arguments[i]));
              }
              return objects.join(' ');
            }

            var i = 1;
            var args = arguments;
            var len = args.length;
            var str = String(f).replace(formatRegExp, function (x) {
              if (x === '%%') return '%';
              if (i >= len) return x;
              switch (x) {
                case '%s': return String(args[i++]);
                case '%d': return Number(args[i++]);
                case '%j':
                  try {
                    return JSON.stringify(args[i++]);
                  } catch (_) {
                    return '[Circular]';
                  }
                default:
                  return x;
              }
            });
            for (var x = args[i]; i < len; x = args[++i]) {
              if (isNull(x) || !isObject(x)) {
                str += ' ' + x;
              } else {
                str += ' ' + inspect(x);
              }
            }
            return str;
          };


          // Mark that a method should not be used.
          // Returns a modified function which warns once by default.
          // If --no-deprecation is set, then it is a no-op.
          exports.deprecate = function (fn, msg) {
            // Allow for deprecating things in the process of starting up.
            if (isUndefined(global.process)) {
              return function () {
                return exports.deprecate(fn, msg).apply(this, arguments);
              };
            }

            if (process.noDeprecation === true) {
              return fn;
            }

            var warned = false;
            function deprecated() {
              if (!warned) {
                if (process.throwDeprecation) {
                  throw new Error(msg);
                } else if (process.traceDeprecation) {
                  console.trace(msg);
                } else {
                  console.error(msg);
                }
                warned = true;
              }
              return fn.apply(this, arguments);
            }

            return deprecated;
          };


          var debugs = {};
          var debugEnviron;
          exports.debuglog = function (set) {
            if (isUndefined(debugEnviron))
              debugEnviron = process.env.NODE_DEBUG || '';
            set = set.toUpperCase();
            if (!debugs[set]) {
              if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
                var pid = process.pid;
                debugs[set] = function () {
                  var msg = exports.format.apply(exports, arguments);
                  console.error('%s %d: %s', set, pid, msg);
                };
              } else {
                debugs[set] = function () { };
              }
            }
            return debugs[set];
          };


          /**
           * Echos the value of a value. Trys to print the value out
           * in the best way possible given the different types.
           *
           * @param {Object} obj The object to print out.
           * @param {Object} opts Optional options object that alters the output.
           */
          /* legacy: obj, showHidden, depth, colors*/
          function inspect(obj, opts) {
            // default options
            var ctx = {
              seen: [],
              stylize: stylizeNoColor
            };
            // legacy...
            if (arguments.length >= 3) ctx.depth = arguments[2];
            if (arguments.length >= 4) ctx.colors = arguments[3];
            if (isBoolean(opts)) {
              // legacy...
              ctx.showHidden = opts;
            } else if (opts) {
              // got an "options" object
              exports._extend(ctx, opts);
            }
            // set default options
            if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
            if (isUndefined(ctx.depth)) ctx.depth = 2;
            if (isUndefined(ctx.colors)) ctx.colors = false;
            if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
            if (ctx.colors) ctx.stylize = stylizeWithColor;
            return formatValue(ctx, obj, ctx.depth);
          }
          exports.inspect = inspect;


          // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
          inspect.colors = {
            'bold': [1, 22],
            'italic': [3, 23],
            'underline': [4, 24],
            'inverse': [7, 27],
            'white': [37, 39],
            'grey': [90, 39],
            'black': [30, 39],
            'blue': [34, 39],
            'cyan': [36, 39],
            'green': [32, 39],
            'magenta': [35, 39],
            'red': [31, 39],
            'yellow': [33, 39]
          };

          // Don't use 'blue' not visible on cmd.exe
          inspect.styles = {
            'special': 'cyan',
            'number': 'yellow',
            'boolean': 'yellow',
            'undefined': 'grey',
            'null': 'bold',
            'string': 'green',
            'date': 'magenta',
            // "name": intentionally not styling
            'regexp': 'red'
          };


          function stylizeWithColor(str, styleType) {
            var style = inspect.styles[styleType];

            if (style) {
              return '\u001b[' + inspect.colors[style][0] + 'm' + str +
                '\u001b[' + inspect.colors[style][1] + 'm';
            } else {
              return str;
            }
          }


          function stylizeNoColor(str, styleType) {
            return str;
          }


          function arrayToHash(array) {
            var hash = {};

            array.forEach(function (val, idx) {
              hash[val] = true;
            });

            return hash;
          }


          function formatValue(ctx, value, recurseTimes) {
            // Provide a hook for user-specified inspect functions.
            // Check that value is an object with an inspect function on it
            if (ctx.customInspect &&
              value &&
              isFunction(value.inspect) &&
              // Filter out the util module, it's inspect function is special
              value.inspect !== exports.inspect &&
              // Also filter out any prototype objects using the circular check.
              !(value.constructor && value.constructor.prototype === value)) {
              var ret = value.inspect(recurseTimes, ctx);
              if (!isString(ret)) {
                ret = formatValue(ctx, ret, recurseTimes);
              }
              return ret;
            }

            // Primitive types cannot have properties
            var primitive = formatPrimitive(ctx, value);
            if (primitive) {
              return primitive;
            }

            // Look up the keys of the object.
            var keys = Object.keys(value);
            var visibleKeys = arrayToHash(keys);

            if (ctx.showHidden) {
              keys = Object.getOwnPropertyNames(value);
            }

            // IE doesn't make error fields non-enumerable
            // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
            if (isError(value)
              && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
              return formatError(value);
            }

            // Some type of object without properties can be shortcutted.
            if (keys.length === 0) {
              if (isFunction(value)) {
                var name = value.name ? ': ' + value.name : '';
                return ctx.stylize('[Function' + name + ']', 'special');
              }
              if (isRegExp(value)) {
                return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
              }
              if (isDate(value)) {
                return ctx.stylize(Date.prototype.toString.call(value), 'date');
              }
              if (isError(value)) {
                return formatError(value);
              }
            }

            var base = '', array = false, braces = ['{', '}'];

            // Make Array say that they are Array
            if (isArray(value)) {
              array = true;
              braces = ['[', ']'];
            }

            // Make functions say that they are functions
            if (isFunction(value)) {
              var n = value.name ? ': ' + value.name : '';
              base = ' [Function' + n + ']';
            }

            // Make RegExps say that they are RegExps
            if (isRegExp(value)) {
              base = ' ' + RegExp.prototype.toString.call(value);
            }

            // Make dates with properties first say the date
            if (isDate(value)) {
              base = ' ' + Date.prototype.toUTCString.call(value);
            }

            // Make error with message first say the error
            if (isError(value)) {
              base = ' ' + formatError(value);
            }

            if (keys.length === 0 && (!array || value.length == 0)) {
              return braces[0] + base + braces[1];
            }

            if (recurseTimes < 0) {
              if (isRegExp(value)) {
                return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
              } else {
                return ctx.stylize('[Object]', 'special');
              }
            }

            ctx.seen.push(value);

            var output;
            if (array) {
              output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
            } else {
              output = keys.map(function (key) {
                return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
              });
            }

            ctx.seen.pop();

            return reduceToSingleString(output, base, braces);
          }


          function formatPrimitive(ctx, value) {
            if (isUndefined(value))
              return ctx.stylize('undefined', 'undefined');
            if (isString(value)) {
              var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                .replace(/'/g, "\\'")
                .replace(/\\"/g, '"') + '\'';
              return ctx.stylize(simple, 'string');
            }
            if (isNumber(value))
              return ctx.stylize('' + value, 'number');
            if (isBoolean(value))
              return ctx.stylize('' + value, 'boolean');
            // For some reason typeof null is "object", so special case here.
            if (isNull(value))
              return ctx.stylize('null', 'null');
          }


          function formatError(value) {
            return '[' + Error.prototype.toString.call(value) + ']';
          }


          function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
            var output = [];
            for (var i = 0, l = value.length; i < l; ++i) {
              if (hasOwnProperty(value, String(i))) {
                output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
                  String(i), true));
              } else {
                output.push('');
              }
            }
            keys.forEach(function (key) {
              if (!key.match(/^\d+$/)) {
                output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
                  key, true));
              }
            });
            return output;
          }


          function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
            var name, str, desc;
            desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
            if (desc.get) {
              if (desc.set) {
                str = ctx.stylize('[Getter/Setter]', 'special');
              } else {
                str = ctx.stylize('[Getter]', 'special');
              }
            } else {
              if (desc.set) {
                str = ctx.stylize('[Setter]', 'special');
              }
            }
            if (!hasOwnProperty(visibleKeys, key)) {
              name = '[' + key + ']';
            }
            if (!str) {
              if (ctx.seen.indexOf(desc.value) < 0) {
                if (isNull(recurseTimes)) {
                  str = formatValue(ctx, desc.value, null);
                } else {
                  str = formatValue(ctx, desc.value, recurseTimes - 1);
                }
                if (str.indexOf('\n') > -1) {
                  if (array) {
                    str = str.split('\n').map(function (line) {
                      return '  ' + line;
                    }).join('\n').substr(2);
                  } else {
                    str = '\n' + str.split('\n').map(function (line) {
                      return '   ' + line;
                    }).join('\n');
                  }
                }
              } else {
                str = ctx.stylize('[Circular]', 'special');
              }
            }
            if (isUndefined(name)) {
              if (array && key.match(/^\d+$/)) {
                return str;
              }
              name = JSON.stringify('' + key);
              if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
                name = name.substr(1, name.length - 2);
                name = ctx.stylize(name, 'name');
              } else {
                name = name.replace(/'/g, "\\'")
                  .replace(/\\"/g, '"')
                  .replace(/(^"|"$)/g, "'");
                name = ctx.stylize(name, 'string');
              }
            }

            return name + ': ' + str;
          }


          function reduceToSingleString(output, base, braces) {
            var numLinesEst = 0;
            var length = output.reduce(function (prev, cur) {
              numLinesEst++;
              if (cur.indexOf('\n') >= 0) numLinesEst++;
              return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
            }, 0);

            if (length > 60) {
              return braces[0] +
                (base === '' ? '' : base + '\n ') +
                ' ' +
                output.join(',\n  ') +
                ' ' +
                braces[1];
            }

            return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
          }


          // NOTE: These type checking functions intentionally don't use `instanceof`
          // because it is fragile and can be easily faked with `Object.create()`.
          function isArray(ar) {
            return Array.isArray(ar);
          }
          exports.isArray = isArray;

          function isBoolean(arg) {
            return typeof arg === 'boolean';
          }
          exports.isBoolean = isBoolean;

          function isNull(arg) {
            return arg === null;
          }
          exports.isNull = isNull;

          function isNullOrUndefined(arg) {
            return arg == null;
          }
          exports.isNullOrUndefined = isNullOrUndefined;

          function isNumber(arg) {
            return typeof arg === 'number';
          }
          exports.isNumber = isNumber;

          function isString(arg) {
            return typeof arg === 'string';
          }
          exports.isString = isString;

          function isSymbol(arg) {
            return typeof arg === 'symbol';
          }
          exports.isSymbol = isSymbol;

          function isUndefined(arg) {
            return arg === void 0;
          }
          exports.isUndefined = isUndefined;

          function isRegExp(re) {
            return isObject(re) && objectToString(re) === '[object RegExp]';
          }
          exports.isRegExp = isRegExp;

          function isObject(arg) {
            return typeof arg === 'object' && arg !== null;
          }
          exports.isObject = isObject;

          function isDate(d) {
            return isObject(d) && objectToString(d) === '[object Date]';
          }
          exports.isDate = isDate;

          function isError(e) {
            return isObject(e) &&
              (objectToString(e) === '[object Error]' || e instanceof Error);
          }
          exports.isError = isError;

          function isFunction(arg) {
            return typeof arg === 'function';
          }
          exports.isFunction = isFunction;

          function isPrimitive(arg) {
            return arg === null ||
              typeof arg === 'boolean' ||
              typeof arg === 'number' ||
              typeof arg === 'string' ||
              typeof arg === 'symbol' ||  // ES6 symbol
              typeof arg === 'undefined';
          }
          exports.isPrimitive = isPrimitive;

          exports.isBuffer = require('./support/isBuffer');

          function objectToString(o) {
            return Object.prototype.toString.call(o);
          }


          function pad(n) {
            return n < 10 ? '0' + n.toString(10) : n.toString(10);
          }


          var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
            'Oct', 'Nov', 'Dec'];

          // 26 Feb 16:19:34
          function timestamp() {
            var d = new Date();
            var time = [pad(d.getHours()),
            pad(d.getMinutes()),
            pad(d.getSeconds())].join(':');
            return [d.getDate(), months[d.getMonth()], time].join(' ');
          }


          // log is just a thin wrapper to console.log that prepends a timestamp
          exports.log = function () {
            console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
          };


          /**
           * Inherit the prototype methods from one constructor into another.
           *
           * The Function.prototype.inherits from lang.js rewritten as a standalone
           * function (not on Function.prototype). NOTE: If this file is to be loaded
           * during bootstrapping this function needs to be rewritten using some native
           * functions as prototype setup using normal JavaScript does not work as
           * expected during bootstrapping (see mirror.js in r114903).
           *
           * @param {function} ctor Constructor function which needs to inherit the
           *     prototype.
           * @param {function} superCtor Constructor function to inherit prototype from.
           */
          exports.inherits = require('inherits');

          exports._extend = function (origin, add) {
            // Don't do anything if add isn't an object
            if (!add || !isObject(add)) return origin;

            var keys = Object.keys(add);
            var i = keys.length;
            while (i--) {
              origin[keys[i]] = add[keys[i]];
            }
            return origin;
          };

          function hasOwnProperty(obj, prop) {
            return Object.prototype.hasOwnProperty.call(obj, prop);
          }

        }).call(this)
      }).call(this, require('_process'), typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
    }, { "./support/isBuffer": 167, "_process": 304, "inherits": 166 }], 169: [function (require, module, exports) {
      'use strict'

      exports.byteLength = byteLength
      exports.toByteArray = toByteArray
      exports.fromByteArray = fromByteArray

      var lookup = []
      var revLookup = []
      var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

      var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
      for (var i = 0, len = code.length; i < len; ++i) {
        lookup[i] = code[i]
        revLookup[code.charCodeAt(i)] = i
      }

      // Support decoding URL-safe base64 strings, as Node.js does.
      // See: https://en.wikipedia.org/wiki/Base64#URL_applications
      revLookup['-'.charCodeAt(0)] = 62
      revLookup['_'.charCodeAt(0)] = 63

      function getLens(b64) {
        var len = b64.length

        if (len % 4 > 0) {
          throw new Error('Invalid string. Length must be a multiple of 4')
        }

        // Trim off extra bytes after placeholder bytes are found
        // See: https://github.com/beatgammit/base64-js/issues/42
        var validLen = b64.indexOf('=')
        if (validLen === -1) validLen = len

        var placeHoldersLen = validLen === len
          ? 0
          : 4 - (validLen % 4)

        return [validLen, placeHoldersLen]
      }

      // base64 is 4/3 + up to two characters of the original data
      function byteLength(b64) {
        var lens = getLens(b64)
        var validLen = lens[0]
        var placeHoldersLen = lens[1]
        return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
      }

      function _byteLength(b64, validLen, placeHoldersLen) {
        return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
      }

      function toByteArray(b64) {
        var tmp
        var lens = getLens(b64)
        var validLen = lens[0]
        var placeHoldersLen = lens[1]

        var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

        var curByte = 0

        // if there are placeholders, only get up to the last complete 4 chars
        var len = placeHoldersLen > 0
          ? validLen - 4
          : validLen

        var i
        for (i = 0; i < len; i += 4) {
          tmp =
            (revLookup[b64.charCodeAt(i)] << 18) |
            (revLookup[b64.charCodeAt(i + 1)] << 12) |
            (revLookup[b64.charCodeAt(i + 2)] << 6) |
            revLookup[b64.charCodeAt(i + 3)]
          arr[curByte++] = (tmp >> 16) & 0xFF
          arr[curByte++] = (tmp >> 8) & 0xFF
          arr[curByte++] = tmp & 0xFF
        }

        if (placeHoldersLen === 2) {
          tmp =
            (revLookup[b64.charCodeAt(i)] << 2) |
            (revLookup[b64.charCodeAt(i + 1)] >> 4)
          arr[curByte++] = tmp & 0xFF
        }

        if (placeHoldersLen === 1) {
          tmp =
            (revLookup[b64.charCodeAt(i)] << 10) |
            (revLookup[b64.charCodeAt(i + 1)] << 4) |
            (revLookup[b64.charCodeAt(i + 2)] >> 2)
          arr[curByte++] = (tmp >> 8) & 0xFF
          arr[curByte++] = tmp & 0xFF
        }

        return arr
      }

      function tripletToBase64(num) {
        return lookup[num >> 18 & 0x3F] +
          lookup[num >> 12 & 0x3F] +
          lookup[num >> 6 & 0x3F] +
          lookup[num & 0x3F]
      }

      function encodeChunk(uint8, start, end) {
        var tmp
        var output = []
        for (var i = start; i < end; i += 3) {
          tmp =
            ((uint8[i] << 16) & 0xFF0000) +
            ((uint8[i + 1] << 8) & 0xFF00) +
            (uint8[i + 2] & 0xFF)
          output.push(tripletToBase64(tmp))
        }
        return output.join('')
      }

      function fromByteArray(uint8) {
        var tmp
        var len = uint8.length
        var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
        var parts = []
        var maxChunkLength = 16383 // must be multiple of 3

        // go through the array every three bytes, we'll deal with trailing stuff later
        for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
          parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
        }

        // pad the end with zeros, but make sure to not forget the extra bytes
        if (extraBytes === 1) {
          tmp = uint8[len - 1]
          parts.push(
            lookup[tmp >> 2] +
            lookup[(tmp << 4) & 0x3F] +
            '=='
          )
        } else if (extraBytes === 2) {
          tmp = (uint8[len - 2] << 8) + uint8[len - 1]
          parts.push(
            lookup[tmp >> 10] +
            lookup[(tmp >> 4) & 0x3F] +
            lookup[(tmp << 2) & 0x3F] +
            '='
          )
        }

        return parts.join('')
      }

    }, {}], 170: [function (require, module, exports) {
      (function (module, exports) {
        'use strict';

        // Utils
        function assert(val, msg) {
          if (!val) throw new Error(msg || 'Assertion failed');
        }

        // Could use `inherits` module, but don't want to move from single file
        // architecture yet.
        function inherits(ctor, superCtor) {
          ctor.super_ = superCtor;
          var TempCtor = function () { };
          TempCtor.prototype = superCtor.prototype;
          ctor.prototype = new TempCtor();
          ctor.prototype.constructor = ctor;
        }

        // BN

        function BN(number, base, endian) {
          if (BN.isBN(number)) {
            return number;
          }

          this.negative = 0;
          this.words = null;
          this.length = 0;

          // Reduction context
          this.red = null;

          if (number !== null) {
            if (base === 'le' || base === 'be') {
              endian = base;
              base = 10;
            }

            this._init(number || 0, base || 10, endian || 'be');
          }
        }
        if (typeof module === 'object') {
          module.exports = BN;
        } else {
          exports.BN = BN;
        }

        BN.BN = BN;
        BN.wordSize = 26;

        var Buffer;
        try {
          if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
            Buffer = window.Buffer;
          } else {
            Buffer = require('buffer').Buffer;
          }
        } catch (e) {
        }

        BN.isBN = function isBN(num) {
          if (num instanceof BN) {
            return true;
          }

          return num !== null && typeof num === 'object' &&
            num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
        };

        BN.max = function max(left, right) {
          if (left.cmp(right) > 0) return left;
          return right;
        };

        BN.min = function min(left, right) {
          if (left.cmp(right) < 0) return left;
          return right;
        };

        BN.prototype._init = function init(number, base, endian) {
          if (typeof number === 'number') {
            return this._initNumber(number, base, endian);
          }

          if (typeof number === 'object') {
            return this._initArray(number, base, endian);
          }

          if (base === 'hex') {
            base = 16;
          }
          assert(base === (base | 0) && base >= 2 && base <= 36);

          number = number.toString().replace(/\s+/g, '');
          var start = 0;
          if (number[0] === '-') {
            start++;
            this.negative = 1;
          }

          if (start < number.length) {
            if (base === 16) {
              this._parseHex(number, start, endian);
            } else {
              this._parseBase(number, base, start);
              if (endian === 'le') {
                this._initArray(this.toArray(), base, endian);
              }
            }
          }
        };

        BN.prototype._initNumber = function _initNumber(number, base, endian) {
          if (number < 0) {
            this.negative = 1;
            number = -number;
          }
          if (number < 0x4000000) {
            this.words = [number & 0x3ffffff];
            this.length = 1;
          } else if (number < 0x10000000000000) {
            this.words = [
              number & 0x3ffffff,
              (number / 0x4000000) & 0x3ffffff
            ];
            this.length = 2;
          } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
              number & 0x3ffffff,
              (number / 0x4000000) & 0x3ffffff,
              1
            ];
            this.length = 3;
          }

          if (endian !== 'le') return;

          // Reverse the bytes
          this._initArray(this.toArray(), base, endian);
        };

        BN.prototype._initArray = function _initArray(number, base, endian) {
          // Perhaps a Uint8Array
          assert(typeof number.length === 'number');
          if (number.length <= 0) {
            this.words = [0];
            this.length = 1;
            return this;
          }

          this.length = Math.ceil(number.length / 3);
          this.words = new Array(this.length);
          for (var i = 0; i < this.length; i++) {
            this.words[i] = 0;
          }

          var j, w;
          var off = 0;
          if (endian === 'be') {
            for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
              w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
              this.words[j] |= (w << off) & 0x3ffffff;
              this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
              off += 24;
              if (off >= 26) {
                off -= 26;
                j++;
              }
            }
          } else if (endian === 'le') {
            for (i = 0, j = 0; i < number.length; i += 3) {
              w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
              this.words[j] |= (w << off) & 0x3ffffff;
              this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
              off += 24;
              if (off >= 26) {
                off -= 26;
                j++;
              }
            }
          }
          return this._strip();
        };

        function parseHex4Bits(string, index) {
          var c = string.charCodeAt(index);
          // '0' - '9'
          if (c >= 48 && c <= 57) {
            return c - 48;
            // 'A' - 'F'
          } else if (c >= 65 && c <= 70) {
            return c - 55;
            // 'a' - 'f'
          } else if (c >= 97 && c <= 102) {
            return c - 87;
          } else {
            assert(false, 'Invalid character in ' + string);
          }
        }

        function parseHexByte(string, lowerBound, index) {
          var r = parseHex4Bits(string, index);
          if (index - 1 >= lowerBound) {
            r |= parseHex4Bits(string, index - 1) << 4;
          }
          return r;
        }

        BN.prototype._parseHex = function _parseHex(number, start, endian) {
          // Create possibly bigger array to ensure that it fits the number
          this.length = Math.ceil((number.length - start) / 6);
          this.words = new Array(this.length);
          for (var i = 0; i < this.length; i++) {
            this.words[i] = 0;
          }

          // 24-bits chunks
          var off = 0;
          var j = 0;

          var w;
          if (endian === 'be') {
            for (i = number.length - 1; i >= start; i -= 2) {
              w = parseHexByte(number, start, i) << off;
              this.words[j] |= w & 0x3ffffff;
              if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
              } else {
                off += 8;
              }
            }
          } else {
            var parseLength = number.length - start;
            for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
              w = parseHexByte(number, start, i) << off;
              this.words[j] |= w & 0x3ffffff;
              if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
              } else {
                off += 8;
              }
            }
          }

          this._strip();
        };

        function parseBase(str, start, end, mul) {
          var r = 0;
          var b = 0;
          var len = Math.min(str.length, end);
          for (var i = start; i < len; i++) {
            var c = str.charCodeAt(i) - 48;

            r *= mul;

            // 'a'
            if (c >= 49) {
              b = c - 49 + 0xa;

              // 'A'
            } else if (c >= 17) {
              b = c - 17 + 0xa;

              // '0' - '9'
            } else {
              b = c;
            }
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
          }
          return r;
        }

        BN.prototype._parseBase = function _parseBase(number, base, start) {
          // Initialize as zero
          this.words = [0];
          this.length = 1;

          // Find length of limb in base
          for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
            limbLen++;
          }
          limbLen--;
          limbPow = (limbPow / base) | 0;

          var total = number.length - start;
          var mod = total % limbLen;
          var end = Math.min(total, total - mod) + start;

          var word = 0;
          for (var i = start; i < end; i += limbLen) {
            word = parseBase(number, i, i + limbLen, base);

            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) {
              this.words[0] += word;
            } else {
              this._iaddn(word);
            }
          }

          if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);

            for (i = 0; i < mod; i++) {
              pow *= base;
            }

            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) {
              this.words[0] += word;
            } else {
              this._iaddn(word);
            }
          }

          this._strip();
        };

        BN.prototype.copy = function copy(dest) {
          dest.words = new Array(this.length);
          for (var i = 0; i < this.length; i++) {
            dest.words[i] = this.words[i];
          }
          dest.length = this.length;
          dest.negative = this.negative;
          dest.red = this.red;
        };

        function move(dest, src) {
          dest.words = src.words;
          dest.length = src.length;
          dest.negative = src.negative;
          dest.red = src.red;
        }

        BN.prototype._move = function _move(dest) {
          move(dest, this);
        };

        BN.prototype.clone = function clone() {
          var r = new BN(null);
          this.copy(r);
          return r;
        };

        BN.prototype._expand = function _expand(size) {
          while (this.length < size) {
            this.words[this.length++] = 0;
          }
          return this;
        };

        // Remove leading `0` from `this`
        BN.prototype._strip = function strip() {
          while (this.length > 1 && this.words[this.length - 1] === 0) {
            this.length--;
          }
          return this._normSign();
        };

        BN.prototype._normSign = function _normSign() {
          // -0 = 0
          if (this.length === 1 && this.words[0] === 0) {
            this.negative = 0;
          }
          return this;
        };

        // Check Symbol.for because not everywhere where Symbol defined
        // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
        if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') {
          try {
            BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
          } catch (e) {
            BN.prototype.inspect = inspect;
          }
        } else {
          BN.prototype.inspect = inspect;
        }

        function inspect() {
          return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
        }

        /*
      
        var zeros = [];
        var groupSizes = [];
        var groupBases = [];
      
        var s = '';
        var i = -1;
        while (++i < BN.wordSize) {
          zeros[i] = s;
          s += '0';
        }
        groupSizes[0] = 0;
        groupSizes[1] = 0;
        groupBases[0] = 0;
        groupBases[1] = 0;
        var base = 2 - 1;
        while (++base < 36 + 1) {
          var groupSize = 0;
          var groupBase = 1;
          while (groupBase < (1 << BN.wordSize) / base) {
            groupBase *= base;
            groupSize += 1;
          }
          groupSizes[base] = groupSize;
          groupBases[base] = groupBase;
        }
      
        */

        var zeros = [
          '',
          '0',
          '00',
          '000',
          '0000',
          '00000',
          '000000',
          '0000000',
          '00000000',
          '000000000',
          '0000000000',
          '00000000000',
          '000000000000',
          '0000000000000',
          '00000000000000',
          '000000000000000',
          '0000000000000000',
          '00000000000000000',
          '000000000000000000',
          '0000000000000000000',
          '00000000000000000000',
          '000000000000000000000',
          '0000000000000000000000',
          '00000000000000000000000',
          '000000000000000000000000',
          '0000000000000000000000000'
        ];

        var groupSizes = [
          0, 0,
          25, 16, 12, 11, 10, 9, 8,
          8, 7, 7, 7, 7, 6, 6,
          6, 6, 6, 6, 6, 5, 5,
          5, 5, 5, 5, 5, 5, 5,
          5, 5, 5, 5, 5, 5, 5
        ];

        var groupBases = [
          0, 0,
          33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
          43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
          16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
          6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
          24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
        ];

        BN.prototype.toString = function toString(base, padding) {
          base = base || 10;
          padding = padding | 0 || 1;

          var out;
          if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for (var i = 0; i < this.length; i++) {
              var w = this.words[i];
              var word = (((w << off) | carry) & 0xffffff).toString(16);
              carry = (w >>> (24 - off)) & 0xffffff;
              if (carry !== 0 || i !== this.length - 1) {
                out = zeros[6 - word.length] + word + out;
              } else {
                out = word + out;
              }
              off += 2;
              if (off >= 26) {
                off -= 26;
                i--;
              }
            }
            if (carry !== 0) {
              out = carry.toString(16) + out;
            }
            while (out.length % padding !== 0) {
              out = '0' + out;
            }
            if (this.negative !== 0) {
              out = '-' + out;
            }
            return out;
          }

          if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while (!c.isZero()) {
              var r = c.modrn(groupBase).toString(base);
              c = c.idivn(groupBase);

              if (!c.isZero()) {
                out = zeros[groupSize - r.length] + r + out;
              } else {
                out = r + out;
              }
            }
            if (this.isZero()) {
              out = '0' + out;
            }
            while (out.length % padding !== 0) {
              out = '0' + out;
            }
            if (this.negative !== 0) {
              out = '-' + out;
            }
            return out;
          }

          assert(false, 'Base should be between 2 and 36');
        };

        BN.prototype.toNumber = function toNumber() {
          var ret = this.words[0];
          if (this.length === 2) {
            ret += this.words[1] * 0x4000000;
          } else if (this.length === 3 && this.words[2] === 0x01) {
            // NOTE: at this stage it is known that the top bit is set
            ret += 0x10000000000000 + (this.words[1] * 0x4000000);
          } else if (this.length > 2) {
            assert(false, 'Number can only safely store up to 53 bits');
          }
          return (this.negative !== 0) ? -ret : ret;
        };

        BN.prototype.toJSON = function toJSON() {
          return this.toString(16, 2);
        };

        if (Buffer) {
          BN.prototype.toBuffer = function toBuffer(endian, length) {
            return this.toArrayLike(Buffer, endian, length);
          };
        }

        BN.prototype.toArray = function toArray(endian, length) {
          return this.toArrayLike(Array, endian, length);
        };

        var allocate = function allocate(ArrayType, size) {
          if (ArrayType.allocUnsafe) {
            return ArrayType.allocUnsafe(size);
          }
          return new ArrayType(size);
        };

        BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
          this._strip();

          var byteLength = this.byteLength();
          var reqLength = length || Math.max(1, byteLength);
          assert(byteLength <= reqLength, 'byte array longer than desired length');
          assert(reqLength > 0, 'Requested array length <= 0');

          var res = allocate(ArrayType, reqLength);
          var postfix = endian === 'le' ? 'LE' : 'BE';
          this['_toArrayLike' + postfix](res, byteLength);
          return res;
        };

        BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
          var position = 0;
          var carry = 0;

          for (var i = 0, shift = 0; i < this.length; i++) {
            var word = (this.words[i] << shift) | carry;

            res[position++] = word & 0xff;
            if (position < res.length) {
              res[position++] = (word >> 8) & 0xff;
            }
            if (position < res.length) {
              res[position++] = (word >> 16) & 0xff;
            }

            if (shift === 6) {
              if (position < res.length) {
                res[position++] = (word >> 24) & 0xff;
              }
              carry = 0;
              shift = 0;
            } else {
              carry = word >>> 24;
              shift += 2;
            }
          }

          if (position < res.length) {
            res[position++] = carry;

            while (position < res.length) {
              res[position++] = 0;
            }
          }
        };

        BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
          var position = res.length - 1;
          var carry = 0;

          for (var i = 0, shift = 0; i < this.length; i++) {
            var word = (this.words[i] << shift) | carry;

            res[position--] = word & 0xff;
            if (position >= 0) {
              res[position--] = (word >> 8) & 0xff;
            }
            if (position >= 0) {
              res[position--] = (word >> 16) & 0xff;
            }

            if (shift === 6) {
              if (position >= 0) {
                res[position--] = (word >> 24) & 0xff;
              }
              carry = 0;
              shift = 0;
            } else {
              carry = word >>> 24;
              shift += 2;
            }
          }

          if (position >= 0) {
            res[position--] = carry;

            while (position >= 0) {
              res[position--] = 0;
            }
          }
        };

        if (Math.clz32) {
          BN.prototype._countBits = function _countBits(w) {
            return 32 - Math.clz32(w);
          };
        } else {
          BN.prototype._countBits = function _countBits(w) {
            var t = w;
            var r = 0;
            if (t >= 0x1000) {
              r += 13;
              t >>>= 13;
            }
            if (t >= 0x40) {
              r += 7;
              t >>>= 7;
            }
            if (t >= 0x8) {
              r += 4;
              t >>>= 4;
            }
            if (t >= 0x02) {
              r += 2;
              t >>>= 2;
            }
            return r + t;
          };
        }

        BN.prototype._zeroBits = function _zeroBits(w) {
          // Short-cut
          if (w === 0) return 26;

          var t = w;
          var r = 0;
          if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
          }
          if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
          }
          if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
          }
          if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
          }
          if ((t & 0x1) === 0) {
            r++;
          }
          return r;
        };

        // Return number of used bits in a BN
        BN.prototype.bitLength = function bitLength() {
          var w = this.words[this.length - 1];
          var hi = this._countBits(w);
          return (this.length - 1) * 26 + hi;
        };

        function toBitArray(num) {
          var w = new Array(num.bitLength());

          for (var bit = 0; bit < w.length; bit++) {
            var off = (bit / 26) | 0;
            var wbit = bit % 26;

            w[bit] = (num.words[off] >>> wbit) & 0x01;
          }

          return w;
        }

        // Number of trailing zero bits
        BN.prototype.zeroBits = function zeroBits() {
          if (this.isZero()) return 0;

          var r = 0;
          for (var i = 0; i < this.length; i++) {
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
          }
          return r;
        };

        BN.prototype.byteLength = function byteLength() {
          return Math.ceil(this.bitLength() / 8);
        };

        BN.prototype.toTwos = function toTwos(width) {
          if (this.negative !== 0) {
            return this.abs().inotn(width).iaddn(1);
          }
          return this.clone();
        };

        BN.prototype.fromTwos = function fromTwos(width) {
          if (this.testn(width - 1)) {
            return this.notn(width).iaddn(1).ineg();
          }
          return this.clone();
        };

        BN.prototype.isNeg = function isNeg() {
          return this.negative !== 0;
        };

        // Return negative clone of `this`
        BN.prototype.neg = function neg() {
          return this.clone().ineg();
        };

        BN.prototype.ineg = function ineg() {
          if (!this.isZero()) {
            this.negative ^= 1;
          }

          return this;
        };

        // Or `num` with `this` in-place
        BN.prototype.iuor = function iuor(num) {
          while (this.length < num.length) {
            this.words[this.length++] = 0;
          }

          for (var i = 0; i < num.length; i++) {
            this.words[i] = this.words[i] | num.words[i];
          }

          return this._strip();
        };

        BN.prototype.ior = function ior(num) {
          assert((this.negative | num.negative) === 0);
          return this.iuor(num);
        };

        // Or `num` with `this`
        BN.prototype.or = function or(num) {
          if (this.length > num.length) return this.clone().ior(num);
          return num.clone().ior(this);
        };

        BN.prototype.uor = function uor(num) {
          if (this.length > num.length) return this.clone().iuor(num);
          return num.clone().iuor(this);
        };

        // And `num` with `this` in-place
        BN.prototype.iuand = function iuand(num) {
          // b = min-length(num, this)
          var b;
          if (this.length > num.length) {
            b = num;
          } else {
            b = this;
          }

          for (var i = 0; i < b.length; i++) {
            this.words[i] = this.words[i] & num.words[i];
          }

          this.length = b.length;

          return this._strip();
        };

        BN.prototype.iand = function iand(num) {
          assert((this.negative | num.negative) === 0);
          return this.iuand(num);
        };

        // And `num` with `this`
        BN.prototype.and = function and(num) {
          if (this.length > num.length) return this.clone().iand(num);
          return num.clone().iand(this);
        };

        BN.prototype.uand = function uand(num) {
          if (this.length > num.length) return this.clone().iuand(num);
          return num.clone().iuand(this);
        };

        // Xor `num` with `this` in-place
        BN.prototype.iuxor = function iuxor(num) {
          // a.length > b.length
          var a;
          var b;
          if (this.length > num.length) {
            a = this;
            b = num;
          } else {
            a = num;
            b = this;
          }

          for (var i = 0; i < b.length; i++) {
            this.words[i] = a.words[i] ^ b.words[i];
          }

          if (this !== a) {
            for (; i < a.length; i++) {
              this.words[i] = a.words[i];
            }
          }

          this.length = a.length;

          return this._strip();
        };

        BN.prototype.ixor = function ixor(num) {
          assert((this.negative | num.negative) === 0);
          return this.iuxor(num);
        };

        // Xor `num` with `this`
        BN.prototype.xor = function xor(num) {
          if (this.length > num.length) return this.clone().ixor(num);
          return num.clone().ixor(this);
        };

        BN.prototype.uxor = function uxor(num) {
          if (this.length > num.length) return this.clone().iuxor(num);
          return num.clone().iuxor(this);
        };

        // Not ``this`` with ``width`` bitwidth
        BN.prototype.inotn = function inotn(width) {
          assert(typeof width === 'number' && width >= 0);

          var bytesNeeded = Math.ceil(width / 26) | 0;
          var bitsLeft = width % 26;

          // Extend the buffer with leading zeroes
          this._expand(bytesNeeded);

          if (bitsLeft > 0) {
            bytesNeeded--;
          }

          // Handle complete words
          for (var i = 0; i < bytesNeeded; i++) {
            this.words[i] = ~this.words[i] & 0x3ffffff;
          }

          // Handle the residue
          if (bitsLeft > 0) {
            this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
          }

          // And remove leading zeroes
          return this._strip();
        };

        BN.prototype.notn = function notn(width) {
          return this.clone().inotn(width);
        };

        // Set `bit` of `this`
        BN.prototype.setn = function setn(bit, val) {
          assert(typeof bit === 'number' && bit >= 0);

          var off = (bit / 26) | 0;
          var wbit = bit % 26;

          this._expand(off + 1);

          if (val) {
            this.words[off] = this.words[off] | (1 << wbit);
          } else {
            this.words[off] = this.words[off] & ~(1 << wbit);
          }

          return this._strip();
        };

        // Add `num` to `this` in-place
        BN.prototype.iadd = function iadd(num) {
          var r;

          // negative + positive
          if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();

            // positive + negative
          } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
          }

          // a.length > b.length
          var a, b;
          if (this.length > num.length) {
            a = this;
            b = num;
          } else {
            a = num;
            b = this;
          }

          var carry = 0;
          for (var i = 0; i < b.length; i++) {
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
          }
          for (; carry !== 0 && i < a.length; i++) {
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
          }

          this.length = a.length;
          if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
            // Copy the rest of the words
          } else if (a !== this) {
            for (; i < a.length; i++) {
              this.words[i] = a.words[i];
            }
          }

          return this;
        };

        // Add `num` to `this`
        BN.prototype.add = function add(num) {
          var res;
          if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
          } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
          }

          if (this.length > num.length) return this.clone().iadd(num);

          return num.clone().iadd(this);
        };

        // Subtract `num` from `this` in-place
        BN.prototype.isub = function isub(num) {
          // this - (-num) = this + num
          if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();

            // -this - num = -(this + num)
          } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
          }

          // At this point both numbers are positive
          var cmp = this.cmp(num);

          // Optimization - zeroify
          if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
          }

          // a > b
          var a, b;
          if (cmp > 0) {
            a = this;
            b = num;
          } else {
            a = num;
            b = this;
          }

          var carry = 0;
          for (var i = 0; i < b.length; i++) {
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
          }
          for (; carry !== 0 && i < a.length; i++) {
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
          }

          // Copy rest of the words
          if (carry === 0 && i < a.length && a !== this) {
            for (; i < a.length; i++) {
              this.words[i] = a.words[i];
            }
          }

          this.length = Math.max(this.length, i);

          if (a !== this) {
            this.negative = 1;
          }

          return this._strip();
        };

        // Subtract `num` from `this`
        BN.prototype.sub = function sub(num) {
          return this.clone().isub(num);
        };

        function smallMulTo(self, num, out) {
          out.negative = num.negative ^ self.negative;
          var len = (self.length + num.length) | 0;
          out.length = len;
          len = (len - 1) | 0;

          // Peel one iteration (compiler can't do it, because of code complexity)
          var a = self.words[0] | 0;
          var b = num.words[0] | 0;
          var r = a * b;

          var lo = r & 0x3ffffff;
          var carry = (r / 0x4000000) | 0;
          out.words[0] = lo;

          for (var k = 1; k < len; k++) {
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
              var i = (k - j) | 0;
              a = self.words[i] | 0;
              b = num.words[j] | 0;
              r = a * b + rword;
              ncarry += (r / 0x4000000) | 0;
              rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
          }
          if (carry !== 0) {
            out.words[k] = carry | 0;
          } else {
            out.length--;
          }

          return out._strip();
        }

        // TODO(indutny): it may be reasonable to omit it for users who don't need
        // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
        // multiplication (like elliptic secp256k1).
        var comb10MulTo = function comb10MulTo(self, num, out) {
          var a = self.words;
          var b = num.words;
          var o = out.words;
          var c = 0;
          var lo;
          var mid;
          var hi;
          var a0 = a[0] | 0;
          var al0 = a0 & 0x1fff;
          var ah0 = a0 >>> 13;
          var a1 = a[1] | 0;
          var al1 = a1 & 0x1fff;
          var ah1 = a1 >>> 13;
          var a2 = a[2] | 0;
          var al2 = a2 & 0x1fff;
          var ah2 = a2 >>> 13;
          var a3 = a[3] | 0;
          var al3 = a3 & 0x1fff;
          var ah3 = a3 >>> 13;
          var a4 = a[4] | 0;
          var al4 = a4 & 0x1fff;
          var ah4 = a4 >>> 13;
          var a5 = a[5] | 0;
          var al5 = a5 & 0x1fff;
          var ah5 = a5 >>> 13;
          var a6 = a[6] | 0;
          var al6 = a6 & 0x1fff;
          var ah6 = a6 >>> 13;
          var a7 = a[7] | 0;
          var al7 = a7 & 0x1fff;
          var ah7 = a7 >>> 13;
          var a8 = a[8] | 0;
          var al8 = a8 & 0x1fff;
          var ah8 = a8 >>> 13;
          var a9 = a[9] | 0;
          var al9 = a9 & 0x1fff;
          var ah9 = a9 >>> 13;
          var b0 = b[0] | 0;
          var bl0 = b0 & 0x1fff;
          var bh0 = b0 >>> 13;
          var b1 = b[1] | 0;
          var bl1 = b1 & 0x1fff;
          var bh1 = b1 >>> 13;
          var b2 = b[2] | 0;
          var bl2 = b2 & 0x1fff;
          var bh2 = b2 >>> 13;
          var b3 = b[3] | 0;
          var bl3 = b3 & 0x1fff;
          var bh3 = b3 >>> 13;
          var b4 = b[4] | 0;
          var bl4 = b4 & 0x1fff;
          var bh4 = b4 >>> 13;
          var b5 = b[5] | 0;
          var bl5 = b5 & 0x1fff;
          var bh5 = b5 >>> 13;
          var b6 = b[6] | 0;
          var bl6 = b6 & 0x1fff;
          var bh6 = b6 >>> 13;
          var b7 = b[7] | 0;
          var bl7 = b7 & 0x1fff;
          var bh7 = b7 >>> 13;
          var b8 = b[8] | 0;
          var bl8 = b8 & 0x1fff;
          var bh8 = b8 >>> 13;
          var b9 = b[9] | 0;
          var bl9 = b9 & 0x1fff;
          var bh9 = b9 >>> 13;

          out.negative = self.negative ^ num.negative;
          out.length = 19;
          /* k = 0 */
          lo = Math.imul(al0, bl0);
          mid = Math.imul(al0, bh0);
          mid = (mid + Math.imul(ah0, bl0)) | 0;
          hi = Math.imul(ah0, bh0);
          var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
          w0 &= 0x3ffffff;
          /* k = 1 */
          lo = Math.imul(al1, bl0);
          mid = Math.imul(al1, bh0);
          mid = (mid + Math.imul(ah1, bl0)) | 0;
          hi = Math.imul(ah1, bh0);
          lo = (lo + Math.imul(al0, bl1)) | 0;
          mid = (mid + Math.imul(al0, bh1)) | 0;
          mid = (mid + Math.imul(ah0, bl1)) | 0;
          hi = (hi + Math.imul(ah0, bh1)) | 0;
          var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
          w1 &= 0x3ffffff;
          /* k = 2 */
          lo = Math.imul(al2, bl0);
          mid = Math.imul(al2, bh0);
          mid = (mid + Math.imul(ah2, bl0)) | 0;
          hi = Math.imul(ah2, bh0);
          lo = (lo + Math.imul(al1, bl1)) | 0;
          mid = (mid + Math.imul(al1, bh1)) | 0;
          mid = (mid + Math.imul(ah1, bl1)) | 0;
          hi = (hi + Math.imul(ah1, bh1)) | 0;
          lo = (lo + Math.imul(al0, bl2)) | 0;
          mid = (mid + Math.imul(al0, bh2)) | 0;
          mid = (mid + Math.imul(ah0, bl2)) | 0;
          hi = (hi + Math.imul(ah0, bh2)) | 0;
          var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
          w2 &= 0x3ffffff;
          /* k = 3 */
          lo = Math.imul(al3, bl0);
          mid = Math.imul(al3, bh0);
          mid = (mid + Math.imul(ah3, bl0)) | 0;
          hi = Math.imul(ah3, bh0);
          lo = (lo + Math.imul(al2, bl1)) | 0;
          mid = (mid + Math.imul(al2, bh1)) | 0;
          mid = (mid + Math.imul(ah2, bl1)) | 0;
          hi = (hi + Math.imul(ah2, bh1)) | 0;
          lo = (lo + Math.imul(al1, bl2)) | 0;
          mid = (mid + Math.imul(al1, bh2)) | 0;
          mid = (mid + Math.imul(ah1, bl2)) | 0;
          hi = (hi + Math.imul(ah1, bh2)) | 0;
          lo = (lo + Math.imul(al0, bl3)) | 0;
          mid = (mid + Math.imul(al0, bh3)) | 0;
          mid = (mid + Math.imul(ah0, bl3)) | 0;
          hi = (hi + Math.imul(ah0, bh3)) | 0;
          var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
          w3 &= 0x3ffffff;
          /* k = 4 */
          lo = Math.imul(al4, bl0);
          mid = Math.imul(al4, bh0);
          mid = (mid + Math.imul(ah4, bl0)) | 0;
          hi = Math.imul(ah4, bh0);
          lo = (lo + Math.imul(al3, bl1)) | 0;
          mid = (mid + Math.imul(al3, bh1)) | 0;
          mid = (mid + Math.imul(ah3, bl1)) | 0;
          hi = (hi + Math.imul(ah3, bh1)) | 0;
          lo = (lo + Math.imul(al2, bl2)) | 0;
          mid = (mid + Math.imul(al2, bh2)) | 0;
          mid = (mid + Math.imul(ah2, bl2)) | 0;
          hi = (hi + Math.imul(ah2, bh2)) | 0;
          lo = (lo + Math.imul(al1, bl3)) | 0;
          mid = (mid + Math.imul(al1, bh3)) | 0;
          mid = (mid + Math.imul(ah1, bl3)) | 0;
          hi = (hi + Math.imul(ah1, bh3)) | 0;
          lo = (lo + Math.imul(al0, bl4)) | 0;
          mid = (mid + Math.imul(al0, bh4)) | 0;
          mid = (mid + Math.imul(ah0, bl4)) | 0;
          hi = (hi + Math.imul(ah0, bh4)) | 0;
          var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
          w4 &= 0x3ffffff;
          /* k = 5 */
          lo = Math.imul(al5, bl0);
          mid = Math.imul(al5, bh0);
          mid = (mid + Math.imul(ah5, bl0)) | 0;
          hi = Math.imul(ah5, bh0);
          lo = (lo + Math.imul(al4, bl1)) | 0;
          mid = (mid + Math.imul(al4, bh1)) | 0;
          mid = (mid + Math.imul(ah4, bl1)) | 0;
          hi = (hi + Math.imul(ah4, bh1)) | 0;
          lo = (lo + Math.imul(al3, bl2)) | 0;
          mid = (mid + Math.imul(al3, bh2)) | 0;
          mid = (mid + Math.imul(ah3, bl2)) | 0;
          hi = (hi + Math.imul(ah3, bh2)) | 0;
          lo = (lo + Math.imul(al2, bl3)) | 0;
          mid = (mid + Math.imul(al2, bh3)) | 0;
          mid = (mid + Math.imul(ah2, bl3)) | 0;
          hi = (hi + Math.imul(ah2, bh3)) | 0;
          lo = (lo + Math.imul(al1, bl4)) | 0;
          mid = (mid + Math.imul(al1, bh4)) | 0;
          mid = (mid + Math.imul(ah1, bl4)) | 0;
          hi = (hi + Math.imul(ah1, bh4)) | 0;
          lo = (lo + Math.imul(al0, bl5)) | 0;
          mid = (mid + Math.imul(al0, bh5)) | 0;
          mid = (mid + Math.imul(ah0, bl5)) | 0;
          hi = (hi + Math.imul(ah0, bh5)) | 0;
          var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
          w5 &= 0x3ffffff;
          /* k = 6 */
          lo = Math.imul(al6, bl0);
          mid = Math.imul(al6, bh0);
          mid = (mid + Math.imul(ah6, bl0)) | 0;
          hi = Math.imul(ah6, bh0);
          lo = (lo + Math.imul(al5, bl1)) | 0;
          mid = (mid + Math.imul(al5, bh1)) | 0;
          mid = (mid + Math.imul(ah5, bl1)) | 0;
          hi = (hi + Math.imul(ah5, bh1)) | 0;
          lo = (lo + Math.imul(al4, bl2)) | 0;
          mid = (mid + Math.imul(al4, bh2)) | 0;
          mid = (mid + Math.imul(ah4, bl2)) | 0;
          hi = (hi + Math.imul(ah4, bh2)) | 0;
          lo = (lo + Math.imul(al3, bl3)) | 0;
          mid = (mid + Math.imul(al3, bh3)) | 0;
          mid = (mid + Math.imul(ah3, bl3)) | 0;
          hi = (hi + Math.imul(ah3, bh3)) | 0;
          lo = (lo + Math.imul(al2, bl4)) | 0;
          mid = (mid + Math.imul(al2, bh4)) | 0;
          mid = (mid + Math.imul(ah2, bl4)) | 0;
          hi = (hi + Math.imul(ah2, bh4)) | 0;
          lo = (lo + Math.imul(al1, bl5)) | 0;
          mid = (mid + Math.imul(al1, bh5)) | 0;
          mid = (mid + Math.imul(ah1, bl5)) | 0;
          hi = (hi + Math.imul(ah1, bh5)) | 0;
          lo = (lo + Math.imul(al0, bl6)) | 0;
          mid = (mid + Math.imul(al0, bh6)) | 0;
          mid = (mid + Math.imul(ah0, bl6)) | 0;
          hi = (hi + Math.imul(ah0, bh6)) | 0;
          var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
          w6 &= 0x3ffffff;
          /* k = 7 */
          lo = Math.imul(al7, bl0);
          mid = Math.imul(al7, bh0);
          mid = (mid + Math.imul(ah7, bl0)) | 0;
          hi = Math.imul(ah7, bh0);
          lo = (lo + Math.imul(al6, bl1)) | 0;
          mid = (mid + Math.imul(al6, bh1)) | 0;
          mid = (mid + Math.imul(ah6, bl1)) | 0;
          hi = (hi + Math.imul(ah6, bh1)) | 0;
          lo = (lo + Math.imul(al5, bl2)) | 0;
          mid = (mid + Math.imul(al5, bh2)) | 0;
          mid = (mid + Math.imul(ah5, bl2)) | 0;
          hi = (hi + Math.imul(ah5, bh2)) | 0;
          lo = (lo + Math.imul(al4, bl3)) | 0;
          mid = (mid + Math.imul(al4, bh3)) | 0;
          mid = (mid + Math.imul(ah4, bl3)) | 0;
          hi = (hi + Math.imul(ah4, bh3)) | 0;
          lo = (lo + Math.imul(al3, bl4)) | 0;
          mid = (mid + Math.imul(al3, bh4)) | 0;
          mid = (mid + Math.imul(ah3, bl4)) | 0;
          hi = (hi + Math.imul(ah3, bh4)) | 0;
          lo = (lo + Math.imul(al2, bl5)) | 0;
          mid = (mid + Math.imul(al2, bh5)) | 0;
          mid = (mid + Math.imul(ah2, bl5)) | 0;
          hi = (hi + Math.imul(ah2, bh5)) | 0;
          lo = (lo + Math.imul(al1, bl6)) | 0;
          mid = (mid + Math.imul(al1, bh6)) | 0;
          mid = (mid + Math.imul(ah1, bl6)) | 0;
          hi = (hi + Math.imul(ah1, bh6)) | 0;
          lo = (lo + Math.imul(al0, bl7)) | 0;
          mid = (mid + Math.imul(al0, bh7)) | 0;
          mid = (mid + Math.imul(ah0, bl7)) | 0;
          hi = (hi + Math.imul(ah0, bh7)) | 0;
          var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
          w7 &= 0x3ffffff;
          /* k = 8 */
          lo = Math.imul(al8, bl0);
          mid = Math.imul(al8, bh0);
          mid = (mid + Math.imul(ah8, bl0)) | 0;
          hi = Math.imul(ah8, bh0);
          lo = (lo + Math.imul(al7, bl1)) | 0;
          mid = (mid + Math.imul(al7, bh1)) | 0;
          mid = (mid + Math.imul(ah7, bl1)) | 0;
          hi = (hi + Math.imul(ah7, bh1)) | 0;
          lo = (lo + Math.imul(al6, bl2)) | 0;
          mid = (mid + Math.imul(al6, bh2)) | 0;
          mid = (mid + Math.imul(ah6, bl2)) | 0;
          hi = (hi + Math.imul(ah6, bh2)) | 0;
          lo = (lo + Math.imul(al5, bl3)) | 0;
          mid = (mid + Math.imul(al5, bh3)) | 0;
          mid = (mid + Math.imul(ah5, bl3)) | 0;
          hi = (hi + Math.imul(ah5, bh3)) | 0;
          lo = (lo + Math.imul(al4, bl4)) | 0;
          mid = (mid + Math.imul(al4, bh4)) | 0;
          mid = (mid + Math.imul(ah4, bl4)) | 0;
          hi = (hi + Math.imul(ah4, bh4)) | 0;
          lo = (lo + Math.imul(al3, bl5)) | 0;
          mid = (mid + Math.imul(al3, bh5)) | 0;
          mid = (mid + Math.imul(ah3, bl5)) | 0;
          hi = (hi + Math.imul(ah3, bh5)) | 0;
          lo = (lo + Math.imul(al2, bl6)) | 0;
          mid = (mid + Math.imul(al2, bh6)) | 0;
          mid = (mid + Math.imul(ah2, bl6)) | 0;
          hi = (hi + Math.imul(ah2, bh6)) | 0;
          lo = (lo + Math.imul(al1, bl7)) | 0;
          mid = (mid + Math.imul(al1, bh7)) | 0;
          mid = (mid + Math.imul(ah1, bl7)) | 0;
          hi = (hi + Math.imul(ah1, bh7)) | 0;
          lo = (lo + Math.imul(al0, bl8)) | 0;
          mid = (mid + Math.imul(al0, bh8)) | 0;
          mid = (mid + Math.imul(ah0, bl8)) | 0;
          hi = (hi + Math.imul(ah0, bh8)) | 0;
          var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
          w8 &= 0x3ffffff;
          /* k = 9 */
          lo = Math.imul(al9, bl0);
          mid = Math.imul(al9, bh0);
          mid = (mid + Math.imul(ah9, bl0)) | 0;
          hi = Math.imul(ah9, bh0);
          lo = (lo + Math.imul(al8, bl1)) | 0;
          mid = (mid + Math.imul(al8, bh1)) | 0;
          mid = (mid + Math.imul(ah8, bl1)) | 0;
          hi = (hi + Math.imul(ah8, bh1)) | 0;
          lo = (lo + Math.imul(al7, bl2)) | 0;
          mid = (mid + Math.imul(al7, bh2)) | 0;
          mid = (mid + Math.imul(ah7, bl2)) | 0;
          hi = (hi + Math.imul(ah7, bh2)) | 0;
          lo = (lo + Math.imul(al6, bl3)) | 0;
          mid = (mid + Math.imul(al6, bh3)) | 0;
          mid = (mid + Math.imul(ah6, bl3)) | 0;
          hi = (hi + Math.imul(ah6, bh3)) | 0;
          lo = (lo + Math.imul(al5, bl4)) | 0;
          mid = (mid + Math.imul(al5, bh4)) | 0;
          mid = (mid + Math.imul(ah5, bl4)) | 0;
          hi = (hi + Math.imul(ah5, bh4)) | 0;
          lo = (lo + Math.imul(al4, bl5)) | 0;
          mid = (mid + Math.imul(al4, bh5)) | 0;
          mid = (mid + Math.imul(ah4, bl5)) | 0;
          hi = (hi + Math.imul(ah4, bh5)) | 0;
          lo = (lo + Math.imul(al3, bl6)) | 0;
          mid = (mid + Math.imul(al3, bh6)) | 0;
          mid = (mid + Math.imul(ah3, bl6)) | 0;
          hi = (hi + Math.imul(ah3, bh6)) | 0;
          lo = (lo + Math.imul(al2, bl7)) | 0;
          mid = (mid + Math.imul(al2, bh7)) | 0;
          mid = (mid + Math.imul(ah2, bl7)) | 0;
          hi = (hi + Math.imul(ah2, bh7)) | 0;
          lo = (lo + Math.imul(al1, bl8)) | 0;
          mid = (mid + Math.imul(al1, bh8)) | 0;
          mid = (mid + Math.imul(ah1, bl8)) | 0;
          hi = (hi + Math.imul(ah1, bh8)) | 0;
          lo = (lo + Math.imul(al0, bl9)) | 0;
          mid = (mid + Math.imul(al0, bh9)) | 0;
          mid = (mid + Math.imul(ah0, bl9)) | 0;
          hi = (hi + Math.imul(ah0, bh9)) | 0;
          var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
          w9 &= 0x3ffffff;
          /* k = 10 */
          lo = Math.imul(al9, bl1);
          mid = Math.imul(al9, bh1);
          mid = (mid + Math.imul(ah9, bl1)) | 0;
          hi = Math.imul(ah9, bh1);
          lo = (lo + Math.imul(al8, bl2)) | 0;
          mid = (mid + Math.imul(al8, bh2)) | 0;
          mid = (mid + Math.imul(ah8, bl2)) | 0;
          hi = (hi + Math.imul(ah8, bh2)) | 0;
          lo = (lo + Math.imul(al7, bl3)) | 0;
          mid = (mid + Math.imul(al7, bh3)) | 0;
          mid = (mid + Math.imul(ah7, bl3)) | 0;
          hi = (hi + Math.imul(ah7, bh3)) | 0;
          lo = (lo + Math.imul(al6, bl4)) | 0;
          mid = (mid + Math.imul(al6, bh4)) | 0;
          mid = (mid + Math.imul(ah6, bl4)) | 0;
          hi = (hi + Math.imul(ah6, bh4)) | 0;
          lo = (lo + Math.imul(al5, bl5)) | 0;
          mid = (mid + Math.imul(al5, bh5)) | 0;
          mid = (mid + Math.imul(ah5, bl5)) | 0;
          hi = (hi + Math.imul(ah5, bh5)) | 0;
          lo = (lo + Math.imul(al4, bl6)) | 0;
          mid = (mid + Math.imul(al4, bh6)) | 0;
          mid = (mid + Math.imul(ah4, bl6)) | 0;
          hi = (hi + Math.imul(ah4, bh6)) | 0;
          lo = (lo + Math.imul(al3, bl7)) | 0;
          mid = (mid + Math.imul(al3, bh7)) | 0;
          mid = (mid + Math.imul(ah3, bl7)) | 0;
          hi = (hi + Math.imul(ah3, bh7)) | 0;
          lo = (lo + Math.imul(al2, bl8)) | 0;
          mid = (mid + Math.imul(al2, bh8)) | 0;
          mid = (mid + Math.imul(ah2, bl8)) | 0;
          hi = (hi + Math.imul(ah2, bh8)) | 0;
          lo = (lo + Math.imul(al1, bl9)) | 0;
          mid = (mid + Math.imul(al1, bh9)) | 0;
          mid = (mid + Math.imul(ah1, bl9)) | 0;
          hi = (hi + Math.imul(ah1, bh9)) | 0;
          var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
          w10 &= 0x3ffffff;
          /* k = 11 */
          lo = Math.imul(al9, bl2);
          mid = Math.imul(al9, bh2);
          mid = (mid + Math.imul(ah9, bl2)) | 0;
          hi = Math.imul(ah9, bh2);
          lo = (lo + Math.imul(al8, bl3)) | 0;
          mid = (mid + Math.imul(al8, bh3)) | 0;
          mid = (mid + Math.imul(ah8, bl3)) | 0;
          hi = (hi + Math.imul(ah8, bh3)) | 0;
          lo = (lo + Math.imul(al7, bl4)) | 0;
          mid = (mid + Math.imul(al7, bh4)) | 0;
          mid = (mid + Math.imul(ah7, bl4)) | 0;
          hi = (hi + Math.imul(ah7, bh4)) | 0;
          lo = (lo + Math.imul(al6, bl5)) | 0;
          mid = (mid + Math.imul(al6, bh5)) | 0;
          mid = (mid + Math.imul(ah6, bl5)) | 0;
          hi = (hi + Math.imul(ah6, bh5)) | 0;
          lo = (lo + Math.imul(al5, bl6)) | 0;
          mid = (mid + Math.imul(al5, bh6)) | 0;
          mid = (mid + Math.imul(ah5, bl6)) | 0;
          hi = (hi + Math.imul(ah5, bh6)) | 0;
          lo = (lo + Math.imul(al4, bl7)) | 0;
          mid = (mid + Math.imul(al4, bh7)) | 0;
          mid = (mid + Math.imul(ah4, bl7)) | 0;
          hi = (hi + Math.imul(ah4, bh7)) | 0;
          lo = (lo + Math.imul(al3, bl8)) | 0;
          mid = (mid + Math.imul(al3, bh8)) | 0;
          mid = (mid + Math.imul(ah3, bl8)) | 0;
          hi = (hi + Math.imul(ah3, bh8)) | 0;
          lo = (lo + Math.imul(al2, bl9)) | 0;
          mid = (mid + Math.imul(al2, bh9)) | 0;
          mid = (mid + Math.imul(ah2, bl9)) | 0;
          hi = (hi + Math.imul(ah2, bh9)) | 0;
          var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
          w11 &= 0x3ffffff;
          /* k = 12 */
          lo = Math.imul(al9, bl3);
          mid = Math.imul(al9, bh3);
          mid = (mid + Math.imul(ah9, bl3)) | 0;
          hi = Math.imul(ah9, bh3);
          lo = (lo + Math.imul(al8, bl4)) | 0;
          mid = (mid + Math.imul(al8, bh4)) | 0;
          mid = (mid + Math.imul(ah8, bl4)) | 0;
          hi = (hi + Math.imul(ah8, bh4)) | 0;
          lo = (lo + Math.imul(al7, bl5)) | 0;
          mid = (mid + Math.imul(al7, bh5)) | 0;
          mid = (mid + Math.imul(ah7, bl5)) | 0;
          hi = (hi + Math.imul(ah7, bh5)) | 0;
          lo = (lo + Math.imul(al6, bl6)) | 0;
          mid = (mid + Math.imul(al6, bh6)) | 0;
          mid = (mid + Math.imul(ah6, bl6)) | 0;
          hi = (hi + Math.imul(ah6, bh6)) | 0;
          lo = (lo + Math.imul(al5, bl7)) | 0;
          mid = (mid + Math.imul(al5, bh7)) | 0;
          mid = (mid + Math.imul(ah5, bl7)) | 0;
          hi = (hi + Math.imul(ah5, bh7)) | 0;
          lo = (lo + Math.imul(al4, bl8)) | 0;
          mid = (mid + Math.imul(al4, bh8)) | 0;
          mid = (mid + Math.imul(ah4, bl8)) | 0;
          hi = (hi + Math.imul(ah4, bh8)) | 0;
          lo = (lo + Math.imul(al3, bl9)) | 0;
          mid = (mid + Math.imul(al3, bh9)) | 0;
          mid = (mid + Math.imul(ah3, bl9)) | 0;
          hi = (hi + Math.imul(ah3, bh9)) | 0;
          var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
          w12 &= 0x3ffffff;
          /* k = 13 */
          lo = Math.imul(al9, bl4);
          mid = Math.imul(al9, bh4);
          mid = (mid + Math.imul(ah9, bl4)) | 0;
          hi = Math.imul(ah9, bh4);
          lo = (lo + Math.imul(al8, bl5)) | 0;
          mid = (mid + Math.imul(al8, bh5)) | 0;
          mid = (mid + Math.imul(ah8, bl5)) | 0;
          hi = (hi + Math.imul(ah8, bh5)) | 0;
          lo = (lo + Math.imul(al7, bl6)) | 0;
          mid = (mid + Math.imul(al7, bh6)) | 0;
          mid = (mid + Math.imul(ah7, bl6)) | 0;
          hi = (hi + Math.imul(ah7, bh6)) | 0;
          lo = (lo + Math.imul(al6, bl7)) | 0;
          mid = (mid + Math.imul(al6, bh7)) | 0;
          mid = (mid + Math.imul(ah6, bl7)) | 0;
          hi = (hi + Math.imul(ah6, bh7)) | 0;
          lo = (lo + Math.imul(al5, bl8)) | 0;
          mid = (mid + Math.imul(al5, bh8)) | 0;
          mid = (mid + Math.imul(ah5, bl8)) | 0;
          hi = (hi + Math.imul(ah5, bh8)) | 0;
          lo = (lo + Math.imul(al4, bl9)) | 0;
          mid = (mid + Math.imul(al4, bh9)) | 0;
          mid = (mid + Math.imul(ah4, bl9)) | 0;
          hi = (hi + Math.imul(ah4, bh9)) | 0;
          var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
          w13 &= 0x3ffffff;
          /* k = 14 */
          lo = Math.imul(al9, bl5);
          mid = Math.imul(al9, bh5);
          mid = (mid + Math.imul(ah9, bl5)) | 0;
          hi = Math.imul(ah9, bh5);
          lo = (lo + Math.imul(al8, bl6)) | 0;
          mid = (mid + Math.imul(al8, bh6)) | 0;
          mid = (mid + Math.imul(ah8, bl6)) | 0;
          hi = (hi + Math.imul(ah8, bh6)) | 0;
          lo = (lo + Math.imul(al7, bl7)) | 0;
          mid = (mid + Math.imul(al7, bh7)) | 0;
          mid = (mid + Math.imul(ah7, bl7)) | 0;
          hi = (hi + Math.imul(ah7, bh7)) | 0;
          lo = (lo + Math.imul(al6, bl8)) | 0;
          mid = (mid + Math.imul(al6, bh8)) | 0;
          mid = (mid + Math.imul(ah6, bl8)) | 0;
          hi = (hi + Math.imul(ah6, bh8)) | 0;
          lo = (lo + Math.imul(al5, bl9)) | 0;
          mid = (mid + Math.imul(al5, bh9)) | 0;
          mid = (mid + Math.imul(ah5, bl9)) | 0;
          hi = (hi + Math.imul(ah5, bh9)) | 0;
          var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
          w14 &= 0x3ffffff;
          /* k = 15 */
          lo = Math.imul(al9, bl6);
          mid = Math.imul(al9, bh6);
          mid = (mid + Math.imul(ah9, bl6)) | 0;
          hi = Math.imul(ah9, bh6);
          lo = (lo + Math.imul(al8, bl7)) | 0;
          mid = (mid + Math.imul(al8, bh7)) | 0;
          mid = (mid + Math.imul(ah8, bl7)) | 0;
          hi = (hi + Math.imul(ah8, bh7)) | 0;
          lo = (lo + Math.imul(al7, bl8)) | 0;
          mid = (mid + Math.imul(al7, bh8)) | 0;
          mid = (mid + Math.imul(ah7, bl8)) | 0;
          hi = (hi + Math.imul(ah7, bh8)) | 0;
          lo = (lo + Math.imul(al6, bl9)) | 0;
          mid = (mid + Math.imul(al6, bh9)) | 0;
          mid = (mid + Math.imul(ah6, bl9)) | 0;
          hi = (hi + Math.imul(ah6, bh9)) | 0;
          var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
          w15 &= 0x3ffffff;
          /* k = 16 */
          lo = Math.imul(al9, bl7);
          mid = Math.imul(al9, bh7);
          mid = (mid + Math.imul(ah9, bl7)) | 0;
          hi = Math.imul(ah9, bh7);
          lo = (lo + Math.imul(al8, bl8)) | 0;
          mid = (mid + Math.imul(al8, bh8)) | 0;
          mid = (mid + Math.imul(ah8, bl8)) | 0;
          hi = (hi + Math.imul(ah8, bh8)) | 0;
          lo = (lo + Math.imul(al7, bl9)) | 0;
          mid = (mid + Math.imul(al7, bh9)) | 0;
          mid = (mid + Math.imul(ah7, bl9)) | 0;
          hi = (hi + Math.imul(ah7, bh9)) | 0;
          var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
          w16 &= 0x3ffffff;
          /* k = 17 */
          lo = Math.imul(al9, bl8);
          mid = Math.imul(al9, bh8);
          mid = (mid + Math.imul(ah9, bl8)) | 0;
          hi = Math.imul(ah9, bh8);
          lo = (lo + Math.imul(al8, bl9)) | 0;
          mid = (mid + Math.imul(al8, bh9)) | 0;
          mid = (mid + Math.imul(ah8, bl9)) | 0;
          hi = (hi + Math.imul(ah8, bh9)) | 0;
          var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
          w17 &= 0x3ffffff;
          /* k = 18 */
          lo = Math.imul(al9, bl9);
          mid = Math.imul(al9, bh9);
          mid = (mid + Math.imul(ah9, bl9)) | 0;
          hi = Math.imul(ah9, bh9);
          var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
          c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
          w18 &= 0x3ffffff;
          o[0] = w0;
          o[1] = w1;
          o[2] = w2;
          o[3] = w3;
          o[4] = w4;
          o[5] = w5;
          o[6] = w6;
          o[7] = w7;
          o[8] = w8;
          o[9] = w9;
          o[10] = w10;
          o[11] = w11;
          o[12] = w12;
          o[13] = w13;
          o[14] = w14;
          o[15] = w15;
          o[16] = w16;
          o[17] = w17;
          o[18] = w18;
          if (c !== 0) {
            o[19] = c;
            out.length++;
          }
          return out;
        };

        // Polyfill comb
        if (!Math.imul) {
          comb10MulTo = smallMulTo;
        }

        function bigMulTo(self, num, out) {
          out.negative = num.negative ^ self.negative;
          out.length = self.length + num.length;

          var carry = 0;
          var hncarry = 0;
          for (var k = 0; k < out.length - 1; k++) {
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
              var i = k - j;
              var a = self.words[i] | 0;
              var b = num.words[j] | 0;
              var r = a * b;

              var lo = r & 0x3ffffff;
              ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
              lo = (lo + rword) | 0;
              rword = lo & 0x3ffffff;
              ncarry = (ncarry + (lo >>> 26)) | 0;

              hncarry += ncarry >>> 26;
              ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
          }
          if (carry !== 0) {
            out.words[k] = carry;
          } else {
            out.length--;
          }

          return out._strip();
        }

        function jumboMulTo(self, num, out) {
          // Temporary disable, see https://github.com/indutny/bn.js/issues/211
          // var fftm = new FFTM();
          // return fftm.mulp(self, num, out);
          return bigMulTo(self, num, out);
        }

        BN.prototype.mulTo = function mulTo(num, out) {
          var res;
          var len = this.length + num.length;
          if (this.length === 10 && num.length === 10) {
            res = comb10MulTo(this, num, out);
          } else if (len < 63) {
            res = smallMulTo(this, num, out);
          } else if (len < 1024) {
            res = bigMulTo(this, num, out);
          } else {
            res = jumboMulTo(this, num, out);
          }

          return res;
        };

        // Cooley-Tukey algorithm for FFT
        // slightly revisited to rely on looping instead of recursion

        function FFTM(x, y) {
          this.x = x;
          this.y = y;
        }

        FFTM.prototype.makeRBT = function makeRBT(N) {
          var t = new Array(N);
          var l = BN.prototype._countBits(N) - 1;
          for (var i = 0; i < N; i++) {
            t[i] = this.revBin(i, l, N);
          }

          return t;
        };

        // Returns binary-reversed representation of `x`
        FFTM.prototype.revBin = function revBin(x, l, N) {
          if (x === 0 || x === N - 1) return x;

          var rb = 0;
          for (var i = 0; i < l; i++) {
            rb |= (x & 1) << (l - i - 1);
            x >>= 1;
          }

          return rb;
        };

        // Performs "tweedling" phase, therefore 'emulating'
        // behaviour of the recursive algorithm
        FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
          for (var i = 0; i < N; i++) {
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
          }
        };

        FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
          this.permute(rbt, rws, iws, rtws, itws, N);

          for (var s = 1; s < N; s <<= 1) {
            var l = s << 1;

            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);

            for (var p = 0; p < N; p += l) {
              var rtwdf_ = rtwdf;
              var itwdf_ = itwdf;

              for (var j = 0; j < s; j++) {
                var re = rtws[p + j];
                var ie = itws[p + j];

                var ro = rtws[p + j + s];
                var io = itws[p + j + s];

                var rx = rtwdf_ * ro - itwdf_ * io;

                io = rtwdf_ * io + itwdf_ * ro;
                ro = rx;

                rtws[p + j] = re + ro;
                itws[p + j] = ie + io;

                rtws[p + j + s] = re - ro;
                itws[p + j + s] = ie - io;

                /* jshint maxdepth : false */
                if (j !== l) {
                  rx = rtwdf * rtwdf_ - itwdf * itwdf_;

                  itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                  rtwdf_ = rx;
                }
              }
            }
          }
        };

        FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
          var N = Math.max(m, n) | 1;
          var odd = N & 1;
          var i = 0;
          for (N = N / 2 | 0; N; N = N >>> 1) {
            i++;
          }

          return 1 << i + 1 + odd;
        };

        FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
          if (N <= 1) return;

          for (var i = 0; i < N / 2; i++) {
            var t = rws[i];

            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;

            t = iws[i];

            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
          }
        };

        FFTM.prototype.normalize13b = function normalize13b(ws, N) {
          var carry = 0;
          for (var i = 0; i < N / 2; i++) {
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
              Math.round(ws[2 * i] / N) +
              carry;

            ws[i] = w & 0x3ffffff;

            if (w < 0x4000000) {
              carry = 0;
            } else {
              carry = w / 0x4000000 | 0;
            }
          }

          return ws;
        };

        FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
          var carry = 0;
          for (var i = 0; i < len; i++) {
            carry = carry + (ws[i] | 0);

            rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
          }

          // Pad with zeroes
          for (i = 2 * len; i < N; ++i) {
            rws[i] = 0;
          }

          assert(carry === 0);
          assert((carry & ~0x1fff) === 0);
        };

        FFTM.prototype.stub = function stub(N) {
          var ph = new Array(N);
          for (var i = 0; i < N; i++) {
            ph[i] = 0;
          }

          return ph;
        };

        FFTM.prototype.mulp = function mulp(x, y, out) {
          var N = 2 * this.guessLen13b(x.length, y.length);

          var rbt = this.makeRBT(N);

          var _ = this.stub(N);

          var rws = new Array(N);
          var rwst = new Array(N);
          var iwst = new Array(N);

          var nrws = new Array(N);
          var nrwst = new Array(N);
          var niwst = new Array(N);

          var rmws = out.words;
          rmws.length = N;

          this.convert13b(x.words, x.length, rws, N);
          this.convert13b(y.words, y.length, nrws, N);

          this.transform(rws, _, rwst, iwst, N, rbt);
          this.transform(nrws, _, nrwst, niwst, N, rbt);

          for (var i = 0; i < N; i++) {
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
          }

          this.conjugate(rwst, iwst, N);
          this.transform(rwst, iwst, rmws, _, N, rbt);
          this.conjugate(rmws, _, N);
          this.normalize13b(rmws, N);

          out.negative = x.negative ^ y.negative;
          out.length = x.length + y.length;
          return out._strip();
        };

        // Multiply `this` by `num`
        BN.prototype.mul = function mul(num) {
          var out = new BN(null);
          out.words = new Array(this.length + num.length);
          return this.mulTo(num, out);
        };

        // Multiply employing FFT
        BN.prototype.mulf = function mulf(num) {
          var out = new BN(null);
          out.words = new Array(this.length + num.length);
          return jumboMulTo(this, num, out);
        };

        // In-place Multiplication
        BN.prototype.imul = function imul(num) {
          return this.clone().mulTo(num, this);
        };

        BN.prototype.imuln = function imuln(num) {
          var isNegNum = num < 0;
          if (isNegNum) num = -num;

          assert(typeof num === 'number');
          assert(num < 0x4000000);

          // Carry
          var carry = 0;
          for (var i = 0; i < this.length; i++) {
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += (w / 0x4000000) | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
          }

          if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
          }

          return isNegNum ? this.ineg() : this;
        };

        BN.prototype.muln = function muln(num) {
          return this.clone().imuln(num);
        };

        // `this` * `this`
        BN.prototype.sqr = function sqr() {
          return this.mul(this);
        };

        // `this` * `this` in-place
        BN.prototype.isqr = function isqr() {
          return this.imul(this.clone());
        };

        // Math.pow(`this`, `num`)
        BN.prototype.pow = function pow(num) {
          var w = toBitArray(num);
          if (w.length === 0) return new BN(1);

          // Skip leading zeroes
          var res = this;
          for (var i = 0; i < w.length; i++, res = res.sqr()) {
            if (w[i] !== 0) break;
          }

          if (++i < w.length) {
            for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
              if (w[i] === 0) continue;

              res = res.mul(q);
            }
          }

          return res;
        };

        // Shift-left in-place
        BN.prototype.iushln = function iushln(bits) {
          assert(typeof bits === 'number' && bits >= 0);
          var r = bits % 26;
          var s = (bits - r) / 26;
          var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
          var i;

          if (r !== 0) {
            var carry = 0;

            for (i = 0; i < this.length; i++) {
              var newCarry = this.words[i] & carryMask;
              var c = ((this.words[i] | 0) - newCarry) << r;
              this.words[i] = c | carry;
              carry = newCarry >>> (26 - r);
            }

            if (carry) {
              this.words[i] = carry;
              this.length++;
            }
          }

          if (s !== 0) {
            for (i = this.length - 1; i >= 0; i--) {
              this.words[i + s] = this.words[i];
            }

            for (i = 0; i < s; i++) {
              this.words[i] = 0;
            }

            this.length += s;
          }

          return this._strip();
        };

        BN.prototype.ishln = function ishln(bits) {
          // TODO(indutny): implement me
          assert(this.negative === 0);
          return this.iushln(bits);
        };

        // Shift-right in-place
        // NOTE: `hint` is a lowest bit before trailing zeroes
        // NOTE: if `extended` is present - it will be filled with destroyed bits
        BN.prototype.iushrn = function iushrn(bits, hint, extended) {
          assert(typeof bits === 'number' && bits >= 0);
          var h;
          if (hint) {
            h = (hint - (hint % 26)) / 26;
          } else {
            h = 0;
          }

          var r = bits % 26;
          var s = Math.min((bits - r) / 26, this.length);
          var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
          var maskedWords = extended;

          h -= s;
          h = Math.max(0, h);

          // Extended mode, copy masked part
          if (maskedWords) {
            for (var i = 0; i < s; i++) {
              maskedWords.words[i] = this.words[i];
            }
            maskedWords.length = s;
          }

          if (s === 0) {
            // No-op, we should not move anything at all
          } else if (this.length > s) {
            this.length -= s;
            for (i = 0; i < this.length; i++) {
              this.words[i] = this.words[i + s];
            }
          } else {
            this.words[0] = 0;
            this.length = 1;
          }

          var carry = 0;
          for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
            var word = this.words[i] | 0;
            this.words[i] = (carry << (26 - r)) | (word >>> r);
            carry = word & mask;
          }

          // Push carried bits as a mask
          if (maskedWords && carry !== 0) {
            maskedWords.words[maskedWords.length++] = carry;
          }

          if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
          }

          return this._strip();
        };

        BN.prototype.ishrn = function ishrn(bits, hint, extended) {
          // TODO(indutny): implement me
          assert(this.negative === 0);
          return this.iushrn(bits, hint, extended);
        };

        // Shift-left
        BN.prototype.shln = function shln(bits) {
          return this.clone().ishln(bits);
        };

        BN.prototype.ushln = function ushln(bits) {
          return this.clone().iushln(bits);
        };

        // Shift-right
        BN.prototype.shrn = function shrn(bits) {
          return this.clone().ishrn(bits);
        };

        BN.prototype.ushrn = function ushrn(bits) {
          return this.clone().iushrn(bits);
        };

        // Test if n bit is set
        BN.prototype.testn = function testn(bit) {
          assert(typeof bit === 'number' && bit >= 0);
          var r = bit % 26;
          var s = (bit - r) / 26;
          var q = 1 << r;

          // Fast case: bit is much higher than all existing words
          if (this.length <= s) return false;

          // Check bit and return
          var w = this.words[s];

          return !!(w & q);
        };

        // Return only lowers bits of number (in-place)
        BN.prototype.imaskn = function imaskn(bits) {
          assert(typeof bits === 'number' && bits >= 0);
          var r = bits % 26;
          var s = (bits - r) / 26;

          assert(this.negative === 0, 'imaskn works only with positive numbers');

          if (this.length <= s) {
            return this;
          }

          if (r !== 0) {
            s++;
          }
          this.length = Math.min(s, this.length);

          if (r !== 0) {
            var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
            this.words[this.length - 1] &= mask;
          }

          return this._strip();
        };

        // Return only lowers bits of number
        BN.prototype.maskn = function maskn(bits) {
          return this.clone().imaskn(bits);
        };

        // Add plain number `num` to `this`
        BN.prototype.iaddn = function iaddn(num) {
          assert(typeof num === 'number');
          assert(num < 0x4000000);
          if (num < 0) return this.isubn(-num);

          // Possible sign change
          if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
              this.words[0] = num - (this.words[0] | 0);
              this.negative = 0;
              return this;
            }

            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
          }

          // Add without checks
          return this._iaddn(num);
        };

        BN.prototype._iaddn = function _iaddn(num) {
          this.words[0] += num;

          // Carry
          for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) {
              this.words[i + 1] = 1;
            } else {
              this.words[i + 1]++;
            }
          }
          this.length = Math.max(this.length, i + 1);

          return this;
        };

        // Subtract plain number `num` from `this`
        BN.prototype.isubn = function isubn(num) {
          assert(typeof num === 'number');
          assert(num < 0x4000000);
          if (num < 0) return this.iaddn(-num);

          if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
          }

          this.words[0] -= num;

          if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
          } else {
            // Carry
            for (var i = 0; i < this.length && this.words[i] < 0; i++) {
              this.words[i] += 0x4000000;
              this.words[i + 1] -= 1;
            }
          }

          return this._strip();
        };

        BN.prototype.addn = function addn(num) {
          return this.clone().iaddn(num);
        };

        BN.prototype.subn = function subn(num) {
          return this.clone().isubn(num);
        };

        BN.prototype.iabs = function iabs() {
          this.negative = 0;

          return this;
        };

        BN.prototype.abs = function abs() {
          return this.clone().iabs();
        };

        BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
          var len = num.length + shift;
          var i;

          this._expand(len);

          var w;
          var carry = 0;
          for (i = 0; i < num.length; i++) {
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - ((right / 0x4000000) | 0);
            this.words[i + shift] = w & 0x3ffffff;
          }
          for (; i < this.length - shift; i++) {
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
          }

          if (carry === 0) return this._strip();

          // Subtraction overflow
          assert(carry === -1);
          carry = 0;
          for (i = 0; i < this.length; i++) {
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
          }
          this.negative = 1;

          return this._strip();
        };

        BN.prototype._wordDiv = function _wordDiv(num, mode) {
          var shift = this.length - num.length;

          var a = this.clone();
          var b = num;

          // Normalize
          var bhi = b.words[b.length - 1] | 0;
          var bhiBits = this._countBits(bhi);
          shift = 26 - bhiBits;
          if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
          }

          // Initialize quotient
          var m = a.length - b.length;
          var q;

          if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for (var i = 0; i < q.length; i++) {
              q.words[i] = 0;
            }
          }

          var diff = a.clone()._ishlnsubmul(b, 1, m);
          if (diff.negative === 0) {
            a = diff;
            if (q) {
              q.words[m] = 1;
            }
          }

          for (var j = m - 1; j >= 0; j--) {
            var qj = (a.words[b.length + j] | 0) * 0x4000000 +
              (a.words[b.length + j - 1] | 0);

            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min((qj / bhi) | 0, 0x3ffffff);

            a._ishlnsubmul(b, qj, j);
            while (a.negative !== 0) {
              qj--;
              a.negative = 0;
              a._ishlnsubmul(b, 1, j);
              if (!a.isZero()) {
                a.negative ^= 1;
              }
            }
            if (q) {
              q.words[j] = qj;
            }
          }
          if (q) {
            q._strip();
          }
          a._strip();

          // Denormalize
          if (mode !== 'div' && shift !== 0) {
            a.iushrn(shift);
          }

          return {
            div: q || null,
            mod: a
          };
        };

        // NOTE: 1) `mode` can be set to `mod` to request mod only,
        //       to `div` to request div only, or be absent to
        //       request both div & mod
        //       2) `positive` is true if unsigned mod is requested
        BN.prototype.divmod = function divmod(num, mode, positive) {
          assert(!num.isZero());

          if (this.isZero()) {
            return {
              div: new BN(0),
              mod: new BN(0)
            };
          }

          var div, mod, res;
          if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);

            if (mode !== 'mod') {
              div = res.div.neg();
            }

            if (mode !== 'div') {
              mod = res.mod.neg();
              if (positive && mod.negative !== 0) {
                mod.iadd(num);
              }
            }

            return {
              div: div,
              mod: mod
            };
          }

          if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);

            if (mode !== 'mod') {
              div = res.div.neg();
            }

            return {
              div: div,
              mod: res.mod
            };
          }

          if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);

            if (mode !== 'div') {
              mod = res.mod.neg();
              if (positive && mod.negative !== 0) {
                mod.isub(num);
              }
            }

            return {
              div: res.div,
              mod: mod
            };
          }

          // Both numbers are positive at this point

          // Strip both numbers to approximate shift value
          if (num.length > this.length || this.cmp(num) < 0) {
            return {
              div: new BN(0),
              mod: this
            };
          }

          // Very short reduction
          if (num.length === 1) {
            if (mode === 'div') {
              return {
                div: this.divn(num.words[0]),
                mod: null
              };
            }

            if (mode === 'mod') {
              return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
              };
            }

            return {
              div: this.divn(num.words[0]),
              mod: new BN(this.modrn(num.words[0]))
            };
          }

          return this._wordDiv(num, mode);
        };

        // Find `this` / `num`
        BN.prototype.div = function div(num) {
          return this.divmod(num, 'div', false).div;
        };

        // Find `this` % `num`
        BN.prototype.mod = function mod(num) {
          return this.divmod(num, 'mod', false).mod;
        };

        BN.prototype.umod = function umod(num) {
          return this.divmod(num, 'mod', true).mod;
        };

        // Find Round(`this` / `num`)
        BN.prototype.divRound = function divRound(num) {
          var dm = this.divmod(num);

          // Fast case - exact division
          if (dm.mod.isZero()) return dm.div;

          var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

          var half = num.ushrn(1);
          var r2 = num.andln(1);
          var cmp = mod.cmp(half);

          // Round down
          if (cmp < 0 || (r2 === 1 && cmp === 0)) return dm.div;

          // Round up
          return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
        };

        BN.prototype.modrn = function modrn(num) {
          var isNegNum = num < 0;
          if (isNegNum) num = -num;

          assert(num <= 0x3ffffff);
          var p = (1 << 26) % num;

          var acc = 0;
          for (var i = this.length - 1; i >= 0; i--) {
            acc = (p * acc + (this.words[i] | 0)) % num;
          }

          return isNegNum ? -acc : acc;
        };

        // WARNING: DEPRECATED
        BN.prototype.modn = function modn(num) {
          return this.modrn(num);
        };

        // In-place division by number
        BN.prototype.idivn = function idivn(num) {
          var isNegNum = num < 0;
          if (isNegNum) num = -num;

          assert(num <= 0x3ffffff);

          var carry = 0;
          for (var i = this.length - 1; i >= 0; i--) {
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = (w / num) | 0;
            carry = w % num;
          }

          this._strip();
          return isNegNum ? this.ineg() : this;
        };

        BN.prototype.divn = function divn(num) {
          return this.clone().idivn(num);
        };

        BN.prototype.egcd = function egcd(p) {
          assert(p.negative === 0);
          assert(!p.isZero());

          var x = this;
          var y = p.clone();

          if (x.negative !== 0) {
            x = x.umod(p);
          } else {
            x = x.clone();
          }

          // A * x + B * y = x
          var A = new BN(1);
          var B = new BN(0);

          // C * x + D * y = y
          var C = new BN(0);
          var D = new BN(1);

          var g = 0;

          while (x.isEven() && y.isEven()) {
            x.iushrn(1);
            y.iushrn(1);
            ++g;
          }

          var yp = y.clone();
          var xp = x.clone();

          while (!x.isZero()) {
            for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
              x.iushrn(i);
              while (i-- > 0) {
                if (A.isOdd() || B.isOdd()) {
                  A.iadd(yp);
                  B.isub(xp);
                }

                A.iushrn(1);
                B.iushrn(1);
              }
            }

            for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
              y.iushrn(j);
              while (j-- > 0) {
                if (C.isOdd() || D.isOdd()) {
                  C.iadd(yp);
                  D.isub(xp);
                }

                C.iushrn(1);
                D.iushrn(1);
              }
            }

            if (x.cmp(y) >= 0) {
              x.isub(y);
              A.isub(C);
              B.isub(D);
            } else {
              y.isub(x);
              C.isub(A);
              D.isub(B);
            }
          }

          return {
            a: C,
            b: D,
            gcd: y.iushln(g)
          };
        };

        // This is reduced incarnation of the binary EEA
        // above, designated to invert members of the
        // _prime_ fields F(p) at a maximal speed
        BN.prototype._invmp = function _invmp(p) {
          assert(p.negative === 0);
          assert(!p.isZero());

          var a = this;
          var b = p.clone();

          if (a.negative !== 0) {
            a = a.umod(p);
          } else {
            a = a.clone();
          }

          var x1 = new BN(1);
          var x2 = new BN(0);

          var delta = b.clone();

          while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
            for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
              a.iushrn(i);
              while (i-- > 0) {
                if (x1.isOdd()) {
                  x1.iadd(delta);
                }

                x1.iushrn(1);
              }
            }

            for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
              b.iushrn(j);
              while (j-- > 0) {
                if (x2.isOdd()) {
                  x2.iadd(delta);
                }

                x2.iushrn(1);
              }
            }

            if (a.cmp(b) >= 0) {
              a.isub(b);
              x1.isub(x2);
            } else {
              b.isub(a);
              x2.isub(x1);
            }
          }

          var res;
          if (a.cmpn(1) === 0) {
            res = x1;
          } else {
            res = x2;
          }

          if (res.cmpn(0) < 0) {
            res.iadd(p);
          }

          return res;
        };

        BN.prototype.gcd = function gcd(num) {
          if (this.isZero()) return num.abs();
          if (num.isZero()) return this.abs();

          var a = this.clone();
          var b = num.clone();
          a.negative = 0;
          b.negative = 0;

          // Remove common factor of two
          for (var shift = 0; a.isEven() && b.isEven(); shift++) {
            a.iushrn(1);
            b.iushrn(1);
          }

          do {
            while (a.isEven()) {
              a.iushrn(1);
            }
            while (b.isEven()) {
              b.iushrn(1);
            }

            var r = a.cmp(b);
            if (r < 0) {
              // Swap `a` and `b` to make `a` always bigger than `b`
              var t = a;
              a = b;
              b = t;
            } else if (r === 0 || b.cmpn(1) === 0) {
              break;
            }

            a.isub(b);
          } while (true);

          return b.iushln(shift);
        };

        // Invert number in the field F(num)
        BN.prototype.invm = function invm(num) {
          return this.egcd(num).a.umod(num);
        };

        BN.prototype.isEven = function isEven() {
          return (this.words[0] & 1) === 0;
        };

        BN.prototype.isOdd = function isOdd() {
          return (this.words[0] & 1) === 1;
        };

        // And first word and num
        BN.prototype.andln = function andln(num) {
          return this.words[0] & num;
        };

        // Increment at the bit position in-line
        BN.prototype.bincn = function bincn(bit) {
          assert(typeof bit === 'number');
          var r = bit % 26;
          var s = (bit - r) / 26;
          var q = 1 << r;

          // Fast case: bit is much higher than all existing words
          if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
          }

          // Add bit and propagate, if needed
          var carry = q;
          for (var i = s; carry !== 0 && i < this.length; i++) {
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
          }
          if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
          }
          return this;
        };

        BN.prototype.isZero = function isZero() {
          return this.length === 1 && this.words[0] === 0;
        };

        BN.prototype.cmpn = function cmpn(num) {
          var negative = num < 0;

          if (this.negative !== 0 && !negative) return -1;
          if (this.negative === 0 && negative) return 1;

          this._strip();

          var res;
          if (this.length > 1) {
            res = 1;
          } else {
            if (negative) {
              num = -num;
            }

            assert(num <= 0x3ffffff, 'Number is too big');

            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
          }
          if (this.negative !== 0) return -res | 0;
          return res;
        };

        // Compare two numbers and return:
        // 1 - if `this` > `num`
        // 0 - if `this` == `num`
        // -1 - if `this` < `num`
        BN.prototype.cmp = function cmp(num) {
          if (this.negative !== 0 && num.negative === 0) return -1;
          if (this.negative === 0 && num.negative !== 0) return 1;

          var res = this.ucmp(num);
          if (this.negative !== 0) return -res | 0;
          return res;
        };

        // Unsigned comparison
        BN.prototype.ucmp = function ucmp(num) {
          // At this point both numbers have the same sign
          if (this.length > num.length) return 1;
          if (this.length < num.length) return -1;

          var res = 0;
          for (var i = this.length - 1; i >= 0; i--) {
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;

            if (a === b) continue;
            if (a < b) {
              res = -1;
            } else if (a > b) {
              res = 1;
            }
            break;
          }
          return res;
        };

        BN.prototype.gtn = function gtn(num) {
          return this.cmpn(num) === 1;
        };

        BN.prototype.gt = function gt(num) {
          return this.cmp(num) === 1;
        };

        BN.prototype.gten = function gten(num) {
          return this.cmpn(num) >= 0;
        };

        BN.prototype.gte = function gte(num) {
          return this.cmp(num) >= 0;
        };

        BN.prototype.ltn = function ltn(num) {
          return this.cmpn(num) === -1;
        };

        BN.prototype.lt = function lt(num) {
          return this.cmp(num) === -1;
        };

        BN.prototype.lten = function lten(num) {
          return this.cmpn(num) <= 0;
        };

        BN.prototype.lte = function lte(num) {
          return this.cmp(num) <= 0;
        };

        BN.prototype.eqn = function eqn(num) {
          return this.cmpn(num) === 0;
        };

        BN.prototype.eq = function eq(num) {
          return this.cmp(num) === 0;
        };

        //
        // A reduce context, could be using montgomery or something better, depending
        // on the `m` itself.
        //
        BN.red = function red(num) {
          return new Red(num);
        };

        BN.prototype.toRed = function toRed(ctx) {
          assert(!this.red, 'Already a number in reduction context');
          assert(this.negative === 0, 'red works only with positives');
          return ctx.convertTo(this)._forceRed(ctx);
        };

        BN.prototype.fromRed = function fromRed() {
          assert(this.red, 'fromRed works only with numbers in reduction context');
          return this.red.convertFrom(this);
        };

        BN.prototype._forceRed = function _forceRed(ctx) {
          this.red = ctx;
          return this;
        };

        BN.prototype.forceRed = function forceRed(ctx) {
          assert(!this.red, 'Already a number in reduction context');
          return this._forceRed(ctx);
        };

        BN.prototype.redAdd = function redAdd(num) {
          assert(this.red, 'redAdd works only with red numbers');
          return this.red.add(this, num);
        };

        BN.prototype.redIAdd = function redIAdd(num) {
          assert(this.red, 'redIAdd works only with red numbers');
          return this.red.iadd(this, num);
        };

        BN.prototype.redSub = function redSub(num) {
          assert(this.red, 'redSub works only with red numbers');
          return this.red.sub(this, num);
        };

        BN.prototype.redISub = function redISub(num) {
          assert(this.red, 'redISub works only with red numbers');
          return this.red.isub(this, num);
        };

        BN.prototype.redShl = function redShl(num) {
          assert(this.red, 'redShl works only with red numbers');
          return this.red.shl(this, num);
        };

        BN.prototype.redMul = function redMul(num) {
          assert(this.red, 'redMul works only with red numbers');
          this.red._verify2(this, num);
          return this.red.mul(this, num);
        };

        BN.prototype.redIMul = function redIMul(num) {
          assert(this.red, 'redMul works only with red numbers');
          this.red._verify2(this, num);
          return this.red.imul(this, num);
        };

        BN.prototype.redSqr = function redSqr() {
          assert(this.red, 'redSqr works only with red numbers');
          this.red._verify1(this);
          return this.red.sqr(this);
        };

        BN.prototype.redISqr = function redISqr() {
          assert(this.red, 'redISqr works only with red numbers');
          this.red._verify1(this);
          return this.red.isqr(this);
        };

        // Square root over p
        BN.prototype.redSqrt = function redSqrt() {
          assert(this.red, 'redSqrt works only with red numbers');
          this.red._verify1(this);
          return this.red.sqrt(this);
        };

        BN.prototype.redInvm = function redInvm() {
          assert(this.red, 'redInvm works only with red numbers');
          this.red._verify1(this);
          return this.red.invm(this);
        };

        // Return negative clone of `this` % `red modulo`
        BN.prototype.redNeg = function redNeg() {
          assert(this.red, 'redNeg works only with red numbers');
          this.red._verify1(this);
          return this.red.neg(this);
        };

        BN.prototype.redPow = function redPow(num) {
          assert(this.red && !num.red, 'redPow(normalNum)');
          this.red._verify1(this);
          return this.red.pow(this, num);
        };

        // Prime numbers with efficient reduction
        var primes = {
          k256: null,
          p224: null,
          p192: null,
          p25519: null
        };

        // Pseudo-Mersenne prime
        function MPrime(name, p) {
          // P = 2 ^ N - K
          this.name = name;
          this.p = new BN(p, 16);
          this.n = this.p.bitLength();
          this.k = new BN(1).iushln(this.n).isub(this.p);

          this.tmp = this._tmp();
        }

        MPrime.prototype._tmp = function _tmp() {
          var tmp = new BN(null);
          tmp.words = new Array(Math.ceil(this.n / 13));
          return tmp;
        };

        MPrime.prototype.ireduce = function ireduce(num) {
          // Assumes that `num` is less than `P^2`
          // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
          var r = num;
          var rlen;

          do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
          } while (rlen > this.n);

          var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
          if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
          } else if (cmp > 0) {
            r.isub(this.p);
          } else {
            if (r.strip !== undefined) {
              // r is a BN v4 instance
              r.strip();
            } else {
              // r is a BN v5 instance
              r._strip();
            }
          }

          return r;
        };

        MPrime.prototype.split = function split(input, out) {
          input.iushrn(this.n, 0, out);
        };

        MPrime.prototype.imulK = function imulK(num) {
          return num.imul(this.k);
        };

        function K256() {
          MPrime.call(
            this,
            'k256',
            'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
        }
        inherits(K256, MPrime);

        K256.prototype.split = function split(input, output) {
          // 256 = 9 * 26 + 22
          var mask = 0x3fffff;

          var outLen = Math.min(input.length, 9);
          for (var i = 0; i < outLen; i++) {
            output.words[i] = input.words[i];
          }
          output.length = outLen;

          if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
          }

          // Shift by 9 limbs
          var prev = input.words[9];
          output.words[output.length++] = prev & mask;

          for (i = 10; i < input.length; i++) {
            var next = input.words[i] | 0;
            input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
            prev = next;
          }
          prev >>>= 22;
          input.words[i - 10] = prev;
          if (prev === 0 && input.length > 10) {
            input.length -= 10;
          } else {
            input.length -= 9;
          }
        };

        K256.prototype.imulK = function imulK(num) {
          // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
          num.words[num.length] = 0;
          num.words[num.length + 1] = 0;
          num.length += 2;

          // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
          var lo = 0;
          for (var i = 0; i < num.length; i++) {
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + ((lo / 0x4000000) | 0);
          }

          // Fast length reduction
          if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) {
              num.length--;
            }
          }
          return num;
        };

        function P224() {
          MPrime.call(
            this,
            'p224',
            'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
        }
        inherits(P224, MPrime);

        function P192() {
          MPrime.call(
            this,
            'p192',
            'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
        }
        inherits(P192, MPrime);

        function P25519() {
          // 2 ^ 255 - 19
          MPrime.call(
            this,
            '25519',
            '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
        }
        inherits(P25519, MPrime);

        P25519.prototype.imulK = function imulK(num) {
          // K = 0x13
          var carry = 0;
          for (var i = 0; i < num.length; i++) {
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;

            num.words[i] = lo;
            carry = hi;
          }
          if (carry !== 0) {
            num.words[num.length++] = carry;
          }
          return num;
        };

        // Exported mostly for testing purposes, use plain name instead
        BN._prime = function prime(name) {
          // Cached version of prime
          if (primes[name]) return primes[name];

          var prime;
          if (name === 'k256') {
            prime = new K256();
          } else if (name === 'p224') {
            prime = new P224();
          } else if (name === 'p192') {
            prime = new P192();
          } else if (name === 'p25519') {
            prime = new P25519();
          } else {
            throw new Error('Unknown prime ' + name);
          }
          primes[name] = prime;

          return prime;
        };

        //
        // Base reduction engine
        //
        function Red(m) {
          if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
          } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
          }
        }

        Red.prototype._verify1 = function _verify1(a) {
          assert(a.negative === 0, 'red works only with positives');
          assert(a.red, 'red works only with red numbers');
        };

        Red.prototype._verify2 = function _verify2(a, b) {
          assert((a.negative | b.negative) === 0, 'red works only with positives');
          assert(a.red && a.red === b.red,
            'red works only with red numbers');
        };

        Red.prototype.imod = function imod(a) {
          if (this.prime) return this.prime.ireduce(a)._forceRed(this);

          move(a, a.umod(this.m)._forceRed(this));
          return a;
        };

        Red.prototype.neg = function neg(a) {
          if (a.isZero()) {
            return a.clone();
          }

          return this.m.sub(a)._forceRed(this);
        };

        Red.prototype.add = function add(a, b) {
          this._verify2(a, b);

          var res = a.add(b);
          if (res.cmp(this.m) >= 0) {
            res.isub(this.m);
          }
          return res._forceRed(this);
        };

        Red.prototype.iadd = function iadd(a, b) {
          this._verify2(a, b);

          var res = a.iadd(b);
          if (res.cmp(this.m) >= 0) {
            res.isub(this.m);
          }
          return res;
        };

        Red.prototype.sub = function sub(a, b) {
          this._verify2(a, b);

          var res = a.sub(b);
          if (res.cmpn(0) < 0) {
            res.iadd(this.m);
          }
          return res._forceRed(this);
        };

        Red.prototype.isub = function isub(a, b) {
          this._verify2(a, b);

          var res = a.isub(b);
          if (res.cmpn(0) < 0) {
            res.iadd(this.m);
          }
          return res;
        };

        Red.prototype.shl = function shl(a, num) {
          this._verify1(a);
          return this.imod(a.ushln(num));
        };

        Red.prototype.imul = function imul(a, b) {
          this._verify2(a, b);
          return this.imod(a.imul(b));
        };

        Red.prototype.mul = function mul(a, b) {
          this._verify2(a, b);
          return this.imod(a.mul(b));
        };

        Red.prototype.isqr = function isqr(a) {
          return this.imul(a, a.clone());
        };

        Red.prototype.sqr = function sqr(a) {
          return this.mul(a, a);
        };

        Red.prototype.sqrt = function sqrt(a) {
          if (a.isZero()) return a.clone();

          var mod3 = this.m.andln(3);
          assert(mod3 % 2 === 1);

          // Fast case
          if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
          }

          // Tonelli-Shanks algorithm (Totally unoptimized and slow)
          //
          // Find Q and S, that Q * 2 ^ S = (P - 1)
          var q = this.m.subn(1);
          var s = 0;
          while (!q.isZero() && q.andln(1) === 0) {
            s++;
            q.iushrn(1);
          }
          assert(!q.isZero());

          var one = new BN(1).toRed(this);
          var nOne = one.redNeg();

          // Find quadratic non-residue
          // NOTE: Max is such because of generalized Riemann hypothesis.
          var lpow = this.m.subn(1).iushrn(1);
          var z = this.m.bitLength();
          z = new BN(2 * z * z).toRed(this);

          while (this.pow(z, lpow).cmp(nOne) !== 0) {
            z.redIAdd(nOne);
          }

          var c = this.pow(z, q);
          var r = this.pow(a, q.addn(1).iushrn(1));
          var t = this.pow(a, q);
          var m = s;
          while (t.cmp(one) !== 0) {
            var tmp = t;
            for (var i = 0; tmp.cmp(one) !== 0; i++) {
              tmp = tmp.redSqr();
            }
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));

            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
          }

          return r;
        };

        Red.prototype.invm = function invm(a) {
          var inv = a._invmp(this.m);
          if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
          } else {
            return this.imod(inv);
          }
        };

        Red.prototype.pow = function pow(a, num) {
          if (num.isZero()) return new BN(1).toRed(this);
          if (num.cmpn(1) === 0) return a.clone();

          var windowSize = 4;
          var wnd = new Array(1 << windowSize);
          wnd[0] = new BN(1).toRed(this);
          wnd[1] = a;
          for (var i = 2; i < wnd.length; i++) {
            wnd[i] = this.mul(wnd[i - 1], a);
          }

          var res = wnd[0];
          var current = 0;
          var currentLen = 0;
          var start = num.bitLength() % 26;
          if (start === 0) {
            start = 26;
          }

          for (i = num.length - 1; i >= 0; i--) {
            var word = num.words[i];
            for (var j = start - 1; j >= 0; j--) {
              var bit = (word >> j) & 1;
              if (res !== wnd[0]) {
                res = this.sqr(res);
              }

              if (bit === 0 && current === 0) {
                currentLen = 0;
                continue;
              }

              current <<= 1;
              current |= bit;
              currentLen++;
              if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

              res = this.mul(res, wnd[current]);
              currentLen = 0;
              current = 0;
            }
            start = 26;
          }

          return res;
        };

        Red.prototype.convertTo = function convertTo(num) {
          var r = num.umod(this.m);

          return r === num ? r.clone() : r;
        };

        Red.prototype.convertFrom = function convertFrom(num) {
          var res = num.clone();
          res.red = null;
          return res;
        };

        //
        // Montgomery method engine
        //

        BN.mont = function mont(num) {
          return new Mont(num);
        };

        function Mont(m) {
          Red.call(this, m);

          this.shift = this.m.bitLength();
          if (this.shift % 26 !== 0) {
            this.shift += 26 - (this.shift % 26);
          }

          this.r = new BN(1).iushln(this.shift);
          this.r2 = this.imod(this.r.sqr());
          this.rinv = this.r._invmp(this.m);

          this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
          this.minv = this.minv.umod(this.r);
          this.minv = this.r.sub(this.minv);
        }
        inherits(Mont, Red);

        Mont.prototype.convertTo = function convertTo(num) {
          return this.imod(num.ushln(this.shift));
        };

        Mont.prototype.convertFrom = function convertFrom(num) {
          var r = this.imod(num.mul(this.rinv));
          r.red = null;
          return r;
        };

        Mont.prototype.imul = function imul(a, b) {
          if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
          }

          var t = a.imul(b);
          var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
          var u = t.isub(c).iushrn(this.shift);
          var res = u;

          if (u.cmp(this.m) >= 0) {
            res = u.isub(this.m);
          } else if (u.cmpn(0) < 0) {
            res = u.iadd(this.m);
          }

          return res._forceRed(this);
        };

        Mont.prototype.mul = function mul(a, b) {
          if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

          var t = a.mul(b);
          var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
          var u = t.isub(c).iushrn(this.shift);
          var res = u;
          if (u.cmp(this.m) >= 0) {
            res = u.isub(this.m);
          } else if (u.cmpn(0) < 0) {
            res = u.iadd(this.m);
          }

          return res._forceRed(this);
        };

        Mont.prototype.invm = function invm(a) {
          // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
          var res = this.imod(a._invmp(this.m).mul(this.r2));
          return res._forceRed(this);
        };
      })(typeof module === 'undefined' || module, this);

    }, { "buffer": 172 }], 171: [function (require, module, exports) {
      arguments[4][65][0].apply(exports, arguments)
    }, { "crypto": 172, "dup": 65 }], 172: [function (require, module, exports) {

    }, {}], 173: [function (require, module, exports) {
      // based on the aes implimentation in triple sec
      // https://github.com/keybase/triplesec
      // which is in turn based on the one from crypto-js
      // https://code.google.com/p/crypto-js/

      var Buffer = require('safe-buffer').Buffer

      function asUInt32Array(buf) {
        if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)

        var len = (buf.length / 4) | 0
        var out = new Array(len)

        for (var i = 0; i < len; i++) {
          out[i] = buf.readUInt32BE(i * 4)
        }

        return out
      }

      function scrubVec(v) {
        for (var i = 0; i < v.length; v++) {
          v[i] = 0
        }
      }

      function cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
        var SUB_MIX0 = SUB_MIX[0]
        var SUB_MIX1 = SUB_MIX[1]
        var SUB_MIX2 = SUB_MIX[2]
        var SUB_MIX3 = SUB_MIX[3]

        var s0 = M[0] ^ keySchedule[0]
        var s1 = M[1] ^ keySchedule[1]
        var s2 = M[2] ^ keySchedule[2]
        var s3 = M[3] ^ keySchedule[3]
        var t0, t1, t2, t3
        var ksRow = 4

        for (var round = 1; round < nRounds; round++) {
          t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[(s1 >>> 16) & 0xff] ^ SUB_MIX2[(s2 >>> 8) & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++]
          t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[(s2 >>> 16) & 0xff] ^ SUB_MIX2[(s3 >>> 8) & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++]
          t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[(s3 >>> 16) & 0xff] ^ SUB_MIX2[(s0 >>> 8) & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++]
          t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[(s0 >>> 16) & 0xff] ^ SUB_MIX2[(s1 >>> 8) & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++]
          s0 = t0
          s1 = t1
          s2 = t2
          s3 = t3
        }

        t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
        t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
        t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
        t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
        t0 = t0 >>> 0
        t1 = t1 >>> 0
        t2 = t2 >>> 0
        t3 = t3 >>> 0

        return [t0, t1, t2, t3]
      }

      // AES constants
      var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
      var G = (function () {
        // Compute double table
        var d = new Array(256)
        for (var j = 0; j < 256; j++) {
          if (j < 128) {
            d[j] = j << 1
          } else {
            d[j] = (j << 1) ^ 0x11b
          }
        }

        var SBOX = []
        var INV_SBOX = []
        var SUB_MIX = [[], [], [], []]
        var INV_SUB_MIX = [[], [], [], []]

        // Walk GF(2^8)
        var x = 0
        var xi = 0
        for (var i = 0; i < 256; ++i) {
          // Compute sbox
          var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
          sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
          SBOX[x] = sx
          INV_SBOX[sx] = x

          // Compute multiplication
          var x2 = d[x]
          var x4 = d[x2]
          var x8 = d[x4]

          // Compute sub bytes, mix columns tables
          var t = (d[sx] * 0x101) ^ (sx * 0x1010100)
          SUB_MIX[0][x] = (t << 24) | (t >>> 8)
          SUB_MIX[1][x] = (t << 16) | (t >>> 16)
          SUB_MIX[2][x] = (t << 8) | (t >>> 24)
          SUB_MIX[3][x] = t

          // Compute inv sub bytes, inv mix columns tables
          t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
          INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
          INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
          INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
          INV_SUB_MIX[3][sx] = t

          if (x === 0) {
            x = xi = 1
          } else {
            x = x2 ^ d[d[d[x8 ^ x2]]]
            xi ^= d[d[xi]]
          }
        }

        return {
          SBOX: SBOX,
          INV_SBOX: INV_SBOX,
          SUB_MIX: SUB_MIX,
          INV_SUB_MIX: INV_SUB_MIX
        }
      })()

      function AES(key) {
        this._key = asUInt32Array(key)
        this._reset()
      }

      AES.blockSize = 4 * 4
      AES.keySize = 256 / 8
      AES.prototype.blockSize = AES.blockSize
      AES.prototype.keySize = AES.keySize
      AES.prototype._reset = function () {
        var keyWords = this._key
        var keySize = keyWords.length
        var nRounds = keySize + 6
        var ksRows = (nRounds + 1) * 4

        var keySchedule = []
        for (var k = 0; k < keySize; k++) {
          keySchedule[k] = keyWords[k]
        }

        for (k = keySize; k < ksRows; k++) {
          var t = keySchedule[k - 1]

          if (k % keySize === 0) {
            t = (t << 8) | (t >>> 24)
            t =
              (G.SBOX[t >>> 24] << 24) |
              (G.SBOX[(t >>> 16) & 0xff] << 16) |
              (G.SBOX[(t >>> 8) & 0xff] << 8) |
              (G.SBOX[t & 0xff])

            t ^= RCON[(k / keySize) | 0] << 24
          } else if (keySize > 6 && k % keySize === 4) {
            t =
              (G.SBOX[t >>> 24] << 24) |
              (G.SBOX[(t >>> 16) & 0xff] << 16) |
              (G.SBOX[(t >>> 8) & 0xff] << 8) |
              (G.SBOX[t & 0xff])
          }

          keySchedule[k] = keySchedule[k - keySize] ^ t
        }

        var invKeySchedule = []
        for (var ik = 0; ik < ksRows; ik++) {
          var ksR = ksRows - ik
          var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)]

          if (ik < 4 || ksR <= 4) {
            invKeySchedule[ik] = tt
          } else {
            invKeySchedule[ik] =
              G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^
              G.INV_SUB_MIX[1][G.SBOX[(tt >>> 16) & 0xff]] ^
              G.INV_SUB_MIX[2][G.SBOX[(tt >>> 8) & 0xff]] ^
              G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]]
          }
        }

        this._nRounds = nRounds
        this._keySchedule = keySchedule
        this._invKeySchedule = invKeySchedule
      }

      AES.prototype.encryptBlockRaw = function (M) {
        M = asUInt32Array(M)
        return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds)
      }

      AES.prototype.encryptBlock = function (M) {
        var out = this.encryptBlockRaw(M)
        var buf = Buffer.allocUnsafe(16)
        buf.writeUInt32BE(out[0], 0)
        buf.writeUInt32BE(out[1], 4)
        buf.writeUInt32BE(out[2], 8)
        buf.writeUInt32BE(out[3], 12)
        return buf
      }

      AES.prototype.decryptBlock = function (M) {
        M = asUInt32Array(M)

        // swap
        var m1 = M[1]
        M[1] = M[3]
        M[3] = m1

        var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds)
        var buf = Buffer.allocUnsafe(16)
        buf.writeUInt32BE(out[0], 0)
        buf.writeUInt32BE(out[3], 4)
        buf.writeUInt32BE(out[2], 8)
        buf.writeUInt32BE(out[1], 12)
        return buf
      }

      AES.prototype.scrub = function () {
        scrubVec(this._keySchedule)
        scrubVec(this._invKeySchedule)
        scrubVec(this._key)
      }

      module.exports.AES = AES

    }, { "safe-buffer": 315 }], 174: [function (require, module, exports) {
      var aes = require('./aes')
      var Buffer = require('safe-buffer').Buffer
      var Transform = require('cipher-base')
      var inherits = require('inherits')
      var GHASH = require('./ghash')
      var xor = require('buffer-xor')
      var incr32 = require('./incr32')

      function xorTest(a, b) {
        var out = 0
        if (a.length !== b.length) out++

        var len = Math.min(a.length, b.length)
        for (var i = 0; i < len; ++i) {
          out += (a[i] ^ b[i])
        }

        return out
      }

      function calcIv(self, iv, ck) {
        if (iv.length === 12) {
          self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])])
          return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])])
        }
        var ghash = new GHASH(ck)
        var len = iv.length
        var toPad = len % 16
        ghash.update(iv)
        if (toPad) {
          toPad = 16 - toPad
          ghash.update(Buffer.alloc(toPad, 0))
        }
        ghash.update(Buffer.alloc(8, 0))
        var ivBits = len * 8
        var tail = Buffer.alloc(8)
        tail.writeUIntBE(ivBits, 0, 8)
        ghash.update(tail)
        self._finID = ghash.state
        var out = Buffer.from(self._finID)
        incr32(out)
        return out
      }
      function StreamCipher(mode, key, iv, decrypt) {
        Transform.call(this)

        var h = Buffer.alloc(4, 0)

        this._cipher = new aes.AES(key)
        var ck = this._cipher.encryptBlock(h)
        this._ghash = new GHASH(ck)
        iv = calcIv(this, iv, ck)

        this._prev = Buffer.from(iv)
        this._cache = Buffer.allocUnsafe(0)
        this._secCache = Buffer.allocUnsafe(0)
        this._decrypt = decrypt
        this._alen = 0
        this._len = 0
        this._mode = mode

        this._authTag = null
        this._called = false
      }

      inherits(StreamCipher, Transform)

      StreamCipher.prototype._update = function (chunk) {
        if (!this._called && this._alen) {
          var rump = 16 - (this._alen % 16)
          if (rump < 16) {
            rump = Buffer.alloc(rump, 0)
            this._ghash.update(rump)
          }
        }

        this._called = true
        var out = this._mode.encrypt(this, chunk)
        if (this._decrypt) {
          this._ghash.update(chunk)
        } else {
          this._ghash.update(out)
        }
        this._len += chunk.length
        return out
      }

      StreamCipher.prototype._final = function () {
        if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data')

        var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
        if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data')

        this._authTag = tag
        this._cipher.scrub()
      }

      StreamCipher.prototype.getAuthTag = function getAuthTag() {
        if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state')

        return this._authTag
      }

      StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
        if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state')

        this._authTag = tag
      }

      StreamCipher.prototype.setAAD = function setAAD(buf) {
        if (this._called) throw new Error('Attempting to set AAD in unsupported state')

        this._ghash.update(buf)
        this._alen += buf.length
      }

      module.exports = StreamCipher

    }, { "./aes": 173, "./ghash": 178, "./incr32": 179, "buffer-xor": 215, "cipher-base": 217, "inherits": 285, "safe-buffer": 315 }], 175: [function (require, module, exports) {
      var ciphers = require('./encrypter')
      var deciphers = require('./decrypter')
      var modes = require('./modes/list.json')

      function getCiphers() {
        return Object.keys(modes)
      }

      exports.createCipher = exports.Cipher = ciphers.createCipher
      exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
      exports.createDecipher = exports.Decipher = deciphers.createDecipher
      exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
      exports.listCiphers = exports.getCiphers = getCiphers

    }, { "./decrypter": 176, "./encrypter": 177, "./modes/list.json": 187 }], 176: [function (require, module, exports) {
      var AuthCipher = require('./authCipher')
      var Buffer = require('safe-buffer').Buffer
      var MODES = require('./modes')
      var StreamCipher = require('./streamCipher')
      var Transform = require('cipher-base')
      var aes = require('./aes')
      var ebtk = require('evp_bytestokey')
      var inherits = require('inherits')

      function Decipher(mode, key, iv) {
        Transform.call(this)

        this._cache = new Splitter()
        this._last = void 0
        this._cipher = new aes.AES(key)
        this._prev = Buffer.from(iv)
        this._mode = mode
        this._autopadding = true
      }

      inherits(Decipher, Transform)

      Decipher.prototype._update = function (data) {
        this._cache.add(data)
        var chunk
        var thing
        var out = []
        while ((chunk = this._cache.get(this._autopadding))) {
          thing = this._mode.decrypt(this, chunk)
          out.push(thing)
        }
        return Buffer.concat(out)
      }

      Decipher.prototype._final = function () {
        var chunk = this._cache.flush()
        if (this._autopadding) {
          return unpad(this._mode.decrypt(this, chunk))
        } else if (chunk) {
          throw new Error('data not multiple of block length')
        }
      }

      Decipher.prototype.setAutoPadding = function (setTo) {
        this._autopadding = !!setTo
        return this
      }

      function Splitter() {
        this.cache = Buffer.allocUnsafe(0)
      }

      Splitter.prototype.add = function (data) {
        this.cache = Buffer.concat([this.cache, data])
      }

      Splitter.prototype.get = function (autoPadding) {
        var out
        if (autoPadding) {
          if (this.cache.length > 16) {
            out = this.cache.slice(0, 16)
            this.cache = this.cache.slice(16)
            return out
          }
        } else {
          if (this.cache.length >= 16) {
            out = this.cache.slice(0, 16)
            this.cache = this.cache.slice(16)
            return out
          }
        }

        return null
      }

      Splitter.prototype.flush = function () {
        if (this.cache.length) return this.cache
      }

      function unpad(last) {
        var padded = last[15]
        if (padded < 1 || padded > 16) {
          throw new Error('unable to decrypt data')
        }
        var i = -1
        while (++i < padded) {
          if (last[(i + (16 - padded))] !== padded) {
            throw new Error('unable to decrypt data')
          }
        }
        if (padded === 16) return

        return last.slice(0, 16 - padded)
      }

      function createDecipheriv(suite, password, iv) {
        var config = MODES[suite.toLowerCase()]
        if (!config) throw new TypeError('invalid suite type')

        if (typeof iv === 'string') iv = Buffer.from(iv)
        if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

        if (typeof password === 'string') password = Buffer.from(password)
        if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

        if (config.type === 'stream') {
          return new StreamCipher(config.module, password, iv, true)
        } else if (config.type === 'auth') {
          return new AuthCipher(config.module, password, iv, true)
        }

        return new Decipher(config.module, password, iv)
      }

      function createDecipher(suite, password) {
        var config = MODES[suite.toLowerCase()]
        if (!config) throw new TypeError('invalid suite type')

        var keys = ebtk(password, false, config.key, config.iv)
        return createDecipheriv(suite, keys.key, keys.iv)
      }

      exports.createDecipher = createDecipher
      exports.createDecipheriv = createDecipheriv

    }, { "./aes": 173, "./authCipher": 174, "./modes": 186, "./streamCipher": 189, "cipher-base": 217, "evp_bytestokey": 254, "inherits": 285, "safe-buffer": 315 }], 177: [function (require, module, exports) {
      var MODES = require('./modes')
      var AuthCipher = require('./authCipher')
      var Buffer = require('safe-buffer').Buffer
      var StreamCipher = require('./streamCipher')
      var Transform = require('cipher-base')
      var aes = require('./aes')
      var ebtk = require('evp_bytestokey')
      var inherits = require('inherits')

      function Cipher(mode, key, iv) {
        Transform.call(this)

        this._cache = new Splitter()
        this._cipher = new aes.AES(key)
        this._prev = Buffer.from(iv)
        this._mode = mode
        this._autopadding = true
      }

      inherits(Cipher, Transform)

      Cipher.prototype._update = function (data) {
        this._cache.add(data)
        var chunk
        var thing
        var out = []

        while ((chunk = this._cache.get())) {
          thing = this._mode.encrypt(this, chunk)
          out.push(thing)
        }

        return Buffer.concat(out)
      }

      var PADDING = Buffer.alloc(16, 0x10)

      Cipher.prototype._final = function () {
        var chunk = this._cache.flush()
        if (this._autopadding) {
          chunk = this._mode.encrypt(this, chunk)
          this._cipher.scrub()
          return chunk
        }

        if (!chunk.equals(PADDING)) {
          this._cipher.scrub()
          throw new Error('data not multiple of block length')
        }
      }

      Cipher.prototype.setAutoPadding = function (setTo) {
        this._autopadding = !!setTo
        return this
      }

      function Splitter() {
        this.cache = Buffer.allocUnsafe(0)
      }

      Splitter.prototype.add = function (data) {
        this.cache = Buffer.concat([this.cache, data])
      }

      Splitter.prototype.get = function () {
        if (this.cache.length > 15) {
          var out = this.cache.slice(0, 16)
          this.cache = this.cache.slice(16)
          return out
        }
        return null
      }

      Splitter.prototype.flush = function () {
        var len = 16 - this.cache.length
        var padBuff = Buffer.allocUnsafe(len)

        var i = -1
        while (++i < len) {
          padBuff.writeUInt8(len, i)
        }

        return Buffer.concat([this.cache, padBuff])
      }

      function createCipheriv(suite, password, iv) {
        var config = MODES[suite.toLowerCase()]
        if (!config) throw new TypeError('invalid suite type')

        if (typeof password === 'string') password = Buffer.from(password)
        if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

        if (typeof iv === 'string') iv = Buffer.from(iv)
        if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

        if (config.type === 'stream') {
          return new StreamCipher(config.module, password, iv)
        } else if (config.type === 'auth') {
          return new AuthCipher(config.module, password, iv)
        }

        return new Cipher(config.module, password, iv)
      }

      function createCipher(suite, password) {
        var config = MODES[suite.toLowerCase()]
        if (!config) throw new TypeError('invalid suite type')

        var keys = ebtk(password, false, config.key, config.iv)
        return createCipheriv(suite, keys.key, keys.iv)
      }

      exports.createCipheriv = createCipheriv
      exports.createCipher = createCipher

    }, { "./aes": 173, "./authCipher": 174, "./modes": 186, "./streamCipher": 189, "cipher-base": 217, "evp_bytestokey": 254, "inherits": 285, "safe-buffer": 315 }], 178: [function (require, module, exports) {
      var Buffer = require('safe-buffer').Buffer
      var ZEROES = Buffer.alloc(16, 0)

      function toArray(buf) {
        return [
          buf.readUInt32BE(0),
          buf.readUInt32BE(4),
          buf.readUInt32BE(8),
          buf.readUInt32BE(12)
        ]
      }

      function fromArray(out) {
        var buf = Buffer.allocUnsafe(16)
        buf.writeUInt32BE(out[0] >>> 0, 0)
        buf.writeUInt32BE(out[1] >>> 0, 4)
        buf.writeUInt32BE(out[2] >>> 0, 8)
        buf.writeUInt32BE(out[3] >>> 0, 12)
        return buf
      }

      function GHASH(key) {
        this.h = key
        this.state = Buffer.alloc(16, 0)
        this.cache = Buffer.allocUnsafe(0)
      }

      // from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
      // by Juho Vähä-Herttua
      GHASH.prototype.ghash = function (block) {
        var i = -1
        while (++i < block.length) {
          this.state[i] ^= block[i]
        }
        this._multiply()
      }

      GHASH.prototype._multiply = function () {
        var Vi = toArray(this.h)
        var Zi = [0, 0, 0, 0]
        var j, xi, lsbVi
        var i = -1
        while (++i < 128) {
          xi = (this.state[~~(i / 8)] & (1 << (7 - (i % 8)))) !== 0
          if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0]
            Zi[1] ^= Vi[1]
            Zi[2] ^= Vi[2]
            Zi[3] ^= Vi[3]
          }

          // Store the value of LSB(V_i)
          lsbVi = (Vi[3] & 1) !== 0

          // V_i+1 = V_i >> 1
          for (j = 3; j > 0; j--) {
            Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
          }
          Vi[0] = Vi[0] >>> 1

          // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
          if (lsbVi) {
            Vi[0] = Vi[0] ^ (0xe1 << 24)
          }
        }
        this.state = fromArray(Zi)
      }

      GHASH.prototype.update = function (buf) {
        this.cache = Buffer.concat([this.cache, buf])
        var chunk
        while (this.cache.length >= 16) {
          chunk = this.cache.slice(0, 16)
          this.cache = this.cache.slice(16)
          this.ghash(chunk)
        }
      }

      GHASH.prototype.final = function (abl, bl) {
        if (this.cache.length) {
          this.ghash(Buffer.concat([this.cache, ZEROES], 16))
        }

        this.ghash(fromArray([0, abl, 0, bl]))
        return this.state
      }

      module.exports = GHASH

    }, { "safe-buffer": 315 }], 179: [function (require, module, exports) {
      function incr32(iv) {
        var len = iv.length
        var item
        while (len--) {
          item = iv.readUInt8(len)
          if (item === 255) {
            iv.writeUInt8(0, len)
          } else {
            item++
            iv.writeUInt8(item, len)
            break
          }
        }
      }
      module.exports = incr32

    }, {}], 180: [function (require, module, exports) {
      var xor = require('buffer-xor')

      exports.encrypt = function (self, block) {
        var data = xor(block, self._prev)

        self._prev = self._cipher.encryptBlock(data)
        return self._prev
      }

      exports.decrypt = function (self, block) {
        var pad = self._prev

        self._prev = block
        var out = self._cipher.decryptBlock(block)

        return xor(out, pad)
      }

    }, { "buffer-xor": 215 }], 181: [function (require, module, exports) {
      var Buffer = require('safe-buffer').Buffer
      var xor = require('buffer-xor')

      function encryptStart(self, data, decrypt) {
        var len = data.length
        var out = xor(data, self._cache)
        self._cache = self._cache.slice(len)
        self._prev = Buffer.concat([self._prev, decrypt ? data : out])
        return out
      }

      exports.encrypt = function (self, data, decrypt) {
        var out = Buffer.allocUnsafe(0)
        var len

        while (data.length) {
          if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev)
            self._prev = Buffer.allocUnsafe(0)
          }

          if (self._cache.length <= data.length) {
            len = self._cache.length
            out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
            data = data.slice(len)
          } else {
            out = Buffer.concat([out, encryptStart(self, data, decrypt)])
            break
          }
        }

        return out
      }

    }, { "buffer-xor": 215, "safe-buffer": 315 }], 182: [function (require, module, exports) {
      var Buffer = require('safe-buffer').Buffer

      function encryptByte(self, byteParam, decrypt) {
        var pad
        var i = -1
        var len = 8
        var out = 0
        var bit, value
        while (++i < len) {
          pad = self._cipher.encryptBlock(self._prev)
          bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
          value = pad[0] ^ bit
          out += ((value & 0x80) >> (i % 8))
          self._prev = shiftIn(self._prev, decrypt ? bit : value)
        }
        return out
      }

      function shiftIn(buffer, value) {
        var len = buffer.length
        var i = -1
        var out = Buffer.allocUnsafe(buffer.length)
        buffer = Buffer.concat([buffer, Buffer.from([value])])

        while (++i < len) {
          out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
        }

        return out
      }

      exports.encrypt = function (self, chunk, decrypt) {
        var len = chunk.length
        var out = Buffer.allocUnsafe(len)
        var i = -1

        while (++i < len) {
          out[i] = encryptByte(self, chunk[i], decrypt)
        }

        return out
      }

    }, { "safe-buffer": 315 }], 183: [function (require, module, exports) {
      var Buffer = require('safe-buffer').Buffer

      function encryptByte(self, byteParam, decrypt) {
        var pad = self._cipher.encryptBlock(self._prev)
        var out = pad[0] ^ byteParam

        self._prev = Buffer.concat([
          self._prev.slice(1),
          Buffer.from([decrypt ? byteParam : out])
        ])

        return out
      }

      exports.encrypt = function (self, chunk, decrypt) {
        var len = chunk.length
        var out = Buffer.allocUnsafe(len)
        var i = -1

        while (++i < len) {
          out[i] = encryptByte(self, chunk[i], decrypt)
        }

        return out
      }

    }, { "safe-buffer": 315 }], 184: [function (require, module, exports) {
      var xor = require('buffer-xor')
      var Buffer = require('safe-buffer').Buffer
      var incr32 = require('../incr32')

      function getBlock(self) {
        var out = self._cipher.encryptBlockRaw(self._prev)
        incr32(self._prev)
        return out
      }

      var blockSize = 16
      exports.encrypt = function (self, chunk) {
        var chunkNum = Math.ceil(chunk.length / blockSize)
        var start = self._cache.length
        self._cache = Buffer.concat([
          self._cache,
          Buffer.allocUnsafe(chunkNum * blockSize)
        ])
        for (var i = 0; i < chunkNum; i++) {
          var out = getBlock(self)
          var offset = start + i * blockSize
          self._cache.writeUInt32BE(out[0], offset + 0)
          self._cache.writeUInt32BE(out[1], offset + 4)
          self._cache.writeUInt32BE(out[2], offset + 8)
          self._cache.writeUInt32BE(out[3], offset + 12)
        }
        var pad = self._cache.slice(0, chunk.length)
        self._cache = self._cache.slice(chunk.length)
        return xor(chunk, pad)
      }

    }, { "../incr32": 179, "buffer-xor": 215, "safe-buffer": 315 }], 185: [function (require, module, exports) {
      exports.encrypt = function (self, block) {
        return self._cipher.encryptBlock(block)
      }

      exports.decrypt = function (self, block) {
        return self._cipher.decryptBlock(block)
      }

    }, {}], 186: [function (require, module, exports) {
      var modeModules = {
        ECB: require('./ecb'),
        CBC: require('./cbc'),
        CFB: require('./cfb'),
        CFB8: require('./cfb8'),
        CFB1: require('./cfb1'),
        OFB: require('./ofb'),
        CTR: require('./ctr'),
        GCM: require('./ctr')
      }

      var modes = require('./list.json')

      for (var key in modes) {
        modes[key].module = modeModules[modes[key].mode]
      }

      module.exports = modes

    }, { "./cbc": 180, "./cfb": 181, "./cfb1": 182, "./cfb8": 183, "./ctr": 184, "./ecb": 185, "./list.json": 187, "./ofb": 188 }], 187: [function (require, module, exports) {
      module.exports = {
        "aes-128-ecb": {
          "cipher": "AES",
          "key": 128,
          "iv": 0,
          "mode": "ECB",
          "type": "block"
        },
        "aes-192-ecb": {
          "cipher": "AES",
          "key": 192,
          "iv": 0,
          "mode": "ECB",
          "type": "block"
        },
        "aes-256-ecb": {
          "cipher": "AES",
          "key": 256,
          "iv": 0,
          "mode": "ECB",
          "type": "block"
        },
        "aes-128-cbc": {
          "cipher": "AES",
          "key": 128,
          "iv": 16,
          "mode": "CBC",
          "type": "block"
        },
        "aes-192-cbc": {
          "cipher": "AES",
          "key": 192,
          "iv": 16,
          "mode": "CBC",
          "type": "block"
        },
        "aes-256-cbc": {
          "cipher": "AES",
          "key": 256,
          "iv": 16,
          "mode": "CBC",
          "type": "block"
        },
        "aes128": {
          "cipher": "AES",
          "key": 128,
          "iv": 16,
          "mode": "CBC",
          "type": "block"
        },
        "aes192": {
          "cipher": "AES",
          "key": 192,
          "iv": 16,
          "mode": "CBC",
          "type": "block"
        },
        "aes256": {
          "cipher": "AES",
          "key": 256,
          "iv": 16,
          "mode": "CBC",
          "type": "block"
        },
        "aes-128-cfb": {
          "cipher": "AES",
          "key": 128,
          "iv": 16,
          "mode": "CFB",
          "type": "stream"
        },
        "aes-192-cfb": {
          "cipher": "AES",
          "key": 192,
          "iv": 16,
          "mode": "CFB",
          "type": "stream"
        },
        "aes-256-cfb": {
          "cipher": "AES",
          "key": 256,
          "iv": 16,
          "mode": "CFB",
          "type": "stream"
        },
        "aes-128-cfb8": {
          "cipher": "AES",
          "key": 128,
          "iv": 16,
          "mode": "CFB8",
          "type": "stream"
        },
        "aes-192-cfb8": {
          "cipher": "AES",
          "key": 192,
          "iv": 16,
          "mode": "CFB8",
          "type": "stream"
        },
        "aes-256-cfb8": {
          "cipher": "AES",
          "key": 256,
          "iv": 16,
          "mode": "CFB8",
          "type": "stream"
        },
        "aes-128-cfb1": {
          "cipher": "AES",
          "key": 128,
          "iv": 16,
          "mode": "CFB1",
          "type": "stream"
        },
        "aes-192-cfb1": {
          "cipher": "AES",
          "key": 192,
          "iv": 16,
          "mode": "CFB1",
          "type": "stream"
        },
        "aes-256-cfb1": {
          "cipher": "AES",
          "key": 256,
          "iv": 16,
          "mode": "CFB1",
          "type": "stream"
        },
        "aes-128-ofb": {
          "cipher": "AES",
          "key": 128,
          "iv": 16,
          "mode": "OFB",
          "type": "stream"
        },
        "aes-192-ofb": {
          "cipher": "AES",
          "key": 192,
          "iv": 16,
          "mode": "OFB",
          "type": "stream"
        },
        "aes-256-ofb": {
          "cipher": "AES",
          "key": 256,
          "iv": 16,
          "mode": "OFB",
          "type": "stream"
        },
        "aes-128-ctr": {
          "cipher": "AES",
          "key": 128,
          "iv": 16,
          "mode": "CTR",
          "type": "stream"
        },
        "aes-192-ctr": {
          "cipher": "AES",
          "key": 192,
          "iv": 16,
          "mode": "CTR",
          "type": "stream"
        },
        "aes-256-ctr": {
          "cipher": "AES",
          "key": 256,
          "iv": 16,
          "mode": "CTR",
          "type": "stream"
        },
        "aes-128-gcm": {
          "cipher": "AES",
          "key": 128,
          "iv": 12,
          "mode": "GCM",
          "type": "auth"
        },
        "aes-192-gcm": {
          "cipher": "AES",
          "key": 192,
          "iv": 12,
          "mode": "GCM",
          "type": "auth"
        },
        "aes-256-gcm": {
          "cipher": "AES",
          "key": 256,
          "iv": 12,
          "mode": "GCM",
          "type": "auth"
        }
      }

    }, {}], 188: [function (require, module, exports) {
      (function (Buffer) {
        (function () {
          var xor = require('buffer-xor')

          function getBlock(self) {
            self._prev = self._cipher.encryptBlock(self._prev)
            return self._prev
          }

          exports.encrypt = function (self, chunk) {
            while (self._cache.length < chunk.length) {
              self._cache = Buffer.concat([self._cache, getBlock(self)])
            }

            var pad = self._cache.slice(0, chunk.length)
            self._cache = self._cache.slice(chunk.length)
            return xor(chunk, pad)
          }

        }).call(this)
      }).call(this, require("buffer").Buffer)
    }, { "buffer": 216, "buffer-xor": 215 }], 189: [function (require, module, exports) {
      var aes = require('./aes')
      var Buffer = require('safe-buffer').Buffer
      var Transform = require('cipher-base')
      var inherits = require('inherits')

      function StreamCipher(mode, key, iv, decrypt) {
        Transform.call(this)

        this._cipher = new aes.AES(key)
        this._prev = Buffer.from(iv)
        this._cache = Buffer.allocUnsafe(0)
        this._secCache = Buffer.allocUnsafe(0)
        this._decrypt = decrypt
        this._mode = mode
      }

      inherits(StreamCipher, Transform)

      StreamCipher.prototype._update = function (chunk) {
        return this._mode.encrypt(this, chunk, this._decrypt)
      }

      StreamCipher.prototype._final = function () {
        this._cipher.scrub()
      }

      module.exports = StreamCipher

    }, { "./aes": 173, "cipher-base": 217, "inherits": 285, "safe-buffer": 315 }], 190: [function (require, module, exports) {
      var DES = require('browserify-des')
      var aes = require('browserify-aes/browser')
      var aesModes = require('browserify-aes/modes')
      var desModes = require('browserify-des/modes')
      var ebtk = require('evp_bytestokey')

      function createCipher(suite, password) {
        suite = suite.toLowerCase()

        var keyLen, ivLen
        if (aesModes[suite]) {
          keyLen = aesModes[suite].key
          ivLen = aesModes[suite].iv
        } else if (desModes[suite]) {
          keyLen = desModes[suite].key * 8
          ivLen = desModes[suite].iv
        } else {
          throw new TypeError('invalid suite type')
        }

        var keys = ebtk(password, false, keyLen, ivLen)
        return createCipheriv(suite, keys.key, keys.iv)
      }

      function createDecipher(suite, password) {
        suite = suite.toLowerCase()

        var keyLen, ivLen
        if (aesModes[suite]) {
          keyLen = aesModes[suite].key
          ivLen = aesModes[suite].iv
        } else if (desModes[suite]) {
          keyLen = desModes[suite].key * 8
          ivLen = desModes[suite].iv
        } else {
          throw new TypeError('invalid suite type')
        }

        var keys = ebtk(password, false, keyLen, ivLen)
        return createDecipheriv(suite, keys.key, keys.iv)
      }

      function createCipheriv(suite, key, iv) {
        suite = suite.toLowerCase()
        if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
        if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })

        throw new TypeError('invalid suite type')
      }

      function createDecipheriv(suite, key, iv) {
        suite = suite.toLowerCase()
        if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
        if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })

        throw new TypeError('invalid suite type')
      }

      function getCiphers() {
        return Object.keys(desModes).concat(aes.getCiphers())
      }

      exports.createCipher = exports.Cipher = createCipher
      exports.createCipheriv = exports.Cipheriv = createCipheriv
      exports.createDecipher = exports.Decipher = createDecipher
      exports.createDecipheriv = exports.Decipheriv = createDecipheriv
      exports.listCiphers = exports.getCiphers = getCiphers

    }, { "browserify-aes/browser": 175, "browserify-aes/modes": 186, "browserify-des": 191, "browserify-des/modes": 192, "evp_bytestokey": 254 }], 191: [function (require, module, exports) {
      var CipherBase = require('cipher-base')
      var des = require('des.js')
      var inherits = require('inherits')
      var Buffer = require('safe-buffer').Buffer

      var modes = {
        'des-ede3-cbc': des.CBC.instantiate(des.EDE),
        'des-ede3': des.EDE,
        'des-ede-cbc': des.CBC.instantiate(des.EDE),
        'des-ede': des.EDE,
        'des-cbc': des.CBC.instantiate(des.DES),
        'des-ecb': des.DES
      }
      modes.des = modes['des-cbc']
      modes.des3 = modes['des-ede3-cbc']
      module.exports = DES
      inherits(DES, CipherBase)
      function DES(opts) {
        CipherBase.call(this)
        var modeName = opts.mode.toLowerCase()
        var mode = modes[modeName]
        var type
        if (opts.decrypt) {
          type = 'decrypt'
        } else {
          type = 'encrypt'
        }
        var key = opts.key
        if (!Buffer.isBuffer(key)) {
          key = Buffer.from(key)
        }
        if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
          key = Buffer.concat([key, key.slice(0, 8)])
        }
        var iv = opts.iv
        if (!Buffer.isBuffer(iv)) {
          iv = Buffer.from(iv)
        }
        this._des = mode.create({
          key: key,
          iv: iv,
          type: type
        })
      }
      DES.prototype._update = function (data) {
        return Buffer.from(this._des.update(data))
      }
      DES.prototype._final = function () {
        return Buffer.from(this._des.final())
      }

    }, { "cipher-base": 217, "des.js": 225, "inherits": 285, "safe-buffer": 315 }], 192: [function (require, module, exports) {
      exports['des-ecb'] = {
        key: 8,
        iv: 0
      }
      exports['des-cbc'] = exports.des = {
        key: 8,
        iv: 8
      }
      exports['des-ede3-cbc'] = exports.des3 = {
        key: 24,
        iv: 8
      }
      exports['des-ede3'] = {
        key: 24,
        iv: 0
      }
      exports['des-ede-cbc'] = {
        key: 16,
        iv: 8
      }
      exports['des-ede'] = {
        key: 16,
        iv: 0
      }

    }, {}], 193: [function (require, module, exports) {
      (function (Buffer) {
        (function () {
          var BN = require('bn.js')
          var randomBytes = require('randombytes')

          function blind(priv) {
            var r = getr(priv)
            var blinder = r.toRed(BN.mont(priv.modulus)).redPow(new BN(priv.publicExponent)).fromRed()
            return { blinder: blinder, unblinder: r.invm(priv.modulus) }
          }

          function getr(priv) {
            var len = priv.modulus.byteLength()
            var r
            do {
              r = new BN(randomBytes(len))
            } while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2))
            return r
          }

          function crt(msg, priv) {
            var blinds = blind(priv)
            var len = priv.modulus.byteLength()
            var blinded = new BN(msg).mul(blinds.blinder).umod(priv.modulus)
            var c1 = blinded.toRed(BN.mont(priv.prime1))
            var c2 = blinded.toRed(BN.mont(priv.prime2))
            var qinv = priv.coefficient
            var p = priv.prime1
            var q = priv.prime2
            var m1 = c1.redPow(priv.exponent1).fromRed()
            var m2 = c2.redPow(priv.exponent2).fromRed()
            var h = m1.isub(m2).imul(qinv).umod(p).imul(q)
            return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike(Buffer, 'be', len)
          }
          crt.getr = getr

          module.exports = crt

        }).call(this)
      }).call(this, require("buffer").Buffer)
    }, { "bn.js": 170, "buffer": 216, "randombytes": 312 }], 194: [function (require, module, exports) {
      module.exports = require('./browser/algorithms.json')

    }, { "./browser/algorithms.json": 195 }], 195: [function (require, module, exports) {
      module.exports = {
        "sha224WithRSAEncryption": {
          "sign": "rsa",
          "hash": "sha224",
          "id": "302d300d06096086480165030402040500041c"
        },
        "RSA-SHA224": {
          "sign": "ecdsa/rsa",
          "hash": "sha224",
          "id": "302d300d06096086480165030402040500041c"
        },
        "sha256WithRSAEncryption": {
          "sign": "rsa",
          "hash": "sha256",
          "id": "3031300d060960864801650304020105000420"
        },
        "RSA-SHA256": {
          "sign": "ecdsa/rsa",
          "hash": "sha256",
          "id": "3031300d060960864801650304020105000420"
        },
        "sha384WithRSAEncryption": {
          "sign": "rsa",
          "hash": "sha384",
          "id": "3041300d060960864801650304020205000430"
        },
        "RSA-SHA384": {
          "sign": "ecdsa/rsa",
          "hash": "sha384",
          "id": "3041300d060960864801650304020205000430"
        },
        "sha512WithRSAEncryption": {
          "sign": "rsa",
          "hash": "sha512",
          "id": "3051300d060960864801650304020305000440"
        },
        "RSA-SHA512": {
          "sign": "ecdsa/rsa",
          "hash": "sha512",
          "id": "3051300d060960864801650304020305000440"
        },
        "RSA-SHA1": {
          "sign": "rsa",
          "hash": "sha1",
          "id": "3021300906052b0e03021a05000414"
        },
        "ecdsa-with-SHA1": {
          "sign": "ecdsa",
          "hash": "sha1",
          "id": ""
        },
        "sha256": {
          "sign": "ecdsa",
          "hash": "sha256",
          "id": ""
        },
        "sha224": {
          "sign": "ecdsa",
          "hash": "sha224",
          "id": ""
        },
        "sha384": {
          "sign": "ecdsa",
          "hash": "sha384",
          "id": ""
        },
        "sha512": {
          "sign": "ecdsa",
          "hash": "sha512",
          "id": ""
        },
        "DSA-SHA": {
          "sign": "dsa",
          "hash": "sha1",
          "id": ""
        },
        "DSA-SHA1": {
          "sign": "dsa",
          "hash": "sha1",
          "id": ""
        },
        "DSA": {
          "sign": "dsa",
          "hash": "sha1",
          "id": ""
        },
        "DSA-WITH-SHA224": {
          "sign": "dsa",
          "hash": "sha224",
          "id": ""
        },
        "DSA-SHA224": {
          "sign": "dsa",
          "hash": "sha224",
          "id": ""
        },
        "DSA-WITH-SHA256": {
          "sign": "dsa",
          "hash": "sha256",
          "id": ""
        },
        "DSA-SHA256": {
          "sign": "dsa",
          "hash": "sha256",
          "id": ""
        },
        "DSA-WITH-SHA384": {
          "sign": "dsa",
          "hash": "sha384",
          "id": ""
        },
        "DSA-SHA384": {
          "sign": "dsa",
          "hash": "sha384",
          "id": ""
        },
        "DSA-WITH-SHA512": {
          "sign": "dsa",
          "hash": "sha512",
          "id": ""
        },
        "DSA-SHA512": {
          "sign": "dsa",
          "hash": "sha512",
          "id": ""
        },
        "DSA-RIPEMD160": {
          "sign": "dsa",
          "hash": "rmd160",
          "id": ""
        },
        "ripemd160WithRSA": {
          "sign": "rsa",
          "hash": "rmd160",
          "id": "3021300906052b2403020105000414"
        },
        "RSA-RIPEMD160": {
          "sign": "rsa",
          "hash": "rmd160",
          "id": "3021300906052b2403020105000414"
        },
        "md5WithRSAEncryption": {
          "sign": "rsa",
          "hash": "md5",
          "id": "3020300c06082a864886f70d020505000410"
        },
        "RSA-MD5": {
          "sign": "rsa",
          "hash": "md5",
          "id": "3020300c06082a864886f70d020505000410"
        }
      }

    }, {}], 196: [function (require, module, exports) {
      module.exports = {
        "1.3.132.0.10": "secp256k1",
        "1.3.132.0.33": "p224",
        "1.2.840.10045.3.1.1": "p192",
        "1.2.840.10045.3.1.7": "p256",
        "1.3.132.0.34": "p384",
        "1.3.132.0.35": "p521"
      }

    }, {}], 197: [function (require, module, exports) {
      var Buffer = require('safe-buffer').Buffer
      var createHash = require('create-hash')
      var stream = require('readable-stream')
      var inherits = require('inherits')
      var sign = require('./sign')
      var verify = require('./verify')

      var algorithms = require('./algorithms.json')
      Object.keys(algorithms).forEach(function (key) {
        algorithms[key].id = Buffer.from(algorithms[key].id, 'hex')
        algorithms[key.toLowerCase()] = algorithms[key]
      })

      function Sign(algorithm) {
        stream.Writable.call(this)

        var data = algorithms[algorithm]
        if (!data) throw new Error('Unknown message digest')

        this._hashType = data.hash
        this._hash = createHash(data.hash)
        this._tag = data.id
        this._signType = data.sign
      }
      inherits(Sign, stream.Writable)

      Sign.prototype._write = function _write(data, _, done) {
        this._hash.update(data)
        done()
      }

      Sign.prototype.update = function update(data, enc) {
        if (typeof data === 'string') data = Buffer.from(data, enc)

        this._hash.update(data)
        return this
      }

      Sign.prototype.sign = function signMethod(key, enc) {
        this.end()
        var hash = this._hash.digest()
        var sig = sign(hash, key, this._hashType, this._signType, this._tag)

        return enc ? sig.toString(enc) : sig
      }

      function Verify(algorithm) {
        stream.Writable.call(this)

        var data = algorithms[algorithm]
        if (!data) throw new Error('Unknown message digest')

        this._hash = createHash(data.hash)
        this._tag = data.id
        this._signType = data.sign
      }
      inherits(Verify, stream.Writable)

      Verify.prototype._write = function _write(data, _, done) {
        this._hash.update(data)
        done()
      }

      Verify.prototype.update = function update(data, enc) {
        if (typeof data === 'string') data = Buffer.from(data, enc)

        this._hash.update(data)
        return this
      }

      Verify.prototype.verify = function verifyMethod(key, sig, enc) {
        if (typeof sig === 'string') sig = Buffer.from(sig, enc)

        this.end()
        var hash = this._hash.digest()
        return verify(sig, hash, key, this._signType, this._tag)
      }

      function createSign(algorithm) {
        return new Sign(algorithm)
      }

      function createVerify(algorithm) {
        return new Verify(algorithm)
      }

      module.exports = {
        Sign: createSign,
        Verify: createVerify,
        createSign: createSign,
        createVerify: createVerify
      }

    }, { "./algorithms.json": 195, "./sign": 198, "./verify": 199, "create-hash": 220, "inherits": 285, "readable-stream": 214, "safe-buffer": 315 }], 198: [function (require, module, exports) {
      // much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
      var Buffer = require('safe-buffer').Buffer
      var createHmac = require('create-hmac')
      var crt = require('browserify-rsa')
      var EC = require('elliptic').ec
      var BN = require('bn.js')
      var parseKeys = require('parse-asn1')
      var curves = require('./curves.json')

      function sign(hash, key, hashType, signType, tag) {
        var priv = parseKeys(key)
        if (priv.curve) {
          // rsa keys can be interpreted as ecdsa ones in openssl
          if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
          return ecSign(hash, priv)
        } else if (priv.type === 'dsa') {
          if (signType !== 'dsa') throw new Error('wrong private key type')
          return dsaSign(hash, priv, hashType)
        } else {
          if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
        }
        hash = Buffer.concat([tag, hash])
        var len = priv.modulus.byteLength()
        var pad = [0, 1]
        while (hash.length + pad.length + 1 < len) pad.push(0xff)
        pad.push(0x00)
        var i = -1
        while (++i < hash.length) pad.push(hash[i])

        var out = crt(pad, priv)
        return out
      }

      function ecSign(hash, priv) {
        var curveId = curves[priv.curve.join('.')]
        if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'))

        var curve = new EC(curveId)
        var key = curve.keyFromPrivate(priv.privateKey)
        var out = key.sign(hash)

        return Buffer.from(out.toDER())
      }

      function dsaSign(hash, priv, algo) {
        var x = priv.params.priv_key
        var p = priv.params.p
        var q = priv.params.q
        var g = priv.params.g
        var r = new BN(0)
        var k
        var H = bits2int(hash, q).mod(q)
        var s = false
        var kv = getKey(x, q, hash, algo)
        while (s === false) {
          k = makeKey(q, kv, algo)
          r = makeR(g, k, p, q)
          s = k.invm(q).imul(H.add(x.mul(r))).mod(q)
          if (s.cmpn(0) === 0) {
            s = false
            r = new BN(0)
          }
        }
        return toDER(r, s)
      }

      function toDER(r, s) {
        r = r.toArray()
        s = s.toArray()

        // Pad values
        if (r[0] & 0x80) r = [0].concat(r)
        if (s[0] & 0x80) s = [0].concat(s)

        var total = r.length + s.length + 4
        var res = [0x30, total, 0x02, r.length]
        res = res.concat(r, [0x02, s.length], s)
        return Buffer.from(res)
      }

      function getKey(x, q, hash, algo) {
        x = Buffer.from(x.toArray())
        if (x.length < q.byteLength()) {
          var zeros = Buffer.alloc(q.byteLength() - x.length)
          x = Buffer.concat([zeros, x])
        }
        var hlen = hash.length
        var hbits = bits2octets(hash, q)
        var v = Buffer.alloc(hlen)
        v.fill(1)
        var k = Buffer.alloc(hlen)
        k = createHmac(algo, k).update(v).update(Buffer.from([0])).update(x).update(hbits).digest()
        v = createHmac(algo, k).update(v).digest()
        k = createHmac(algo, k).update(v).update(Buffer.from([1])).update(x).update(hbits).digest()
        v = createHmac(algo, k).update(v).digest()
        return { k: k, v: v }
      }

      function bits2int(obits, q) {
        var bits = new BN(obits)
        var shift = (obits.length << 3) - q.bitLength()
        if (shift > 0) bits.ishrn(shift)
        return bits
      }

      function bits2octets(bits, q) {
        bits = bits2int(bits, q)
        bits = bits.mod(q)
        var out = Buffer.from(bits.toArray())
        if (out.length < q.byteLength()) {
          var zeros = Buffer.alloc(q.byteLength() - out.length)
          out = Buffer.concat([zeros, out])
        }
        return out
      }

      function makeKey(q, kv, algo) {
        var t
        var k

        do {
          t = Buffer.alloc(0)

          while (t.length * 8 < q.bitLength()) {
            kv.v = createHmac(algo, kv.k).update(kv.v).digest()
            t = Buffer.concat([t, kv.v])
          }

          k = bits2int(t, q)
          kv.k = createHmac(algo, kv.k).update(kv.v).update(Buffer.from([0])).digest()
          kv.v = createHmac(algo, kv.k).update(kv.v).digest()
        } while (k.cmp(q) !== -1)

        return k
      }

      function makeR(g, k, p, q) {
        return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q)
      }

      module.exports = sign
      module.exports.getKey = getKey
      module.exports.makeKey = makeKey

    }, { "./curves.json": 196, "bn.js": 170, "browserify-rsa": 193, "create-hmac": 222, "elliptic": 236, "parse-asn1": 297, "safe-buffer": 315 }], 199: [function (require, module, exports) {
      // much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
      var Buffer = require('safe-buffer').Buffer
      var BN = require('bn.js')
      var EC = require('elliptic').ec
      var parseKeys = require('parse-asn1')
      var curves = require('./curves.json')

      function verify(sig, hash, key, signType, tag) {
        var pub = parseKeys(key)
        if (pub.type === 'ec') {
          // rsa keys can be interpreted as ecdsa ones in openssl
          if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
          return ecVerify(sig, hash, pub)
        } else if (pub.type === 'dsa') {
          if (signType !== 'dsa') throw new Error('wrong public key type')
          return dsaVerify(sig, hash, pub)
        } else {
          if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
        }
        hash = Buffer.concat([tag, hash])
        var len = pub.modulus.byteLength()
        var pad = [1]
        var padNum = 0
        while (hash.length + pad.length + 2 < len) {
          pad.push(0xff)
          padNum++
        }
        pad.push(0x00)
        var i = -1
        while (++i < hash.length) {
          pad.push(hash[i])
        }
        pad = Buffer.from(pad)
        var red = BN.mont(pub.modulus)
        sig = new BN(sig).toRed(red)

        sig = sig.redPow(new BN(pub.publicExponent))
        sig = Buffer.from(sig.fromRed().toArray())
        var out = padNum < 8 ? 1 : 0
        len = Math.min(sig.length, pad.length)
        if (sig.length !== pad.length) out = 1

        i = -1
        while (++i < len) out |= sig[i] ^ pad[i]
        return out === 0
      }

      function ecVerify(sig, hash, pub) {
        var curveId = curves[pub.data.algorithm.curve.join('.')]
        if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'))

        var curve = new EC(curveId)
        var pubkey = pub.data.subjectPrivateKey.data

        return curve.verify(hash, sig, pubkey)
      }

      function dsaVerify(sig, hash, pub) {
        var p = pub.data.p
        var q = pub.data.q
        var g = pub.data.g
        var y = pub.data.pub_key
        var unpacked = parseKeys.signature.decode(sig, 'der')
        var s = unpacked.s
        var r = unpacked.r
        checkValue(s, q)
        checkValue(r, q)
        var montp = BN.mont(p)
        var w = s.invm(q)
        var v = g.toRed(montp)
          .redPow(new BN(hash).mul(w).mod(q))
          .fromRed()
          .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
          .mod(p)
          .mod(q)
        return v.cmp(r) === 0
      }

      function checkValue(b, q) {
        if (b.cmpn(0) <= 0) throw new Error('invalid sig')
        if (b.cmp(q) >= q) throw new Error('invalid sig')
      }

      module.exports = verify

    }, { "./curves.json": 196, "bn.js": 170, "elliptic": 236, "parse-asn1": 297, "safe-buffer": 315 }], 200: [function (require, module, exports) {
      arguments[4][117][0].apply(exports, arguments)
    }, { "dup": 117 }], 201: [function (require, module, exports) {
      arguments[4][118][0].apply(exports, arguments)
    }, { "./_stream_readable": 203, "./_stream_writable": 205, "_process": 304, "dup": 118, "inherits": 285 }], 202: [function (require, module, exports) {
      arguments[4][119][0].apply(exports, arguments)
    }, { "./_stream_transform": 204, "dup": 119, "inherits": 285 }], 203: [function (require, module, exports) {
      arguments[4][120][0].apply(exports, arguments)
    }, { "../errors": 200, "./_stream_duplex": 201, "./internal/streams/async_iterator": 206, "./internal/streams/buffer_list": 207, "./internal/streams/destroy": 208, "./internal/streams/from": 210, "./internal/streams/state": 212, "./internal/streams/stream": 213, "_process": 304, "buffer": 216, "dup": 120, "events": 253, "inherits": 285, "string_decoder/": 340, "util": 172 }], 204: [function (require, module, exports) {
      arguments[4][121][0].apply(exports, arguments)
    }, { "../errors": 200, "./_stream_duplex": 201, "dup": 121, "inherits": 285 }], 205: [function (require, module, exports) {
      arguments[4][122][0].apply(exports, arguments)
    }, { "../errors": 200, "./_stream_duplex": 201, "./internal/streams/destroy": 208, "./internal/streams/state": 212, "./internal/streams/stream": 213, "_process": 304, "buffer": 216, "dup": 122, "inherits": 285, "util-deprecate": 341 }], 206: [function (require, module, exports) {
      arguments[4][123][0].apply(exports, arguments)
    }, { "./end-of-stream": 209, "_process": 304, "dup": 123 }], 207: [function (require, module, exports) {
      arguments[4][124][0].apply(exports, arguments)
    }, { "buffer": 216, "dup": 124, "util": 172 }], 208: [function (require, module, exports) {
      arguments[4][125][0].apply(exports, arguments)
    }, { "_process": 304, "dup": 125 }], 209: [function (require, module, exports) {
      arguments[4][126][0].apply(exports, arguments)
    }, { "../../../errors": 200, "dup": 126 }], 210: [function (require, module, exports) {
      arguments[4][127][0].apply(exports, arguments)
    }, { "dup": 127 }], 211: [function (require, module, exports) {
      arguments[4][128][0].apply(exports, arguments)
    }, { "../../../errors": 200, "./end-of-stream": 209, "dup": 128 }], 212: [function (require, module, exports) {
      arguments[4][129][0].apply(exports, arguments)
    }, { "../../../errors": 200, "dup": 129 }], 213: [function (require, module, exports) {
      arguments[4][130][0].apply(exports, arguments)
    }, { "dup": 130, "events": 253 }], 214: [function (require, module, exports) {
      arguments[4][131][0].apply(exports, arguments)
    }, { "./lib/_stream_duplex.js": 201, "./lib/_stream_passthrough.js": 202, "./lib/_stream_readable.js": 203, "./lib/_stream_transform.js": 204, "./lib/_stream_writable.js": 205, "./lib/internal/streams/end-of-stream.js": 209, "./lib/internal/streams/pipeline.js": 211, "dup": 131 }], 215: [function (require, module, exports) {
      (function (Buffer) {
        (function () {
          module.exports = function xor(a, b) {
            var length = Math.min(a.length, b.length)
            var buffer = new Buffer(length)

            for (var i = 0; i < length; ++i) {
              buffer[i] = a[i] ^ b[i]
            }

            return buffer
          }

        }).call(this)
      }).call(this, require("buffer").Buffer)
    }, { "buffer": 216 }], 216: [function (require, module, exports) {
      (function (Buffer) {
        (function () {
          /*!
           * The buffer module from node.js, for the browser.
           *
           * @author   Feross Aboukhadijeh <https://feross.org>
           * @license  MIT
           */
          /* eslint-disable no-proto */

          'use strict'

          var base64 = require('base64-js')
          var ieee754 = require('ieee754')

          exports.Buffer = Buffer
          exports.SlowBuffer = SlowBuffer
          exports.INSPECT_MAX_BYTES = 50

          var K_MAX_LENGTH = 0x7fffffff
          exports.kMaxLength = K_MAX_LENGTH

          /**
           * If `Buffer.TYPED_ARRAY_SUPPORT`:
           *   === true    Use Uint8Array implementation (fastest)
           *   === false   Print warning and recommend using `buffer` v4.x which has an Object
           *               implementation (most compatible, even IE6)
           *
           * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
           * Opera 11.6+, iOS 4.2+.
           *
           * We report that the browser does not support typed arrays if the are not subclassable
           * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
           * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
           * for __proto__ and has a buggy typed array implementation.
           */
          Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

          if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
            typeof console.error === 'function') {
            console.error(
              'This browser lacks typed array (Uint8Array) support which is required by ' +
              '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
            )
          }

          function typedArraySupport() {
            // Can typed array instances can be augmented?
            try {
              var arr = new Uint8Array(1)
              arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function () { return 42 } }
              return arr.foo() === 42
            } catch (e) {
              return false
            }
          }

          Object.defineProperty(Buffer.prototype, 'parent', {
            enumerable: true,
            get: function () {
              if (!Buffer.isBuffer(this)) return undefined
              return this.buffer
            }
          })

          Object.defineProperty(Buffer.prototype, 'offset', {
            enumerable: true,
            get: function () {
              if (!Buffer.isBuffer(this)) return undefined
              return this.byteOffset
            }
          })

          function createBuffer(length) {
            if (length > K_MAX_LENGTH) {
              throw new RangeError('The value "' + length + '" is invalid for option "size"')
            }
            // Return an augmented `Uint8Array` instance
            var buf = new Uint8Array(length)
            buf.__proto__ = Buffer.prototype
            return buf
          }

          /**
           * The Buffer constructor returns instances of `Uint8Array` that have their
           * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
           * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
           * and the `Uint8Array` methods. Square bracket notation works as expected -- it
           * returns a single octet.
           *
           * The `Uint8Array` prototype remains unmodified.
           */

          function Buffer(arg, encodingOrOffset, length) {
            // Common case.
            if (typeof arg === 'number') {
              if (typeof encodingOrOffset === 'string') {
                throw new TypeError(
                  'The "string" argument must be of type string. Received type number'
                )
              }
              return allocUnsafe(arg)
            }
            return from(arg, encodingOrOffset, length)
          }

          // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
          if (typeof Symbol !== 'undefined' && Symbol.species != null &&
            Buffer[Symbol.species] === Buffer) {
            Object.defineProperty(Buffer, Symbol.species, {
              value: null,
              configurable: true,
              enumerable: false,
              writable: false
            })
          }

          Buffer.poolSize = 8192 // not used by this implementation

          function from(value, encodingOrOffset, length) {
            if (typeof value === 'string') {
              return fromString(value, encodingOrOffset)
            }

            if (ArrayBuffer.isView(value)) {
              return fromArrayLike(value)
            }

            if (value == null) {
              throw TypeError(
                'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
                'or Array-like Object. Received type ' + (typeof value)
              )
            }

            if (isInstance(value, ArrayBuffer) ||
              (value && isInstance(value.buffer, ArrayBuffer))) {
              return fromArrayBuffer(value, encodingOrOffset, length)
            }

            if (typeof value === 'number') {
              throw new TypeError(
                'The "value" argument must not be of type number. Received type number'
              )
            }

            var valueOf = value.valueOf && value.valueOf()
            if (valueOf != null && valueOf !== value) {
              return Buffer.from(valueOf, encodingOrOffset, length)
            }

            var b = fromObject(value)
            if (b) return b

            if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
              typeof value[Symbol.toPrimitive] === 'function') {
              return Buffer.from(
                value[Symbol.toPrimitive]('string'), encodingOrOffset, length
              )
            }

            throw new TypeError(
              'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
              'or Array-like Object. Received type ' + (typeof value)
            )
          }

          /**
           * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
           * if value is a number.
           * Buffer.from(str[, encoding])
           * Buffer.from(array)
           * Buffer.from(buffer)
           * Buffer.from(arrayBuffer[, byteOffset[, length]])
           **/
          Buffer.from = function (value, encodingOrOffset, length) {
            return from(value, encodingOrOffset, length)
          }

          // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
          // https://github.com/feross/buffer/pull/148
          Buffer.prototype.__proto__ = Uint8Array.prototype
          Buffer.__proto__ = Uint8Array

          function assertSize(size) {
            if (typeof size !== 'number') {
              throw new TypeError('"size" argument must be of type number')
            } else if (size < 0) {
              throw new RangeError('The value "' + size + '" is invalid for option "size"')
            }
          }

          function alloc(size, fill, encoding) {
            assertSize(size)
            if (size <= 0) {
              return createBuffer(size)
            }
            if (fill !== undefined) {
              // Only pay attention to encoding if it's a string. This
              // prevents accidentally sending in a number that would
              // be interpretted as a start offset.
              return typeof encoding === 'string'
                ? createBuffer(size).fill(fill, encoding)
                : createBuffer(size).fill(fill)
            }
            return createBuffer(size)
          }

          /**
           * Creates a new filled Buffer instance.
           * alloc(size[, fill[, encoding]])
           **/
          Buffer.alloc = function (size, fill, encoding) {
            return alloc(size, fill, encoding)
          }

          function allocUnsafe(size) {
            assertSize(size)
            return createBuffer(size < 0 ? 0 : checked(size) | 0)
          }

          /**
           * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
           * */
          Buffer.allocUnsafe = function (size) {
            return allocUnsafe(size)
          }
          /**
           * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
           */
          Buffer.allocUnsafeSlow = function (size) {
            return allocUnsafe(size)
          }

          function fromString(string, encoding) {
            if (typeof encoding !== 'string' || encoding === '') {
              encoding = 'utf8'
            }

            if (!Buffer.isEncoding(encoding)) {
              throw new TypeError('Unknown encoding: ' + encoding)
            }

            var length = byteLength(string, encoding) | 0
            var buf = createBuffer(length)

            var actual = buf.write(string, encoding)

            if (actual !== length) {
              // Writing a hex string, for example, that contains invalid characters will
              // cause everything after the first invalid character to be ignored. (e.g.
              // 'abxxcd' will be treated as 'ab')
              buf = buf.slice(0, actual)
            }

            return buf
          }

          function fromArrayLike(array) {
            var length = array.length < 0 ? 0 : checked(array.length) | 0
            var buf = createBuffer(length)
            for (var i = 0; i < length; i += 1) {
              buf[i] = array[i] & 255
            }
            return buf
          }

          function fromArrayBuffer(array, byteOffset, length) {
            if (byteOffset < 0 || array.byteLength < byteOffset) {
              throw new RangeError('"offset" is outside of buffer bounds')
            }

            if (array.byteLength < byteOffset + (length || 0)) {
              throw new RangeError('"length" is outside of buffer bounds')
            }

            var buf
            if (byteOffset === undefined && length === undefined) {
              buf = new Uint8Array(array)
            } else if (length === undefined) {
              buf = new Uint8Array(array, byteOffset)
            } else {
              buf = new Uint8Array(array, byteOffset, length)
            }

            // Return an augmented `Uint8Array` instance
            buf.__proto__ = Buffer.prototype
            return buf
          }

          function fromObject(obj) {
            if (Buffer.isBuffer(obj)) {
              var len = checked(obj.length) | 0
              var buf = createBuffer(len)

              if (buf.length === 0) {
                return buf
              }

              obj.copy(buf, 0, 0, len)
              return buf
            }

            if (obj.length !== undefined) {
              if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
                return createBuffer(0)
              }
              return fromArrayLike(obj)
            }

            if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
              return fromArrayLike(obj.data)
            }
          }

          function checked(length) {
            // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
            // length is NaN (which is otherwise coerced to zero.)
            if (length >= K_MAX_LENGTH) {
              throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
            }
            return length | 0
          }

          function SlowBuffer(length) {
            if (+length != length) { // eslint-disable-line eqeqeq
              length = 0
            }
            return Buffer.alloc(+length)
          }

          Buffer.isBuffer = function isBuffer(b) {
            return b != null && b._isBuffer === true &&
              b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
          }

          Buffer.compare = function compare(a, b) {
            if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
            if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
            if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
              throw new TypeError(
                'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
              )
            }

            if (a === b) return 0

            var x = a.length
            var y = b.length

            for (var i = 0, len = Math.min(x, y); i < len; ++i) {
              if (a[i] !== b[i]) {
                x = a[i]
                y = b[i]
                break
              }
            }

            if (x < y) return -1
            if (y < x) return 1
            return 0
          }

          Buffer.isEncoding = function isEncoding(encoding) {
            switch (String(encoding).toLowerCase()) {
              case 'hex':
              case 'utf8':
              case 'utf-8':
              case 'ascii':
              case 'latin1':
              case 'binary':
              case 'base64':
              case 'ucs2':
              case 'ucs-2':
              case 'utf16le':
              case 'utf-16le':
                return true
              default:
                return false
            }
          }

          Buffer.concat = function concat(list, length) {
            if (!Array.isArray(list)) {
              throw new TypeError('"list" argument must be an Array of Buffers')
            }

            if (list.length === 0) {
              return Buffer.alloc(0)
            }

            var i
            if (length === undefined) {
              length = 0
              for (i = 0; i < list.length; ++i) {
                length += list[i].length
              }
            }

            var buffer = Buffer.allocUnsafe(length)
            var pos = 0
            for (i = 0; i < list.length; ++i) {
              var buf = list[i]
              if (isInstance(buf, Uint8Array)) {
                buf = Buffer.from(buf)
              }
              if (!Buffer.isBuffer(buf)) {
                throw new TypeError('"list" argument must be an Array of Buffers')
              }
              buf.copy(buffer, pos)
              pos += buf.length
            }
            return buffer
          }

          function byteLength(string, encoding) {
            if (Buffer.isBuffer(string)) {
              return string.length
            }
            if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
              return string.byteLength
            }
            if (typeof string !== 'string') {
              throw new TypeError(
                'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
                'Received type ' + typeof string
              )
            }

            var len = string.length
            var mustMatch = (arguments.length > 2 && arguments[2] === true)
            if (!mustMatch && len === 0) return 0

            // Use a for loop to avoid recursion
            var loweredCase = false
            for (; ;) {
              switch (encoding) {
                case 'ascii':
                case 'latin1':
                case 'binary':
                  return len
                case 'utf8':
                case 'utf-8':
                  return utf8ToBytes(string).length
                case 'ucs2':
                case 'ucs-2':
                case 'utf16le':
                case 'utf-16le':
                  return len * 2
                case 'hex':
                  return len >>> 1
                case 'base64':
                  return base64ToBytes(string).length
                default:
                  if (loweredCase) {
                    return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
                  }
                  encoding = ('' + encoding).toLowerCase()
                  loweredCase = true
              }
            }
          }
          Buffer.byteLength = byteLength

          function slowToString(encoding, start, end) {
            var loweredCase = false

            // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
            // property of a typed array.

            // This behaves neither like String nor Uint8Array in that we set start/end
            // to their upper/lower bounds if the value passed is out of range.
            // undefined is handled specially as per ECMA-262 6th Edition,
            // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
            if (start === undefined || start < 0) {
              start = 0
            }
            // Return early if start > this.length. Done here to prevent potential uint32
            // coercion fail below.
            if (start > this.length) {
              return ''
            }

            if (end === undefined || end > this.length) {
              end = this.length
            }

            if (end <= 0) {
              return ''
            }

            // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
            end >>>= 0
            start >>>= 0

            if (end <= start) {
              return ''
            }

            if (!encoding) encoding = 'utf8'

            while (true) {
              switch (encoding) {
                case 'hex':
                  return hexSlice(this, start, end)

                case 'utf8':
                case 'utf-8':
                  return utf8Slice(this, start, end)

                case 'ascii':
                  return asciiSlice(this, start, end)

                case 'latin1':
                case 'binary':
                  return latin1Slice(this, start, end)

                case 'base64':
                  return base64Slice(this, start, end)

                case 'ucs2':
                case 'ucs-2':
                case 'utf16le':
                case 'utf-16le':
                  return utf16leSlice(this, start, end)

                default:
                  if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
                  encoding = (encoding + '').toLowerCase()
                  loweredCase = true
              }
            }
          }

          // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
          // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
          // reliably in a browserify context because there could be multiple different
          // copies of the 'buffer' package in use. This method works even for Buffer
          // instances that were created from another copy of the `buffer` package.
          // See: https://github.com/feross/buffer/issues/154
          Buffer.prototype._isBuffer = true

          function swap(b, n, m) {
            var i = b[n]
            b[n] = b[m]
            b[m] = i
          }

          Buffer.prototype.swap16 = function swap16() {
            var len = this.length
            if (len % 2 !== 0) {
              throw new RangeError('Buffer size must be a multiple of 16-bits')
            }
            for (var i = 0; i < len; i += 2) {
              swap(this, i, i + 1)
            }
            return this
          }

          Buffer.prototype.swap32 = function swap32() {
            var len = this.length
            if (len % 4 !== 0) {
              throw new RangeError('Buffer size must be a multiple of 32-bits')
            }
            for (var i = 0; i < len; i += 4) {
              swap(this, i, i + 3)
              swap(this, i + 1, i + 2)
            }
            return this
          }

          Buffer.prototype.swap64 = function swap64() {
            var len = this.length
            if (len % 8 !== 0) {
              throw new RangeError('Buffer size must be a multiple of 64-bits')
            }
            for (var i = 0; i < len; i += 8) {
              swap(this, i, i + 7)
              swap(this, i + 1, i + 6)
              swap(this, i + 2, i + 5)
              swap(this, i + 3, i + 4)
            }
            return this
          }

          Buffer.prototype.toString = function toString() {
            var length = this.length
            if (length === 0) return ''
            if (arguments.length === 0) return utf8Slice(this, 0, length)
            return slowToString.apply(this, arguments)
          }

          Buffer.prototype.toLocaleString = Buffer.prototype.toString

          Buffer.prototype.equals = function equals(b) {
            if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
            if (this === b) return true
            return Buffer.compare(this, b) === 0
          }

          Buffer.prototype.inspect = function inspect() {
            var str = ''
            var max = exports.INSPECT_MAX_BYTES
            str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
            if (this.length > max) str += ' ... '
            return '<Buffer ' + str + '>'
          }

          Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
            if (isInstance(target, Uint8Array)) {
              target = Buffer.from(target, target.offset, target.byteLength)
            }
            if (!Buffer.isBuffer(target)) {
              throw new TypeError(
                'The "target" argument must be one of type Buffer or Uint8Array. ' +
                'Received type ' + (typeof target)
              )
            }

            if (start === undefined) {
              start = 0
            }
            if (end === undefined) {
              end = target ? target.length : 0
            }
            if (thisStart === undefined) {
              thisStart = 0
            }
            if (thisEnd === undefined) {
              thisEnd = this.length
            }

            if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
              throw new RangeError('out of range index')
            }

            if (thisStart >= thisEnd && start >= end) {
              return 0
            }
            if (thisStart >= thisEnd) {
              return -1
            }
            if (start >= end) {
              return 1
            }

            start >>>= 0
            end >>>= 0
            thisStart >>>= 0
            thisEnd >>>= 0

            if (this === target) return 0

            var x = thisEnd - thisStart
            var y = end - start
            var len = Math.min(x, y)

            var thisCopy = this.slice(thisStart, thisEnd)
            var targetCopy = target.slice(start, end)

            for (var i = 0; i < len; ++i) {
              if (thisCopy[i] !== targetCopy[i]) {
                x = thisCopy[i]
                y = targetCopy[i]
                break
              }
            }

            if (x < y) return -1
            if (y < x) return 1
            return 0
          }

          // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
          // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
          //
          // Arguments:
          // - buffer - a Buffer to search
          // - val - a string, Buffer, or number
          // - byteOffset - an index into `buffer`; will be clamped to an int32
          // - encoding - an optional encoding, relevant is val is a string
          // - dir - true for indexOf, false for lastIndexOf
          function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
            // Empty buffer means no match
            if (buffer.length === 0) return -1

            // Normalize byteOffset
            if (typeof byteOffset === 'string') {
              encoding = byteOffset
              byteOffset = 0
            } else if (byteOffset > 0x7fffffff) {
              byteOffset = 0x7fffffff
            } else if (byteOffset < -0x80000000) {
              byteOffset = -0x80000000
            }
            byteOffset = +byteOffset // Coerce to Number.
            if (numberIsNaN(byteOffset)) {
              // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
              byteOffset = dir ? 0 : (buffer.length - 1)
            }

            // Normalize byteOffset: negative offsets start from the end of the buffer
            if (byteOffset < 0) byteOffset = buffer.length + byteOffset
            if (byteOffset >= buffer.length) {
              if (dir) return -1
              else byteOffset = buffer.length - 1
            } else if (byteOffset < 0) {
              if (dir) byteOffset = 0
              else return -1
            }

            // Normalize val
            if (typeof val === 'string') {
              val = Buffer.from(val, encoding)
            }

            // Finally, search either indexOf (if dir is true) or lastIndexOf
            if (Buffer.isBuffer(val)) {
              // Special case: looking for empty string/buffer always fails
              if (val.length === 0) {
                return -1
              }
              return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
            } else if (typeof val === 'number') {
              val = val & 0xFF // Search for a byte value [0-255]
              if (typeof Uint8Array.prototype.indexOf === 'function') {
                if (dir) {
                  return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
                } else {
                  return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
                }
              }
              return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
            }

            throw new TypeError('val must be string, number or Buffer')
          }

          function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
            var indexSize = 1
            var arrLength = arr.length
            var valLength = val.length

            if (encoding !== undefined) {
              encoding = String(encoding).toLowerCase()
              if (encoding === 'ucs2' || encoding === 'ucs-2' ||
                encoding === 'utf16le' || encoding === 'utf-16le') {
                if (arr.length < 2 || val.length < 2) {
                  return -1
                }
                indexSize = 2
                arrLength /= 2
                valLength /= 2
                byteOffset /= 2
              }
            }

            function read(buf, i) {
              if (indexSize === 1) {
                return buf[i]
              } else {
                return buf.readUInt16BE(i * indexSize)
              }
            }

            var i
            if (dir) {
              var foundIndex = -1
              for (i = byteOffset; i < arrLength; i++) {
                if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                  if (foundIndex === -1) foundIndex = i
                  if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
                } else {
                  if (foundIndex !== -1) i -= i - foundIndex
                  foundIndex = -1
                }
              }
            } else {
              if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
              for (i = byteOffset; i >= 0; i--) {
                var found = true
                for (var j = 0; j < valLength; j++) {
                  if (read(arr, i + j) !== read(val, j)) {
                    found = false
                    break
                  }
                }
                if (found) return i
              }
            }

            return -1
          }

          Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
            return this.indexOf(val, byteOffset, encoding) !== -1
          }

          Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
            return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
          }

          Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
            return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
          }

          function hexWrite(buf, string, offset, length) {
            offset = Number(offset) || 0
            var remaining = buf.length - offset
            if (!length) {
              length = remaining
            } else {
              length = Number(length)
              if (length > remaining) {
                length = remaining
              }
            }

            var strLen = string.length

            if (length > strLen / 2) {
              length = strLen / 2
            }
            for (var i = 0; i < length; ++i) {
              var parsed = parseInt(string.substr(i * 2, 2), 16)
              if (numberIsNaN(parsed)) return i
              buf[offset + i] = parsed
            }
            return i
          }

          function utf8Write(buf, string, offset, length) {
            return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
          }

          function asciiWrite(buf, string, offset, length) {
            return blitBuffer(asciiToBytes(string), buf, offset, length)
          }

          function latin1Write(buf, string, offset, length) {
            return asciiWrite(buf, string, offset, length)
          }

          function base64Write(buf, string, offset, length) {
            return blitBuffer(base64ToBytes(string), buf, offset, length)
          }

          function ucs2Write(buf, string, offset, length) {
            return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
          }

          Buffer.prototype.write = function write(string, offset, length, encoding) {
            // Buffer#write(string)
            if (offset === undefined) {
              encoding = 'utf8'
              length = this.length
              offset = 0
              // Buffer#write(string, encoding)
            } else if (length === undefined && typeof offset === 'string') {
              encoding = offset
              length = this.length
              offset = 0
              // Buffer#write(string, offset[, length][, encoding])
            } else if (isFinite(offset)) {
              offset = offset >>> 0
              if (isFinite(length)) {
                length = length >>> 0
                if (encoding === undefined) encoding = 'utf8'
              } else {
                encoding = length
                length = undefined
              }
            } else {
              throw new Error(
                'Buffer.write(string, encoding, offset[, length]) is no longer supported'
              )
            }

            var remaining = this.length - offset
            if (length === undefined || length > remaining) length = remaining

            if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
              throw new RangeError('Attempt to write outside buffer bounds')
            }

            if (!encoding) encoding = 'utf8'

            var loweredCase = false
            for (; ;) {
              switch (encoding) {
                case 'hex':
                  return hexWrite(this, string, offset, length)

                case 'utf8':
                case 'utf-8':
                  return utf8Write(this, string, offset, length)

                case 'ascii':
                  return asciiWrite(this, string, offset, length)

                case 'latin1':
                case 'binary':
                  return latin1Write(this, string, offset, length)

                case 'base64':
                  // Warning: maxLength not taken into account in base64Write
                  return base64Write(this, string, offset, length)

                case 'ucs2':
                case 'ucs-2':
                case 'utf16le':
                case 'utf-16le':
                  return ucs2Write(this, string, offset, length)

                default:
                  if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
                  encoding = ('' + encoding).toLowerCase()
                  loweredCase = true
              }
            }
          }

          Buffer.prototype.toJSON = function toJSON() {
            return {
              type: 'Buffer',
              data: Array.prototype.slice.call(this._arr || this, 0)
            }
          }

          function base64Slice(buf, start, end) {
            if (start === 0 && end === buf.length) {
              return base64.fromByteArray(buf)
            } else {
              return base64.fromByteArray(buf.slice(start, end))
            }
          }

          function utf8Slice(buf, start, end) {
            end = Math.min(buf.length, end)
            var res = []

            var i = start
            while (i < end) {
              var firstByte = buf[i]
              var codePoint = null
              var bytesPerSequence = (firstByte > 0xEF) ? 4
                : (firstByte > 0xDF) ? 3
                  : (firstByte > 0xBF) ? 2
                    : 1

              if (i + bytesPerSequence <= end) {
                var secondByte, thirdByte, fourthByte, tempCodePoint

                switch (bytesPerSequence) {
                  case 1:
                    if (firstByte < 0x80) {
                      codePoint = firstByte
                    }
                    break
                  case 2:
                    secondByte = buf[i + 1]
                    if ((secondByte & 0xC0) === 0x80) {
                      tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
                      if (tempCodePoint > 0x7F) {
                        codePoint = tempCodePoint
                      }
                    }
                    break
                  case 3:
                    secondByte = buf[i + 1]
                    thirdByte = buf[i + 2]
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                      tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
                      if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
                        codePoint = tempCodePoint
                      }
                    }
                    break
                  case 4:
                    secondByte = buf[i + 1]
                    thirdByte = buf[i + 2]
                    fourthByte = buf[i + 3]
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                      tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
                      if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
                        codePoint = tempCodePoint
                      }
                    }
                }
              }

              if (codePoint === null) {
                // we did not generate a valid codePoint so insert a
                // replacement char (U+FFFD) and advance only 1 byte
                codePoint = 0xFFFD
                bytesPerSequence = 1
              } else if (codePoint > 0xFFFF) {
                // encode to utf16 (surrogate pair dance)
                codePoint -= 0x10000
                res.push(codePoint >>> 10 & 0x3FF | 0xD800)
                codePoint = 0xDC00 | codePoint & 0x3FF
              }

              res.push(codePoint)
              i += bytesPerSequence
            }

            return decodeCodePointsArray(res)
          }

          // Based on http://stackoverflow.com/a/22747272/680742, the browser with
          // the lowest limit is Chrome, with 0x10000 args.
          // We go 1 magnitude less, for safety
          var MAX_ARGUMENTS_LENGTH = 0x1000

          function decodeCodePointsArray(codePoints) {
            var len = codePoints.length
            if (len <= MAX_ARGUMENTS_LENGTH) {
              return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
            }

            // Decode in chunks to avoid "call stack size exceeded".
            var res = ''
            var i = 0
            while (i < len) {
              res += String.fromCharCode.apply(
                String,
                codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
              )
            }
            return res
          }

          function asciiSlice(buf, start, end) {
            var ret = ''
            end = Math.min(buf.length, end)

            for (var i = start; i < end; ++i) {
              ret += String.fromCharCode(buf[i] & 0x7F)
            }
            return ret
          }

          function latin1Slice(buf, start, end) {
            var ret = ''
            end = Math.min(buf.length, end)

            for (var i = start; i < end; ++i) {
              ret += String.fromCharCode(buf[i])
            }
            return ret
          }

          function hexSlice(buf, start, end) {
            var len = buf.length

            if (!start || start < 0) start = 0
            if (!end || end < 0 || end > len) end = len

            var out = ''
            for (var i = start; i < end; ++i) {
              out += toHex(buf[i])
            }
            return out
          }

          function utf16leSlice(buf, start, end) {
            var bytes = buf.slice(start, end)
            var res = ''
            for (var i = 0; i < bytes.length; i += 2) {
              res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
            }
            return res
          }

          Buffer.prototype.slice = function slice(start, end) {
            var len = this.length
            start = ~~start
            end = end === undefined ? len : ~~end

            if (start < 0) {
              start += len
              if (start < 0) start = 0
            } else if (start > len) {
              start = len
            }

            if (end < 0) {
              end += len
              if (end < 0) end = 0
            } else if (end > len) {
              end = len
            }

            if (end < start) end = start

            var newBuf = this.subarray(start, end)
            // Return an augmented `Uint8Array` instance
            newBuf.__proto__ = Buffer.prototype
            return newBuf
          }

          /*
           * Need to make sure that buffer isn't trying to write out of bounds.
           */
          function checkOffset(offset, ext, length) {
            if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
            if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
          }

          Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
            offset = offset >>> 0
            byteLength = byteLength >>> 0
            if (!noAssert) checkOffset(offset, byteLength, this.length)

            var val = this[offset]
            var mul = 1
            var i = 0
            while (++i < byteLength && (mul *= 0x100)) {
              val += this[offset + i] * mul
            }

            return val
          }

          Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
            offset = offset >>> 0
            byteLength = byteLength >>> 0
            if (!noAssert) {
              checkOffset(offset, byteLength, this.length)
            }

            var val = this[offset + --byteLength]
            var mul = 1
            while (byteLength > 0 && (mul *= 0x100)) {
              val += this[offset + --byteLength] * mul
            }

            return val
          }

          Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
            offset = offset >>> 0
            if (!noAssert) checkOffset(offset, 1, this.length)
            return this[offset]
          }

          Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
            offset = offset >>> 0
            if (!noAssert) checkOffset(offset, 2, this.length)
            return this[offset] | (this[offset + 1] << 8)
          }

          Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
            offset = offset >>> 0
            if (!noAssert) checkOffset(offset, 2, this.length)
            return (this[offset] << 8) | this[offset + 1]
          }

          Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
            offset = offset >>> 0
            if (!noAssert) checkOffset(offset, 4, this.length)

            return ((this[offset]) |
              (this[offset + 1] << 8) |
              (this[offset + 2] << 16)) +
              (this[offset + 3] * 0x1000000)
          }

          Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
            offset = offset >>> 0
            if (!noAssert) checkOffset(offset, 4, this.length)

            return (this[offset] * 0x1000000) +
              ((this[offset + 1] << 16) |
                (this[offset + 2] << 8) |
                this[offset + 3])
          }

          Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
            offset = offset >>> 0
            byteLength = byteLength >>> 0
            if (!noAssert) checkOffset(offset, byteLength, this.length)

            var val = this[offset]
            var mul = 1
            var i = 0
            while (++i < byteLength && (mul *= 0x100)) {
              val += this[offset + i] * mul
            }
            mul *= 0x80

            if (val >= mul) val -= Math.pow(2, 8 * byteLength)

            return val
          }

          Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
            offset = offset >>> 0
            byteLength = byteLength >>> 0
            if (!noAssert) checkOffset(offset, byteLength, this.length)

            var i = byteLength
            var mul = 1
            var val = this[offset + --i]
            while (i > 0 && (mul *= 0x100)) {
              val += this[offset + --i] * mul
            }
            mul *= 0x80

            if (val >= mul) val -= Math.pow(2, 8 * byteLength)

            return val
          }

          Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
            offset = offset >>> 0
            if (!noAssert) checkOffset(offset, 1, this.length)
            if (!(this[offset] & 0x80)) return (this[offset])
            return ((0xff - this[offset] + 1) * -1)
          }

          Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
            offset = offset >>> 0
            if (!noAssert) checkOffset(offset, 2, this.length)
            var val = this[offset] | (this[offset + 1] << 8)
            return (val & 0x8000) ? val | 0xFFFF0000 : val
          }

          Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
            offset = offset >>> 0
            if (!noAssert) checkOffset(offset, 2, this.length)
            var val = this[offset + 1] | (this[offset] << 8)
            return (val & 0x8000) ? val | 0xFFFF0000 : val
          }

          Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
            offset = offset >>> 0
            if (!noAssert) checkOffset(offset, 4, this.length)

            return (this[offset]) |
              (this[offset + 1] << 8) |
              (this[offset + 2] << 16) |
              (this[offset + 3] << 24)
          }

          Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
            offset = offset >>> 0
            if (!noAssert) checkOffset(offset, 4, this.length)

            return (this[offset] << 24) |
              (this[offset + 1] << 16) |
              (this[offset + 2] << 8) |
              (this[offset + 3])
          }

          Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
            offset = offset >>> 0
            if (!noAssert) checkOffset(offset, 4, this.length)
            return ieee754.read(this, offset, true, 23, 4)
          }

          Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
            offset = offset >>> 0
            if (!noAssert) checkOffset(offset, 4, this.length)
            return ieee754.read(this, offset, false, 23, 4)
          }

          Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
            offset = offset >>> 0
            if (!noAssert) checkOffset(offset, 8, this.length)
            return ieee754.read(this, offset, true, 52, 8)
          }

          Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
            offset = offset >>> 0
            if (!noAssert) checkOffset(offset, 8, this.length)
            return ieee754.read(this, offset, false, 52, 8)
          }

          function checkInt(buf, value, offset, ext, max, min) {
            if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
            if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
            if (offset + ext > buf.length) throw new RangeError('Index out of range')
          }

          Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
            value = +value
            offset = offset >>> 0
            byteLength = byteLength >>> 0
            if (!noAssert) {
              var maxBytes = Math.pow(2, 8 * byteLength) - 1
              checkInt(this, value, offset, byteLength, maxBytes, 0)
            }

            var mul = 1
            var i = 0
            this[offset] = value & 0xFF
            while (++i < byteLength && (mul *= 0x100)) {
              this[offset + i] = (value / mul) & 0xFF
            }

            return offset + byteLength
          }

          Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
            value = +value
            offset = offset >>> 0
            byteLength = byteLength >>> 0
            if (!noAssert) {
              var maxBytes = Math.pow(2, 8 * byteLength) - 1
              checkInt(this, value, offset, byteLength, maxBytes, 0)
            }

            var i = byteLength - 1
            var mul = 1
            this[offset + i] = value & 0xFF
            while (--i >= 0 && (mul *= 0x100)) {
              this[offset + i] = (value / mul) & 0xFF
            }

            return offset + byteLength
          }

          Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
            value = +value
            offset = offset >>> 0
            if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
            this[offset] = (value & 0xff)
            return offset + 1
          }

          Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
            value = +value
            offset = offset >>> 0
            if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
            this[offset] = (value & 0xff)
            this[offset + 1] = (value >>> 8)
            return offset + 2
          }

          Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
            value = +value
            offset = offset >>> 0
            if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
            this[offset] = (value >>> 8)
            this[offset + 1] = (value & 0xff)
            return offset + 2
          }

          Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
            value = +value
            offset = offset >>> 0
            if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
            this[offset + 3] = (value >>> 24)
            this[offset + 2] = (value >>> 16)
            this[offset + 1] = (value >>> 8)
            this[offset] = (value & 0xff)
            return offset + 4
          }

          Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
            value = +value
            offset = offset >>> 0
            if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
            this[offset] = (value >>> 24)
            this[offset + 1] = (value >>> 16)
            this[offset + 2] = (value >>> 8)
            this[offset + 3] = (value & 0xff)
            return offset + 4
          }

          Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
            value = +value
            offset = offset >>> 0
            if (!noAssert) {
              var limit = Math.pow(2, (8 * byteLength) - 1)

              checkInt(this, value, offset, byteLength, limit - 1, -limit)
            }

            var i = 0
            var mul = 1
            var sub = 0
            this[offset] = value & 0xFF
            while (++i < byteLength && (mul *= 0x100)) {
              if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
                sub = 1
              }
              this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
            }

            return offset + byteLength
          }

          Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
            value = +value
            offset = offset >>> 0
            if (!noAssert) {
              var limit = Math.pow(2, (8 * byteLength) - 1)

              checkInt(this, value, offset, byteLength, limit - 1, -limit)
            }

            var i = byteLength - 1
            var mul = 1
            var sub = 0
            this[offset + i] = value & 0xFF
            while (--i >= 0 && (mul *= 0x100)) {
              if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
                sub = 1
              }
              this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
            }

            return offset + byteLength
          }

          Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
            value = +value
            offset = offset >>> 0
            if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
            if (value < 0) value = 0xff + value + 1
            this[offset] = (value & 0xff)
            return offset + 1
          }

          Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
            value = +value
            offset = offset >>> 0
            if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
            this[offset] = (value & 0xff)
            this[offset + 1] = (value >>> 8)
            return offset + 2
          }

          Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
            value = +value
            offset = offset >>> 0
            if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
            this[offset] = (value >>> 8)
            this[offset + 1] = (value & 0xff)
            return offset + 2
          }

          Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
            value = +value
            offset = offset >>> 0
            if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
            this[offset] = (value & 0xff)
            this[offset + 1] = (value >>> 8)
            this[offset + 2] = (value >>> 16)
            this[offset + 3] = (value >>> 24)
            return offset + 4
          }

          Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
            value = +value
            offset = offset >>> 0
            if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
            if (value < 0) value = 0xffffffff + value + 1
            this[offset] = (value >>> 24)
            this[offset + 1] = (value >>> 16)
            this[offset + 2] = (value >>> 8)
            this[offset + 3] = (value & 0xff)
            return offset + 4
          }

          function checkIEEE754(buf, value, offset, ext, max, min) {
            if (offset + ext > buf.length) throw new RangeError('Index out of range')
            if (offset < 0) throw new RangeError('Index out of range')
          }

          function writeFloat(buf, value, offset, littleEndian, noAssert) {
            value = +value
            offset = offset >>> 0
            if (!noAssert) {
              checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
            }
            ieee754.write(buf, value, offset, littleEndian, 23, 4)
            return offset + 4
          }

          Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
            return writeFloat(this, value, offset, true, noAssert)
          }

          Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
            return writeFloat(this, value, offset, false, noAssert)
          }

          function writeDouble(buf, value, offset, littleEndian, noAssert) {
            value = +value
            offset = offset >>> 0
            if (!noAssert) {
              checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
            }
            ieee754.write(buf, value, offset, littleEndian, 52, 8)
            return offset + 8
          }

          Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
            return writeDouble(this, value, offset, true, noAssert)
          }

          Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
            return writeDouble(this, value, offset, false, noAssert)
          }

          // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
          Buffer.prototype.copy = function copy(target, targetStart, start, end) {
            if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
            if (!start) start = 0
            if (!end && end !== 0) end = this.length
            if (targetStart >= target.length) targetStart = target.length
            if (!targetStart) targetStart = 0
            if (end > 0 && end < start) end = start

            // Copy 0 bytes; we're done
            if (end === start) return 0
            if (target.length === 0 || this.length === 0) return 0

            // Fatal error conditions
            if (targetStart < 0) {
              throw new RangeError('targetStart out of bounds')
            }
            if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
            if (end < 0) throw new RangeError('sourceEnd out of bounds')

            // Are we oob?
            if (end > this.length) end = this.length
            if (target.length - targetStart < end - start) {
              end = target.length - targetStart + start
            }

            var len = end - start

            if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
              // Use built-in when available, missing from IE11
              this.copyWithin(targetStart, start, end)
            } else if (this === target && start < targetStart && targetStart < end) {
              // descending copy from end
              for (var i = len - 1; i >= 0; --i) {
                target[i + targetStart] = this[i + start]
              }
            } else {
              Uint8Array.prototype.set.call(
                target,
                this.subarray(start, end),
                targetStart
              )
            }

            return len
          }

          // Usage:
          //    buffer.fill(number[, offset[, end]])
          //    buffer.fill(buffer[, offset[, end]])
          //    buffer.fill(string[, offset[, end]][, encoding])
          Buffer.prototype.fill = function fill(val, start, end, encoding) {
            // Handle string cases:
            if (typeof val === 'string') {
              if (typeof start === 'string') {
                encoding = start
                start = 0
                end = this.length
              } else if (typeof end === 'string') {
                encoding = end
                end = this.length
              }
              if (encoding !== undefined && typeof encoding !== 'string') {
                throw new TypeError('encoding must be a string')
              }
              if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
                throw new TypeError('Unknown encoding: ' + encoding)
              }
              if (val.length === 1) {
                var code = val.charCodeAt(0)
                if ((encoding === 'utf8' && code < 128) ||
                  encoding === 'latin1') {
                  // Fast path: If `val` fits into a single byte, use that numeric value.
                  val = code
                }
              }
            } else if (typeof val === 'number') {
              val = val & 255
            }

            // Invalid ranges are not set to a default, so can range check early.
            if (start < 0 || this.length < start || this.length < end) {
              throw new RangeError('Out of range index')
            }

            if (end <= start) {
              return this
            }

            start = start >>> 0
            end = end === undefined ? this.length : end >>> 0

            if (!val) val = 0

            var i
            if (typeof val === 'number') {
              for (i = start; i < end; ++i) {
                this[i] = val
              }
            } else {
              var bytes = Buffer.isBuffer(val)
                ? val
                : Buffer.from(val, encoding)
              var len = bytes.length
              if (len === 0) {
                throw new TypeError('The value "' + val +
                  '" is invalid for argument "value"')
              }
              for (i = 0; i < end - start; ++i) {
                this[i + start] = bytes[i % len]
              }
            }

            return this
          }

          // HELPER FUNCTIONS
          // ================

          var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

          function base64clean(str) {
            // Node takes equal signs as end of the Base64 encoding
            str = str.split('=')[0]
            // Node strips out invalid characters like \n and \t from the string, base64-js does not
            str = str.trim().replace(INVALID_BASE64_RE, '')
            // Node converts strings with length < 2 to ''
            if (str.length < 2) return ''
            // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
            while (str.length % 4 !== 0) {
              str = str + '='
            }
            return str
          }

          function toHex(n) {
            if (n < 16) return '0' + n.toString(16)
            return n.toString(16)
          }

          function utf8ToBytes(string, units) {
            units = units || Infinity
            var codePoint
            var length = string.length
            var leadSurrogate = null
            var bytes = []

            for (var i = 0; i < length; ++i) {
              codePoint = string.charCodeAt(i)

              // is surrogate component
              if (codePoint > 0xD7FF && codePoint < 0xE000) {
                // last char was a lead
                if (!leadSurrogate) {
                  // no lead yet
                  if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
                    continue
                  } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
                    continue
                  }

                  // valid lead
                  leadSurrogate = codePoint

                  continue
                }

                // 2 leads in a row
                if (codePoint < 0xDC00) {
                  if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
                  leadSurrogate = codePoint
                  continue
                }

                // valid surrogate pair
                codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
              } else if (leadSurrogate) {
                // valid bmp char, but last char was a lead
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
              }

              leadSurrogate = null

              // encode utf8
              if (codePoint < 0x80) {
                if ((units -= 1) < 0) break
                bytes.push(codePoint)
              } else if (codePoint < 0x800) {
                if ((units -= 2) < 0) break
                bytes.push(
                  codePoint >> 0x6 | 0xC0,
                  codePoint & 0x3F | 0x80
                )
              } else if (codePoint < 0x10000) {
                if ((units -= 3) < 0) break
                bytes.push(
                  codePoint >> 0xC | 0xE0,
                  codePoint >> 0x6 & 0x3F | 0x80,
                  codePoint & 0x3F | 0x80
                )
              } else if (codePoint < 0x110000) {
                if ((units -= 4) < 0) break
                bytes.push(
                  codePoint >> 0x12 | 0xF0,
                  codePoint >> 0xC & 0x3F | 0x80,
                  codePoint >> 0x6 & 0x3F | 0x80,
                  codePoint & 0x3F | 0x80
                )
              } else {
                throw new Error('Invalid code point')
              }
            }

            return bytes
          }

          function asciiToBytes(str) {
            var byteArray = []
            for (var i = 0; i < str.length; ++i) {
              // Node's code seems to be doing this and not & 0x7F..
              byteArray.push(str.charCodeAt(i) & 0xFF)
            }
            return byteArray
          }

          function utf16leToBytes(str, units) {
            var c, hi, lo
            var byteArray = []
            for (var i = 0; i < str.length; ++i) {
              if ((units -= 2) < 0) break

              c = str.charCodeAt(i)
              hi = c >> 8
              lo = c % 256
              byteArray.push(lo)
              byteArray.push(hi)
            }

            return byteArray
          }

          function base64ToBytes(str) {
            return base64.toByteArray(base64clean(str))
          }

          function blitBuffer(src, dst, offset, length) {
            for (var i = 0; i < length; ++i) {
              if ((i + offset >= dst.length) || (i >= src.length)) break
              dst[i + offset] = src[i]
            }
            return i
          }

          // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
          // the `instanceof` check but they should be treated as of that type.
          // See: https://github.com/feross/buffer/issues/166
          function isInstance(obj, type) {
            return obj instanceof type ||
              (obj != null && obj.constructor != null && obj.constructor.name != null &&
                obj.constructor.name === type.name)
          }
          function numberIsNaN(obj) {
            // For IE11 support
            return obj !== obj // eslint-disable-line no-self-compare
          }

        }).call(this)
      }).call(this, require("buffer").Buffer)
    }, { "base64-js": 169, "buffer": 216, "ieee754": 284 }], 217: [function (require, module, exports) {
      arguments[4][69][0].apply(exports, arguments)
    }, { "dup": 69, "inherits": 285, "safe-buffer": 315, "stream": 325, "string_decoder": 340 }], 218: [function (require, module, exports) {
      (function (Buffer) {
        (function () {
          var elliptic = require('elliptic')
          var BN = require('bn.js')

          module.exports = function createECDH(curve) {
            return new ECDH(curve)
          }

          var aliases = {
            secp256k1: {
              name: 'secp256k1',
              byteLength: 32
            },
            secp224r1: {
              name: 'p224',
              byteLength: 28
            },
            prime256v1: {
              name: 'p256',
              byteLength: 32
            },
            prime192v1: {
              name: 'p192',
              byteLength: 24
            },
            ed25519: {
              name: 'ed25519',
              byteLength: 32
            },
            secp384r1: {
              name: 'p384',
              byteLength: 48
            },
            secp521r1: {
              name: 'p521',
              byteLength: 66
            }
          }

          aliases.p224 = aliases.secp224r1
          aliases.p256 = aliases.secp256r1 = aliases.prime256v1
          aliases.p192 = aliases.secp192r1 = aliases.prime192v1
          aliases.p384 = aliases.secp384r1
          aliases.p521 = aliases.secp521r1

          function ECDH(curve) {
            this.curveType = aliases[curve]
            if (!this.curveType) {
              this.curveType = {
                name: curve
              }
            }
            this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
            this.keys = void 0
          }

          ECDH.prototype.generateKeys = function (enc, format) {
            this.keys = this.curve.genKeyPair()
            return this.getPublicKey(enc, format)
          }

          ECDH.prototype.computeSecret = function (other, inenc, enc) {
            inenc = inenc || 'utf8'
            if (!Buffer.isBuffer(other)) {
              other = new Buffer(other, inenc)
            }
            var otherPub = this.curve.keyFromPublic(other).getPublic()
            var out = otherPub.mul(this.keys.getPrivate()).getX()
            return formatReturnValue(out, enc, this.curveType.byteLength)
          }

          ECDH.prototype.getPublicKey = function (enc, format) {
            var key = this.keys.getPublic(format === 'compressed', true)
            if (format === 'hybrid') {
              if (key[key.length - 1] % 2) {
                key[0] = 7
              } else {
                key[0] = 6
              }
            }
            return formatReturnValue(key, enc)
          }

          ECDH.prototype.getPrivateKey = function (enc) {
            return formatReturnValue(this.keys.getPrivate(), enc)
          }

          ECDH.prototype.setPublicKey = function (pub, enc) {
            enc = enc || 'utf8'
            if (!Buffer.isBuffer(pub)) {
              pub = new Buffer(pub, enc)
            }
            this.keys._importPublic(pub)
            return this
          }

          ECDH.prototype.setPrivateKey = function (priv, enc) {
            enc = enc || 'utf8'
            if (!Buffer.isBuffer(priv)) {
              priv = new Buffer(priv, enc)
            }

            var _priv = new BN(priv)
            _priv = _priv.toString(16)
            this.keys = this.curve.genKeyPair()
            this.keys._importPrivate(_priv)
            return this
          }

          function formatReturnValue(bn, enc, len) {
            if (!Array.isArray(bn)) {
              bn = bn.toArray()
            }
            var buf = new Buffer(bn)
            if (len && buf.length < len) {
              var zeros = new Buffer(len - buf.length)
              zeros.fill(0)
              buf = Buffer.concat([zeros, buf])
            }
            if (!enc) {
              return buf
            } else {
              return buf.toString(enc)
            }
          }

        }).call(this)
      }).call(this, require("buffer").Buffer)
    }, { "bn.js": 219, "buffer": 216, "elliptic": 236 }], 219: [function (require, module, exports) {
      arguments[4][64][0].apply(exports, arguments)
    }, { "buffer": 172, "dup": 64 }], 220: [function (require, module, exports) {
      arguments[4][70][0].apply(exports, arguments)
    }, { "cipher-base": 217, "dup": 70, "inherits": 285, "md5.js": 287, "ripemd160": 314, "sha.js": 318 }], 221: [function (require, module, exports) {
      arguments[4][71][0].apply(exports, arguments)
    }, { "dup": 71, "md5.js": 287 }], 222: [function (require, module, exports) {
      arguments[4][72][0].apply(exports, arguments)
    }, { "./legacy": 223, "cipher-base": 217, "create-hash/md5": 221, "dup": 72, "inherits": 285, "ripemd160": 314, "safe-buffer": 315, "sha.js": 318 }], 223: [function (require, module, exports) {
      arguments[4][73][0].apply(exports, arguments)
    }, { "cipher-base": 217, "dup": 73, "inherits": 285, "safe-buffer": 315 }], 224: [function (require, module, exports) {
      'use strict'

      exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = require('randombytes')
      exports.createHash = exports.Hash = require('create-hash')
      exports.createHmac = exports.Hmac = require('create-hmac')

      var algos = require('browserify-sign/algos')
      var algoKeys = Object.keys(algos)
      var hashes = ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'].concat(algoKeys)
      exports.getHashes = function () {
        return hashes
      }

      var p = require('pbkdf2')
      exports.pbkdf2 = p.pbkdf2
      exports.pbkdf2Sync = p.pbkdf2Sync

      var aes = require('browserify-cipher')

      exports.Cipher = aes.Cipher
      exports.createCipher = aes.createCipher
      exports.Cipheriv = aes.Cipheriv
      exports.createCipheriv = aes.createCipheriv
      exports.Decipher = aes.Decipher
      exports.createDecipher = aes.createDecipher
      exports.Decipheriv = aes.Decipheriv
      exports.createDecipheriv = aes.createDecipheriv
      exports.getCiphers = aes.getCiphers
      exports.listCiphers = aes.listCiphers

      var dh = require('diffie-hellman')

      exports.DiffieHellmanGroup = dh.DiffieHellmanGroup
      exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup
      exports.getDiffieHellman = dh.getDiffieHellman
      exports.createDiffieHellman = dh.createDiffieHellman
      exports.DiffieHellman = dh.DiffieHellman

      var sign = require('browserify-sign')

      exports.createSign = sign.createSign
      exports.Sign = sign.Sign
      exports.createVerify = sign.createVerify
      exports.Verify = sign.Verify

      exports.createECDH = require('create-ecdh')

      var publicEncrypt = require('public-encrypt')

      exports.publicEncrypt = publicEncrypt.publicEncrypt
      exports.privateEncrypt = publicEncrypt.privateEncrypt
      exports.publicDecrypt = publicEncrypt.publicDecrypt
      exports.privateDecrypt = publicEncrypt.privateDecrypt

      // the least I can do is make error messages for the rest of the node.js/crypto api.
      // ;[
      //   'createCredentials'
      // ].forEach(function (name) {
      //   exports[name] = function () {
      //     throw new Error([
      //       'sorry, ' + name + ' is not implemented yet',
      //       'we accept pull requests',
      //       'https://github.com/crypto-browserify/crypto-browserify'
      //     ].join('\n'))
      //   }
      // })

      var rf = require('randomfill')

      exports.randomFill = rf.randomFill
      exports.randomFillSync = rf.randomFillSync

      exports.createCredentials = function () {
        throw new Error([
          'sorry, createCredentials is not implemented yet',
          'we accept pull requests',
          'https://github.com/crypto-browserify/crypto-browserify'
        ].join('\n'))
      }

      exports.constants = {
        'DH_CHECK_P_NOT_SAFE_PRIME': 2,
        'DH_CHECK_P_NOT_PRIME': 1,
        'DH_UNABLE_TO_CHECK_GENERATOR': 4,
        'DH_NOT_SUITABLE_GENERATOR': 8,
        'NPN_ENABLED': 1,
        'ALPN_ENABLED': 1,
        'RSA_PKCS1_PADDING': 1,
        'RSA_SSLV23_PADDING': 2,
        'RSA_NO_PADDING': 3,
        'RSA_PKCS1_OAEP_PADDING': 4,
        'RSA_X931_PADDING': 5,
        'RSA_PKCS1_PSS_PADDING': 6,
        'POINT_CONVERSION_COMPRESSED': 2,
        'POINT_CONVERSION_UNCOMPRESSED': 4,
        'POINT_CONVERSION_HYBRID': 6
      }

    }, { "browserify-cipher": 190, "browserify-sign": 197, "browserify-sign/algos": 194, "create-ecdh": 218, "create-hash": 220, "create-hmac": 222, "diffie-hellman": 231, "pbkdf2": 298, "public-encrypt": 305, "randombytes": 312, "randomfill": 313 }], 225: [function (require, module, exports) {
      'use strict';

      exports.utils = require('./des/utils');
      exports.Cipher = require('./des/cipher');
      exports.DES = require('./des/des');
      exports.CBC = require('./des/cbc');
      exports.EDE = require('./des/ede');

    }, { "./des/cbc": 226, "./des/cipher": 227, "./des/des": 228, "./des/ede": 229, "./des/utils": 230 }], 226: [function (require, module, exports) {
      'use strict';

      var assert = require('minimalistic-assert');
      var inherits = require('inherits');

      var proto = {};

      function CBCState(iv) {
        assert.equal(iv.length, 8, 'Invalid IV length');

        this.iv = new Array(8);
        for (var i = 0; i < this.iv.length; i++)
          this.iv[i] = iv[i];
      }

      function instantiate(Base) {
        function CBC(options) {
          Base.call(this, options);
          this._cbcInit();
        }
        inherits(CBC, Base);

        var keys = Object.keys(proto);
        for (var i = 0; i < keys.length; i++) {
          var key = keys[i];
          CBC.prototype[key] = proto[key];
        }

        CBC.create = function create(options) {
          return new CBC(options);
        };

        return CBC;
      }

      exports.instantiate = instantiate;

      proto._cbcInit = function _cbcInit() {
        var state = new CBCState(this.options.iv);
        this._cbcState = state;
      };

      proto._update = function _update(inp, inOff, out, outOff) {
        var state = this._cbcState;
        var superProto = this.constructor.super_.prototype;

        var iv = state.iv;
        if (this.type === 'encrypt') {
          for (var i = 0; i < this.blockSize; i++)
            iv[i] ^= inp[inOff + i];

          superProto._update.call(this, iv, 0, out, outOff);

          for (var i = 0; i < this.blockSize; i++)
            iv[i] = out[outOff + i];
        } else {
          superProto._update.call(this, inp, inOff, out, outOff);

          for (var i = 0; i < this.blockSize; i++)
            out[outOff + i] ^= iv[i];

          for (var i = 0; i < this.blockSize; i++)
            iv[i] = inp[inOff + i];
        }
      };

    }, { "inherits": 285, "minimalistic-assert": 290 }], 227: [function (require, module, exports) {
      'use strict';

      var assert = require('minimalistic-assert');

      function Cipher(options) {
        this.options = options;

        this.type = this.options.type;
        this.blockSize = 8;
        this._init();

        this.buffer = new Array(this.blockSize);
        this.bufferOff = 0;
      }
      module.exports = Cipher;

      Cipher.prototype._init = function _init() {
        // Might be overrided
      };

      Cipher.prototype.update = function update(data) {
        if (data.length === 0)
          return [];

        if (this.type === 'decrypt')
          return this._updateDecrypt(data);
        else
          return this._updateEncrypt(data);
      };

      Cipher.prototype._buffer = function _buffer(data, off) {
        // Append data to buffer
        var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
        for (var i = 0; i < min; i++)
          this.buffer[this.bufferOff + i] = data[off + i];
        this.bufferOff += min;

        // Shift next
        return min;
      };

      Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
        this._update(this.buffer, 0, out, off);
        this.bufferOff = 0;
        return this.blockSize;
      };

      Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
        var inputOff = 0;
        var outputOff = 0;

        var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
        var out = new Array(count * this.blockSize);

        if (this.bufferOff !== 0) {
          inputOff += this._buffer(data, inputOff);

          if (this.bufferOff === this.buffer.length)
            outputOff += this._flushBuffer(out, outputOff);
        }

        // Write blocks
        var max = data.length - ((data.length - inputOff) % this.blockSize);
        for (; inputOff < max; inputOff += this.blockSize) {
          this._update(data, inputOff, out, outputOff);
          outputOff += this.blockSize;
        }

        // Queue rest
        for (; inputOff < data.length; inputOff++, this.bufferOff++)
          this.buffer[this.bufferOff] = data[inputOff];

        return out;
      };

      Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
        var inputOff = 0;
        var outputOff = 0;

        var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
        var out = new Array(count * this.blockSize);

        // TODO(indutny): optimize it, this is far from optimal
        for (; count > 0; count--) {
          inputOff += this._buffer(data, inputOff);
          outputOff += this._flushBuffer(out, outputOff);
        }

        // Buffer rest of the input
        inputOff += this._buffer(data, inputOff);

        return out;
      };

      Cipher.prototype.final = function final(buffer) {
        var first;
        if (buffer)
          first = this.update(buffer);

        var last;
        if (this.type === 'encrypt')
          last = this._finalEncrypt();
        else
          last = this._finalDecrypt();

        if (first)
          return first.concat(last);
        else
          return last;
      };

      Cipher.prototype._pad = function _pad(buffer, off) {
        if (off === 0)
          return false;

        while (off < buffer.length)
          buffer[off++] = 0;

        return true;
      };

      Cipher.prototype._finalEncrypt = function _finalEncrypt() {
        if (!this._pad(this.buffer, this.bufferOff))
          return [];

        var out = new Array(this.blockSize);
        this._update(this.buffer, 0, out, 0);
        return out;
      };

      Cipher.prototype._unpad = function _unpad(buffer) {
        return buffer;
      };

      Cipher.prototype._finalDecrypt = function _finalDecrypt() {
        assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
        var out = new Array(this.blockSize);
        this._flushBuffer(out, 0);

        return this._unpad(out);
      };

    }, { "minimalistic-assert": 290 }], 228: [function (require, module, exports) {
      'use strict';

      var assert = require('minimalistic-assert');
      var inherits = require('inherits');

      var utils = require('./utils');
      var Cipher = require('./cipher');

      function DESState() {
        this.tmp = new Array(2);
        this.keys = null;
      }

      function DES(options) {
        Cipher.call(this, options);

        var state = new DESState();
        this._desState = state;

        this.deriveKeys(state, options.key);
      }
      inherits(DES, Cipher);
      module.exports = DES;

      DES.create = function create(options) {
        return new DES(options);
      };

      var shiftTable = [
        1, 1, 2, 2, 2, 2, 2, 2,
        1, 2, 2, 2, 2, 2, 2, 1
      ];

      DES.prototype.deriveKeys = function deriveKeys(state, key) {
        state.keys = new Array(16 * 2);

        assert.equal(key.length, this.blockSize, 'Invalid key length');

        var kL = utils.readUInt32BE(key, 0);
        var kR = utils.readUInt32BE(key, 4);

        utils.pc1(kL, kR, state.tmp, 0);
        kL = state.tmp[0];
        kR = state.tmp[1];
        for (var i = 0; i < state.keys.length; i += 2) {
          var shift = shiftTable[i >>> 1];
          kL = utils.r28shl(kL, shift);
          kR = utils.r28shl(kR, shift);
          utils.pc2(kL, kR, state.keys, i);
        }
      };

      DES.prototype._update = function _update(inp, inOff, out, outOff) {
        var state = this._desState;

        var l = utils.readUInt32BE(inp, inOff);
        var r = utils.readUInt32BE(inp, inOff + 4);

        // Initial Permutation
        utils.ip(l, r, state.tmp, 0);
        l = state.tmp[0];
        r = state.tmp[1];

        if (this.type === 'encrypt')
          this._encrypt(state, l, r, state.tmp, 0);
        else
          this._decrypt(state, l, r, state.tmp, 0);

        l = state.tmp[0];
        r = state.tmp[1];

        utils.writeUInt32BE(out, l, outOff);
        utils.writeUInt32BE(out, r, outOff + 4);
      };

      DES.prototype._pad = function _pad(buffer, off) {
        var value = buffer.length - off;
        for (var i = off; i < buffer.length; i++)
          buffer[i] = value;

        return true;
      };

      DES.prototype._unpad = function _unpad(buffer) {
        var pad = buffer[buffer.length - 1];
        for (var i = buffer.length - pad; i < buffer.length; i++)
          assert.equal(buffer[i], pad);

        return buffer.slice(0, buffer.length - pad);
      };

      DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
        var l = lStart;
        var r = rStart;

        // Apply f() x16 times
        for (var i = 0; i < state.keys.length; i += 2) {
          var keyL = state.keys[i];
          var keyR = state.keys[i + 1];

          // f(r, k)
          utils.expand(r, state.tmp, 0);

          keyL ^= state.tmp[0];
          keyR ^= state.tmp[1];
          var s = utils.substitute(keyL, keyR);
          var f = utils.permute(s);

          var t = r;
          r = (l ^ f) >>> 0;
          l = t;
        }

        // Reverse Initial Permutation
        utils.rip(r, l, out, off);
      };

      DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
        var l = rStart;
        var r = lStart;

        // Apply f() x16 times
        for (var i = state.keys.length - 2; i >= 0; i -= 2) {
          var keyL = state.keys[i];
          var keyR = state.keys[i + 1];

          // f(r, k)
          utils.expand(l, state.tmp, 0);

          keyL ^= state.tmp[0];
          keyR ^= state.tmp[1];
          var s = utils.substitute(keyL, keyR);
          var f = utils.permute(s);

          var t = l;
          l = (r ^ f) >>> 0;
          r = t;
        }

        // Reverse Initial Permutation
        utils.rip(l, r, out, off);
      };

    }, { "./cipher": 227, "./utils": 230, "inherits": 285, "minimalistic-assert": 290 }], 229: [function (require, module, exports) {
      'use strict';

      var assert = require('minimalistic-assert');
      var inherits = require('inherits');

      var Cipher = require('./cipher');
      var DES = require('./des');

      function EDEState(type, key) {
        assert.equal(key.length, 24, 'Invalid key length');

        var k1 = key.slice(0, 8);
        var k2 = key.slice(8, 16);
        var k3 = key.slice(16, 24);

        if (type === 'encrypt') {
          this.ciphers = [
            DES.create({ type: 'encrypt', key: k1 }),
            DES.create({ type: 'decrypt', key: k2 }),
            DES.create({ type: 'encrypt', key: k3 })
          ];
        } else {
          this.ciphers = [
            DES.create({ type: 'decrypt', key: k3 }),
            DES.create({ type: 'encrypt', key: k2 }),
            DES.create({ type: 'decrypt', key: k1 })
          ];
        }
      }

      function EDE(options) {
        Cipher.call(this, options);

        var state = new EDEState(this.type, this.options.key);
        this._edeState = state;
      }
      inherits(EDE, Cipher);

      module.exports = EDE;

      EDE.create = function create(options) {
        return new EDE(options);
      };

      EDE.prototype._update = function _update(inp, inOff, out, outOff) {
        var state = this._edeState;

        state.ciphers[0]._update(inp, inOff, out, outOff);
        state.ciphers[1]._update(out, outOff, out, outOff);
        state.ciphers[2]._update(out, outOff, out, outOff);
      };

      EDE.prototype._pad = DES.prototype._pad;
      EDE.prototype._unpad = DES.prototype._unpad;

    }, { "./cipher": 227, "./des": 228, "inherits": 285, "minimalistic-assert": 290 }], 230: [function (require, module, exports) {
      'use strict';

      exports.readUInt32BE = function readUInt32BE(bytes, off) {
        var res = (bytes[0 + off] << 24) |
          (bytes[1 + off] << 16) |
          (bytes[2 + off] << 8) |
          bytes[3 + off];
        return res >>> 0;
      };

      exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
        bytes[0 + off] = value >>> 24;
        bytes[1 + off] = (value >>> 16) & 0xff;
        bytes[2 + off] = (value >>> 8) & 0xff;
        bytes[3 + off] = value & 0xff;
      };

      exports.ip = function ip(inL, inR, out, off) {
        var outL = 0;
        var outR = 0;

        for (var i = 6; i >= 0; i -= 2) {
          for (var j = 0; j <= 24; j += 8) {
            outL <<= 1;
            outL |= (inR >>> (j + i)) & 1;
          }
          for (var j = 0; j <= 24; j += 8) {
            outL <<= 1;
            outL |= (inL >>> (j + i)) & 1;
          }
        }

        for (var i = 6; i >= 0; i -= 2) {
          for (var j = 1; j <= 25; j += 8) {
            outR <<= 1;
            outR |= (inR >>> (j + i)) & 1;
          }
          for (var j = 1; j <= 25; j += 8) {
            outR <<= 1;
            outR |= (inL >>> (j + i)) & 1;
          }
        }

        out[off + 0] = outL >>> 0;
        out[off + 1] = outR >>> 0;
      };

      exports.rip = function rip(inL, inR, out, off) {
        var outL = 0;
        var outR = 0;

        for (var i = 0; i < 4; i++) {
          for (var j = 24; j >= 0; j -= 8) {
            outL <<= 1;
            outL |= (inR >>> (j + i)) & 1;
            outL <<= 1;
            outL |= (inL >>> (j + i)) & 1;
          }
        }
        for (var i = 4; i < 8; i++) {
          for (var j = 24; j >= 0; j -= 8) {
            outR <<= 1;
            outR |= (inR >>> (j + i)) & 1;
            outR <<= 1;
            outR |= (inL >>> (j + i)) & 1;
          }
        }

        out[off + 0] = outL >>> 0;
        out[off + 1] = outR >>> 0;
      };

      exports.pc1 = function pc1(inL, inR, out, off) {
        var outL = 0;
        var outR = 0;

        // 7, 15, 23, 31, 39, 47, 55, 63
        // 6, 14, 22, 30, 39, 47, 55, 63
        // 5, 13, 21, 29, 39, 47, 55, 63
        // 4, 12, 20, 28
        for (var i = 7; i >= 5; i--) {
          for (var j = 0; j <= 24; j += 8) {
            outL <<= 1;
            outL |= (inR >> (j + i)) & 1;
          }
          for (var j = 0; j <= 24; j += 8) {
            outL <<= 1;
            outL |= (inL >> (j + i)) & 1;
          }
        }
        for (var j = 0; j <= 24; j += 8) {
          outL <<= 1;
          outL |= (inR >> (j + i)) & 1;
        }

        // 1, 9, 17, 25, 33, 41, 49, 57
        // 2, 10, 18, 26, 34, 42, 50, 58
        // 3, 11, 19, 27, 35, 43, 51, 59
        // 36, 44, 52, 60
        for (var i = 1; i <= 3; i++) {
          for (var j = 0; j <= 24; j += 8) {
            outR <<= 1;
            outR |= (inR >> (j + i)) & 1;
          }
          for (var j = 0; j <= 24; j += 8) {
            outR <<= 1;
            outR |= (inL >> (j + i)) & 1;
          }
        }
        for (var j = 0; j <= 24; j += 8) {
          outR <<= 1;
          outR |= (inL >> (j + i)) & 1;
        }

        out[off + 0] = outL >>> 0;
        out[off + 1] = outR >>> 0;
      };

      exports.r28shl = function r28shl(num, shift) {
        return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
      };

      var pc2table = [
        // inL => outL
        14, 11, 17, 4, 27, 23, 25, 0,
        13, 22, 7, 18, 5, 9, 16, 24,
        2, 20, 12, 21, 1, 8, 15, 26,

        // inR => outR
        15, 4, 25, 19, 9, 1, 26, 16,
        5, 11, 23, 8, 12, 7, 17, 0,
        22, 3, 10, 14, 6, 20, 27, 24
      ];

      exports.pc2 = function pc2(inL, inR, out, off) {
        var outL = 0;
        var outR = 0;

        var len = pc2table.length >>> 1;
        for (var i = 0; i < len; i++) {
          outL <<= 1;
          outL |= (inL >>> pc2table[i]) & 0x1;
        }
        for (var i = len; i < pc2table.length; i++) {
          outR <<= 1;
          outR |= (inR >>> pc2table[i]) & 0x1;
        }

        out[off + 0] = outL >>> 0;
        out[off + 1] = outR >>> 0;
      };

      exports.expand = function expand(r, out, off) {
        var outL = 0;
        var outR = 0;

        outL = ((r & 1) << 5) | (r >>> 27);
        for (var i = 23; i >= 15; i -= 4) {
          outL <<= 6;
          outL |= (r >>> i) & 0x3f;
        }
        for (var i = 11; i >= 3; i -= 4) {
          outR |= (r >>> i) & 0x3f;
          outR <<= 6;
        }
        outR |= ((r & 0x1f) << 1) | (r >>> 31);

        out[off + 0] = outL >>> 0;
        out[off + 1] = outR >>> 0;
      };

      var sTable = [
        14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
        3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
        4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
        15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

        15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
        9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
        0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
        5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

        10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
        1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
        13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
        11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

        7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
        1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
        10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
        15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

        2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
        8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
        4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
        15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

        12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
        0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
        9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
        7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

        4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
        3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
        1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
        10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

        13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
        10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
        7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
        0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
      ];

      exports.substitute = function substitute(inL, inR) {
        var out = 0;
        for (var i = 0; i < 4; i++) {
          var b = (inL >>> (18 - i * 6)) & 0x3f;
          var sb = sTable[i * 0x40 + b];

          out <<= 4;
          out |= sb;
        }
        for (var i = 0; i < 4; i++) {
          var b = (inR >>> (18 - i * 6)) & 0x3f;
          var sb = sTable[4 * 0x40 + i * 0x40 + b];

          out <<= 4;
          out |= sb;
        }
        return out >>> 0;
      };

      var permuteTable = [
        16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
        30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
      ];

      exports.permute = function permute(num) {
        var out = 0;
        for (var i = 0; i < permuteTable.length; i++) {
          out <<= 1;
          out |= (num >>> permuteTable[i]) & 0x1;
        }
        return out >>> 0;
      };

      exports.padSplit = function padSplit(num, size, group) {
        var str = num.toString(2);
        while (str.length < size)
          str = '0' + str;

        var out = [];
        for (var i = 0; i < size; i += group)
          out.push(str.slice(i, i + group));
        return out.join(' ');
      };

    }, {}], 231: [function (require, module, exports) {
      (function (Buffer) {
        (function () {
          var generatePrime = require('./lib/generatePrime')
          var primes = require('./lib/primes.json')

          var DH = require('./lib/dh')

          function getDiffieHellman(mod) {
            var prime = new Buffer(primes[mod].prime, 'hex')
            var gen = new Buffer(primes[mod].gen, 'hex')

            return new DH(prime, gen)
          }

          var ENCODINGS = {
            'binary': true, 'hex': true, 'base64': true
          }

          function createDiffieHellman(prime, enc, generator, genc) {
            if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
              return createDiffieHellman(prime, 'binary', enc, generator)
            }

            enc = enc || 'binary'
            genc = genc || 'binary'
            generator = generator || new Buffer([2])

            if (!Buffer.isBuffer(generator)) {
              generator = new Buffer(generator, genc)
            }

            if (typeof prime === 'number') {
              return new DH(generatePrime(prime, generator), generator, true)
            }

            if (!Buffer.isBuffer(prime)) {
              prime = new Buffer(prime, enc)
            }

            return new DH(prime, generator, true)
          }

          exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
          exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman

        }).call(this)
      }).call(this, require("buffer").Buffer)
    }, { "./lib/dh": 232, "./lib/generatePrime": 233, "./lib/primes.json": 234, "buffer": 216 }], 232: [function (require, module, exports) {
      (function (Buffer) {
        (function () {
          var BN = require('bn.js');
          var MillerRabin = require('miller-rabin');
          var millerRabin = new MillerRabin();
          var TWENTYFOUR = new BN(24);
          var ELEVEN = new BN(11);
          var TEN = new BN(10);
          var THREE = new BN(3);
          var SEVEN = new BN(7);
          var primes = require('./generatePrime');
          var randomBytes = require('randombytes');
          module.exports = DH;

          function setPublicKey(pub, enc) {
            enc = enc || 'utf8';
            if (!Buffer.isBuffer(pub)) {
              pub = new Buffer(pub, enc);
            }
            this._pub = new BN(pub);
            return this;
          }

          function setPrivateKey(priv, enc) {
            enc = enc || 'utf8';
            if (!Buffer.isBuffer(priv)) {
              priv = new Buffer(priv, enc);
            }
            this._priv = new BN(priv);
            return this;
          }

          var primeCache = {};
          function checkPrime(prime, generator) {
            var gen = generator.toString('hex');
            var hex = [gen, prime.toString(16)].join('_');
            if (hex in primeCache) {
              return primeCache[hex];
            }
            var error = 0;

            if (prime.isEven() ||
              !primes.simpleSieve ||
              !primes.fermatTest(prime) ||
              !millerRabin.test(prime)) {
              //not a prime so +1
              error += 1;

              if (gen === '02' || gen === '05') {
                // we'd be able to check the generator
                // it would fail so +8
                error += 8;
              } else {
                //we wouldn't be able to test the generator
                // so +4
                error += 4;
              }
              primeCache[hex] = error;
              return error;
            }
            if (!millerRabin.test(prime.shrn(1))) {
              //not a safe prime
              error += 2;
            }
            var rem;
            switch (gen) {
              case '02':
                if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
                  // unsuidable generator
                  error += 8;
                }
                break;
              case '05':
                rem = prime.mod(TEN);
                if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
                  // prime mod 10 needs to equal 3 or 7
                  error += 8;
                }
                break;
              default:
                error += 4;
            }
            primeCache[hex] = error;
            return error;
          }

          function DH(prime, generator, malleable) {
            this.setGenerator(generator);
            this.__prime = new BN(prime);
            this._prime = BN.mont(this.__prime);
            this._primeLen = prime.length;
            this._pub = undefined;
            this._priv = undefined;
            this._primeCode = undefined;
            if (malleable) {
              this.setPublicKey = setPublicKey;
              this.setPrivateKey = setPrivateKey;
            } else {
              this._primeCode = 8;
            }
          }
          Object.defineProperty(DH.prototype, 'verifyError', {
            enumerable: true,
            get: function () {
              if (typeof this._primeCode !== 'number') {
                this._primeCode = checkPrime(this.__prime, this.__gen);
              }
              return this._primeCode;
            }
          });
          DH.prototype.generateKeys = function () {
            if (!this._priv) {
              this._priv = new BN(randomBytes(this._primeLen));
            }
            this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
            return this.getPublicKey();
          };

          DH.prototype.computeSecret = function (other) {
            other = new BN(other);
            other = other.toRed(this._prime);
            var secret = other.redPow(this._priv).fromRed();
            var out = new Buffer(secret.toArray());
            var prime = this.getPrime();
            if (out.length < prime.length) {
              var front = new Buffer(prime.length - out.length);
              front.fill(0);
              out = Buffer.concat([front, out]);
            }
            return out;
          };

          DH.prototype.getPublicKey = function getPublicKey(enc) {
            return formatReturnValue(this._pub, enc);
          };

          DH.prototype.getPrivateKey = function getPrivateKey(enc) {
            return formatReturnValue(this._priv, enc);
          };

          DH.prototype.getPrime = function (enc) {
            return formatReturnValue(this.__prime, enc);
          };

          DH.prototype.getGenerator = function (enc) {
            return formatReturnValue(this._gen, enc);
          };

          DH.prototype.setGenerator = function (gen, enc) {
            enc = enc || 'utf8';
            if (!Buffer.isBuffer(gen)) {
              gen = new Buffer(gen, enc);
            }
            this.__gen = gen;
            this._gen = new BN(gen);
            return this;
          };

          function formatReturnValue(bn, enc) {
            var buf = new Buffer(bn.toArray());
            if (!enc) {
              return buf;
            } else {
              return buf.toString(enc);
            }
          }

        }).call(this)
      }).call(this, require("buffer").Buffer)
    }, { "./generatePrime": 233, "bn.js": 235, "buffer": 216, "miller-rabin": 288, "randombytes": 312 }], 233: [function (require, module, exports) {
      var randomBytes = require('randombytes');
      module.exports = findPrime;
      findPrime.simpleSieve = simpleSieve;
      findPrime.fermatTest = fermatTest;
      var BN = require('bn.js');
      var TWENTYFOUR = new BN(24);
      var MillerRabin = require('miller-rabin');
      var millerRabin = new MillerRabin();
      var ONE = new BN(1);
      var TWO = new BN(2);
      var FIVE = new BN(5);
      var SIXTEEN = new BN(16);
      var EIGHT = new BN(8);
      var TEN = new BN(10);
      var THREE = new BN(3);
      var SEVEN = new BN(7);
      var ELEVEN = new BN(11);
      var FOUR = new BN(4);
      var TWELVE = new BN(12);
      var primes = null;

      function _getPrimes() {
        if (primes !== null)
          return primes;

        var limit = 0x100000;
        var res = [];
        res[0] = 2;
        for (var i = 1, k = 3; k < limit; k += 2) {
          var sqrt = Math.ceil(Math.sqrt(k));
          for (var j = 0; j < i && res[j] <= sqrt; j++)
            if (k % res[j] === 0)
              break;

          if (i !== j && res[j] <= sqrt)
            continue;

          res[i++] = k;
        }
        primes = res;
        return res;
      }

      function simpleSieve(p) {
        var primes = _getPrimes();

        for (var i = 0; i < primes.length; i++)
          if (p.modn(primes[i]) === 0) {
            if (p.cmpn(primes[i]) === 0) {
              return true;
            } else {
              return false;
            }
          }

        return true;
      }

      function fermatTest(p) {
        var red = BN.mont(p);
        return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
      }

      function findPrime(bits, gen) {
        if (bits < 16) {
          // this is what openssl does
          if (gen === 2 || gen === 5) {
            return new BN([0x8c, 0x7b]);
          } else {
            return new BN([0x8c, 0x27]);
          }
        }
        gen = new BN(gen);

        var num, n2;

        while (true) {
          num = new BN(randomBytes(Math.ceil(bits / 8)));
          while (num.bitLength() > bits) {
            num.ishrn(1);
          }
          if (num.isEven()) {
            num.iadd(ONE);
          }
          if (!num.testn(1)) {
            num.iadd(TWO);
          }
          if (!gen.cmp(TWO)) {
            while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
              num.iadd(FOUR);
            }
          } else if (!gen.cmp(FIVE)) {
            while (num.mod(TEN).cmp(THREE)) {
              num.iadd(FOUR);
            }
          }
          n2 = num.shrn(1);
          if (simpleSieve(n2) && simpleSieve(num) &&
            fermatTest(n2) && fermatTest(num) &&
            millerRabin.test(n2) && millerRabin.test(num)) {
            return num;
          }
        }

      }

    }, { "bn.js": 235, "miller-rabin": 288, "randombytes": 312 }], 234: [function (require, module, exports) {
      module.exports = {
        "modp1": {
          "gen": "02",
          "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
        },
        "modp2": {
          "gen": "02",
          "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
        },
        "modp5": {
          "gen": "02",
          "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
        },
        "modp14": {
          "gen": "02",
          "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
        },
        "modp15": {
          "gen": "02",
          "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
        },
        "modp16": {
          "gen": "02",
          "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
        },
        "modp17": {
          "gen": "02",
          "prime": "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
        },
        "modp18": {
          "gen": "02",
          "prime": "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"
        }
      }
    }, {}], 235: [function (require, module, exports) {
      arguments[4][64][0].apply(exports, arguments)
    }, { "buffer": 172, "dup": 64 }], 236: [function (require, module, exports) {
      arguments[4][79][0].apply(exports, arguments)
    }, { "../package.json": 252, "./elliptic/curve": 239, "./elliptic/curves": 242, "./elliptic/ec": 243, "./elliptic/eddsa": 246, "./elliptic/utils": 250, "brorand": 171, "dup": 79 }], 237: [function (require, module, exports) {
      arguments[4][80][0].apply(exports, arguments)
    }, { "../utils": 250, "bn.js": 251, "dup": 80 }], 238: [function (require, module, exports) {
      arguments[4][81][0].apply(exports, arguments)
    }, { "../utils": 250, "./base": 237, "bn.js": 251, "dup": 81, "inherits": 285 }], 239: [function (require, module, exports) {
      arguments[4][82][0].apply(exports, arguments)
    }, { "./base": 237, "./edwards": 238, "./mont": 240, "./short": 241, "dup": 82 }], 240: [function (require, module, exports) {
      arguments[4][83][0].apply(exports, arguments)
    }, { "../utils": 250, "./base": 237, "bn.js": 251, "dup": 83, "inherits": 285 }], 241: [function (require, module, exports) {
      arguments[4][84][0].apply(exports, arguments)
    }, { "../utils": 250, "./base": 237, "bn.js": 251, "dup": 84, "inherits": 285 }], 242: [function (require, module, exports) {
      arguments[4][85][0].apply(exports, arguments)
    }, { "./curve": 239, "./precomputed/secp256k1": 249, "./utils": 250, "dup": 85, "hash.js": 271 }], 243: [function (require, module, exports) {
      arguments[4][86][0].apply(exports, arguments)
    }, { "../curves": 242, "../utils": 250, "./key": 244, "./signature": 245, "bn.js": 251, "brorand": 171, "dup": 86, "hmac-drbg": 283 }], 244: [function (require, module, exports) {
      arguments[4][87][0].apply(exports, arguments)
    }, { "../utils": 250, "bn.js": 251, "dup": 87 }], 245: [function (require, module, exports) {
      arguments[4][88][0].apply(exports, arguments)
    }, { "../utils": 250, "bn.js": 251, "dup": 88 }], 246: [function (require, module, exports) {
      arguments[4][89][0].apply(exports, arguments)
    }, { "../curves": 242, "../utils": 250, "./key": 247, "./signature": 248, "dup": 89, "hash.js": 271 }], 247: [function (require, module, exports) {
      arguments[4][90][0].apply(exports, arguments)
    }, { "../utils": 250, "dup": 90 }], 248: [function (require, module, exports) {
      arguments[4][91][0].apply(exports, arguments)
    }, { "../utils": 250, "bn.js": 251, "dup": 91 }], 249: [function (require, module, exports) {
      arguments[4][92][0].apply(exports, arguments)
    }, { "dup": 92 }], 250: [function (require, module, exports) {
      arguments[4][93][0].apply(exports, arguments)
    }, { "bn.js": 251, "dup": 93, "minimalistic-assert": 290, "minimalistic-crypto-utils": 291 }], 251: [function (require, module, exports) {
      arguments[4][64][0].apply(exports, arguments)
    }, { "buffer": 172, "dup": 64 }], 252: [function (require, module, exports) {
      arguments[4][94][0].apply(exports, arguments)
    }, { "dup": 94 }], 253: [function (require, module, exports) {
      // Copyright Joyent, Inc. and other Node contributors.
      //
      // Permission is hereby granted, free of charge, to any person obtaining a
      // copy of this software and associated documentation files (the
      // "Software"), to deal in the Software without restriction, including
      // without limitation the rights to use, copy, modify, merge, publish,
      // distribute, sublicense, and/or sell copies of the Software, and to permit
      // persons to whom the Software is furnished to do so, subject to the
      // following conditions:
      //
      // The above copyright notice and this permission notice shall be included
      // in all copies or substantial portions of the Software.
      //
      // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
      // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
      // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
      // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
      // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
      // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
      // USE OR OTHER DEALINGS IN THE SOFTWARE.

      'use strict';

      var R = typeof Reflect === 'object' ? Reflect : null
      var ReflectApply = R && typeof R.apply === 'function'
        ? R.apply
        : function ReflectApply(target, receiver, args) {
          return Function.prototype.apply.call(target, receiver, args);
        }

      var ReflectOwnKeys
      if (R && typeof R.ownKeys === 'function') {
        ReflectOwnKeys = R.ownKeys
      } else if (Object.getOwnPropertySymbols) {
        ReflectOwnKeys = function ReflectOwnKeys(target) {
          return Object.getOwnPropertyNames(target)
            .concat(Object.getOwnPropertySymbols(target));
        };
      } else {
        ReflectOwnKeys = function ReflectOwnKeys(target) {
          return Object.getOwnPropertyNames(target);
        };
      }

      function ProcessEmitWarning(warning) {
        if (console && console.warn) console.warn(warning);
      }

      var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
        return value !== value;
      }

      function EventEmitter() {
        EventEmitter.init.call(this);
      }
      module.exports = EventEmitter;
      module.exports.once = once;

      // Backwards-compat with node 0.10.x
      EventEmitter.EventEmitter = EventEmitter;

      EventEmitter.prototype._events = undefined;
      EventEmitter.prototype._eventsCount = 0;
      EventEmitter.prototype._maxListeners = undefined;

      // By default EventEmitters will print a warning if more than 10 listeners are
      // added to it. This is a useful default which helps finding memory leaks.
      var defaultMaxListeners = 10;

      function checkListener(listener) {
        if (typeof listener !== 'function') {
          throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
        }
      }

      Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
        enumerable: true,
        get: function () {
          return defaultMaxListeners;
        },
        set: function (arg) {
          if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
            throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
          }
          defaultMaxListeners = arg;
        }
      });

      EventEmitter.init = function () {

        if (this._events === undefined ||
          this._events === Object.getPrototypeOf(this)._events) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        }

        this._maxListeners = this._maxListeners || undefined;
      };

      // Obviously not all Emitters should be limited to 10. This function allows
      // that to be increased. Set to zero for unlimited.
      EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
        if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
          throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
        }
        this._maxListeners = n;
        return this;
      };

      function _getMaxListeners(that) {
        if (that._maxListeners === undefined)
          return EventEmitter.defaultMaxListeners;
        return that._maxListeners;
      }

      EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
        return _getMaxListeners(this);
      };

      EventEmitter.prototype.emit = function emit(type) {
        var args = [];
        for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
        var doError = (type === 'error');

        var events = this._events;
        if (events !== undefined)
          doError = (doError && events.error === undefined);
        else if (!doError)
          return false;

        // If there is no 'error' event listener then throw.
        if (doError) {
          var er;
          if (args.length > 0)
            er = args[0];
          if (er instanceof Error) {
            // Note: The comments on the `throw` lines are intentional, they show
            // up in Node's output if this results in an unhandled exception.
            throw er; // Unhandled 'error' event
          }
          // At least give some kind of context to the user
          var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
          err.context = er;
          throw err; // Unhandled 'error' event
        }

        var handler = events[type];

        if (handler === undefined)
          return false;

        if (typeof handler === 'function') {
          ReflectApply(handler, this, args);
        } else {
          var len = handler.length;
          var listeners = arrayClone(handler, len);
          for (var i = 0; i < len; ++i)
            ReflectApply(listeners[i], this, args);
        }

        return true;
      };

      function _addListener(target, type, listener, prepend) {
        var m;
        var events;
        var existing;

        checkListener(listener);

        events = target._events;
        if (events === undefined) {
          events = target._events = Object.create(null);
          target._eventsCount = 0;
        } else {
          // To avoid recursion in the case that type === "newListener"! Before
          // adding it to the listeners, first emit "newListener".
          if (events.newListener !== undefined) {
            target.emit('newListener', type,
              listener.listener ? listener.listener : listener);

            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
          }
          existing = events[type];
        }

        if (existing === undefined) {
          // Optimize the case of one listener. Don't need the extra array object.
          existing = events[type] = listener;
          ++target._eventsCount;
        } else {
          if (typeof existing === 'function') {
            // Adding the second element, need to change to array.
            existing = events[type] =
              prepend ? [listener, existing] : [existing, listener];
            // If we've already got an array, just append.
          } else if (prepend) {
            existing.unshift(listener);
          } else {
            existing.push(listener);
          }

          // Check for listener leak
          m = _getMaxListeners(target);
          if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' +
              existing.length + ' ' + String(type) + ' listeners ' +
              'added. Use emitter.setMaxListeners() to ' +
              'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            ProcessEmitWarning(w);
          }
        }

        return target;
      }

      EventEmitter.prototype.addListener = function addListener(type, listener) {
        return _addListener(this, type, listener, false);
      };

      EventEmitter.prototype.on = EventEmitter.prototype.addListener;

      EventEmitter.prototype.prependListener =
        function prependListener(type, listener) {
          return _addListener(this, type, listener, true);
        };

      function onceWrapper() {
        if (!this.fired) {
          this.target.removeListener(this.type, this.wrapFn);
          this.fired = true;
          if (arguments.length === 0)
            return this.listener.call(this.target);
          return this.listener.apply(this.target, arguments);
        }
      }

      function _onceWrap(target, type, listener) {
        var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
        var wrapped = onceWrapper.bind(state);
        wrapped.listener = listener;
        state.wrapFn = wrapped;
        return wrapped;
      }

      EventEmitter.prototype.once = function once(type, listener) {
        checkListener(listener);
        this.on(type, _onceWrap(this, type, listener));
        return this;
      };

      EventEmitter.prototype.prependOnceListener =
        function prependOnceListener(type, listener) {
          checkListener(listener);
          this.prependListener(type, _onceWrap(this, type, listener));
          return this;
        };

      // Emits a 'removeListener' event if and only if the listener was removed.
      EventEmitter.prototype.removeListener =
        function removeListener(type, listener) {
          var list, events, position, i, originalListener;

          checkListener(listener);

          events = this._events;
          if (events === undefined)
            return this;

          list = events[type];
          if (list === undefined)
            return this;

          if (list === listener || list.listener === listener) {
            if (--this._eventsCount === 0)
              this._events = Object.create(null);
            else {
              delete events[type];
              if (events.removeListener)
                this.emit('removeListener', type, list.listener || listener);
            }
          } else if (typeof list !== 'function') {
            position = -1;

            for (i = list.length - 1; i >= 0; i--) {
              if (list[i] === listener || list[i].listener === listener) {
                originalListener = list[i].listener;
                position = i;
                break;
              }
            }

            if (position < 0)
              return this;

            if (position === 0)
              list.shift();
            else {
              spliceOne(list, position);
            }

            if (list.length === 1)
              events[type] = list[0];

            if (events.removeListener !== undefined)
              this.emit('removeListener', type, originalListener || listener);
          }

          return this;
        };

      EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

      EventEmitter.prototype.removeAllListeners =
        function removeAllListeners(type) {
          var listeners, events, i;

          events = this._events;
          if (events === undefined)
            return this;

          // not listening for removeListener, no need to emit
          if (events.removeListener === undefined) {
            if (arguments.length === 0) {
              this._events = Object.create(null);
              this._eventsCount = 0;
            } else if (events[type] !== undefined) {
              if (--this._eventsCount === 0)
                this._events = Object.create(null);
              else
                delete events[type];
            }
            return this;
          }

          // emit removeListener for all listeners on all events
          if (arguments.length === 0) {
            var keys = Object.keys(events);
            var key;
            for (i = 0; i < keys.length; ++i) {
              key = keys[i];
              if (key === 'removeListener') continue;
              this.removeAllListeners(key);
            }
            this.removeAllListeners('removeListener');
            this._events = Object.create(null);
            this._eventsCount = 0;
            return this;
          }

          listeners = events[type];

          if (typeof listeners === 'function') {
            this.removeListener(type, listeners);
          } else if (listeners !== undefined) {
            // LIFO order
            for (i = listeners.length - 1; i >= 0; i--) {
              this.removeListener(type, listeners[i]);
            }
          }

          return this;
        };

      function _listeners(target, type, unwrap) {
        var events = target._events;

        if (events === undefined)
          return [];

        var evlistener = events[type];
        if (evlistener === undefined)
          return [];

        if (typeof evlistener === 'function')
          return unwrap ? [evlistener.listener || evlistener] : [evlistener];

        return unwrap ?
          unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
      }

      EventEmitter.prototype.listeners = function listeners(type) {
        return _listeners(this, type, true);
      };

      EventEmitter.prototype.rawListeners = function rawListeners(type) {
        return _listeners(this, type, false);
      };

      EventEmitter.listenerCount = function (emitter, type) {
        if (typeof emitter.listenerCount === 'function') {
          return emitter.listenerCount(type);
        } else {
          return listenerCount.call(emitter, type);
        }
      };

      EventEmitter.prototype.listenerCount = listenerCount;
      function listenerCount(type) {
        var events = this._events;

        if (events !== undefined) {
          var evlistener = events[type];

          if (typeof evlistener === 'function') {
            return 1;
          } else if (evlistener !== undefined) {
            return evlistener.length;
          }
        }

        return 0;
      }

      EventEmitter.prototype.eventNames = function eventNames() {
        return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
      };

      function arrayClone(arr, n) {
        var copy = new Array(n);
        for (var i = 0; i < n; ++i)
          copy[i] = arr[i];
        return copy;
      }

      function spliceOne(list, index) {
        for (; index + 1 < list.length; index++)
          list[index] = list[index + 1];
        list.pop();
      }

      function unwrapListeners(arr) {
        var ret = new Array(arr.length);
        for (var i = 0; i < ret.length; ++i) {
          ret[i] = arr[i].listener || arr[i];
        }
        return ret;
      }

      function once(emitter, name) {
        return new Promise(function (resolve, reject) {
          function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
          }

          function resolver() {
            if (typeof emitter.removeListener === 'function') {
              emitter.removeListener('error', errorListener);
            }
            resolve([].slice.call(arguments));
          };

          eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
          if (name !== 'error') {
            addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
          }
        });
      }

      function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
        if (typeof emitter.on === 'function') {
          eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
        }
      }

      function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
        if (typeof emitter.on === 'function') {
          if (flags.once) {
            emitter.once(name, listener);
          } else {
            emitter.on(name, listener);
          }
        } else if (typeof emitter.addEventListener === 'function') {
          // EventTarget does not have `error` event semantics like Node
          // EventEmitters, we do not listen for `error` events here.
          emitter.addEventListener(name, function wrapListener(arg) {
            // IE does not have builtin `{ once: true }` support so we
            // have to do it manually.
            if (flags.once) {
              emitter.removeEventListener(name, wrapListener);
            }
            listener(arg);
          });
        } else {
          throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
        }
      }

    }, {}], 254: [function (require, module, exports) {
      var Buffer = require('safe-buffer').Buffer
      var MD5 = require('md5.js')

      /* eslint-disable camelcase */
      function EVP_BytesToKey(password, salt, keyBits, ivLen) {
        if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary')
        if (salt) {
          if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary')
          if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length')
        }

        var keyLen = keyBits / 8
        var key = Buffer.alloc(keyLen)
        var iv = Buffer.alloc(ivLen || 0)
        var tmp = Buffer.alloc(0)

        while (keyLen > 0 || ivLen > 0) {
          var hash = new MD5()
          hash.update(tmp)
          hash.update(password)
          if (salt) hash.update(salt)
          tmp = hash.digest()

          var used = 0

          if (keyLen > 0) {
            var keyStart = key.length - keyLen
            used = Math.min(keyLen, tmp.length)
            tmp.copy(key, keyStart, 0, used)
            keyLen -= used
          }

          if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen
            var length = Math.min(ivLen, tmp.length - used)
            tmp.copy(iv, ivStart, used, used + length)
            ivLen -= length
          }
        }

        tmp.fill(0)
        return { key: key, iv: iv }
      }

      module.exports = EVP_BytesToKey

    }, { "md5.js": 287, "safe-buffer": 315 }], 255: [function (require, module, exports) {
      arguments[4][95][0].apply(exports, arguments)
    }, { "dup": 95, "inherits": 285, "readable-stream": 270, "safe-buffer": 315 }], 256: [function (require, module, exports) {
      arguments[4][117][0].apply(exports, arguments)
    }, { "dup": 117 }], 257: [function (require, module, exports) {
      arguments[4][118][0].apply(exports, arguments)
    }, { "./_stream_readable": 259, "./_stream_writable": 261, "_process": 304, "dup": 118, "inherits": 285 }], 258: [function (require, module, exports) {
      arguments[4][119][0].apply(exports, arguments)
    }, { "./_stream_transform": 260, "dup": 119, "inherits": 285 }], 259: [function (require, module, exports) {
      arguments[4][120][0].apply(exports, arguments)
    }, { "../errors": 256, "./_stream_duplex": 257, "./internal/streams/async_iterator": 262, "./internal/streams/buffer_list": 263, "./internal/streams/destroy": 264, "./internal/streams/from": 266, "./internal/streams/state": 268, "./internal/streams/stream": 269, "_process": 304, "buffer": 216, "dup": 120, "events": 253, "inherits": 285, "string_decoder/": 340, "util": 172 }], 260: [function (require, module, exports) {
      arguments[4][121][0].apply(exports, arguments)
    }, { "../errors": 256, "./_stream_duplex": 257, "dup": 121, "inherits": 285 }], 261: [function (require, module, exports) {
      arguments[4][122][0].apply(exports, arguments)
    }, { "../errors": 256, "./_stream_duplex": 257, "./internal/streams/destroy": 264, "./internal/streams/state": 268, "./internal/streams/stream": 269, "_process": 304, "buffer": 216, "dup": 122, "inherits": 285, "util-deprecate": 341 }], 262: [function (require, module, exports) {
      arguments[4][123][0].apply(exports, arguments)
    }, { "./end-of-stream": 265, "_process": 304, "dup": 123 }], 263: [function (require, module, exports) {
      arguments[4][124][0].apply(exports, arguments)
    }, { "buffer": 216, "dup": 124, "util": 172 }], 264: [function (require, module, exports) {
      arguments[4][125][0].apply(exports, arguments)
    }, { "_process": 304, "dup": 125 }], 265: [function (require, module, exports) {
      arguments[4][126][0].apply(exports, arguments)
    }, { "../../../errors": 256, "dup": 126 }], 266: [function (require, module, exports) {
      arguments[4][127][0].apply(exports, arguments)
    }, { "dup": 127 }], 267: [function (require, module, exports) {
      arguments[4][128][0].apply(exports, arguments)
    }, { "../../../errors": 256, "./end-of-stream": 265, "dup": 128 }], 268: [function (require, module, exports) {
      arguments[4][129][0].apply(exports, arguments)
    }, { "../../../errors": 256, "dup": 129 }], 269: [function (require, module, exports) {
      arguments[4][130][0].apply(exports, arguments)
    }, { "dup": 130, "events": 253 }], 270: [function (require, module, exports) {
      arguments[4][131][0].apply(exports, arguments)
    }, { "./lib/_stream_duplex.js": 257, "./lib/_stream_passthrough.js": 258, "./lib/_stream_readable.js": 259, "./lib/_stream_transform.js": 260, "./lib/_stream_writable.js": 261, "./lib/internal/streams/end-of-stream.js": 265, "./lib/internal/streams/pipeline.js": 267, "dup": 131 }], 271: [function (require, module, exports) {
      arguments[4][96][0].apply(exports, arguments)
    }, { "./hash/common": 272, "./hash/hmac": 273, "./hash/ripemd": 274, "./hash/sha": 275, "./hash/utils": 282, "dup": 96 }], 272: [function (require, module, exports) {
      arguments[4][97][0].apply(exports, arguments)
    }, { "./utils": 282, "dup": 97, "minimalistic-assert": 290 }], 273: [function (require, module, exports) {
      arguments[4][98][0].apply(exports, arguments)
    }, { "./utils": 282, "dup": 98, "minimalistic-assert": 290 }], 274: [function (require, module, exports) {
      arguments[4][99][0].apply(exports, arguments)
    }, { "./common": 272, "./utils": 282, "dup": 99 }], 275: [function (require, module, exports) {
      arguments[4][100][0].apply(exports, arguments)
    }, { "./sha/1": 276, "./sha/224": 277, "./sha/256": 278, "./sha/384": 279, "./sha/512": 280, "dup": 100 }], 276: [function (require, module, exports) {
      arguments[4][101][0].apply(exports, arguments)
    }, { "../common": 272, "../utils": 282, "./common": 281, "dup": 101 }], 277: [function (require, module, exports) {
      arguments[4][102][0].apply(exports, arguments)
    }, { "../utils": 282, "./256": 278, "dup": 102 }], 278: [function (require, module, exports) {
      arguments[4][103][0].apply(exports, arguments)
    }, { "../common": 272, "../utils": 282, "./common": 281, "dup": 103, "minimalistic-assert": 290 }], 279: [function (require, module, exports) {
      arguments[4][104][0].apply(exports, arguments)
    }, { "../utils": 282, "./512": 280, "dup": 104 }], 280: [function (require, module, exports) {
      arguments[4][105][0].apply(exports, arguments)
    }, { "../common": 272, "../utils": 282, "dup": 105, "minimalistic-assert": 290 }], 281: [function (require, module, exports) {
      arguments[4][106][0].apply(exports, arguments)
    }, { "../utils": 282, "dup": 106 }], 282: [function (require, module, exports) {
      arguments[4][107][0].apply(exports, arguments)
    }, { "dup": 107, "inherits": 285, "minimalistic-assert": 290 }], 283: [function (require, module, exports) {
      arguments[4][108][0].apply(exports, arguments)
    }, { "dup": 108, "hash.js": 271, "minimalistic-assert": 290, "minimalistic-crypto-utils": 291 }], 284: [function (require, module, exports) {
      /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
      exports.read = function (buffer, offset, isLE, mLen, nBytes) {
        var e, m
        var eLen = (nBytes * 8) - mLen - 1
        var eMax = (1 << eLen) - 1
        var eBias = eMax >> 1
        var nBits = -7
        var i = isLE ? (nBytes - 1) : 0
        var d = isLE ? -1 : 1
        var s = buffer[offset + i]

        i += d

        e = s & ((1 << (-nBits)) - 1)
        s >>= (-nBits)
        nBits += eLen
        for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) { }

        m = e & ((1 << (-nBits)) - 1)
        e >>= (-nBits)
        nBits += mLen
        for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) { }

        if (e === 0) {
          e = 1 - eBias
        } else if (e === eMax) {
          return m ? NaN : ((s ? -1 : 1) * Infinity)
        } else {
          m = m + Math.pow(2, mLen)
          e = e - eBias
        }
        return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
      }

      exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
        var e, m, c
        var eLen = (nBytes * 8) - mLen - 1
        var eMax = (1 << eLen) - 1
        var eBias = eMax >> 1
        var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
        var i = isLE ? 0 : (nBytes - 1)
        var d = isLE ? 1 : -1
        var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

        value = Math.abs(value)

        if (isNaN(value) || value === Infinity) {
          m = isNaN(value) ? 1 : 0
          e = eMax
        } else {
          e = Math.floor(Math.log(value) / Math.LN2)
          if (value * (c = Math.pow(2, -e)) < 1) {
            e--
            c *= 2
          }
          if (e + eBias >= 1) {
            value += rt / c
          } else {
            value += rt * Math.pow(2, 1 - eBias)
          }
          if (value * c >= 2) {
            e++
            c /= 2
          }

          if (e + eBias >= eMax) {
            m = 0
            e = eMax
          } else if (e + eBias >= 1) {
            m = ((value * c) - 1) * Math.pow(2, mLen)
            e = e + eBias
          } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
            e = 0
          }
        }

        for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) { }

        e = (e << mLen) | m
        eLen += mLen
        for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) { }

        buffer[offset + i - d] |= s * 128
      }

    }, {}], 285: [function (require, module, exports) {
      arguments[4][109][0].apply(exports, arguments)
    }, { "dup": 109 }], 286: [function (require, module, exports) {
      /*!
       * Determine if an object is a Buffer
       *
       * @author   Feross Aboukhadijeh <https://feross.org>
       * @license  MIT
       */

      // The _isBuffer check is for Safari 5-7 support, because it's missing
      // Object.prototype.constructor. Remove this eventually
      module.exports = function (obj) {
        return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
      }

      function isBuffer(obj) {
        return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
      }

      // For Node v0.10 support. Remove this eventually.
      function isSlowBuffer(obj) {
        return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
      }

    }, {}], 287: [function (require, module, exports) {
      arguments[4][110][0].apply(exports, arguments)
    }, { "dup": 110, "hash-base": 255, "inherits": 285, "safe-buffer": 315 }], 288: [function (require, module, exports) {
      var bn = require('bn.js');
      var brorand = require('brorand');

      function MillerRabin(rand) {
        this.rand = rand || new brorand.Rand();
      }
      module.exports = MillerRabin;

      MillerRabin.create = function create(rand) {
        return new MillerRabin(rand);
      };

      MillerRabin.prototype._randbelow = function _randbelow(n) {
        var len = n.bitLength();
        var min_bytes = Math.ceil(len / 8);

        // Generage random bytes until a number less than n is found.
        // This ensures that 0..n-1 have an equal probability of being selected.
        do
          var a = new bn(this.rand.generate(min_bytes));
        while (a.cmp(n) >= 0);

        return a;
      };

      MillerRabin.prototype._randrange = function _randrange(start, stop) {
        // Generate a random number greater than or equal to start and less than stop.
        var size = stop.sub(start);
        return start.add(this._randbelow(size));
      };

      MillerRabin.prototype.test = function test(n, k, cb) {
        var len = n.bitLength();
        var red = bn.mont(n);
        var rone = new bn(1).toRed(red);

        if (!k)
          k = Math.max(1, (len / 48) | 0);

        // Find d and s, (n - 1) = (2 ^ s) * d;
        var n1 = n.subn(1);
        for (var s = 0; !n1.testn(s); s++) { }
        var d = n.shrn(s);

        var rn1 = n1.toRed(red);

        var prime = true;
        for (; k > 0; k--) {
          var a = this._randrange(new bn(2), n1);
          if (cb)
            cb(a);

          var x = a.toRed(red).redPow(d);
          if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
            continue;

          for (var i = 1; i < s; i++) {
            x = x.redSqr();

            if (x.cmp(rone) === 0)
              return false;
            if (x.cmp(rn1) === 0)
              break;
          }

          if (i === s)
            return false;
        }

        return prime;
      };

      MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
        var len = n.bitLength();
        var red = bn.mont(n);
        var rone = new bn(1).toRed(red);

        if (!k)
          k = Math.max(1, (len / 48) | 0);

        // Find d and s, (n - 1) = (2 ^ s) * d;
        var n1 = n.subn(1);
        for (var s = 0; !n1.testn(s); s++) { }
        var d = n.shrn(s);

        var rn1 = n1.toRed(red);

        for (; k > 0; k--) {
          var a = this._randrange(new bn(2), n1);

          var g = n.gcd(a);
          if (g.cmpn(1) !== 0)
            return g;

          var x = a.toRed(red).redPow(d);
          if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
            continue;

          for (var i = 1; i < s; i++) {
            x = x.redSqr();

            if (x.cmp(rone) === 0)
              return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0)
              break;
          }

          if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
          }
        }

        return false;
      };

    }, { "bn.js": 289, "brorand": 171 }], 289: [function (require, module, exports) {
      arguments[4][64][0].apply(exports, arguments)
    }, { "buffer": 172, "dup": 64 }], 290: [function (require, module, exports) {
      arguments[4][112][0].apply(exports, arguments)
    }, { "dup": 112 }], 291: [function (require, module, exports) {
      arguments[4][113][0].apply(exports, arguments)
    }, { "dup": 113 }], 292: [function (require, module, exports) {
      /*
      object-assign
      (c) Sindre Sorhus
      @license MIT
      */

      'use strict';
      /* eslint-disable no-unused-vars */
      var getOwnPropertySymbols = Object.getOwnPropertySymbols;
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var propIsEnumerable = Object.prototype.propertyIsEnumerable;

      function toObject(val) {
        if (val === null || val === undefined) {
          throw new TypeError('Object.assign cannot be called with null or undefined');
        }

        return Object(val);
      }

      function shouldUseNative() {
        try {
          if (!Object.assign) {
            return false;
          }

          // Detect buggy property enumeration order in older V8 versions.

          // https://bugs.chromium.org/p/v8/issues/detail?id=4118
          var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
          test1[5] = 'de';
          if (Object.getOwnPropertyNames(test1)[0] === '5') {
            return false;
          }

          // https://bugs.chromium.org/p/v8/issues/detail?id=3056
          var test2 = {};
          for (var i = 0; i < 10; i++) {
            test2['_' + String.fromCharCode(i)] = i;
          }
          var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
            return test2[n];
          });
          if (order2.join('') !== '0123456789') {
            return false;
          }

          // https://bugs.chromium.org/p/v8/issues/detail?id=3056
          var test3 = {};
          'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
            test3[letter] = letter;
          });
          if (Object.keys(Object.assign({}, test3)).join('') !==
            'abcdefghijklmnopqrst') {
            return false;
          }

          return true;
        } catch (err) {
          // We don't expect any of the above to throw, but better to be safe.
          return false;
        }
      }

      module.exports = shouldUseNative() ? Object.assign : function (target, source) {
        var from;
        var to = toObject(target);
        var symbols;

        for (var s = 1; s < arguments.length; s++) {
          from = Object(arguments[s]);

          for (var key in from) {
            if (hasOwnProperty.call(from, key)) {
              to[key] = from[key];
            }
          }

          if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);
            for (var i = 0; i < symbols.length; i++) {
              if (propIsEnumerable.call(from, symbols[i])) {
                to[symbols[i]] = from[symbols[i]];
              }
            }
          }
        }

        return to;
      };

    }, {}], 293: [function (require, module, exports) {
      module.exports = {
        "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
        "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
        "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
        "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
        "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
        "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
        "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
        "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
        "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
        "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
        "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
        "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
      }
    }, {}], 294: [function (require, module, exports) {
      // from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
      // Fedor, you are amazing.
      'use strict'

      var asn1 = require('asn1.js')

      exports.certificate = require('./certificate')

      var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
        this.seq().obj(
          this.key('version').int(),
          this.key('modulus').int(),
          this.key('publicExponent').int(),
          this.key('privateExponent').int(),
          this.key('prime1').int(),
          this.key('prime2').int(),
          this.key('exponent1').int(),
          this.key('exponent2').int(),
          this.key('coefficient').int()
        )
      })
      exports.RSAPrivateKey = RSAPrivateKey

      var RSAPublicKey = asn1.define('RSAPublicKey', function () {
        this.seq().obj(
          this.key('modulus').int(),
          this.key('publicExponent').int()
        )
      })
      exports.RSAPublicKey = RSAPublicKey

      var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
        this.seq().obj(
          this.key('algorithm').use(AlgorithmIdentifier),
          this.key('subjectPublicKey').bitstr()
        )
      })
      exports.PublicKey = PublicKey

      var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
        this.seq().obj(
          this.key('algorithm').objid(),
          this.key('none').null_().optional(),
          this.key('curve').objid().optional(),
          this.key('params').seq().obj(
            this.key('p').int(),
            this.key('q').int(),
            this.key('g').int()
          ).optional()
        )
      })

      var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
        this.seq().obj(
          this.key('version').int(),
          this.key('algorithm').use(AlgorithmIdentifier),
          this.key('subjectPrivateKey').octstr()
        )
      })
      exports.PrivateKey = PrivateKeyInfo
      var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
        this.seq().obj(
          this.key('algorithm').seq().obj(
            this.key('id').objid(),
            this.key('decrypt').seq().obj(
              this.key('kde').seq().obj(
                this.key('id').objid(),
                this.key('kdeparams').seq().obj(
                  this.key('salt').octstr(),
                  this.key('iters').int()
                )
              ),
              this.key('cipher').seq().obj(
                this.key('algo').objid(),
                this.key('iv').octstr()
              )
            )
          ),
          this.key('subjectPrivateKey').octstr()
        )
      })

      exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo

      var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
        this.seq().obj(
          this.key('version').int(),
          this.key('p').int(),
          this.key('q').int(),
          this.key('g').int(),
          this.key('pub_key').int(),
          this.key('priv_key').int()
        )
      })
      exports.DSAPrivateKey = DSAPrivateKey

      exports.DSAparam = asn1.define('DSAparam', function () {
        this.int()
      })

      var ECPrivateKey = asn1.define('ECPrivateKey', function () {
        this.seq().obj(
          this.key('version').int(),
          this.key('privateKey').octstr(),
          this.key('parameters').optional().explicit(0).use(ECParameters),
          this.key('publicKey').optional().explicit(1).bitstr()
        )
      })
      exports.ECPrivateKey = ECPrivateKey

      var ECParameters = asn1.define('ECParameters', function () {
        this.choice({
          namedCurve: this.objid()
        })
      })

      exports.signature = asn1.define('signature', function () {
        this.seq().obj(
          this.key('r').int(),
          this.key('s').int()
        )
      })

    }, { "./certificate": 295, "asn1.js": 150 }], 295: [function (require, module, exports) {
      // from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
      // thanks to @Rantanen

      'use strict'

      var asn = require('asn1.js')

      var Time = asn.define('Time', function () {
        this.choice({
          utcTime: this.utctime(),
          generalTime: this.gentime()
        })
      })

      var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
        this.seq().obj(
          this.key('type').objid(),
          this.key('value').any()
        )
      })

      var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
        this.seq().obj(
          this.key('algorithm').objid(),
          this.key('parameters').optional(),
          this.key('curve').objid().optional()
        )
      })

      var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
        this.seq().obj(
          this.key('algorithm').use(AlgorithmIdentifier),
          this.key('subjectPublicKey').bitstr()
        )
      })

      var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
        this.setof(AttributeTypeValue)
      })

      var RDNSequence = asn.define('RDNSequence', function () {
        this.seqof(RelativeDistinguishedName)
      })

      var Name = asn.define('Name', function () {
        this.choice({
          rdnSequence: this.use(RDNSequence)
        })
      })

      var Validity = asn.define('Validity', function () {
        this.seq().obj(
          this.key('notBefore').use(Time),
          this.key('notAfter').use(Time)
        )
      })

      var Extension = asn.define('Extension', function () {
        this.seq().obj(
          this.key('extnID').objid(),
          this.key('critical').bool().def(false),
          this.key('extnValue').octstr()
        )
      })

      var TBSCertificate = asn.define('TBSCertificate', function () {
        this.seq().obj(
          this.key('version').explicit(0).int().optional(),
          this.key('serialNumber').int(),
          this.key('signature').use(AlgorithmIdentifier),
          this.key('issuer').use(Name),
          this.key('validity').use(Validity),
          this.key('subject').use(Name),
          this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
          this.key('issuerUniqueID').implicit(1).bitstr().optional(),
          this.key('subjectUniqueID').implicit(2).bitstr().optional(),
          this.key('extensions').explicit(3).seqof(Extension).optional()
        )
      })

      var X509Certificate = asn.define('X509Certificate', function () {
        this.seq().obj(
          this.key('tbsCertificate').use(TBSCertificate),
          this.key('signatureAlgorithm').use(AlgorithmIdentifier),
          this.key('signatureValue').bitstr()
        )
      })

      module.exports = X509Certificate

    }, { "asn1.js": 150 }], 296: [function (require, module, exports) {
      // adapted from https://github.com/apatil/pemstrip
      var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m
      var startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m
      var fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m
      var evp = require('evp_bytestokey')
      var ciphers = require('browserify-aes')
      var Buffer = require('safe-buffer').Buffer
      module.exports = function (okey, password) {
        var key = okey.toString()
        var match = key.match(findProc)
        var decrypted
        if (!match) {
          var match2 = key.match(fullRegex)
          decrypted = Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64')
        } else {
          var suite = 'aes' + match[1]
          var iv = Buffer.from(match[2], 'hex')
          var cipherText = Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64')
          var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key
          var out = []
          var cipher = ciphers.createDecipheriv(suite, cipherKey, iv)
          out.push(cipher.update(cipherText))
          out.push(cipher.final())
          decrypted = Buffer.concat(out)
        }
        var tag = key.match(startRegex)[1]
        return {
          tag: tag,
          data: decrypted
        }
      }

    }, { "browserify-aes": 175, "evp_bytestokey": 254, "safe-buffer": 315 }], 297: [function (require, module, exports) {
      var asn1 = require('./asn1')
      var aesid = require('./aesid.json')
      var fixProc = require('./fixProc')
      var ciphers = require('browserify-aes')
      var compat = require('pbkdf2')
      var Buffer = require('safe-buffer').Buffer
      module.exports = parseKeys

      function parseKeys(buffer) {
        var password
        if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
          password = buffer.passphrase
          buffer = buffer.key
        }
        if (typeof buffer === 'string') {
          buffer = Buffer.from(buffer)
        }

        var stripped = fixProc(buffer, password)

        var type = stripped.tag
        var data = stripped.data
        var subtype, ndata
        switch (type) {
          case 'CERTIFICATE':
            ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo
          // falls through
          case 'PUBLIC KEY':
            if (!ndata) {
              ndata = asn1.PublicKey.decode(data, 'der')
            }
            subtype = ndata.algorithm.algorithm.join('.')
            switch (subtype) {
              case '1.2.840.113549.1.1.1':
                return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der')
              case '1.2.840.10045.2.1':
                ndata.subjectPrivateKey = ndata.subjectPublicKey
                return {
                  type: 'ec',
                  data: ndata
                }
              case '1.2.840.10040.4.1':
                ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der')
                return {
                  type: 'dsa',
                  data: ndata.algorithm.params
                }
              default: throw new Error('unknown key id ' + subtype)
            }
          // throw new Error('unknown key type ' + type)
          case 'ENCRYPTED PRIVATE KEY':
            data = asn1.EncryptedPrivateKey.decode(data, 'der')
            data = decrypt(data, password)
          // falls through
          case 'PRIVATE KEY':
            ndata = asn1.PrivateKey.decode(data, 'der')
            subtype = ndata.algorithm.algorithm.join('.')
            switch (subtype) {
              case '1.2.840.113549.1.1.1':
                return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der')
              case '1.2.840.10045.2.1':
                return {
                  curve: ndata.algorithm.curve,
                  privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                }
              case '1.2.840.10040.4.1':
                ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der')
                return {
                  type: 'dsa',
                  params: ndata.algorithm.params
                }
              default: throw new Error('unknown key id ' + subtype)
            }
          // throw new Error('unknown key type ' + type)
          case 'RSA PUBLIC KEY':
            return asn1.RSAPublicKey.decode(data, 'der')
          case 'RSA PRIVATE KEY':
            return asn1.RSAPrivateKey.decode(data, 'der')
          case 'DSA PRIVATE KEY':
            return {
              type: 'dsa',
              params: asn1.DSAPrivateKey.decode(data, 'der')
            }
          case 'EC PRIVATE KEY':
            data = asn1.ECPrivateKey.decode(data, 'der')
            return {
              curve: data.parameters.value,
              privateKey: data.privateKey
            }
          default: throw new Error('unknown key type ' + type)
        }
      }
      parseKeys.signature = asn1.signature
      function decrypt(data, password) {
        var salt = data.algorithm.decrypt.kde.kdeparams.salt
        var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10)
        var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')]
        var iv = data.algorithm.decrypt.cipher.iv
        var cipherText = data.subjectPrivateKey
        var keylen = parseInt(algo.split('-')[1], 10) / 8
        var key = compat.pbkdf2Sync(password, salt, iters, keylen, 'sha1')
        var cipher = ciphers.createDecipheriv(algo, key, iv)
        var out = []
        out.push(cipher.update(cipherText))
        out.push(cipher.final())
        return Buffer.concat(out)
      }

    }, { "./aesid.json": 293, "./asn1": 294, "./fixProc": 296, "browserify-aes": 175, "pbkdf2": 298, "safe-buffer": 315 }], 298: [function (require, module, exports) {
      exports.pbkdf2 = require('./lib/async')
      exports.pbkdf2Sync = require('./lib/sync')

    }, { "./lib/async": 299, "./lib/sync": 302 }], 299: [function (require, module, exports) {
      (function (global) {
        (function () {
          var Buffer = require('safe-buffer').Buffer

          var checkParameters = require('./precondition')
          var defaultEncoding = require('./default-encoding')
          var sync = require('./sync')
          var toBuffer = require('./to-buffer')

          var ZERO_BUF
          var subtle = global.crypto && global.crypto.subtle
          var toBrowser = {
            sha: 'SHA-1',
            'sha-1': 'SHA-1',
            sha1: 'SHA-1',
            sha256: 'SHA-256',
            'sha-256': 'SHA-256',
            sha384: 'SHA-384',
            'sha-384': 'SHA-384',
            'sha-512': 'SHA-512',
            sha512: 'SHA-512'
          }
          var checks = []
          function checkNative(algo) {
            if (global.process && !global.process.browser) {
              return Promise.resolve(false)
            }
            if (!subtle || !subtle.importKey || !subtle.deriveBits) {
              return Promise.resolve(false)
            }
            if (checks[algo] !== undefined) {
              return checks[algo]
            }
            ZERO_BUF = ZERO_BUF || Buffer.alloc(8)
            var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
              .then(function () {
                return true
              }).catch(function () {
                return false
              })
            checks[algo] = prom
            return prom
          }
          var nextTick
          function getNextTick() {
            if (nextTick) {
              return nextTick
            }
            if (global.process && global.process.nextTick) {
              nextTick = global.process.nextTick
            } else if (global.queueMicrotask) {
              nextTick = global.queueMicrotask
            } else if (global.setImmediate) {
              nextTick = global.setImmediate
            } else {
              nextTick = global.setTimeout
            }
            return nextTick
          }
          function browserPbkdf2(password, salt, iterations, length, algo) {
            return subtle.importKey(
              'raw', password, { name: 'PBKDF2' }, false, ['deriveBits']
            ).then(function (key) {
              return subtle.deriveBits({
                name: 'PBKDF2',
                salt: salt,
                iterations: iterations,
                hash: {
                  name: algo
                }
              }, key, length << 3)
            }).then(function (res) {
              return Buffer.from(res)
            })
          }

          function resolvePromise(promise, callback) {
            promise.then(function (out) {
              getNextTick()(function () {
                callback(null, out)
              })
            }, function (e) {
              getNextTick()(function () {
                callback(e)
              })
            })
          }
          module.exports = function (password, salt, iterations, keylen, digest, callback) {
            if (typeof digest === 'function') {
              callback = digest
              digest = undefined
            }

            digest = digest || 'sha1'
            var algo = toBrowser[digest.toLowerCase()]

            if (!algo || typeof global.Promise !== 'function') {
              getNextTick()(function () {
                var out
                try {
                  out = sync(password, salt, iterations, keylen, digest)
                } catch (e) {
                  return callback(e)
                }
                callback(null, out)
              })
              return
            }

            checkParameters(iterations, keylen)
            password = toBuffer(password, defaultEncoding, 'Password')
            salt = toBuffer(salt, defaultEncoding, 'Salt')
            if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2')

            resolvePromise(checkNative(algo).then(function (resp) {
              if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo)

              return sync(password, salt, iterations, keylen, digest)
            }), callback)
          }

        }).call(this)
      }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
    }, { "./default-encoding": 300, "./precondition": 301, "./sync": 302, "./to-buffer": 303, "safe-buffer": 315 }], 300: [function (require, module, exports) {
      (function (process, global) {
        (function () {
          var defaultEncoding
          /* istanbul ignore next */
          if (global.process && global.process.browser) {
            defaultEncoding = 'utf-8'
          } else if (global.process && global.process.version) {
            var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10)

            defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary'
          } else {
            defaultEncoding = 'utf-8'
          }
          module.exports = defaultEncoding

        }).call(this)
      }).call(this, require('_process'), typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
    }, { "_process": 304 }], 301: [function (require, module, exports) {
      var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs

      module.exports = function (iterations, keylen) {
        if (typeof iterations !== 'number') {
          throw new TypeError('Iterations not a number')
        }

        if (iterations < 0) {
          throw new TypeError('Bad iterations')
        }

        if (typeof keylen !== 'number') {
          throw new TypeError('Key length not a number')
        }

        if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
          throw new TypeError('Bad key length')
        }
      }

    }, {}], 302: [function (require, module, exports) {
      var md5 = require('create-hash/md5')
      var RIPEMD160 = require('ripemd160')
      var sha = require('sha.js')
      var Buffer = require('safe-buffer').Buffer

      var checkParameters = require('./precondition')
      var defaultEncoding = require('./default-encoding')
      var toBuffer = require('./to-buffer')

      var ZEROS = Buffer.alloc(128)
      var sizes = {
        md5: 16,
        sha1: 20,
        sha224: 28,
        sha256: 32,
        sha384: 48,
        sha512: 64,
        rmd160: 20,
        ripemd160: 20
      }

      function Hmac(alg, key, saltLen) {
        var hash = getDigest(alg)
        var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

        if (key.length > blocksize) {
          key = hash(key)
        } else if (key.length < blocksize) {
          key = Buffer.concat([key, ZEROS], blocksize)
        }

        var ipad = Buffer.allocUnsafe(blocksize + sizes[alg])
        var opad = Buffer.allocUnsafe(blocksize + sizes[alg])
        for (var i = 0; i < blocksize; i++) {
          ipad[i] = key[i] ^ 0x36
          opad[i] = key[i] ^ 0x5C
        }

        var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4)
        ipad.copy(ipad1, 0, 0, blocksize)
        this.ipad1 = ipad1
        this.ipad2 = ipad
        this.opad = opad
        this.alg = alg
        this.blocksize = blocksize
        this.hash = hash
        this.size = sizes[alg]
      }

      Hmac.prototype.run = function (data, ipad) {
        data.copy(ipad, this.blocksize)
        var h = this.hash(ipad)
        h.copy(this.opad, this.blocksize)
        return this.hash(this.opad)
      }

      function getDigest(alg) {
        function shaFunc(data) {
          return sha(alg).update(data).digest()
        }
        function rmd160Func(data) {
          return new RIPEMD160().update(data).digest()
        }

        if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func
        if (alg === 'md5') return md5
        return shaFunc
      }

      function pbkdf2(password, salt, iterations, keylen, digest) {
        checkParameters(iterations, keylen)
        password = toBuffer(password, defaultEncoding, 'Password')
        salt = toBuffer(salt, defaultEncoding, 'Salt')

        digest = digest || 'sha1'

        var hmac = new Hmac(digest, password, salt.length)

        var DK = Buffer.allocUnsafe(keylen)
        var block1 = Buffer.allocUnsafe(salt.length + 4)
        salt.copy(block1, 0, 0, salt.length)

        var destPos = 0
        var hLen = sizes[digest]
        var l = Math.ceil(keylen / hLen)

        for (var i = 1; i <= l; i++) {
          block1.writeUInt32BE(i, salt.length)

          var T = hmac.run(block1, hmac.ipad1)
          var U = T

          for (var j = 1; j < iterations; j++) {
            U = hmac.run(U, hmac.ipad2)
            for (var k = 0; k < hLen; k++) T[k] ^= U[k]
          }

          T.copy(DK, destPos)
          destPos += hLen
        }

        return DK
      }

      module.exports = pbkdf2

    }, { "./default-encoding": 300, "./precondition": 301, "./to-buffer": 303, "create-hash/md5": 221, "ripemd160": 314, "safe-buffer": 315, "sha.js": 318 }], 303: [function (require, module, exports) {
      var Buffer = require('safe-buffer').Buffer

      module.exports = function (thing, encoding, name) {
        if (Buffer.isBuffer(thing)) {
          return thing
        } else if (typeof thing === 'string') {
          return Buffer.from(thing, encoding)
        } else if (ArrayBuffer.isView(thing)) {
          return Buffer.from(thing.buffer)
        } else {
          throw new TypeError(name + ' must be a string, a Buffer, a typed array or a DataView')
        }
      }

    }, { "safe-buffer": 315 }], 304: [function (require, module, exports) {
      // shim for using process in browser
      var process = module.exports = {};

      // cached from whatever global is present so that test runners that stub it
      // don't break things.  But we need to wrap it in a try catch in case it is
      // wrapped in strict mode code which doesn't define any globals.  It's inside a
      // function because try/catches deoptimize in certain engines.

      var cachedSetTimeout;
      var cachedClearTimeout;

      function defaultSetTimout() {
        throw new Error('setTimeout has not been defined');
      }
      function defaultClearTimeout() {
        throw new Error('clearTimeout has not been defined');
      }
      (function () {
        try {
          if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
          } else {
            cachedSetTimeout = defaultSetTimout;
          }
        } catch (e) {
          cachedSetTimeout = defaultSetTimout;
        }
        try {
          if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
          } else {
            cachedClearTimeout = defaultClearTimeout;
          }
        } catch (e) {
          cachedClearTimeout = defaultClearTimeout;
        }
      }())
      function runTimeout(fun) {
        if (cachedSetTimeout === setTimeout) {
          //normal enviroments in sane situations
          return setTimeout(fun, 0);
        }
        // if setTimeout wasn't available but was latter defined
        if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
          cachedSetTimeout = setTimeout;
          return setTimeout(fun, 0);
        }
        try {
          // when when somebody has screwed with setTimeout but no I.E. maddness
          return cachedSetTimeout(fun, 0);
        } catch (e) {
          try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
          } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
          }
        }


      }
      function runClearTimeout(marker) {
        if (cachedClearTimeout === clearTimeout) {
          //normal enviroments in sane situations
          return clearTimeout(marker);
        }
        // if clearTimeout wasn't available but was latter defined
        if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
          cachedClearTimeout = clearTimeout;
          return clearTimeout(marker);
        }
        try {
          // when when somebody has screwed with setTimeout but no I.E. maddness
          return cachedClearTimeout(marker);
        } catch (e) {
          try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
          } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
          }
        }



      }
      var queue = [];
      var draining = false;
      var currentQueue;
      var queueIndex = -1;

      function cleanUpNextTick() {
        if (!draining || !currentQueue) {
          return;
        }
        draining = false;
        if (currentQueue.length) {
          queue = currentQueue.concat(queue);
        } else {
          queueIndex = -1;
        }
        if (queue.length) {
          drainQueue();
        }
      }

      function drainQueue() {
        if (draining) {
          return;
        }
        var timeout = runTimeout(cleanUpNextTick);
        draining = true;

        var len = queue.length;
        while (len) {
          currentQueue = queue;
          queue = [];
          while (++queueIndex < len) {
            if (currentQueue) {
              currentQueue[queueIndex].run();
            }
          }
          queueIndex = -1;
          len = queue.length;
        }
        currentQueue = null;
        draining = false;
        runClearTimeout(timeout);
      }

      process.nextTick = function (fun) {
        var args = new Array(arguments.length - 1);
        if (arguments.length > 1) {
          for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
          }
        }
        queue.push(new Item(fun, args));
        if (queue.length === 1 && !draining) {
          runTimeout(drainQueue);
        }
      };

      // v8 likes predictible objects
      function Item(fun, array) {
        this.fun = fun;
        this.array = array;
      }
      Item.prototype.run = function () {
        this.fun.apply(null, this.array);
      };
      process.title = 'browser';
      process.browser = true;
      process.env = {};
      process.argv = [];
      process.version = ''; // empty string to avoid regexp issues
      process.versions = {};

      function noop() { }

      process.on = noop;
      process.addListener = noop;
      process.once = noop;
      process.off = noop;
      process.removeListener = noop;
      process.removeAllListeners = noop;
      process.emit = noop;
      process.prependListener = noop;
      process.prependOnceListener = noop;

      process.listeners = function (name) { return [] }

      process.binding = function (name) {
        throw new Error('process.binding is not supported');
      };

      process.cwd = function () { return '/' };
      process.chdir = function (dir) {
        throw new Error('process.chdir is not supported');
      };
      process.umask = function () { return 0; };

    }, {}], 305: [function (require, module, exports) {
      exports.publicEncrypt = require('./publicEncrypt')
      exports.privateDecrypt = require('./privateDecrypt')

      exports.privateEncrypt = function privateEncrypt(key, buf) {
        return exports.publicEncrypt(key, buf, true)
      }

      exports.publicDecrypt = function publicDecrypt(key, buf) {
        return exports.privateDecrypt(key, buf, true)
      }

    }, { "./privateDecrypt": 308, "./publicEncrypt": 309 }], 306: [function (require, module, exports) {
      var createHash = require('create-hash')
      var Buffer = require('safe-buffer').Buffer

      module.exports = function (seed, len) {
        var t = Buffer.alloc(0)
        var i = 0
        var c
        while (t.length < len) {
          c = i2ops(i++)
          t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()])
        }
        return t.slice(0, len)
      }

      function i2ops(c) {
        var out = Buffer.allocUnsafe(4)
        out.writeUInt32BE(c, 0)
        return out
      }

    }, { "create-hash": 220, "safe-buffer": 315 }], 307: [function (require, module, exports) {
      arguments[4][64][0].apply(exports, arguments)
    }, { "buffer": 172, "dup": 64 }], 308: [function (require, module, exports) {
      var parseKeys = require('parse-asn1')
      var mgf = require('./mgf')
      var xor = require('./xor')
      var BN = require('bn.js')
      var crt = require('browserify-rsa')
      var createHash = require('create-hash')
      var withPublic = require('./withPublic')
      var Buffer = require('safe-buffer').Buffer

      module.exports = function privateDecrypt(privateKey, enc, reverse) {
        var padding
        if (privateKey.padding) {
          padding = privateKey.padding
        } else if (reverse) {
          padding = 1
        } else {
          padding = 4
        }

        var key = parseKeys(privateKey)
        var k = key.modulus.byteLength()
        if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) {
          throw new Error('decryption error')
        }
        var msg
        if (reverse) {
          msg = withPublic(new BN(enc), key)
        } else {
          msg = crt(enc, key)
        }
        var zBuffer = Buffer.alloc(k - msg.length)
        msg = Buffer.concat([zBuffer, msg], k)
        if (padding === 4) {
          return oaep(key, msg)
        } else if (padding === 1) {
          return pkcs1(key, msg, reverse)
        } else if (padding === 3) {
          return msg
        } else {
          throw new Error('unknown padding')
        }
      }

      function oaep(key, msg) {
        var k = key.modulus.byteLength()
        var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
        var hLen = iHash.length
        if (msg[0] !== 0) {
          throw new Error('decryption error')
        }
        var maskedSeed = msg.slice(1, hLen + 1)
        var maskedDb = msg.slice(hLen + 1)
        var seed = xor(maskedSeed, mgf(maskedDb, hLen))
        var db = xor(maskedDb, mgf(seed, k - hLen - 1))
        if (compare(iHash, db.slice(0, hLen))) {
          throw new Error('decryption error')
        }
        var i = hLen
        while (db[i] === 0) {
          i++
        }
        if (db[i++] !== 1) {
          throw new Error('decryption error')
        }
        return db.slice(i)
      }

      function pkcs1(key, msg, reverse) {
        var p1 = msg.slice(0, 2)
        var i = 2
        var status = 0
        while (msg[i++] !== 0) {
          if (i >= msg.length) {
            status++
            break
          }
        }
        var ps = msg.slice(2, i - 1)

        if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)) {
          status++
        }
        if (ps.length < 8) {
          status++
        }
        if (status) {
          throw new Error('decryption error')
        }
        return msg.slice(i)
      }
      function compare(a, b) {
        a = Buffer.from(a)
        b = Buffer.from(b)
        var dif = 0
        var len = a.length
        if (a.length !== b.length) {
          dif++
          len = Math.min(a.length, b.length)
        }
        var i = -1
        while (++i < len) {
          dif += (a[i] ^ b[i])
        }
        return dif
      }

    }, { "./mgf": 306, "./withPublic": 310, "./xor": 311, "bn.js": 307, "browserify-rsa": 193, "create-hash": 220, "parse-asn1": 297, "safe-buffer": 315 }], 309: [function (require, module, exports) {
      var parseKeys = require('parse-asn1')
      var randomBytes = require('randombytes')
      var createHash = require('create-hash')
      var mgf = require('./mgf')
      var xor = require('./xor')
      var BN = require('bn.js')
      var withPublic = require('./withPublic')
      var crt = require('browserify-rsa')
      var Buffer = require('safe-buffer').Buffer

      module.exports = function publicEncrypt(publicKey, msg, reverse) {
        var padding
        if (publicKey.padding) {
          padding = publicKey.padding
        } else if (reverse) {
          padding = 1
        } else {
          padding = 4
        }
        var key = parseKeys(publicKey)
        var paddedMsg
        if (padding === 4) {
          paddedMsg = oaep(key, msg)
        } else if (padding === 1) {
          paddedMsg = pkcs1(key, msg, reverse)
        } else if (padding === 3) {
          paddedMsg = new BN(msg)
          if (paddedMsg.cmp(key.modulus) >= 0) {
            throw new Error('data too long for modulus')
          }
        } else {
          throw new Error('unknown padding')
        }
        if (reverse) {
          return crt(paddedMsg, key)
        } else {
          return withPublic(paddedMsg, key)
        }
      }

      function oaep(key, msg) {
        var k = key.modulus.byteLength()
        var mLen = msg.length
        var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
        var hLen = iHash.length
        var hLen2 = 2 * hLen
        if (mLen > k - hLen2 - 2) {
          throw new Error('message too long')
        }
        var ps = Buffer.alloc(k - mLen - hLen2 - 2)
        var dblen = k - hLen - 1
        var seed = randomBytes(hLen)
        var maskedDb = xor(Buffer.concat([iHash, ps, Buffer.alloc(1, 1), msg], dblen), mgf(seed, dblen))
        var maskedSeed = xor(seed, mgf(maskedDb, hLen))
        return new BN(Buffer.concat([Buffer.alloc(1), maskedSeed, maskedDb], k))
      }
      function pkcs1(key, msg, reverse) {
        var mLen = msg.length
        var k = key.modulus.byteLength()
        if (mLen > k - 11) {
          throw new Error('message too long')
        }
        var ps
        if (reverse) {
          ps = Buffer.alloc(k - mLen - 3, 0xff)
        } else {
          ps = nonZero(k - mLen - 3)
        }
        return new BN(Buffer.concat([Buffer.from([0, reverse ? 1 : 2]), ps, Buffer.alloc(1), msg], k))
      }
      function nonZero(len) {
        var out = Buffer.allocUnsafe(len)
        var i = 0
        var cache = randomBytes(len * 2)
        var cur = 0
        var num
        while (i < len) {
          if (cur === cache.length) {
            cache = randomBytes(len * 2)
            cur = 0
          }
          num = cache[cur++]
          if (num) {
            out[i++] = num
          }
        }
        return out
      }

    }, { "./mgf": 306, "./withPublic": 310, "./xor": 311, "bn.js": 307, "browserify-rsa": 193, "create-hash": 220, "parse-asn1": 297, "randombytes": 312, "safe-buffer": 315 }], 310: [function (require, module, exports) {
      var BN = require('bn.js')
      var Buffer = require('safe-buffer').Buffer

      function withPublic(paddedMsg, key) {
        return Buffer.from(paddedMsg
          .toRed(BN.mont(key.modulus))
          .redPow(new BN(key.publicExponent))
          .fromRed()
          .toArray())
      }

      module.exports = withPublic

    }, { "bn.js": 307, "safe-buffer": 315 }], 311: [function (require, module, exports) {
      module.exports = function xor(a, b) {
        var len = a.length
        var i = -1
        while (++i < len) {
          a[i] ^= b[i]
        }
        return a
      }

    }, {}], 312: [function (require, module, exports) {
      arguments[4][116][0].apply(exports, arguments)
    }, { "_process": 304, "dup": 116, "safe-buffer": 315 }], 313: [function (require, module, exports) {
      (function (process, global) {
        (function () {
          'use strict'

          function oldBrowser() {
            throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
          }
          var safeBuffer = require('safe-buffer')
          var randombytes = require('randombytes')
          var Buffer = safeBuffer.Buffer
          var kBufferMaxLength = safeBuffer.kMaxLength
          var crypto = global.crypto || global.msCrypto
          var kMaxUint32 = Math.pow(2, 32) - 1
          function assertOffset(offset, length) {
            if (typeof offset !== 'number' || offset !== offset) { // eslint-disable-line no-self-compare
              throw new TypeError('offset must be a number')
            }

            if (offset > kMaxUint32 || offset < 0) {
              throw new TypeError('offset must be a uint32')
            }

            if (offset > kBufferMaxLength || offset > length) {
              throw new RangeError('offset out of range')
            }
          }

          function assertSize(size, offset, length) {
            if (typeof size !== 'number' || size !== size) { // eslint-disable-line no-self-compare
              throw new TypeError('size must be a number')
            }

            if (size > kMaxUint32 || size < 0) {
              throw new TypeError('size must be a uint32')
            }

            if (size + offset > length || size > kBufferMaxLength) {
              throw new RangeError('buffer too small')
            }
          }
          if ((crypto && crypto.getRandomValues) || !process.browser) {
            exports.randomFill = randomFill
            exports.randomFillSync = randomFillSync
          } else {
            exports.randomFill = oldBrowser
            exports.randomFillSync = oldBrowser
          }
          function randomFill(buf, offset, size, cb) {
            if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
              throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
            }

            if (typeof offset === 'function') {
              cb = offset
              offset = 0
              size = buf.length
            } else if (typeof size === 'function') {
              cb = size
              size = buf.length - offset
            } else if (typeof cb !== 'function') {
              throw new TypeError('"cb" argument must be a function')
            }
            assertOffset(offset, buf.length)
            assertSize(size, offset, buf.length)
            return actualFill(buf, offset, size, cb)
          }

          function actualFill(buf, offset, size, cb) {
            if (process.browser) {
              var ourBuf = buf.buffer
              var uint = new Uint8Array(ourBuf, offset, size)
              crypto.getRandomValues(uint)
              if (cb) {
                process.nextTick(function () {
                  cb(null, buf)
                })
                return
              }
              return buf
            }
            if (cb) {
              randombytes(size, function (err, bytes) {
                if (err) {
                  return cb(err)
                }
                bytes.copy(buf, offset)
                cb(null, buf)
              })
              return
            }
            var bytes = randombytes(size)
            bytes.copy(buf, offset)
            return buf
          }
          function randomFillSync(buf, offset, size) {
            if (typeof offset === 'undefined') {
              offset = 0
            }
            if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
              throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
            }

            assertOffset(offset, buf.length)

            if (size === undefined) size = buf.length - offset

            assertSize(size, offset, buf.length)

            return actualFill(buf, offset, size)
          }

        }).call(this)
      }).call(this, require('_process'), typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
    }, { "_process": 304, "randombytes": 312, "safe-buffer": 315 }], 314: [function (require, module, exports) {
      arguments[4][132][0].apply(exports, arguments)
    }, { "buffer": 216, "dup": 132, "hash-base": 255, "inherits": 285 }], 315: [function (require, module, exports) {
      arguments[4][133][0].apply(exports, arguments)
    }, { "buffer": 216, "dup": 133 }], 316: [function (require, module, exports) {
      (function (process) {
        (function () {
          /* eslint-disable node/no-deprecated-api */

          'use strict'

          var buffer = require('buffer')
          var Buffer = buffer.Buffer

          var safer = {}

          var key

          for (key in buffer) {
            if (!buffer.hasOwnProperty(key)) continue
            if (key === 'SlowBuffer' || key === 'Buffer') continue
            safer[key] = buffer[key]
          }

          var Safer = safer.Buffer = {}
          for (key in Buffer) {
            if (!Buffer.hasOwnProperty(key)) continue
            if (key === 'allocUnsafe' || key === 'allocUnsafeSlow') continue
            Safer[key] = Buffer[key]
          }

          safer.Buffer.prototype = Buffer.prototype

          if (!Safer.from || Safer.from === Uint8Array.from) {
            Safer.from = function (value, encodingOrOffset, length) {
              if (typeof value === 'number') {
                throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value)
              }
              if (value && typeof value.length === 'undefined') {
                throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ' + typeof value)
              }
              return Buffer(value, encodingOrOffset, length)
            }
          }

          if (!Safer.alloc) {
            Safer.alloc = function (size, fill, encoding) {
              if (typeof size !== 'number') {
                throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size)
              }
              if (size < 0 || size >= 2 * (1 << 30)) {
                throw new RangeError('The value "' + size + '" is invalid for option "size"')
              }
              var buf = Buffer(size)
              if (!fill || fill.length === 0) {
                buf.fill(0)
              } else if (typeof encoding === 'string') {
                buf.fill(fill, encoding)
              } else {
                buf.fill(fill)
              }
              return buf
            }
          }

          if (!safer.kStringMaxLength) {
            try {
              safer.kStringMaxLength = process.binding('buffer').kStringMaxLength
            } catch (e) {
              // we can't determine kStringMaxLength in environments where process.binding
              // is unsupported, so let's not set it
            }
          }

          if (!safer.constants) {
            safer.constants = {
              MAX_LENGTH: safer.kMaxLength
            }
            if (safer.kStringMaxLength) {
              safer.constants.MAX_STRING_LENGTH = safer.kStringMaxLength
            }
          }

          module.exports = safer

        }).call(this)
      }).call(this, require('_process'))
    }, { "_process": 304, "buffer": 216 }], 317: [function (require, module, exports) {
      arguments[4][134][0].apply(exports, arguments)
    }, { "dup": 134, "safe-buffer": 315 }], 318: [function (require, module, exports) {
      arguments[4][135][0].apply(exports, arguments)
    }, { "./sha": 319, "./sha1": 320, "./sha224": 321, "./sha256": 322, "./sha384": 323, "./sha512": 324, "dup": 135 }], 319: [function (require, module, exports) {
      arguments[4][136][0].apply(exports, arguments)
    }, { "./hash": 317, "dup": 136, "inherits": 285, "safe-buffer": 315 }], 320: [function (require, module, exports) {
      arguments[4][137][0].apply(exports, arguments)
    }, { "./hash": 317, "dup": 137, "inherits": 285, "safe-buffer": 315 }], 321: [function (require, module, exports) {
      arguments[4][138][0].apply(exports, arguments)
    }, { "./hash": 317, "./sha256": 322, "dup": 138, "inherits": 285, "safe-buffer": 315 }], 322: [function (require, module, exports) {
      arguments[4][139][0].apply(exports, arguments)
    }, { "./hash": 317, "dup": 139, "inherits": 285, "safe-buffer": 315 }], 323: [function (require, module, exports) {
      arguments[4][140][0].apply(exports, arguments)
    }, { "./hash": 317, "./sha512": 324, "dup": 140, "inherits": 285, "safe-buffer": 315 }], 324: [function (require, module, exports) {
      arguments[4][141][0].apply(exports, arguments)
    }, { "./hash": 317, "dup": 141, "inherits": 285, "safe-buffer": 315 }], 325: [function (require, module, exports) {
      // Copyright Joyent, Inc. and other Node contributors.
      //
      // Permission is hereby granted, free of charge, to any person obtaining a
      // copy of this software and associated documentation files (the
      // "Software"), to deal in the Software without restriction, including
      // without limitation the rights to use, copy, modify, merge, publish,
      // distribute, sublicense, and/or sell copies of the Software, and to permit
      // persons to whom the Software is furnished to do so, subject to the
      // following conditions:
      //
      // The above copyright notice and this permission notice shall be included
      // in all copies or substantial portions of the Software.
      //
      // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
      // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
      // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
      // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
      // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
      // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
      // USE OR OTHER DEALINGS IN THE SOFTWARE.

      module.exports = Stream;

      var EE = require('events').EventEmitter;
      var inherits = require('inherits');

      inherits(Stream, EE);
      Stream.Readable = require('readable-stream/lib/_stream_readable.js');
      Stream.Writable = require('readable-stream/lib/_stream_writable.js');
      Stream.Duplex = require('readable-stream/lib/_stream_duplex.js');
      Stream.Transform = require('readable-stream/lib/_stream_transform.js');
      Stream.PassThrough = require('readable-stream/lib/_stream_passthrough.js');
      Stream.finished = require('readable-stream/lib/internal/streams/end-of-stream.js')
      Stream.pipeline = require('readable-stream/lib/internal/streams/pipeline.js')

      // Backwards-compat with node 0.4.x
      Stream.Stream = Stream;



      // old-style streams.  Note that the pipe method (the only relevant
      // part of this class) is overridden in the Readable class.

      function Stream() {
        EE.call(this);
      }

      Stream.prototype.pipe = function (dest, options) {
        var source = this;

        function ondata(chunk) {
          if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) {
              source.pause();
            }
          }
        }

        source.on('data', ondata);

        function ondrain() {
          if (source.readable && source.resume) {
            source.resume();
          }
        }

        dest.on('drain', ondrain);

        // If the 'end' option is not supplied, dest.end() will be called when
        // source gets the 'end' or 'close' events.  Only dest.end() once.
        if (!dest._isStdio && (!options || options.end !== false)) {
          source.on('end', onend);
          source.on('close', onclose);
        }

        var didOnEnd = false;
        function onend() {
          if (didOnEnd) return;
          didOnEnd = true;

          dest.end();
        }


        function onclose() {
          if (didOnEnd) return;
          didOnEnd = true;

          if (typeof dest.destroy === 'function') dest.destroy();
        }

        // don't leave dangling pipes when there are errors.
        function onerror(er) {
          cleanup();
          if (EE.listenerCount(this, 'error') === 0) {
            throw er; // Unhandled stream error in pipe.
          }
        }

        source.on('error', onerror);
        dest.on('error', onerror);

        // remove all the event listeners that were added.
        function cleanup() {
          source.removeListener('data', ondata);
          dest.removeListener('drain', ondrain);

          source.removeListener('end', onend);
          source.removeListener('close', onclose);

          source.removeListener('error', onerror);
          dest.removeListener('error', onerror);

          source.removeListener('end', cleanup);
          source.removeListener('close', cleanup);

          dest.removeListener('close', cleanup);
        }

        source.on('end', cleanup);
        source.on('close', cleanup);

        dest.on('close', cleanup);

        dest.emit('pipe', source);

        // Allow for unix-like usage: A.pipe(B).pipe(C)
        return dest;
      };

    }, { "events": 253, "inherits": 285, "readable-stream/lib/_stream_duplex.js": 327, "readable-stream/lib/_stream_passthrough.js": 328, "readable-stream/lib/_stream_readable.js": 329, "readable-stream/lib/_stream_transform.js": 330, "readable-stream/lib/_stream_writable.js": 331, "readable-stream/lib/internal/streams/end-of-stream.js": 335, "readable-stream/lib/internal/streams/pipeline.js": 337 }], 326: [function (require, module, exports) {
      arguments[4][117][0].apply(exports, arguments)
    }, { "dup": 117 }], 327: [function (require, module, exports) {
      arguments[4][118][0].apply(exports, arguments)
    }, { "./_stream_readable": 329, "./_stream_writable": 331, "_process": 304, "dup": 118, "inherits": 285 }], 328: [function (require, module, exports) {
      arguments[4][119][0].apply(exports, arguments)
    }, { "./_stream_transform": 330, "dup": 119, "inherits": 285 }], 329: [function (require, module, exports) {
      arguments[4][120][0].apply(exports, arguments)
    }, { "../errors": 326, "./_stream_duplex": 327, "./internal/streams/async_iterator": 332, "./internal/streams/buffer_list": 333, "./internal/streams/destroy": 334, "./internal/streams/from": 336, "./internal/streams/state": 338, "./internal/streams/stream": 339, "_process": 304, "buffer": 216, "dup": 120, "events": 253, "inherits": 285, "string_decoder/": 340, "util": 172 }], 330: [function (require, module, exports) {
      arguments[4][121][0].apply(exports, arguments)
    }, { "../errors": 326, "./_stream_duplex": 327, "dup": 121, "inherits": 285 }], 331: [function (require, module, exports) {
      arguments[4][122][0].apply(exports, arguments)
    }, { "../errors": 326, "./_stream_duplex": 327, "./internal/streams/destroy": 334, "./internal/streams/state": 338, "./internal/streams/stream": 339, "_process": 304, "buffer": 216, "dup": 122, "inherits": 285, "util-deprecate": 341 }], 332: [function (require, module, exports) {
      arguments[4][123][0].apply(exports, arguments)
    }, { "./end-of-stream": 335, "_process": 304, "dup": 123 }], 333: [function (require, module, exports) {
      arguments[4][124][0].apply(exports, arguments)
    }, { "buffer": 216, "dup": 124, "util": 172 }], 334: [function (require, module, exports) {
      arguments[4][125][0].apply(exports, arguments)
    }, { "_process": 304, "dup": 125 }], 335: [function (require, module, exports) {
      arguments[4][126][0].apply(exports, arguments)
    }, { "../../../errors": 326, "dup": 126 }], 336: [function (require, module, exports) {
      arguments[4][127][0].apply(exports, arguments)
    }, { "dup": 127 }], 337: [function (require, module, exports) {
      arguments[4][128][0].apply(exports, arguments)
    }, { "../../../errors": 326, "./end-of-stream": 335, "dup": 128 }], 338: [function (require, module, exports) {
      arguments[4][129][0].apply(exports, arguments)
    }, { "../../../errors": 326, "dup": 129 }], 339: [function (require, module, exports) {
      arguments[4][130][0].apply(exports, arguments)
    }, { "dup": 130, "events": 253 }], 340: [function (require, module, exports) {
      arguments[4][142][0].apply(exports, arguments)
    }, { "dup": 142, "safe-buffer": 315 }], 341: [function (require, module, exports) {
      arguments[4][147][0].apply(exports, arguments)
    }, { "dup": 147 }]
  }, {}, [32])(32)
});
